
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0e00"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0e00"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";
parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $fO90s.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $8coUR({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $8coUR({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $8coUR({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $8coUR({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $8coUR({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $8coUR({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $8coUR({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $8coUR({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $8coUR({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $8coUR({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $8coUR({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $8coUR({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $fO90s.unstable_runWithPriority, Of = $fO90s.unstable_scheduleCallback, Pf = $fO90s.unstable_cancelCallback, Qf = $fO90s.unstable_shouldYield, Rf = $fO90s.unstable_requestPaint, Sf = $fO90s.unstable_now, Tf = $fO90s.unstable_getCurrentPriorityLevel, Uf = $fO90s.unstable_ImmediatePriority, Vf = $fO90s.unstable_UserBlockingPriority, Wf = $fO90s.unstable_NormalPriority, Xf = $fO90s.unstable_LowPriority, Yf = $fO90s.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $acw62.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});



parcelRegister("7we3r", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance($lk5EI(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));

$57966c7e0affc4cb$var$axios.VERSION = (parcelRequire("35BUy")).version;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));

// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (parcelRequire("dxy9O"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {
"use strict";

var $jJbMR = parcelRequire("jJbMR");
// utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM
};

});
parcelRegister("jJbMR", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ewFRw", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $bv3QM = parcelRequire("bv3QM");
var $a93486d2307f31c3$var$validators = $bv3QM.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $bv3QM.assertOptions(transitional, {
        silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
        forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
        clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $dlZEJ,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $dlZEJ(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($gKvUL.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + "=" + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("83RYu", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $4Tkeq("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7YJ0v", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $lJY4v;
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("lJY4v", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");

var $8v8A7 = parcelRequire("8v8A7");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    else if (typeof $hPtJY !== "undefined" && Object.prototype.toString.call($hPtJY) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
function $fd3c65eeb28abd71$var$stringifySafely(rawValue, parser, encoder) {
    if ($gKvUL.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $gKvUL.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $fd3c65eeb28abd71$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, "Accept");
            $kiL6T(headers, "Content-Type");
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($gKvUL.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/json");
                return $fd3c65eeb28abd71$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $fd3c65eeb28abd71$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $gKvUL.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $8v8A7(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$gKvUL.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("kiL6T", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("8v8A7", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("at5cb", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");

var $lJY4v = parcelRequire("lJY4v");

var $4Tkeq = parcelRequire("4Tkeq");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($gKvUL.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $lJY4v.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $4Tkeq("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {
"use strict";

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("kjF3e", function(module, exports) {
"use strict";

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});


parcelRegister("8JRzs", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push("path=" + path);
            if ($gKvUL.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7GD7a", function(module, exports) {
"use strict";

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("ckHwb", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("fE4ul", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("lDriZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("889er", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("4Tkeq", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});




parcelRegister("7L4QX", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("lk5EI", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $gKvUL.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $gKvUL.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("bv3QM", function(module, exports) {
"use strict";

var $35BUy = parcelRequire("35BUy");
var $85f59389941e7907$require$VERSION = $35BUy.version;
var $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $85f59389941e7907$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("35BUy", function(module, exports) {
module.exports = {
    "version": "0.24.0"
};

});



parcelRegister("lAKPy", function(module, exports) {
"use strict";

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $fb81495929d8a282$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $fb81495929d8a282$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("dxy9O", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $ed8cf1f08d8b2081$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$exports = {};
$ed8cf1f08d8b2081$var$$parcel$export($ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$exports, "SSRProvider", ()=>$ed8cf1f08d8b2081$export$9f8ac96af4b1b2ae);
$ed8cf1f08d8b2081$var$$parcel$export($ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$exports, "useSSRSafeId", ()=>$ed8cf1f08d8b2081$export$619500959fc48b26);
$ed8cf1f08d8b2081$var$$parcel$export($ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$exports, "useIsSSR", ()=>$ed8cf1f08d8b2081$export$535bd6ca7f90a273);
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$SSRContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$defaultContext);
function $ed8cf1f08d8b2081$export$9f8ac96af4b1b2ae(props) {
    let cur = (0, $acw62.useContext)($ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$SSRContext);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$defaultContext ? "" : `${cur.prefix}-${++cur.current}`,
            current: 0
        }), [
        cur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$SSRContext.Provider, {
        value: value
    }, props.children);
}
let $ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
function $ed8cf1f08d8b2081$export$619500959fc48b26(defaultId) {
    let ctx = (0, $acw62.useContext)($ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$defaultContext && !$ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    return (0, $acw62.useMemo)(()=>defaultId || `react-aria${ctx.prefix}-${++ctx.current}`, [
        defaultId
    ]);
}
function $ed8cf1f08d8b2081$export$535bd6ca7f90a273() {
    let cur = (0, $acw62.useContext)($ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$SSRContext);
    let isInSSRContext = cur !== $ed8cf1f08d8b2081$var$$704cf1d3b684cc5c$var$defaultContext;
    let [isSSR, setIsSSR] = (0, $acw62.useState)(isInSSRContext);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof window !== "undefined" && isInSSRContext) // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return isSSR;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;



var $acw62 = parcelRequire("acw62");
function $4cd691a5721e7a58$export$40bfa8c7b0832715(value1, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $acw62.useState)(value1 || defaultValue);
    let ref = (0, $acw62.useRef)(value1 !== undefined);
    let wasControlled = ref.current;
    let isControlled = value1 !== undefined;
    // Internal state reference for useCallback
    let stateRef = (0, $acw62.useRef)(stateValue);
    if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
    ref.current = isControlled;
    let setValue = (0, $acw62.useCallback)((value2, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(stateRef.current, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) stateRef.current = value;
        };
        if (typeof value2 === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value2(isControlled ? stateRef.current : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value2);
            onChangeCaller(value2, ...args);
        }
    }, [
        isControlled,
        onChange
    ]);
    // If a controlled component's value prop changes, we need to update stateRef
    if (isControlled) stateRef.current = value1;
    else value1 = stateValue;
    return [
        value1,
        setValue
    ];
}
function $4cd691a5721e7a58$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $4cd691a5721e7a58$export$cb6e0bb50bc19463(value, min, max, step) {
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $4cd691a5721e7a58$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}


function $4d60a29ecf011a9e$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $4d60a29ecf011a9e$var$$bdb11010cef70236$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$bdb11010cef70236$exports, "useId", ()=>$4d60a29ecf011a9e$export$f680877a34711e37);
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$bdb11010cef70236$exports, "mergeIds", ()=>$4d60a29ecf011a9e$export$cd8c9cb68f842629);
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$bdb11010cef70236$exports, "useSlotId", ()=>$4d60a29ecf011a9e$export$b4cc09c592e8fdb8);
var $4d60a29ecf011a9e$var$$f0a04ccd8dbdd83b$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$f0a04ccd8dbdd83b$exports, "useLayoutEffect", ()=>$4d60a29ecf011a9e$export$e5c5a5f917a5871c);
const $4d60a29ecf011a9e$export$e5c5a5f917a5871c = typeof window !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};
let $4d60a29ecf011a9e$var$$bdb11010cef70236$var$idsUpdaterMap = new Map();
function $4d60a29ecf011a9e$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $acw62.useState)(defaultId);
    let nextId = (0, $acw62.useRef)(null);
    let res = (0, $ed8cf1f08d8b2081$export$619500959fc48b26)(value);
    let updateValue = (0, $acw62.useCallback)((val)=>{
        nextId.current = val;
    }, []);
    $4d60a29ecf011a9e$var$$bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    $4d60a29ecf011a9e$export$e5c5a5f917a5871c(()=>{
        let r = res;
        return ()=>{
            $4d60a29ecf011a9e$var$$bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    // This cannot cause an infinite loop because the ref is updated first.
    // eslint-disable-next-line
    (0, $acw62.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $4d60a29ecf011a9e$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $4d60a29ecf011a9e$var$$bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $4d60a29ecf011a9e$var$$bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $4d60a29ecf011a9e$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $4d60a29ecf011a9e$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = $4d60a29ecf011a9e$export$14d238f342723f25(id);
    let updateId = (0, $acw62.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : null;
        });
    }, [
        id,
        setResolvedId
    ]);
    $4d60a29ecf011a9e$export$e5c5a5f917a5871c(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}
var $4d60a29ecf011a9e$var$$ff5963eb1fccf552$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$ff5963eb1fccf552$exports, "chain", ()=>$4d60a29ecf011a9e$export$e08e3b67e392101e);
function $4d60a29ecf011a9e$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}
var $4d60a29ecf011a9e$var$$3ef42575df84b30b$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$3ef42575df84b30b$exports, "mergeProps", ()=>$4d60a29ecf011a9e$export$9d1611c77c2fe928);
function $4d60a29ecf011a9e$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = $4d60a29ecf011a9e$export$e08e3b67e392101e(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(a, b);
            else if (key === "id" && a && b) result.id = $4d60a29ecf011a9e$export$cd8c9cb68f842629(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}
var $4d60a29ecf011a9e$var$$5dc95899b306f630$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$5dc95899b306f630$exports, "mergeRefs", ()=>$4d60a29ecf011a9e$export$c9058316764c140e);
function $4d60a29ecf011a9e$export$c9058316764c140e(...refs) {
    return (value)=>{
        for (let ref of refs){
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        }
    };
}
var $4d60a29ecf011a9e$var$$65484d02dcb7eb3e$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$65484d02dcb7eb3e$exports, "filterDOMProps", ()=>$4d60a29ecf011a9e$export$457c3d6518dd4c6f);
const $4d60a29ecf011a9e$var$$65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
const $4d60a29ecf011a9e$var$$65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
const $4d60a29ecf011a9e$var$$65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $4d60a29ecf011a9e$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($4d60a29ecf011a9e$var$$65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $4d60a29ecf011a9e$var$$65484d02dcb7eb3e$var$labelablePropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $4d60a29ecf011a9e$var$$65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}
var $4d60a29ecf011a9e$var$$7215afc6de606d6b$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$7215afc6de606d6b$exports, "focusWithoutScrolling", ()=>$4d60a29ecf011a9e$export$de79e2c695e052f3);
function $4d60a29ecf011a9e$export$de79e2c695e052f3(element) {
    if ($4d60a29ecf011a9e$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $4d60a29ecf011a9e$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $4d60a29ecf011a9e$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $4d60a29ecf011a9e$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $4d60a29ecf011a9e$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($4d60a29ecf011a9e$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $4d60a29ecf011a9e$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            var focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $4d60a29ecf011a9e$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $4d60a29ecf011a9e$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $4d60a29ecf011a9e$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $4d60a29ecf011a9e$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}
var $4d60a29ecf011a9e$var$$ab71dadb03a6fb2e$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$ab71dadb03a6fb2e$exports, "getOffset", ()=>$4d60a29ecf011a9e$export$622cea445a1c5b7d);
function $4d60a29ecf011a9e$export$622cea445a1c5b7d(element, reverse, orientation = "horizontal") {
    let rect = element.getBoundingClientRect();
    if (reverse) return orientation === "horizontal" ? rect.right : rect.bottom;
    return orientation === "horizontal" ? rect.left : rect.top;
}
var $4d60a29ecf011a9e$var$$103b0e103f1b5952$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$103b0e103f1b5952$exports, "clamp", ()=>(0, $4cd691a5721e7a58$export$7d15b64cf5a3a4c4));
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$103b0e103f1b5952$exports, "snapValueToStep", ()=>(0, $4cd691a5721e7a58$export$cb6e0bb50bc19463));
var $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$bbed8b41f857bcc0$exports, "runAfterTransition", ()=>$4d60a29ecf011a9e$export$24490316f764c430);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    let onTransitionStart = (e)=>{
        // Add the transitioning property to the list for this element.
        let transitions = $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd);
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        // Remove property from list of transitioning properties.
        let properties = $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $4d60a29ecf011a9e$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $4d60a29ecf011a9e$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}
var $4d60a29ecf011a9e$var$$9cc09df9fd7676be$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$9cc09df9fd7676be$exports, "useDrag1D", ()=>$4d60a29ecf011a9e$export$7bbed75feba39706);
// Keep track of elements that we are currently handling dragging for via useDrag1D.
// If there's an ancestor and a descendant both using useDrag1D(), and the user starts
// dragging the descendant, we don't want useDrag1D events to fire for the ancestor.
const $4d60a29ecf011a9e$var$$9cc09df9fd7676be$var$draggingElements = [];
function $4d60a29ecf011a9e$export$7bbed75feba39706(props) {
    console.warn("useDrag1D is deprecated, please use `useMove` instead https://react-spectrum.adobe.com/react-aria/useMove.html");
    let { containerRef: containerRef, reverse: reverse, orientation: orientation, onHover: onHover, onDrag: onDrag, onPositionChange: onPositionChange, onIncrement: onIncrement, onDecrement: onDecrement, onIncrementToMax: onIncrementToMax, onDecrementToMin: onDecrementToMin, onCollapseToggle: onCollapseToggle } = props;
    let getPosition = (e)=>orientation === "horizontal" ? e.clientX : e.clientY;
    let getNextOffset = (e)=>{
        let containerOffset = $4d60a29ecf011a9e$export$622cea445a1c5b7d(containerRef.current, reverse, orientation);
        let mouseOffset = getPosition(e);
        let nextOffset = reverse ? containerOffset - mouseOffset : mouseOffset - containerOffset;
        return nextOffset;
    };
    let dragging = (0, $acw62.useRef)(false);
    let prevPosition = (0, $acw62.useRef)(0);
    // Keep track of the current handlers in a ref so that the events can access them.
    let handlers = (0, $acw62.useRef)({
        onPositionChange: onPositionChange,
        onDrag: onDrag
    });
    handlers.current.onDrag = onDrag;
    handlers.current.onPositionChange = onPositionChange;
    let onMouseDragged = (e)=>{
        e.preventDefault();
        let nextOffset = getNextOffset(e);
        if (!dragging.current) {
            dragging.current = true;
            if (handlers.current.onDrag) handlers.current.onDrag(true);
            if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        }
        if (prevPosition.current === nextOffset) return;
        prevPosition.current = nextOffset;
        if (onPositionChange) onPositionChange(nextOffset);
    };
    let onMouseUp = (e)=>{
        const target = e.target;
        dragging.current = false;
        let nextOffset = getNextOffset(e);
        if (handlers.current.onDrag) handlers.current.onDrag(false);
        if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        $4d60a29ecf011a9e$var$$9cc09df9fd7676be$var$draggingElements.splice($4d60a29ecf011a9e$var$$9cc09df9fd7676be$var$draggingElements.indexOf(target), 1);
        window.removeEventListener("mouseup", onMouseUp, false);
        window.removeEventListener("mousemove", onMouseDragged, false);
    };
    let onMouseDown = (e)=>{
        const target = e.currentTarget;
        // If we're already handling dragging on a descendant with useDrag1D, then
        // we don't want to handle the drag motion on this target as well.
        if ($4d60a29ecf011a9e$var$$9cc09df9fd7676be$var$draggingElements.some((elt)=>target.contains(elt))) return;
        $4d60a29ecf011a9e$var$$9cc09df9fd7676be$var$draggingElements.push(target);
        window.addEventListener("mousemove", onMouseDragged, false);
        window.addEventListener("mouseup", onMouseUp, false);
    };
    let onMouseEnter = ()=>{
        if (onHover) onHover(true);
    };
    let onMouseOut = ()=>{
        if (onHover) onHover(false);
    };
    let onKeyDown = (e)=>{
        switch(e.key){
            case "Left":
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case "Up":
            case "ArrowUp":
                if (orientation === "vertical") {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case "Right":
            case "ArrowRight":
                if (orientation === "horizontal") {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case "Down":
            case "ArrowDown":
                if (orientation === "vertical") {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case "Home":
                e.preventDefault();
                if (onDecrementToMin) onDecrementToMin();
                break;
            case "End":
                e.preventDefault();
                if (onIncrementToMax) onIncrementToMax();
                break;
            case "Enter":
                e.preventDefault();
                if (onCollapseToggle) onCollapseToggle();
                break;
        }
    };
    return {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        onKeyDown: onKeyDown
    };
}
var $4d60a29ecf011a9e$var$$03deb23ff14920c4$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$03deb23ff14920c4$exports, "useGlobalListeners", ()=>$4d60a29ecf011a9e$export$4eaf04e54aa8eed6);
function $4d60a29ecf011a9e$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $acw62.useRef)(new Map());
    let addGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        var ref;
        let fn = ((ref = globalListeners.current.get(listener)) === null || ref === void 0 ? void 0 : ref.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $acw62.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    // eslint-disable-next-line arrow-body-style
    (0, $acw62.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}
var $4d60a29ecf011a9e$var$$313b98861ee5dd6c$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$313b98861ee5dd6c$exports, "useLabels", ()=>$4d60a29ecf011a9e$export$d6875122194c7b44);
function $4d60a29ecf011a9e$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id, "aria-label": label, "aria-labelledby": labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = $4d60a29ecf011a9e$export$f680877a34711e37(id);
    if (labelledBy && label) {
        let ids = new Set([
            ...labelledBy.trim().split(/\s+/),
            id
        ]);
        labelledBy = [
            ...ids
        ].join(" ");
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        "aria-label": label,
        "aria-labelledby": labelledBy
    };
}
var $4d60a29ecf011a9e$var$$df56164dff5785e2$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$df56164dff5785e2$exports, "useObjectRef", ()=>$4d60a29ecf011a9e$export$4338b53315abf666);
function $4d60a29ecf011a9e$export$4338b53315abf666(forwardedRef) {
    const objRef = (0, $acw62.useRef)();
    /**
   * We're using `useLayoutEffect` here instead of `useEffect` because we want
   * to make sure that the `ref` value is up to date before other places in the
   * the execution cycle try to read it.
   */ $4d60a29ecf011a9e$export$e5c5a5f917a5871c(()=>{
        if (!forwardedRef) return;
        if (typeof forwardedRef === "function") forwardedRef(objRef.current);
        else forwardedRef.current = objRef.current;
    }, [
        forwardedRef
    ]);
    return objRef;
}
var $4d60a29ecf011a9e$var$$4f58c5f72bcf79f7$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$4f58c5f72bcf79f7$exports, "useUpdateEffect", ()=>$4d60a29ecf011a9e$export$496315a1608d9602);
function $4d60a29ecf011a9e$export$496315a1608d9602(effect, dependencies) {
    const isInitialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}
var $4d60a29ecf011a9e$var$$9daab02d461809db$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$9daab02d461809db$exports, "useResizeObserver", ()=>$4d60a29ecf011a9e$export$683480f191c0e3ea);
function $4d60a29ecf011a9e$var$$9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== "undefined";
}
function $4d60a29ecf011a9e$export$683480f191c0e3ea(options) {
    const { ref: ref, onResize: onResize } = options;
    (0, $acw62.useEffect)(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$4d60a29ecf011a9e$var$$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener("resize", onResize, false);
            return ()=>{
                window.removeEventListener("resize", onResize, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}
var $4d60a29ecf011a9e$var$$e7801be82b4b2a53$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$e7801be82b4b2a53$exports, "useSyncRef", ()=>$4d60a29ecf011a9e$export$4debdb1a3f0fa79e);
function $4d60a29ecf011a9e$export$4debdb1a3f0fa79e(context, ref) {
    $4d60a29ecf011a9e$export$e5c5a5f917a5871c(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                context.ref.current = null;
            };
        }
    }, [
        context,
        ref
    ]);
}
var $4d60a29ecf011a9e$var$$62d8ded9296f3872$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$62d8ded9296f3872$exports, "getScrollParent", ()=>$4d60a29ecf011a9e$export$cfa2225e87938781);
function $4d60a29ecf011a9e$export$cfa2225e87938781(node) {
    while(node && !$4d60a29ecf011a9e$var$$62d8ded9296f3872$var$isScrollable(node))node = node.parentElement;
    return node || document.scrollingElement || document.documentElement;
}
function $4d60a29ecf011a9e$var$$62d8ded9296f3872$var$isScrollable(node) {
    let style = window.getComputedStyle(node);
    return /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
}
var $4d60a29ecf011a9e$var$$5df64b3807dc15ee$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$5df64b3807dc15ee$exports, "useViewportSize", ()=>$4d60a29ecf011a9e$export$d699905dd57c73ca);
// @ts-ignore
let $4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$visualViewport = typeof window !== "undefined" && window.visualViewport;
function $4d60a29ecf011a9e$export$d699905dd57c73ca() {
    let [size1, setSize] = (0, $acw62.useState)(()=>$4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$getViewportSize());
    (0, $acw62.useEffect)(()=>{
        // Use visualViewport api to track available height even on iOS virtual keyboard opening
        let onResize = ()=>{
            setSize((size)=>{
                let newSize = $4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$getViewportSize();
                if (newSize.width === size.width && newSize.height === size.height) return size;
                return newSize;
            });
        };
        if (!$4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$visualViewport) window.addEventListener("resize", onResize);
        else $4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$visualViewport.addEventListener("resize", onResize);
        return ()=>{
            if (!$4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$visualViewport) window.removeEventListener("resize", onResize);
            else $4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$visualViewport.removeEventListener("resize", onResize);
        };
    }, []);
    return size1;
}
function $4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$getViewportSize() {
    return {
        width: ($4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$visualViewport === null || $4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$visualViewport.width) || window.innerWidth,
        height: ($4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$visualViewport === null || $4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $4d60a29ecf011a9e$var$$5df64b3807dc15ee$var$visualViewport.height) || window.innerHeight
    };
}
var $4d60a29ecf011a9e$var$$ef06256079686ba0$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$ef06256079686ba0$exports, "useDescription", ()=>$4d60a29ecf011a9e$export$f8aeda7b10753fa1);
let $4d60a29ecf011a9e$var$$ef06256079686ba0$var$descriptionId = 0;
const $4d60a29ecf011a9e$var$$ef06256079686ba0$var$descriptionNodes = new Map();
function $4d60a29ecf011a9e$export$f8aeda7b10753fa1(description) {
    let [id1, setId] = (0, $acw62.useState)(null);
    $4d60a29ecf011a9e$export$e5c5a5f917a5871c(()=>{
        if (!description) return;
        let desc = $4d60a29ecf011a9e$var$$ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$4d60a29ecf011a9e$var$$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $4d60a29ecf011a9e$var$$ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (--desc.refCount === 0) {
                desc.element.remove();
                $4d60a29ecf011a9e$var$$ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id1 : undefined
    };
}
var $4d60a29ecf011a9e$var$$c87311424ea30a05$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$c87311424ea30a05$exports, "isMac", ()=>$4d60a29ecf011a9e$export$9ac100e40613ea10);
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$c87311424ea30a05$exports, "isIPhone", ()=>$4d60a29ecf011a9e$export$186c6964ca17d99);
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$c87311424ea30a05$exports, "isIPad", ()=>$4d60a29ecf011a9e$export$7bef049ce92e4224);
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$c87311424ea30a05$exports, "isIOS", ()=>$4d60a29ecf011a9e$export$fedb369cb70207f1);
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$c87311424ea30a05$exports, "isAppleDevice", ()=>$4d60a29ecf011a9e$export$e1865c3bedcd822b);
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$c87311424ea30a05$exports, "isWebKit", ()=>$4d60a29ecf011a9e$export$78551043582a6a98);
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$c87311424ea30a05$exports, "isChrome", ()=>$4d60a29ecf011a9e$export$6446a186d09e379e);
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$c87311424ea30a05$exports, "isAndroid", ()=>$4d60a29ecf011a9e$export$a11b0059900ceec8);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4d60a29ecf011a9e$var$$c87311424ea30a05$var$testUserAgent(re) {
    var ref;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((ref = window.navigator["userAgentData"]) === null || ref === void 0 ? void 0 : ref.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $4d60a29ecf011a9e$var$$c87311424ea30a05$var$testPlatform(re) {
    return typeof window !== "undefined" && window.navigator != null ? re.test((window.navigator["userAgentData"] || window.navigator).platform) : false;
}
function $4d60a29ecf011a9e$export$9ac100e40613ea10() {
    return $4d60a29ecf011a9e$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $4d60a29ecf011a9e$export$186c6964ca17d99() {
    return $4d60a29ecf011a9e$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $4d60a29ecf011a9e$export$7bef049ce92e4224() {
    return $4d60a29ecf011a9e$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || $4d60a29ecf011a9e$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $4d60a29ecf011a9e$export$fedb369cb70207f1() {
    return $4d60a29ecf011a9e$export$186c6964ca17d99() || $4d60a29ecf011a9e$export$7bef049ce92e4224();
}
function $4d60a29ecf011a9e$export$e1865c3bedcd822b() {
    return $4d60a29ecf011a9e$export$9ac100e40613ea10() || $4d60a29ecf011a9e$export$fedb369cb70207f1();
}
function $4d60a29ecf011a9e$export$78551043582a6a98() {
    return $4d60a29ecf011a9e$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$4d60a29ecf011a9e$export$6446a186d09e379e();
}
function $4d60a29ecf011a9e$export$6446a186d09e379e() {
    return $4d60a29ecf011a9e$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
}
function $4d60a29ecf011a9e$export$a11b0059900ceec8() {
    return $4d60a29ecf011a9e$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
}
var $4d60a29ecf011a9e$var$$e9faafb641e167db$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$e9faafb641e167db$exports, "useEvent", ()=>$4d60a29ecf011a9e$export$90fc3a17d93f704c);
function $4d60a29ecf011a9e$export$90fc3a17d93f704c(ref, event, handler1, options) {
    let handlerRef = (0, $acw62.useRef)(handler1);
    handlerRef.current = handler1;
    let isDisabled = handler1 == null;
    (0, $acw62.useEffect)(()=>{
        if (isDisabled) return;
        let element = ref.current;
        let handler = (e)=>handlerRef.current.call(this, e);
        element.addEventListener(event, handler, options);
        return ()=>{
            element.removeEventListener(event, handler, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled
    ]);
}
var $4d60a29ecf011a9e$var$$1dbecbe27a04f9af$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$1dbecbe27a04f9af$exports, "useValueEffect", ()=>$4d60a29ecf011a9e$export$14d238f342723f25);
function $4d60a29ecf011a9e$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $acw62.useState)(defaultValue);
    let valueRef = (0, $acw62.useRef)(value);
    let effect = (0, $acw62.useRef)(null);
    valueRef.current = value;
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $acw62.useRef)(null);
    nextRef.current = ()=>{
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef.current();
        else setValue(newValue.value);
    };
    $4d60a29ecf011a9e$export$e5c5a5f917a5871c(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef.current();
    });
    let queue = (0, $acw62.useCallback)((fn)=>{
        effect.current = fn(valueRef.current);
        nextRef.current();
    }, [
        effect,
        nextRef
    ]);
    return [
        value,
        queue
    ];
}
var $4d60a29ecf011a9e$var$$2f04cbc44ee30ce0$exports = {};
$4d60a29ecf011a9e$var$$parcel$export($4d60a29ecf011a9e$var$$2f04cbc44ee30ce0$exports, "scrollIntoView", ()=>$4d60a29ecf011a9e$export$53a0910f038337bd);
function $4d60a29ecf011a9e$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $4d60a29ecf011a9e$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "left");
    let offsetY = $4d60a29ecf011a9e$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "top");
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    let maxX = x + scrollView.offsetWidth;
    let maxY = y + scrollView.offsetHeight;
    if (offsetX <= x) x = offsetX;
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= y) y = offsetY;
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $4d60a29ecf011a9e$var$$2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === "left" ? "offsetLeft" : "offsetTop";
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}



var $acw62 = parcelRequire("acw62");

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}



var $4c7cc2bf81666647$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($4c7cc2bf81666647$export$896afd8541959ee5 || ($4c7cc2bf81666647$export$896afd8541959ee5 = {}));




var $e62d085b79ea4606$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($e62d085b79ea4606$export$b87f371cbc396fcf || ($e62d085b79ea4606$export$b87f371cbc396fcf = {}));
var $e62d085b79ea4606$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($e62d085b79ea4606$export$906452485466fa53 || ($e62d085b79ea4606$export$906452485466fa53 = {}));
function $e62d085b79ea4606$export$cfa10c5697238752(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.literal;
}
function $e62d085b79ea4606$export$4f55724281bdfaf9(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.argument;
}
function $e62d085b79ea4606$export$e11187b219e191e1(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.number;
}
function $e62d085b79ea4606$export$32d811605da75f40(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.date;
}
function $e62d085b79ea4606$export$34ec46f596b1702f(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.time;
}
function $e62d085b79ea4606$export$dcfe1c11d168b5a1(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.select;
}
function $e62d085b79ea4606$export$6c796d116f0a4fbc(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.plural;
}
function $e62d085b79ea4606$export$c0ece297bdd0c082(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.pound;
}
function $e62d085b79ea4606$export$5c83de34745812b(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.tag;
}
function $e62d085b79ea4606$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $e62d085b79ea4606$export$906452485466fa53.number);
}
function $e62d085b79ea4606$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $e62d085b79ea4606$export$906452485466fa53.dateTime);
}
function $e62d085b79ea4606$export$f0ac572c1121c662(value) {
    return {
        type: $e62d085b79ea4606$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $e62d085b79ea4606$export$425e864b0ba114f1(value, style) {
    return {
        type: $e62d085b79ea4606$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $8a8e2dd39f8c2b53$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $8a8e2dd39f8c2b53$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $088961f6a5934025$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $088961f6a5934025$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($088961f6a5934025$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}



// @generated from regex-gen.ts
var $38d7ef65502c3cf1$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $68833020532266e2$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $38d7ef65502c3cf1$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $68833020532266e2$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $68833020532266e2$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $68833020532266e2$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $68833020532266e2$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $68833020532266e2$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $68833020532266e2$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $68833020532266e2$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $68833020532266e2$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $68833020532266e2$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $68833020532266e2$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, all), $68833020532266e2$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, all), $68833020532266e2$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($68833020532266e2$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($68833020532266e2$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($68833020532266e2$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), $68833020532266e2$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), $68833020532266e2$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $68833020532266e2$var$parseSign(token.stem);
        if (signOpts) result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $68833020532266e2$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $99659e106fc3b209$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};


function $2207e049a5272320$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $2207e049a5272320$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $2207e049a5272320$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $99659e106fc3b209$export$a8c9209db4084317)[regionTag || ""] || (0, $99659e106fc3b209$export$a8c9209db4084317)[languageTag || ""] || (0, $99659e106fc3b209$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $99659e106fc3b209$export$a8c9209db4084317)["001"];
    return hourCycles[0];
}


var $60e6f3ba709db920$var$_a;
var $60e6f3ba709db920$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $8a8e2dd39f8c2b53$export$523451f94304dd6c).source, "*"));
var $60e6f3ba709db920$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $8a8e2dd39f8c2b53$export$523451f94304dd6c).source, "*$"));
function $60e6f3ba709db920$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $60e6f3ba709db920$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $60e6f3ba709db920$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $60e6f3ba709db920$var$hasNativeFromEntries = !!Object.fromEntries;
var $60e6f3ba709db920$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $60e6f3ba709db920$var$hasTrimStart = !!String.prototype.trimStart;
var $60e6f3ba709db920$var$hasTrimEnd = !!String.prototype.trimEnd;
var $60e6f3ba709db920$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $60e6f3ba709db920$var$isSafeInteger = $60e6f3ba709db920$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $60e6f3ba709db920$var$re = $60e6f3ba709db920$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = (($60e6f3ba709db920$var$_a = $60e6f3ba709db920$var$re.exec("a")) === null || $60e6f3ba709db920$var$_a === void 0 ? void 0 : $60e6f3ba709db920$var$_a[0]) === "a";
} catch (_) {
    $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $60e6f3ba709db920$var$startsWith = $60e6f3ba709db920$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $60e6f3ba709db920$var$fromCodePoint = $60e6f3ba709db920$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $60e6f3ba709db920$var$fromEntries = // native
$60e6f3ba709db920$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $60e6f3ba709db920$var$codePointAt = $60e6f3ba709db920$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $60e6f3ba709db920$var$trimStart = $60e6f3ba709db920$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($60e6f3ba709db920$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $60e6f3ba709db920$var$trimEnd = $60e6f3ba709db920$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($60e6f3ba709db920$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $60e6f3ba709db920$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $60e6f3ba709db920$var$matchIdentifierAtIndex;
if ($60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1 = $60e6f3ba709db920$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $60e6f3ba709db920$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$60e6f3ba709db920$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $60e6f3ba709db920$var$codePointAt(s, index);
        if (c === undefined || $60e6f3ba709db920$var$_isWhiteSpace(c) || $60e6f3ba709db920$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $60e6f3ba709db920$var$fromCodePoint.apply(void 0, match);
};
var $60e6f3ba709db920$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).pound,
                    location: $60e6f3ba709db920$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $60e6f3ba709db920$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$60e6f3ba709db920$var$_isAlpha(this.char())) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_TAG, $60e6f3ba709db920$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $60e6f3ba709db920$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_TAG, $60e6f3ba709db920$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).UNCLOSED_TAG, $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_TAG, $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $60e6f3ba709db920$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $60e6f3ba709db920$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$60e6f3ba709db920$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $60e6f3ba709db920$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $60e6f3ba709db920$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EMPTY_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).MALFORMED_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).MALFORMED_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $60e6f3ba709db920$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $60e6f3ba709db920$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $60e6f3ba709db920$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $60e6f3ba709db920$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $60e6f3ba709db920$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $60e6f3ba709db920$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $60e6f3ba709db920$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $2207e049a5272320$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $e62d085b79ea4606$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $088961f6a5934025$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $e62d085b79ea4606$export$b87f371cbc396fcf).date : (0, $e62d085b79ea4606$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $e62d085b79ea4606$export$b87f371cbc396fcf).number : argType === "date" ? (0, $e62d085b79ea4606$export$b87f371cbc396fcf).date : (0, $e62d085b79ea4606$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $60e6f3ba709db920$var$createLocation(typeEndPosition_1, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $60e6f3ba709db920$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $e62d085b79ea4606$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $60e6f3ba709db920$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $60e6f3ba709db920$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $60e6f3ba709db920$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $68833020532266e2$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $e62d085b79ea4606$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $68833020532266e2$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $4c7cc2bf81666647$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $4c7cc2bf81666647$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $4c7cc2bf81666647$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $4c7cc2bf81666647$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $4c7cc2bf81666647$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $60e6f3ba709db920$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$60e6f3ba709db920$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $60e6f3ba709db920$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($60e6f3ba709db920$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $60e6f3ba709db920$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $60e6f3ba709db920$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $60e6f3ba709db920$var$_isAlphaOrSlash(codepoint) {
    return $60e6f3ba709db920$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $60e6f3ba709db920$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $60e6f3ba709db920$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $60e6f3ba709db920$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $b673c42291cd7fb6$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $e62d085b79ea4606$export$dcfe1c11d168b5a1)(el) || (0, $e62d085b79ea4606$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $b673c42291cd7fb6$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $e62d085b79ea4606$export$e11187b219e191e1)(el) && (0, $e62d085b79ea4606$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $e62d085b79ea4606$export$32d811605da75f40)(el) || (0, $e62d085b79ea4606$export$34ec46f596b1702f)(el)) && (0, $e62d085b79ea4606$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $e62d085b79ea4606$export$5c83de34745812b)(el)) $b673c42291cd7fb6$var$pruneLocation(el.children);
    });
}
function $b673c42291cd7fb6$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $60e6f3ba709db920$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $4c7cc2bf81666647$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $b673c42291cd7fb6$var$pruneLocation(result.val);
    return result.val;
}


//
// Main
//
function $8f38f7d77b1e84b6$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $8f38f7d77b1e84b6$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $8f38f7d77b1e84b6$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $8f38f7d77b1e84b6$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $8f38f7d77b1e84b6$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $8f38f7d77b1e84b6$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $8f38f7d77b1e84b6$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8f38f7d77b1e84b6$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8f38f7d77b1e84b6$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $8f38f7d77b1e84b6$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $8f38f7d77b1e84b6$var$monadic : $8f38f7d77b1e84b6$var$variadic;
    return $8f38f7d77b1e84b6$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $8f38f7d77b1e84b6$var$strategyVariadic(fn, options) {
    return $8f38f7d77b1e84b6$var$assemble(fn, this, $8f38f7d77b1e84b6$var$variadic, options.cache.create(), options.serializer);
}
function $8f38f7d77b1e84b6$var$strategyMonadic(fn, options) {
    return $8f38f7d77b1e84b6$var$assemble(fn, this, $8f38f7d77b1e84b6$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $8f38f7d77b1e84b6$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $8f38f7d77b1e84b6$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache();
    }
};
var $8f38f7d77b1e84b6$export$c5491a8691a23b9e = {
    variadic: $8f38f7d77b1e84b6$var$strategyVariadic,
    monadic: $8f38f7d77b1e84b6$var$strategyMonadic
};




var $b2de32051be1701b$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($b2de32051be1701b$export$d4e71bc0b80dc0fb || ($b2de32051be1701b$export$d4e71bc0b80dc0fb = {}));
var $b2de32051be1701b$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $b2de32051be1701b$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $b2de32051be1701b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($b2de32051be1701b$export$7369836851cc1329);
var $b2de32051be1701b$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $b2de32051be1701b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($b2de32051be1701b$export$7369836851cc1329);
var $b2de32051be1701b$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $b2de32051be1701b$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($b2de32051be1701b$export$7369836851cc1329);


var $a7bf6eec6df43b65$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($a7bf6eec6df43b65$export$49694c2877b44c57 || ($a7bf6eec6df43b65$export$49694c2877b44c57 = {}));
function $a7bf6eec6df43b65$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $a7bf6eec6df43b65$export$49694c2877b44c57.literal || part.type !== $a7bf6eec6df43b65$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $a7bf6eec6df43b65$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $a7bf6eec6df43b65$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $e62d085b79ea4606$export$cfa10c5697238752)(els[0])) return [
        {
            type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $e62d085b79ea4606$export$cfa10c5697238752)(el)) {
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $e62d085b79ea4606$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $b2de32051be1701b$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $e62d085b79ea4606$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $a7bf6eec6df43b65$export$49694c2877b44c57.literal : $a7bf6eec6df43b65$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $e62d085b79ea4606$export$32d811605da75f40)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $e62d085b79ea4606$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $e62d085b79ea4606$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $e62d085b79ea4606$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $e62d085b79ea4606$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $e62d085b79ea4606$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $e62d085b79ea4606$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$a7bf6eec6df43b65$export$df0c12a2d414a163(formatFn)) throw new (0, $b2de32051be1701b$export$cbc0db47c750f7c9)(value_1, "function", originalMessage);
            var parts = $a7bf6eec6df43b65$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $a7bf6eec6df43b65$export$49694c2877b44c57.literal : $a7bf6eec6df43b65$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $e62d085b79ea4606$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $b2de32051be1701b$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a7bf6eec6df43b65$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $e62d085b79ea4606$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $b2de32051be1701b$export$7369836851cc1329)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $b2de32051be1701b$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $b2de32051be1701b$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a7bf6eec6df43b65$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $a7bf6eec6df43b65$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $65f19ee2190344e6$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $65f19ee2190344e6$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $65f19ee2190344e6$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, defaultConfig));
}
function $65f19ee2190344e6$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $65f19ee2190344e6$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $8f38f7d77b1e84b6$export$2e2bcd8739ae039)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.number),
            strategy: (0, $8f38f7d77b1e84b6$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $8f38f7d77b1e84b6$export$2e2bcd8739ae039)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $8f38f7d77b1e84b6$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $8f38f7d77b1e84b6$export$2e2bcd8739ae039)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $8f38f7d77b1e84b6$export$c5491a8691a23b9e).variadic
        })
    };
}
var $65f19ee2190344e6$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $a7bf6eec6df43b65$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $a7bf6eec6df43b65$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $65f19ee2190344e6$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $65f19ee2190344e6$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $b673c42291cd7fb6$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();




var $693d63d2fb891c85$export$2e2bcd8739ae039 = (0, $65f19ee2190344e6$export$d342343268debc40);


class $ea9b33d428529013$export$64839e615120df17 {
    getStringForLocale(key, locale) {
        let strings = this.messages[locale];
        if (!strings) {
            strings = $ea9b33d428529013$var$$d6fd23bc337660df$var$getStringsForLocale(locale, this.messages, this.defaultLocale);
            this.messages[locale] = strings;
        }
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    constructor(messages, defaultLocale = "en-US"){
        // Clone messages so we don't modify the original object.
        this.messages = {
            ...messages
        };
        this.defaultLocale = defaultLocale;
    }
}
function $ea9b33d428529013$var$$d6fd23bc337660df$var$getStringsForLocale(locale, strings, defaultLocale = "en-US") {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $ea9b33d428529013$var$$d6fd23bc337660df$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + "-")) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $ea9b33d428529013$var$$d6fd23bc337660df$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split("-")[0];
}
class $ea9b33d428529013$export$526ebc05ff964723 {
    format(key, variables) {
        let message = this.cache[key];
        if (!message) {
            let msg = this.messages.getStringForLocale(key, this.locale);
            if (!msg) throw new Error(`Could not find intl message ${key} in ${this.locale} locale`);
            message = new (0, $693d63d2fb891c85$export$2e2bcd8739ae039)(msg, this.locale);
            this.cache[key] = message;
        }
        let varCopy;
        if (variables) varCopy = Object.keys(variables).reduce((acc, key)=>{
            acc[key] = variables[key] == null ? false : variables[key];
            return acc;
        }, {});
        return message.format(varCopy);
    }
    constructor(locale, messages){
        this.locale = locale;
        this.messages = messages;
        this.cache = {};
    }
}


function $2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(amount, numerator) {
    return amount - numerator * Math.floor(amount / numerator);
}
function $2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$784d13d8ee351f07(date) {
    if (date.era) return new $2af5319728ad75f0$export$99faa760c7908e4f(date.calendar, date.era, date.year, date.month, date.day);
    else return new $2af5319728ad75f0$export$99faa760c7908e4f(date.calendar, date.year, date.month, date.day);
}
function $2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$27fa0172ae2644b3(date) {
    if (date.era) return new $2af5319728ad75f0$export$ca871e8dbb80966f(date.calendar, date.era, date.year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
    else return new $2af5319728ad75f0$export$ca871e8dbb80966f(date.calendar, date.year, date.month, date.day, date.hour, date.minute, date.second);
}
const $2af5319728ad75f0$var$$3b62074eb05584b2$var$EPOCH = 1721426; // 001/01/03 Julian C.E.
function $2af5319728ad75f0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, month, day) {
    year = $2af5319728ad75f0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(era, year);
    let y1 = year - 1;
    let monthOffset = -2;
    if (month <= 2) monthOffset = 0;
    else if ($2af5319728ad75f0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year)) monthOffset = -1;
    return $2af5319728ad75f0$var$$3b62074eb05584b2$var$EPOCH - 1 + 365 * y1 + Math.floor(y1 / 4) - Math.floor(y1 / 100) + Math.floor(y1 / 400) + Math.floor((367 * month - 362) / 12 + monthOffset + day);
}
function $2af5319728ad75f0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $2af5319728ad75f0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(era, year) {
    return era === "BC" ? 1 - year : year;
}
function $2af5319728ad75f0$var$$3b62074eb05584b2$export$4475b7e617eb123c(year) {
    let era = "AD";
    if (year <= 0) {
        era = "BC";
        year = 1 - year;
    }
    return [
        era,
        year
    ];
}
const $2af5319728ad75f0$var$$3b62074eb05584b2$var$daysInMonth = {
    standard: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    leapyear: [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ]
};
class $2af5319728ad75f0$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let jd0 = jd;
        let depoch = jd0 - $2af5319728ad75f0$var$$3b62074eb05584b2$var$EPOCH;
        let quadricent = Math.floor(depoch / 146097);
        let dqc = $2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(depoch, 146097);
        let cent = Math.floor(dqc / 36524);
        let dcent = $2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(dqc, 36524);
        let quad = Math.floor(dcent / 1461);
        let dquad = $2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(dcent, 1461);
        let yindex = Math.floor(dquad / 365);
        let extendedYear = quadricent * 400 + cent * 100 + quad * 4 + yindex + (cent !== 4 && yindex !== 4 ? 1 : 0);
        let [era, year] = $2af5319728ad75f0$var$$3b62074eb05584b2$export$4475b7e617eb123c(extendedYear);
        let yearDay = jd0 - $2af5319728ad75f0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 1, 1);
        let leapAdj = 2;
        if (jd0 < $2af5319728ad75f0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 1)) leapAdj = 0;
        else if ($2af5319728ad75f0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year)) leapAdj = 1;
        let month = Math.floor(((yearDay + leapAdj) * 12 + 373) / 367);
        let day = jd0 - $2af5319728ad75f0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, month, 1) + 1;
        return new $2af5319728ad75f0$export$99faa760c7908e4f(era, year, month, day);
    }
    toJulianDay(date) {
        return $2af5319728ad75f0$var$$3b62074eb05584b2$export$f297eb839006d339(date.era, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        return $2af5319728ad75f0$var$$3b62074eb05584b2$var$daysInMonth[$2af5319728ad75f0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? "leapyear" : "standard"][date.month - 1];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getMonthsInYear(date) {
        return 12;
    }
    getDaysInYear(date) {
        return $2af5319728ad75f0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? 366 : 365;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getYearsInEra(date) {
        return 9999;
    }
    getEras() {
        return [
            "BC",
            "AD"
        ];
    }
    isInverseEra(date) {
        return date.era === "BC";
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === "BC" ? "AD" : "BC";
            date.year = 1 - date.year;
        }
    }
    constructor(){
        this.identifier = "gregory";
    }
}
const $2af5319728ad75f0$var$$2fe286d2fb449abb$export$7a5acbd77d414bd9 = {
    "001": 1,
    AD: 1,
    AE: 6,
    AF: 6,
    AI: 1,
    AL: 1,
    AM: 1,
    AN: 1,
    AT: 1,
    AX: 1,
    AZ: 1,
    BA: 1,
    BE: 1,
    BG: 1,
    BH: 6,
    BM: 1,
    BN: 1,
    BY: 1,
    CH: 1,
    CL: 1,
    CM: 1,
    CR: 1,
    CY: 1,
    CZ: 1,
    DE: 1,
    DJ: 6,
    DK: 1,
    DZ: 6,
    EC: 1,
    EE: 1,
    EG: 6,
    ES: 1,
    FI: 1,
    FJ: 1,
    FO: 1,
    FR: 1,
    GB: 1,
    GE: 1,
    GF: 1,
    GP: 1,
    GR: 1,
    HR: 1,
    HU: 1,
    IE: 1,
    IQ: 6,
    IR: 6,
    IS: 1,
    IT: 1,
    JO: 6,
    KG: 1,
    KW: 6,
    KZ: 1,
    LB: 1,
    LI: 1,
    LK: 1,
    LT: 1,
    LU: 1,
    LV: 1,
    LY: 6,
    MC: 1,
    MD: 1,
    ME: 1,
    MK: 1,
    MN: 1,
    MQ: 1,
    MV: 5,
    MY: 1,
    NL: 1,
    NO: 1,
    NZ: 1,
    OM: 6,
    PL: 1,
    QA: 6,
    RE: 1,
    RO: 1,
    RS: 1,
    RU: 1,
    SD: 6,
    SE: 1,
    SI: 1,
    SK: 1,
    SM: 1,
    SY: 6,
    TJ: 1,
    TM: 1,
    TR: 1,
    UA: 1,
    UY: 1,
    UZ: 1,
    VA: 1,
    VN: 1,
    XK: 1
};
function $2af5319728ad75f0$export$ea39ec197993aef0(a, b) {
    b = $2af5319728ad75f0$export$b4a036af3fc0b032(b, a.calendar);
    return a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function $2af5319728ad75f0$export$a18c89cbd24170ff(a, b) {
    b = $2af5319728ad75f0$export$b4a036af3fc0b032(b, a.calendar);
    // In the Japanese calendar, months can span multiple eras/years, so only compare the first of the month.
    a = $2af5319728ad75f0$export$a5a3b454ada2268e(a);
    b = $2af5319728ad75f0$export$a5a3b454ada2268e(b);
    return a.era === b.era && a.year === b.year && a.month === b.month;
}
function $2af5319728ad75f0$export$5841f9eb9773f25f(a, b) {
    b = $2af5319728ad75f0$export$b4a036af3fc0b032(b, a.calendar);
    a = $2af5319728ad75f0$export$f91e89d3d0406102(a);
    b = $2af5319728ad75f0$export$f91e89d3d0406102(b);
    return a.era === b.era && a.year === b.year;
}
function $2af5319728ad75f0$export$91b62ebf2ba703ee(a, b) {
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function $2af5319728ad75f0$export$5a8da0c44a3afdf2(a, b) {
    a = $2af5319728ad75f0$export$a5a3b454ada2268e(a);
    b = $2af5319728ad75f0$export$a5a3b454ada2268e(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month;
}
function $2af5319728ad75f0$export$ea840f5a6dda8147(a, b) {
    a = $2af5319728ad75f0$export$f91e89d3d0406102(a);
    b = $2af5319728ad75f0$export$f91e89d3d0406102(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year;
}
function $2af5319728ad75f0$export$629b0a497aa65267(date, timeZone) {
    return $2af5319728ad75f0$export$ea39ec197993aef0(date, $2af5319728ad75f0$export$d0bdf45af03a6ea3(timeZone));
}
function $2af5319728ad75f0$export$2061056d06d7cdf7(date, locale) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let dayOfWeek = Math.ceil(julian + 1 - $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$getWeekStart(locale)) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    return dayOfWeek;
}
function $2af5319728ad75f0$export$461939dd4422153(timeZone) {
    return $2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(Date.now(), timeZone);
}
function $2af5319728ad75f0$export$d0bdf45af03a6ea3(timeZone) {
    return $2af5319728ad75f0$export$93522d1a439f3617($2af5319728ad75f0$export$461939dd4422153(timeZone));
}
function $2af5319728ad75f0$var$$14e0f24ef4ac5c92$export$68781ddf31c0090f(a, b) {
    return a.calendar.toJulianDay(a) - b.calendar.toJulianDay(b);
}
function $2af5319728ad75f0$var$$14e0f24ef4ac5c92$export$c19a80a9721b80f6(a, b) {
    return $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$timeToMs(a) - $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$timeToMs(b);
}
function $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$timeToMs(a) {
    return a.hour * 3600000 + a.minute * 60000 + a.second * 1000 + a.millisecond;
}
function $2af5319728ad75f0$export$126c91c941de7e(a, timeZone) {
    let ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(a, timeZone);
    let tomorrow = a.add({
        days: 1
    });
    let tomorrowMs = $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(tomorrow, timeZone);
    return (tomorrowMs - ms) / 3600000;
}
let $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$localTimeZone = null;
function $2af5319728ad75f0$export$aa8b41735afcabd2() {
    // TODO: invalidate this somehow?
    if ($2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$localTimeZone == null) $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$localTimeZone;
}
function $2af5319728ad75f0$export$a5a3b454ada2268e(date) {
    // Use `subtract` instead of `set` so we don't get constrained in an era.
    return date.subtract({
        days: date.day - 1
    });
}
function $2af5319728ad75f0$export$a2258d9c4118825c(date) {
    return date.add({
        days: date.calendar.getDaysInMonth(date) - date.day
    });
}
function $2af5319728ad75f0$export$f91e89d3d0406102(date) {
    return $2af5319728ad75f0$export$a5a3b454ada2268e(date.subtract({
        months: date.month - 1
    }));
}
function $2af5319728ad75f0$export$8b7aa55c66d5569e(date) {
    return $2af5319728ad75f0$export$a2258d9c4118825c(date.add({
        months: date.calendar.getMonthsInYear(date) - date.month
    }));
}
function $2af5319728ad75f0$export$5412ac11713b72ad(date) {
    if (date.calendar.getMinimumMonthInYear) return date.calendar.getMinimumMonthInYear(date);
    return 1;
}
function $2af5319728ad75f0$export$b2f4953d301981d5(date) {
    if (date.calendar.getMinimumDayInMonth) return date.calendar.getMinimumDayInMonth(date);
    return 1;
}
function $2af5319728ad75f0$export$42c81a444fbfb5d4(date, locale) {
    let dayOfWeek = $2af5319728ad75f0$export$2061056d06d7cdf7(date, locale);
    return date.subtract({
        days: dayOfWeek
    });
}
function $2af5319728ad75f0$export$ef8b6d9133084f4e(date, locale) {
    return $2af5319728ad75f0$export$42c81a444fbfb5d4(date, locale).add({
        days: 6
    });
}
const $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$cachedRegions = new Map();
function $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$getRegion(locale) {
    // If the Intl.Locale API is available, use it to get the region for the locale.
    // @ts-ignore
    if (Intl.Locale) {
        // Constructing an Intl.Locale is expensive, so cache the result.
        let region = $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$cachedRegions.get(locale);
        if (!region) {
            // @ts-ignore
            region = new Intl.Locale(locale).maximize().region;
            $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$cachedRegions.set(locale, region);
        }
        return region;
    }
    // If not, just try splitting the string.
    // If the second part of the locale string is 'u',
    // then this is a unicode extension, so ignore it.
    // Otherwise, it should be the region.
    let part = locale.split("-")[1];
    return part === "u" ? null : part;
}
function $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$getWeekStart(locale) {
    // TODO: use Intl.Locale for this once browsers support the weekInfo property
    // https://github.com/tc39/proposal-intl-locale-info
    let region = $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$getRegion(locale);
    return $2af5319728ad75f0$var$$2fe286d2fb449abb$export$7a5acbd77d414bd9[region] || 0;
}
function $2af5319728ad75f0$export$ccc1b2479e7dd654(date, locale) {
    let days = date.calendar.getDaysInMonth(date);
    return Math.ceil(($2af5319728ad75f0$export$2061056d06d7cdf7($2af5319728ad75f0$export$a5a3b454ada2268e(date), locale) + days) / 7);
}
function $2af5319728ad75f0$export$5c333a116e949cdd(a, b) {
    if (a && b) return a.compare(b) <= 0 ? a : b;
    return a || b;
}
function $2af5319728ad75f0$export$a75f2bff57811055(a, b) {
    if (a && b) return a.compare(b) >= 0 ? a : b;
    return a || b;
}
const $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$WEEKEND_DATA = {
    AF: [
        4,
        5
    ],
    AE: [
        5,
        6
    ],
    BH: [
        5,
        6
    ],
    DZ: [
        5,
        6
    ],
    EG: [
        5,
        6
    ],
    IL: [
        5,
        6
    ],
    IQ: [
        5,
        6
    ],
    IR: [
        5,
        5
    ],
    JO: [
        5,
        6
    ],
    KW: [
        5,
        6
    ],
    LY: [
        5,
        6
    ],
    OM: [
        5,
        6
    ],
    QA: [
        5,
        6
    ],
    SA: [
        5,
        6
    ],
    SD: [
        5,
        6
    ],
    SY: [
        5,
        6
    ],
    YE: [
        5,
        6
    ]
};
function $2af5319728ad75f0$export$618d60ea299da42(date, locale) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let dayOfWeek = Math.ceil(julian + 1) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    let region = $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$getRegion(locale);
    // Use Intl.Locale for this once weekInfo is supported.
    // https://github.com/tc39/proposal-intl-locale-info
    let [start, end] = $2af5319728ad75f0$var$$14e0f24ef4ac5c92$var$WEEKEND_DATA[region] || [
        6,
        0
    ];
    return dayOfWeek === start || dayOfWeek === end;
}
function $2af5319728ad75f0$export$ee9d87258e1d19ed(date, locale) {
    return !$2af5319728ad75f0$export$618d60ea299da42(date, locale);
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) {
    date = $2af5319728ad75f0$export$b4a036af3fc0b032(date, new $2af5319728ad75f0$export$80ee6245ec4f29ec());
    let year = $2af5319728ad75f0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(date.era, date.year);
    return $2af5319728ad75f0$var$$11d87f3f76e88657$var$epochFromParts(year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, millisecond) {
    // Note: Date.UTC() interprets one and two-digit years as being in the
    // 20th century, so don't use it
    let date = new Date();
    date.setUTCHours(hour, minute, second, millisecond);
    date.setUTCFullYear(year, month - 1, day);
    return date.getTime();
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms, timeZone) {
    // Fast path for UTC.
    if (timeZone === "UTC") return 0;
    // Fast path: for local timezone, use native Date.
    if (timeZone === $2af5319728ad75f0$export$aa8b41735afcabd2()) return new Date(ms).getTimezoneOffset() * -60000;
    let { year: year, month: month, day: day, hour: hour, minute: minute, second: second } = $2af5319728ad75f0$var$$11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone);
    let utc = $2af5319728ad75f0$var$$11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, 0);
    return utc - Math.floor(ms / 1000) * 1000;
}
const $2af5319728ad75f0$var$$11d87f3f76e88657$var$formattersByTimeZone = new Map();
function $2af5319728ad75f0$var$$11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone) {
    let formatter = $2af5319728ad75f0$var$$11d87f3f76e88657$var$formattersByTimeZone.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            hour12: false,
            era: "short",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        });
        $2af5319728ad75f0$var$$11d87f3f76e88657$var$formattersByTimeZone.set(timeZone, formatter);
    }
    let parts = formatter.formatToParts(new Date(ms));
    let namedParts = {};
    for (let part of parts)if (part.type !== "literal") namedParts[part.type] = part.value;
    return {
        // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
        year: namedParts.era === "BC" || namedParts.era === "B" ? -namedParts.year + 1 : +namedParts.year,
        month: +namedParts.month,
        day: +namedParts.day,
        hour: namedParts.hour === "24" ? 0 : +namedParts.hour,
        minute: +namedParts.minute,
        second: +namedParts.second
    };
}
const $2af5319728ad75f0$var$$11d87f3f76e88657$var$DAYMILLIS = 86400000;
function $2af5319728ad75f0$var$$11d87f3f76e88657$export$136f38efe7caf549(date, timeZone) {
    let ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date);
    let earlier = ms - $2af5319728ad75f0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms - $2af5319728ad75f0$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let later = ms - $2af5319728ad75f0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms + $2af5319728ad75f0$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    return $2af5319728ad75f0$var$$11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later);
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later) {
    let found = earlier === later ? [
        earlier
    ] : [
        earlier,
        later
    ];
    return found.filter((absolute)=>$2af5319728ad75f0$var$$11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute));
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute) {
    let parts = $2af5319728ad75f0$var$$11d87f3f76e88657$var$getTimeZoneParts(absolute, timeZone);
    return date.year === parts.year && date.month === parts.month && date.day === parts.day && date.hour === parts.hour && date.minute === parts.minute && date.second === parts.second;
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(date, timeZone, disambiguation = "compatible") {
    let dateTime = $2af5319728ad75f0$export$b21e0b124e224484(date);
    // Fast path: if the time zone is UTC, use native Date.
    if (timeZone === "UTC") return $2af5319728ad75f0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime);
    // Fast path: if the time zone is the local timezone and disambiguation is compatible, use native Date.
    if (timeZone === $2af5319728ad75f0$export$aa8b41735afcabd2() && disambiguation === "compatible") {
        dateTime = $2af5319728ad75f0$export$b4a036af3fc0b032(dateTime, new $2af5319728ad75f0$export$80ee6245ec4f29ec());
        // Don't use Date constructor here because two-digit years are interpreted in the 20th century.
        let date = new Date();
        let year = $2af5319728ad75f0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(dateTime.era, dateTime.year);
        date.setFullYear(year, dateTime.month - 1, dateTime.day);
        date.setHours(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
        return date.getTime();
    }
    let ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime);
    let offsetBefore = $2af5319728ad75f0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms - $2af5319728ad75f0$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let offsetAfter = $2af5319728ad75f0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms + $2af5319728ad75f0$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let valid = $2af5319728ad75f0$var$$11d87f3f76e88657$var$getValidWallTimes(dateTime, timeZone, ms - offsetBefore, ms - offsetAfter);
    if (valid.length === 1) return valid[0];
    if (valid.length > 1) switch(disambiguation){
        // 'compatible' means 'earlier' for "fall back" transitions
        case "compatible":
        case "earlier":
            return valid[0];
        case "later":
            return valid[valid.length - 1];
        case "reject":
            throw new RangeError("Multiple possible absolute times found");
    }
    switch(disambiguation){
        case "earlier":
            return Math.min(ms - offsetBefore, ms - offsetAfter);
        // 'compatible' means 'later' for "spring forward" transitions
        case "compatible":
        case "later":
            return Math.max(ms - offsetBefore, ms - offsetAfter);
        case "reject":
            throw new RangeError("No such absolute time found");
    }
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$export$e67a095c620b86fe(dateTime, timeZone, disambiguation = "compatible") {
    return new Date($2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(dateTime, timeZone, disambiguation));
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, timeZone) {
    let offset = $2af5319728ad75f0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms, timeZone);
    let date = new Date(ms + offset);
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth() + 1;
    let day = date.getUTCDate();
    let hour = date.getUTCHours();
    let minute = date.getUTCMinutes();
    let second = date.getUTCSeconds();
    let millisecond = date.getUTCMilliseconds();
    return new $2af5319728ad75f0$export$d3b7288e7994edea(year, month, day, timeZone, offset, hour, minute, second, millisecond);
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$export$e57ff100d91bd4b9(date, timeZone) {
    return $2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(date.getTime(), timeZone);
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$export$d7f92bcd3596b086(date) {
    return $2af5319728ad75f0$var$$11d87f3f76e88657$export$e57ff100d91bd4b9(date, $2af5319728ad75f0$export$aa8b41735afcabd2());
}
function $2af5319728ad75f0$export$93522d1a439f3617(dateTime) {
    return new $2af5319728ad75f0$export$99faa760c7908e4f(dateTime.calendar, dateTime.era, dateTime.year, dateTime.month, dateTime.day);
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$export$6f4d78149f3f53ac(date) {
    return {
        era: date.era,
        year: date.year,
        month: date.month,
        day: date.day
    };
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$export$4d0393e732857be5(date) {
    return {
        hour: date.hour,
        minute: date.minute,
        second: date.second,
        millisecond: date.millisecond
    };
}
function $2af5319728ad75f0$export$b21e0b124e224484(date, time) {
    let hour = 0, minute = 0, second = 0, millisecond = 0;
    if ("timeZone" in date) ({ hour: hour, minute: minute, second: second, millisecond: millisecond } = date);
    else if ("hour" in date && !time) return date;
    if (time) ({ hour: hour, minute: minute, second: second, millisecond: millisecond } = time);
    return new $2af5319728ad75f0$export$ca871e8dbb80966f(date.calendar, date.era, date.year, date.month, date.day, hour, minute, second, millisecond);
}
function $2af5319728ad75f0$export$d33f79e3ffc3dc83(dateTime) {
    return new $2af5319728ad75f0$export$680ea196effce5f(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
}
function $2af5319728ad75f0$export$b4a036af3fc0b032(date, calendar) {
    if (date.calendar.identifier === calendar.identifier) return date;
    let calendarDate = calendar.fromJulianDay(date.calendar.toJulianDay(date));
    let copy = date.copy();
    copy.calendar = calendar;
    copy.era = calendarDate.era;
    copy.year = calendarDate.year;
    copy.month = calendarDate.month;
    copy.day = calendarDate.day;
    return copy;
}
function $2af5319728ad75f0$export$84c95a83c799e074(date, timeZone, disambiguation) {
    if (date instanceof $2af5319728ad75f0$export$d3b7288e7994edea) {
        if (date.timeZone === timeZone) return date;
        return $2af5319728ad75f0$export$538b00033cc11c75(date, timeZone);
    }
    let ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(date, timeZone, disambiguation);
    return $2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, timeZone);
}
function $2af5319728ad75f0$var$$11d87f3f76e88657$export$83aac07b4c37b25(date) {
    let ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
    return new Date(ms);
}
function $2af5319728ad75f0$export$538b00033cc11c75(date, timeZone) {
    let ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
    return $2af5319728ad75f0$export$b4a036af3fc0b032($2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, timeZone), date.calendar);
}
function $2af5319728ad75f0$export$d9b67bc93c097491(date) {
    return $2af5319728ad75f0$export$538b00033cc11c75(date, $2af5319728ad75f0$export$aa8b41735afcabd2());
}
const $2af5319728ad75f0$var$$735220c2d4774dd3$var$ONE_HOUR = 3600000;
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$e16d8520af44a096(date, duration) {
    let mutableDate = date.copy();
    let days = "hour" in date ? $2af5319728ad75f0$var$$735220c2d4774dd3$var$addTimeFields(date, duration) : 0;
    $2af5319728ad75f0$var$$735220c2d4774dd3$var$addYears(mutableDate, duration.years || 0);
    if (mutableDate.calendar.balanceYearMonth) mutableDate.calendar.balanceYearMonth(mutableDate, date);
    mutableDate.month += duration.months || 0;
    $2af5319728ad75f0$var$$735220c2d4774dd3$var$balanceYearMonth(mutableDate);
    $2af5319728ad75f0$var$$735220c2d4774dd3$var$constrainMonthDay(mutableDate);
    mutableDate.day += (duration.weeks || 0) * 7;
    mutableDate.day += duration.days || 0;
    mutableDate.day += days;
    $2af5319728ad75f0$var$$735220c2d4774dd3$var$balanceDay(mutableDate);
    if (mutableDate.calendar.balanceDate) mutableDate.calendar.balanceDate(mutableDate);
    // Constrain in case adding ended up with a date outside the valid range for the calendar system.
    // The behavior here is slightly different than when constraining in the `set` function in that
    // we adjust smaller fields to their minimum/maximum values rather than constraining each field
    // individually. This matches the general behavior of `add` vs `set` regarding how fields are balanced.
    if (mutableDate.year < 1) {
        mutableDate.year = 1;
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxYear = mutableDate.calendar.getYearsInEra(mutableDate);
    if (mutableDate.year > maxYear) {
        var _calendar, ref;
        let isInverseEra = (ref = (_calendar = mutableDate.calendar).isInverseEra) === null || ref === void 0 ? void 0 : ref.call(_calendar, mutableDate);
        mutableDate.year = maxYear;
        mutableDate.month = isInverseEra ? 1 : mutableDate.calendar.getMonthsInYear(mutableDate);
        mutableDate.day = isInverseEra ? 1 : mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    if (mutableDate.month < 1) {
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxMonth = mutableDate.calendar.getMonthsInYear(mutableDate);
    if (mutableDate.month > maxMonth) {
        mutableDate.month = maxMonth;
        mutableDate.day = mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    mutableDate.day = Math.max(1, Math.min(mutableDate.calendar.getDaysInMonth(mutableDate), mutableDate.day));
    return mutableDate;
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$var$addYears(date, years) {
    var _calendar, ref;
    if ((ref = (_calendar = date.calendar).isInverseEra) === null || ref === void 0 ? void 0 : ref.call(_calendar, date)) years = -years;
    date.year += years;
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$var$balanceYearMonth(date) {
    while(date.month < 1){
        $2af5319728ad75f0$var$$735220c2d4774dd3$var$addYears(date, -1);
        date.month += date.calendar.getMonthsInYear(date);
    }
    let monthsInYear = 0;
    while(date.month > (monthsInYear = date.calendar.getMonthsInYear(date))){
        date.month -= monthsInYear;
        $2af5319728ad75f0$var$$735220c2d4774dd3$var$addYears(date, 1);
    }
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$var$balanceDay(date) {
    while(date.day < 1){
        date.month--;
        $2af5319728ad75f0$var$$735220c2d4774dd3$var$balanceYearMonth(date);
        date.day += date.calendar.getDaysInMonth(date);
    }
    while(date.day > date.calendar.getDaysInMonth(date)){
        date.day -= date.calendar.getDaysInMonth(date);
        date.month++;
        $2af5319728ad75f0$var$$735220c2d4774dd3$var$balanceYearMonth(date);
    }
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$var$constrainMonthDay(date) {
    date.month = Math.max(1, Math.min(date.calendar.getMonthsInYear(date), date.month));
    date.day = Math.max(1, Math.min(date.calendar.getDaysInMonth(date), date.day));
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(date) {
    if (date.calendar.constrainDate) date.calendar.constrainDate(date);
    date.year = Math.max(1, Math.min(date.calendar.getYearsInEra(date), date.year));
    $2af5319728ad75f0$var$$735220c2d4774dd3$var$constrainMonthDay(date);
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration) {
    let inverseDuration = {};
    for(let key in duration)if (typeof duration[key] === "number") inverseDuration[key] = -duration[key];
    return inverseDuration;
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$4e2d2ead65e5f7e3(date, duration) {
    return $2af5319728ad75f0$var$$735220c2d4774dd3$export$e16d8520af44a096(date, $2af5319728ad75f0$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be(date, fields) {
    let mutableDate = date.copy();
    if (fields.era != null) mutableDate.era = fields.era;
    if (fields.year != null) mutableDate.year = fields.year;
    if (fields.month != null) mutableDate.month = fields.month;
    if (fields.day != null) mutableDate.day = fields.day;
    $2af5319728ad75f0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(mutableDate);
    return mutableDate;
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(value, fields) {
    let mutableValue = value.copy();
    if (fields.hour != null) mutableValue.hour = fields.hour;
    if (fields.minute != null) mutableValue.minute = fields.minute;
    if (fields.second != null) mutableValue.second = fields.second;
    if (fields.millisecond != null) mutableValue.millisecond = fields.millisecond;
    $2af5319728ad75f0$var$$735220c2d4774dd3$export$7555de1e070510cb(mutableValue);
    return mutableValue;
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$var$balanceTime(time) {
    time.second += Math.floor(time.millisecond / 1000);
    time.millisecond = $2af5319728ad75f0$var$$735220c2d4774dd3$var$nonNegativeMod(time.millisecond, 1000);
    time.minute += Math.floor(time.second / 60);
    time.second = $2af5319728ad75f0$var$$735220c2d4774dd3$var$nonNegativeMod(time.second, 60);
    time.hour += Math.floor(time.minute / 60);
    time.minute = $2af5319728ad75f0$var$$735220c2d4774dd3$var$nonNegativeMod(time.minute, 60);
    let days = Math.floor(time.hour / 24);
    time.hour = $2af5319728ad75f0$var$$735220c2d4774dd3$var$nonNegativeMod(time.hour, 24);
    return days;
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$7555de1e070510cb(time) {
    time.millisecond = Math.max(0, Math.min(time.millisecond, 1000));
    time.second = Math.max(0, Math.min(time.second, 59));
    time.minute = Math.max(0, Math.min(time.minute, 59));
    time.hour = Math.max(0, Math.min(time.hour, 23));
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$var$nonNegativeMod(a, b) {
    let result = a % b;
    if (result < 0) result += b;
    return result;
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$var$addTimeFields(time, duration) {
    time.hour += duration.hours || 0;
    time.minute += duration.minutes || 0;
    time.second += duration.seconds || 0;
    time.millisecond += duration.milliseconds || 0;
    return $2af5319728ad75f0$var$$735220c2d4774dd3$var$balanceTime(time);
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$7ed87b6bc2506470(time, duration) {
    let res = time.copy();
    $2af5319728ad75f0$var$$735220c2d4774dd3$var$addTimeFields(res, duration);
    return res;
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$fe34d3a381cd7501(time, duration) {
    return $2af5319728ad75f0$var$$735220c2d4774dd3$export$7ed87b6bc2506470(time, $2af5319728ad75f0$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$d52ced6badfb9a4c(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case "era":
            {
                let eras = value.calendar.getEras();
                let eraIndex = eras.indexOf(value.era);
                if (eraIndex < 0) throw new Error("Invalid era: " + value.era);
                eraIndex = $2af5319728ad75f0$var$$735220c2d4774dd3$var$cycleValue(eraIndex, amount, 0, eras.length - 1, options === null || options === void 0 ? void 0 : options.round);
                mutable.era = eras[eraIndex];
                // Constrain the year and other fields within the era, so the era doesn't change when we balance below.
                $2af5319728ad75f0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(mutable);
                break;
            }
        case "year":
            var _calendar, ref;
            if ((ref = (_calendar = mutable.calendar).isInverseEra) === null || ref === void 0 ? void 0 : ref.call(_calendar, mutable)) amount = -amount;
            // The year field should not cycle within the era as that can cause weird behavior affecting other fields.
            // We need to also allow values < 1 so that decrementing goes to the previous era. If we get -Infinity back
            // we know we wrapped around after reaching 9999 (the maximum), so set the year back to 1.
            mutable.year = $2af5319728ad75f0$var$$735220c2d4774dd3$var$cycleValue(value.year, amount, -Infinity, 9999, options === null || options === void 0 ? void 0 : options.round);
            if (mutable.year === -Infinity) mutable.year = 1;
            if (mutable.calendar.balanceYearMonth) mutable.calendar.balanceYearMonth(mutable, value);
            break;
        case "month":
            mutable.month = $2af5319728ad75f0$var$$735220c2d4774dd3$var$cycleValue(value.month, amount, 1, value.calendar.getMonthsInYear(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        case "day":
            mutable.day = $2af5319728ad75f0$var$$735220c2d4774dd3$var$cycleValue(value.day, amount, 1, value.calendar.getDaysInMonth(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    if (value.calendar.balanceDate) value.calendar.balanceDate(mutable);
    $2af5319728ad75f0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(mutable);
    return mutable;
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case "hour":
            {
                let hours = value.hour;
                let min = 0;
                let max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    let isPM = hours >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                mutable.hour = $2af5319728ad75f0$var$$735220c2d4774dd3$var$cycleValue(hours, amount, min, max, options === null || options === void 0 ? void 0 : options.round);
                break;
            }
        case "minute":
            mutable.minute = $2af5319728ad75f0$var$$735220c2d4774dd3$var$cycleValue(value.minute, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "second":
            mutable.second = $2af5319728ad75f0$var$$735220c2d4774dd3$var$cycleValue(value.second, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "millisecond":
            mutable.millisecond = $2af5319728ad75f0$var$$735220c2d4774dd3$var$cycleValue(value.millisecond, amount, 0, 999, options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    return mutable;
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$var$cycleValue(value, amount, min, max, round = false) {
    if (round) {
        value += Math.sign(amount);
        if (value < min) value = max;
        let div = Math.abs(amount);
        if (amount > 0) value = Math.ceil(value / div) * div;
        else value = Math.floor(value / div) * div;
        if (value > max) value = min;
    } else {
        value += amount;
        if (value < min) value = max - (min - value - 1);
        else if (value > max) value = min + (value - max - 1);
    }
    return value;
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$96b1d28349274637(dateTime, duration) {
    let ms;
    if (duration.years != null && duration.years !== 0 || duration.months != null && duration.months !== 0 || duration.days != null && duration.days !== 0) {
        let res = $2af5319728ad75f0$var$$735220c2d4774dd3$export$e16d8520af44a096($2af5319728ad75f0$export$b21e0b124e224484(dateTime), {
            years: duration.years,
            months: duration.months,
            days: duration.days
        });
        // Changing the date may change the timezone offset, so we need to recompute
        // using the 'compatible' disambiguation.
        ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone);
    } else ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime) - dateTime.offset;
    // Perform time manipulation in milliseconds rather than on the original time fields to account for DST.
    // For example, adding one hour during a DST transition may result in the hour field staying the same or
    // skipping an hour. This results in the offset field changing value instead of the specified field.
    ms += duration.milliseconds || 0;
    ms += (duration.seconds || 0) * 1000;
    ms += (duration.minutes || 0) * 60000;
    ms += (duration.hours || 0) * 3600000;
    let res = $2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone);
    return $2af5319728ad75f0$export$b4a036af3fc0b032(res, dateTime.calendar);
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$6814caac34ca03c7(dateTime, duration) {
    return $2af5319728ad75f0$var$$735220c2d4774dd3$export$96b1d28349274637(dateTime, $2af5319728ad75f0$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$9a297d111fc86b79(dateTime, field, amount, options) {
    // For date fields, we want the time to remain consistent and the UTC offset to potentially change to account for DST changes.
    // For time fields, we want the time to change by the amount given. This may result in the hour field staying the same, but the UTC
    // offset changing in the case of a backward DST transition, or skipping an hour in the case of a forward DST transition.
    switch(field){
        case "hour":
            {
                let min = 0;
                let max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    let isPM = dateTime.hour >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                // The minimum and maximum hour may be affected by daylight saving time.
                // For example, it might jump forward at midnight, and skip 1am.
                // Or it might end at midnight and repeat the 11pm hour. To handle this, we get
                // the possible absolute times for the min and max, and find the maximum range
                // that is within the current day.
                let plainDateTime = $2af5319728ad75f0$export$b21e0b124e224484(dateTime);
                let minDate = $2af5319728ad75f0$export$b4a036af3fc0b032($2af5319728ad75f0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: min
                }), new $2af5319728ad75f0$export$80ee6245ec4f29ec());
                let minAbsolute = [
                    $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(minDate, dateTime.timeZone, "earlier"),
                    $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(minDate, dateTime.timeZone, "later")
                ].filter((ms)=>$2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone).day === minDate.day)[0];
                let maxDate = $2af5319728ad75f0$export$b4a036af3fc0b032($2af5319728ad75f0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: max
                }), new $2af5319728ad75f0$export$80ee6245ec4f29ec());
                let maxAbsolute = [
                    $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(maxDate, dateTime.timeZone, "earlier"),
                    $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(maxDate, dateTime.timeZone, "later")
                ].filter((ms)=>$2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone).day === maxDate.day).pop();
                // Since hours may repeat, we need to operate on the absolute time in milliseconds.
                // This is done in hours from the Unix epoch so that cycleValue works correctly,
                // and then converted back to milliseconds.
                let ms1 = $2af5319728ad75f0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime) - dateTime.offset;
                let hours = Math.floor(ms1 / $2af5319728ad75f0$var$$735220c2d4774dd3$var$ONE_HOUR);
                let remainder = ms1 % $2af5319728ad75f0$var$$735220c2d4774dd3$var$ONE_HOUR;
                ms1 = $2af5319728ad75f0$var$$735220c2d4774dd3$var$cycleValue(hours, amount, Math.floor(minAbsolute / $2af5319728ad75f0$var$$735220c2d4774dd3$var$ONE_HOUR), Math.floor(maxAbsolute / $2af5319728ad75f0$var$$735220c2d4774dd3$var$ONE_HOUR), options === null || options === void 0 ? void 0 : options.round) * $2af5319728ad75f0$var$$735220c2d4774dd3$var$ONE_HOUR + remainder;
                // Now compute the new timezone offset, and convert the absolute time back to local time.
                return $2af5319728ad75f0$export$b4a036af3fc0b032($2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms1, dateTime.timeZone), dateTime.calendar);
            }
        case "minute":
        case "second":
        case "millisecond":
            // @ts-ignore
            return $2af5319728ad75f0$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(dateTime, field, amount, options);
        case "era":
        case "year":
        case "month":
        case "day":
            {
                let res = $2af5319728ad75f0$var$$735220c2d4774dd3$export$d52ced6badfb9a4c($2af5319728ad75f0$export$b21e0b124e224484(dateTime), field, amount, options);
                let ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone);
                return $2af5319728ad75f0$export$b4a036af3fc0b032($2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone), dateTime.calendar);
            }
        default:
            throw new Error("Unsupported field " + field);
    }
}
function $2af5319728ad75f0$var$$735220c2d4774dd3$export$31b5430eb18be4f8(dateTime, fields, disambiguation) {
    // Set the date/time fields, and recompute the UTC offset to account for DST changes.
    // We also need to validate by converting back to a local time in case hours are skipped during forward DST transitions.
    let plainDateTime = $2af5319728ad75f0$export$b21e0b124e224484(dateTime);
    let res = $2af5319728ad75f0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56($2af5319728ad75f0$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be(plainDateTime, fields), fields);
    // If the resulting plain date time values are equal, return the original time.
    // We don't want to change the offset when setting the time to the same value.
    if (res.compare(plainDateTime) === 0) return dateTime;
    let ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone, disambiguation);
    return $2af5319728ad75f0$export$b4a036af3fc0b032($2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone), dateTime.calendar);
}
const $2af5319728ad75f0$var$$fae977aafc393c5c$var$TIME_RE = /^(\d{2})(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const $2af5319728ad75f0$var$$fae977aafc393c5c$var$DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const $2af5319728ad75f0$var$$fae977aafc393c5c$var$DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const $2af5319728ad75f0$var$$fae977aafc393c5c$var$ZONED_DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:([+-]\d{2})(?::(\d{2}))?)?\[(.*?)\]$/;
const $2af5319728ad75f0$var$$fae977aafc393c5c$var$ABSOLUTE_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::(\d{2}))?)|Z)$/;
function $2af5319728ad75f0$export$c9698ec7f05a07e1(value) {
    let m = value.match($2af5319728ad75f0$var$$fae977aafc393c5c$var$TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 time string: " + value);
    return new $2af5319728ad75f0$export$680ea196effce5f($2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[1], 0, 23), m[2] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[2], 0, 59) : 0, m[3] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, 59) : 0, m[4] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, Infinity) * 1000 : 0);
}
function $2af5319728ad75f0$export$6b862160d295c8e(value) {
    let m = value.match($2af5319728ad75f0$var$$fae977aafc393c5c$var$DATE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date string: " + value);
    let date = new $2af5319728ad75f0$export$99faa760c7908e4f($2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[1], 0, 9999), $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1);
    date.day = $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function $2af5319728ad75f0$export$588937bcd60ade55(value) {
    let m = value.match($2af5319728ad75f0$var$$fae977aafc393c5c$var$DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new $2af5319728ad75f0$export$ca871e8dbb80966f($2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[4] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function $2af5319728ad75f0$export$fd7893f06e92a6a4(value, disambiguation) {
    let m = value.match($2af5319728ad75f0$var$$fae977aafc393c5c$var$ZONED_DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new $2af5319728ad75f0$export$d3b7288e7994edea($2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[10], 0, m[4] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    let plainDateTime = $2af5319728ad75f0$export$b21e0b124e224484(date);
    let ms;
    if (m[8]) {
        var ref;
        date.offset = $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[8], -23, 23) * 3600000 + $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber((ref = m[9]) !== null && ref !== void 0 ? ref : "0", 0, 59) * 60000;
        ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
        // Validate offset against parsed date.
        let absolutes = $2af5319728ad75f0$var$$11d87f3f76e88657$export$136f38efe7caf549(plainDateTime, date.timeZone);
        if (!absolutes.includes(ms)) throw new Error(`Offset ${$2af5319728ad75f0$var$$fae977aafc393c5c$var$offsetToString(date.offset)} is invalid for ${$2af5319728ad75f0$var$$fae977aafc393c5c$export$4223de14708adc63(date)} in ${date.timeZone}`);
    } else ms = $2af5319728ad75f0$var$$11d87f3f76e88657$export$5107c82f94518f5c($2af5319728ad75f0$export$b21e0b124e224484(plainDateTime), date.timeZone, disambiguation);
    return $2af5319728ad75f0$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, date.timeZone);
}
function $2af5319728ad75f0$export$5adfdab05168c219(value, timeZone) {
    let m = value.match($2af5319728ad75f0$var$$fae977aafc393c5c$var$ABSOLUTE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new $2af5319728ad75f0$export$d3b7288e7994edea($2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, timeZone, 0, m[4] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    var ref;
    if (m[8]) date.offset = $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(m[8], -23, 23) * 3600000 + $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber((ref = m[9]) !== null && ref !== void 0 ? ref : "0", 0, 59) * 60000;
    return $2af5319728ad75f0$export$538b00033cc11c75(date, timeZone);
}
function $2af5319728ad75f0$export$8e384432362ed0f0(value) {
    return $2af5319728ad75f0$export$5adfdab05168c219(value, $2af5319728ad75f0$export$aa8b41735afcabd2());
}
function $2af5319728ad75f0$var$$fae977aafc393c5c$var$parseNumber(value, min, max) {
    let val = Number(value);
    if (val < min || val > max) throw new RangeError(`Value out of range: ${min} <= ${val} <= ${max}`);
    return val;
}
function $2af5319728ad75f0$var$$fae977aafc393c5c$export$f59dee82248f5ad4(time) {
    return `${String(time.hour).padStart(2, "0")}:${String(time.minute).padStart(2, "0")}:${String(time.second).padStart(2, "0")}${time.millisecond ? String(time.millisecond / 1000).slice(1) : ""}`;
}
function $2af5319728ad75f0$var$$fae977aafc393c5c$export$60dfd74aa96791bd(date) {
    let gregorianDate = $2af5319728ad75f0$export$b4a036af3fc0b032(date, new $2af5319728ad75f0$export$80ee6245ec4f29ec());
    return `${String(gregorianDate.year).padStart(4, "0")}-${String(gregorianDate.month).padStart(2, "0")}-${String(gregorianDate.day).padStart(2, "0")}`;
}
function $2af5319728ad75f0$var$$fae977aafc393c5c$export$4223de14708adc63(date) {
    // @ts-ignore
    return `${$2af5319728ad75f0$var$$fae977aafc393c5c$export$60dfd74aa96791bd(date)}T${$2af5319728ad75f0$var$$fae977aafc393c5c$export$f59dee82248f5ad4(date)}`;
}
function $2af5319728ad75f0$var$$fae977aafc393c5c$var$offsetToString(offset) {
    let sign = Math.sign(offset) < 0 ? "-" : "+";
    offset = Math.abs(offset);
    let offsetHours = Math.floor(offset / 3600000);
    let offsetMinutes = offset % 3600000 / 60000;
    return `${sign}${String(offsetHours).padStart(2, "0")}:${String(offsetMinutes).padStart(2, "0")}`;
}
function $2af5319728ad75f0$var$$fae977aafc393c5c$export$bf79f1ebf4b18792(date) {
    return `${$2af5319728ad75f0$var$$fae977aafc393c5c$export$4223de14708adc63(date)}${$2af5319728ad75f0$var$$fae977aafc393c5c$var$offsetToString(date.offset)}[${date.timeZone}]`;
}
function $2af5319728ad75f0$var$$35ea8db9cb2ccb90$var$shiftArgs(args) {
    let calendar = typeof args[0] === "object" ? args.shift() : new $2af5319728ad75f0$export$80ee6245ec4f29ec();
    let era;
    if (typeof args[0] === "string") era = args.shift();
    else {
        let eras = calendar.getEras();
        era = eras[eras.length - 1];
    }
    let year = args.shift();
    let month = args.shift();
    let day = args.shift();
    return [
        calendar,
        era,
        year,
        month,
        day
    ];
}
class $2af5319728ad75f0$export$99faa760c7908e4f {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $2af5319728ad75f0$export$99faa760c7908e4f(this.calendar, this.era, this.year, this.month, this.day);
        else return new $2af5319728ad75f0$export$99faa760c7908e4f(this.calendar, this.year, this.month, this.day);
    }
    /** Returns a new `CalendarDate` with the given duration added to it. */ add(duration) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$e16d8520af44a096(this, duration);
    }
    /** Returns a new `CalendarDate` with the given duration subtracted from it. */ subtract(duration) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$4e2d2ead65e5f7e3(this, duration);
    }
    /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be(this, fields);
    }
    /**
   * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$d52ced6badfb9a4c(this, field, amount, options);
    }
    /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */ toDate(timeZone) {
        return $2af5319728ad75f0$var$$11d87f3f76e88657$export$e67a095c620b86fe(this, timeZone);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return $2af5319728ad75f0$var$$fae977aafc393c5c$export$60dfd74aa96791bd(this);
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        return $2af5319728ad75f0$var$$14e0f24ef4ac5c92$export$68781ddf31c0090f(this, b);
    }
    constructor(...args){
        // This prevents TypeScript from allowing other types with the same fields to match.
        // i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
        // If that behavior is desired, use the AnyCalendarDate interface instead.
        $2af5319728ad75f0$var$_type.set(this, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $2af5319728ad75f0$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        $2af5319728ad75f0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
}
var $2af5319728ad75f0$var$_type = new WeakMap();
class $2af5319728ad75f0$export$680ea196effce5f {
    /** Returns a copy of this time. */ copy() {
        return new $2af5319728ad75f0$export$680ea196effce5f(this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `Time` with the given duration added to it. */ add(duration) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$7ed87b6bc2506470(this, duration);
    }
    /** Returns a new `Time` with the given duration subtracted from it. */ subtract(duration) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$fe34d3a381cd7501(this, duration);
    }
    /** Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(this, fields);
    }
    /**
   * Returns a new `Time` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(this, field, amount, options);
    }
    /** Converts the time to an ISO 8601 formatted string. */ toString() {
        return $2af5319728ad75f0$var$$fae977aafc393c5c$export$f59dee82248f5ad4(this);
    }
    /** Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after. */ compare(b) {
        return $2af5319728ad75f0$var$$14e0f24ef4ac5c92$export$c19a80a9721b80f6(this, b);
    }
    constructor(hour = 0, minute = 0, second = 0, millisecond = 0){
        // This prevents TypeScript from allowing other types with the same fields to match.
        $2af5319728ad75f0$var$_type1.set(this, {
            writable: true,
            value: void 0
        });
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
        $2af5319728ad75f0$var$$735220c2d4774dd3$export$7555de1e070510cb(this);
    }
}
var $2af5319728ad75f0$var$_type1 = new WeakMap();
class $2af5319728ad75f0$export$ca871e8dbb80966f {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $2af5319728ad75f0$export$ca871e8dbb80966f(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
        else return new $2af5319728ad75f0$export$ca871e8dbb80966f(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `CalendarDateTime` with the given duration added to it. */ add(duration) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$e16d8520af44a096(this, duration);
    }
    /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$4e2d2ead65e5f7e3(this, duration);
    }
    /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be($2af5319728ad75f0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(this, fields), fields);
    }
    /**
   * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        switch(field){
            case "era":
            case "year":
            case "month":
            case "day":
                return $2af5319728ad75f0$var$$735220c2d4774dd3$export$d52ced6badfb9a4c(this, field, amount, options);
            default:
                return $2af5319728ad75f0$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(this, field, amount, options);
        }
    }
    /** Converts the date to a native JavaScript Date object in the given time zone. */ toDate(timeZone, disambiguation) {
        return $2af5319728ad75f0$var$$11d87f3f76e88657$export$e67a095c620b86fe(this, timeZone, disambiguation);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return $2af5319728ad75f0$var$$fae977aafc393c5c$export$4223de14708adc63(this);
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        let res = $2af5319728ad75f0$var$$14e0f24ef4ac5c92$export$68781ddf31c0090f(this, b);
        if (res === 0) return $2af5319728ad75f0$var$$14e0f24ef4ac5c92$export$c19a80a9721b80f6(this, $2af5319728ad75f0$export$b21e0b124e224484(b));
        return res;
    }
    constructor(...args){
        // This prevents TypeScript from allowing other types with the same fields to match.
        $2af5319728ad75f0$var$_type2.set(this, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $2af5319728ad75f0$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        $2af5319728ad75f0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
}
var $2af5319728ad75f0$var$_type2 = new WeakMap();
class $2af5319728ad75f0$export$d3b7288e7994edea {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $2af5319728ad75f0$export$d3b7288e7994edea(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
        else return new $2af5319728ad75f0$export$d3b7288e7994edea(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `ZonedDateTime` with the given duration added to it. */ add(duration) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$96b1d28349274637(this, duration);
    }
    /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$6814caac34ca03c7(this, duration);
    }
    /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields, disambiguation) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$31b5430eb18be4f8(this, fields, disambiguation);
    }
    /**
   * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return $2af5319728ad75f0$var$$735220c2d4774dd3$export$9a297d111fc86b79(this, field, amount, options);
    }
    /** Converts the date to a native JavaScript Date object. */ toDate() {
        return $2af5319728ad75f0$var$$11d87f3f76e88657$export$83aac07b4c37b25(this);
    }
    /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */ toString() {
        return $2af5319728ad75f0$var$$fae977aafc393c5c$export$bf79f1ebf4b18792(this);
    }
    /** Converts the date to an ISO 8601 formatted string in UTC. */ toAbsoluteString() {
        return this.toDate().toISOString();
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        // TODO: Is this a bad idea??
        return this.toDate().getTime() - $2af5319728ad75f0$export$84c95a83c799e074(b, this.timeZone).toDate().getTime();
    }
    constructor(...args){
        // This prevents TypeScript from allowing other types with the same fields to match.
        $2af5319728ad75f0$var$_type3.set(this, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $2af5319728ad75f0$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        let timeZone = args.shift();
        let offset = args.shift();
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.timeZone = timeZone;
        this.offset = offset;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        $2af5319728ad75f0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
}
var $2af5319728ad75f0$var$_type3 = new WeakMap();
const $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_START_DATES = [
    [
        1868,
        9,
        8
    ],
    [
        1912,
        7,
        30
    ],
    [
        1926,
        12,
        25
    ],
    [
        1989,
        1,
        8
    ],
    [
        2019,
        5,
        1
    ]
];
const $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_END_DATES = [
    [
        1912,
        7,
        29
    ],
    [
        1926,
        12,
        24
    ],
    [
        1989,
        1,
        7
    ],
    [
        2019,
        4,
        30
    ]
];
const $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_ADDENDS = [
    1867,
    1911,
    1925,
    1988,
    2018
];
const $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_NAMES = [
    "meiji",
    "taisho",
    "showa",
    "heisei",
    "reiwa"
];
function $2af5319728ad75f0$var$$62225008020f0a13$var$findEraFromGregorianDate(date) {
    const idx = $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_START_DATES.findIndex(([year, month, day])=>{
        if (date.year < year) return true;
        if (date.year === year && date.month < month) return true;
        if (date.year === year && date.month === month && date.day < day) return true;
        return false;
    });
    if (idx === -1) return $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_START_DATES.length - 1;
    if (idx === 0) return 0;
    return idx - 1;
}
function $2af5319728ad75f0$var$$62225008020f0a13$var$toGregorian(date) {
    let eraAddend = $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_ADDENDS[$2af5319728ad75f0$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era)];
    if (!eraAddend) throw new Error("Unknown era: " + date.era);
    return new $2af5319728ad75f0$export$99faa760c7908e4f(date.year + eraAddend, date.month, date.day);
}
class $2af5319728ad75f0$export$b746ab2b60cdffbf extends $2af5319728ad75f0$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let era = $2af5319728ad75f0$var$$62225008020f0a13$var$findEraFromGregorianDate(date);
        return new $2af5319728ad75f0$export$99faa760c7908e4f(this, $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_NAMES[era], date.year - $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_ADDENDS[era], date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($2af5319728ad75f0$var$$62225008020f0a13$var$toGregorian(date));
    }
    balanceDate(date) {
        let gregorianDate = $2af5319728ad75f0$var$$62225008020f0a13$var$toGregorian(date);
        let era = $2af5319728ad75f0$var$$62225008020f0a13$var$findEraFromGregorianDate(gregorianDate);
        if ($2af5319728ad75f0$var$$62225008020f0a13$var$ERA_NAMES[era] !== date.era) {
            date.era = $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_NAMES[era];
            date.year = gregorianDate.year - $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_ADDENDS[era];
        }
        // Constrain in case we went before the first supported era.
        this.constrainDate(date);
    }
    constrainDate(date) {
        let idx = $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        let end = $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_END_DATES[idx];
        if (end != null) {
            let [endYear, endMonth, endDay] = end;
            // Constrain the year to the maximum possible value in the era.
            // Then constrain the month and day fields within that.
            let maxYear = endYear - $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_ADDENDS[idx];
            date.year = Math.max(1, Math.min(maxYear, date.year));
            if (date.year === maxYear) {
                date.month = Math.min(endMonth, date.month);
                if (date.month === endMonth) date.day = Math.min(endDay, date.day);
            }
            if (date.year === 1) {
                let [, startMonth, startDay] = $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_START_DATES[idx];
                date.month = Math.max(startMonth, date.month);
                if (date.month === startMonth) date.day = Math.max(startDay, date.day);
            }
        }
    }
    getEras() {
        return $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_NAMES;
    }
    getYearsInEra(date) {
        // Get the number of years in the era, taking into account the date's month and day fields.
        let era = $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        let next = $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_START_DATES[era + 1];
        if (next == null) return 9999;
        let cur = $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_START_DATES[era];
        let years = next[0] - cur[0];
        if (date.month < next[1] || date.month === next[1] && date.day < next[2]) years++;
        return years;
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($2af5319728ad75f0$var$$62225008020f0a13$var$toGregorian(date));
    }
    getMinimumMonthInYear(date) {
        let start = $2af5319728ad75f0$var$$62225008020f0a13$var$getMinimums(date);
        return start ? start[1] : 1;
    }
    getMinimumDayInMonth(date) {
        let start = $2af5319728ad75f0$var$$62225008020f0a13$var$getMinimums(date);
        return start && date.month === start[1] ? start[2] : 1;
    }
    constructor(...args){
        super(...args);
        this.identifier = "japanese";
    }
}
function $2af5319728ad75f0$var$$62225008020f0a13$var$getMinimums(date) {
    if (date.year === 1) {
        let idx = $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        return $2af5319728ad75f0$var$$62225008020f0a13$var$ERA_START_DATES[idx];
    }
}
const $2af5319728ad75f0$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START = -543;
class $2af5319728ad75f0$export$42d20a78301dee44 extends $2af5319728ad75f0$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let gregorianDate = super.fromJulianDay(jd);
        let year = $2af5319728ad75f0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(gregorianDate.era, gregorianDate.year);
        return new $2af5319728ad75f0$export$99faa760c7908e4f(this, year - $2af5319728ad75f0$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START, gregorianDate.month, gregorianDate.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($2af5319728ad75f0$var$$8d73d47422ca7302$var$toGregorian(date));
    }
    getEras() {
        return [
            "BE"
        ];
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($2af5319728ad75f0$var$$8d73d47422ca7302$var$toGregorian(date));
    }
    balanceDate() {}
    constructor(...args){
        super(...args);
        this.identifier = "buddhist";
    }
}
function $2af5319728ad75f0$var$$8d73d47422ca7302$var$toGregorian(date) {
    let [era, year] = $2af5319728ad75f0$var$$3b62074eb05584b2$export$4475b7e617eb123c(date.year + $2af5319728ad75f0$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START);
    return new $2af5319728ad75f0$export$99faa760c7908e4f(era, year, date.month, date.day);
}
const $2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START = 1911;
function $2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$gregorianYear(date) {
    return date.era === "minguo" ? date.year + $2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START : 1 - date.year + $2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
}
function $2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan(year) {
    let y = year - $2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
    if (y > 0) return [
        "minguo",
        y
    ];
    else return [
        "before_minguo",
        1 - y
    ];
}
class $2af5319728ad75f0$export$65e01080afcb0799 extends $2af5319728ad75f0$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let extendedYear = $2af5319728ad75f0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(date.era, date.year);
        let [era, year] = $2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan(extendedYear);
        return new $2af5319728ad75f0$export$99faa760c7908e4f(this, era, year, date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$toGregorian(date));
    }
    getEras() {
        return [
            "before_minguo",
            "minguo"
        ];
    }
    balanceDate(date) {
        let [era, year] = $2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan($2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$gregorianYear(date));
        date.era = era;
        date.year = year;
    }
    isInverseEra(date) {
        return date.era === "before_minguo";
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$toGregorian(date));
    }
    constructor(...args){
        super(...args);
        this.identifier // Republic of China
         = "roc";
    }
}
function $2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$toGregorian(date) {
    let [era, year] = $2af5319728ad75f0$var$$3b62074eb05584b2$export$4475b7e617eb123c($2af5319728ad75f0$var$$5f31bd6f0c8940b2$var$gregorianYear(date));
    return new $2af5319728ad75f0$export$99faa760c7908e4f(era, year, date.month, date.day);
}
const $2af5319728ad75f0$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH = 1948321; // 622/03/19 Julian C.E.
function $2af5319728ad75f0$var$$f3ed2e4472ae7e25$var$isLeapYear(year) {
    let y0 = year > 0 ? year - 474 : year - 473;
    let y1 = $2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(y0, 2820) + 474;
    return $2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1((y1 + 38) * 31, 128) < 31;
}
function $2af5319728ad75f0$var$$f3ed2e4472ae7e25$var$persianToJulianDay(year, month, day) {
    let y0 = year > 0 ? year - 474 : year - 473;
    let y1 = $2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(y0, 2820) + 474;
    let offset = month <= 7 ? 31 * (month - 1) : 30 * (month - 1) + 6;
    return $2af5319728ad75f0$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH - 1 + 1029983 * Math.floor(y0 / 2820) + 365 * (y1 - 1) + Math.floor((31 * y1 - 5) / 128) + offset + day;
}
class $2af5319728ad75f0$export$37fccdbfd14c5939 {
    fromJulianDay(jd) {
        let d0 = jd - $2af5319728ad75f0$var$$f3ed2e4472ae7e25$var$persianToJulianDay(475, 1, 1);
        let n2820 = Math.floor(d0 / 1029983);
        let d1 = $2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(d0, 1029983);
        let y2820 = d1 === 1029982 ? 2820 : Math.floor((128 * d1 + 46878) / 46751);
        let year = 474 + 2820 * n2820 + y2820;
        if (year <= 0) year--;
        let yDay = jd - $2af5319728ad75f0$var$$f3ed2e4472ae7e25$var$persianToJulianDay(year, 1, 1) + 1;
        let month = yDay <= 186 ? Math.ceil(yDay / 31) : Math.ceil((yDay - 6) / 31);
        let day = jd - $2af5319728ad75f0$var$$f3ed2e4472ae7e25$var$persianToJulianDay(year, month, 1) + 1;
        return new $2af5319728ad75f0$export$99faa760c7908e4f(this, year, month, day);
    }
    toJulianDay(date) {
        return $2af5319728ad75f0$var$$f3ed2e4472ae7e25$var$persianToJulianDay(date.year, date.month, date.day);
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInMonth(date) {
        if (date.month <= 6) return 31;
        if (date.month <= 11) return 30;
        return $2af5319728ad75f0$var$$f3ed2e4472ae7e25$var$isLeapYear(date.year) ? 30 : 29;
    }
    getEras() {
        return [
            "AP"
        ];
    }
    getYearsInEra() {
        return 9999;
    }
    constructor(){
        this.identifier = "persian";
    }
}
// Starts in 78 AD,
const $2af5319728ad75f0$var$$82c358003bdda0a8$var$INDIAN_ERA_START = 78;
// The Indian year starts 80 days later than the Gregorian year.
const $2af5319728ad75f0$var$$82c358003bdda0a8$var$INDIAN_YEAR_START = 80;
class $2af5319728ad75f0$export$39f31c639fa15726 extends $2af5319728ad75f0$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        // Gregorian date for Julian day
        let date = super.fromJulianDay(jd);
        // Year in Saka era
        let indianYear = date.year - $2af5319728ad75f0$var$$82c358003bdda0a8$var$INDIAN_ERA_START;
        // Day number in Gregorian year (starting from 0)
        let yDay = jd - $2af5319728ad75f0$var$$3b62074eb05584b2$export$f297eb839006d339(date.era, date.year, 1, 1);
        let leapMonth;
        if (yDay < $2af5319728ad75f0$var$$82c358003bdda0a8$var$INDIAN_YEAR_START) {
            //  Day is at the end of the preceding Saka year
            indianYear--;
            // Days in leapMonth this year, previous Gregorian year
            leapMonth = $2af5319728ad75f0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year - 1) ? 31 : 30;
            yDay += leapMonth + 155 + 90 + 10;
        } else {
            // Days in leapMonth this year
            leapMonth = $2af5319728ad75f0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? 31 : 30;
            yDay -= $2af5319728ad75f0$var$$82c358003bdda0a8$var$INDIAN_YEAR_START;
        }
        let indianMonth;
        let indianDay;
        if (yDay < leapMonth) {
            indianMonth = 1;
            indianDay = yDay + 1;
        } else {
            let mDay = yDay - leapMonth;
            if (mDay < 155) {
                indianMonth = Math.floor(mDay / 31) + 2;
                indianDay = mDay % 31 + 1;
            } else {
                mDay -= 155;
                indianMonth = Math.floor(mDay / 30) + 7;
                indianDay = mDay % 30 + 1;
            }
        }
        return new $2af5319728ad75f0$export$99faa760c7908e4f(this, indianYear, indianMonth, indianDay);
    }
    toJulianDay(date) {
        let extendedYear = date.year + $2af5319728ad75f0$var$$82c358003bdda0a8$var$INDIAN_ERA_START;
        let [era, year] = $2af5319728ad75f0$var$$3b62074eb05584b2$export$4475b7e617eb123c(extendedYear);
        let leapMonth;
        let jd;
        if ($2af5319728ad75f0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year)) {
            leapMonth = 31;
            jd = $2af5319728ad75f0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 21);
        } else {
            leapMonth = 30;
            jd = $2af5319728ad75f0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 22);
        }
        if (date.month === 1) return jd + date.day - 1;
        jd += leapMonth + Math.min(date.month - 2, 5) * 31;
        if (date.month >= 8) jd += (date.month - 7) * 30;
        jd += date.day - 1;
        return jd;
    }
    getDaysInMonth(date) {
        if (date.month === 1 && $2af5319728ad75f0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year + $2af5319728ad75f0$var$$82c358003bdda0a8$var$INDIAN_ERA_START)) return 31;
        if (date.month >= 2 && date.month <= 6) return 31;
        return 30;
    }
    getYearsInEra() {
        return 9999;
    }
    getEras() {
        return [
            "saka"
        ];
    }
    balanceDate() {}
    constructor(...args){
        super(...args);
        this.identifier = "indian";
    }
}
const $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC = 1948440; // CE 622 July 16 Friday (Julian calendar) / CE 622 July 19 (Gregorian calendar)
const $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC = 1948439; // CE 622 July 15 Thursday (Julian calendar)
const $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START = 1300;
const $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END = 1600;
const $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_START_DAYS = 460322;
function $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, day) {
    return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + epoch - 1;
}
function $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(calendar, epoch, jd) {
    let year = Math.floor((30 * (jd - epoch) + 10646) / 10631);
    let month = Math.min(12, Math.ceil((jd - (29 + $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, 1, 1))) / 29.5) + 1);
    let day = jd - $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, 1) + 1;
    return new $2af5319728ad75f0$export$99faa760c7908e4f(calendar, year, month, day);
}
function $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$isLeapYear(year) {
    return (14 + 11 * year) % 30 < 11;
}
class $2af5319728ad75f0$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        return $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(this, $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC, jd);
    }
    toJulianDay(date) {
        return $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$islamicToJulianDay($2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let length = 29 + date.month % 2;
        if (date.month === 12 && $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$isLeapYear(date.year)) length++;
        return length;
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInYear(date) {
        return $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$isLeapYear(date.year) ? 355 : 354;
    }
    getYearsInEra() {
        return 9999;
    }
    getEras() {
        return [
            "AH"
        ];
    }
    constructor(){
        this.identifier = "islamic-civil";
    }
}
class $2af5319728ad75f0$export$37f0887f2f9d22f7 extends $2af5319728ad75f0$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        return $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(this, $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, jd);
    }
    toJulianDay(date) {
        return $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$islamicToJulianDay($2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, date.year, date.month, date.day);
    }
    constructor(...args){
        super(...args);
        this.identifier = "islamic-tbla";
    }
}
// Generated by scripts/generate-umalqura.js
const $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_DATA = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH;
let $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE;
function $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraYearStart(year) {
    return $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_START_DAYS + $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
function $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, month) {
    let idx = year - $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START;
    let mask = 1 << 11 - (month - 1);
    if (($2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH[idx] & mask) === 0) return 29;
    else return 30;
}
function $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(year, month) {
    let day = $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraYearStart(year);
    for(let i = 1; i < month; i++)day += $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
    return day;
}
function $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraYearLength(year) {
    return $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year + 1 - $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] - $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
class $2af5319728ad75f0$export$5baab4758c231076 extends $2af5319728ad75f0$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        let days = jd - $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC;
        let startDays = $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraYearStart($2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START);
        let endDays = $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraYearStart($2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END);
        if (days < startDays || days > endDays) return super.fromJulianDay(jd);
        else {
            let y = $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START - 1;
            let m = 1;
            let d = 1;
            while(d > 0){
                y++;
                d = days - $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraYearStart(y) + 1;
                let yearLength = $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraYearLength(y);
                if (d === yearLength) {
                    m = 12;
                    break;
                } else if (d < yearLength) {
                    let monthLength = $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                    m = 1;
                    while(d > monthLength){
                        d -= monthLength;
                        m++;
                        monthLength = $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                    }
                    break;
                }
            }
            return new $2af5319728ad75f0$export$99faa760c7908e4f(this, y, m, days - $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(y, m) + 1);
        }
    }
    toJulianDay(date) {
        if (date.year < $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.toJulianDay(date);
        return $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC + $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(date.year, date.month) + (date.day - 1);
    }
    getDaysInMonth(date) {
        if (date.year < $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.getDaysInMonth(date);
        return $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(date.year, date.month);
    }
    getDaysInYear(date) {
        if (date.year < $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.getDaysInYear(date);
        return $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraYearLength(date.year);
    }
    constructor(){
        super();
        this.identifier = "islamic-umalqura";
        if (!$2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH) $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH = new Uint16Array(Uint8Array.from(atob($2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_DATA), (c)=>c.charCodeAt(0)).buffer);
        if (!$2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE) {
            $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE = new Uint32Array($2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END - $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START + 1);
            let yearStart = 0;
            for(let year = $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START; year <= $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END; year++){
                $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] = yearStart;
                for(let i = 1; i <= 12; i++)yearStart += $2af5319728ad75f0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
            }
        }
    }
}
const $2af5319728ad75f0$var$$7c5f6fbf42389787$var$HEBREW_EPOCH = 347997;
// Hebrew date calculations are performed in terms of days, hours, and
// "parts" (or halakim), which are 1/1080 of an hour, or 3 1/3 seconds.
const $2af5319728ad75f0$var$$7c5f6fbf42389787$var$HOUR_PARTS = 1080;
const $2af5319728ad75f0$var$$7c5f6fbf42389787$var$DAY_PARTS = 24 * $2af5319728ad75f0$var$$7c5f6fbf42389787$var$HOUR_PARTS;
// An approximate value for the length of a lunar month.
// It is used to calculate the approximate year and month of a given
// absolute date.
const $2af5319728ad75f0$var$$7c5f6fbf42389787$var$MONTH_DAYS = 29;
const $2af5319728ad75f0$var$$7c5f6fbf42389787$var$MONTH_FRACT = 12 * $2af5319728ad75f0$var$$7c5f6fbf42389787$var$HOUR_PARTS + 793;
const $2af5319728ad75f0$var$$7c5f6fbf42389787$var$MONTH_PARTS = $2af5319728ad75f0$var$$7c5f6fbf42389787$var$MONTH_DAYS * $2af5319728ad75f0$var$$7c5f6fbf42389787$var$DAY_PARTS + $2af5319728ad75f0$var$$7c5f6fbf42389787$var$MONTH_FRACT;
function $2af5319728ad75f0$var$$7c5f6fbf42389787$var$isLeapYear(year) {
    return $2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(year * 7 + 1, 19) < 7;
}
// Test for delay of start of new year and to avoid
// Sunday, Wednesday, and Friday as start of the new year.
function $2af5319728ad75f0$var$$7c5f6fbf42389787$var$hebrewDelay1(year) {
    let months = Math.floor((235 * year - 234) / 19);
    let parts = 12084 + 13753 * months;
    let day = months * 29 + Math.floor(parts / 25920);
    if ($2af5319728ad75f0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(3 * (day + 1), 7) < 3) day += 1;
    return day;
}
// Check for delay in start of new year due to length of adjacent years
function $2af5319728ad75f0$var$$7c5f6fbf42389787$var$hebrewDelay2(year) {
    let last = $2af5319728ad75f0$var$$7c5f6fbf42389787$var$hebrewDelay1(year - 1);
    let present = $2af5319728ad75f0$var$$7c5f6fbf42389787$var$hebrewDelay1(year);
    let next = $2af5319728ad75f0$var$$7c5f6fbf42389787$var$hebrewDelay1(year + 1);
    if (next - present === 356) return 2;
    if (present - last === 382) return 1;
    return 0;
}
function $2af5319728ad75f0$var$$7c5f6fbf42389787$var$startOfYear(year) {
    return $2af5319728ad75f0$var$$7c5f6fbf42389787$var$hebrewDelay1(year) + $2af5319728ad75f0$var$$7c5f6fbf42389787$var$hebrewDelay2(year);
}
function $2af5319728ad75f0$var$$7c5f6fbf42389787$var$getDaysInYear(year) {
    return $2af5319728ad75f0$var$$7c5f6fbf42389787$var$startOfYear(year + 1) - $2af5319728ad75f0$var$$7c5f6fbf42389787$var$startOfYear(year);
}
function $2af5319728ad75f0$var$$7c5f6fbf42389787$var$getYearType(year) {
    let yearLength = $2af5319728ad75f0$var$$7c5f6fbf42389787$var$getDaysInYear(year);
    if (yearLength > 380) yearLength -= 30; // Subtract length of leap month.
    switch(yearLength){
        case 353:
            return 0; // deficient
        case 354:
            return 1; // normal
        case 355:
            return 2; // complete
    }
}
function $2af5319728ad75f0$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month) {
    // Normalize month numbers from 1 - 13, even on non-leap years
    if (month >= 6 && !$2af5319728ad75f0$var$$7c5f6fbf42389787$var$isLeapYear(year)) month++;
    // First of all, dispose of fixed-length 29 day months
    if (month === 4 || month === 7 || month === 9 || month === 11 || month === 13) return 29;
    let yearType = $2af5319728ad75f0$var$$7c5f6fbf42389787$var$getYearType(year);
    // If it's Heshvan, days depend on length of year
    if (month === 2) return yearType === 2 ? 30 : 29;
    // Similarly, Kislev varies with the length of year
    if (month === 3) return yearType === 0 ? 29 : 30;
    // Adar I only exists in leap years
    if (month === 6) return $2af5319728ad75f0$var$$7c5f6fbf42389787$var$isLeapYear(year) ? 30 : 0;
    return 30;
}
class $2af5319728ad75f0$export$ca405048b8fb5af {
    fromJulianDay(jd) {
        let d = jd - $2af5319728ad75f0$var$$7c5f6fbf42389787$var$HEBREW_EPOCH;
        let m = d * $2af5319728ad75f0$var$$7c5f6fbf42389787$var$DAY_PARTS / $2af5319728ad75f0$var$$7c5f6fbf42389787$var$MONTH_PARTS; // Months (approx)
        let year = Math.floor((19 * m + 234) / 235) + 1; // Years (approx)
        let ys = $2af5319728ad75f0$var$$7c5f6fbf42389787$var$startOfYear(year); // 1st day of year
        let dayOfYear = Math.floor(d - ys);
        // Because of the postponement rules, it's possible to guess wrong.  Fix it.
        while(dayOfYear < 1){
            year--;
            ys = $2af5319728ad75f0$var$$7c5f6fbf42389787$var$startOfYear(year);
            dayOfYear = Math.floor(d - ys);
        }
        // Now figure out which month we're in, and the date within that month
        let month = 1;
        let monthStart = 0;
        while(monthStart < dayOfYear){
            monthStart += $2af5319728ad75f0$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month);
            month++;
        }
        month--;
        monthStart -= $2af5319728ad75f0$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month);
        let day = dayOfYear - monthStart;
        return new $2af5319728ad75f0$export$99faa760c7908e4f(this, year, month, day);
    }
    toJulianDay(date) {
        let jd = $2af5319728ad75f0$var$$7c5f6fbf42389787$var$startOfYear(date.year);
        for(let month = 1; month < date.month; month++)jd += $2af5319728ad75f0$var$$7c5f6fbf42389787$var$getDaysInMonth(date.year, month);
        return jd + date.day + $2af5319728ad75f0$var$$7c5f6fbf42389787$var$HEBREW_EPOCH;
    }
    getDaysInMonth(date) {
        return $2af5319728ad75f0$var$$7c5f6fbf42389787$var$getDaysInMonth(date.year, date.month);
    }
    getMonthsInYear(date) {
        return $2af5319728ad75f0$var$$7c5f6fbf42389787$var$isLeapYear(date.year) ? 13 : 12;
    }
    getDaysInYear(date) {
        return $2af5319728ad75f0$var$$7c5f6fbf42389787$var$getDaysInYear(date.year);
    }
    getYearsInEra() {
        return 9999;
    }
    getEras() {
        return [
            "AM"
        ];
    }
    balanceYearMonth(date, previousDate) {
        // Keep date in the same month when switching between leap years and non leap years
        if (previousDate.year !== date.year) {
            if ($2af5319728ad75f0$var$$7c5f6fbf42389787$var$isLeapYear(previousDate.year) && !$2af5319728ad75f0$var$$7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month--;
            else if (!$2af5319728ad75f0$var$$7c5f6fbf42389787$var$isLeapYear(previousDate.year) && $2af5319728ad75f0$var$$7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month++;
        }
    }
    constructor(){
        this.identifier = "hebrew";
    }
}
const $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH = 1723856;
const $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH = 1824665;
// The delta between Amete Alem 1 and Amete Mihret 1
// AA 5501 = AM 1
const $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA = 5500;
function $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, day) {
    return epoch // difference from Julian epoch to 1,1,1
     + 365 * year // number of days from years
     + Math.floor(year / 4) // extra day of leap year
     + 30 * (month - 1 // number of days from months (1 based)
    ) + day - 1 // number of days for present month (1 based)
    ;
}
function $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$julianDayToCE(calendar, epoch, jd) {
    let year = Math.floor(4 * (jd - epoch) / 1461);
    let month = 1 + Math.floor((jd - $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, 1, 1)) / 30);
    let day = jd + 1 - $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, 1);
    return new $2af5319728ad75f0$export$99faa760c7908e4f(calendar, year, month, day);
}
function $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$getLeapDay(year) {
    return Math.floor(year % 4 / 3);
}
function $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$getDaysInMonth(year, month) {
    // The Ethiopian and Coptic calendars have 13 months, 12 of 30 days each and
    // an intercalary month at the end of the year of 5 or 6 days, depending whether
    // the year is a leap year or not. The Leap Year follows the same rules as the
    // Julian Calendar so that the extra month always has six days in the year before
    // a Julian Leap Year.
    if (month % 13 !== 0) return 30;
    else return $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$getLeapDay(year) + 5;
}
class $2af5319728ad75f0$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let date = $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$julianDayToCE(this, $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd);
        if (date.year > 0) date.era = "AM";
        else {
            date.era = "AA";
            date.year += $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        }
        return date;
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === "AA") year -= $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        return $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$ceToJulianDay($2af5319728ad75f0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let year = date.year;
        if (date.era === "AA") year -= $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        return $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$getDaysInMonth(year, date.month);
    }
    getMonthsInYear() {
        return 13;
    }
    getDaysInYear(date) {
        return 365 + $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$getLeapDay(date.year);
    }
    getYearsInEra() {
        return 9999;
    }
    getEras() {
        return [
            "AA",
            "AM"
        ];
    }
    constructor(){
        this.identifier = "ethiopic";
    }
}
class $2af5319728ad75f0$export$d72e0c37005a4914 extends $2af5319728ad75f0$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let date = $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$julianDayToCE(this, $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd);
        date.era = "AA";
        date.year += $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        return date;
    }
    getEras() {
        return [
            "AA"
        ];
    }
    constructor(...args){
        super(...args);
        this.identifier // also known as 'ethiopic-amete-alem' in ICU
         = "ethioaa";
    }
}
class $2af5319728ad75f0$export$fe6243cbe1a4b7c1 extends $2af5319728ad75f0$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let date = $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$julianDayToCE(this, $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH, jd);
        if (date.year <= 0) {
            date.era = "BCE";
            date.year = 1 - date.year;
        } else date.era = "CE";
        return date;
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === "BCE") year = 1 - year;
        return $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$ceToJulianDay($2af5319728ad75f0$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let year = date.year;
        if (date.era === "BCE") year = 1 - year;
        return $2af5319728ad75f0$var$$b956b2d7a6cf451f$var$getDaysInMonth(year, date.month);
    }
    isInverseEra(date) {
        return date.era === "BCE";
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === "BCE" ? "CE" : "BCE";
            date.year = 1 - date.year;
        }
    }
    getEras() {
        return [
            "BCE",
            "CE"
        ];
    }
    constructor(...args){
        super(...args);
        this.identifier = "coptic";
    }
}
function $2af5319728ad75f0$export$dd0bbc9b26defe37(name) {
    switch(name){
        case "buddhist":
            return new $2af5319728ad75f0$export$42d20a78301dee44();
        case "ethiopic":
            return new $2af5319728ad75f0$export$26ba6eab5e20cd7d();
        case "ethioaa":
            return new $2af5319728ad75f0$export$d72e0c37005a4914();
        case "coptic":
            return new $2af5319728ad75f0$export$fe6243cbe1a4b7c1();
        case "hebrew":
            return new $2af5319728ad75f0$export$ca405048b8fb5af();
        case "indian":
            return new $2af5319728ad75f0$export$39f31c639fa15726();
        case "islamic-civil":
            return new $2af5319728ad75f0$export$2066795aadd37bfc();
        case "islamic-tbla":
            return new $2af5319728ad75f0$export$37f0887f2f9d22f7();
        case "islamic-umalqura":
            return new $2af5319728ad75f0$export$5baab4758c231076();
        case "japanese":
            return new $2af5319728ad75f0$export$b746ab2b60cdffbf();
        case "persian":
            return new $2af5319728ad75f0$export$37fccdbfd14c5939();
        case "roc":
            return new $2af5319728ad75f0$export$65e01080afcb0799();
        case "gregory":
        default:
            return new $2af5319728ad75f0$export$80ee6245ec4f29ec();
    }
}
var $2af5319728ad75f0$var$$484f90c8d1b5efb9$exports = {};
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $2af5319728ad75f0$var$$fb18d541ea1ad717$var$formatterCache = new Map();
class $2af5319728ad75f0$export$ad991b66133851cf {
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === "function") return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === "function") return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if ($2af5319728ad75f0$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = $2af5319728ad75f0$var$$fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12";
        }
        return resolvedOptions;
    }
    constructor(locale, options = {}){
        this.formatter = $2af5319728ad75f0$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const $2af5319728ad75f0$var$$fb18d541ea1ad717$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: "h11"
    },
    false: {}
};
function $2af5319728ad75f0$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === "boolean" && $2af5319728ad75f0$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = $2af5319728ad75f0$var$$fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split("-")[0]];
        let defaultHourCycle = options.hour12 ? "h12" : "h23";
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($2af5319728ad75f0$var$$fb18d541ea1ad717$var$formatterCache.has(cacheKey)) return $2af5319728ad75f0$var$$fb18d541ea1ad717$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    $2af5319728ad75f0$var$$fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let $2af5319728ad75f0$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $2af5319728ad75f0$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
    if ($2af5319728ad75f0$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null) $2af5319728ad75f0$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === "24";
    return $2af5319728ad75f0$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
let $2af5319728ad75f0$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $2af5319728ad75f0$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
    if ($2af5319728ad75f0$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null) $2af5319728ad75f0$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat("fr", {
        hour: "numeric",
        hour12: false
    }).resolvedOptions().hourCycle === "h12";
    return $2af5319728ad75f0$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $2af5319728ad75f0$var$$fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
    locale += (locale.includes("-u-") ? "" : "-u") + "-nu-latn";
    let formatter = $2af5319728ad75f0$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === "hour").value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === "hour").value, 10);
    if (min === 0 && max === 23) return "h23";
    if (min === 24 && max === 23) return "h24";
    if (min === 0 && max === 11) return "h11";
    if (min === 12 && max === 11) return "h12";
    throw new Error("Unexpected hour cycle result");
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$formatterCache = new Map();
let $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    // @ts-ignore
    $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch (e) {}
let $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    // @ts-ignore
    $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch (e1) {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            "ja-JP": " \u5EA6",
            "zh-TW": "\u5EA6",
            "sl-SI": " \xb0"
        }
    }
};
class $d937707f3e0c3d96$export$cc77c4ff7e8673c5 {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = "";
        if (!$d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === "unit" && !$d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$supportsUnit) {
            var ref;
            let { unit: unit, unitDisplay: unitDisplay = "short", locale: locale } = this.resolvedOptions();
            let values = (ref = $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || ref === void 0 ? void 0 : ref[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        // @ts-ignore
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRange === "function") return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRangeToParts === "function") return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === "unit") options = {
            ...options,
            style: "unit",
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {}){
        this.numberFormatter = $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem } = options;
    if (numberingSystem && locale.indexOf("-u-nu-") === -1) locale = `${locale}-u-nu-${numberingSystem}`;
    if (options.style === "unit" && !$d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$supportsUnit) {
        var ref;
        let { unit: unit, unitDisplay: unitDisplay = "short" } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((ref = $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || ref === void 0 ? void 0 : ref[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: "decimal"
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $d937707f3e0c3d96$var$$488c6ddbf4ef74c2$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === "auto") return numberFormat.format(num);
    else if (signDisplay === "never") return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === "always") needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === "exceptZero") {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
            if ([
                ...minus
            ].length !== 1) console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
            let positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}
const $d937707f3e0c3d96$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX = new RegExp("^.*\\(.*\\).*$");
const $d937707f3e0c3d96$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS = [
    "latn",
    "arab",
    "hanidec"
];
class $d937707f3e0c3d96$export$cd11ab140839f11d {
    /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ parse(value) {
        return $d937707f3e0c3d96$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).parse(value);
    }
    /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ isValidPartialNumber(value, minValue, maxValue) {
        return $d937707f3e0c3d96$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
    }
    /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ getNumberingSystem(value) {
        return $d937707f3e0c3d96$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.options = options;
    }
}
const $d937707f3e0c3d96$var$$6c7bd7858deea686$var$numberParserCache = new Map();
function $d937707f3e0c3d96$var$$6c7bd7858deea686$var$getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    let defaultParser = $d937707f3e0c3d96$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes("-nu-") && !defaultParser.isValidPartialNumber(value)) {
        for (let numberingSystem of $d937707f3e0c3d96$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS)if (numberingSystem !== defaultParser.options.numberingSystem) {
            let parser = $d937707f3e0c3d96$var$$6c7bd7858deea686$var$getCachedNumberParser(locale + (locale.includes("-u-") ? "-nu-" : "-u-nu-") + numberingSystem, options);
            if (parser.isValidPartialNumber(value)) return parser;
        }
    }
    return defaultParser;
}
function $d937707f3e0c3d96$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options) {
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    let parser = $d937707f3e0c3d96$var$$6c7bd7858deea686$var$numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new $d937707f3e0c3d96$var$$6c7bd7858deea686$var$NumberParserImpl(locale, options);
        $d937707f3e0c3d96$var$$6c7bd7858deea686$var$numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
class $d937707f3e0c3d96$var$$6c7bd7858deea686$var$NumberParserImpl {
    parse(value) {
        // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
        let fullySanitizedValue = this.sanitize(value);
        // Remove group characters, and replace decimal points and numerals with ASCII values.
        fullySanitizedValue = $d937707f3e0c3d96$var$$6c7bd7858deea686$var$replaceAll(fullySanitizedValue, this.symbols.group, "").replace(this.symbols.decimal, ".").replace(this.symbols.minusSign, "-").replace(this.symbols.numeral, this.symbols.index);
        let newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
        if (isNaN(newValue)) return NaN;
        // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
        if (this.options.currencySign === "accounting" && $d937707f3e0c3d96$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
        // when reading the number, if it's a percent, then it should be interpreted as being divided by 100
        if (this.options.style === "percent") {
            newValue /= 100;
            var _maximumFractionDigits;
            // after dividing to get the percent value, javascript may get .0210999999 instead of .0211, so fix the number of fraction digits
            newValue = +newValue.toFixed(((_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _maximumFractionDigits !== void 0 ? _maximumFractionDigits : 0) + 2);
        }
        return newValue;
    }
    sanitize(value) {
        // Remove literals and whitespace, which are allowed anywhere in the string
        value = value.replace(this.symbols.literals, "");
        // Replace the ASCII minus sign with the minus sign used in the current locale
        // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
        value = value.replace("-", this.symbols.minusSign);
        // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
        // instead they use the , (44) character or apparently the (1548) character.
        if (this.options.numberingSystem === "arab") {
            value = value.replace(",", this.symbols.decimal);
            value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
            value = $d937707f3e0c3d96$var$$6c7bd7858deea686$var$replaceAll(value, ".", this.symbols.group);
        }
        // fr-FR group character is char code 8239, but that's not a key on the french keyboard,
        // so allow 'period' as a group char and replace it with a space
        if (this.options.locale === "fr-FR") value = $d937707f3e0c3d96$var$$6c7bd7858deea686$var$replaceAll(value, ".", String.fromCharCode(8239));
        return value;
    }
    isValidPartialNumber(value, minValue = -Infinity, maxValue = Infinity) {
        value = this.sanitize(value);
        // Remove minus or plus sign, which must be at the start of the string.
        if (value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
        else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
        // Numbers cannot start with a group separator
        if (value.startsWith(this.symbols.group)) return false;
        // Remove numerals, groups, and decimals
        value = $d937707f3e0c3d96$var$$6c7bd7858deea686$var$replaceAll(value, this.symbols.group, "").replace(this.symbols.numeral, "").replace(this.symbols.decimal, "");
        // The number is valid if there are no remaining characters
        return value.length === 0;
    }
    constructor(locale, options = {}){
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = $d937707f3e0c3d96$var$$6c7bd7858deea686$var$getSymbols(this.formatter, this.options, options);
    }
}
const $d937707f3e0c3d96$var$$6c7bd7858deea686$var$nonLiteralParts = new Set([
    "decimal",
    "fraction",
    "integer",
    "minusSign",
    "plusSign",
    "group"
]);
function $d937707f3e0c3d96$var$$6c7bd7858deea686$var$getSymbols(formatter, intlOptions, originalOptions) {
    var ref, ref1, ref2, ref3;
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    let allParts = formatter.formatToParts(-10000.111);
    let posAllParts = formatter.formatToParts(10000.111);
    let singularParts = formatter.formatToParts(1);
    var ref4;
    let minusSign = (ref4 = (ref = allParts.find((p)=>p.type === "minusSign")) === null || ref === void 0 ? void 0 : ref.value) !== null && ref4 !== void 0 ? ref4 : "-";
    let plusSign = (ref1 = posAllParts.find((p)=>p.type === "plusSign")) === null || ref1 === void 0 ? void 0 : ref1.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    // @ts-ignore
    if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "exceptZero" || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "always")) plusSign = "+";
    let decimal = (ref2 = allParts.find((p)=>p.type === "decimal")) === null || ref2 === void 0 ? void 0 : ref2.value;
    let group = (ref3 = allParts.find((p)=>p.type === "group")) === null || ref3 === void 0 ? void 0 : ref3.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    let pluralLiterals = allParts.filter((p)=>!$d937707f3e0c3d96$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$d937707f3e0c3d96$var$$6c7bd7858deea686$var$escapeRegex(p.value));
    let singularLiterals = singularParts.filter((p)=>!$d937707f3e0c3d96$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$d937707f3e0c3d96$var$$6c7bd7858deea686$var$escapeRegex(p.value));
    let sortedLiterals = [
        ...new Set([
            ...singularLiterals,
            ...pluralLiterals
        ])
    ].sort((a, b)=>b.length - a.length);
    let literals = sortedLiterals.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${sortedLiterals.join("|")}|[\\p{White_Space}]`, "gu");
    // These are for replacing non-latn characters with the latn equivalent
    let numerals = [
        ...new Intl.NumberFormat(intlOptions.locale, {
            useGrouping: false
        }).format(9876543210)
    ].reverse();
    let indexes = new Map(numerals.map((d, i)=>[
            d,
            i
        ]));
    let numeral = new RegExp(`[${numerals.join("")}]`, "g");
    let index = (d)=>String(indexes.get(d));
    return {
        minusSign: minusSign,
        plusSign: plusSign,
        decimal: decimal,
        group: group,
        literals: literals,
        numeral: numeral,
        index: index
    };
}
function $d937707f3e0c3d96$var$$6c7bd7858deea686$var$replaceAll(str, find, replace) {
    // @ts-ignore
    if (str.replaceAll) return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function $d937707f3e0c3d96$var$$6c7bd7858deea686$var$escapeRegex(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}


function $cc77112e47cb65f2$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $cc77112e47cb65f2$var$$18f2051aff69b9bf$exports = {};
$cc77112e47cb65f2$var$$parcel$export($cc77112e47cb65f2$var$$18f2051aff69b9bf$exports, "I18nProvider", ()=>$cc77112e47cb65f2$export$a54013f0d02a8f82);
$cc77112e47cb65f2$var$$parcel$export($cc77112e47cb65f2$var$$18f2051aff69b9bf$exports, "useLocale", ()=>$cc77112e47cb65f2$export$43bb16f9c6d9e3f7);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $cc77112e47cb65f2$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $cc77112e47cb65f2$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $cc77112e47cb65f2$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) {
    // If the Intl.Locale API is available, use it to get the script for the locale.
    // This is more accurate than guessing by language, since languages can be written in multiple scripts.
    // @ts-ignore
    if (Intl.Locale) {
        // @ts-ignore
        let script = new Intl.Locale(locale).maximize().script;
        return $cc77112e47cb65f2$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = locale.split("-")[0];
    return $cc77112e47cb65f2$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}
function $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
    // @ts-ignore
    let locale = typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: $cc77112e47cb65f2$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    };
}
let $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$currentLocale = $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
let $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$currentLocale = $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
    for (let listener of $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$listeners)listener($cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $ed8cf1f08d8b2081$export$535bd6ca7f90a273)();
    let [defaultLocale, setDefaultLocale] = (0, $acw62.useState)($cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $acw62.useEffect)(()=>{
        if ($cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}
const $cc77112e47cb65f2$var$$18f2051aff69b9bf$var$I18nContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $cc77112e47cb65f2$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let value = locale ? {
        locale: locale,
        direction: $cc77112e47cb65f2$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    } : defaultLocale;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cc77112e47cb65f2$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $cc77112e47cb65f2$export$43bb16f9c6d9e3f7() {
    let defaultLocale = $cc77112e47cb65f2$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let context = (0, $acw62.useContext)($cc77112e47cb65f2$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}
var $cc77112e47cb65f2$var$$321bc95feeb923dd$exports = {};
$cc77112e47cb65f2$var$$parcel$export($cc77112e47cb65f2$var$$321bc95feeb923dd$exports, "useMessageFormatter", ()=>$cc77112e47cb65f2$export$ec23bf898b1eed85);
const $cc77112e47cb65f2$var$$321bc95feeb923dd$var$cache = new WeakMap();
function $cc77112e47cb65f2$var$$321bc95feeb923dd$var$getCachedDictionary(strings) {
    let dictionary = $cc77112e47cb65f2$var$$321bc95feeb923dd$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $ea9b33d428529013$export$64839e615120df17)(strings);
        $cc77112e47cb65f2$var$$321bc95feeb923dd$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $cc77112e47cb65f2$export$ec23bf898b1eed85(strings) {
    let { locale: locale } = $cc77112e47cb65f2$export$43bb16f9c6d9e3f7();
    let dictionary = (0, $acw62.useMemo)(()=>$cc77112e47cb65f2$var$$321bc95feeb923dd$var$getCachedDictionary(strings), [
        strings
    ]);
    let formatter = (0, $acw62.useMemo)(()=>new (0, $ea9b33d428529013$export$526ebc05ff964723)(locale, dictionary), [
        locale,
        dictionary
    ]);
    return (0, $acw62.useCallback)((key, variables)=>formatter.format(key, variables), [
        formatter
    ]);
}
var $cc77112e47cb65f2$var$$896ba0a80a8f4d36$exports = {};
$cc77112e47cb65f2$var$$parcel$export($cc77112e47cb65f2$var$$896ba0a80a8f4d36$exports, "useDateFormatter", ()=>$cc77112e47cb65f2$export$85fd5fdf27bacc79);
function $cc77112e47cb65f2$export$85fd5fdf27bacc79(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    let lastOptions = (0, $acw62.useRef)(null);
    if (options && lastOptions.current && $cc77112e47cb65f2$var$$896ba0a80a8f4d36$var$isEqual(options, lastOptions.current)) options = lastOptions.current;
    lastOptions.current = options;
    let { locale: locale } = $cc77112e47cb65f2$export$43bb16f9c6d9e3f7();
    return (0, $acw62.useMemo)(()=>new (0, $2af5319728ad75f0$export$ad991b66133851cf)(locale, options), [
        locale,
        options
    ]);
}
function $cc77112e47cb65f2$var$$896ba0a80a8f4d36$var$isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}
var $cc77112e47cb65f2$var$$a916eb452884faea$exports = {};
$cc77112e47cb65f2$var$$parcel$export($cc77112e47cb65f2$var$$a916eb452884faea$exports, "useNumberFormatter", ()=>$cc77112e47cb65f2$export$b7a616150fdb9f44);
function $cc77112e47cb65f2$export$b7a616150fdb9f44(options = {}) {
    let { locale: locale } = $cc77112e47cb65f2$export$43bb16f9c6d9e3f7();
    return (0, $acw62.useMemo)(()=>new (0, $d937707f3e0c3d96$export$cc77c4ff7e8673c5)(locale, options), [
        locale,
        options
    ]);
}
var $cc77112e47cb65f2$var$$325a3faab7a68acd$exports = {};
$cc77112e47cb65f2$var$$parcel$export($cc77112e47cb65f2$var$$325a3faab7a68acd$exports, "useCollator", ()=>$cc77112e47cb65f2$export$a16aca283550c30d);
let $cc77112e47cb65f2$var$$325a3faab7a68acd$var$cache = new Map();
function $cc77112e47cb65f2$export$a16aca283550c30d(options) {
    let { locale: locale } = $cc77112e47cb65f2$export$43bb16f9c6d9e3f7();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($cc77112e47cb65f2$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $cc77112e47cb65f2$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $cc77112e47cb65f2$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}
var $cc77112e47cb65f2$var$$bb77f239b46e8c72$exports = {};
$cc77112e47cb65f2$var$$parcel$export($cc77112e47cb65f2$var$$bb77f239b46e8c72$exports, "useFilter", ()=>$cc77112e47cb65f2$export$3274cf84b703fff);
function $cc77112e47cb65f2$export$3274cf84b703fff(options) {
    let collator = $cc77112e47cb65f2$export$a16aca283550c30d({
        usage: "search",
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    return {
        startsWith (string, substring) {
            if (substring.length === 0) return true;
            // Normalize both strings so we can slice safely
            // TODO: take into account the ignorePunctuation option as well...
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            return collator.compare(string.slice(0, substring.length), substring) === 0;
        },
        endsWith (string, substring) {
            if (substring.length === 0) return true;
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            return collator.compare(string.slice(-substring.length), substring) === 0;
        },
        contains (string, substring) {
            if (substring.length === 0) return true;
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            let scan = 0;
            let sliceLen = substring.length;
            for(; scan + sliceLen <= string.length; scan++){
                let slice = string.slice(scan, scan + sliceLen);
                if (collator.compare(substring, slice) === 0) return true;
            }
            return false;
        }
    };
}


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $fcf05e248574eb57$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $da31306d5140b746$export$2e2bcd8739ae039(node) {
    var doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $9d0d2e2a013bac9c$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $da31306d5140b746$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $9f2c378a21ca2430$var$rUpper = /([A-Z])/g;
function $9f2c378a21ca2430$export$2e2bcd8739ae039(string) {
    return string.replace($9f2c378a21ca2430$var$rUpper, "-$1").toLowerCase();
}


var $09bdad49a6503060$var$msPattern = /^ms-/;
function $09bdad49a6503060$export$2e2bcd8739ae039(string) {
    return (0, $9f2c378a21ca2430$export$2e2bcd8739ae039)(string).replace($09bdad49a6503060$var$msPattern, "-ms-");
}


var $c8af0fa0e8553220$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $c8af0fa0e8553220$export$2e2bcd8739ae039(value) {
    return !!(value && $c8af0fa0e8553220$var$supportedTransforms.test(value));
}


function $1d31c226dae4138f$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property)) || (0, $9d0d2e2a013bac9c$export$2e2bcd8739ae039)(node).getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $09bdad49a6503060$export$2e2bcd8739ae039)(key));
        else if ((0, $c8af0fa0e8553220$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $09bdad49a6503060$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $1d31c226dae4138f$export$2e2bcd8739ae039 = $1d31c226dae4138f$var$style;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $967999a1a8cec832$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



function $fc8594b4316b900d$export$2e2bcd8739ae039(element) {
    return "nodeType" in element && element.nodeType === document.DOCUMENT_NODE;
}


function $d3d3fbb30222fd24$export$2e2bcd8739ae039(node) {
    if ("window" in node && node.window === node) return node;
    if ((0, $fc8594b4316b900d$export$2e2bcd8739ae039)(node)) return node.defaultView || false;
    return false;
}


function $6d0df9a75a0b0b32$export$2e2bcd8739ae039(offset) {
    var prop = offset === "pageXOffset" ? "scrollLeft" : "scrollTop";
    function scrollAccessor(node, val) {
        var win = (0, $d3d3fbb30222fd24$export$2e2bcd8739ae039)(node);
        if (val === undefined) return win ? win[offset] : node[prop];
        if (win) win.scrollTo(win[offset], val);
        else node[prop] = val;
    }
    return scrollAccessor;
}


var /**
 * Gets or sets the scroll left position of a given element.
 * 
 * @param node the element
 * @param val the position to set
 */ $9192210c1fe01404$export$2e2bcd8739ae039 = (0, $6d0df9a75a0b0b32$export$2e2bcd8739ae039)("pageXOffset");



var /**
 * Gets or sets the scroll top position of a given element.
 * 
 * @param node the element
 * @param val the position to set
 */ $9e400fc8aadfa818$export$2e2bcd8739ae039 = (0, $6d0df9a75a0b0b32$export$2e2bcd8739ae039)("pageYOffset");


function $1291e088852df2a8$export$2e2bcd8739ae039(node) {
    var doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)(node);
    var box = {
        top: 0,
        left: 0,
        height: 0,
        width: 0
    };
    var docElem = doc && doc.documentElement; // Make sure it's not a disconnected DOM node
    if (!docElem || !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(docElem, node)) return box;
    if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
    box = {
        top: box.top + (0, $9e400fc8aadfa818$export$2e2bcd8739ae039)(docElem) - (docElem.clientTop || 0),
        left: box.left + (0, $9192210c1fe01404$export$2e2bcd8739ae039)(docElem) - (docElem.clientLeft || 0),
        width: box.width,
        height: box.height
    };
    return box;
}


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}






var $15b3c05fb1b671f5$var$isHTMLElement = function isHTMLElement(e) {
    return !!e && "offsetParent" in e;
};
function $15b3c05fb1b671f5$export$2e2bcd8739ae039(node) {
    var doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)(node);
    var parent = node && node.offsetParent;
    while($15b3c05fb1b671f5$var$isHTMLElement(parent) && parent.nodeName !== "HTML" && (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(parent, "position") === "static")parent = parent.offsetParent;
    return parent || doc.documentElement;
}




var $ea64cb59793cf53a$var$nodeName = function nodeName(node) {
    return node.nodeName && node.nodeName.toLowerCase();
};
function $ea64cb59793cf53a$export$2e2bcd8739ae039(node, offsetParent) {
    var parentOffset = {
        top: 0,
        left: 0
    };
    var offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
    // because it is its only offset parent
    if ((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, "position") === "fixed") offset = node.getBoundingClientRect();
    else {
        var parent = offsetParent || (0, $15b3c05fb1b671f5$export$2e2bcd8739ae039)(node);
        offset = (0, $1291e088852df2a8$export$2e2bcd8739ae039)(node);
        if ($ea64cb59793cf53a$var$nodeName(parent) !== "html") parentOffset = (0, $1291e088852df2a8$export$2e2bcd8739ae039)(parent);
        var borderTop = String((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(parent, "borderTopWidth") || 0);
        parentOffset.top += parseInt(borderTop, 10) - (0, $9e400fc8aadfa818$export$2e2bcd8739ae039)(parent) || 0;
        var borderLeft = String((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(parent, "borderLeftWidth") || 0);
        parentOffset.left += parseInt(borderLeft, 10) - (0, $9192210c1fe01404$export$2e2bcd8739ae039)(parent) || 0;
    }
    var marginTop = String((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, "marginTop") || 0);
    var marginLeft = String((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, "marginLeft") || 0); // Subtract parent offsets and node margins
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, offset, {
        top: offset.top - parentOffset.top - (parseInt(marginTop, 10) || 0),
        left: offset.left - parentOffset.left - (parseInt(marginLeft, 10) || 0)
    });
}







var $acw62 = parcelRequire("acw62");
function $895d146aa86f8a19$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $895d146aa86f8a19$var$$3b117e43dc0ca95d$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$3b117e43dc0ca95d$exports, "Pressable", ()=>$895d146aa86f8a19$export$27c701ed9e449e99);
var $895d146aa86f8a19$var$$f6c31cce2adf654f$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$f6c31cce2adf654f$exports, "usePress", ()=>$895d146aa86f8a19$export$45712eceda6fad21);
// Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $895d146aa86f8a19$var$$14c0b72509d70225$var$state = "default";
let $895d146aa86f8a19$var$$14c0b72509d70225$var$savedUserSelect = "";
let $895d146aa86f8a19$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $895d146aa86f8a19$var$$14c0b72509d70225$export$16a4697467175487(target) {
    if ((0, $4d60a29ecf011a9e$export$fedb369cb70207f1)()) {
        if ($895d146aa86f8a19$var$$14c0b72509d70225$var$state === "default") {
            $895d146aa86f8a19$var$$14c0b72509d70225$var$savedUserSelect = document.documentElement.style.webkitUserSelect;
            document.documentElement.style.webkitUserSelect = "none";
        }
        $895d146aa86f8a19$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $895d146aa86f8a19$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $895d146aa86f8a19$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
    if ((0, $4d60a29ecf011a9e$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($895d146aa86f8a19$var$$14c0b72509d70225$var$state !== "disabled") return;
        $895d146aa86f8a19$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            // Wait for any CSS transitions to complete so we don't recompute style
            // for the whole page in the middle of the animation and cause jank.
            (0, $4d60a29ecf011a9e$export$24490316f764c430)(()=>{
                // Avoid race conditions
                if ($895d146aa86f8a19$var$$14c0b72509d70225$var$state === "restoring") {
                    if (document.documentElement.style.webkitUserSelect === "none") document.documentElement.style.webkitUserSelect = $895d146aa86f8a19$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $895d146aa86f8a19$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $895d146aa86f8a19$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else // Ignore state since it doesn't apply for non iOS
    if (target && $895d146aa86f8a19$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
        let targetOldUserSelect = $895d146aa86f8a19$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
        if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
        if (target.getAttribute("style") === "") target.removeAttribute("style");
        $895d146aa86f8a19$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
    }
}
function $895d146aa86f8a19$var$$8a9cb279dc87e130$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    return event.detail === 0 && !event.pointerType;
}
class $895d146aa86f8a19$var$$8a9cb279dc87e130$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $895d146aa86f8a19$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $acw62.useRef)({
        isFocused: false,
        onBlur: onBlur,
        observer: null
    });
    stateRef.current.onBlur = onBlur;
    // Clean up MutationObserver on unmount. See below.
    // eslint-disable-next-line arrow-body-style
    (0, $4d60a29ecf011a9e$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    // This function is called during a React onFocus event.
    return (0, $acw62.useCallback)((e1)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e1.target instanceof HTMLButtonElement || e1.target instanceof HTMLInputElement || e1.target instanceof HTMLTextAreaElement || e1.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e1.target;
            let onBlurHandler = (e)=>{
                var _current, ref;
                stateRef.current.isFocused = false;
                if (target.disabled) (ref = (_current = stateRef.current).onBlur) === null || ref === void 0 || ref.call(_current, new $895d146aa86f8a19$var$$8a9cb279dc87e130$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    stateRef.current.observer.disconnect();
                    target.dispatchEvent(new FocusEvent("blur"));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, []);
}
const $895d146aa86f8a19$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
$895d146aa86f8a19$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $acw62.useContext)($895d146aa86f8a19$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    (0, $4d60a29ecf011a9e$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
function $895d146aa86f8a19$export$45712eceda6fad21(props) {
    let { onPress: onPress1, onPressChange: onPressChange1, onPressStart: onPressStart1, onPressEnd: onPressEnd1, onPressUp: onPressUp1, isDisabled: isDisabled1, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $895d146aa86f8a19$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let propsRef = (0, $acw62.useRef)(null);
    propsRef.current = {
        onPress: onPress1,
        onPressChange: onPressChange1,
        onPressStart: onPressStart1,
        onPressEnd: onPressEnd1,
        onPressUp: onPressUp1,
        isDisabled: isDisabled1,
        shouldCancelOnPointerExit: shouldCancelOnPointerExit
    };
    let [isPressed, setPressed] = (0, $acw62.useState)(false);
    let ref = (0, $acw62.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $4d60a29ecf011a9e$export$4eaf04e54aa8eed6)();
    let pressProps1 = (0, $acw62.useMemo)(()=>{
        let state = ref.current;
        let triggerPressStart = (originalEvent, pointerType)=>{
            let { onPressStart: onPressStart, onPressChange: onPressChange, isDisabled: isDisabled } = propsRef.current;
            if (isDisabled || state.didFirePressStart) return;
            if (onPressStart) onPressStart({
                type: "pressstart",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
            if (onPressChange) onPressChange(true);
            state.didFirePressStart = true;
            setPressed(true);
        };
        let triggerPressEnd = (originalEvent, pointerType, wasPressed = true)=>{
            let { onPressEnd: onPressEnd, onPressChange: onPressChange, onPress: onPress, isDisabled: isDisabled } = propsRef.current;
            if (!state.didFirePressStart) return;
            state.ignoreClickAfterPress = true;
            state.didFirePressStart = false;
            if (onPressEnd) onPressEnd({
                type: "pressend",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
            if (onPressChange) onPressChange(false);
            setPressed(false);
            if (onPress && wasPressed && !isDisabled) onPress({
                type: "press",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let triggerPressUp = (originalEvent, pointerType)=>{
            let { onPressUp: onPressUp, isDisabled: isDisabled } = propsRef.current;
            if (isDisabled) return;
            if (onPressUp) onPressUp({
                type: "pressup",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let cancel = (e)=>{
            if (state.isPressed) {
                if (state.isOverTarget) triggerPressEnd($895d146aa86f8a19$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isPressed = false;
                state.isOverTarget = false;
                state.activePointerId = null;
                state.pointerType = null;
                removeAllGlobalListeners();
                if (!allowTextSelectionOnPress) $895d146aa86f8a19$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
            }
        };
        let pressProps = {
            onKeyDown (e) {
                if ($895d146aa86f8a19$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent) && e.currentTarget.contains(e.target)) {
                    if ($895d146aa86f8a19$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target)) e.preventDefault();
                    e.stopPropagation();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred.
                        addGlobalListener(document, "keyup", onKeyUp, false);
                    }
                }
            },
            onKeyUp (e) {
                if ($895d146aa86f8a19$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent) && !e.repeat && e.currentTarget.contains(e.target)) triggerPressUp($895d146aa86f8a19$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0) {
                    e.stopPropagation();
                    if (isDisabled1) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && (state.pointerType === "virtual" || $895d146aa86f8a19$var$$8a9cb279dc87e130$export$60278871457622de(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled1 && !preventFocusOnPress) (0, $4d60a29ecf011a9e$export$de79e2c695e052f3)(e.currentTarget);
                        triggerPressStart(e, "virtual");
                        triggerPressUp(e, "virtual");
                        triggerPressEnd(e, "virtual");
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                }
            }
        };
        let onKeyUp = (e)=>{
            if (state.isPressed && $895d146aa86f8a19$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e)) {
                if ($895d146aa86f8a19$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target)) e.preventDefault();
                e.stopPropagation();
                state.isPressed = false;
                let target = e.target;
                triggerPressEnd($895d146aa86f8a19$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If the target is a link, trigger the click method to open the URL,
                // but defer triggering pressEnd until onClick event handler.
                if (state.target.contains(target) && $895d146aa86f8a19$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) || state.target.getAttribute("role") === "link") state.target.click();
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ($895d146aa86f8a19$var$$f6c31cce2adf654f$var$isVirtualPointerEvent(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($895d146aa86f8a19$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                e.stopPropagation();
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled1 && !preventFocusOnPress) (0, $4d60a29ecf011a9e$export$de79e2c695e052f3)(e.currentTarget);
                    if (!allowTextSelectionOnPress) $895d146aa86f8a19$var$$14c0b72509d70225$export$16a4697467175487(state.target);
                    triggerPressStart(e, state.pointerType);
                    addGlobalListener(document, "pointermove", onPointerMove, false);
                    addGlobalListener(document, "pointerup", onPointerUp, false);
                    addGlobalListener(document, "pointercancel", onPointerCancel, false);
                }
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($895d146aa86f8a19$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $895d146aa86f8a19$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if ($895d146aa86f8a19$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        triggerPressStart($895d146aa86f8a19$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    triggerPressEnd($895d146aa86f8a19$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0) {
                    if ($895d146aa86f8a19$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($895d146aa86f8a19$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget) triggerPressEnd($895d146aa86f8a19$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) $895d146aa86f8a19$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($895d146aa86f8a19$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                e.stopPropagation();
                if (state.ignoreEmulatedMouseEvents) return;
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = $895d146aa86f8a19$var$$8a9cb279dc87e130$export$60278871457622de(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled1 && !preventFocusOnPress) (0, $4d60a29ecf011a9e$export$de79e2c695e052f3)(e.currentTarget);
                triggerPressStart(e, state.pointerType);
                addGlobalListener(document, "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = true;
                    triggerPressStart(e, state.pointerType);
                }
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = false;
                    triggerPressEnd(e, state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType);
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if ($895d146aa86f8a19$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($895d146aa86f8a19$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.isOverTarget) triggerPressEnd($895d146aa86f8a19$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                let touch = $895d146aa86f8a19$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled1 && !preventFocusOnPress) (0, $4d60a29ecf011a9e$export$de79e2c695e052f3)(e.currentTarget);
                if (!allowTextSelectionOnPress) $895d146aa86f8a19$var$$14c0b72509d70225$export$16a4697467175487(state.target);
                triggerPressStart(e, state.pointerType);
                addGlobalListener(window, "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (!state.isPressed) return;
                let touch = $895d146aa86f8a19$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                if (touch && $895d146aa86f8a19$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    triggerPressEnd(e, state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (!state.isPressed) return;
                let touch = $895d146aa86f8a19$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                if (touch && $895d146aa86f8a19$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    triggerPressUp(e, state.pointerType);
                    triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget) triggerPressEnd(e, state.pointerType, false);
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (!allowTextSelectionOnPress) $895d146aa86f8a19$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled1,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress
    ]);
    // Remove user-select: none in case component unmounts immediately after pressStart
    // eslint-disable-next-line arrow-body-style
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (!allowTextSelectionOnPress) $895d146aa86f8a19$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(ref.current.target);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(domProps, pressProps1)
    };
}
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event) {
    const { key: key, code: code, target: target } = event;
    const element = target;
    const { tagName: tagName, isContentEditable: isContentEditable } = element;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && tagName !== "INPUT" && tagName !== "TEXTAREA" && isContentEditable !== true && (!$895d146aa86f8a19$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element) || role === "button" && key !== "Enter") && // An element with role='link' should only trigger with Enter key
    !(role === "link" && key !== "Enter");
}
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = point.width / 2 || point.radiusX || 0;
    let offsetY = point.height / 2 || point.radiusY || 0;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $895d146aa86f8a19$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $895d146aa86f8a19$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !target.draggable;
}
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target) {
    return !((target.tagName === "INPUT" || target.tagName === "BUTTON") && target.type === "submit");
}
function $895d146aa86f8a19$var$$f6c31cce2adf654f$var$isVirtualPointerEvent(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}
const $895d146aa86f8a19$export$27c701ed9e449e99 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: children, ...props }, ref)=>{
    let newRef = (0, $acw62.useRef)();
    ref = ref !== null && ref !== void 0 ? ref : newRef;
    let { pressProps: pressProps } = $895d146aa86f8a19$export$45712eceda6fad21({
        ...props,
        ref: ref
    });
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
        ref: ref,
        ...(0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(child.props, pressProps)
    });
});
var $895d146aa86f8a19$var$$f1ab8c75478c6f73$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$f1ab8c75478c6f73$exports, "PressResponder", ()=>$895d146aa86f8a19$export$3351871ee4b288b8);
const $895d146aa86f8a19$export$3351871ee4b288b8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $acw62.useRef)(false);
    let prevContext = (0, $acw62.useContext)($895d146aa86f8a19$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    let context = (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(prevContext || {}, {
        ...props,
        ref: ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref),
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $4d60a29ecf011a9e$export$4debdb1a3f0fa79e)(prevContext, ref);
    (0, $acw62.useEffect)(()=>{
        if (!isRegistered.current) console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($895d146aa86f8a19$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
});
var $895d146aa86f8a19$var$$a1ea59d68270f0dd$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$a1ea59d68270f0dd$exports, "useFocus", ()=>$895d146aa86f8a19$export$f8168d8dd8fd66e6);
function $895d146aa86f8a19$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $acw62.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = $895d146aa86f8a19$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    const onFocus = (0, $acw62.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : null
        }
    };
}
var $895d146aa86f8a19$var$$507fabe10e71c6fb$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$507fabe10e71c6fb$exports, "isFocusVisible", ()=>$895d146aa86f8a19$export$b9b3dfddab17db27);
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$507fabe10e71c6fb$exports, "getInteractionModality", ()=>$895d146aa86f8a19$export$630ff653c5ada6a9);
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$507fabe10e71c6fb$exports, "setInteractionModality", ()=>$895d146aa86f8a19$export$8397ddfc504fdb9a);
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$507fabe10e71c6fb$exports, "useInteractionModality", ()=>$895d146aa86f8a19$export$98e20ec92f614cfe);
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$507fabe10e71c6fb$exports, "useFocusVisible", ()=>$895d146aa86f8a19$export$ffd9e5021c1fb2d6);
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$507fabe10e71c6fb$exports, "useFocusVisibleListener", ()=>$895d146aa86f8a19$export$ec71b4b83ac08ec3);
let $895d146aa86f8a19$var$$507fabe10e71c6fb$var$currentModality = null;
let $895d146aa86f8a19$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasSetupGlobalListeners = false;
let $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $895d146aa86f8a19$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $895d146aa86f8a19$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $895d146aa86f8a19$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $895d146aa86f8a19$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $4d60a29ecf011a9e$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($895d146aa86f8a19$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $895d146aa86f8a19$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $895d146aa86f8a19$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $895d146aa86f8a19$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $895d146aa86f8a19$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ($895d146aa86f8a19$var$$8a9cb279dc87e130$export$60278871457622de(e)) {
        $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $895d146aa86f8a19$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $895d146aa86f8a19$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $895d146aa86f8a19$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $895d146aa86f8a19$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents() {
    if (typeof window === "undefined" || $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasSetupGlobalListeners) return;
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function() {
        $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    document.addEventListener("keydown", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener("keyup", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener("click", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    window.addEventListener("focus", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    window.addEventListener("blur", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        document.addEventListener("pointerdown", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("pointermove", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("pointerup", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        document.addEventListener("mousedown", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("mousemove", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("mouseup", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $895d146aa86f8a19$var$$507fabe10e71c6fb$var$hasSetupGlobalListeners = true;
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $895d146aa86f8a19$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    else document.addEventListener("DOMContentLoaded", $895d146aa86f8a19$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents);
}
function $895d146aa86f8a19$export$b9b3dfddab17db27() {
    return $895d146aa86f8a19$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $895d146aa86f8a19$export$630ff653c5ada6a9() {
    return $895d146aa86f8a19$var$$507fabe10e71c6fb$var$currentModality;
}
function $895d146aa86f8a19$export$8397ddfc504fdb9a(modality) {
    $895d146aa86f8a19$var$$507fabe10e71c6fb$var$currentModality = modality;
    $895d146aa86f8a19$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $895d146aa86f8a19$export$98e20ec92f614cfe() {
    $895d146aa86f8a19$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $acw62.useState)($895d146aa86f8a19$var$$507fabe10e71c6fb$var$currentModality);
    (0, $acw62.useEffect)(()=>{
        let handler = ()=>{
            setModality($895d146aa86f8a19$var$$507fabe10e71c6fb$var$currentModality);
        };
        $895d146aa86f8a19$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $895d146aa86f8a19$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return modality;
}
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $895d146aa86f8a19$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    return !(isTextInput && modality === "keyboard" && e instanceof KeyboardEvent && !$895d146aa86f8a19$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $895d146aa86f8a19$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(autoFocus || $895d146aa86f8a19$export$b9b3dfddab17db27());
    $895d146aa86f8a19$export$ec71b4b83ac08ec3(($507fabe10e71c6fb$export$b9b3dfddab17db27)=>{
        setFocusVisible($507fabe10e71c6fb$export$b9b3dfddab17db27);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $895d146aa86f8a19$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $895d146aa86f8a19$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $acw62.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$895d146aa86f8a19$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(opts === null || opts === void 0 ? void 0 : opts.isTextInput, modality, e)) return;
            fn($895d146aa86f8a19$export$b9b3dfddab17db27());
        };
        $895d146aa86f8a19$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $895d146aa86f8a19$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, deps);
}
var $895d146aa86f8a19$var$$9ab94262bd0047c7$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$9ab94262bd0047c7$exports, "useFocusWithin", ()=>$895d146aa86f8a19$export$420e68273165f4ec);
function $895d146aa86f8a19$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $acw62.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $acw62.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = $895d146aa86f8a19$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    let onFocus = (0, $acw62.useCallback)((e)=>{
        if (!state.current.isFocusWithin) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            onFocus: null,
            onBlur: null
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}
var $895d146aa86f8a19$var$$6179b936705e76d3$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$6179b936705e76d3$exports, "useHover", ()=>$895d146aa86f8a19$export$ae780daf29e6d456);
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $895d146aa86f8a19$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $895d146aa86f8a19$var$$6179b936705e76d3$var$hoverCount = 0;
function $895d146aa86f8a19$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $895d146aa86f8a19$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $895d146aa86f8a19$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $895d146aa86f8a19$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $895d146aa86f8a19$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $895d146aa86f8a19$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $895d146aa86f8a19$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $895d146aa86f8a19$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $895d146aa86f8a19$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $895d146aa86f8a19$var$$6179b936705e76d3$var$hoverCount--;
        if ($895d146aa86f8a19$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $895d146aa86f8a19$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $895d146aa86f8a19$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $895d146aa86f8a19$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $acw62.useState)(false);
    let state = (0, $acw62.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $acw62.useEffect)($895d146aa86f8a19$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps1, triggerHoverEnd: triggerHoverEnd1 } = (0, $acw62.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($895d146aa86f8a19$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$895d146aa86f8a19$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $acw62.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd1({
            currentTarget: state.target
        }, state.pointerType);
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps1,
        isHovered: isHovered
    };
}
var $895d146aa86f8a19$var$$e0b6e0b68ec7f50f$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$e0b6e0b68ec7f50f$exports, "useInteractOutside", ()=>$895d146aa86f8a19$export$872b660ac5a1ff98);
function $895d146aa86f8a19$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $acw62.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false,
        onInteractOutside: onInteractOutside,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let state = stateRef.current;
    state.onInteractOutside = onInteractOutside;
    state.onInteractOutsideStart = onInteractOutsideStart;
    (0, $acw62.useEffect)(()=>{
        if (isDisabled) return;
        let onPointerDown = (e)=>{
            if ($895d146aa86f8a19$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref) && state.onInteractOutside) {
                if (state.onInteractOutsideStart) state.onInteractOutsideStart(e);
                state.isPointerDown = true;
            }
        };
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && state.onInteractOutside && $895d146aa86f8a19$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            // changing these to capture phase fixed combobox
            document.addEventListener("pointerdown", onPointerDown, true);
            document.addEventListener("pointerup", onPointerUp, true);
            return ()=>{
                document.removeEventListener("pointerdown", onPointerDown, true);
                document.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && state.onInteractOutside && $895d146aa86f8a19$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.onInteractOutside && state.isPointerDown && $895d146aa86f8a19$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            document.addEventListener("mousedown", onPointerDown, true);
            document.addEventListener("mouseup", onMouseUp, true);
            document.addEventListener("touchstart", onPointerDown, true);
            document.addEventListener("touchend", onTouchEnd, true);
            return ()=>{
                document.removeEventListener("mousedown", onPointerDown, true);
                document.removeEventListener("mouseup", onMouseUp, true);
                document.removeEventListener("touchstart", onPointerDown, true);
                document.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        state,
        isDisabled
    ]);
}
function $895d146aa86f8a19$var$$e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    // if the event target is no longer in the document
    if (event.target) {
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}
var $895d146aa86f8a19$var$$46d819fcbaf35654$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$46d819fcbaf35654$exports, "useKeyboard", ()=>$895d146aa86f8a19$export$8f71654801c2f7cd);
function $895d146aa86f8a19$var$$93925083ecbb358c$export$48d1ea6320830260(handler) {
    if (!handler) return;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}
function $895d146aa86f8a19$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: $895d146aa86f8a19$var$$93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
            onKeyUp: $895d146aa86f8a19$var$$93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
        }
    };
}
var $895d146aa86f8a19$var$$e8a7022cf87cba2a$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$e8a7022cf87cba2a$exports, "useMove", ()=>$895d146aa86f8a19$export$36da96379f79f245);
function $895d146aa86f8a19$export$36da96379f79f245(props) {
    let { onMoveStart: onMoveStart, onMove: onMove, onMoveEnd: onMoveEnd } = props;
    let state = (0, $acw62.useRef)({
        didMove: false,
        lastPosition: null,
        id: null
    });
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $4d60a29ecf011a9e$export$4eaf04e54aa8eed6)();
    let moveProps1 = (0, $acw62.useMemo)(()=>{
        let moveProps = {};
        let start = ()=>{
            $895d146aa86f8a19$var$$14c0b72509d70225$export$16a4697467175487();
            state.current.didMove = false;
        };
        let move = (originalEvent, pointerType, deltaX, deltaY)=>{
            if (deltaX === 0 && deltaY === 0) return;
            if (!state.current.didMove) {
                state.current.didMove = true;
                onMoveStart === null || onMoveStart === void 0 || onMoveStart({
                    type: "movestart",
                    pointerType: pointerType,
                    shiftKey: originalEvent.shiftKey,
                    metaKey: originalEvent.metaKey,
                    ctrlKey: originalEvent.ctrlKey,
                    altKey: originalEvent.altKey
                });
            }
            onMove({
                type: "move",
                pointerType: pointerType,
                deltaX: deltaX,
                deltaY: deltaY,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let end = (originalEvent, pointerType)=>{
            $895d146aa86f8a19$var$$14c0b72509d70225$export$b0d6fa1ab32e3295();
            if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 || onMoveEnd({
                type: "moveend",
                pointerType: pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        if (typeof PointerEvent === "undefined") {
            let onMouseMove = (e)=>{
                if (e.button === 0) {
                    move(e, "mouse", e.pageX - state.current.lastPosition.pageX, e.pageY - state.current.lastPosition.pageY);
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onMouseUp = (e)=>{
                if (e.button === 0) {
                    end(e, "mouse");
                    removeGlobalListener(window, "mousemove", onMouseMove, false);
                    removeGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            moveProps.onMouseDown = (e)=>{
                if (e.button === 0) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    addGlobalListener(window, "mousemove", onMouseMove, false);
                    addGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            let onTouchMove = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    let { pageX: pageX, pageY: pageY } = e.changedTouches[touch];
                    move(e, "touch", pageX - state.current.lastPosition.pageX, pageY - state.current.lastPosition.pageY);
                    state.current.lastPosition = {
                        pageX: pageX,
                        pageY: pageY
                    };
                }
            };
            let onTouchEnd = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    end(e, "touch");
                    state.current.id = null;
                    removeGlobalListener(window, "touchmove", onTouchMove);
                    removeGlobalListener(window, "touchend", onTouchEnd);
                    removeGlobalListener(window, "touchcancel", onTouchEnd);
                }
            };
            moveProps.onTouchStart = (e)=>{
                if (e.changedTouches.length === 0 || state.current.id != null) return;
                let { pageX: pageX, pageY: pageY, identifier: identifier } = e.changedTouches[0];
                start();
                e.stopPropagation();
                e.preventDefault();
                state.current.lastPosition = {
                    pageX: pageX,
                    pageY: pageY
                };
                state.current.id = identifier;
                addGlobalListener(window, "touchmove", onTouchMove, false);
                addGlobalListener(window, "touchend", onTouchEnd, false);
                addGlobalListener(window, "touchcancel", onTouchEnd, false);
            };
        } else {
            let onPointerMove = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || "mouse";
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    move(e, pointerType, e.pageX - state.current.lastPosition.pageX, e.pageY - state.current.lastPosition.pageY);
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || "mouse";
                    end(e, pointerType);
                    state.current.id = null;
                    removeGlobalListener(window, "pointermove", onPointerMove, false);
                    removeGlobalListener(window, "pointerup", onPointerUp, false);
                    removeGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
            moveProps.onPointerDown = (e)=>{
                if (e.button === 0 && state.current.id == null) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    state.current.id = e.pointerId;
                    addGlobalListener(window, "pointermove", onPointerMove, false);
                    addGlobalListener(window, "pointerup", onPointerUp, false);
                    addGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
        }
        let triggerKeyboardMove = (e, deltaX, deltaY)=>{
            start();
            move(e, "keyboard", deltaX, deltaY);
            end(e, "keyboard");
        };
        moveProps.onKeyDown = (e)=>{
            switch(e.key){
                case "Left":
                case "ArrowLeft":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case "Right":
                case "ArrowRight":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case "Up":
                case "ArrowUp":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case "Down":
                case "ArrowDown":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        state,
        onMoveStart,
        onMove,
        onMoveEnd,
        addGlobalListener,
        removeGlobalListener
    ]);
    return {
        moveProps: moveProps1
    };
}
var $895d146aa86f8a19$var$$7d0a636d7a4dcefd$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$7d0a636d7a4dcefd$exports, "useScrollWheel", ()=>$895d146aa86f8a19$export$2123ff2b87c81ca);
function $895d146aa86f8a19$export$2123ff2b87c81ca(props, ref) {
    let { onScroll: onScroll, isDisabled: isDisabled } = props;
    let onScrollHandler = (0, $acw62.useCallback)((e)=>{
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    (0, $4d60a29ecf011a9e$export$90fc3a17d93f704c)(ref, "wheel", isDisabled ? null : onScrollHandler);
}
var $895d146aa86f8a19$var$$8a26561d2877236e$exports = {};
$895d146aa86f8a19$var$$parcel$export($895d146aa86f8a19$var$$8a26561d2877236e$exports, "useLongPress", ()=>$895d146aa86f8a19$export$c24ed0104d07eab9);
const $895d146aa86f8a19$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $895d146aa86f8a19$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $895d146aa86f8a19$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $acw62.useRef)(null);
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $4d60a29ecf011a9e$export$4eaf04e54aa8eed6)();
    let { pressProps: pressProps } = $895d146aa86f8a19$export$45712eceda6fad21({
        isDisabled: isDisabled,
        onPressStart (e1) {
            if (e1.pointerType === "mouse" || e1.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e1,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e1.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e1,
                        type: "longpress"
                    });
                    timeRef.current = null;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e1.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e1.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e1.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $4d60a29ecf011a9e$export$f8aeda7b10753fa1)(onLongPress && !isDisabled ? accessibilityDescription : null);
    return {
        longPressProps: (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(pressProps, descriptionProps)
    };
}


var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));




var $acw62 = parcelRequire("acw62");

function $6410015022a21732$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $6410015022a21732$var$$5c3e21d68f1c4674$exports = {};
$6410015022a21732$var$$parcel$export($6410015022a21732$var$$5c3e21d68f1c4674$exports, "useVisuallyHidden", ()=>$6410015022a21732$export$a966af930f325cab);
$6410015022a21732$var$$parcel$export($6410015022a21732$var$$5c3e21d68f1c4674$exports, "VisuallyHidden", ()=>$6410015022a21732$export$439d29a4e110a164);
const $6410015022a21732$var$$5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    margin: "0 -1px -1px 0",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: 1,
    whiteSpace: "nowrap"
};
function $6410015022a21732$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let { focusProps: focusProps } = (0, $895d146aa86f8a19$export$f8168d8dd8fd66e6)({
        isDisabled: !isFocusable,
        onFocusChange: setFocused
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $acw62.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$6410015022a21732$var$$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $6410015022a21732$var$$5c3e21d68f1c4674$var$styles;
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusProps,
            style: combinedStyles
        }
    };
}
function $6410015022a21732$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = "div", isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $6410015022a21732$export$a966af930f325cab(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(otherProps, visuallyHiddenProps), children);
}


function $e0fe69584fec2898$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $e0fe69584fec2898$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $e0fe69584fec2898$var$$2a41e45df1593e64$exports = {};
$e0fe69584fec2898$var$$parcel$export($e0fe69584fec2898$var$$2a41e45df1593e64$exports, "useOverlayPosition", ()=>$e0fe69584fec2898$export$d39e1813b3bdd0e1);
const $e0fe69584fec2898$var$$edcf132a9284368a$var$AXIS = {
    top: "top",
    bottom: "top",
    left: "left",
    right: "left"
};
const $e0fe69584fec2898$var$$edcf132a9284368a$var$FLIPPED_DIRECTION = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
const $e0fe69584fec2898$var$$edcf132a9284368a$var$CROSS_AXIS = {
    top: "left",
    left: "top"
};
const $e0fe69584fec2898$var$$edcf132a9284368a$var$AXIS_SIZE = {
    top: "height",
    left: "width"
};
const $e0fe69584fec2898$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
// @ts-ignore
let $e0fe69584fec2898$var$$edcf132a9284368a$var$visualViewport = typeof window !== "undefined" && window.visualViewport;
function $e0fe69584fec2898$var$$edcf132a9284368a$var$getContainerDimensions(containerNode) {
    let width = 0, height = 0, top = 0, left = 0;
    let scroll = {};
    if (containerNode.tagName === "BODY") {
        var ref;
        width = (ref = $e0fe69584fec2898$var$$edcf132a9284368a$var$visualViewport === null || $e0fe69584fec2898$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $e0fe69584fec2898$var$$edcf132a9284368a$var$visualViewport.width) !== null && ref !== void 0 ? ref : document.documentElement.clientWidth;
        var ref1;
        height = (ref1 = $e0fe69584fec2898$var$$edcf132a9284368a$var$visualViewport === null || $e0fe69584fec2898$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $e0fe69584fec2898$var$$edcf132a9284368a$var$visualViewport.height) !== null && ref1 !== void 0 ? ref1 : document.documentElement.clientHeight;
        scroll.top = (0, $9e400fc8aadfa818$export$2e2bcd8739ae039)((0, $fcf05e248574eb57$export$2e2bcd8739ae039)(containerNode).documentElement) || (0, $9e400fc8aadfa818$export$2e2bcd8739ae039)(containerNode);
        scroll.left = (0, $9192210c1fe01404$export$2e2bcd8739ae039)((0, $fcf05e248574eb57$export$2e2bcd8739ae039)(containerNode).documentElement) || (0, $9192210c1fe01404$export$2e2bcd8739ae039)(containerNode);
    } else {
        ({ width: width, height: height, top: top, left: left } = (0, $1291e088852df2a8$export$2e2bcd8739ae039)(containerNode));
        scroll.top = (0, $9e400fc8aadfa818$export$2e2bcd8739ae039)(containerNode);
        scroll.left = (0, $9192210c1fe01404$export$2e2bcd8739ae039)(containerNode);
    }
    return {
        width: width,
        height: height,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $e0fe69584fec2898$var$$edcf132a9284368a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
function $e0fe69584fec2898$var$$edcf132a9284368a$var$getDelta(axis, offset, size, containerDimensions, padding) {
    let containerScroll = containerDimensions.scroll[axis];
    let containerHeight = containerDimensions[$e0fe69584fec2898$var$$edcf132a9284368a$var$AXIS_SIZE[axis]];
    let startEdgeOffset = offset - padding - containerScroll;
    let endEdgeOffset = offset + padding - containerScroll + size;
    if (startEdgeOffset < 0) return -startEdgeOffset;
    else if (endEdgeOffset > containerHeight) return Math.max(containerHeight - endEdgeOffset, -startEdgeOffset);
    else return 0;
}
function $e0fe69584fec2898$var$$edcf132a9284368a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $e0fe69584fec2898$var$$edcf132a9284368a$var$parsePlacement(input) {
    if ($e0fe69584fec2898$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $e0fe69584fec2898$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(" ");
    let axis = $e0fe69584fec2898$var$$edcf132a9284368a$var$AXIS[placement] || "right";
    let crossAxis = $e0fe69584fec2898$var$$edcf132a9284368a$var$CROSS_AXIS[axis];
    if (!$e0fe69584fec2898$var$$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = "center";
    let size = $e0fe69584fec2898$var$$edcf132a9284368a$var$AXIS_SIZE[axis];
    let crossSize = $e0fe69584fec2898$var$$edcf132a9284368a$var$AXIS_SIZE[crossAxis];
    $e0fe69584fec2898$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $e0fe69584fec2898$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $e0fe69584fec2898$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned) {
    let { placement: placement, crossPlacement: crossPlacement, axis: axis, crossAxis: crossAxis, size: size, crossSize: crossSize } = placementInfo;
    let position = {};
    // button position
    position[crossAxis] = childOffset[crossAxis];
    if (crossPlacement === "center") // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
    else if (crossPlacement !== crossAxis) // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
    /* else {
    the overlay top should match the button top
  } */ // add the crossOffset from props
    position[crossAxis] += crossOffset;
    // this is button center position - the overlay size + half of the button to align bottom of overlay with button center
    let minViablePosition = childOffset[crossAxis] + childOffset[crossSize] / 2 - overlaySize[crossSize];
    // this is button position of center, aligns top of overlay with button center
    let maxViablePosition = childOffset[crossAxis] + childOffset[crossSize] / 2;
    // clamp it into the range of the min/max positions
    position[crossAxis] = Math.min(Math.max(minViablePosition, position[crossAxis]), maxViablePosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[size];
        position[$e0fe69584fec2898$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $e0fe69584fec2898$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding) {
    return position.top != null ? Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top - (containerOffsetWithBoundary.top + position.top) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    )) : Math.max(0, childOffset.top + containerOffsetWithBoundary.top - (boundaryDimensions.top + boundaryDimensions.scroll.top) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    ));
}
function $e0fe69584fec2898$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    let { placement: placement, axis: axis, size: size } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[$e0fe69584fec2898$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[$e0fe69584fec2898$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $e0fe69584fec2898$var$$edcf132a9284368a$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight) {
    let placementInfo = $e0fe69584fec2898$var$$edcf132a9284368a$var$parsePlacement(placementInput);
    let { size: size, crossAxis: crossAxis, crossSize: crossSize, placement: placement, crossPlacement: crossPlacement } = placementInfo;
    let position = $e0fe69584fec2898$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
    let normalizedOffset = offset;
    let space = $e0fe69584fec2898$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        let flippedPlacementInfo = $e0fe69584fec2898$var$$edcf132a9284368a$var$parsePlacement(`${$e0fe69584fec2898$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $e0fe69584fec2898$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
        let flippedSpace = $e0fe69584fec2898$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    let delta = $e0fe69584fec2898$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
    position[crossAxis] += delta;
    let maxHeight = $e0fe69584fec2898$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $e0fe69584fec2898$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
    delta = $e0fe69584fec2898$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
    position[crossAxis] += delta;
    let arrowPosition = {};
    arrowPosition[crossAxis] = childOffset[crossAxis] - position[crossAxis] + childOffset[crossSize] / 2;
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function $e0fe69584fec2898$var$$edcf132a9284368a$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement, targetNode: targetNode, overlayNode: overlayNode, scrollNode: scrollNode, padding: padding, shouldFlip: shouldFlip, boundaryElement: boundaryElement, offset: offset, crossOffset: crossOffset, maxHeight: maxHeight } = opts;
    let container = overlayNode.offsetParent || document.body;
    let isBodyContainer = container.tagName === "BODY";
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== "static";
    let childOffset = isBodyContainer ? (0, $1291e088852df2a8$export$2e2bcd8739ae039)(targetNode) : (0, $ea64cb59793cf53a$export$2e2bcd8739ae039)(targetNode, container);
    if (!isBodyContainer) {
        let marginTop = String((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(targetNode, "marginTop"));
        let marginLeft = String((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(targetNode, "marginLeft"));
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = (0, $1291e088852df2a8$export$2e2bcd8739ae039)(overlayNode);
    let margins = $e0fe69584fec2898$var$$edcf132a9284368a$var$getMargins(overlayNode);
    overlaySize.width += margins.left + margins.right;
    overlaySize.height += margins.top + margins.bottom;
    let scrollSize = $e0fe69584fec2898$var$$edcf132a9284368a$var$getScroll(scrollNode);
    let boundaryDimensions = $e0fe69584fec2898$var$$edcf132a9284368a$var$getContainerDimensions(boundaryElement);
    let containerOffsetWithBoundary = boundaryElement.tagName === "BODY" ? (0, $1291e088852df2a8$export$2e2bcd8739ae039)(container) : (0, $ea64cb59793cf53a$export$2e2bcd8739ae039)(container, boundaryElement);
    return $e0fe69584fec2898$var$$edcf132a9284368a$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight);
}
const $e0fe69584fec2898$var$$dd149f63282afbbf$export$f6211563215e3b37 = new WeakMap();
function $e0fe69584fec2898$var$$dd149f63282afbbf$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef, isOpen: isOpen, onClose: onClose } = opts;
    (0, $acw62.useEffect)(()=>{
        if (!isOpen) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || $e0fe69584fec2898$var$$dd149f63282afbbf$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener("scroll", onScroll, true);
        return ()=>{
            window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}
// @ts-ignore
let $e0fe69584fec2898$var$$2a41e45df1593e64$var$visualViewport = typeof window !== "undefined" && window.visualViewport;
function $e0fe69584fec2898$export$d39e1813b3bdd0e1(props) {
    let { direction: direction } = (0, $cc77112e47cb65f2$export$43bb16f9c6d9e3f7)();
    let { targetRef: targetRef, overlayRef: overlayRef, scrollRef: scrollRef = overlayRef, placement: placement = "bottom", containerPadding: containerPadding = 12, shouldFlip: shouldFlip = true, boundaryElement: boundaryElement = typeof document !== "undefined" ? document.body : null, offset: offset = 0, crossOffset: crossOffset = 0, shouldUpdatePosition: shouldUpdatePosition = true, isOpen: isOpen = true, onClose: onClose, maxHeight: maxHeight } = props;
    let [position, setPosition] = (0, $acw62.useState)({
        position: {},
        arrowOffsetLeft: undefined,
        arrowOffsetTop: undefined,
        maxHeight: undefined,
        placement: undefined
    });
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight
    ];
    let updatePosition = (0, $acw62.useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
        setPosition($e0fe69584fec2898$var$$edcf132a9284368a$export$b3ceb0cbf1056d98({
            placement: $e0fe69584fec2898$var$$2a41e45df1593e64$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight
        }));
    }, deps);
    // Update position when anything changes
    (0, $4d60a29ecf011a9e$export$e5c5a5f917a5871c)(updatePosition, deps);
    // Update position on window resize
    $e0fe69584fec2898$var$$2a41e45df1593e64$var$useResize(updatePosition);
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (0, $acw62.useRef)(false);
    (0, $4d60a29ecf011a9e$export$e5c5a5f917a5871c)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        $e0fe69584fec2898$var$$2a41e45df1593e64$var$visualViewport === null || $e0fe69584fec2898$var$$2a41e45df1593e64$var$visualViewport === void 0 || $e0fe69584fec2898$var$$2a41e45df1593e64$var$visualViewport.addEventListener("resize", onResize);
        return ()=>{
            $e0fe69584fec2898$var$$2a41e45df1593e64$var$visualViewport === null || $e0fe69584fec2898$var$$2a41e45df1593e64$var$visualViewport === void 0 || $e0fe69584fec2898$var$$2a41e45df1593e64$var$visualViewport.removeEventListener("resize", onResize);
        };
    }, [
        updatePosition
    ]);
    let close = (0, $acw62.useCallback)(()=>{
        if (!isResizing.current) onClose();
    }, [
        onClose,
        isResizing
    ]);
    // When scrolling a parent scrollable region of the trigger (other than the body),
    // we hide the popover. Otherwise, its position would be incorrect.
    $e0fe69584fec2898$var$$dd149f63282afbbf$export$18fc8428861184da({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose ? close : undefined
    });
    return {
        overlayProps: {
            style: {
                position: "absolute",
                zIndex: 100000,
                ...position.position,
                maxHeight: position.maxHeight
            }
        },
        placement: position.placement,
        arrowProps: {
            style: {
                left: position.arrowOffsetLeft,
                top: position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $e0fe69584fec2898$var$$2a41e45df1593e64$var$useResize(onResize) {
    (0, $4d60a29ecf011a9e$export$e5c5a5f917a5871c)(()=>{
        window.addEventListener("resize", onResize, false);
        return ()=>{
            window.removeEventListener("resize", onResize, false);
        };
    }, [
        onResize
    ]);
}
function $e0fe69584fec2898$var$$2a41e45df1593e64$var$translateRTL(position, direction) {
    if (direction === "rtl") return position.replace("start", "right").replace("end", "left");
    return position.replace("start", "left").replace("end", "right");
}
var $e0fe69584fec2898$var$$a11501f3d1d39e6c$exports = {};
$e0fe69584fec2898$var$$parcel$export($e0fe69584fec2898$var$$a11501f3d1d39e6c$exports, "useOverlay", ()=>$e0fe69584fec2898$export$ea8f71083e90600f);
const $e0fe69584fec2898$var$$a11501f3d1d39e6c$var$visibleOverlays = [];
function $e0fe69584fec2898$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose, shouldCloseOnBlur: shouldCloseOnBlur, isOpen: isOpen, isDismissable: isDismissable = false, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside } = props;
    // Add the overlay ref to the stack of visible overlays on mount, and remove on unmount.
    (0, $acw62.useEffect)(()=>{
        if (isOpen) $e0fe69584fec2898$var$$a11501f3d1d39e6c$var$visibleOverlays.push(ref);
        return ()=>{
            let index = $e0fe69584fec2898$var$$a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
            if (index >= 0) $e0fe69584fec2898$var$$a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack.
    let onHide = ()=>{
        if ($e0fe69584fec2898$var$$a11501f3d1d39e6c$var$visibleOverlays[$e0fe69584fec2898$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($e0fe69584fec2898$var$$a11501f3d1d39e6c$var$visibleOverlays[$e0fe69584fec2898$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($e0fe69584fec2898$var$$a11501f3d1d39e6c$var$visibleOverlays[$e0fe69584fec2898$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === "Escape" && !isKeyboardDismissDisabled) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    // Handle clicking outside the overlay to close it
    (0, $895d146aa86f8a19$export$872b660ac5a1ff98)({
        ref: ref,
        onInteractOutside: isDismissable ? onInteractOutside : null,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps } = (0, $895d146aa86f8a19$export$420e68273165f4ec)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}
var $e0fe69584fec2898$var$$628037886ba31236$exports = {};
$e0fe69584fec2898$var$$parcel$export($e0fe69584fec2898$var$$628037886ba31236$exports, "useOverlayTrigger", ()=>$e0fe69584fec2898$export$f9d5c8beee7d008d);
function $e0fe69584fec2898$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type } = props;
    let { isOpen: isOpen } = state;
    // Backward compatibility. Share state close function with useOverlayPosition so it can close on scroll
    // without forcing users to pass onClose.
    (0, $acw62.useEffect)(()=>{
        if (ref && ref.current) $e0fe69584fec2898$var$$dd149f63282afbbf$export$f6211563215e3b37.set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === "menu") ariaHasPopup = true;
    else if (type === "listbox") ariaHasPopup = "listbox";
    let overlayId = (0, $4d60a29ecf011a9e$export$f680877a34711e37)();
    return {
        triggerProps: {
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? overlayId : null
        },
        overlayProps: {
            id: overlayId
        }
    };
}
var $e0fe69584fec2898$var$$49c51c25361d4cd2$exports = {};
$e0fe69584fec2898$var$$parcel$export($e0fe69584fec2898$var$$49c51c25361d4cd2$exports, "usePreventScroll", ()=>$e0fe69584fec2898$export$ee0f7cc6afcd1c18);
// @ts-ignore
const $e0fe69584fec2898$var$$49c51c25361d4cd2$var$visualViewport = typeof window !== "undefined" && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const $e0fe69584fec2898$var$$49c51c25361d4cd2$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $e0fe69584fec2898$export$ee0f7cc6afcd1c18(options = {}) {
    let { isDisabled: isDisabled } = options;
    (0, $4d60a29ecf011a9e$export$e5c5a5f917a5871c)(()=>{
        if (isDisabled) return;
        if ((0, $4d60a29ecf011a9e$export$fedb369cb70207f1)()) return $e0fe69584fec2898$var$$49c51c25361d4cd2$var$preventScrollMobileSafari();
        else return $e0fe69584fec2898$var$$49c51c25361d4cd2$var$preventScrollStandard();
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $e0fe69584fec2898$var$$49c51c25361d4cd2$var$preventScrollStandard() {
    return (0, $4d60a29ecf011a9e$export$e08e3b67e392101e)($e0fe69584fec2898$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $e0fe69584fec2898$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Prevent default on `touchmove` events inside a scrollable element when the scroll position is at the
//    top or bottom. This avoids the whole page scrolling instead, but does prevent overscrolling.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $e0fe69584fec2898$var$$49c51c25361d4cd2$var$preventScrollMobileSafari() {
    let scrollable;
    let lastY = 0;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = (0, $4d60a29ecf011a9e$export$cfa2225e87938781)(e.target);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        lastY = e.changedTouches[0].pageY;
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead. Unfortunately, this disables bounce scrolling when at
        // the top but it's the best we can do.
        let y = e.changedTouches[0].pageY;
        let scrollTop = scrollable.scrollTop;
        let bottom = scrollable.scrollHeight - scrollable.clientHeight;
        if (scrollTop <= 0 && y > lastY || scrollTop >= bottom && y < lastY) e.preventDefault();
        lastY = y;
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if ($e0fe69584fec2898$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = "translateY(-2000px)";
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = "";
            });
        }
    };
    let onFocus = (e)=>{
        let target = e.target;
        if ($e0fe69584fec2898$var$$49c51c25361d4cd2$var$willOpenKeyboard(target)) {
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = "translateY(-2000px)";
            requestAnimationFrame(()=>{
                target.style.transform = "";
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($e0fe69584fec2898$var$$49c51c25361d4cd2$var$visualViewport) {
                    if ($e0fe69584fec2898$var$$49c51c25361d4cd2$var$visualViewport.height < window.innerHeight) // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $e0fe69584fec2898$var$$49c51c25361d4cd2$var$scrollIntoView(target);
                    });
                    else // measure the correct position to scroll to.
                    $e0fe69584fec2898$var$$49c51c25361d4cd2$var$visualViewport.addEventListener("resize", ()=>$e0fe69584fec2898$var$$49c51c25361d4cd2$var$scrollIntoView(target), {
                        once: true
                    });
                }
            });
        }
    };
    let onWindowScroll = ()=>{
        // Last resort. If the window scrolled, scroll it back to the top.
        // It should always be at the top because the body will have a negative margin (see below).
        window.scrollTo(0, 0);
    };
    // Record the original scroll position so we can restore it.
    // Then apply a negative margin to the body to offset it by the scroll position. This will
    // enable us to scroll the window to the top, which is required for the rest of this to work.
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    let restoreStyles = (0, $4d60a29ecf011a9e$export$e08e3b67e392101e)($e0fe69584fec2898$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $e0fe69584fec2898$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $e0fe69584fec2898$var$$49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${scrollY}px`));
    // Scroll to the top. The negative margin on the body will make this appear the same.
    window.scrollTo(0, 0);
    let removeEvents = (0, $4d60a29ecf011a9e$export$e08e3b67e392101e)($e0fe69584fec2898$var$$49c51c25361d4cd2$var$addEvent(document, "touchstart", onTouchStart, {
        passive: false,
        capture: true
    }), $e0fe69584fec2898$var$$49c51c25361d4cd2$var$addEvent(document, "touchmove", onTouchMove, {
        passive: false,
        capture: true
    }), $e0fe69584fec2898$var$$49c51c25361d4cd2$var$addEvent(document, "touchend", onTouchEnd, {
        passive: false,
        capture: true
    }), $e0fe69584fec2898$var$$49c51c25361d4cd2$var$addEvent(document, "focus", onFocus, true), $e0fe69584fec2898$var$$49c51c25361d4cd2$var$addEvent(window, "scroll", onWindowScroll));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreStyles();
        removeEvents();
        window.scrollTo(scrollX, scrollY);
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $e0fe69584fec2898$var$$49c51c25361d4cd2$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $e0fe69584fec2898$var$$49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    return ()=>{
        target.removeEventListener(event, handler, options);
    };
}
function $e0fe69584fec2898$var$$49c51c25361d4cd2$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = (0, $4d60a29ecf011a9e$export$cfa2225e87938781)(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        target = scrollable.parentElement;
    }
}
function $e0fe69584fec2898$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !$e0fe69584fec2898$var$$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}
var $e0fe69584fec2898$var$$f57aed4a881a3485$exports = {};
$e0fe69584fec2898$var$$parcel$export($e0fe69584fec2898$var$$f57aed4a881a3485$exports, "ModalProvider", ()=>$e0fe69584fec2898$export$178405afcd8c5eb);
$e0fe69584fec2898$var$$parcel$export($e0fe69584fec2898$var$$f57aed4a881a3485$exports, "useModalProvider", ()=>$e0fe69584fec2898$export$d9aaed4c3ece1bc0);
$e0fe69584fec2898$var$$parcel$export($e0fe69584fec2898$var$$f57aed4a881a3485$exports, "OverlayProvider", ()=>$e0fe69584fec2898$export$bf688221f59024e5);
$e0fe69584fec2898$var$$parcel$export($e0fe69584fec2898$var$$f57aed4a881a3485$exports, "OverlayContainer", ()=>$e0fe69584fec2898$export$b47c3594eab58386);
$e0fe69584fec2898$var$$parcel$export($e0fe69584fec2898$var$$f57aed4a881a3485$exports, "useModal", ()=>$e0fe69584fec2898$export$33ffd74ebf07f060);
const $e0fe69584fec2898$var$$f57aed4a881a3485$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $e0fe69584fec2898$export$178405afcd8c5eb(props) {
    let { children: children } = props;
    let parent = (0, $acw62.useContext)($e0fe69584fec2898$var$$f57aed4a881a3485$var$Context);
    let [modalCount, setModalCount] = (0, $acw62.useState)(0);
    let context = (0, $acw62.useMemo)(()=>({
            parent: parent,
            modalCount: modalCount,
            addModal () {
                setModalCount((count)=>count + 1);
                if (parent) parent.addModal();
            },
            removeModal () {
                setModalCount((count)=>count - 1);
                if (parent) parent.removeModal();
            }
        }), [
        parent,
        modalCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0fe69584fec2898$var$$f57aed4a881a3485$var$Context.Provider, {
        value: context
    }, children);
}
function $e0fe69584fec2898$export$d9aaed4c3ece1bc0() {
    let context = (0, $acw62.useContext)($e0fe69584fec2898$var$$f57aed4a881a3485$var$Context);
    return {
        modalProviderProps: {
            "aria-hidden": context && context.modalCount > 0 ? true : null
        }
    };
}
/**
 * Creates a root node that will be aria-hidden if there are other modals open.
 */ function $e0fe69584fec2898$var$$f57aed4a881a3485$var$OverlayContainerDOM(props) {
    let { modalProviderProps: modalProviderProps } = $e0fe69584fec2898$export$d9aaed4c3ece1bc0();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-overlay-container": true,
        ...props,
        ...modalProviderProps
    });
}
function $e0fe69584fec2898$export$bf688221f59024e5(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0fe69584fec2898$export$178405afcd8c5eb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0fe69584fec2898$var$$f57aed4a881a3485$var$OverlayContainerDOM, props));
}
function $e0fe69584fec2898$export$b47c3594eab58386(props) {
    let { portalContainer: portalContainer = document.body, ...rest } = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (portalContainer.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
    }, [
        portalContainer
    ]);
    let contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0fe69584fec2898$export$bf688221f59024e5, rest);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(contents, portalContainer);
}
function $e0fe69584fec2898$export$33ffd74ebf07f060(options) {
    // Add aria-hidden to all parent providers on mount, and restore on unmount.
    let context = (0, $acw62.useContext)($e0fe69584fec2898$var$$f57aed4a881a3485$var$Context);
    if (!context) throw new Error("Modal is not contained within a provider");
    (0, $acw62.useEffect)(()=>{
        if ((options === null || options === void 0 ? void 0 : options.isDisabled) || !context || !context.parent) return;
        // The immediate context is from the provider containing this modal, so we only
        // want to trigger aria-hidden on its parents not on the modal provider itself.
        context.parent.addModal();
        return ()=>{
            if (context && context.parent) context.parent.removeModal();
        };
    }, [
        context,
        context.parent,
        options === null || options === void 0 ? void 0 : options.isDisabled
    ]);
    return {
        modalProps: {
            "data-ismodal": !(options === null || options === void 0 ? void 0 : options.isDisabled)
        }
    };
}
var $e0fe69584fec2898$var$$86ea4cb521eb2e37$exports = {};
$e0fe69584fec2898$var$$parcel$export($e0fe69584fec2898$var$$86ea4cb521eb2e37$exports, "DismissButton", ()=>$e0fe69584fec2898$export$2317d149ed6f78c4);
var $e0fe69584fec2898$var$$61fe14465afefc5e$exports = {};
var $e0fe69584fec2898$var$$773d5888b972f1cf$exports = {};
$e0fe69584fec2898$var$$773d5888b972f1cf$exports = JSON.parse('{"dismiss":"\u062A\u062C\u0627\u0647\u0644"}');
var $e0fe69584fec2898$var$$d11f19852b941573$exports = {};
$e0fe69584fec2898$var$$d11f19852b941573$exports = JSON.parse('{"dismiss":"\u041E\u0442\u0445\u0432\u044A\u0440\u043B\u044F\u043D\u0435"}');
var $e0fe69584fec2898$var$$b983974c2ee1efb3$exports = {};
$e0fe69584fec2898$var$$b983974c2ee1efb3$exports = JSON.parse('{"dismiss":"Odstranit"}');
var $e0fe69584fec2898$var$$5809cc9d4e92de73$exports = {};
$e0fe69584fec2898$var$$5809cc9d4e92de73$exports = JSON.parse('{"dismiss":"Luk"}');
var $e0fe69584fec2898$var$$c68c2e4fc74398d1$exports = {};
$e0fe69584fec2898$var$$c68c2e4fc74398d1$exports = JSON.parse('{"dismiss":"Schlie\xdfen"}');
var $e0fe69584fec2898$var$$0898b4c153db2b77$exports = {};
$e0fe69584fec2898$var$$0898b4c153db2b77$exports = JSON.parse('{"dismiss":"\u0391\u03C0\u03CC\u03C1\u03C1\u03B9\u03C8\u03B7"}');
var $e0fe69584fec2898$var$$6d74810286a15183$exports = {};
$e0fe69584fec2898$var$$6d74810286a15183$exports = JSON.parse('{"dismiss":"Dismiss"}');
var $e0fe69584fec2898$var$$309d73dc65f78055$exports = {};
$e0fe69584fec2898$var$$309d73dc65f78055$exports = JSON.parse('{"dismiss":"Descartar"}');
var $e0fe69584fec2898$var$$44ad94f7205cf593$exports = {};
$e0fe69584fec2898$var$$44ad94f7205cf593$exports = JSON.parse('{"dismiss":"L\xf5peta"}');
var $e0fe69584fec2898$var$$7c28f5687f0779a9$exports = {};
$e0fe69584fec2898$var$$7c28f5687f0779a9$exports = JSON.parse('{"dismiss":"Hylk\xe4\xe4"}');
var $e0fe69584fec2898$var$$e6d75df4b68bd73a$exports = {};
$e0fe69584fec2898$var$$e6d75df4b68bd73a$exports = JSON.parse('{"dismiss":"Rejeter"}');
var $e0fe69584fec2898$var$$87505c9dab186d0f$exports = {};
$e0fe69584fec2898$var$$87505c9dab186d0f$exports = JSON.parse('{"dismiss":"\u05D4\u05EA\u05E2\u05DC\u05DD"}');
var $e0fe69584fec2898$var$$553439c3ffb3e492$exports = {};
$e0fe69584fec2898$var$$553439c3ffb3e492$exports = JSON.parse('{"dismiss":"Odbaci"}');
var $e0fe69584fec2898$var$$74cf411061b983a2$exports = {};
$e0fe69584fec2898$var$$74cf411061b983a2$exports = JSON.parse('{"dismiss":"Elutas\xedt\xe1s"}');
var $e0fe69584fec2898$var$$e933f298574dc435$exports = {};
$e0fe69584fec2898$var$$e933f298574dc435$exports = JSON.parse('{"dismiss":"Ignora"}');
var $e0fe69584fec2898$var$$ac91fc9fe02f71f6$exports = {};
$e0fe69584fec2898$var$$ac91fc9fe02f71f6$exports = JSON.parse('{"dismiss":"\u9589\u3058\u308B"}');
var $e0fe69584fec2898$var$$52b96f86422025af$exports = {};
$e0fe69584fec2898$var$$52b96f86422025af$exports = JSON.parse('{"dismiss":"\uBB34\uC2DC"}');
var $e0fe69584fec2898$var$$c0d724c3e51dafa6$exports = {};
$e0fe69584fec2898$var$$c0d724c3e51dafa6$exports = JSON.parse('{"dismiss":"Atmesti"}');
var $e0fe69584fec2898$var$$c92899672a3fe72e$exports = {};
$e0fe69584fec2898$var$$c92899672a3fe72e$exports = JSON.parse('{"dismiss":"Ner\u0101d\u012Bt"}');
var $e0fe69584fec2898$var$$9f576b39d8e7a9d6$exports = {};
$e0fe69584fec2898$var$$9f576b39d8e7a9d6$exports = JSON.parse('{"dismiss":"Lukk"}');
var $e0fe69584fec2898$var$$9d025808aeec81a7$exports = {};
$e0fe69584fec2898$var$$9d025808aeec81a7$exports = JSON.parse('{"dismiss":"Negeren"}');
var $e0fe69584fec2898$var$$fce709921e2c0fa6$exports = {};
$e0fe69584fec2898$var$$fce709921e2c0fa6$exports = JSON.parse('{"dismiss":"Zignoruj"}');
var $e0fe69584fec2898$var$$2599cf0c4ab37f59$exports = {};
$e0fe69584fec2898$var$$2599cf0c4ab37f59$exports = JSON.parse('{"dismiss":"Descartar"}');
var $e0fe69584fec2898$var$$3c220ae7ef8a35fd$exports = {};
$e0fe69584fec2898$var$$3c220ae7ef8a35fd$exports = JSON.parse('{"dismiss":"Dispensar"}');
var $e0fe69584fec2898$var$$93562b5094072f54$exports = {};
$e0fe69584fec2898$var$$93562b5094072f54$exports = JSON.parse('{"dismiss":"Revocare"}');
var $e0fe69584fec2898$var$$cd9e2abd0d06c7b4$exports = {};
$e0fe69584fec2898$var$$cd9e2abd0d06c7b4$exports = JSON.parse('{"dismiss":"\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C"}');
var $e0fe69584fec2898$var$$45375701f409adf1$exports = {};
$e0fe69584fec2898$var$$45375701f409adf1$exports = JSON.parse('{"dismiss":"Zru\u0161i\u0165"}');
var $e0fe69584fec2898$var$$27fab53a576de9dd$exports = {};
$e0fe69584fec2898$var$$27fab53a576de9dd$exports = JSON.parse('{"dismiss":"Opusti"}');
var $e0fe69584fec2898$var$$4438748d9952e7c7$exports = {};
$e0fe69584fec2898$var$$4438748d9952e7c7$exports = JSON.parse('{"dismiss":"Odbaci"}');
var $e0fe69584fec2898$var$$0936d7347ef4da4c$exports = {};
$e0fe69584fec2898$var$$0936d7347ef4da4c$exports = JSON.parse('{"dismiss":"Avvisa"}');
var $e0fe69584fec2898$var$$29700c92185d38f8$exports = {};
$e0fe69584fec2898$var$$29700c92185d38f8$exports = JSON.parse('{"dismiss":"Kapat"}');
var $e0fe69584fec2898$var$$662ccaf2be4c25b3$exports = {};
$e0fe69584fec2898$var$$662ccaf2be4c25b3$exports = JSON.parse('{"dismiss":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"}');
var $e0fe69584fec2898$var$$d80a27deda7cdb3c$exports = {};
$e0fe69584fec2898$var$$d80a27deda7cdb3c$exports = JSON.parse('{"dismiss":"\u53D6\u6D88"}');
var $e0fe69584fec2898$var$$2b2734393847c884$exports = {};
$e0fe69584fec2898$var$$2b2734393847c884$exports = JSON.parse('{"dismiss":"\u95DC\u9589"}');
$e0fe69584fec2898$var$$61fe14465afefc5e$exports = {
    "ar-AE": $e0fe69584fec2898$var$$773d5888b972f1cf$exports,
    "bg-BG": $e0fe69584fec2898$var$$d11f19852b941573$exports,
    "cs-CZ": $e0fe69584fec2898$var$$b983974c2ee1efb3$exports,
    "da-DK": $e0fe69584fec2898$var$$5809cc9d4e92de73$exports,
    "de-DE": $e0fe69584fec2898$var$$c68c2e4fc74398d1$exports,
    "el-GR": $e0fe69584fec2898$var$$0898b4c153db2b77$exports,
    "en-US": $e0fe69584fec2898$var$$6d74810286a15183$exports,
    "es-ES": $e0fe69584fec2898$var$$309d73dc65f78055$exports,
    "et-EE": $e0fe69584fec2898$var$$44ad94f7205cf593$exports,
    "fi-FI": $e0fe69584fec2898$var$$7c28f5687f0779a9$exports,
    "fr-FR": $e0fe69584fec2898$var$$e6d75df4b68bd73a$exports,
    "he-IL": $e0fe69584fec2898$var$$87505c9dab186d0f$exports,
    "hr-HR": $e0fe69584fec2898$var$$553439c3ffb3e492$exports,
    "hu-HU": $e0fe69584fec2898$var$$74cf411061b983a2$exports,
    "it-IT": $e0fe69584fec2898$var$$e933f298574dc435$exports,
    "ja-JP": $e0fe69584fec2898$var$$ac91fc9fe02f71f6$exports,
    "ko-KR": $e0fe69584fec2898$var$$52b96f86422025af$exports,
    "lt-LT": $e0fe69584fec2898$var$$c0d724c3e51dafa6$exports,
    "lv-LV": $e0fe69584fec2898$var$$c92899672a3fe72e$exports,
    "nb-NO": $e0fe69584fec2898$var$$9f576b39d8e7a9d6$exports,
    "nl-NL": $e0fe69584fec2898$var$$9d025808aeec81a7$exports,
    "pl-PL": $e0fe69584fec2898$var$$fce709921e2c0fa6$exports,
    "pt-BR": $e0fe69584fec2898$var$$2599cf0c4ab37f59$exports,
    "pt-PT": $e0fe69584fec2898$var$$3c220ae7ef8a35fd$exports,
    "ro-RO": $e0fe69584fec2898$var$$93562b5094072f54$exports,
    "ru-RU": $e0fe69584fec2898$var$$cd9e2abd0d06c7b4$exports,
    "sk-SK": $e0fe69584fec2898$var$$45375701f409adf1$exports,
    "sl-SI": $e0fe69584fec2898$var$$27fab53a576de9dd$exports,
    "sr-SP": $e0fe69584fec2898$var$$4438748d9952e7c7$exports,
    "sv-SE": $e0fe69584fec2898$var$$0936d7347ef4da4c$exports,
    "tr-TR": $e0fe69584fec2898$var$$29700c92185d38f8$exports,
    "uk-UA": $e0fe69584fec2898$var$$662ccaf2be4c25b3$exports,
    "zh-CN": $e0fe69584fec2898$var$$d80a27deda7cdb3c$exports,
    "zh-TW": $e0fe69584fec2898$var$$2b2734393847c884$exports
};
function $e0fe69584fec2898$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss, ...otherProps } = props;
    let formatMessage = (0, $cc77112e47cb65f2$export$ec23bf898b1eed85)(/*@__PURE__*/ $e0fe69584fec2898$var$$parcel$interopDefault($e0fe69584fec2898$var$$61fe14465afefc5e$exports));
    let labels = (0, $4d60a29ecf011a9e$export$d6875122194c7b44)(otherProps, formatMessage("dismiss"));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6410015022a21732$export$439d29a4e110a164), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick
    }));
}
var $e0fe69584fec2898$var$$5e3802645cc19319$exports = {};
$e0fe69584fec2898$var$$parcel$export($e0fe69584fec2898$var$$5e3802645cc19319$exports, "ariaHideOutside", ()=>$e0fe69584fec2898$export$1c3ebcada18427bf);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $e0fe69584fec2898$var$$5e3802645cc19319$var$refCountMap = new WeakMap();
function $e0fe69584fec2898$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            // If this node is a live announcer, add it to the set of nodes to keep visible.
            if (node instanceof HTMLElement && node.dataset.liveAnnouncer === "true") visibleNodes.add(node);
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive.
            if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement)) return NodeFilter.FILTER_REJECT;
            // VoiceOver on iOS has issues hiding elements with role="row". Hide the cells inside instead.
            // https://bugs.webkit.org/show_bug.cgi?id=222623
            if (node instanceof HTMLElement && node.getAttribute("role") === "row") return NodeFilter.FILTER_SKIP;
            // Skip this node but continue to children if one of the targets is inside the node.
            if (targets.some((target)=>node.contains(target))) return NodeFilter.FILTER_SKIP;
            return NodeFilter.FILTER_ACCEPT;
        }
    });
    let hide = (node)=>{
        var ref;
        let refCount = (ref = $e0fe69584fec2898$var$$5e3802645cc19319$var$refCountMap.get(node)) !== null && ref !== void 0 ? ref : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute("aria-hidden") === "true" && refCount === 0) return;
        if (refCount === 0) node.setAttribute("aria-hidden", "true");
        hiddenNodes.add(node);
        $e0fe69584fec2898$var$$5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
    };
    let node1 = walker.nextNode();
    while(node1 != null){
        hide(node1);
        node1 = walker.nextNode();
    }
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== "childList" || change.addedNodes.length === 0) continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) for (let node2 of change.addedNodes){
                if (node2 instanceof HTMLElement && node2.dataset.liveAnnouncer === "true") visibleNodes.add(node2);
                else if (node2 instanceof Element) hide(node2);
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $e0fe69584fec2898$var$$5e3802645cc19319$var$refCountMap.get(node);
            if (count === 1) {
                node.removeAttribute("aria-hidden");
                $e0fe69584fec2898$var$$5e3802645cc19319$var$refCountMap.delete(node);
            } else $e0fe69584fec2898$var$$5e3802645cc19319$var$refCountMap.set(node, count - 1);
        }
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $5ef971420afb2954$var$e = "colors", $5ef971420afb2954$var$t = "sizes", $5ef971420afb2954$var$r = "space", $5ef971420afb2954$export$22deaee80f3d7c38 = {
    gap: $5ef971420afb2954$var$r,
    gridGap: $5ef971420afb2954$var$r,
    columnGap: $5ef971420afb2954$var$r,
    gridColumnGap: $5ef971420afb2954$var$r,
    rowGap: $5ef971420afb2954$var$r,
    gridRowGap: $5ef971420afb2954$var$r,
    inset: $5ef971420afb2954$var$r,
    insetBlock: $5ef971420afb2954$var$r,
    insetBlockEnd: $5ef971420afb2954$var$r,
    insetBlockStart: $5ef971420afb2954$var$r,
    insetInline: $5ef971420afb2954$var$r,
    insetInlineEnd: $5ef971420afb2954$var$r,
    insetInlineStart: $5ef971420afb2954$var$r,
    margin: $5ef971420afb2954$var$r,
    marginTop: $5ef971420afb2954$var$r,
    marginRight: $5ef971420afb2954$var$r,
    marginBottom: $5ef971420afb2954$var$r,
    marginLeft: $5ef971420afb2954$var$r,
    marginBlock: $5ef971420afb2954$var$r,
    marginBlockEnd: $5ef971420afb2954$var$r,
    marginBlockStart: $5ef971420afb2954$var$r,
    marginInline: $5ef971420afb2954$var$r,
    marginInlineEnd: $5ef971420afb2954$var$r,
    marginInlineStart: $5ef971420afb2954$var$r,
    padding: $5ef971420afb2954$var$r,
    paddingTop: $5ef971420afb2954$var$r,
    paddingRight: $5ef971420afb2954$var$r,
    paddingBottom: $5ef971420afb2954$var$r,
    paddingLeft: $5ef971420afb2954$var$r,
    paddingBlock: $5ef971420afb2954$var$r,
    paddingBlockEnd: $5ef971420afb2954$var$r,
    paddingBlockStart: $5ef971420afb2954$var$r,
    paddingInline: $5ef971420afb2954$var$r,
    paddingInlineEnd: $5ef971420afb2954$var$r,
    paddingInlineStart: $5ef971420afb2954$var$r,
    top: $5ef971420afb2954$var$r,
    right: $5ef971420afb2954$var$r,
    bottom: $5ef971420afb2954$var$r,
    left: $5ef971420afb2954$var$r,
    scrollMargin: $5ef971420afb2954$var$r,
    scrollMarginTop: $5ef971420afb2954$var$r,
    scrollMarginRight: $5ef971420afb2954$var$r,
    scrollMarginBottom: $5ef971420afb2954$var$r,
    scrollMarginLeft: $5ef971420afb2954$var$r,
    scrollMarginX: $5ef971420afb2954$var$r,
    scrollMarginY: $5ef971420afb2954$var$r,
    scrollMarginBlock: $5ef971420afb2954$var$r,
    scrollMarginBlockEnd: $5ef971420afb2954$var$r,
    scrollMarginBlockStart: $5ef971420afb2954$var$r,
    scrollMarginInline: $5ef971420afb2954$var$r,
    scrollMarginInlineEnd: $5ef971420afb2954$var$r,
    scrollMarginInlineStart: $5ef971420afb2954$var$r,
    scrollPadding: $5ef971420afb2954$var$r,
    scrollPaddingTop: $5ef971420afb2954$var$r,
    scrollPaddingRight: $5ef971420afb2954$var$r,
    scrollPaddingBottom: $5ef971420afb2954$var$r,
    scrollPaddingLeft: $5ef971420afb2954$var$r,
    scrollPaddingX: $5ef971420afb2954$var$r,
    scrollPaddingY: $5ef971420afb2954$var$r,
    scrollPaddingBlock: $5ef971420afb2954$var$r,
    scrollPaddingBlockEnd: $5ef971420afb2954$var$r,
    scrollPaddingBlockStart: $5ef971420afb2954$var$r,
    scrollPaddingInline: $5ef971420afb2954$var$r,
    scrollPaddingInlineEnd: $5ef971420afb2954$var$r,
    scrollPaddingInlineStart: $5ef971420afb2954$var$r,
    fontSize: "fontSizes",
    background: $5ef971420afb2954$var$e,
    backgroundColor: $5ef971420afb2954$var$e,
    backgroundImage: $5ef971420afb2954$var$e,
    borderImage: $5ef971420afb2954$var$e,
    border: $5ef971420afb2954$var$e,
    borderBlock: $5ef971420afb2954$var$e,
    borderBlockEnd: $5ef971420afb2954$var$e,
    borderBlockStart: $5ef971420afb2954$var$e,
    borderBottom: $5ef971420afb2954$var$e,
    borderBottomColor: $5ef971420afb2954$var$e,
    borderColor: $5ef971420afb2954$var$e,
    borderInline: $5ef971420afb2954$var$e,
    borderInlineEnd: $5ef971420afb2954$var$e,
    borderInlineStart: $5ef971420afb2954$var$e,
    borderLeft: $5ef971420afb2954$var$e,
    borderLeftColor: $5ef971420afb2954$var$e,
    borderRight: $5ef971420afb2954$var$e,
    borderRightColor: $5ef971420afb2954$var$e,
    borderTop: $5ef971420afb2954$var$e,
    borderTopColor: $5ef971420afb2954$var$e,
    caretColor: $5ef971420afb2954$var$e,
    color: $5ef971420afb2954$var$e,
    columnRuleColor: $5ef971420afb2954$var$e,
    fill: $5ef971420afb2954$var$e,
    outline: $5ef971420afb2954$var$e,
    outlineColor: $5ef971420afb2954$var$e,
    stroke: $5ef971420afb2954$var$e,
    textDecorationColor: $5ef971420afb2954$var$e,
    fontFamily: "fonts",
    fontWeight: "fontWeights",
    lineHeight: "lineHeights",
    letterSpacing: "letterSpacings",
    blockSize: $5ef971420afb2954$var$t,
    minBlockSize: $5ef971420afb2954$var$t,
    maxBlockSize: $5ef971420afb2954$var$t,
    inlineSize: $5ef971420afb2954$var$t,
    minInlineSize: $5ef971420afb2954$var$t,
    maxInlineSize: $5ef971420afb2954$var$t,
    width: $5ef971420afb2954$var$t,
    minWidth: $5ef971420afb2954$var$t,
    maxWidth: $5ef971420afb2954$var$t,
    height: $5ef971420afb2954$var$t,
    minHeight: $5ef971420afb2954$var$t,
    maxHeight: $5ef971420afb2954$var$t,
    flexBasis: $5ef971420afb2954$var$t,
    gridTemplateColumns: $5ef971420afb2954$var$t,
    gridTemplateRows: $5ef971420afb2954$var$t,
    borderWidth: "borderWidths",
    borderTopWidth: "borderWidths",
    borderRightWidth: "borderWidths",
    borderBottomWidth: "borderWidths",
    borderLeftWidth: "borderWidths",
    borderStyle: "borderStyles",
    borderTopStyle: "borderStyles",
    borderRightStyle: "borderStyles",
    borderBottomStyle: "borderStyles",
    borderLeftStyle: "borderStyles",
    borderRadius: "radii",
    borderTopLeftRadius: "radii",
    borderTopRightRadius: "radii",
    borderBottomRightRadius: "radii",
    borderBottomLeftRadius: "radii",
    boxShadow: "shadows",
    textShadow: "shadows",
    transition: "transitions",
    zIndex: "zIndices"
}, $5ef971420afb2954$var$i = (e, t)=>"function" == typeof t ? {
        "()": Function.prototype.toString.call(t)
    } : t, $5ef971420afb2954$var$o = ()=>{
    const e = Object.create(null);
    return (t, r, ...n)=>{
        const o = ((e)=>JSON.stringify(e, $5ef971420afb2954$var$i))(t);
        return o in e ? e[o] : e[o] = r(t, ...n);
    };
}, $5ef971420afb2954$var$l = Symbol.for("sxs.internal"), $5ef971420afb2954$var$s = (e, t)=>Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), $5ef971420afb2954$var$a = (e)=>{
    for(const t in e)return !0;
    return !1;
}, { hasOwnProperty: $5ef971420afb2954$var$c } = Object.prototype, $5ef971420afb2954$var$d = (e)=>e.includes("-") ? e : e.replace(/[A-Z]/g, (e)=>"-" + e.toLowerCase()), $5ef971420afb2954$var$g = /\s+(?![^()]*\))/, $5ef971420afb2954$var$p = (e)=>(t)=>e(..."string" == typeof t ? String(t).split($5ef971420afb2954$var$g) : [
            t
        ]), $5ef971420afb2954$var$u = {
    appearance: (e)=>({
            WebkitAppearance: e,
            appearance: e
        }),
    backfaceVisibility: (e)=>({
            WebkitBackfaceVisibility: e,
            backfaceVisibility: e
        }),
    backdropFilter: (e)=>({
            WebkitBackdropFilter: e,
            backdropFilter: e
        }),
    backgroundClip: (e)=>({
            WebkitBackgroundClip: e,
            backgroundClip: e
        }),
    boxDecorationBreak: (e)=>({
            WebkitBoxDecorationBreak: e,
            boxDecorationBreak: e
        }),
    clipPath: (e)=>({
            WebkitClipPath: e,
            clipPath: e
        }),
    content: (e)=>({
            content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"`
        }),
    hyphens: (e)=>({
            WebkitHyphens: e,
            hyphens: e
        }),
    maskImage: (e)=>({
            WebkitMaskImage: e,
            maskImage: e
        }),
    maskSize: (e)=>({
            WebkitMaskSize: e,
            maskSize: e
        }),
    tabSize: (e)=>({
            MozTabSize: e,
            tabSize: e
        }),
    textSizeAdjust: (e)=>({
            WebkitTextSizeAdjust: e,
            textSizeAdjust: e
        }),
    userSelect: (e)=>({
            WebkitUserSelect: e,
            userSelect: e
        }),
    marginBlock: $5ef971420afb2954$var$p((e, t)=>({
            marginBlockStart: e,
            marginBlockEnd: t || e
        })),
    marginInline: $5ef971420afb2954$var$p((e, t)=>({
            marginInlineStart: e,
            marginInlineEnd: t || e
        })),
    maxSize: $5ef971420afb2954$var$p((e, t)=>({
            maxBlockSize: e,
            maxInlineSize: t || e
        })),
    minSize: $5ef971420afb2954$var$p((e, t)=>({
            minBlockSize: e,
            minInlineSize: t || e
        })),
    paddingBlock: $5ef971420afb2954$var$p((e, t)=>({
            paddingBlockStart: e,
            paddingBlockEnd: t || e
        })),
    paddingInline: $5ef971420afb2954$var$p((e, t)=>({
            paddingInlineStart: e,
            paddingInlineEnd: t || e
        }))
}, $5ef971420afb2954$var$h = /([\d.]+)([^]*)/, $5ef971420afb2954$var$f = (e, t)=>e.length ? e.reduce((e, r)=>(e.push(...t.map((e)=>e.includes("&") ? e.replace(/&/g, /[ +>|~]/.test(r) && /&.*&/.test(e) ? `:is(${r})` : r) : r + " " + e)), e), []) : t, $5ef971420afb2954$var$m = (e, t)=>e in $5ef971420afb2954$var$b && "string" == typeof t ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (t, r, n, i)=>r + ("stretch" === n ? `-moz-available${i};${$5ef971420afb2954$var$d(e)}:${r}-webkit-fill-available` : `-moz-fit-content${i};${$5ef971420afb2954$var$d(e)}:${r}fit-content`) + i) : String(t), $5ef971420afb2954$var$b = {
    blockSize: 1,
    height: 1,
    inlineSize: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    width: 1
}, $5ef971420afb2954$var$S = (e)=>e ? e + "-" : "", $5ef971420afb2954$var$k = (e, t, r)=>e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (e, n, i, o, l)=>"$" == o == !!i ? e : (n || "--" == o ? "calc(" : "") + "var(--" + ("$" === o ? $5ef971420afb2954$var$S(t) + (l.includes("$") ? "" : $5ef971420afb2954$var$S(r)) + l.replace(/\$/g, "-") : l) + ")" + (n || "--" == o ? "*" + (n || "") + (i || "1") + ")" : "")), $5ef971420afb2954$var$y = /\s*,\s*(?![^()]*\))/, $5ef971420afb2954$var$B = Object.prototype.toString, $5ef971420afb2954$var$$ = (e, t, r, n, i)=>{
    let o, l, s;
    const a = (e, t, r)=>{
        let c, g;
        const p = (e)=>{
            for(c in e){
                const R = 64 === c.charCodeAt(0), z = R && Array.isArray(e[c]) ? e[c] : [
                    e[c]
                ];
                for (g of z){
                    const e = /[A-Z]/.test($ = c) ? $ : $.replace(/-[^]/g, (e)=>e[1].toUpperCase()), z = "object" == typeof g && g && g.toString === $5ef971420afb2954$var$B && (!n.utils[e] || !t.length);
                    if (e in n.utils && !z) {
                        const t = n.utils[e];
                        if (t !== l) {
                            l = t, p(t(g)), l = null;
                            continue;
                        }
                    } else if (e in $5ef971420afb2954$var$u) {
                        const t = $5ef971420afb2954$var$u[e];
                        if (t !== s) {
                            s = t, p(t(g)), s = null;
                            continue;
                        }
                    }
                    if (R && (b = c.slice(1) in n.media ? "@media " + n.media[c.slice(1)] : c, c = b.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (e, t, r, n, i, o)=>{
                        const l = $5ef971420afb2954$var$h.test(t), s = .0625 * (l ? -1 : 1), [a, c] = l ? [
                            n,
                            t
                        ] : [
                            t,
                            n
                        ];
                        return "(" + ("=" === r[0] ? "" : ">" === r[0] === l ? "max-" : "min-") + a + ":" + ("=" !== r[0] && 1 === r.length ? c.replace($5ef971420afb2954$var$h, (e, t, n)=>Number(t) + s * (">" === r ? 1 : -1) + n) : c) + (i ? ") and (" + (">" === i[0] ? "min-" : "max-") + a + ":" + (1 === i.length ? o.replace($5ef971420afb2954$var$h, (e, t, r)=>Number(t) + s * (">" === i ? -1 : 1) + r) : o) : "") + ")";
                    })), z) {
                        const e = R ? r.concat(c) : [
                            ...r
                        ], n = R ? [
                            ...t
                        ] : $5ef971420afb2954$var$f(t, c.split($5ef971420afb2954$var$y));
                        void 0 !== o && i($5ef971420afb2954$var$x(...o)), o = void 0, a(g, n, e);
                    } else void 0 === o && (o = [
                        [],
                        t,
                        r
                    ]), c = R || 36 !== c.charCodeAt(0) ? c : `--${$5ef971420afb2954$var$S(n.prefix)}${c.slice(1).replace(/\$/g, "-")}`, g = z ? g : "number" == typeof g ? g && e in $5ef971420afb2954$var$I ? String(g) + "px" : String(g) : $5ef971420afb2954$var$k($5ef971420afb2954$var$m(e, null == g ? "" : g), n.prefix, n.themeMap[e]), o[0].push(`${R ? `${c} ` : `${$5ef971420afb2954$var$d(c)}:`}${g}`);
                }
            }
            var b, $;
        };
        p(e), void 0 !== o && i($5ef971420afb2954$var$x(...o)), o = void 0;
    };
    a(e, t, r);
}, $5ef971420afb2954$var$x = (e, t, r)=>`${r.map((e)=>`${e}{`).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(r.length ? r.length + 1 : 0).join("}")}`, $5ef971420afb2954$var$I = {
    animationDelay: 1,
    animationDuration: 1,
    backgroundSize: 1,
    blockSize: 1,
    border: 1,
    borderBlock: 1,
    borderBlockEnd: 1,
    borderBlockEndWidth: 1,
    borderBlockStart: 1,
    borderBlockStartWidth: 1,
    borderBlockWidth: 1,
    borderBottom: 1,
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderBottomWidth: 1,
    borderEndEndRadius: 1,
    borderEndStartRadius: 1,
    borderInlineEnd: 1,
    borderInlineEndWidth: 1,
    borderInlineStart: 1,
    borderInlineStartWidth: 1,
    borderInlineWidth: 1,
    borderLeft: 1,
    borderLeftWidth: 1,
    borderRadius: 1,
    borderRight: 1,
    borderRightWidth: 1,
    borderSpacing: 1,
    borderStartEndRadius: 1,
    borderStartStartRadius: 1,
    borderTop: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    borderTopWidth: 1,
    borderWidth: 1,
    bottom: 1,
    columnGap: 1,
    columnRule: 1,
    columnRuleWidth: 1,
    columnWidth: 1,
    containIntrinsicSize: 1,
    flexBasis: 1,
    fontSize: 1,
    gap: 1,
    gridAutoColumns: 1,
    gridAutoRows: 1,
    gridTemplateColumns: 1,
    gridTemplateRows: 1,
    height: 1,
    inlineSize: 1,
    inset: 1,
    insetBlock: 1,
    insetBlockEnd: 1,
    insetBlockStart: 1,
    insetInline: 1,
    insetInlineEnd: 1,
    insetInlineStart: 1,
    left: 1,
    letterSpacing: 1,
    margin: 1,
    marginBlock: 1,
    marginBlockEnd: 1,
    marginBlockStart: 1,
    marginBottom: 1,
    marginInline: 1,
    marginInlineEnd: 1,
    marginInlineStart: 1,
    marginLeft: 1,
    marginRight: 1,
    marginTop: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    offsetDistance: 1,
    offsetRotate: 1,
    outline: 1,
    outlineOffset: 1,
    outlineWidth: 1,
    overflowClipMargin: 1,
    padding: 1,
    paddingBlock: 1,
    paddingBlockEnd: 1,
    paddingBlockStart: 1,
    paddingBottom: 1,
    paddingInline: 1,
    paddingInlineEnd: 1,
    paddingInlineStart: 1,
    paddingLeft: 1,
    paddingRight: 1,
    paddingTop: 1,
    perspective: 1,
    right: 1,
    rowGap: 1,
    scrollMargin: 1,
    scrollMarginBlock: 1,
    scrollMarginBlockEnd: 1,
    scrollMarginBlockStart: 1,
    scrollMarginBottom: 1,
    scrollMarginInline: 1,
    scrollMarginInlineEnd: 1,
    scrollMarginInlineStart: 1,
    scrollMarginLeft: 1,
    scrollMarginRight: 1,
    scrollMarginTop: 1,
    scrollPadding: 1,
    scrollPaddingBlock: 1,
    scrollPaddingBlockEnd: 1,
    scrollPaddingBlockStart: 1,
    scrollPaddingBottom: 1,
    scrollPaddingInline: 1,
    scrollPaddingInlineEnd: 1,
    scrollPaddingInlineStart: 1,
    scrollPaddingLeft: 1,
    scrollPaddingRight: 1,
    scrollPaddingTop: 1,
    shapeMargin: 1,
    textDecoration: 1,
    textDecorationThickness: 1,
    textIndent: 1,
    textUnderlineOffset: 1,
    top: 1,
    transitionDelay: 1,
    transitionDuration: 1,
    verticalAlign: 1,
    width: 1,
    wordSpacing: 1
}, $5ef971420afb2954$var$R = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97)), $5ef971420afb2954$var$z = (e)=>((e)=>{
        let t, r = "";
        for(t = Math.abs(e); t > 52; t = t / 52 | 0)r = $5ef971420afb2954$var$R(t % 52) + r;
        return $5ef971420afb2954$var$R(t % 52) + r;
    })(((e, t)=>{
        let r = t.length;
        for(; r;)e = 33 * e ^ t.charCodeAt(--r);
        return e;
    })(5381, JSON.stringify(e)) >>> 0), $5ef971420afb2954$var$W = [
    "themed",
    "global",
    "styled",
    "onevar",
    "resonevar",
    "allvar",
    "inline"
], $5ef971420afb2954$var$j = (e)=>{
    if (e.href && !e.href.startsWith(location.origin)) return !1;
    try {
        return !!e.cssRules;
    } catch (e) {
        return !1;
    }
}, $5ef971420afb2954$var$E = (e)=>{
    let t;
    const r = ()=>{
        const { cssRules: e } = t.sheet;
        return [].map.call(e, (r, n)=>{
            const { cssText: i } = r;
            let o = "";
            if (i.startsWith("--sxs")) return "";
            if (e[n - 1] && (o = e[n - 1].cssText).startsWith("--sxs")) {
                if (!r.cssRules.length) return "";
                for(const e in t.rules)if (t.rules[e].group === r) return `--sxs{--sxs:${[
                    ...t.rules[e].cache
                ].join(" ")}}${i}`;
                return r.cssRules.length ? `${o}${i}` : "";
            }
            return i;
        }).join("");
    }, n = ()=>{
        if (t) {
            const { rules: e, sheet: r } = t;
            if (!r.deleteRule) {
                for(; 3 === Object(Object(r.cssRules)[0]).type;)r.cssRules.splice(0, 1);
                r.cssRules = [];
            }
            for(const t in e)delete e[t];
        }
        const i = Object(e).styleSheets || [];
        for (const e of i)if ($5ef971420afb2954$var$j(e)) {
            for(let i = 0, o = e.cssRules; o[i]; ++i){
                const l = Object(o[i]);
                if (1 !== l.type) continue;
                const s = Object(o[i + 1]);
                if (4 !== s.type) continue;
                ++i;
                const { cssText: a } = l;
                if (!a.startsWith("--sxs")) continue;
                const c = a.slice(14, -3).trim().split(/\s+/), d = $5ef971420afb2954$var$W[c[0]];
                d && (t || (t = {
                    sheet: e,
                    reset: n,
                    rules: {},
                    toString: r
                }), t.rules[d] = {
                    group: s,
                    index: i,
                    cache: new Set(c)
                });
            }
            if (t) break;
        }
        if (!t) {
            const i = (e, t)=>({
                    type: t,
                    cssRules: [],
                    insertRule (e, t) {
                        this.cssRules.splice(t, 0, i(e, {
                            import: 3,
                            undefined: 1
                        }[(e.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
                    },
                    get cssText () {
                        return "@media{}" === e ? `@media{${[].map.call(this.cssRules, (e)=>e.cssText).join("")}}` : e;
                    }
                });
            t = {
                sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : i("", "text/css"),
                rules: {},
                reset: n,
                toString: r
            };
        }
        const { sheet: o, rules: l } = t;
        for(let e = $5ef971420afb2954$var$W.length - 1; e >= 0; --e){
            const t = $5ef971420afb2954$var$W[e];
            if (!l[t]) {
                const r = $5ef971420afb2954$var$W[e + 1], n = l[r] ? l[r].index : o.cssRules.length;
                o.insertRule("@media{}", n), o.insertRule(`--sxs{--sxs:${e}}`, n), l[t] = {
                    group: o.cssRules[n + 1],
                    index: n,
                    cache: new Set([
                        e
                    ])
                };
            }
            $5ef971420afb2954$var$v(l[t]);
        }
    };
    return n(), t;
}, $5ef971420afb2954$var$v = (e)=>{
    const t = e.group;
    let r = t.cssRules.length;
    e.apply = (e)=>{
        try {
            t.insertRule(e, r), ++r;
        } catch (e) {}
    };
}, $5ef971420afb2954$var$T = Symbol(), $5ef971420afb2954$var$w = $5ef971420afb2954$var$o(), $5ef971420afb2954$var$M = (e, t)=>$5ef971420afb2954$var$w(e, ()=>(...r)=>{
            let n = {
                type: null,
                composers: new Set
            };
            for (const t of r)if (null != t) {
                if (t[$5ef971420afb2954$var$l]) {
                    null == n.type && (n.type = t[$5ef971420afb2954$var$l].type);
                    for (const e of t[$5ef971420afb2954$var$l].composers)n.composers.add(e);
                } else t.constructor !== Object || t.$$typeof ? null == n.type && (n.type = t) : n.composers.add($5ef971420afb2954$var$C(t, e));
            }
            return null == n.type && (n.type = "span"), n.composers.size || n.composers.add([
                "PJLV",
                {},
                [],
                [],
                {},
                []
            ]), $5ef971420afb2954$var$P(e, n, t);
        }), $5ef971420afb2954$var$C = ({ variants: e, compoundVariants: t, defaultVariants: r, ...n }, i)=>{
    const o = `${$5ef971420afb2954$var$S(i.prefix)}c-${$5ef971420afb2954$var$z(n)}`, l = [], s = [], d = Object.create(null), g = [];
    for(const e in r)d[e] = String(r[e]);
    if ("object" == typeof e && e) for(const t in e){
        p = d, u = t, $5ef971420afb2954$var$c.call(p, u) || (d[t] = "undefined");
        const r = e[t];
        for(const e in r){
            const n = {
                [t]: String(e)
            };
            "undefined" === String(e) && g.push(t);
            const i = r[e], o = [
                n,
                i,
                !$5ef971420afb2954$var$a(i)
            ];
            l.push(o);
        }
    }
    var p, u;
    if ("object" == typeof t && t) for (const e of t){
        let { css: t, ...r } = e;
        t = "object" == typeof t && t || {};
        for(const e in r)r[e] = String(r[e]);
        const n = [
            r,
            t,
            !$5ef971420afb2954$var$a(t)
        ];
        s.push(n);
    }
    return [
        o,
        n,
        l,
        s,
        d,
        g
    ];
}, $5ef971420afb2954$var$P = (e, t, r)=>{
    const [n, i, o, a] = $5ef971420afb2954$var$L(t.composers), c = "function" == typeof t.type || t.type.$$typeof ? ((e)=>{
        function t() {
            for(let r = 0; r < t[$5ef971420afb2954$var$T].length; r++){
                const [n, i] = t[$5ef971420afb2954$var$T][r];
                e.rules[n].apply(i);
            }
            return t[$5ef971420afb2954$var$T] = [], null;
        }
        return t[$5ef971420afb2954$var$T] = [], t.rules = {}, $5ef971420afb2954$var$W.forEach((e)=>t.rules[e] = {
                apply: (r)=>t[$5ef971420afb2954$var$T].push([
                        e,
                        r
                    ])
            }), t;
    })(r) : null, d = (c || r).rules, g = `.${n}${i.length > 1 ? `:where(.${i.slice(1).join(".")})` : ""}`, p = (l)=>{
        l = "object" == typeof l && l || $5ef971420afb2954$var$A;
        const { css: s, ...p } = l, u = {};
        for(const e in o)if (delete p[e], e in l) {
            let t = l[e];
            "object" == typeof t && t ? u[e] = {
                "@initial": o[e],
                ...t
            } : (t = String(t), u[e] = "undefined" !== t || a.has(e) ? t : o[e]);
        } else u[e] = o[e];
        const h = new Set([
            ...i
        ]);
        for (const [n, i, o, l] of t.composers){
            r.rules.styled.cache.has(n) || (r.rules.styled.cache.add(n), $5ef971420afb2954$var$$(i, [
                `.${n}`
            ], [], e, (e)=>{
                d.styled.apply(e);
            }));
            const t = $5ef971420afb2954$var$O(o, u, e.media), s = $5ef971420afb2954$var$O(l, u, e.media, !0);
            for (const i of t)if (void 0 !== i) for (const [t, o, l] of i){
                const i = `${n}-${$5ef971420afb2954$var$z(o)}-${t}`;
                h.add(i);
                const s = (l ? r.rules.resonevar : r.rules.onevar).cache, a = l ? d.resonevar : d.onevar;
                s.has(i) || (s.add(i), $5ef971420afb2954$var$$(o, [
                    `.${i}`
                ], [], e, (e)=>{
                    a.apply(e);
                }));
            }
            for (const t of s)if (void 0 !== t) for (const [i, o] of t){
                const t = `${n}-${$5ef971420afb2954$var$z(o)}-${i}`;
                h.add(t), r.rules.allvar.cache.has(t) || (r.rules.allvar.cache.add(t), $5ef971420afb2954$var$$(o, [
                    `.${t}`
                ], [], e, (e)=>{
                    d.allvar.apply(e);
                }));
            }
        }
        if ("object" == typeof s && s) {
            const t = `${n}-i${$5ef971420afb2954$var$z(s)}-css`;
            h.add(t), r.rules.inline.cache.has(t) || (r.rules.inline.cache.add(t), $5ef971420afb2954$var$$(s, [
                `.${t}`
            ], [], e, (e)=>{
                d.inline.apply(e);
            }));
        }
        for (const e of String(l.className || "").trim().split(/\s+/))e && h.add(e);
        const f = p.className = [
            ...h
        ].join(" ");
        return {
            type: t.type,
            className: f,
            selector: g,
            props: p,
            toString: ()=>f,
            deferredInjector: c
        };
    };
    return $5ef971420afb2954$var$s(p, {
        className: n,
        selector: g,
        [$5ef971420afb2954$var$l]: t,
        toString: ()=>(r.rules.styled.cache.has(n) || p(), n)
    });
}, $5ef971420afb2954$var$L = (e)=>{
    let t = "";
    const r = [], n = {}, i = [];
    for (const [o, , , , l, s] of e){
        "" === t && (t = o), r.push(o), i.push(...s);
        for(const e in l){
            const t = l[e];
            (void 0 === n[e] || "undefined" !== t || s.includes(t)) && (n[e] = t);
        }
    }
    return [
        t,
        r,
        n,
        new Set(i)
    ];
}, $5ef971420afb2954$var$O = (e, t, r, n)=>{
    const i = [];
    e: for (let [o, l, s] of e){
        if (s) continue;
        let e, a = 0, c = !1;
        for(e in o){
            const n = o[e];
            let i = t[e];
            if (i !== n) {
                if ("object" != typeof i || !i) continue e;
                {
                    let e, t, o = 0;
                    for(const l in i){
                        if (n === String(i[l])) {
                            if ("@initial" !== l) {
                                const e = l.slice(1);
                                (t = t || []).push(e in r ? r[e] : l.replace(/^@media ?/, "")), c = !0;
                            }
                            a += o, e = !0;
                        }
                        ++o;
                    }
                    if (t && t.length && (l = {
                        ["@media " + t.join(", ")]: l
                    }), !e) continue e;
                }
            }
        }
        (i[a] = i[a] || []).push([
            n ? "cv" : `${e}-${o[e]}`,
            l,
            c
        ]);
    }
    return i;
}, $5ef971420afb2954$var$A = {}, $5ef971420afb2954$var$N = $5ef971420afb2954$var$o(), $5ef971420afb2954$var$D = (e, t)=>$5ef971420afb2954$var$N(e, ()=>(...r)=>{
            const n = ()=>{
                for (let n of r){
                    n = "object" == typeof n && n || {};
                    let r = $5ef971420afb2954$var$z(n);
                    if (!t.rules.global.cache.has(r)) {
                        if (t.rules.global.cache.add(r), "@import" in n) {
                            let e = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
                            for (let r of [].concat(n["@import"]))r = r.includes('"') || r.includes("'") ? r : `"${r}"`, t.sheet.insertRule(`@import ${r};`, e++);
                            delete n["@import"];
                        }
                        $5ef971420afb2954$var$$(n, [], [], e, (e)=>{
                            t.rules.global.apply(e);
                        });
                    }
                }
                return "";
            };
            return $5ef971420afb2954$var$s(n, {
                toString: n
            });
        }), $5ef971420afb2954$var$H = $5ef971420afb2954$var$o(), $5ef971420afb2954$var$V = (e, t)=>$5ef971420afb2954$var$H(e, ()=>(r)=>{
            const n = `${$5ef971420afb2954$var$S(e.prefix)}k-${$5ef971420afb2954$var$z(r)}`, i = ()=>{
                if (!t.rules.global.cache.has(n)) {
                    t.rules.global.cache.add(n);
                    const i = [];
                    $5ef971420afb2954$var$$(r, [], [], e, (e)=>i.push(e));
                    const o = `@keyframes ${n}{${i.join("")}}`;
                    t.rules.global.apply(o);
                }
                return n;
            };
            return $5ef971420afb2954$var$s(i, {
                get name () {
                    return i();
                },
                toString: i
            });
        }), $5ef971420afb2954$var$G = class {
    constructor(e, t, r, n){
        this.token = null == e ? "" : String(e), this.value = null == t ? "" : String(t), this.scale = null == r ? "" : String(r), this.prefix = null == n ? "" : String(n);
    }
    get computedValue() {
        return "var(" + this.variable + ")";
    }
    get variable() {
        return "--" + $5ef971420afb2954$var$S(this.prefix) + $5ef971420afb2954$var$S(this.scale) + this.token;
    }
    toString() {
        return this.computedValue;
    }
}, $5ef971420afb2954$var$F = $5ef971420afb2954$var$o(), $5ef971420afb2954$var$J = (e, t)=>$5ef971420afb2954$var$F(e, ()=>(r, n)=>{
            n = "object" == typeof r && r || Object(n);
            const i = `.${r = (r = "string" == typeof r ? r : "") || `${$5ef971420afb2954$var$S(e.prefix)}t-${$5ef971420afb2954$var$z(n)}`}`, o = {}, l = [];
            for(const t in n){
                o[t] = {};
                for(const r in n[t]){
                    const i = `--${$5ef971420afb2954$var$S(e.prefix)}${t}-${r}`, s = $5ef971420afb2954$var$k(String(n[t][r]), e.prefix, t);
                    o[t][r] = new $5ef971420afb2954$var$G(r, s, t, e.prefix), l.push(`${i}:${s}`);
                }
            }
            const s = ()=>{
                if (l.length && !t.rules.themed.cache.has(r)) {
                    t.rules.themed.cache.add(r);
                    const i = `${n === e.theme ? ":root," : ""}.${r}{${l.join(";")}}`;
                    t.rules.themed.apply(i);
                }
                return r;
            };
            return {
                ...o,
                get className () {
                    return s();
                },
                selector: i,
                toString: s
            };
        }), $5ef971420afb2954$var$U = $5ef971420afb2954$var$o();
var $5ef971420afb2954$var$X, $5ef971420afb2954$var$Y = $5ef971420afb2954$var$o(), $5ef971420afb2954$export$3c6706659c99b84e = (e)=>{
    const t = ((e)=>{
        let t = !1;
        const r = $5ef971420afb2954$var$U(e, (e)=>{
            t = !0;
            const r = "prefix" in (e = "object" == typeof e && e || {}) ? String(e.prefix) : "", i = "object" == typeof e.media && e.media || {}, o = "object" == typeof e.root ? e.root || null : globalThis.document || null, l = "object" == typeof e.theme && e.theme || {}, s = {
                prefix: r,
                media: i,
                theme: l,
                themeMap: "object" == typeof e.themeMap && e.themeMap || {
                    ...$5ef971420afb2954$export$22deaee80f3d7c38
                },
                utils: "object" == typeof e.utils && e.utils || {}
            }, a = $5ef971420afb2954$var$E(o), c = {
                css: $5ef971420afb2954$var$M(s, a),
                globalCss: $5ef971420afb2954$var$D(s, a),
                keyframes: $5ef971420afb2954$var$V(s, a),
                createTheme: $5ef971420afb2954$var$J(s, a),
                reset () {
                    a.reset(), c.theme.toString();
                },
                theme: {},
                sheet: a,
                config: s,
                prefix: r,
                getCssText: a.toString,
                toString: a.toString
            };
            return String(c.theme = c.createTheme(l)), c;
        });
        return t || r.reset(), r;
    })(e);
    return t.styled = (({ config: e, sheet: t })=>$5ef971420afb2954$var$Y(e, ()=>{
            const r = $5ef971420afb2954$var$M(e, t);
            return (...e)=>{
                const t = r(...e), n = t[$5ef971420afb2954$var$l].type, i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((e, r)=>{
                    const i = e && e.as || n, { props: o, deferredInjector: l } = t(e);
                    return delete o.as, o.ref = r, l ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(i, o), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(l, null)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(i, o);
                });
                return i.className = t.className, i.displayName = `Styled.${n.displayName || n.name || n}`, i.selector = t.selector, i.toString = ()=>t.selector, i[$5ef971420afb2954$var$l] = t[$5ef971420afb2954$var$l], i;
            };
        }))(t), t;
}, $5ef971420afb2954$var$K = ()=>$5ef971420afb2954$var$X || ($5ef971420afb2954$var$X = $5ef971420afb2954$export$3c6706659c99b84e()), $5ef971420afb2954$export$25d302a5b900a763 = (...e)=>$5ef971420afb2954$var$K().createTheme(...e), $5ef971420afb2954$export$db53682eef82cc11 = (...e)=>$5ef971420afb2954$var$K().globalCss(...e), $5ef971420afb2954$export$d25ddfdf17c3ad3e = (...e)=>$5ef971420afb2954$var$K().keyframes(...e), $5ef971420afb2954$export$dbf350e5966cf602 = (...e)=>$5ef971420afb2954$var$K().css(...e), $5ef971420afb2954$export$3817b7a54a07cec7 = (...e)=>$5ef971420afb2954$var$K().styled(...e);
 //# sourceMappingUrl=index.map



const $860c7657b9fd8b12$export$e4f2515e2619004e = {
    fonts: {
        sans: "-apple-system, BlinkMacSystemFont, 'Segoe UI','Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans','Helvetica Neue', sans-serif;",
        mono: "Menlo, Monaco, 'Lucida Console', 'Liberation Mono', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono','Courier New', monospace;"
    },
    fontSizes: {
        xs: "0.75rem",
        sm: "0.875rem",
        base: "1rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        xl2: "1.5rem",
        xl3: "1.875rem",
        xl4: "2.25rem",
        xl5: "3rem",
        xl6: "3.75rem",
        xl7: "4.5rem",
        xl8: "6rem",
        xl9: "8rem"
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900
    },
    lineHeights: {
        xs: 1,
        sm: 1.25,
        base: 1.5,
        md: 1.5,
        lg: 1.75,
        xl: 1.75,
        xl2: 2,
        xl3: 2.25,
        xl4: 2.5,
        xl5: 1,
        xl6: 1,
        xl7: 1,
        xl8: 1,
        xl9: 1
    },
    letterSpacings: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
    },
    space: {
        0: "0rem",
        xs: "0.5rem",
        sm: "0.75rem",
        md: "1rem",
        lg: "1.25rem",
        xl: "2.25rem",
        px: "1px",
        1: "0.125rem",
        2: "0.25rem",
        3: "0.375rem",
        4: "0.5rem",
        5: "0.625rem",
        6: "0.75rem",
        7: "0.875rem",
        8: "1rem",
        9: "1.25rem",
        10: "1.5rem",
        11: "1.75rem",
        12: "2rem",
        13: "2.25rem",
        14: "2.5rem",
        15: "2.75rem",
        16: "3rem",
        17: "3.5rem",
        18: "4rem",
        20: "5rem",
        24: "6rem",
        28: "7rem",
        32: "8rem",
        36: "9rem",
        40: "10rem",
        44: "11rem",
        48: "12rem",
        52: "13rem",
        56: "14rem",
        60: "15rem",
        64: "16rem",
        72: "18rem",
        80: "20rem",
        96: "24rem"
    },
    radii: {
        xs: "7px",
        sm: "9px",
        md: "12px",
        base: "14px",
        lg: "14px",
        xl: "18px",
        squared: "33%",
        rounded: "50%",
        pill: "9999px"
    },
    zIndices: {
        1: "100",
        2: "200",
        3: "300",
        4: "400",
        5: "500",
        10: "1000",
        max: "9999"
    },
    borderWeights: {
        light: "1px",
        normal: "2px",
        bold: "3px",
        extrabold: "4px",
        black: "5px"
    },
    transitions: {
        default: "all 250ms ease",
        button: "background 0.25s ease 0s, color 0.25s ease 0s, border-color 0.25s ease 0s, box-shadow 0.25s ease 0s, transform 0.25s ease 0s, opacity 0.25s ease 0s",
        avatar: "box-shadow 0.25s ease 0s, opacity 0.25s ease 0s",
        link: "opacity 0.25s ease 0s, background 0.25s ease 0s",
        card: "transform 0.25s ease 0s, filter 0.25s ease 0s, box-shadow 0.25s ease 0s",
        dropdownItem: "background 0.25s ease, transform 0.25s ease, color 0.15s ease, box-shadow 0.25s ease 0s"
    },
    breakpoints: {
        xs: "650px",
        sm: "960px",
        md: "1280px",
        lg: "1400px",
        xl: "1920px"
    }
};
const $860c7657b9fd8b12$export$f1dd60f4a4247eae = {
    white: "#ffffff",
    black: "#000000",
    primaryLight: "$blue200",
    primaryLightHover: "$blue300",
    primaryLightActive: "$blue400",
    primaryLightContrast: "$blue600",
    primary: "$blue600",
    primaryBorder: "$blue500",
    primaryBorderHover: "$blue600",
    primarySolidHover: "$blue700",
    primarySolidContrast: "$white",
    primaryShadow: "$blue500",
    secondaryLight: "$purple200",
    secondaryLightHover: "$purple300",
    secondaryLightActive: "$purple400",
    secondaryLightContrast: "$purple600",
    secondary: "$purple600",
    secondaryBorder: "$purple500",
    secondaryBorderHover: "$purple600",
    secondarySolidHover: "$purple700",
    secondarySolidContrast: "$white",
    secondaryShadow: "$purple500",
    successLight: "$green200",
    successLightHover: "$green300",
    successLightActive: "$green400",
    successLightContrast: "$green700",
    success: "$green600",
    successBorder: "$green500",
    successBorderHover: "$green600",
    successSolidHover: "$green700",
    successSolidContrast: "$white",
    successShadow: "$green500",
    warningLight: "$yellow200",
    warningLightHover: "$yellow300",
    warningLightActive: "$yellow400",
    warningLightContrast: "$yellow700",
    warning: "$yellow600",
    warningBorder: "$yellow500",
    warningBorderHover: "$yellow600",
    warningSolidHover: "$yellow700",
    warningSolidContrast: "$white",
    warningShadow: "$yellow500",
    errorLight: "$red200",
    errorLightHover: "$red300",
    errorLightActive: "$red400",
    errorLightContrast: "$red600",
    error: "$red600",
    errorBorder: "$red500",
    errorBorderHover: "$red600",
    errorSolidHover: "$red700",
    errorSolidContrast: "$white",
    errorShadow: "$red500",
    neutralLight: "$gray100",
    neutralLightHover: "$gray200",
    neutralLightActive: "$gray300",
    neutralLightContrast: "$gray800",
    neutral: "$gray600",
    neutralBorder: "$gray400",
    neutralBorderHover: "$gray500",
    neutralSolidHover: "$gray600",
    neutralSolidContrast: "$white",
    neutralShadow: "$gray400",
    gradient: "linear-gradient(112deg, $cyan600 -63.59%, $pink600 -20.3%, $blue600 70.46%)",
    accents0: "$gray50",
    accents1: "$gray100",
    accents2: "$gray200",
    accents3: "$gray300",
    accents4: "$gray400",
    accents5: "$gray500",
    accents6: "$gray600",
    accents7: "$gray700",
    accents8: "$gray800",
    accents9: "$gray900",
    border: "$gray300"
};
const $860c7657b9fd8b12$export$70cf733c9021843f = {
    xs: `(min-width: ${$860c7657b9fd8b12$export$e4f2515e2619004e.breakpoints.xs})`,
    sm: `(min-width: ${$860c7657b9fd8b12$export$e4f2515e2619004e.breakpoints.sm})`,
    md: `(min-width: ${$860c7657b9fd8b12$export$e4f2515e2619004e.breakpoints.md})`,
    lg: `(min-width: ${$860c7657b9fd8b12$export$e4f2515e2619004e.breakpoints.lg})`,
    xl: `(min-width: ${$860c7657b9fd8b12$export$e4f2515e2619004e.breakpoints.xl})`,
    xsMax: `(max-width: ${$860c7657b9fd8b12$export$e4f2515e2619004e.breakpoints.xs})`,
    smMax: `(max-width: ${$860c7657b9fd8b12$export$e4f2515e2619004e.breakpoints.sm})`,
    mdMax: `(max-width: ${$860c7657b9fd8b12$export$e4f2515e2619004e.breakpoints.md})`,
    lgMax: `(max-width: ${$860c7657b9fd8b12$export$e4f2515e2619004e.breakpoints.lg})`,
    xlMax: `(max-width: ${$860c7657b9fd8b12$export$e4f2515e2619004e.breakpoints.xl})`,
    motion: "(prefers-reduced-motion: reduce)",
    safari: "not all and (min-resolution:.001dpcm)",
    hover: "(any-hover: hover)",
    dark: "(prefers-color-scheme: dark)",
    light: "(prefers-color-scheme: light)"
};
const $860c7657b9fd8b12$export$f03847efb1ba2adf = {
    p: (e)=>({
            padding: e
        }),
    pt: (e)=>({
            paddingTop: e
        }),
    pr: (e)=>({
            paddingRight: e
        }),
    pb: (e)=>({
            paddingBottom: e
        }),
    pl: (e)=>({
            paddingLeft: e
        }),
    px: (e)=>({
            paddingLeft: e,
            paddingRight: e
        }),
    py: (e)=>({
            paddingTop: e,
            paddingBottom: e
        }),
    m: (e)=>({
            margin: e
        }),
    mt: (e)=>({
            marginTop: e
        }),
    mr: (e)=>({
            marginRight: e
        }),
    mb: (e)=>({
            marginBottom: e
        }),
    ml: (e)=>({
            marginLeft: e
        }),
    mx: (e)=>({
            marginLeft: e,
            marginRight: e
        }),
    my: (e)=>({
            marginTop: e,
            marginBottom: e
        }),
    ta: (e)=>({
            textAlign: e
        }),
    tt: (e)=>({
            textTransform: e
        }),
    to: (e)=>({
            textOverflow: e
        }),
    d: (e)=>({
            display: e
        }),
    dflex: (e)=>({
            display: "flex",
            alignItems: e,
            justifyContent: e
        }),
    fd: (e)=>({
            flexDirection: e
        }),
    fw: (e)=>({
            flexWrap: e
        }),
    ai: (e)=>({
            alignItems: e
        }),
    ac: (e)=>({
            alignContent: e
        }),
    jc: (e)=>({
            justifyContent: e
        }),
    as: (e)=>({
            alignSelf: e
        }),
    fg: (e)=>({
            flexGrow: e
        }),
    fs: (e)=>({
            fontSize: e
        }),
    fb: (e)=>({
            flexBasis: e
        }),
    bc: (e)=>({
            backgroundColor: e
        }),
    bf: (e)=>({
            backdropFilter: e
        }),
    bg: (e)=>({
            background: e
        }),
    bgBlur: (e)=>({
            bf: "saturate(180%) blur(10px)",
            bg: e
        }),
    bgColor: (e)=>({
            backgroundColor: e
        }),
    backgroundClip: (e)=>({
            WebkitBackgroundClip: e,
            backgroundClip: e
        }),
    bgClip: (e)=>({
            WebkitBackgroundClip: e,
            backgroundClip: e
        }),
    br: (e)=>({
            borderRadius: e
        }),
    bw: (e)=>({
            borderWidth: e
        }),
    btrr: (e)=>({
            borderTopRightRadius: e
        }),
    bbrr: (e)=>({
            borderBottomRightRadius: e
        }),
    bblr: (e)=>({
            borderBottomLeftRadius: e
        }),
    btlr: (e)=>({
            borderTopLeftRadius: e
        }),
    bs: (e)=>({
            boxShadow: e
        }),
    ds: (e)=>({
            dropShadow: e
        }),
    shadow: (e)=>({
            boxShadow: e
        }),
    dshadow: (e)=>({
            dropShadow: e
        }),
    dropShadow: (e)=>({
            filter: `$dropShadows${e}`
        }),
    normalShadow: (e)=>({
            boxShadow: `0 4px 14px 0 $colors${e}`
        }),
    normalShadowVar: (e)=>({
            boxShadow: `0 4px 14px 0 ${e}`
        }),
    lh: (e)=>({
            lineHeight: e
        }),
    ov: (e)=>({
            overflow: e
        }),
    ox: (e)=>({
            overflowX: e
        }),
    oy: (e)=>({
            overflowY: e
        }),
    pe: (e)=>({
            pointerEvents: e
        }),
    events: (e)=>({
            pointerEvents: e
        }),
    us: (e)=>({
            WebkitUserSelect: e,
            userSelect: e
        }),
    userSelect: (e)=>({
            WebkitUserSelect: e,
            userSelect: e
        }),
    w: (e)=>({
            width: e
        }),
    h: (e)=>({
            height: e
        }),
    mw: (e)=>({
            maxWidth: e
        }),
    maxW: (e)=>({
            maxWidth: e
        }),
    mh: (e)=>({
            maxHeight: e
        }),
    maxH: (e)=>({
            maxHeight: e
        }),
    size: (e)=>({
            width: e,
            height: e
        }),
    minSize: (e)=>({
            minWidth: e,
            minHeight: e,
            width: e,
            height: e
        }),
    sizeMin: (e)=>({
            minWidth: e,
            minHeight: e,
            width: e,
            height: e
        }),
    maxSize: (e)=>({
            maxWidth: e,
            maxHeight: e
        }),
    sizeMax: (e)=>({
            maxWidth: e,
            maxHeight: e
        }),
    appearance: (e)=>({
            WebkitAppearance: e,
            appearance: e
        }),
    scale: (e)=>({
            transform: `scale(${e})`
        }),
    linearGradient: (e)=>({
            backgroundImage: `linear-gradient(${e})`
        }),
    tdl: (e)=>({
            textDecorationLine: e
        }),
    truncateText: (e)=>({
            maxWidth: e,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }),
    textGradient: (e)=>({
            backgroundImage: `linear-gradient(${e})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            "&::selection": {
                WebkitTextFillColor: "$colors$text"
            }
        })
};
const $860c7657b9fd8b12$export$22deaee80f3d7c38 = {
    ...(0, $5ef971420afb2954$export$22deaee80f3d7c38),
    width: "space",
    height: "space",
    minWidth: "space",
    maxWidth: "space",
    minHeight: "space",
    maxHeight: "space",
    flexBasis: "space",
    gridTemplateColumns: "space",
    gridTemplateRows: "space",
    blockSize: "space",
    minBlockSize: "space",
    maxBlockSize: "space",
    inlineSize: "space",
    minInlineSize: "space",
    maxInlineSize: "space",
    borderWidth: "borderWeights"
};
var $860c7657b9fd8b12$export$2e2bcd8739ae039 = {
    prefix: "nextui",
    theme: {
        ...$860c7657b9fd8b12$export$e4f2515e2619004e,
        colors: $860c7657b9fd8b12$export$f1dd60f4a4247eae,
        shadows: {},
        dropShadows: {}
    },
    media: $860c7657b9fd8b12$export$70cf733c9021843f,
    utils: $860c7657b9fd8b12$export$f03847efb1ba2adf,
    themeMap: $860c7657b9fd8b12$export$22deaee80f3d7c38
};


const $93b0fa2efc35027b$export$2aa0182783e7e9de = {
    blue50: "#EDF5FF",
    blue100: "#E1EFFF",
    blue200: "#CEE4FE",
    blue300: "#B7D5F8",
    blue400: "#96C1F2",
    blue500: "#5EA2EF",
    blue600: "#0072F5",
    blue700: "#005FCC",
    blue800: "#004799",
    blue900: "#00254D"
};
const $93b0fa2efc35027b$export$10e0fd027e632624 = {
    blue50: "#10253E",
    blue100: "#102C4C",
    blue200: "#0F3158",
    blue300: "#0D3868",
    blue400: "#0A4281",
    blue500: "#0952A5",
    blue600: "#0072F5",
    blue700: "#3694FF",
    blue800: "#3694FF",
    blue900: "#EAF4FF"
};

const $143d2ab923f8a615$export$7474046f446842ee = {
    cyan50: "#F0FCFF",
    cyan100: "#E6FAFE",
    cyan200: "#D7F8FE",
    cyan300: "#C3F4FD",
    cyan400: "#A5EEFD",
    cyan500: "#7EE7FC",
    cyan600: "#06B7DB",
    cyan700: "#09AACD",
    cyan800: "#0E8AAA",
    cyan900: "#053B48"
};
const $143d2ab923f8a615$export$dee6c7c6683c0d88 = {
    cyan50: "#012A32",
    cyan100: "#023A46",
    cyan200: "#024B5A",
    cyan300: "#036072",
    cyan400: "#037086",
    cyan500: "#048EA9",
    cyan600: "#06B7DB",
    cyan700: "#33D9FA",
    cyan800: "#6FE4FB",
    cyan900: "#EBFBFE"
};

const $6d871cbc41d5f19f$export$3e2c219d3ab79d01 = {
    gray50: "#F1F3F5",
    gray100: "#ECEEF0",
    gray200: "#E6E8EB",
    gray300: "#DFE3E6",
    gray400: "#D7DBDF",
    gray500: "#C1C8CD",
    gray600: "#889096",
    gray700: "#7E868C",
    gray800: "#687076",
    gray900: "#11181C"
};
const $6d871cbc41d5f19f$export$eea3c7b476ea2b4b = {
    gray50: "#16181A",
    gray100: "#26292B",
    gray200: "#2B2F31",
    gray300: "#313538",
    gray400: "#3A3F42",
    gray500: "#4C5155",
    gray600: "#697177",
    gray700: "#787F85",
    gray800: "#9BA1A6",
    gray900: "#ECEDEE"
};

const $29b011df9bc4f09d$export$955a2ebd2fb142ae = {
    green50: "#F1FDF7",
    green100: "#E8FCF1",
    green200: "#DAFBE8",
    green300: "#C8F9DD",
    green400: "#ADF5CC",
    green500: "#88F1B6",
    green600: "#17C964",
    green700: "#13A452",
    green800: "#108944",
    green900: "#06371B"
};
const $29b011df9bc4f09d$export$76a3d804058f9b5f = {
    green50: "#042F14",
    green100: "#06381B",
    green200: "#074A24",
    green300: "#0A6130",
    green400: "#0B7439",
    green500: "#0F9549",
    green600: "#17C964",
    green700: "#41EC8B",
    green800: "#78F2AD",
    green900: "#ECFDF4"
};

const $66682f451e0dd7b9$export$47853bc718611763 = {
    pink50: "#FFF0FB",
    pink100: "#FFE5F8",
    pink200: "#FFD6F3",
    pink300: "#FFC2EE",
    pink400: "#FFA3E5",
    pink500: "#FF7AD9",
    pink600: "#FF4ECD",
    pink700: "#D6009A",
    pink800: "#B80084",
    pink900: "#4D0037"
};
const $66682f451e0dd7b9$export$aaf76fd0048ee42e = {
    pink50: "#330025",
    pink100: "#470033",
    pink200: "#5C0042",
    pink300: "#750054",
    pink400: "#8A0063",
    pink500: "#AD007C",
    pink600: "#FF4ECD",
    pink700: "#FF2EC4",
    pink800: "#FF6BD5",
    pink900: "#FFEBF9"
};

const $f5ffb332adde5fe2$export$e13cce2a2d16a9d4 = {
    purple50: "#F7F2FD",
    purple100: "#F1E8FB",
    purple200: "#EADCF8",
    purple300: "#E0CBF5",
    purple400: "#D1B1F0",
    purple500: "#BC8EE9",
    purple600: "#7828C8",
    purple700: "#6622AA",
    purple800: "#4D1980",
    purple900: "#290E44"
};
const $f5ffb332adde5fe2$export$7a65e68792738764 = {
    purple50: "#1F0A33",
    purple100: "#240C3C",
    purple200: "#2E0F4D",
    purple300: "#3B1362",
    purple400: "#451773",
    purple500: "#571D91",
    purple600: "#7828C8",
    purple700: "#9750DD",
    purple800: "#B583E7",
    purple900: "#F7ECFC"
};

const $9bd2d876f946e3e2$export$a90204d1394caf30 = {
    red50: "#FEF0F5",
    red100: "#FEE7EF",
    red200: "#FDD8E5",
    red300: "#FCC5D8",
    red400: "#FAA8C5",
    red500: "#F881AB",
    red600: "#F31260",
    red700: "#B80A47",
    red800: "#910838",
    red900: "#4E041E"
};
const $9bd2d876f946e3e2$export$e984d34fc144caa1 = {
    red50: "#300313",
    red100: "#300313",
    red200: "#44041A",
    red300: "#5C0523",
    red400: "#6F062B",
    red500: "#910838",
    red600: "#F31260",
    red700: "#F4256D",
    red800: "#F75F94",
    red900: "#FDD8E5"
};

const $9f65fbdff7f0c5e3$export$594c5a8758200c32 = {
    yellow50: "#FEF9F0",
    yellow100: "#FEF5E7",
    yellow200: "#FDEFD8",
    yellow300: "#FCE7C5",
    yellow400: "#FBDBA7",
    yellow500: "#F9CB80",
    yellow600: "#F5A524",
    yellow700: "#B97509",
    yellow800: "#925D07",
    yellow900: "#4E3104"
};
const $9f65fbdff7f0c5e3$export$67d203119f0ecec = {
    yellow50: "#3A2503",
    yellow100: "#442B03",
    yellow200: "#583804",
    yellow300: "#704705",
    yellow400: "#845306",
    yellow500: "#A66908",
    yellow600: "#F5A524",
    yellow700: "#F6AD37",
    yellow800: "#F8C572",
    yellow900: "#FEF7EC"
};


var $727c2f7d9b6ced2b$export$2e2bcd8739ae039 = {
    colors: {
        background: "$white",
        foreground: "$black",
        backgroundContrast: "$white",
        ...(0, $93b0fa2efc35027b$export$2aa0182783e7e9de),
        ...(0, $f5ffb332adde5fe2$export$e13cce2a2d16a9d4),
        ...(0, $29b011df9bc4f09d$export$955a2ebd2fb142ae),
        ...(0, $9f65fbdff7f0c5e3$export$594c5a8758200c32),
        ...(0, $9bd2d876f946e3e2$export$a90204d1394caf30),
        ...(0, $143d2ab923f8a615$export$7474046f446842ee),
        ...(0, $66682f451e0dd7b9$export$47853bc718611763),
        ...(0, $6d871cbc41d5f19f$export$3e2c219d3ab79d01),
        text: "$gray900",
        link: "$blue600",
        codeLight: "$pink100",
        code: "$pink600",
        selection: "$blue200"
    },
    shadows: {
        xs: "0 2px 8px 1px rgb(104 112 118 / 0.07), 0 1px 1px -1px rgb(104 112 118 / 0.04)",
        sm: "0 2px 8px 2px rgb(104 112 118 / 0.07), 0 2px 4px -1px rgb(104 112 118 / 0.04)",
        md: "0 12px 20px 6px rgb(104 112 118 / 0.08)",
        lg: "0 12px 34px 6px rgb(104 112 118 / 0.18)",
        xl: "0 25px 65px 0px rgb(104 112 118 / 0.35)"
    },
    dropShadows: {
        xs: "drop-shadow(0 2px 4px rgb(104 112 118 / 0.07)) drop-shadow(0 1px 1px rgb(104 112 118 / 0.04))",
        sm: "drop-shadow(0 2px 8px rgb(104 112 118 / 0.07)) drop-shadow(0 2px 4px rgb(104 112 118 / 0.04))",
        md: "drop-shadow(0 4px 12px rgb(104 112 118 / 0.08)) drop-shadow(0 20px 8px rgb(104 112 118 / 0.04))",
        lg: "drop-shadow(0 12px 24px rgb(104 112 118 / 0.15)) drop-shadow(0 12px 14px rgb(104 112 118 / 0.1))",
        xl: "drop-shadow(0 25px 34px rgb(104 112 118 / 0.35))"
    }
};



var $4e09aabc1d82dfbd$export$2e2bcd8739ae039 = {
    colors: {
        background: "$black",
        foreground: "$white",
        backgroundContrast: "$accents0",
        ...(0, $93b0fa2efc35027b$export$10e0fd027e632624),
        ...(0, $f5ffb332adde5fe2$export$7a65e68792738764),
        ...(0, $29b011df9bc4f09d$export$76a3d804058f9b5f),
        ...(0, $9f65fbdff7f0c5e3$export$67d203119f0ecec),
        ...(0, $9bd2d876f946e3e2$export$e984d34fc144caa1),
        ...(0, $143d2ab923f8a615$export$dee6c7c6683c0d88),
        ...(0, $66682f451e0dd7b9$export$aaf76fd0048ee42e),
        ...(0, $6d871cbc41d5f19f$export$eea3c7b476ea2b4b),
        primaryLight: "$blue50",
        primaryLightHover: "$blue100",
        primaryLightActive: "$blue200",
        primaryLightContrast: "$blue600",
        secondaryLight: "$purple50",
        secondaryLightHover: "$purple100",
        secondaryLightActive: "$purple200",
        secondaryLightContrast: "$purple800",
        secondary: "$purple700",
        secondaryBorder: "$purple500",
        secondaryBorderHover: "$purple600",
        secondarySolidHover: "$purple700",
        secondaryShadow: "$purple500",
        successLight: "$green50",
        successLightHover: "$green100",
        successLightActive: "$green200",
        warningLight: "$yellow50",
        warningLightHover: "$yellow100",
        warningLightActive: "$yellow200",
        errorLight: "$red50",
        errorLightHover: "$red100",
        errorLightActive: "$red200",
        errorLightContrast: "$red700",
        neutralLight: "$gray200",
        neutralLightHover: "$gray300",
        neutralLightActive: "$gray400",
        neutralSolidContrast: "$white",
        text: "$gray900",
        link: "$blue700",
        codeLight: "$cyan50",
        code: "$cyan600",
        selection: "$pink800"
    },
    shadows: {
        xs: "0 2px 8px 1px rgb(0 0 0 / 0.07), 0 1px 1px -1px rgb(0 0 0 / 0.04)",
        sm: "0 2px 8px 2px rgb(0 0 0 / 0.07), 0 2px 4px -1px rgb(0 0 0 / 0.04)",
        md: "0 12px 20px 6px rgb(0 0 0 / 0.08)",
        lg: "0 12px 34px 6px rgb(0 0 0 / 0.18)",
        xl: "0 25px 65px 0px rgb(0 0 0 / 0.35)"
    },
    dropShadows: {
        xs: "drop-shadow(0 2px 4px rgb(0 0 0 / 0.07)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.04))",
        sm: "drop-shadow(0 2px 8px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 4px rgb(0 0 0 / 0.04))",
        md: "drop-shadow(0 4px 12px rgb(0 0 0 / 0.08)) drop-shadow(0 20px 8px rgb(0 0 0 / 0.04))",
        lg: "drop-shadow(0 12px 24px rgb(0 0 0 / 0.15)) drop-shadow(0 12px 14px rgb(0 0 0 / 0.1))",
        xl: "drop-shadow(0 25px 34px rgb(0 0 0 / 0.35))"
    }
};


function $ee20efb1fcb0e764$export$2e2bcd8739ae039(o) {
    for(var r, e, l = Array.prototype.slice.call(arguments, 1); l.length;)for(e in r = l.shift())r.hasOwnProperty(e) && ("object" == typeof o[e] && o[e] && "[object Array]" !== Object.prototype.toString.call(o[e]) && "object" == typeof r[e] && null !== r[e] ? o[e] = $ee20efb1fcb0e764$export$2e2bcd8739ae039({}, o[e], r[e]) : o[e] = r[e]);
    return o;
}


const $07d095cbefc9a288$export$e8ce4a3f0fe3345c = (e)=>(0, $ee20efb1fcb0e764$export$2e2bcd8739ae039)(e, (0, $860c7657b9fd8b12$export$2e2bcd8739ae039).theme);
const $07d095cbefc9a288$var$m = (0, $5ef971420afb2954$export$3c6706659c99b84e)({
    ...(0, $860c7657b9fd8b12$export$2e2bcd8739ae039),
    theme: {
        ...(0, $860c7657b9fd8b12$export$2e2bcd8739ae039).theme,
        shadows: {
            ...(0, $727c2f7d9b6ced2b$export$2e2bcd8739ae039).shadows
        },
        dropShadows: {
            ...(0, $727c2f7d9b6ced2b$export$2e2bcd8739ae039).dropShadows
        },
        colors: {
            ...(0, $860c7657b9fd8b12$export$2e2bcd8739ae039).theme.colors,
            ...(0, $727c2f7d9b6ced2b$export$2e2bcd8739ae039).colors
        }
    }
});
const $07d095cbefc9a288$export$abd0d7aa8467faf6 = $07d095cbefc9a288$var$m.createTheme;
const $07d095cbefc9a288$export$3817b7a54a07cec7 = $07d095cbefc9a288$var$m.styled;
const $07d095cbefc9a288$export$dbf350e5966cf602 = $07d095cbefc9a288$var$m.css;
const $07d095cbefc9a288$export$db53682eef82cc11 = $07d095cbefc9a288$var$m.globalCss;
const $07d095cbefc9a288$export$d25ddfdf17c3ad3e = $07d095cbefc9a288$var$m.keyframes;
const $07d095cbefc9a288$export$681e449128971c74 = $07d095cbefc9a288$var$m.getCssText;
const $07d095cbefc9a288$export$bca14c5b3b88a9c9 = $07d095cbefc9a288$var$m.theme;
const $07d095cbefc9a288$export$e506a1d27d1eaa20 = $07d095cbefc9a288$var$m.config;
const $07d095cbefc9a288$export$25d302a5b900a763 = ({ type: e, theme: t, className: m })=>{
    if (!e) throw new Error("Theme type is required");
    return $07d095cbefc9a288$export$abd0d7aa8467faf6(m || `${e}-theme`, (0, $ee20efb1fcb0e764$export$2e2bcd8739ae039)("dark" === e ? (0, $4e09aabc1d82dfbd$export$2e2bcd8739ae039) : (0, $727c2f7d9b6ced2b$export$2e2bcd8739ae039), t));
};



const $ad6c436e0f974ff5$var$n = (0, $07d095cbefc9a288$export$db53682eef82cc11)({
    "*, *:before, *:after": {
        boxSizing: "border-box",
        textRendering: "geometricPrecision",
        WebkitTapHighlightColor: "transparent"
    },
    html: {
        fontSize: "$base"
    },
    body: {
        margin: 0,
        padding: 0,
        minHeight: "100%",
        position: "relative",
        overflowX: "hidden",
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        textRendering: "optimizeLegibility",
        fontSize: "$base",
        lineHeight: "$md",
        fontFamily: "$sans"
    },
    "html, body": {
        backgroundColor: "$background",
        color: "$text"
    },
    "p, small": {
        color: "inherit",
        letterSpacing: "$tighter",
        fontWeight: "$normal",
        fontFamily: "$sans"
    },
    p: {
        fontSize: "$base",
        lineHeight: "$lg"
    },
    small: {
        margin: 0,
        lineHeight: "$xs",
        fontSize: "$xs"
    },
    b: {
        fontWeight: "$semibold"
    },
    span: {
        fontSize: "inherit",
        color: "inherit",
        fontWeight: "inherit"
    },
    img: {
        maxWidth: "100%"
    },
    a: {
        cursor: "pointer",
        fontSize: "inherit",
        WebkitTouchCallout: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        WebkitBoxAlign: "center",
        alignItems: "center",
        color: "$link",
        textDecoration: "none"
    },
    "a:hover": {
        textDecoration: "none"
    },
    "ul,ol": {
        padding: 0,
        listStyleType: "none",
        margin: "$sm $sm $sm $lg",
        color: "$foreground"
    },
    ol: {
        listStyleType: "decimal"
    },
    li: {
        marginBottom: "$5",
        fontSize: "$base",
        lineHeight: "$lg"
    },
    "h1,h2,h3,h4,h5,h6": {
        color: "inherit",
        margin: "0 0 $5 0"
    },
    h1: {
        letterSpacing: "$tighter",
        fontSize: "$xl5",
        lineHeight: "$md",
        fontWeight: "$bold"
    },
    h2: {
        letterSpacing: "$tighter",
        fontSize: "$xl4",
        fontWeight: "$semibold"
    },
    h3: {
        letterSpacing: "$tighter",
        fontSize: "$xl2",
        fontWeight: "$semibold"
    },
    h4: {
        letterSpacing: "$tighter",
        fontSize: "$xl",
        fontWeight: "$semibold"
    },
    h5: {
        letterSpacing: "$tight",
        fontSize: "$md",
        fontWeight: "$semibold"
    },
    h6: {
        letterSpacing: "$tight",
        fontSize: "$sm",
        fontWeight: "$semibold"
    },
    "button, input, select,textarea": {
        fontFamily: "inherit",
        fontSize: "inherit",
        lineHeight: "inherit",
        color: "inherit",
        margin: 0
    },
    "button:focus, input:focus, select:focus, textarea:focus": {
        outline: "none"
    },
    code: {
        color: "$code",
        padding: "$1 $2",
        borderRadius: "$xs",
        bg: "$codeLight",
        fontFamily: "$mono",
        fontSize: "$sm",
        whiteSpace: "pre-wrap",
        transition: "opacity 0.25s ease 0s"
    },
    "code:hover": {
        opacity: .8
    },
    pre: {
        overflow: "auto",
        whiteSpace: "pre",
        textAlign: "left",
        fontSize: "$sm",
        borderRadius: "$lg",
        padding: "$md $lg",
        margin: "$lg 0 ",
        fontFamily: "$mono",
        lineHeight: "$md",
        webkitOverflowScrolling: "touch"
    },
    "pre code": {
        color: "$foreground",
        fontSize: "$sm",
        lineHeight: "$sm",
        whiteSpace: "pre"
    },
    "pre code:before,pre code:after": {
        display: "none"
    },
    "pre p": {
        margin: 0
    },
    "pre::-webkit-scrollbar": {
        display: "none",
        width: 0,
        height: 0,
        background: "transparent"
    },
    hr: {
        background: "$border",
        borderColor: "transparent",
        borderWidth: "0px",
        borderStyle: "none",
        height: "1px"
    },
    details: {
        backgroundColor: "$accents1",
        border: "none"
    },
    "details:focus, details:hover, details:active": {
        outline: "none"
    },
    summary: {
        cursor: "pointer",
        userSelect: "none",
        listStyle: "none",
        outline: "none"
    },
    "summary::-webkit-details-marker, summary::before": {
        display: "none"
    },
    "summary::-moz-list-bullet": {
        fontSize: 0
    },
    "summary:focus, summary:hover, summary:active": {
        outline: "none",
        listStyle: "none"
    },
    "::selection": {
        backgroundColor: "$selection"
    },
    blockquote: {
        padding: "$md $lg",
        color: "$accents7",
        backgroundColor: "$accents0",
        borderRadius: "$lg",
        margin: "$10 0"
    },
    "blockquote *:first-child": {
        marginTop: 0
    },
    "blockquote *:last-child": {
        marginBottom: 0
    },
    kbd: {
        width: "fit-content",
        textAlign: "center",
        display: "inline-block",
        color: "$accents8",
        bg: "$accents0",
        border: "1px solid $border",
        boxShadow: "0 0 1px 0 rgb(0 0 0 / 14%)",
        fontFamily: "$sans",
        borderRadius: "5px",
        padding: "$1 $3",
        mx: "$1",
        lineHeight: "$sm",
        fontSize: "$sm"
    },
    "kbd + kbd": {
        ml: "$2"
    }
}), $ad6c436e0f974ff5$var$r = ({ children: t })=>($ad6c436e0f974ff5$var$n(), (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
        children: t
    })), $ad6c436e0f974ff5$var$l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($ad6c436e0f974ff5$var$r);
$ad6c436e0f974ff5$var$l.flush = ()=>(0, $7b02d682eb115277$exports.jsx)("style", {
        id: "stitches",
        dangerouslySetInnerHTML: {
            __html: (0, $07d095cbefc9a288$export$681e449128971c74)()
        }
    });
var $ad6c436e0f974ff5$export$2e2bcd8739ae039 = $ad6c436e0f974ff5$var$l;



var $acw62 = parcelRequire("acw62");

const $a1074736d4db0ca2$export$2fba198b5b2e37fa = {
    isDark: !1,
    theme: (0, $07d095cbefc9a288$export$bca14c5b3b88a9c9),
    type: "light"
};
const $a1074736d4db0ca2$var$o = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($a1074736d4db0ca2$export$2fba198b5b2e37fa);
var $a1074736d4db0ca2$export$2e2bcd8739ae039 = $a1074736d4db0ca2$var$o;


var $ae4bbcebb3f13d26$export$2e2bcd8739ae039 = (e, t)=>(e.defaultProps = t, e);



const $611d0ac831719832$export$a6cdc56e425d0d0a = (e)=>e && "object" == typeof e;
const $611d0ac831719832$export$aef2e31affb47ea1 = (e, t, { [e]: r, ...c })=>({
        [t]: r,
        ...c
    });
const $611d0ac831719832$export$84f041eb9803ea1f = (e)=>$611d0ac831719832$export$a6cdc56e425d0d0a(e) ? e instanceof Array ? [
        ...e
    ] : {
        ...e
    } : e;
const $611d0ac831719832$export$b3b16780f600581f = (e, t)=>{
    if (!$611d0ac831719832$export$a6cdc56e425d0d0a(e)) return e;
    if (e instanceof Array) return [
        ...e
    ];
    const r = {
        ...e
    };
    return t.forEach((e)=>r[e] && delete r[e]), r;
};
const $611d0ac831719832$export$969b205aa1357eaa = (e)=>{
    if (!$611d0ac831719832$export$a6cdc56e425d0d0a(e)) return e;
    if (e instanceof Array) return [
        ...e
    ];
    const t = {
        ...e
    };
    return Object.keys(t).forEach((e)=>{
        void 0 !== t[e] && null !== t[e] || delete t[e];
    }), t;
};
const $611d0ac831719832$export$9b6c4b6c15d86468 = (e, t = [])=>{
    if (!$611d0ac831719832$export$a6cdc56e425d0d0a(e)) return e;
    if (e instanceof Array) return [
        ...e
    ];
    const r = {
        ...e
    };
    return t.forEach((e)=>{
        r[e] && delete r[e];
    }), r;
};
const $611d0ac831719832$export$38eb86f225c9e34c = (e, t)=>$611d0ac831719832$export$a6cdc56e425d0d0a(e) ? e instanceof Array ? [
        ...e
    ] : e[t] : e;




function $62c7a094ec6fa639$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $62c7a094ec6fa639$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $62c7a094ec6fa639$export$2e2bcd8739ae039(...e) {
    for(var t, f, n = 0, o = ""; n < e.length;)(t = e[n++]) && (f = $62c7a094ec6fa639$var$r(t)) && (o && (o += " "), o += f);
    return o;
}


const $fb41ce022561a2ac$export$37e2c47c7e49c28a = (t, l)=>{
    if (!document || !t) return "";
    let o = getComputedStyle(document.documentElement);
    const r = `--${(0, $860c7657b9fd8b12$export$2e2bcd8739ae039).prefix}-${t}-${l}`, n = o.getPropertyValue(r);
    return n && n.includes("var") && $fb41ce022561a2ac$export$37e2c47c7e49c28a(t, n), n;
};
const $fb41ce022561a2ac$export$ca62a9a432dc162f = ()=>{
    const l = [
        ...Object.keys((0, $860c7657b9fd8b12$export$2e2bcd8739ae039).theme.colors),
        ...Object.keys((0, $727c2f7d9b6ced2b$export$2e2bcd8739ae039).colors)
    ], o = Object.keys((0, $727c2f7d9b6ced2b$export$2e2bcd8739ae039).shadows);
    return {
        colors: l.reduce((t, l)=>{
            const o = $fb41ce022561a2ac$export$37e2c47c7e49c28a("colors", l);
            return o && (t[l] = {
                prefix: (0, $860c7657b9fd8b12$export$2e2bcd8739ae039).prefix,
                scale: "colors",
                token: l,
                value: o
            }), t;
        }, {}),
        shadows: o.reduce((t, l)=>{
            const o = $fb41ce022561a2ac$export$37e2c47c7e49c28a("shadows", l);
            return o && (t[l] = {
                prefix: (0, $860c7657b9fd8b12$export$2e2bcd8739ae039).prefix,
                scale: "shadows",
                token: l,
                value: o
            }), t;
        }, {})
    };
};
const $fb41ce022561a2ac$export$9e0dd4ee511d128e = (e)=>{
    var t;
    const l = (null == e || null == (t = e.getAttribute("style")) ? void 0 : t.split(";").map((e)=>e.trim()).filter((e)=>e.includes("color-scheme"))) || [], o = l.length > 0 ? l[0].replace("color-scheme: ", "").replace(";", "") : "";
    return (null == e ? void 0 : e.getAttribute("data-theme")) || o;
};
const $fb41ce022561a2ac$export$f79377683d328856 = (e)=>"string" == typeof e && null != e && e.includes("-theme") ? null == e ? void 0 : e.replace("-theme", "") : e;
const $fb41ce022561a2ac$export$e6eb54368342cb84 = (e)=>{
    var t, o;
    if (!document) return;
    const r = document.documentElement, n = (null == r || null == (t = r.getAttribute("class")) ? void 0 : t.split(" ").filter((e)=>!e.includes("theme") && !e.includes("light") && !e.includes("dark"))) || [], s = (null == r || null == (o = r.getAttribute("style")) ? void 0 : o.split(";").filter((e)=>!e.includes("color-scheme") && e.length).map((e)=>`${e};`)) || [];
    null == r || r.setAttribute("class", (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)(n, `${$fb41ce022561a2ac$export$f79377683d328856(e)}-theme`)), null == r || r.setAttribute("style", (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)(s, `color-scheme: ${e};`));
};



var $acw62 = parcelRequire("acw62");
var $9a09c3985de915d9$export$2e2bcd8739ae039 = ()=>{
    const [n, r] = (0, $acw62.useState)(!1);
    return (0, $acw62.useEffect)(()=>{
        r(Boolean("undefined" != typeof window && window.document && window.document.createElement));
    }, []), {
        isBrowser: n,
        isServer: !n
    };
};


var $f4aea09d6c1ae125$export$2e2bcd8739ae039 = (0, $9a09c3985de915d9$export$2e2bcd8739ae039);



var $4c52ef0142b7b9e1$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)(({ theme: e, disableBaseline: n, children: x })=>{
    const { isBrowser: j } = (0, $f4aea09d6c1ae125$export$2e2bcd8739ae039)(), [B, N] = (0, $acw62.useState)((0, $a1074736d4db0ca2$export$2fba198b5b2e37fa).type), g = (e)=>{
        N((t)=>t !== e ? e : t);
    }, w = (e)=>{
        const t = (0, $fb41ce022561a2ac$export$9e0dd4ee511d128e)(e);
        t && g(t);
    }, E = (0, $acw62.useMemo)(()=>{
        const e = j ? (0, $fb41ce022561a2ac$export$ca62a9a432dc162f)() : {}, t = (0, $ee20efb1fcb0e764$export$2e2bcd8739ae039)((0, $611d0ac831719832$export$84f041eb9803ea1f)((0, $a1074736d4db0ca2$export$2fba198b5b2e37fa).theme), e), r = (0, $fb41ce022561a2ac$export$f79377683d328856)(B);
        return {
            theme: t,
            type: r,
            isDark: "dark" === r
        };
    }, [
        B,
        j
    ]);
    return (0, $acw62.useEffect)(()=>{
        var e, t, r;
        w(null == (e = document) ? void 0 : e.documentElement);
        const o = new MutationObserver((e)=>{
            var t;
            if (e && e.length > 0 && "BODY" === (null == (t = e[0]) ? void 0 : t.target.nodeName)) {
                var r, o, m;
                const e = null == (r = document) || null == (o = r.body) || null == (m = o.dataset) ? void 0 : m.theme;
                e && g(e);
            } else {
                var s;
                w(null == (s = document) ? void 0 : s.documentElement);
            }
        });
        return o.observe(null == (t = document) ? void 0 : t.documentElement, {
            attributes: !0,
            attributeFilter: [
                "data-theme",
                "style"
            ]
        }), o.observe(null == (r = document) ? void 0 : r.body, {
            attributes: !0,
            attributeFilter: [
                "data-theme",
                "style"
            ]
        }), ()=>o.disconnect();
    }, []), (0, $acw62.useEffect)(()=>{
        j && e && null != e && e.className && ((0, $fb41ce022561a2ac$export$e6eb54368342cb84)(e.className), g((0, $fb41ce022561a2ac$export$f79377683d328856)(e.className)));
    }, [
        j,
        e
    ]), (0, $7b02d682eb115277$exports.jsx)((0, $ed8cf1f08d8b2081$export$9f8ac96af4b1b2ae), {
        children: (0, $7b02d682eb115277$exports.jsx)((0, $e0fe69584fec2898$export$bf688221f59024e5), {
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $a1074736d4db0ca2$export$2e2bcd8739ae039).Provider, {
                value: E,
                children: [
                    !n && (0, $7b02d682eb115277$exports.jsx)((0, $ad6c436e0f974ff5$export$2e2bcd8739ae039), {}),
                    x
                ]
            })
        })
    });
}, {
    disableBaseline: !1
});


parcelRequire("acw62");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $c38e0f42709c826a$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $c38e0f42709c826a$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $c38e0f42709c826a$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $c38e0f42709c826a$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $c38e0f42709c826a$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $c38e0f42709c826a$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $c38e0f42709c826a$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($c38e0f42709c826a$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $c38e0f42709c826a$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ const $c38e0f42709c826a$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $c38e0f42709c826a$var$stringToByteArray$1(str);
    return $c38e0f42709c826a$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $c38e0f42709c826a$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $c38e0f42709c826a$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $c38e0f42709c826a$export$c62426fdd000a97e = function(str) {
    try {
        return $c38e0f42709c826a$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $c38e0f42709c826a$export$6c40052bed430212(value) {
    return $c38e0f42709c826a$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $c38e0f42709c826a$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$c38e0f42709c826a$var$isValidKey(prop)) continue;
        target[prop] = $c38e0f42709c826a$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $c38e0f42709c826a$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c38e0f42709c826a$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(header)),
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $c38e0f42709c826a$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $c38e0f42709c826a$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($c38e0f42709c826a$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $c38e0f42709c826a$export$8ee0fc9ee280b4ee() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $c38e0f42709c826a$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $c38e0f42709c826a$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $c38e0f42709c826a$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $c38e0f42709c826a$export$f2f6a8999f8ebd30() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $c38e0f42709c826a$export$7e7b1a9668aaed8() {
    const ua = $c38e0f42709c826a$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $c38e0f42709c826a$export$202944b2d2824246() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $c38e0f42709c826a$export$5d1d834fbbf8bab7() {
    return $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_CLIENT === true || $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $c38e0f42709c826a$export$95df08bae54cb4df() {
    return !$c38e0f42709c826a$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $c38e0f42709c826a$export$3865db50535c2055() {
    return typeof indexedDB === "object";
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $c38e0f42709c826a$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $c38e0f42709c826a$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */ function $c38e0f42709c826a$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if (e.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $c38e0f42709c826a$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $c38e0f42709c826a$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $c38e0f42709c826a$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c38e0f42709c826a$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c38e0f42709c826a$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $c38e0f42709c826a$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $c38e0f42709c826a$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $c38e0f42709c826a$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $c38e0f42709c826a$var$replaceTemplate(template, data) {
    return template.replace($c38e0f42709c826a$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $c38e0f42709c826a$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $c38e0f42709c826a$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $c38e0f42709c826a$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[0]) || "");
        claims = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$5f870fcca7ae6a88 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$701c661ec91095f2 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $c38e0f42709c826a$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$fc970ed23da99565 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $c38e0f42709c826a$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $c38e0f42709c826a$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $c38e0f42709c826a$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $c38e0f42709c826a$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($c38e0f42709c826a$var$isObject(aProp) && $c38e0f42709c826a$var$isObject(bProp)) {
            if (!$c38e0f42709c826a$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $c38e0f42709c826a$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $c38e0f42709c826a$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $c38e0f42709c826a$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $c38e0f42709c826a$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $c38e0f42709c826a$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $c38e0f42709c826a$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $c38e0f42709c826a$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $c38e0f42709c826a$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($c38e0f42709c826a$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $c38e0f42709c826a$var$noop;
        if (observer.error === undefined) observer.error = $c38e0f42709c826a$var$noop;
        if (observer.complete === undefined) observer.complete = $c38e0f42709c826a$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c38e0f42709c826a$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $c38e0f42709c826a$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $c38e0f42709c826a$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $c38e0f42709c826a$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $c38e0f42709c826a$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $c38e0f42709c826a$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $c38e0f42709c826a$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $c38e0f42709c826a$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $c38e0f42709c826a$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $c38e0f42709c826a$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $c38e0f42709c826a$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $c38e0f42709c826a$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $c38e0f42709c826a$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($c38e0f42709c826a$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $c38e0f42709c826a$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $c38e0f42709c826a$var$indicator(i);
}
function $c38e0f42709c826a$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $a83e7ccd68ca8d4e$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($a83e7ccd68ca8d4e$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $a83e7ccd68ca8d4e$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $a83e7ccd68ca8d4e$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $45b460d9de9b230f$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $45b460d9de9b230f$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($45b460d9de9b230f$export$243e62d78d3b544d || ($45b460d9de9b230f$export$243e62d78d3b544d = {}));
const $45b460d9de9b230f$var$levelStringToEnum = {
    "debug": $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG,
    "verbose": $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE,
    "info": $45b460d9de9b230f$export$243e62d78d3b544d.INFO,
    "warn": $45b460d9de9b230f$export$243e62d78d3b544d.WARN,
    "error": $45b460d9de9b230f$export$243e62d78d3b544d.ERROR,
    "silent": $45b460d9de9b230f$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $45b460d9de9b230f$var$defaultLogLevel = $45b460d9de9b230f$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $45b460d9de9b230f$var$ConsoleMethod = {
    [$45b460d9de9b230f$export$243e62d78d3b544d.DEBUG]: "log",
    [$45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE]: "log",
    [$45b460d9de9b230f$export$243e62d78d3b544d.INFO]: "info",
    [$45b460d9de9b230f$export$243e62d78d3b544d.WARN]: "warn",
    [$45b460d9de9b230f$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $45b460d9de9b230f$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $45b460d9de9b230f$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $45b460d9de9b230f$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $45b460d9de9b230f$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $45b460d9de9b230f$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $45b460d9de9b230f$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $45b460d9de9b230f$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $45b460d9de9b230f$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $45b460d9de9b230f$export$c622e99c0ce7b1c9(level) {
    $45b460d9de9b230f$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $45b460d9de9b230f$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $45b460d9de9b230f$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $45b460d9de9b230f$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $45b460d9de9b230f$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($57d436074e210fb5$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $57d436074e210fb5$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */ ;
}
const $57d436074e210fb5$var$name$o = "@firebase/app";
const $57d436074e210fb5$var$version$1 = "0.7.12";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$logger = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/app");
const $57d436074e210fb5$var$name$n = "@firebase/app-compat";
const $57d436074e210fb5$var$name$m = "@firebase/analytics-compat";
const $57d436074e210fb5$var$name$l = "@firebase/analytics";
const $57d436074e210fb5$var$name$k = "@firebase/app-check-compat";
const $57d436074e210fb5$var$name$j = "@firebase/app-check";
const $57d436074e210fb5$var$name$i = "@firebase/auth";
const $57d436074e210fb5$var$name$h = "@firebase/auth-compat";
const $57d436074e210fb5$var$name$g = "@firebase/database";
const $57d436074e210fb5$var$name$f = "@firebase/database-compat";
const $57d436074e210fb5$var$name$e = "@firebase/functions";
const $57d436074e210fb5$var$name$d = "@firebase/functions-compat";
const $57d436074e210fb5$var$name$c = "@firebase/installations";
const $57d436074e210fb5$var$name$b = "@firebase/installations-compat";
const $57d436074e210fb5$var$name$a = "@firebase/messaging";
const $57d436074e210fb5$var$name$9 = "@firebase/messaging-compat";
const $57d436074e210fb5$var$name$8 = "@firebase/performance";
const $57d436074e210fb5$var$name$7 = "@firebase/performance-compat";
const $57d436074e210fb5$var$name$6 = "@firebase/remote-config";
const $57d436074e210fb5$var$name$5 = "@firebase/remote-config-compat";
const $57d436074e210fb5$var$name$4 = "@firebase/storage";
const $57d436074e210fb5$var$name$3 = "@firebase/storage-compat";
const $57d436074e210fb5$var$name$2 = "@firebase/firestore";
const $57d436074e210fb5$var$name$1 = "@firebase/firestore-compat";
const $57d436074e210fb5$var$name = "firebase";
const $57d436074e210fb5$var$version = "9.6.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $57d436074e210fb5$export$9f30fa0c10967f7f = "[DEFAULT]";
const $57d436074e210fb5$var$PLATFORM_LOG_STRING = {
    [$57d436074e210fb5$var$name$o]: "fire-core",
    [$57d436074e210fb5$var$name$n]: "fire-core-compat",
    [$57d436074e210fb5$var$name$l]: "fire-analytics",
    [$57d436074e210fb5$var$name$m]: "fire-analytics-compat",
    [$57d436074e210fb5$var$name$j]: "fire-app-check",
    [$57d436074e210fb5$var$name$k]: "fire-app-check-compat",
    [$57d436074e210fb5$var$name$i]: "fire-auth",
    [$57d436074e210fb5$var$name$h]: "fire-auth-compat",
    [$57d436074e210fb5$var$name$g]: "fire-rtdb",
    [$57d436074e210fb5$var$name$f]: "fire-rtdb-compat",
    [$57d436074e210fb5$var$name$e]: "fire-fn",
    [$57d436074e210fb5$var$name$d]: "fire-fn-compat",
    [$57d436074e210fb5$var$name$c]: "fire-iid",
    [$57d436074e210fb5$var$name$b]: "fire-iid-compat",
    [$57d436074e210fb5$var$name$a]: "fire-fcm",
    [$57d436074e210fb5$var$name$9]: "fire-fcm-compat",
    [$57d436074e210fb5$var$name$8]: "fire-perf",
    [$57d436074e210fb5$var$name$7]: "fire-perf-compat",
    [$57d436074e210fb5$var$name$6]: "fire-rc",
    [$57d436074e210fb5$var$name$5]: "fire-rc-compat",
    [$57d436074e210fb5$var$name$4]: "fire-gcs",
    [$57d436074e210fb5$var$name$3]: "fire-gcs-compat",
    [$57d436074e210fb5$var$name$2]: "fire-fst",
    [$57d436074e210fb5$var$name$1]: "fire-fst-compat",
    "fire-js": "fire-js",
    [$57d436074e210fb5$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $57d436074e210fb5$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $57d436074e210fb5$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $57d436074e210fb5$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $57d436074e210fb5$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $57d436074e210fb5$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $57d436074e210fb5$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($57d436074e210fb5$export$9566bce3835c0f28.has(componentName)) {
        $57d436074e210fb5$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $57d436074e210fb5$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $57d436074e210fb5$export$b4e3c36c855b14b5.values())$57d436074e210fb5$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $57d436074e210fb5$export$fa0d6da0f5838f50(app, name) {
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $57d436074e210fb5$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    $57d436074e210fb5$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $57d436074e210fb5$export$3685d89b9c3cdfaf() {
    $57d436074e210fb5$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$ERRORS = {
    ["no-app" /* NO_APP */ ]: "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()",
    ["bad-app-name" /* BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["invalid-app-argument" /* INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function."
};
const $57d436074e210fb5$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("app", "Firebase", $57d436074e210fb5$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $57d436074e210fb5$var$ERROR_FACTORY.create("app-deleted" /* APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $57d436074e210fb5$export$31499a9cd224b78c = $57d436074e210fb5$var$version;
function $57d436074e210fb5$export$c55cfd413944906d(options, rawConfig = {}) {
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $57d436074e210fb5$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $57d436074e210fb5$var$ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */ , {
        appName: String(name)
    });
    const existingApp = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $57d436074e210fb5$var$ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)(name);
    for (const component of $57d436074e210fb5$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $57d436074e210fb5$var$FirebaseAppImpl(options, config, container);
    $57d436074e210fb5$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $57d436074e210fb5$export$f9962582c9e66d99(name = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    const app = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (!app) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-app" /* NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $57d436074e210fb5$export$68ddedf7d44b3bdf() {
    return Array.from($57d436074e210fb5$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $57d436074e210fb5$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($57d436074e210fb5$export$b4e3c36c855b14b5.has(name)) {
        $57d436074e210fb5$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $57d436074e210fb5$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $57d436074e210fb5$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $57d436074e210fb5$var$logger.warn(warning.join(" "));
        return;
    }
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $57d436074e210fb5$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $57d436074e210fb5$var$ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */ );
    (0, $45b460d9de9b230f$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $57d436074e210fb5$export$c622e99c0ce7b1c9(logLevel) {
    (0, $45b460d9de9b230f$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d436074e210fb5$var$registerCoreComponents(variant) {
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("platform-logger", (container)=>new $57d436074e210fb5$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* PRIVATE */ ));
    // Register `app` package.
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$o, $57d436074e210fb5$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$o, $57d436074e210fb5$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $57d436074e210fb5$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $57d436074e210fb5$var$registerCoreComponents("");


var $b9f389ba82d8f28a$var$name = "firebase";
var $b9f389ba82d8f28a$var$version = "9.6.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $57d436074e210fb5$export$d29d5299a7137abc)($b9f389ba82d8f28a$var$name, $b9f389ba82d8f28a$var$version, "app");


const $21244af9bc38e1ad$var$firebaseApp = (0, $57d436074e210fb5$export$c55cfd413944906d)({
    apiKey: "AIzaSyDcimdNg7I4xSFv4w8aS7PuleRCUsjDM5Q",
    authDomain: "vcard-pininfarinasegno.firebaseapp.com",
    projectId: "vcard-pininfarinasegno",
    storageBucket: "vcard-pininfarinasegno.appspot.com",
    messagingSenderId: "291198345295",
    appId: "1:291198345295:web:1009ced978800e22804a3a",
    measurementId: "G-MZ7Y6GKGRS"
});
var $21244af9bc38e1ad$export$2e2bcd8739ae039 = $21244af9bc38e1ad$var$firebaseApp;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



function $066ee5e43859dd8f$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $066ee5e43859dd8f$var$$9bf71ea28793e738$exports = {};
$066ee5e43859dd8f$var$$parcel$export($066ee5e43859dd8f$var$$9bf71ea28793e738$exports, "FocusScope", ()=>$066ee5e43859dd8f$export$20e40289641fbbb6);
$066ee5e43859dd8f$var$$parcel$export($066ee5e43859dd8f$var$$9bf71ea28793e738$exports, "useFocusManager", ()=>$066ee5e43859dd8f$export$10c5169755ce7bd7);
$066ee5e43859dd8f$var$$parcel$export($066ee5e43859dd8f$var$$9bf71ea28793e738$exports, "getFocusableTreeWalker", ()=>$066ee5e43859dd8f$export$2d6ec8fc375ceafa);
$066ee5e43859dd8f$var$$parcel$export($066ee5e43859dd8f$var$$9bf71ea28793e738$exports, "createFocusManager", ()=>$066ee5e43859dd8f$export$c5251b9e124bf29);
var $066ee5e43859dd8f$var$$6a99195332edec8b$exports = {};
$066ee5e43859dd8f$var$$parcel$export($066ee5e43859dd8f$var$$6a99195332edec8b$exports, "focusSafely", ()=>$066ee5e43859dd8f$export$80f3e147d781571c);
function $066ee5e43859dd8f$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    if ((0, $895d146aa86f8a19$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = document.activeElement;
        (0, $4d60a29ecf011a9e$export$24490316f764c430)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (document.activeElement === lastFocusedElement && document.contains(element)) (0, $4d60a29ecf011a9e$export$de79e2c695e052f3)(element);
        });
    } else (0, $4d60a29ecf011a9e$export$de79e2c695e052f3)(element);
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $066ee5e43859dd8f$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    if (!(element instanceof HTMLElement) && !(element instanceof SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $066ee5e43859dd8f$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $066ee5e43859dd8f$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $066ee5e43859dd8f$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $066ee5e43859dd8f$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $066ee5e43859dd8f$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}
const $066ee5e43859dd8f$var$$9bf71ea28793e738$var$FocusContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
let $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope = null;
let $066ee5e43859dd8f$var$$9bf71ea28793e738$var$scopes = new Map();
function $066ee5e43859dd8f$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $acw62.useRef)();
    let endRef = (0, $acw62.useRef)();
    let scopeRef = (0, $acw62.useRef)([]);
    let ctx = (0, $acw62.useContext)($066ee5e43859dd8f$var$$9bf71ea28793e738$var$FocusContext);
    let parentScope = ctx === null || ctx === void 0 ? void 0 : ctx.scopeRef;
    (0, $4d60a29ecf011a9e$export$e5c5a5f917a5871c)(()=>{
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = startRef.current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children,
        parentScope
    ]);
    (0, $4d60a29ecf011a9e$export$e5c5a5f917a5871c)(()=>{
        $066ee5e43859dd8f$var$$9bf71ea28793e738$var$scopes.set(scopeRef, parentScope);
        return ()=>{
            // Restore the active scope on unmount if this scope or a descendant scope is active.
            // Parent effect cleanups run before children, so we need to check if the
            // parent scope actually still exists before restoring the active scope to it.
            if ((scopeRef === $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope || $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $066ee5e43859dd8f$var$$9bf71ea28793e738$var$scopes.has(parentScope))) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $066ee5e43859dd8f$var$$9bf71ea28793e738$var$scopes.delete(scopeRef);
        };
    }, [
        scopeRef,
        parentScope
    ]);
    $066ee5e43859dd8f$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $066ee5e43859dd8f$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $066ee5e43859dd8f$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    let focusManager = $066ee5e43859dd8f$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($066ee5e43859dd8f$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: {
            scopeRef: scopeRef,
            focusManager: focusManager
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $066ee5e43859dd8f$export$10c5169755ce7bd7() {
    var ref;
    return (ref = (0, $acw62.useContext)($066ee5e43859dd8f$var$$9bf71ea28793e738$var$FocusContext)) === null || ref === void 0 ? void 0 : ref.focusManager;
}
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[0].previousElementSibling;
            let walker = $066ee5e43859dd8f$export$2d6ec8fc375ceafa($066ee5e43859dd8f$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable
            }, scope);
            walker.currentNode = $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let walker = $066ee5e43859dd8f$export$2d6ec8fc375ceafa($066ee5e43859dd8f$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable
            }, scope);
            walker.currentNode = $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable } = opts;
            let walker = $066ee5e43859dd8f$export$2d6ec8fc375ceafa($066ee5e43859dd8f$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable } = opts;
            let walker = $066ee5e43859dd8f$export$2d6ec8fc375ceafa($066ee5e43859dd8f$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $066ee5e43859dd8f$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $066ee5e43859dd8f$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $acw62.useRef)();
    let raf = (0, $acw62.useRef)(null);
    (0, $4d60a29ecf011a9e$export$e5c5a5f917a5871c)(()=>{
        let scope1 = scopeRef.current;
        if (!contain) return;
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || scopeRef !== $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope) return;
            let focusedElement = document.activeElement;
            let scope = scopeRef.current;
            if (!$066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let walker = $066ee5e43859dd8f$export$2d6ec8fc375ceafa($066ee5e43859dd8f$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: true
            }, scope);
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if (!$066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope || $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isAncestorScope($066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope, scopeRef)) {
                $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if (scopeRef === $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope && !$066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusFirstInScope($066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope.current);
            } else if (scopeRef === $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (scopeRef === $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope && !$066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInChildScope(document.activeElement, scopeRef)) {
                    $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    focusedNode.current = e.target;
                    focusedNode.current.focus();
                }
            });
        };
        document.addEventListener("keydown", onKeyDown, false);
        document.addEventListener("focusin", onFocus, false);
        scope1.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope1.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            document.removeEventListener("keydown", onKeyDown, false);
            document.removeEventListener("focusin", onFocus, false);
            scope1.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope1.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    // eslint-disable-next-line arrow-body-style
    (0, $acw62.useEffect)(()=>{
        return ()=>cancelAnimationFrame(raf.current);
    }, [
        raf
    ]);
}
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    for (let scope of $066ee5e43859dd8f$var$$9bf71ea28793e738$var$scopes.keys()){
        if ($066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(element, scope.current)) return true;
    }
    return false;
}
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    return scope.some((node)=>node.contains(element));
}
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope) {
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let s of $066ee5e43859dd8f$var$$9bf71ea28793e738$var$scopes.keys()){
        if ((s === scope || $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isAncestorScope(scope, s)) && $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    let parent = $066ee5e43859dd8f$var$$9bf71ea28793e738$var$scopes.get(scope);
    if (!parent) return false;
    if (parent === ancestor) return true;
    return $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, parent);
}
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        $066ee5e43859dd8f$export$80f3e147d781571c(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err1) {
    // ignore
    }
}
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusFirstInScope(scope) {
    let sentinel = scope[0].previousElementSibling;
    let walker = $066ee5e43859dd8f$export$2d6ec8fc375ceafa($066ee5e43859dd8f$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
        tabbable: true
    }, scope);
    walker.currentNode = sentinel;
    $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(walker.nextNode());
}
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            if (!$066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(document.activeElement, $066ee5e43859dd8f$var$$9bf71ea28793e738$var$activeScope.current)) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, []);
}
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    const nodeToRestoreRef = (0, $acw62.useRef)(typeof document !== "undefined" ? document.activeElement : null);
    // useLayoutEffect instead of useEffect so the active element is saved synchronously instead of asynchronously.
    (0, $4d60a29ecf011a9e$export$e5c5a5f917a5871c)(()=>{
        let nodeToRestore = nodeToRestoreRef.current;
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey) return;
            let focusedElement = document.activeElement;
            if (!$066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $066ee5e43859dd8f$export$2d6ec8fc375ceafa(document.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!document.body.contains(nodeToRestore) || nodeToRestore === document.body) nodeToRestore = null;
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) document.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) document.removeEventListener("keydown", onKeyDown, true);
            if (restoreFocus && nodeToRestore && $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(document.activeElement, scopeRef.current)) requestAnimationFrame(()=>{
                if (document.body.contains(nodeToRestore)) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(nodeToRestore);
            });
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
}
function $066ee5e43859dd8f$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $066ee5e43859dd8f$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $066ee5e43859dd8f$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var ref;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (ref = opts.from) === null || ref === void 0 ? void 0 : ref.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && $066ee5e43859dd8f$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(node) && (!scope || $066ee5e43859dd8f$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $066ee5e43859dd8f$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || document.activeElement;
            let walker = $066ee5e43859dd8f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || document.activeElement;
            let walker = $066ee5e43859dd8f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $066ee5e43859dd8f$var$$9bf71ea28793e738$var$last(walker);
                if (next) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                previousNode = $066ee5e43859dd8f$var$$9bf71ea28793e738$var$last(walker);
            }
            if (previousNode) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $066ee5e43859dd8f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $066ee5e43859dd8f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $066ee5e43859dd8f$var$$9bf71ea28793e738$var$last(walker);
            if (next) $066ee5e43859dd8f$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next;
        }
    };
}
function $066ee5e43859dd8f$var$$9bf71ea28793e738$var$last(walker) {
    let next;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
var $066ee5e43859dd8f$var$$907718708eab68af$exports = {};
$066ee5e43859dd8f$var$$parcel$export($066ee5e43859dd8f$var$$907718708eab68af$exports, "FocusRing", ()=>$066ee5e43859dd8f$export$1a38b4ad7f578e1d);
var $066ee5e43859dd8f$var$$f7dceffc5ad7768b$exports = {};
$066ee5e43859dd8f$var$$parcel$export($066ee5e43859dd8f$var$$f7dceffc5ad7768b$exports, "useFocusRing", ()=>$066ee5e43859dd8f$export$4e328f61c538687f);
function $066ee5e43859dd8f$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $acw62.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $895d146aa86f8a19$export$b9b3dfddab17db27)()
    });
    let [isFocused1, setFocused] = (0, $acw62.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $acw62.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $acw62.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $895d146aa86f8a19$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $895d146aa86f8a19$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $895d146aa86f8a19$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused1,
        isFocusVisible: state.current.isFocused && isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}
function $066ee5e43859dd8f$export$1a38b4ad7f578e1d(props) {
    let { children: children, focusClass: focusClass, focusRingClass: focusRingClass } = props;
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = $066ee5e43859dd8f$export$4e328f61c538687f(props);
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(child.props, {
        ...focusProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [focusClass || ""]: isFocused,
            [focusRingClass || ""]: isFocusVisible
        })
    }));
}
var $066ee5e43859dd8f$var$$e6afbd83fe6ebbd2$exports = {};
$066ee5e43859dd8f$var$$parcel$export($066ee5e43859dd8f$var$$e6afbd83fe6ebbd2$exports, "FocusableProvider", ()=>$066ee5e43859dd8f$export$13f3202a3e5ddd5);
$066ee5e43859dd8f$var$$parcel$export($066ee5e43859dd8f$var$$e6afbd83fe6ebbd2$exports, "useFocusable", ()=>$066ee5e43859dd8f$export$4c014de7c8940b4c);
let $066ee5e43859dd8f$var$$e6afbd83fe6ebbd2$var$FocusableContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $066ee5e43859dd8f$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $acw62.useContext)($066ee5e43859dd8f$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $4d60a29ecf011a9e$export$4debdb1a3f0fa79e)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $066ee5e43859dd8f$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let context = {
        ...otherProps,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($066ee5e43859dd8f$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $066ee5e43859dd8f$export$13f3202a3e5ddd5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($066ee5e43859dd8f$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $066ee5e43859dd8f$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $895d146aa86f8a19$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps } = (0, $895d146aa86f8a19$export$8f71654801c2f7cd)(props);
    let interactions = (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(focusProps, keyboardProps);
    let domProps = $066ee5e43859dd8f$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $acw62.useRef)(props.autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) $066ee5e43859dd8f$export$80f3e147d781571c(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}





function $0765cc1e8d6648f2$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $0765cc1e8d6648f2$var$$701a24aa0da5b062$exports = {};
$0765cc1e8d6648f2$var$$parcel$export($0765cc1e8d6648f2$var$$701a24aa0da5b062$exports, "useButton", ()=>$0765cc1e8d6648f2$export$ea18c227d4417cc3);
function $0765cc1e8d6648f2$export$ea18c227d4417cc3(props, ref) {
    let { elementType: elementType = "button", isDisabled: isDisabled, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, preventFocusOnPress: preventFocusOnPress, allowFocusWhenDisabled: allowFocusWhenDisabled, onClick: deprecatedOnClick, href: href, target: target, rel: rel, type: type = "button" } = props;
    let additionalProps;
    if (elementType === "button") additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: "button",
        tabIndex: isDisabled ? undefined : 0,
        href: elementType === "a" && isDisabled ? undefined : href,
        target: elementType === "a" ? target : undefined,
        type: elementType === "input" ? type : undefined,
        disabled: elementType === "input" ? isDisabled : undefined,
        "aria-disabled": !isDisabled || elementType === "input" ? undefined : isDisabled,
        rel: elementType === "a" ? rel : undefined
    };
    let { pressProps: pressProps, isPressed: isPressed } = (0, $895d146aa86f8a19$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps } = (0, $066ee5e43859dd8f$export$4c014de7c8940b4c)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(focusableProps, pressProps, (0, $4d60a29ecf011a9e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(additionalProps, buttonProps, {
            "aria-haspopup": props["aria-haspopup"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-pressed": props["aria-pressed"],
            onClick: (e)=>{
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn("onClick is deprecated, please use onPress");
                }
            }
        })
    };
}
var $0765cc1e8d6648f2$var$$55f54f7887471b58$exports = {};
$0765cc1e8d6648f2$var$$parcel$export($0765cc1e8d6648f2$var$$55f54f7887471b58$exports, "useToggleButton", ()=>$0765cc1e8d6648f2$export$51e84d46ca0bc451);
function $0765cc1e8d6648f2$export$51e84d46ca0bc451(props, state, ref) {
    const { isSelected: isSelected } = state;
    const { isPressed: isPressed, buttonProps: buttonProps } = $0765cc1e8d6648f2$export$ea18c227d4417cc3({
        ...props,
        onPress: (0, $4d60a29ecf011a9e$export$e08e3b67e392101e)(state.toggle, props.onPress)
    }, ref);
    return {
        isPressed: isPressed,
        buttonProps: (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(buttonProps, {
            "aria-pressed": isSelected
        })
    };
}




const $2fe9d5fdd1aa82cd$var$o = {};
var $2fe9d5fdd1aa82cd$export$2e2bcd8739ae039 = (e, n)=>{
    const r = `[Next UI]${n ? ` [${n}]` : " "}: ${e}`;
    if ("undefined" != typeof console && !$2fe9d5fdd1aa82cd$var$o[r]) {
        $2fe9d5fdd1aa82cd$var$o[r] = !0;
        console.warn(r);
    }
};


var $364cddea3adf1f69$export$2e2bcd8739ae039 = (0, $2fe9d5fdd1aa82cd$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");




const $29aa2688f5aace4f$var$a = (0, $07d095cbefc9a288$export$d25ddfdf17c3ad3e)({
    "0%": {
        opacity: 0,
        transform: "scale(0.25)"
    },
    "30%": {
        opacity: 1
    },
    "80%": {
        opacity: .5
    },
    "100%": {
        transform: "scale(28)",
        opacity: 0
    }
});
const $29aa2688f5aace4f$export$43b4b309f2c2c56 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    "& svg": {
        position: "absolute",
        animation: `350ms linear ${$29aa2688f5aace4f$var$a}`,
        animationFillMode: "forwards",
        width: "$md",
        height: "$md"
    }
});
const $29aa2688f5aace4f$var$m = ({ visible: t, x: r, y: o, color: n, onCompleted: a, className: m, ...c })=>{
    const d = (0, $acw62.useRef)(null), p = Number.isNaN(+o) ? 0 : o - 10, u = Number.isNaN(+r) ? 0 : r - 10;
    return (0, $acw62.useEffect)(()=>{
        if (d.current) return d.current.addEventListener("animationend", a), ()=>{
            d.current && d.current.removeEventListener("animationend", a);
        };
    }), t ? (0, $7b02d682eb115277$exports.jsx)($29aa2688f5aace4f$export$43b4b309f2c2c56, {
        ref: d,
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-drip", m),
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            style: {
                top: p,
                left: u
            },
            children: (0, $7b02d682eb115277$exports.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: (0, $7b02d682eb115277$exports.jsx)("g", {
                    className: "nextui-drip-filler",
                    fill: n,
                    children: (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "100%",
                        height: "100%",
                        rx: "10"
                    })
                })
            })
        })
    }) : null;
}, $29aa2688f5aace4f$var$c = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($29aa2688f5aace4f$var$m);
var $29aa2688f5aace4f$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($29aa2688f5aace4f$var$c, {
    visible: !1,
    x: 0,
    y: 0,
    className: ""
});


const $10aa0e63a29ca4bc$export$4c9c434877f2e91e = (e, o)=>{
    var r, t, n, l, d, a, i, s, g, u, b;
    return o.isButtonGroup ? {
        ...e,
        auto: !0,
        shadow: !1,
        bordered: null != (r = o.bordered) ? r : e.bordered,
        borderWeight: null != (t = o.borderWeight) ? t : e.borderWeight,
        ghost: null != (n = o.ghost) ? n : e.ghost,
        ripple: null != (l = o.ripple) ? l : e.ripple,
        flat: null != (d = o.flat) ? d : e.flat,
        animated: null != (a = o.animated) ? a : e.animated,
        rounded: null != (i = o.rounded) ? i : e.rounded,
        light: null != (s = o.light) ? s : e.light,
        size: null != (g = o.size) ? g : e.size,
        color: null != (u = o.color) ? u : e.color,
        disabled: null != (b = o.disabled) ? b : e.disabled
    } : e;
};
const $10aa0e63a29ca4bc$export$5b27f6dd7aa65003 = (e)=>{
    if (!e.disabled) return e.auto && "gradient" === e.color && (e.bordered || e.ghost) ? {
        px: "$$buttonBorderWeight",
        py: "$$buttonBorderWeight"
    } : {};
    const o = {
        bg: "$accents1",
        color: "$accents7",
        transform: "none",
        boxShadow: "none",
        pe: "none"
    };
    return e.bordered || e.flat || e.ghost || e.light ? "gradient" === e.color && (e.bordered || e.ghost) ? {
        color: "$accents4",
        backgroundImage: "linear-gradient($background, $background), linear-gradient($accents2, $accents2)",
        transform: "none",
        boxShadow: "none",
        pe: "none",
        pl: "$$buttonBorderWeight",
        pr: "$$buttonBorderWeight"
    } : e.bordered || e.ghost || e.light ? {
        ...o,
        bg: "transparent",
        borderColor: "$accents4"
    } : e.flat ? {
        ...o,
        bg: "$accents1"
    } : {} : o;
};



var $acw62 = parcelRequire("acw62");
const $b97313e89f3393f8$var$o = {
    isButtonGroup: !1,
    disabled: !1
};
const $b97313e89f3393f8$export$4c574c91bb0be0e2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($b97313e89f3393f8$var$o);
const $b97313e89f3393f8$export$85d63e852e3be3b3 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($b97313e89f3393f8$export$4c574c91bb0be0e2);



var $acw62 = parcelRequire("acw62");




const $635d39c539a13295$export$f515a9994dd57db5 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {
    dflex: "center",
    position: "absolute",
    left: "$$buttonPadding",
    right: "auto",
    top: "50%",
    transform: "translateY(-50%)",
    color: "inherit",
    zIndex: "$1",
    "& svg": {
        background: "transparent"
    },
    variants: {
        isAuto: {
            true: {
                position: "relative",
                transform: "none",
                top: "0%"
            }
        },
        isRight: {
            true: {
                right: "$$buttonPadding",
                left: "auto"
            }
        },
        isSingle: {
            true: {
                position: "static",
                transform: "none"
            }
        },
        isGradientButtonBorder: {
            true: {}
        }
    },
    compoundVariants: [
        {
            isAuto: !0,
            isRight: !0,
            isSingle: !1,
            css: {
                order: 2,
                ml: "calc($$buttonPadding / 2)",
                right: "0%",
                left: "0%"
            }
        },
        {
            isAuto: !0,
            isRight: !1,
            isSingle: !1,
            css: {
                order: 0,
                mr: "calc($$buttonPadding / 2)",
                right: "0%",
                left: "0%"
            }
        },
        {
            isSingle: !0,
            isRight: !1,
            css: {
                ml: 0
            }
        },
        {
            isSingle: !0,
            isRight: !0,
            css: {
                mr: 0
            }
        },
        {
            isSingle: !0,
            isRight: !1,
            isGradientButtonBorder: !0,
            css: {
                mr: "calc($$buttonPadding / 2)"
            }
        }
    ]
});
const $635d39c539a13295$var$e = ({ children: t, className: i, css: n, ...e })=>(0, $7b02d682eb115277$exports.jsx)($635d39c539a13295$export$f515a9994dd57db5, {
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-button-icon", {
            "nextui-button-icon-right": e.isRight,
            "nextui-button-icon-single": e.isSingle
        }, i),
        css: {
            ...n
        },
        ...e,
        children: t
    });
$635d39c539a13295$var$e.toString = ()=>".nextui-button-icon";
const $635d39c539a13295$var$r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($635d39c539a13295$var$e);
var $635d39c539a13295$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($635d39c539a13295$var$r, {
    className: ""
});




var $acw62 = parcelRequire("acw62");
var $679bd7128dceb7a7$export$2e2bcd8739ae039 = (e = !1, n)=>{
    const [r, o] = (0, $acw62.useState)(e), [c, i] = (0, $acw62.useState)(0), [l, u] = (0, $acw62.useState)(0);
    return {
        visible: r,
        x: c,
        y: l,
        onClick: (t)=>{
            if (!n.current) return;
            const e = n.current.getBoundingClientRect();
            o(!0), i(t.clientX - e.left), u(t.clientY - e.top);
        },
        onCompleted: ()=>{
            o(!1), i(0), u(0);
        }
    };
};


var $6980a7fe0d40944d$export$2e2bcd8739ae039 = (0, $679bd7128dceb7a7$export$2e2bcd8739ae039);




const $eaf275b21629a4ec$export$fcece08f39236f43 = (0, $07d095cbefc9a288$export$dbf350e5966cf602)({
    WebkitTapHighlightColor: "transparent",
    "&:focus:not(&:focus-visible)": {
        boxShadow: "none"
    },
    "&:focus": {
        outline: "none",
        boxShadow: "0 0 0 2px $colors$background, 0 0 0 4px $colors$primary"
    },
    "@safari": {
        WebkitTapHighlightColor: "transparent",
        outline: "none"
    }
});
const $eaf275b21629a4ec$export$ab780f34ea253ed3 = (0, $07d095cbefc9a288$export$dbf350e5966cf602)({
    variants: {
        isFocusVisible: {
            true: {
                outline: "transparent solid 2px",
                outlineOffset: "2px",
                boxShadow: "0 0 0 2px $colors$background, 0 0 0 4px $colors$primary"
            },
            false: {
                outline: "none"
            }
        }
    }
});
const $eaf275b21629a4ec$export$18f796664128d249 = (0, $07d095cbefc9a288$export$dbf350e5966cf602)({
    transform: "translateZ(0)",
    backfaceVisibility: "hidden"
});
const $eaf275b21629a4ec$export$74eab49e97f7dd3b = (0, $07d095cbefc9a288$export$dbf350e5966cf602)({
    border: "0px",
    clip: "rect(0px, 0px, 0px, 0px)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
});
const $eaf275b21629a4ec$export$6215605c4cb3914a = (0, $07d095cbefc9a288$export$dbf350e5966cf602)({
    '&[aria-haspopup="true"]&[aria-expanded="true"]': {
        opacity: .7,
        transform: "scale(0.97)"
    }
});



const $5fbe2f5a607c3031$export$2d5d2ba3c7c8c40b = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("button", {
    $$buttonBorderRadius: "$radii$md",
    $$buttonPressedScale: .97,
    dflex: "center",
    appearance: "none",
    boxSizing: "border-box",
    fontWeight: "$medium",
    us: "none",
    lineHeight: "$sm",
    ta: "center",
    whiteSpace: "nowrap",
    transition: "$button",
    position: "relative",
    overflow: "hidden",
    border: "none",
    cursor: "pointer",
    pe: "auto",
    p: 0,
    br: "$$buttonBorderRadius",
    "@motion": {
        transition: "none"
    },
    ".nextui-button-text": {
        dflex: "center",
        zIndex: "$2",
        "p, pre, div": {
            margin: 0
        }
    },
    [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
        zIndex: "$1",
        ".nextui-drip-filler": {
            opacity: .25,
            fill: "$accents2"
        }
    },
    variants: {
        bordered: {
            true: {
                bg: "transparent",
                borderStyle: "solid",
                color: "$text"
            }
        },
        ghost: {
            true: {}
        },
        color: {
            default: {
                bg: "$primary",
                color: "$primarySolidContrast"
            },
            primary: {
                bg: "$primary",
                color: "$primarySolidContrast"
            },
            secondary: {
                bg: "$secondary",
                color: "$secondarySolidContrast"
            },
            success: {
                bg: "$success",
                color: "$successSolidContrast"
            },
            warning: {
                bg: "$warning",
                color: "$warningSolidContrast"
            },
            error: {
                bg: "$error",
                color: "$errorSolidContrast"
            },
            gradient: {
                bg: "$gradient",
                color: "$primarySolidContrast"
            }
        },
        size: {
            xs: {
                $$buttonPadding: "$space$3",
                $$buttonBorderRadius: "$radii$xs",
                $$buttonHeight: "$space$10",
                px: "$3",
                height: "$$buttonHeight",
                lh: "$space$10",
                width: "auto",
                minWidth: "$20",
                fontSize: "$xs"
            },
            sm: {
                $$buttonPadding: "$space$5",
                $$buttonBorderRadius: "$radii$sm",
                $$buttonHeight: "$space$12",
                px: "$5",
                height: "$$buttonHeight",
                lh: "$space$14",
                width: "auto",
                minWidth: "$36",
                fontSize: "$sm"
            },
            md: {
                $$buttonPadding: "$space$7",
                $$buttonBorderRadius: "$radii$md",
                $$buttonHeight: "$space$14",
                px: "$7",
                height: "$$buttonHeight",
                lh: "$space$14",
                width: "auto",
                minWidth: "$48",
                fontSize: "$sm"
            },
            lg: {
                $$buttonPadding: "$space$9",
                $$buttonBorderRadius: "$radii$base",
                $$buttonHeight: "$space$16",
                px: "$9",
                height: "$$buttonHeight",
                lh: "$space$15",
                width: "auto",
                minWidth: "$60",
                fontSize: "$md"
            },
            xl: {
                $$buttonPadding: "$space$10",
                $$buttonBorderRadius: "$radii$xl",
                $$buttonHeight: "$space$18",
                px: "$10",
                height: "$$buttonHeight",
                lh: "$space$17",
                width: "auto",
                minWidth: "$72",
                fontSize: "$lg"
            }
        },
        borderWeight: {
            light: {
                bw: "$light",
                $$buttonBorderWeight: "$borderWeights$light"
            },
            normal: {
                bw: "$normal",
                $$buttonBorderWeight: "$borderWeights$normal"
            },
            bold: {
                bw: "$bold",
                $$buttonBorderWeight: "$borderWeights$bold"
            },
            extrabold: {
                bw: "$extrabold",
                $$buttonBorderWeight: "$borderWeights$extrabold"
            },
            black: {
                bw: "$black",
                $$buttonBorderWeight: "$borderWeights$black"
            }
        },
        flat: {
            true: {
                color: "$text"
            }
        },
        light: {
            true: {
                bg: "transparent",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .8,
                        fill: "$accents2"
                    }
                }
            }
        },
        shadow: {
            true: {
                bs: "$sm"
            }
        },
        animated: {
            false: {
                transition: "none"
            }
        },
        auto: {
            true: {
                width: "auto",
                minWidth: "min-content"
            }
        },
        rounded: {
            true: {
                $$buttonBorderRadius: "$radii$pill"
            }
        },
        isPressed: {
            true: {}
        },
        isHovered: {
            true: {}
        },
        isChildLess: {
            true: {
                p: 0,
                width: "$$buttonHeight",
                height: "$$buttonHeight"
            }
        }
    },
    compoundVariants: [
        {
            isPressed: !0,
            animated: !0,
            css: {
                transform: "scale($$buttonPressedScale)"
            }
        },
        {
            auto: !0,
            isChildLess: !1,
            size: "xs",
            css: {
                px: "$5",
                minWidth: "min-content"
            }
        },
        {
            auto: !0,
            isChildLess: !1,
            size: "sm",
            css: {
                px: "$8",
                minWidth: "min-content"
            }
        },
        {
            auto: !0,
            isChildLess: !1,
            size: "md",
            css: {
                px: "$9",
                minWidth: "min-content"
            }
        },
        {
            auto: !0,
            isChildLess: !1,
            size: "lg",
            css: {
                px: "$10",
                minWidth: "min-content"
            }
        },
        {
            auto: !0,
            isChildLess: !1,
            size: "xl",
            css: {
                px: "$11",
                minWidth: "min-content"
            }
        },
        {
            shadow: !0,
            color: "default",
            css: {
                normalShadow: "$primaryShadow"
            }
        },
        {
            shadow: !0,
            color: "primary",
            css: {
                normalShadow: "$primaryShadow"
            }
        },
        {
            shadow: !0,
            color: "secondary",
            css: {
                normalShadow: "$secondaryShadow"
            }
        },
        {
            shadow: !0,
            color: "warning",
            css: {
                normalShadow: "$warningShadow"
            }
        },
        {
            shadow: !0,
            color: "success",
            css: {
                normalShadow: "$successShadow"
            }
        },
        {
            shadow: !0,
            color: "error",
            css: {
                normalShadow: "$errorShadow"
            }
        },
        {
            shadow: !0,
            color: "gradient",
            css: {
                normalShadow: "$primaryShadow"
            }
        },
        {
            light: !0,
            color: "default",
            css: {
                bg: "transparent",
                color: "$text",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .8,
                        fill: "$primaryLightActive"
                    }
                }
            }
        },
        {
            light: !0,
            color: "primary",
            css: {
                bg: "transparent",
                color: "$primary",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .8,
                        fill: "$primaryLightActive"
                    }
                }
            }
        },
        {
            light: !0,
            color: "secondary",
            css: {
                bg: "transparent",
                color: "$secondary",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .8,
                        fill: "$secondaryLightActive"
                    }
                }
            }
        },
        {
            light: !0,
            color: "warning",
            css: {
                bg: "transparent",
                color: "$warning",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .8,
                        fill: "$warningLightActive"
                    }
                }
            }
        },
        {
            light: !0,
            color: "success",
            css: {
                bg: "transparent",
                color: "$success",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .8,
                        fill: "$successLightActive"
                    }
                }
            }
        },
        {
            light: !0,
            color: "error",
            css: {
                bg: "transparent",
                color: "$error",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .8,
                        fill: "$errorLightActive"
                    }
                }
            }
        },
        {
            bordered: !0,
            color: "default",
            css: {
                bg: "transparent",
                borderColor: "$primary",
                color: "$primary",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        fill: "$primary"
                    }
                }
            }
        },
        {
            bordered: !0,
            color: "primary",
            css: {
                bg: "transparent",
                borderColor: "$primary",
                color: "$primary",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        fill: "$primary"
                    }
                }
            }
        },
        {
            bordered: !0,
            color: "secondary",
            css: {
                bg: "transparent",
                borderColor: "$secondary",
                color: "$secondary",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        fill: "$secondary"
                    }
                }
            }
        },
        {
            bordered: !0,
            color: "success",
            css: {
                bg: "transparent",
                borderColor: "$success",
                color: "$success",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        fill: "$success"
                    }
                }
            }
        },
        {
            bordered: !0,
            color: "warning",
            css: {
                bg: "transparent",
                borderColor: "$warning",
                color: "$warning",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        fill: "$warning"
                    }
                }
            }
        },
        {
            bordered: !0,
            color: "error",
            css: {
                bg: "transparent",
                borderColor: "$error",
                color: "$error",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        fill: "$error"
                    }
                }
            }
        },
        {
            bordered: !0,
            color: "gradient",
            css: {
                bg: "transparent",
                color: "$text",
                padding: "$$buttonBorderWeight",
                bgClip: "content-box, border-box",
                borderColor: "$primary",
                backgroundImage: "linear-gradient($background, $background), $gradient",
                border: "none",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        fill: "$secondary"
                    }
                }
            }
        },
        {
            ghost: !0,
            isHovered: !0,
            color: "default",
            css: {
                bg: "$primary",
                color: "$primarySolidContrast"
            }
        },
        {
            ghost: !0,
            isHovered: !0,
            color: "primary",
            css: {
                bg: "$primary",
                color: "$primarySolidContrast"
            }
        },
        {
            ghost: !0,
            isHovered: !0,
            color: "secondary",
            css: {
                bg: "$secondary",
                color: "$secondarySolidContrast"
            }
        },
        {
            ghost: !0,
            isHovered: !0,
            color: "success",
            css: {
                bg: "$success",
                color: "$successSolidContrast"
            }
        },
        {
            ghost: !0,
            isHovered: !0,
            color: "warning",
            css: {
                bg: "$warning",
                color: "$warningSolidContrast"
            }
        },
        {
            ghost: !0,
            isHovered: !0,
            color: "error",
            css: {
                bg: "$error",
                color: "$errorSolidContrast"
            }
        },
        {
            ghost: !0,
            color: "gradient",
            isHovered: !0,
            css: {
                bg: "$gradient",
                color: "$white"
            }
        },
        {
            flat: !0,
            color: "default",
            css: {
                bg: "$primaryLight",
                color: "$primaryLightContrast",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .4,
                        fill: "$primary"
                    }
                }
            }
        },
        {
            flat: !0,
            color: "primary",
            css: {
                bg: "$primaryLight",
                color: "$primaryLightContrast",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .4,
                        fill: "$primary"
                    }
                }
            }
        },
        {
            flat: !0,
            color: "secondary",
            css: {
                bg: "$secondaryLight",
                color: "$secondaryLightContrast",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .4,
                        fill: "$secondary"
                    }
                }
            }
        },
        {
            flat: !0,
            color: "success",
            css: {
                bg: "$successLight",
                color: "$successLightContrast",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .4,
                        fill: "$success"
                    }
                }
            }
        },
        {
            flat: !0,
            color: "warning",
            css: {
                bg: "$warningLight",
                color: "$warningLightContrast",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .4,
                        fill: "$warning"
                    }
                }
            }
        },
        {
            flat: !0,
            color: "error",
            css: {
                bg: "$errorLight",
                color: "$errorLightContrast",
                [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
                    ".nextui-drip-filler": {
                        opacity: .4,
                        fill: "$error"
                    }
                }
            }
        },
        {
            flat: !0,
            isHovered: !0,
            color: "default",
            css: {
                bg: "$primaryLightHover"
            }
        },
        {
            flat: !0,
            isHovered: !0,
            color: "primary",
            css: {
                bg: "$primaryLightHover"
            }
        },
        {
            flat: !0,
            isHovered: !0,
            color: "secondary",
            css: {
                bg: "$secondaryLightHover"
            }
        },
        {
            flat: !0,
            isHovered: !0,
            color: "success",
            css: {
                bg: "$successLightHover"
            }
        },
        {
            flat: !0,
            isHovered: !0,
            color: "warning",
            css: {
                bg: "$warningLightHover"
            }
        },
        {
            flat: !0,
            isHovered: !0,
            color: "error",
            css: {
                bg: "$errorLightHover"
            }
        },
        {
            flat: !0,
            isPressed: !0,
            color: "default",
            css: {
                bg: "$primaryLightActive"
            }
        },
        {
            flat: !0,
            isPressed: !0,
            color: "primary",
            css: {
                bg: "$primaryLightActive"
            }
        },
        {
            flat: !0,
            isPressed: !0,
            color: "secondary",
            css: {
                bg: "$secondaryLightActive"
            }
        },
        {
            flat: !0,
            isPressed: !0,
            color: "success",
            css: {
                bg: "$successLightActive"
            }
        },
        {
            flat: !0,
            isPressed: !0,
            color: "warning",
            css: {
                bg: "$warningLightActive"
            }
        },
        {
            flat: !0,
            isPressed: !0,
            color: "error",
            css: {
                bg: "$errorLightActive"
            }
        },
        {
            auto: !0,
            color: "gradient",
            bordered: !0,
            css: {
                ".nextui-button-text": {
                    px: "$$buttonPadding"
                },
                ".nextui-button-icon": {
                    ml: "$$buttonPadding"
                },
                ".nextui-button-icon-right": {
                    mr: "$$buttonPadding"
                },
                ".nextui-button-text-left": {
                    pl: 0
                },
                ".nextui-button-text-right": {
                    pr: 0
                }
            }
        },
        {
            rounded: !0,
            size: "xs",
            css: {
                br: "$pill"
            }
        },
        {
            rounded: !0,
            size: "sm",
            css: {
                br: "$pill"
            }
        },
        {
            rounded: !0,
            size: "md",
            css: {
                br: "$pill"
            }
        },
        {
            rounded: !0,
            size: "lg",
            css: {
                br: "$pill"
            }
        },
        {
            rounded: !0,
            size: "xl",
            css: {
                br: "$pill"
            }
        }
    ],
    defaultVariants: {
        color: "default",
        borderWeight: "normal",
        animated: !0,
        size: "md"
    }
}, (0, $eaf275b21629a4ec$export$ab780f34ea253ed3), (0, $eaf275b21629a4ec$export$6215605c4cb3914a));
var $5fbe2f5a607c3031$export$2e2bcd8739ae039 = $5fbe2f5a607c3031$export$2d5d2ba3c7c8c40b;




var $acw62 = parcelRequire("acw62");
function $97d849037ea9c63e$export$71594e8a50f746f4() {
    return !("undefined" == typeof window || !window.document || !window.document.createElement);
}
const $97d849037ea9c63e$export$4e09c449d6c407f7 = $97d849037ea9c63e$export$71594e8a50f746f4();
function $97d849037ea9c63e$export$568a7d21694b4b32(e) {
    const { userAgent: t } = e;
    return /(tablet)|(iPad)|(Nexus 9)/i.test(t) ? "tablet" : /(mobi)/i.test(t) ? "phone" : "desktop";
}
function $97d849037ea9c63e$export$3070bd282ec37ea8(e) {
    return !!$97d849037ea9c63e$export$4e09c449d6c407f7 && function(e) {
        const { userAgent: t, platform: r } = e;
        switch(!0){
            case /Android/.test(t):
                return "Android";
            case /iPhone|iPad|iPod/.test(r):
                return "iOS";
            case /Win/.test(r):
                return "Windows";
            case /Mac/.test(r):
                return "Mac";
            case /CrOS/.test(t):
                return "Chrome OS";
            case /Firefox/.test(t):
                return "Firefox OS";
            default:
                return null;
        }
    }(window.navigator) === e;
}
function $97d849037ea9c63e$export$2d31490a0c05f094(e) {
    return !!$97d849037ea9c63e$export$4e09c449d6c407f7 && function(e) {
        const { userAgent: t, vendor: r } = e, n = /(android)/i.test(t);
        switch(!0){
            case /CriOS/.test(t):
                return "Chrome for iOS";
            case /Edg\//.test(t):
                return "Edge";
            case n && /Silk\//.test(t):
                return "Silk";
            case /Chrome/.test(t) && /Google Inc/.test(r):
                return "Chrome";
            case /Firefox\/\d+\.\d+$/.test(t):
                return "Firefox";
            case n:
                return "AOSP";
            case /MSIE|Trident/.test(t):
                return "IE";
            case /Safari/.test(e.userAgent) && /Apple Computer/.test(t):
                return "Safari";
            case /AppleWebKit/.test(t):
                return "WebKit";
            default:
                return null;
        }
    }(window.navigator) === e;
}
function $97d849037ea9c63e$export$8d04c8cf4d9e22d8() {
    return !!$97d849037ea9c63e$export$4e09c449d6c407f7 && null === window.ontouchstart && null === window.ontouchmove && null === window.ontouchend;
}
function $97d849037ea9c63e$export$a5795cc979dfae80(e) {
    return {
        UNSAFE_getDOMNode: ()=>e.current
    };
}
function $97d849037ea9c63e$export$79d69eee6ae4b329(e, t = e) {
    return {
        ...$97d849037ea9c63e$export$a5795cc979dfae80(e),
        focus () {
            t.current && t.current.focus();
        }
    };
}
function $97d849037ea9c63e$export$c2c55ef9111cafd8(t) {
    const n = (0, $acw62.useRef)(null);
    return (0, $acw62.useImperativeHandle)(t, ()=>n.current), n;
}
function $97d849037ea9c63e$export$96a734597687c040(t, n) {
    const o = (0, $acw62.useRef)(null);
    return (0, $acw62.useImperativeHandle)(t, ()=>$97d849037ea9c63e$export$79d69eee6ae4b329(o, n)), o;
}
function $97d849037ea9c63e$export$4debdb1a3f0fa79e(e, r) {
    (0, $acw62.useLayoutEffect)(()=>{
        if (e && e.ref && r && r.current) return e.ref.current = r.current, ()=>{
            var t;
            null != (t = e.ref) && t.current && (e.ref.current = null);
        };
    }, [
        e,
        r
    ]);
}


const $9013ad1f954747ab$export$a866f231438cc228 = false;
const $9013ad1f954747ab$export$61cb32cff9a99948 = false;
function $9013ad1f954747ab$export$43bee75e5e14138e(t) {
    return Array.isArray(t);
}
function $9013ad1f954747ab$export$4c0262a4f954db45(t) {
    return $9013ad1f954747ab$export$43bee75e5e14138e(t) && 0 === t.length;
}
function $9013ad1f954747ab$export$a6cdc56e425d0d0a(t) {
    const r = typeof t;
    return null != t && ("object" === r || "function" === r) && !$9013ad1f954747ab$export$43bee75e5e14138e(t);
}
function $9013ad1f954747ab$export$83b788b1a3698c03(t) {
    return $9013ad1f954747ab$export$a6cdc56e425d0d0a(t) && 0 === Object.keys(t).length;
}
function $9013ad1f954747ab$export$dd1bc94b04021eeb(t) {
    return $9013ad1f954747ab$export$43bee75e5e14138e(t) ? $9013ad1f954747ab$export$4c0262a4f954db45(t) : $9013ad1f954747ab$export$a6cdc56e425d0d0a(t) ? $9013ad1f954747ab$export$83b788b1a3698c03(t) : null == t || "" === t;
}
function $9013ad1f954747ab$export$f6e2535fb5126e54(t) {
    return "function" == typeof t;
}



const $871034e6c44745ee$var$y = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ as: h, css: y, iconLeftCss: v, iconRightCss: F, onClick: N, onPress: B, onPressStart: j, onPressEnd: w, onPressChange: R, onPressUp: S, ...k }, U)=>{
    const T = (0, $b97313e89f3393f8$export$85d63e852e3be3b3)(), A = (0, $10aa0e63a29ca4bc$export$4c9c434877f2e91e)(k, T), D = (0, $10aa0e63a29ca4bc$export$5b27f6dd7aa65003)(A), { flat: E, children: G, disabled: H, animated: L, light: V, ripple: W, bordered: I, auto: $, borderWeight: q, icon: z, iconRight: J, ghost: K, autoFocus: M, className: O, ...Q } = A, X = (t)=>{
        L && W && Y.current && st(t);
    }, Y = (0, $97d849037ea9c63e$export$c2c55ef9111cafd8)(U), { buttonProps: Z, isPressed: _ } = (0, $0765cc1e8d6648f2$export$ea18c227d4417cc3)({
        ...k,
        onClick: (t)=>{
            X(t), null == N || N(t);
        },
        isDisabled: H,
        elementType: h,
        onPress: (t)=>{
            "keyboard" !== t.pointerType && "virtual" !== t.pointerType || (X(t), null == N || N(t)), null == B || B(t);
        },
        onPressStart: j,
        onPressEnd: w,
        onPressChange: R,
        onPressUp: S
    }, Y), { hoverProps: tt, isHovered: ot } = (0, $895d146aa86f8a19$export$ae780daf29e6d456)({
        isDisabled: H
    }), { isFocused: rt, isFocusVisible: et, focusProps: it } = (0, $066ee5e43859dd8f$export$4e328f61c538687f)({
        autoFocus: M
    }), { onClick: st, ...nt } = (0, $6980a7fe0d40944d$export$2e2bcd8739ae039)(!1, Y);
    (0, $9013ad1f954747ab$export$a866f231438cc228) && "gradient" === A.color && (E || V) && (0, $364cddea3adf1f69$export$2e2bcd8739ae039)("Using the gradient color on flat and light buttons will have no effect.");
    const at = z || J, lt = 0 === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(G), ut = Boolean(J), dt = (0, $acw62.useMemo)(()=>_ ? "pressed" : ot ? "hovered" : H ? "disabled" : "ready", [
        H,
        ot,
        _
    ]), ct = (0, $acw62.useMemo)(()=>ut ? F : v, [
        ut,
        F,
        v
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $5fbe2f5a607c3031$export$2e2bcd8739ae039), {
        as: h,
        ref: Y,
        borderWeight: q,
        auto: $,
        flat: E,
        light: V,
        ghost: K,
        bordered: I || K,
        "data-state": dt,
        animated: L,
        isChildLess: lt,
        isPressed: _,
        isHovered: ot || K && rt,
        isFocusVisible: et && !H,
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-button", `nextui-button--${dt}`, O),
        css: {
            ...y,
            ...D
        },
        ...(0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(Z, it, tt, Q),
        children: [
            0 === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(G) ? (0, $7b02d682eb115277$exports.jsx)((0, $635d39c539a13295$export$2e2bcd8739ae039), {
                isSingle: !0,
                isAuto: $,
                isRight: ut,
                css: ct,
                isGradientButtonBorder: "gradient" === Q.color && (I || K),
                children: at
            }) : at ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $635d39c539a13295$export$2e2bcd8739ae039), {
                        isSingle: !1,
                        isAuto: $,
                        isRight: ut,
                        css: ct,
                        isGradientButtonBorder: "gradient" === Q.color && (I || K),
                        children: at
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-button-text", {
                            "nextui-button-text-right": ut,
                            "nextui-button-text-left": !ut
                        }),
                        children: G
                    })
                ]
            }) : (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "nextui-button-text",
                children: G
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $29aa2688f5aace4f$export$2e2bcd8739ae039), {
                color: "white",
                ...nt
            })
        ]
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($871034e6c44745ee$var$y.displayName = "NextUI.Button"), $871034e6c44745ee$var$y.toString = ()=>".nextui-button";
var $871034e6c44745ee$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($871034e6c44745ee$var$y, {
    ghost: !1,
    bordered: !1,
    ripple: !0,
    animated: !0,
    disabled: !1,
    autoFocus: !1,
    auto: !1,
    className: "",
    type: "button"
});



var $acw62 = parcelRequire("acw62");




const $c1875bc3e1db807d$export$a240dc0ccf211 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    display: "inline-flex",
    margin: "$3",
    backgroundColor: "transparent",
    height: "min-content",
    [`& ${0, $5fbe2f5a607c3031$export$2e2bcd8739ae039}`]: {
        ".nextui-button-text": {
            top: 0
        }
    },
    variants: {
        vertical: {
            true: {
                fd: "column",
                [`& ${0, $5fbe2f5a607c3031$export$2e2bcd8739ae039}`]: {
                    "&:not(:first-child)": {
                        btlr: 0,
                        btrr: 0
                    },
                    "&:not(:last-child)": {
                        bblr: 0,
                        bbrr: 0
                    }
                }
            },
            false: {
                fd: "row",
                [`& ${0, $5fbe2f5a607c3031$export$2e2bcd8739ae039}`]: {
                    "&:not(:first-child)": {
                        btlr: 0,
                        bblr: 0
                    },
                    "&:not(:last-child)": {
                        btrr: 0,
                        bbrr: 0
                    }
                }
            }
        },
        size: {
            xs: {
                br: "$xs"
            },
            sm: {
                br: "$sm"
            },
            md: {
                br: "$md"
            },
            lg: {
                br: "$base"
            },
            xl: {
                br: "$xl"
            }
        },
        rounded: {
            true: {
                br: "$pill"
            }
        },
        bordered: {
            true: {
                bg: "transparent"
            }
        },
        gradient: {
            true: {
                pl: 0
            }
        }
    },
    defaultVariants: {
        vertical: !1
    },
    compoundVariants: [
        {
            bordered: !0,
            vertical: !0,
            css: {
                [`& ${0, $5fbe2f5a607c3031$export$2e2bcd8739ae039}`]: {
                    "&:not(:last-child)": {
                        borderBottom: "none",
                        paddingBottom: "0"
                    }
                }
            }
        },
        {
            bordered: !0,
            vertical: !1,
            css: {
                [`& ${0, $5fbe2f5a607c3031$export$2e2bcd8739ae039}`]: {
                    "&:not(:first-child)": {
                        borderLeft: "none"
                    }
                }
            }
        },
        {
            bordered: !0,
            vertical: !1,
            gradient: !0,
            css: {
                [`& ${0, $5fbe2f5a607c3031$export$2e2bcd8739ae039}`]: {
                    "&:not(:last-child)&:not(:first-child)": {
                        pl: 0
                    },
                    "&:last-child": {
                        pl: 0
                    }
                }
            }
        }
    ]
});
var $c1875bc3e1db807d$export$2e2bcd8739ae039 = $c1875bc3e1db807d$export$a240dc0ccf211;



const $3cb376c86ac9c410$var$a = (o)=>{
    const { disabled: t, size: a, color: l, bordered: n, ghost: s, light: u, flat: m, shadow: p, auto: c, animated: g, rounded: h, ripple: b, borderWeight: f, children: x, ...z } = o, w = (0, $acw62.useMemo)(()=>({
            disabled: t,
            size: a,
            color: l,
            bordered: n,
            light: u,
            ghost: s,
            flat: m,
            shadow: p,
            auto: c,
            borderWeight: f,
            animated: g,
            rounded: h,
            ripple: b,
            isButtonGroup: !0
        }), [
        t,
        g,
        a,
        b,
        l,
        n,
        u,
        s,
        m,
        f
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $b97313e89f3393f8$export$4c574c91bb0be0e2).Provider, {
        value: w,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $c1875bc3e1db807d$export$2e2bcd8739ae039), {
            size: a,
            bordered: n || s,
            gradient: "gradient" === o.color,
            ...z,
            children: x
        })
    });
};
$3cb376c86ac9c410$var$a.toString = ()=>".nextui-button-group";
const $3cb376c86ac9c410$var$l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($3cb376c86ac9c410$var$a);
var $3cb376c86ac9c410$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($3cb376c86ac9c410$var$l, {
    borderWeight: "normal",
    size: "md",
    color: "default"
});





(0, $871034e6c44745ee$export$2e2bcd8739ae039).Group = (0, $3cb376c86ac9c410$export$2e2bcd8739ae039);
var $f992dede62d0c3b0$export$2e2bcd8739ae039 = (0, $871034e6c44745ee$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





const $53d96b676f71ea35$export$5a0763f6a9ca51f0 = (l)=>{
    const { ref: n, disableAnimation: c = !1, disableRipple: p = !1, variant: d = "shadow", isHoverable: u = !1, borderWeight: m = "light", isPressable: b = !1, onClick: P, onPress: f, autoFocus: v, allowTextSelectionOnPress: C = !0, ...g } = l, h = (0, $97d849037ea9c63e$export$c2c55ef9111cafd8)(n), { onClick: k, ...F } = (0, $6980a7fe0d40944d$export$2e2bcd8739ae039)(!1, h), H = (r)=>{
        c || p || !h.current || k(r);
    }, { isPressed: T, pressProps: w } = (0, $895d146aa86f8a19$export$45712eceda6fad21)({
        isDisabled: !b,
        onPress: (r)=>{
            "keyboard" !== r.pointerType && "virtual" !== r.pointerType || (H(r), null == P || P(r)), null == f || f(r);
        },
        allowTextSelectionOnPress: C,
        ...g
    }), { hoverProps: x, isHovered: y } = (0, $895d146aa86f8a19$export$ae780daf29e6d456)({
        isDisabled: !u,
        ...g
    }), { isFocusVisible: D, focusProps: R } = (0, $066ee5e43859dd8f$export$4e328f61c538687f)({
        autoFocus: v
    });
    w.onClick = (r)=>{
        b && (H(r), null == P || P(r));
    };
    const A = (0, $acw62.useCallback)((r = {})=>({
            ...(0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(b ? {
                ...w,
                ...R
            } : {}, u ? x : {}, g, r)
        }), [
        b,
        u,
        w,
        R,
        x,
        g
    ]);
    return {
        cardRef: h,
        variant: d,
        borderWeight: m,
        isPressable: b,
        isHovered: y,
        isPressed: T,
        disableAnimation: c,
        disableRipple: p,
        dripBindings: F,
        onDripClickHandler: k,
        isFocusVisible: D,
        getCardProps: A
    };
};





const $2065034be2b982f3$export$82f012556775e1e0 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    d: "flex",
    w: "100%",
    h: "auto",
    flex: "1 1 auto",
    fd: "column",
    jc: "inherit",
    ai: "inherit",
    ac: "inherit",
    py: "$lg",
    px: "$sm",
    oy: "auto",
    position: "relative",
    ta: "left"
});
const $2065034be2b982f3$export$94fdbc1f5368d5e4 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    $$cardColor: "$colors$backgroundContrast",
    $$cardTextColor: "$colors$text",
    m: 0,
    p: 0,
    br: "$lg",
    bg: "$$cardColor",
    color: "$$cardTextColor",
    position: "relative",
    display: "flex",
    overflow: "hidden",
    fd: "column",
    width: "100%",
    height: "auto",
    boxSizing: "border-box",
    "@motion": {
        transition: "none"
    },
    ".nextui-image": {
        width: "100%"
    },
    [`& ${0, $29aa2688f5aace4f$export$43b4b309f2c2c56}`]: {
        zIndex: "$1",
        ".nextui-drip-filler": {
            opacity: .25,
            fill: "$accents6"
        }
    },
    variants: {
        variant: {
            flat: {
                bg: "$accents0"
            },
            shadow: {
                dropShadow: "$lg"
            },
            bordered: {
                borderStyle: "solid",
                borderColor: "$border"
            }
        },
        borderWeight: {
            light: {
                bw: "$light"
            },
            normal: {
                bw: "$normal"
            },
            bold: {
                bw: "$bold"
            },
            extrabold: {
                bw: "$extrabold"
            },
            black: {
                bw: "$black"
            }
        },
        disableAnimation: {
            true: {
                transition: "none"
            },
            false: {
                transition: "$card"
            }
        },
        isPressable: {
            true: {
                cursor: "pointer",
                us: "none",
                WebkitTapHighlightColor: "transparent"
            }
        },
        isPressed: {
            true: {}
        },
        isHovered: {
            true: {
                dropShadow: "$lg"
            }
        }
    },
    compoundVariants: [
        {
            isPressed: !0,
            disableAnimation: !1,
            css: {
                transform: "scale(0.97)"
            }
        },
        {
            isHovered: !0,
            disableAnimation: !1,
            css: {
                transform: "translateY(-2px)"
            }
        },
        {
            isHovered: !0,
            variant: "shadow",
            css: {
                dropShadow: "$xl"
            }
        }
    ]
}, (0, $eaf275b21629a4ec$export$18f796664128d249), (0, $eaf275b21629a4ec$export$ab780f34ea253ed3));
const $2065034be2b982f3$export$ba53cfdd0b588374 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    w: "100%",
    display: "flex",
    flexShrink: 0,
    zIndex: "$1",
    jc: "flex-start",
    ai: "center",
    overflow: "hidden",
    color: "inherit",
    p: "$sm"
});
const $2065034be2b982f3$export$bee47a86873bd046 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    w: "100%",
    h: "auto",
    p: "$sm",
    d: "flex",
    ai: "center",
    overflow: "hidden",
    color: "inherit",
    bblr: "$lg",
    bbrr: "$lg",
    variants: {
        isBlurred: {
            true: {
                bf: "saturate(180%) blur(10px)",
                bg: "$$cardColor"
            }
        }
    }
});




const $78888fddaba3d167$var$d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ ...r }, t)=>{
    const { as: d, css: n, children: m, ...c } = r, { cardRef: l, variant: p, isFocusVisible: f, isPressable: b, isPressed: u, disableAnimation: x, disableRipple: g, borderWeight: P, isHovered: h, getCardProps: j, dripBindings: v } = (0, $53d96b676f71ea35$export$5a0763f6a9ca51f0)({
        ...c,
        ref: t
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $2065034be2b982f3$export$94fdbc1f5368d5e4), {
        ref: l,
        as: d,
        css: n,
        variant: p,
        role: b ? "button" : "section",
        borderWeight: P,
        disableAnimation: x,
        isPressable: b,
        isPressed: u,
        isHovered: h,
        tabIndex: b ? 0 : -1,
        isFocusVisible: f,
        ...j(),
        children: [
            b && !x && !g && (0, $7b02d682eb115277$exports.jsx)((0, $29aa2688f5aace4f$export$2e2bcd8739ae039), {
                ...v
            }),
            m
        ]
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($78888fddaba3d167$var$d.displayName = "NextUI.Card"), $78888fddaba3d167$var$d.toString = ()=>".nextui-card";
var $78888fddaba3d167$export$2e2bcd8739ae039 = $78888fddaba3d167$var$d;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $2167742a50c97e20$var$i = (0, $07d095cbefc9a288$export$d25ddfdf17c3ad3e)({
    "0%": {
        backgroundPosition: "200% 0"
    },
    to: {
        backgroundPosition: "-200% 0"
    }
});
const $2167742a50c97e20$export$1fdc50e443dc776c = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    opacity: 0,
    margin: "0 auto",
    position: "relative",
    overflow: "hidden",
    maxWidth: "100%",
    transition: "transform 250ms ease 0ms, opacity 200ms ease-in 0ms",
    "@motion": {
        transition: "none"
    },
    variants: {
        ready: {
            true: {
                opacity: 1
            },
            false: {
                opacity: 0
            }
        }
    }
});
const $2167742a50c97e20$export$7722b1870d9eec03 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("img", {
    size: "100%",
    display: "block"
});
const $2167742a50c97e20$export$5112170e4bfc35cb = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    size: "100%",
    borderRadius: "inherit",
    backgroundImage: "linear-gradient(270deg, $colors$accents1, $colors$accents2, $colors$accents2, $colors$accents1)",
    backgroundSize: "400% 100%",
    animation: `${$2167742a50c97e20$var$i} 5s ease-in-out infinite`,
    transition: "opacity 300ms ease-out"
});





const $3d27507be56a584f$var$a = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ opacity: t, css: e, className: o, ...a })=>(0, $7b02d682eb115277$exports.jsx)((0, $2167742a50c97e20$export$5112170e4bfc35cb), {
        css: {
            opacity: t,
            ...e
        },
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-image-skeleton", o),
        ...a
    }));
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($3d27507be56a584f$var$a.displayName = "NextUI.ImageSkeleton"), $3d27507be56a584f$var$a.toString = ()=>".nextui-image-skeleton";
var $3d27507be56a584f$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($3d27507be56a584f$var$a, {
    opacity: .5,
    className: ""
});



var $acw62 = parcelRequire("acw62");
const $467a2c39f088c805$var$i = (t, e)=>{
    if (!t) return 0;
    const i = t.includes("px") ? +t.split("px")[0] : t.includes("%") ? +t.split("%")[0] * e * .01 : t;
    return Number.isNaN(+i) ? 0 : +i;
};
const $467a2c39f088c805$export$862e833e9cfd9220 = (t)=>{
    if (!t || "undefined" == typeof window) return {
        width: 0,
        height: 0
    };
    const e = t.getBoundingClientRect(), { width: h, height: n } = window.getComputedStyle(t);
    return {
        width: $467a2c39f088c805$var$i(`${h}`, e.width),
        height: $467a2c39f088c805$var$i(`${n}`, e.height)
    };
};
var $467a2c39f088c805$export$2e2bcd8739ae039 = (i)=>{
    const [h, n] = (0, $acw62.useState)({
        width: 0,
        height: 0
    }), r = ()=>{
        const { width: t, height: e } = $467a2c39f088c805$export$862e833e9cfd9220(i.current);
        n({
            width: t,
            height: e
        });
    };
    return (0, $acw62.useEffect)(()=>r(), [
        i.current
    ]), [
        h,
        r
    ];
};


var $e923d5d8a906c227$export$2e2bcd8739ae039 = (0, $467a2c39f088c805$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
var $a1f9909621014f64$export$2e2bcd8739ae039 = (e)=>{
    const [o, c] = (0, $acw62.useState)(()=>"function" == typeof e ? e() : e), u = (0, $acw62.useRef)(e);
    (0, $acw62.useEffect)(()=>{
        u.current = o;
    }, [
        o
    ]);
    return [
        o,
        (t)=>{
            const r = "function" == typeof t ? t(u.current) : t;
            u.current = r, c(r);
        },
        u
    ];
};


var $a5e1d70388331739$export$2e2bcd8739ae039 = (0, $a1f9909621014f64$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
var $d88faf3e36a7a2ff$export$2e2bcd8739ae039 = (r, t = !0)=>{
    (0, $acw62.useEffect)(()=>{
        const e = ()=>r();
        return t && e(), window.addEventListener("resize", e), ()=>window.removeEventListener("resize", e);
    }, []);
};


var $c06a267e555cb80f$export$2e2bcd8739ae039 = (0, $d88faf3e36a7a2ff$export$2e2bcd8739ae039);







const $308269dc9eff86c6$export$3e431a229df88919 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((t, c)=>{
    const { src: g, width: h, height: x, showSkeleton: w = !0, className: y, maxDelay: j = 3e3, autoResize: I = !1, objectFit: N = "scale-down", containerCss: b, css: T, ...$ } = t, k = (0, $97d849037ea9c63e$export$c2c55ef9111cafd8)(c), [z, F] = (0, $acw62.useState)(!0), [R, S] = (0, $acw62.useState)(w), { w: C, h: D } = (0, $acw62.useMemo)(()=>({
            w: h ? "number" == typeof h ? `${h}px` : h : "auto",
            h: x ? "number" == typeof x ? `${x}px` : x : "auto"
        }), [
        h,
        x
    ]), [L, U, q] = (0, $a5e1d70388331739$export$2e2bcd8739ae039)(D), [v, A] = (0, $e923d5d8a906c227$export$2e2bcd8739ae039)(k), B = w && !!h && !!x;
    (0, $acw62.useEffect)(()=>{
        k.current && k.current.complete && (F(!1), S(!1));
    }), (0, $acw62.useEffect)(()=>{
        const t = setTimeout(()=>{
            B && S(!1), clearTimeout(t);
        }, j);
        return ()=>clearTimeout(t);
    }, [
        z
    ]), (0, $acw62.useEffect)(()=>{
        if (!I) return;
        const t = 0 === v.width, e = "auto" === q.current;
        !t && h && x && (v.width < h ? !e && U("auto") : e && U(D));
    }, [
        v,
        h
    ]), (0, $c06a267e555cb80f$export$2e2bcd8739ae039)(()=>{
        I && A();
    });
    const E = (0, $acw62.useMemo)(()=>z ? "loading" : "ready", [
        z
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $2167742a50c97e20$export$1fdc50e443dc776c), {
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-image-container", `nextui-image--${E}`, y),
        "data-state": E,
        ready: !z || R,
        css: {
            width: C,
            height: L,
            ...b
        },
        children: [
            R && (0, $7b02d682eb115277$exports.jsx)((0, $3d27507be56a584f$export$2e2bcd8739ae039), {
                opacity: 1
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $2167742a50c97e20$export$7722b1870d9eec03), {
                ref: k,
                className: "nextui-image",
                width: h,
                height: x,
                onLoad: ()=>{
                    F(!1);
                },
                src: g,
                "data-state": E,
                alt: t.alt || "",
                css: {
                    objectFit: N,
                    ...T
                },
                ...$
            })
        ]
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($308269dc9eff86c6$export$3e431a229df88919.displayName = "NextUI.Image"), $308269dc9eff86c6$export$3e431a229df88919.toString = ()=>".nextui-image";
var $308269dc9eff86c6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($308269dc9eff86c6$export$3e431a229df88919);



var $802d2e2c16c7bd56$export$2e2bcd8739ae039 = (0, $308269dc9eff86c6$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

const $5dc879e0b33094f3$export$1bc603050bd777b1 = (t)=>`calc(${15.25 * t}pt + 1px * ${t - 1})`;



const $c49e06d76d9fd2c1$export$9314d5080fde0336 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    width: "100%",
    maxWidth: "100%",
    position: "relative",
    variants: {
        color: {
            default: {
                bg: "$border"
            },
            primary: {
                bg: "$primary"
            },
            secondary: {
                bg: "$secondary"
            },
            success: {
                bg: "$success"
            },
            warning: {
                bg: "$warning"
            },
            error: {
                bg: "$error"
            }
        }
    },
    defaultVariants: {
        color: "default"
    }
});
const $c49e06d76d9fd2c1$export$5f88987e21d9638c = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {
    position: "absolute",
    left: "50%",
    top: "50%",
    minHeight: "100%",
    display: "inline-flex",
    jc: "center",
    ai: "center",
    transform: "translate(-50%, -50%)",
    padding: "0 $lg",
    fontSize: "$base",
    fontWeight: "bold",
    textTransform: "capitalize",
    backgroundColor: "$background",
    zIndex: "$1",
    variants: {
        color: {
            default: {
                color: "$text"
            },
            primary: {
                color: "$primary"
            },
            secondary: {
                color: "$secondary"
            },
            success: {
                color: "$success"
            },
            warning: {
                color: "$warning"
            },
            error: {
                color: "$error"
            }
        }
    }
});



const $87f2334430dca5c5$var$a = ({ height: t, x: e, y: a, align: l, children: m, textColor: c, css: d, ...f })=>{
    const h = (0, $acw62.useMemo)(()=>l && "center" !== l ? "left" === l || "start" === l ? {
            transform: "translateY(-50%)",
            left: "7%"
        } : {
            transform: "translateY(-50%)",
            left: "auto",
            right: "7%"
        } : "", [
        l
    ]), x = a ? (0, $5dc879e0b33094f3$export$1bc603050bd777b1)(a / 2) : 0, u = e ? (0, $5dc879e0b33094f3$export$1bc603050bd777b1)(e / 2) : 0;
    return (0, $7b02d682eb115277$exports.jsx)((0, $c49e06d76d9fd2c1$export$9314d5080fde0336), {
        role: "separator",
        css: {
            margin: `${x} ${u}`,
            height: `calc(${t} * 1px)`,
            ...d
        },
        ...f,
        children: m && (0, $7b02d682eb115277$exports.jsx)((0, $c49e06d76d9fd2c1$export$5f88987e21d9638c), {
            css: {
                ...h
            },
            color: c,
            className: "nextui-divider-text",
            children: m
        })
    });
};
$87f2334430dca5c5$var$a.toString = ()=>".nextui-divider";
const $87f2334430dca5c5$var$l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($87f2334430dca5c5$var$a);
var $87f2334430dca5c5$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($87f2334430dca5c5$var$l, {
    x: 0,
    y: 0,
    height: 1,
    align: "center"
});



var $9d60ef386467ded1$export$2e2bcd8739ae039 = (0, $87f2334430dca5c5$export$2e2bcd8739ae039);


(0, $78888fddaba3d167$export$2e2bcd8739ae039).Header = (0, $2065034be2b982f3$export$ba53cfdd0b588374), (0, $78888fddaba3d167$export$2e2bcd8739ae039).Body = (0, $2065034be2b982f3$export$82f012556775e1e0), (0, $78888fddaba3d167$export$2e2bcd8739ae039).Footer = (0, $2065034be2b982f3$export$bee47a86873bd046), (0, $78888fddaba3d167$export$2e2bcd8739ae039).Image = (0, $802d2e2c16c7bd56$export$2e2bcd8739ae039), (0, $78888fddaba3d167$export$2e2bcd8739ae039).Divider = (0, $9d60ef386467ded1$export$2e2bcd8739ae039);
var $92b7149304f358a3$export$2e2bcd8739ae039 = (0, $78888fddaba3d167$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $2b990b0da8e57c7d$export$b09ac097686f548b = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {});
const $2b990b0da8e57c7d$export$b89c593c33710f10 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    margin: 0,
    boxSizing: "border-box",
    padding: "$$gridGapUnit"
});





const $a01cfc3fe6744cfa$var$l = (t)=>{
    const s = 0 === t ? "none" : "inherit";
    if ("number" == typeof t) {
        const e = 100 / 12 * t, i = e > 100 ? "100%" : e < 0 ? "0" : `${e}%`;
        return {
            flexGrow: 0,
            display: s,
            maxWidth: i,
            flexBasis: i
        };
    }
    return {
        flexGrow: 1,
        display: s,
        maxWidth: "100%",
        flexBasis: "0"
    };
}, $a01cfc3fe6744cfa$var$n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ xs: t, sm: r, md: n, lg: o, xl: x, css: a, justify: d, direction: c, alignItems: f, alignContent: u, children: g, className: p, ...y }, h)=>{
    const j = (0, $acw62.useMemo)(()=>{
        const s = {
            xs: t,
            sm: r,
            md: n,
            lg: o,
            xl: x
        };
        return Object.keys(s).reduce((t, e)=>void 0 !== s[e] && !1 !== s[e] ? `${t} ${e}` : t, "").trim();
    }, [
        t,
        r,
        n,
        o,
        x
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $2b990b0da8e57c7d$export$b89c593c33710f10), {
        ref: h,
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-grid-item", j, p),
        css: {
            alignItems: f,
            alignContent: u,
            justifyContent: d,
            flexDirection: c,
            "&.xs": {
                ...$a01cfc3fe6744cfa$var$l(t)
            },
            "@xsMax": {
                "&.xs": {
                    ...$a01cfc3fe6744cfa$var$l(t)
                }
            },
            "@sm": {
                "&.sm": {
                    ...$a01cfc3fe6744cfa$var$l(r)
                }
            },
            "@md": {
                "&.md": {
                    ...$a01cfc3fe6744cfa$var$l(n)
                }
            },
            "@lg": {
                "&.lg": {
                    ...$a01cfc3fe6744cfa$var$l(o)
                }
            },
            "@xl": {
                "&.xl": {
                    ...$a01cfc3fe6744cfa$var$l(x)
                }
            },
            ...a
        },
        ...y,
        children: g
    });
});
$a01cfc3fe6744cfa$var$n.displayName = "NextUI.GridItem", $a01cfc3fe6744cfa$var$n.toString = ()=>".nextui-grid-item";
var $a01cfc3fe6744cfa$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($a01cfc3fe6744cfa$var$n, {
    xs: !1,
    sm: !1,
    md: !1,
    lg: !1,
    xl: !1,
    className: ""
});



const $78df073a8e6a3a91$var$i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: r, css: i, ...o }, m)=>(0, $7b02d682eb115277$exports.jsx)((0, $a01cfc3fe6744cfa$export$2e2bcd8739ae039), {
        ref: m,
        css: {
            ...i
        },
        ...o,
        children: r
    }));
$78df073a8e6a3a91$var$i.displayName = "NextUI.Grid", $78df073a8e6a3a91$var$i.toString = ()=>".nextui-grid";
var $78df073a8e6a3a91$export$2e2bcd8739ae039 = $78df073a8e6a3a91$var$i;



var $acw62 = parcelRequire("acw62");




const $5772711effa0e33b$var$c = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ gap: r, wrap: e, css: c, children: o, className: n, ...p }, l)=>{
    const m = (0, $acw62.useMemo)(()=>`calc(${r} * $space$3)`, [
        r
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $a01cfc3fe6744cfa$export$2e2bcd8739ae039), {
        ref: l,
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-grid-container", n),
        css: {
            $$gridGapUnit: m,
            display: "flex",
            flexWrap: e,
            boxSizing: "border-box",
            margin: "calc(-1 * $$gridGapUnit)",
            width: "calc(100% + $$gridGapUnit * 2)",
            ...c
        },
        ...p,
        children: o
    });
});
$5772711effa0e33b$var$c.displayName = "NextUI.GridContainer", $5772711effa0e33b$var$c.toString = ()=>".nextui-grid-container";
var $5772711effa0e33b$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($5772711effa0e33b$var$c, {
    gap: 0,
    wrap: "wrap",
    className: ""
});



(0, $78df073a8e6a3a91$export$2e2bcd8739ae039).Container = (0, $5772711effa0e33b$export$2e2bcd8739ae039);
var $20d26af2734c4b5b$export$2e2bcd8739ae039 = (0, $78df073a8e6a3a91$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

const $0440cfd24bed175b$export$65e3907585753458 = (...e)=>e;
$0440cfd24bed175b$export$65e3907585753458("xs", "sm", "md", "lg", "xl");
const $0440cfd24bed175b$export$2346d74f0778c170 = $0440cfd24bed175b$export$65e3907585753458("default", "primary", "secondary", "success", "warning", "error", "gradient");
const $0440cfd24bed175b$export$3beea985d814eaa5 = $0440cfd24bed175b$export$65e3907585753458("default", "primary", "secondary", "success", "warning", "error");
const $0440cfd24bed175b$export$88cd1fcad21c1083 = $0440cfd24bed175b$export$65e3907585753458("default", "primary", "secondary", "success", "warning", "error", "invert", "gradient");
const $0440cfd24bed175b$export$2b6026f6c5a5b9d6 = $0440cfd24bed175b$export$65e3907585753458("default", "primary", "secondary", "success", "warning", "error", "invert");
const $0440cfd24bed175b$export$a1ce31f3661b642c = $0440cfd24bed175b$export$65e3907585753458("default", "primary", "secondary", "success", "warning", "error", "dark", "lite", "alert", "purple", "violet", "gradient", "cyan");
const $0440cfd24bed175b$export$7bea3b3dd30150da = $0440cfd24bed175b$export$65e3907585753458("default", "points", "points-opacity", "gradient", "spinner");
const $0440cfd24bed175b$export$923b539dab95bb6f = $0440cfd24bed175b$export$65e3907585753458("light", "normal", "bold", "extrabold", "black");
const $0440cfd24bed175b$export$3b62c9ef204f70d0 = $0440cfd24bed175b$export$65e3907585753458("normal", "bold", "lighter", "bolder", "inherit", "initial", "revert", "unset");
const $0440cfd24bed175b$export$3a307e3abb57840d = $0440cfd24bed175b$export$65e3907585753458("none", "capitalize", "uppercase", "lowercase", "full-width", "full-size-kana", "inherit", "initial", "revert", "unset");
$0440cfd24bed175b$export$65e3907585753458("default", "slient", "prevent"), $0440cfd24bed175b$export$65e3907585753458("hover", "click"), $0440cfd24bed175b$export$65e3907585753458("top", "topStart", "topEnd", "left", "leftStart", "leftEnd", "bottom", "bottomStart", "bottomEnd", "right", "rightStart", "rightEnd"), $0440cfd24bed175b$export$65e3907585753458("static", "relative", "absolute", "fixed", "sticky", "inherit", "initial", "revert", "unset"), $0440cfd24bed175b$export$65e3907585753458("contain", "cover", "fill", "none", "scale-down", "inherit", "initial", "revert", "unset"), $0440cfd24bed175b$export$65e3907585753458("start", "center", "end", "left", "right"), $0440cfd24bed175b$export$65e3907585753458("flex-start", "center", "flex-end", "space-between", "space-around", "space-evenly"), $0440cfd24bed175b$export$65e3907585753458("flex-start", "flex-end", "center", "stretch", "baseline"), $0440cfd24bed175b$export$65e3907585753458("stretch", "center", "flex-start", "flex-end", "space-between", "space-around"), $0440cfd24bed175b$export$65e3907585753458("row", "row-reverse", "column", "column-reverse"), $0440cfd24bed175b$export$65e3907585753458("nowrap", "wrap", "wrap-reverse"), $0440cfd24bed175b$export$65e3907585753458("flex", "block", "grid", "inline", "inline-block", "inline-flex", "inline-grid"), $0440cfd24bed175b$export$65e3907585753458("left", "right"), $0440cfd24bed175b$export$65e3907585753458("start", "center", "end");
const $0440cfd24bed175b$export$eaab8d1ed846a202 = $0440cfd24bed175b$export$65e3907585753458("clearable", "as", "rounded", "labelLeft", "labelRight", "contentLeft", "contentRight", "contentClickable", "contentLeftStyling", "contentRightStyling", "onContentClick", "onClearClick", "css");
const $0440cfd24bed175b$export$dcfb47138dd854ee = $0440cfd24bed175b$export$65e3907585753458("items", "disabledKeys", "allowDuplicateSelectionEvents", "disallowEmptySelection", "defaultSelectedKeys", "sortDescriptor", "onSortChange");
$0440cfd24bed175b$export$65e3907585753458("toggle", "replace"), $0440cfd24bed175b$export$65e3907585753458("none", "single", "multiple"), $0440cfd24bed175b$export$65e3907585753458("flat", "light", "solid", "shadow"), $0440cfd24bed175b$export$65e3907585753458("flat", "bordered", "shadow");


const $6adadfce8641d1be$export$57e6a6d9b8e425d7 = (t)=>{
    if ("undefined" != typeof document || !t) {
        const r = $6adadfce8641d1be$export$30a9abfd5fb9f5f6(t) ? t.replace("var(", "").replace(")", "") : `--${t}`;
        return getComputedStyle(document.documentElement).getPropertyValue(r);
    }
    return "";
};
const $6adadfce8641d1be$export$30a9abfd5fb9f5f6 = (t)=>!(!t || 0 !== (null == t ? void 0 : t.indexOf("var(")));
const $6adadfce8641d1be$export$8a9b6341a7c96bc = (t)=>/#[a-fA-F0-9]{3,6}/g.test(t);
const $6adadfce8641d1be$export$7229be6d7219ee6a = (t, r = 1)=>{
    let e = 0, o = 0, n = 0;
    return 4 == t.length ? (e = "0x" + t[1] + t[1], o = "0x" + t[2] + t[2], n = "0x" + t[3] + t[3]) : 7 == t.length && (e = "0x" + t[1] + t[2], o = "0x" + t[3] + t[4], n = "0x" + t[5] + t[6]), `rgba(${+e}, ${+o},${+n},${r})`;
};
const $6adadfce8641d1be$export$3999513f906d89a = (r)=>{
    let e = (0, $0440cfd24bed175b$export$2346d74f0778c170).find((t)=>t === r);
    return null != e;
};
const $6adadfce8641d1be$export$15398ea3b1097d32 = (t)=>{
    let e = (0, $0440cfd24bed175b$export$3beea985d814eaa5).find((r)=>r === t);
    return null != e;
};
const $6adadfce8641d1be$export$e82f763eaa28f6fe = (t)=>{
    let r = (new Option).style;
    return r.color = t, r.color == t;
};
const $6adadfce8641d1be$export$5a544e13ad4e1fa5 = (t)=>{
    const r = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (t, r, e, o)=>`${r}${r}${e}${e}${o}${o}`), e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(r);
    if (!e) throw new Error(`Next UI: Unsupported ${t} color.`);
    return [
        Number.parseInt(e[1], 16),
        Number.parseInt(e[2], 16),
        Number.parseInt(e[3], 16)
    ];
};
const $6adadfce8641d1be$export$ba8d101ae32bdaeb = (t, r = "", e = !1)=>{
    const o = t.match(/#[a-fA-F0-9]{6}|#[a-fA-F0-9]{3}$/g);
    return o && o.length > 0 ? e ? o[o.length - 1] : o : r;
};
const $6adadfce8641d1be$export$c837f15574666a0e = (t)=>{
    const r = $6adadfce8641d1be$export$30a9abfd5fb9f5f6(t) ? $6adadfce8641d1be$export$57e6a6d9b8e425d7(t) : t;
    if ("#" === r.charAt(0)) return $6adadfce8641d1be$export$5a544e13ad4e1fa5(r);
    const e = r.replace(/ /g, ""), o = r.substr(0, 4), n = e.match(/\((.+)\)/);
    if (!o.startsWith("rgb") || !n) throw new Error('Next UI: Only support ["RGB", "RGBA", "HEX"] color.');
    return n[1].split(",").map((t)=>Number.parseFloat(t));
};
const $6adadfce8641d1be$export$69db7ce1f7d0c256 = (t, r = 1)=>{
    if (!t) return "";
    const e = $6adadfce8641d1be$export$30a9abfd5fb9f5f6(t) ? $6adadfce8641d1be$export$57e6a6d9b8e425d7(t) : t;
    if (/#[a-fA-F0-9]{3,6}/g.test(e)) return $6adadfce8641d1be$export$7229be6d7219ee6a(e, r);
    if (!/^#|rgb|RGB/.test(e)) return e;
    const [o, n, s] = $6adadfce8641d1be$export$c837f15574666a0e(e);
    return `rgba(${o}, ${n}, ${s}, ${r > 1 ? 1 : r < 0 ? 0 : r})`;
};
function $6adadfce8641d1be$var$e(t, r) {
    return r = r || 2, (new Array(r).join("0") + t).slice(-r);
}
const $6adadfce8641d1be$export$9b515c1c97c284fe = (t, r = !0)=>{
    let o = $6adadfce8641d1be$export$30a9abfd5fb9f5f6(t) ? $6adadfce8641d1be$export$57e6a6d9b8e425d7(t) : t;
    if (0 === o.indexOf("#") && (o = o.slice(1)), 3 === o.length && (o = o[0] + o[0] + o[1] + o[1] + o[2] + o[2]), 6 !== o.length) return t;
    let n = parseInt(o.slice(0, 2), 16), s = parseInt(o.slice(2, 4), 16), l = parseInt(o.slice(4, 6), 16);
    return r ? .299 * n + .587 * s + .114 * l > 186 ? "#000000" : "#FFFFFF" : (n = 255 - n, s = 255 - s, l = 255 - l, "#" + $6adadfce8641d1be$var$e(n.toString(16)) + $6adadfce8641d1be$var$e(s.toString(16)) + $6adadfce8641d1be$var$e(l.toString(16)));
};





const $387c301a0ebf1dc6$export$31ea92f3997410dd = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("p", {
    variants: {
        weight: {
            hairline: {
                fontWeight: "$hairline"
            },
            thin: {
                fontWeight: "$thin"
            },
            light: {
                fontWeight: "$light"
            },
            normal: {
                fontWeight: "$normal"
            },
            medium: {
                fontWeight: "$medium"
            },
            semibold: {
                fontWeight: "$semibold"
            },
            bold: {
                fontWeight: "$bold"
            },
            extrabold: {
                fontWeight: "$extrabold"
            },
            black: {
                fontWeight: "$black"
            }
        }
    }
});



const $90664c023973deaf$export$772657dadf9d4769 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((t, e)=>{
    const { children: m, tag: f, color: n, transform: a, margin: x, size: d, css: c, ...p } = t, u = (0, $97d849037ea9c63e$export$c2c55ef9111cafd8)(e), h = (0, $acw62.useMemo)(()=>(0, $6adadfce8641d1be$export$3999513f906d89a)(n) ? "default" === n ? "$text" : `$${n}` : n, [
        n
    ]), C = (0, $acw62.useMemo)(()=>d ? "number" == typeof d ? `${d}px` : d : "inherit", [
        d
    ]), T = (0, $acw62.useMemo)(()=>x ? "number" == typeof x ? `${d}px` : x : "inherit", [
        x
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $387c301a0ebf1dc6$export$31ea92f3997410dd), {
        ref: u,
        as: f,
        css: {
            color: h,
            fontSize: d ? C : "",
            margin: T,
            tt: a,
            ...c
        },
        ...p,
        children: m
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($90664c023973deaf$export$772657dadf9d4769.displayName = "NextUI.TextChild"), $90664c023973deaf$export$772657dadf9d4769.toString = ()=>".nextui-text-child";
const $90664c023973deaf$var$f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($90664c023973deaf$export$772657dadf9d4769);
var $90664c023973deaf$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($90664c023973deaf$var$f, {
    color: "default"
});



const $7cfe96f37ed774bd$var$m = (t, e, r, o)=>{
    if (!t.length) return e;
    const i = t.slice(1, t.length);
    return (0, $7b02d682eb115277$exports.jsx)((0, $90664c023973deaf$export$2e2bcd8739ae039), {
        tag: t[0],
        size: r,
        transform: o,
        children: $7cfe96f37ed774bd$var$m(i, e, r)
    });
};
const $7cfe96f37ed774bd$export$5f1af8db9871e1d6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((t, r)=>{
    const { h1: i, h2: n, h3: h, h4: a, h5: f, h6: c, b: u, small: d, i: p, span: x, del: b, em: g, blockquote: k, transform: T, size: j, margin: q, children: y, ...z } = t, w = (0, $97d849037ea9c63e$export$c2c55ef9111cafd8)(r), N = {
        h1: i,
        h2: n,
        h3: h,
        h4: a,
        h5: f,
        h6: c,
        blockquote: k
    }, O = {
        span: x,
        small: d,
        b: u,
        em: g,
        i: p,
        del: b
    }, I = Object.keys(N).filter((t)=>N[t]), R = Object.keys(O).filter((t)=>O[t]), S = (0, $acw62.useMemo)(()=>I[0] ? I[0] : R[0] ? R[0] : "p", [
        I,
        R
    ]), U = R.filter((t)=>t !== S), v = (0, $acw62.useMemo)(()=>U.length ? $7cfe96f37ed774bd$var$m(U, y, j, T) : y, [
        U,
        y,
        j,
        T
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $90664c023973deaf$export$2e2bcd8739ae039), {
        ref: w,
        transform: T,
        tag: S,
        margin: q,
        size: j,
        ...z,
        children: v
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($7cfe96f37ed774bd$export$5f1af8db9871e1d6.displayName = "NextUI.Text"), $7cfe96f37ed774bd$export$5f1af8db9871e1d6.toString = ()=>".nextui-text";
const $7cfe96f37ed774bd$var$n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($7cfe96f37ed774bd$export$5f1af8db9871e1d6);
var $7cfe96f37ed774bd$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($7cfe96f37ed774bd$var$n, {
    h1: !1,
    h2: !1,
    h3: !1,
    h4: !1,
    h5: !1,
    h6: !1,
    b: !1,
    small: !1,
    transform: "none",
    i: !1,
    span: !1,
    del: !1,
    em: !1,
    blockquote: !1,
    color: "default"
});



var $639543044de9c802$export$2e2bcd8739ae039 = (0, $7cfe96f37ed774bd$export$2e2bcd8739ae039);


parcelRequire("acw62");
/**
 * React Router DOM v6.2.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $6d23e34a443a4a03$export$e19cd5f9376f8cee, $6d23e34a443a4a03$var$B = $6d23e34a443a4a03$export$e19cd5f9376f8cee || ($6d23e34a443a4a03$export$e19cd5f9376f8cee = {});
$6d23e34a443a4a03$var$B.Pop = "POP";
$6d23e34a443a4a03$var$B.Push = "PUSH";
$6d23e34a443a4a03$var$B.Replace = "REPLACE";
var $6d23e34a443a4a03$var$C = function(b) {
    return b;
};
function $6d23e34a443a4a03$var$D(b, h) {
    if (!b) {
        "undefined" !== typeof console && console.warn(h);
        try {
            throw Error(h);
        } catch (e) {}
    }
}
function $6d23e34a443a4a03$var$E(b) {
    b.preventDefault();
    b.returnValue = "";
}
function $6d23e34a443a4a03$var$F() {
    var b = [];
    return {
        get length () {
            return b.length;
        },
        push: function(h) {
            b.push(h);
            return function() {
                b = b.filter(function(e) {
                    return e !== h;
                });
            };
        },
        call: function(h) {
            b.forEach(function(e) {
                return e && e(h);
            });
        }
    };
}
function $6d23e34a443a4a03$var$H() {
    return Math.random().toString(36).substr(2, 8);
}
function $6d23e34a443a4a03$export$fe53371bee54353d(b) {
    var h = b.pathname;
    h = void 0 === h ? "/" : h;
    var e = b.search;
    e = void 0 === e ? "" : e;
    b = b.hash;
    b = void 0 === b ? "" : b;
    e && "?" !== e && (h += "?" === e.charAt(0) ? e : "?" + e);
    b && "#" !== b && (h += "#" === b.charAt(0) ? b : "#" + b);
    return h;
}
function $6d23e34a443a4a03$export$8ccf933b0513f8d0(b) {
    var h = {};
    if (b) {
        var e = b.indexOf("#");
        0 <= e && (h.hash = b.substr(e), b = b.substr(0, e));
        e = b.indexOf("?");
        0 <= e && (h.search = b.substr(e), b = b.substr(0, e));
        b && (h.pathname = b);
    }
    return h;
}
function $6d23e34a443a4a03$export$719fc203c4e16dee(b) {
    function h() {
        var c = p.location, a = m.state || {};
        return [
            a.idx,
            $6d23e34a443a4a03$var$C({
                pathname: c.pathname,
                search: c.search,
                hash: c.hash,
                state: a.usr || null,
                key: a.key || "default"
            })
        ];
    }
    function e(c) {
        return "string" === typeof c ? c : $6d23e34a443a4a03$export$fe53371bee54353d(c);
    }
    function x(c, a) {
        void 0 === a && (a = null);
        return $6d23e34a443a4a03$var$C((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: q.pathname,
            hash: "",
            search: ""
        }, "string" === typeof c ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(c) : c, {
            state: a,
            key: $6d23e34a443a4a03$var$H()
        }));
    }
    function z(c) {
        t = c;
        c = h();
        v = c[0];
        q = c[1];
        d.call({
            action: t,
            location: q
        });
    }
    function A(c, a) {
        function f() {
            A(c, a);
        }
        var l = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push, k = x(c, a);
        if (!g.length || (g.call({
            action: l,
            location: k,
            retry: f
        }), !1)) {
            var n = [
                {
                    usr: k.state,
                    key: k.key,
                    idx: v + 1
                },
                e(k)
            ];
            k = n[0];
            n = n[1];
            try {
                m.pushState(k, "", n);
            } catch (G) {
                p.location.assign(n);
            }
            z(l);
        }
    }
    function y(c, a) {
        function f() {
            y(c, a);
        }
        var l = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace, k = x(c, a);
        g.length && (g.call({
            action: l,
            location: k,
            retry: f
        }), 1) || (k = [
            {
                usr: k.state,
                key: k.key,
                idx: v
            },
            e(k)
        ], m.replaceState(k[0], "", k[1]), z(l));
    }
    function w(c) {
        m.go(c);
    }
    void 0 === b && (b = {});
    b = b.window;
    var p = void 0 === b ? document.defaultView : b, m = p.history, u = null;
    p.addEventListener("popstate", function() {
        if (u) g.call(u), u = null;
        else {
            var c = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop, a = h(), f = a[0];
            a = a[1];
            if (g.length) {
                if (null != f) {
                    var l = v - f;
                    l && (u = {
                        action: c,
                        location: a,
                        retry: function() {
                            w(-1 * l);
                        }
                    }, w(l));
                }
            } else z(c);
        }
    });
    var t = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    b = h();
    var v = b[0], q = b[1], d = $6d23e34a443a4a03$var$F(), g = $6d23e34a443a4a03$var$F();
    null == v && (v = 0, m.replaceState((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, m.state, {
        idx: v
    }), ""));
    return {
        get action () {
            return t;
        },
        get location () {
            return q;
        },
        createHref: e,
        push: A,
        replace: y,
        go: w,
        back: function() {
            w(-1);
        },
        forward: function() {
            w(1);
        },
        listen: function(c) {
            return d.push(c);
        },
        block: function(c) {
            var a = g.push(c);
            1 === g.length && p.addEventListener("beforeunload", $6d23e34a443a4a03$var$E);
            return function() {
                a();
                g.length || p.removeEventListener("beforeunload", $6d23e34a443a4a03$var$E);
            };
        }
    };
}
function $6d23e34a443a4a03$export$b71fdd3798280242(b) {
    function h() {
        var a = $6d23e34a443a4a03$export$8ccf933b0513f8d0(m.location.hash.substr(1)), f = a.pathname, l = a.search;
        a = a.hash;
        var k = u.state || {};
        return [
            k.idx,
            $6d23e34a443a4a03$var$C({
                pathname: void 0 === f ? "/" : f,
                search: void 0 === l ? "" : l,
                hash: void 0 === a ? "" : a,
                state: k.usr || null,
                key: k.key || "default"
            })
        ];
    }
    function e() {
        if (t) c.call(t), t = null;
        else {
            var a = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop, f = h(), l = f[0];
            f = f[1];
            if (c.length) {
                if (null != l) {
                    var k = q - l;
                    k && (t = {
                        action: a,
                        location: f,
                        retry: function() {
                            p(-1 * k);
                        }
                    }, p(k));
                }
            } else A(a);
        }
    }
    function x(a) {
        var f = document.querySelector("base"), l = "";
        f && f.getAttribute("href") && (f = m.location.href, l = f.indexOf("#"), l = -1 === l ? f : f.slice(0, l));
        return l + "#" + ("string" === typeof a ? a : $6d23e34a443a4a03$export$fe53371bee54353d(a));
    }
    function z(a, f) {
        void 0 === f && (f = null);
        return $6d23e34a443a4a03$var$C((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: d.pathname,
            hash: "",
            search: ""
        }, "string" === typeof a ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(a) : a, {
            state: f,
            key: $6d23e34a443a4a03$var$H()
        }));
    }
    function A(a) {
        v = a;
        a = h();
        q = a[0];
        d = a[1];
        g.call({
            action: v,
            location: d
        });
    }
    function y(a, f) {
        function l() {
            y(a, f);
        }
        var k = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push, n = z(a, f);
        if (!c.length || (c.call({
            action: k,
            location: n,
            retry: l
        }), !1)) {
            var G = [
                {
                    usr: n.state,
                    key: n.key,
                    idx: q + 1
                },
                x(n)
            ];
            n = G[0];
            G = G[1];
            try {
                u.pushState(n, "", G);
            } catch (K) {
                m.location.assign(G);
            }
            A(k);
        }
    }
    function w(a, f) {
        function l() {
            w(a, f);
        }
        var k = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace, n = z(a, f);
        c.length && (c.call({
            action: k,
            location: n,
            retry: l
        }), 1) || (n = [
            {
                usr: n.state,
                key: n.key,
                idx: q
            },
            x(n)
        ], u.replaceState(n[0], "", n[1]), A(k));
    }
    function p(a) {
        u.go(a);
    }
    void 0 === b && (b = {});
    b = b.window;
    var m = void 0 === b ? document.defaultView : b, u = m.history, t = null;
    m.addEventListener("popstate", e);
    m.addEventListener("hashchange", function() {
        var a = h()[1];
        $6d23e34a443a4a03$export$fe53371bee54353d(a) !== $6d23e34a443a4a03$export$fe53371bee54353d(d) && e();
    });
    var v = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    b = h();
    var q = b[0], d = b[1], g = $6d23e34a443a4a03$var$F(), c = $6d23e34a443a4a03$var$F();
    null == q && (q = 0, u.replaceState((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, u.state, {
        idx: q
    }), ""));
    return {
        get action () {
            return v;
        },
        get location () {
            return d;
        },
        createHref: x,
        push: y,
        replace: w,
        go: p,
        back: function() {
            p(-1);
        },
        forward: function() {
            p(1);
        },
        listen: function(a) {
            return g.push(a);
        },
        block: function(a) {
            var f = c.push(a);
            1 === c.length && m.addEventListener("beforeunload", $6d23e34a443a4a03$var$E);
            return function() {
                f();
                c.length || m.removeEventListener("beforeunload", $6d23e34a443a4a03$var$E);
            };
        }
    };
}
function $6d23e34a443a4a03$export$2b76ad033c6e6d08(b) {
    function h(d, g) {
        void 0 === g && (g = null);
        return $6d23e34a443a4a03$var$C((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: t.pathname,
            search: "",
            hash: ""
        }, "string" === typeof d ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(d) : d, {
            state: g,
            key: $6d23e34a443a4a03$var$H()
        }));
    }
    function e(d, g, c) {
        return !q.length || (q.call({
            action: d,
            location: g,
            retry: c
        }), !1);
    }
    function x(d, g) {
        u = d;
        t = g;
        v.call({
            action: u,
            location: t
        });
    }
    function z(d, g) {
        var c = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push, a = h(d, g);
        e(c, a, function() {
            z(d, g);
        }) && (m += 1, p.splice(m, p.length, a), x(c, a));
    }
    function A(d, g) {
        var c = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace, a = h(d, g);
        e(c, a, function() {
            A(d, g);
        }) && (p[m] = a, x(c, a));
    }
    function y(d) {
        var g = Math.min(Math.max(m + d, 0), p.length - 1), c = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop, a = p[g];
        e(c, a, function() {
            y(d);
        }) && (m = g, x(c, a));
    }
    void 0 === b && (b = {});
    var w = b;
    b = w.initialEntries;
    w = w.initialIndex;
    var p = (void 0 === b ? [
        "/"
    ] : b).map(function(d) {
        var g = $6d23e34a443a4a03$var$C((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: "/",
            search: "",
            hash: "",
            state: null,
            key: $6d23e34a443a4a03$var$H()
        }, "string" === typeof d ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(d) : d));
        return g;
    }), m = Math.min(Math.max(null == w ? p.length - 1 : w, 0), p.length - 1), u = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop, t = p[m], v = $6d23e34a443a4a03$var$F(), q = $6d23e34a443a4a03$var$F();
    return {
        get index () {
            return m;
        },
        get action () {
            return u;
        },
        get location () {
            return t;
        },
        createHref: function(d) {
            return "string" === typeof d ? d : $6d23e34a443a4a03$export$fe53371bee54353d(d);
        },
        push: z,
        replace: A,
        go: y,
        back: function() {
            y(-1);
        },
        forward: function() {
            y(1);
        },
        listen: function(d) {
            return v.push(d);
        },
        block: function(d) {
            return q.push(d);
        }
    };
}


/**
 * React Router v6.2.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $926608a7a86d7371$var$invariant(cond, message) {
    if (!cond) throw new Error(message);
}
function $926608a7a86d7371$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
const $926608a7a86d7371$var$alreadyWarned = {};
function $926608a7a86d7371$var$warningOnce(key, cond, message) {
    if (!cond && !$926608a7a86d7371$var$alreadyWarned[key]) $926608a7a86d7371$var$alreadyWarned[key] = true;
} ///////////////////////////////////////////////////////////////////////////////
// CONTEXT
///////////////////////////////////////////////////////////////////////////////
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $926608a7a86d7371$export$26749e8557646306 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $926608a7a86d7371$export$c7914228fb69b0f5 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $926608a7a86d7371$export$9072aa6dd1f93057 = /*#__PURE__*/ (0, $acw62.createContext)({
    outlet: null,
    matches: []
});
// COMPONENTS
///////////////////////////////////////////////////////////////////////////////
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/docs/en/v6/api#memoryrouter
 */ function $926608a7a86d7371$export$ae46f04cfaffe093(_ref) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref;
    let historyRef = (0, $acw62.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $6d23e34a443a4a03$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex
    });
    let history = historyRef.current;
    let [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/docs/en/v6/api#navigate
 */ function $926608a7a86d7371$export$444b3ab0cb9aec40(_ref2) {
    let { to: to, replace: replace, state: state } = _ref2;
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let navigate = $926608a7a86d7371$export$9770f232ac06a008();
    (0, $acw62.useEffect)(()=>{
        navigate(to, {
            replace: replace,
            state: state
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/docs/en/v6/api#outlet
 */ function $926608a7a86d7371$export$910ae8079b2c2852(props) {
    return $926608a7a86d7371$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#route
 */ function $926608a7a86d7371$export$e7b0ac011bb776c6(_props) {
    $926608a7a86d7371$var$invariant(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/docs/en/v6/api#router
 */ function $926608a7a86d7371$export$55185c17a0fcbe46(_ref3) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $6d23e34a443a4a03$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref3;
    !!$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let basename = $926608a7a86d7371$var$normalizePathname(basenameProp);
    let navigationContext = (0, $acw62.useMemo)(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = (0, $acw62.useMemo)(()=>{
        let trailingPathname = $926608a7a86d7371$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#routes
 */ function $926608a7a86d7371$export$3565eb3d00ca5a74(_ref4) {
    let { children: children, location: location } = _ref4;
    return $926608a7a86d7371$export$5d3fca4a98652595($926608a7a86d7371$export$16da398f5434bdec(children), location);
} ///////////////////////////////////////////////////////////////////////////////
// HOOKS
///////////////////////////////////////////////////////////////////////////////
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usehref
 */ function $926608a7a86d7371$export$b66bb29c5006f12f(to) {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $acw62.useContext)($926608a7a86d7371$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $926608a7a86d7371$export$e75d2a2d1b3c245b(to);
    let joinedPathname = pathname;
    if (basename !== "/") {
        let toPathname = $926608a7a86d7371$var$getToPathname(to);
        let endsWithSlash = toPathname != null && toPathname.endsWith("/");
        joinedPathname = pathname === "/" ? basename + (endsWithSlash ? "/" : "") : $926608a7a86d7371$var$joinPaths([
            basename,
            pathname
        ]);
    }
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useinroutercontext
 */ function $926608a7a86d7371$export$9c954a9d03d32f4a() {
    return (0, $acw62.useContext)($926608a7a86d7371$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/docs/en/v6/api#uselocation
 */ function $926608a7a86d7371$export$45d76561a5302f2b() {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    return (0, $acw62.useContext)($926608a7a86d7371$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigationtype
 */ function $926608a7a86d7371$export$1b3f31771c5d07c() {
    return (0, $acw62.useContext)($926608a7a86d7371$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns true if the URL for the given "to" value matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usematch
 */ function $926608a7a86d7371$export$6c330e8992e8a295(pattern) {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { pathname: pathname } = $926608a7a86d7371$export$45d76561a5302f2b();
    return (0, $acw62.useMemo)(()=>$926608a7a86d7371$export$81336c211d5ff295(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigate
 */ function $926608a7a86d7371$export$9770f232ac06a008() {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $acw62.useContext)($926608a7a86d7371$export$26749e8557646306);
    let { matches: matches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $926608a7a86d7371$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    let activeRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        activeRef.current = true;
    });
    let navigate = (0, $acw62.useCallback)(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $926608a7a86d7371$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname);
        if (basename !== "/") path.pathname = $926608a7a86d7371$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $926608a7a86d7371$var$OutletContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/docs/en/v6/api#useoutletcontext
 */ function $926608a7a86d7371$export$4138103a3ae699cc() {
    return (0, $acw62.useContext)($926608a7a86d7371$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useoutlet
 */ function $926608a7a86d7371$export$a3be3530d8e40d0b(context) {
    let outlet = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useparams
 */ function $926608a7a86d7371$export$99eaa27ddbbb95ef() {
    let { matches: matches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useresolvedpath
 */ function $926608a7a86d7371$export$e75d2a2d1b3c245b(to) {
    let { matches: matches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $926608a7a86d7371$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    return (0, $acw62.useMemo)(()=>$926608a7a86d7371$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname), [
        to,
        routePathnamesJson,
        locationPathname
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useroutes
 */ function $926608a7a86d7371$export$5d3fca4a98652595(routes, locationArg) {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { matches: parentMatches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $926608a7a86d7371$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && $926608a7a86d7371$var$invariant(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = $926608a7a86d7371$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    return $926608a7a86d7371$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $926608a7a86d7371$var$joinPaths([
                parentPathnameBase,
                match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $926608a7a86d7371$var$joinPaths([
                parentPathnameBase,
                match.pathnameBase
            ])
        })), parentMatches);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/docs/en/v6/api#createroutesfromchildren
 */ function $926608a7a86d7371$export$16da398f5434bdec(children) {
    let routes = [];
    (0, $acw62.Children).forEach(children, (element)=>{
        if (!/*#__PURE__*/ (0, $acw62.isValidElement)(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === (0, $acw62.Fragment)) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $926608a7a86d7371$export$16da398f5434bdec(element.props.children));
            return;
        }
        !(element.type === $926608a7a86d7371$export$e7b0ac011bb776c6) && $926608a7a86d7371$var$invariant(false);
        let route = {
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path
        };
        if (element.props.children) route.children = $926608a7a86d7371$export$16da398f5434bdec(element.props.children);
        routes.push(route);
    });
    return routes;
}
/**
 * The parameters that were parsed from the URL path.
 */ /**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/api#generatepath
 */ function $926608a7a86d7371$export$82476f982757e71e(path, params) {
    if (params === void 0) params = {};
    return path.replace(/:(\w+)/g, (_, key)=>{
        !(params[key] != null) && $926608a7a86d7371$var$invariant(false);
        return params[key];
    }).replace(/\/*\*$/, (_)=>params["*"] == null ? "" : params["*"].replace(/^\/*/, "/"));
}
/**
 * A RouteMatch contains info about how a route matched a URL.
 */ /**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchroutes
 */ function $926608a7a86d7371$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(locationArg) : locationArg;
    let pathname = $926608a7a86d7371$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $926608a7a86d7371$var$flattenRoutes(routes);
    $926608a7a86d7371$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $926608a7a86d7371$var$matchRouteBranch(branches[i], pathname);
    return matches;
}
function $926608a7a86d7371$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    routes.forEach((route, index)=>{
        let meta = {
            relativePath: route.path || "",
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            !meta.relativePath.startsWith(parentPath) && $926608a7a86d7371$var$invariant(false);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $926608a7a86d7371$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            !(route.index !== true) && $926608a7a86d7371$var$invariant(false);
            $926608a7a86d7371$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $926608a7a86d7371$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $926608a7a86d7371$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $926608a7a86d7371$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $926608a7a86d7371$var$paramRe = /^:\w+$/;
const $926608a7a86d7371$var$dynamicSegmentValue = 3;
const $926608a7a86d7371$var$indexRouteValue = 2;
const $926608a7a86d7371$var$emptySegmentValue = 1;
const $926608a7a86d7371$var$staticSegmentValue = 10;
const $926608a7a86d7371$var$splatPenalty = -2;
const $926608a7a86d7371$var$isSplat = (s)=>s === "*";
function $926608a7a86d7371$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($926608a7a86d7371$var$isSplat)) initialScore += $926608a7a86d7371$var$splatPenalty;
    if (index) initialScore += $926608a7a86d7371$var$indexRouteValue;
    return segments.filter((s)=>!$926608a7a86d7371$var$isSplat(s)).reduce((score, segment)=>score + ($926608a7a86d7371$var$paramRe.test(segment) ? $926608a7a86d7371$var$dynamicSegmentValue : segment === "" ? $926608a7a86d7371$var$emptySegmentValue : $926608a7a86d7371$var$staticSegmentValue), initialScore);
}
function $926608a7a86d7371$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $926608a7a86d7371$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $926608a7a86d7371$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            params: matchedParams,
            pathname: $926608a7a86d7371$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $926608a7a86d7371$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ]),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $926608a7a86d7371$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $926608a7a86d7371$export$daf73786167a7f72(matches) {
    return $926608a7a86d7371$var$_renderMatches(matches);
}
function $926608a7a86d7371$var$_renderMatches(matches, parentMatches) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) return null;
    return matches.reduceRight((outlet, match, index)=>{
        return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$9072aa6dd1f93057.Provider, {
            children: match.route.element !== undefined ? match.route.element : /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$910ae8079b2c2852, null),
            value: {
                outlet: outlet,
                matches: parentMatches.concat(matches.slice(0, index + 1))
            }
        });
    }, null);
}
/**
 * A PathPattern is used to match on some portion of a URL pathname.
 */ /**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchpath
 */ function $926608a7a86d7371$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $926608a7a86d7371$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $926608a7a86d7371$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $926608a7a86d7371$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else regexpSource += end ? "\\/*$" // When matching to the end, ignore trailing slashes
     : // parent routes to matching only their own words and nothing more, e.g. parent
    // route "/home" should not match "/home2".
    "(?:\\b|\\/|$)";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $926608a7a86d7371$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/docs/en/v6/api#resolvepath
 */ function $926608a7a86d7371$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $926608a7a86d7371$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $926608a7a86d7371$var$normalizeSearch(search),
        hash: $926608a7a86d7371$var$normalizeHash(hash)
    };
}
function $926608a7a86d7371$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $926608a7a86d7371$var$resolveTo(toArg, routePathnames, locationPathname) {
    let to = typeof toArg === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(toArg) : toArg;
    let toPathname = toArg === "" || to.pathname === "" ? "/" : to.pathname; // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $926608a7a86d7371$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original to value had one.
    if (toPathname && toPathname !== "/" && toPathname.endsWith("/") && !path.pathname.endsWith("/")) path.pathname += "/";
    return path;
}
function $926608a7a86d7371$var$getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(to).pathname : to.pathname;
}
function $926608a7a86d7371$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let nextChar = pathname.charAt(basename.length);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(basename.length) || "/";
}
const $926608a7a86d7371$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
const $926608a7a86d7371$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
const $926608a7a86d7371$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $926608a7a86d7371$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash; ///////////////////////////////////////////////////////////////////////////////


function $0c90f43fc3673aef$var$_extends() {
    $0c90f43fc3673aef$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0c90f43fc3673aef$var$_extends.apply(this, arguments);
}
function $0c90f43fc3673aef$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0c90f43fc3673aef$var$_excluded = [
    "onClick",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to"
], $0c90f43fc3673aef$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
];
function $0c90f43fc3673aef$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} ////////////////////////////////////////////////////////////////////////////////
// COMPONENTS
////////////////////////////////////////////////////////////////////////////////
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0c90f43fc3673aef$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window } = _ref;
    let historyRef = (0, $acw62.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $6d23e34a443a4a03$export$719fc203c4e16dee)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $926608a7a86d7371$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0c90f43fc3673aef$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window } = _ref2;
    let historyRef = (0, $acw62.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $6d23e34a443a4a03$export$b71fdd3798280242)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $926608a7a86d7371$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0c90f43fc3673aef$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $926608a7a86d7371$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $0c90f43fc3673aef$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $0c90f43fc3673aef$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $acw62.forwardRef)(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, reloadDocument: reloadDocument, replace: replace = false, state: state, target: target, to: to } = _ref4, rest = $0c90f43fc3673aef$var$_objectWithoutPropertiesLoose(_ref4, $0c90f43fc3673aef$var$_excluded);
    let href = (0, $926608a7a86d7371$export$b66bb29c5006f12f)(to);
    let internalOnClick = $0c90f43fc3673aef$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented && !reloadDocument) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    (0, $acw62.createElement)("a", $0c90f43fc3673aef$var$_extends({}, rest, {
        href: href,
        onClick: handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $0c90f43fc3673aef$export$b0d92dbee9b5b60d = /*#__PURE__*/ (0, $acw62.forwardRef)(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $0c90f43fc3673aef$var$_objectWithoutPropertiesLoose(_ref5, $0c90f43fc3673aef$var$_excluded2);
    let location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    let path = (0, $926608a7a86d7371$export$e75d2a2d1b3c245b)(to);
    let locationPathname = location.pathname;
    let toPathname = path.pathname;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive
    }) : styleProp;
    return /*#__PURE__*/ (0, $acw62.createElement)($0c90f43fc3673aef$export$a6c7ac8248d6e38a, $0c90f43fc3673aef$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive
    }) : children);
});
// HOOKS
////////////////////////////////////////////////////////////////////////////////
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0c90f43fc3673aef$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    let location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    let path = (0, $926608a7a86d7371$export$e75d2a2d1b3c245b)(to);
    return (0, $acw62.useCallback)((event)=>{
        if (event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
        !$0c90f43fc3673aef$var$isModifiedEvent(event) // Ignore clicks with modifier keys
        ) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here.
            let replace = !!replaceProp || (0, $6d23e34a443a4a03$export$fe53371bee54353d)(location) === (0, $6d23e34a443a4a03$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0c90f43fc3673aef$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = (0, $acw62.useRef)($0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    let searchParams = (0, $acw62.useMemo)(()=>{
        let searchParams = $0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(location.search);
        for (let key of defaultSearchParamsRef.current.keys())if (!searchParams.has(key)) defaultSearchParamsRef.current.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
        return searchParams;
    }, [
        location.search
    ]);
    let navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    let setSearchParams = (0, $acw62.useCallback)((nextInit, navigateOptions)=>{
        navigate("?" + $0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(nextInit), navigateOptions);
    }, [
        navigate
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}


const $5af3c10acd1e5147$export$481b2dde3f63f0a1 = {
    categories: [
        {
            name: "items",
            items: [
                {
                    path: "/unlinked-items",
                    name: "unlinked items",
                    relativePath: true
                },
                {
                    path: "/orders",
                    name: "ordini",
                    relativePath: true
                }
            ]
        },
        {
            name: "service",
            items: [
                {
                    path: "/corps",
                    name: "corps",
                    relativePath: true
                },
                {
                    path: "/members",
                    name: "membri",
                    relativePath: true
                }
            ]
        },
        {
            name: "utente",
            items: [
                // {
                //     path: "/",
                //     name: "impostazioni",
                //     relativePath: true
                // },
                {
                    path: "/logout",
                    name: "logout",
                    color: "error",
                    relativePath: true
                }
            ]
        }
    ]
};




var $acw62 = parcelRequire("acw62");






/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $78783784837c9463$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $78783784837c9463$export$ae1af26003f05816 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $78783784837c9463$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $78783784837c9463$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $78783784837c9463$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* INVALID_APP_ID */ ]: "The mobile app identifier is not registed for the current project.",
        ["invalid-user-token" /* INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* INVALID_IDP_RESPONSE */ ]: "The supplied auth credential is malformed or has expired.",
        ["invalid-message-payload" /* INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-multi-factor-info" /* MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance."
    };
}
function $78783784837c9463$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $78783784837c9463$export$df995fae86a55f06 = $78783784837c9463$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $78783784837c9463$export$ef35774e6d314e91 = $78783784837c9463$var$_prodErrorMap;
const $78783784837c9463$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("auth", "Firebase", $78783784837c9463$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $78783784837c9463$export$e7094788287c5e9b = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$logClient = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/auth");
function $78783784837c9463$var$_logError(msg, ...args) {
    if ($78783784837c9463$var$logClient.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).ERROR) $78783784837c9463$var$logClient.error(`Auth (${(0, $57d436074e210fb5$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$export$6554612db691658e(authOrCode, ...rest) {
    throw $78783784837c9463$var$createErrorInternal(authOrCode, ...rest);
}
function $78783784837c9463$export$d66dc83d8cfc8dd(authOrCode, ...rest) {
    return $78783784837c9463$var$createErrorInternal(authOrCode, ...rest);
}
function $78783784837c9463$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $78783784837c9463$export$ef35774e6d314e91()), {
        [code]: message
    });
    const factory = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $78783784837c9463$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $78783784837c9463$export$6554612db691658e(auth, "argument-error" /* ARGUMENT_ERROR */ );
        throw $78783784837c9463$var$_errorWithCustomMessage(auth, "argument-error" /* ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $78783784837c9463$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $78783784837c9463$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $78783784837c9463$export$92108d983e8ee699(assertion, authOrCode, ...rest) {
    if (!assertion) throw $78783784837c9463$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $78783784837c9463$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $78783784837c9463$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $78783784837c9463$export$2f6ca3d3b1f80bf5(assertion, message) {
    if (!assertion) $78783784837c9463$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$instanceCache = new Map();
function $78783784837c9463$export$9fa96a7d116ea3ce(cls) {
    $78783784837c9463$export$2f6ca3d3b1f80bf5(cls instanceof Function, "Expected a class definition");
    let instance = $78783784837c9463$var$instanceCache.get(cls);
    if (instance) {
        $78783784837c9463$export$2f6ca3d3b1f80bf5(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $78783784837c9463$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $78783784837c9463$export$96f57966bedc81b4(app, deps) {
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $78783784837c9463$export$6554612db691658e(auth, "already-initialized" /* ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $78783784837c9463$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($78783784837c9463$export$9fa96a7d116ea3ce);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $78783784837c9463$var$_isHttpOrHttps() {
    return $78783784837c9463$var$_getCurrentScheme() === "http:" || $78783784837c9463$var$_getCurrentScheme() === "https:";
}
function $78783784837c9463$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $78783784837c9463$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($78783784837c9463$var$_isHttpOrHttps() || (0, $c38e0f42709c826a$export$caa8774a9107a58e)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $78783784837c9463$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $78783784837c9463$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $78783784837c9463$export$2f6ca3d3b1f80bf5(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $c38e0f42709c826a$export$872f8323f01d7ae0)() || (0, $c38e0f42709c826a$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$78783784837c9463$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$_emulatorUrl(config, path) {
    $78783784837c9463$export$2f6ca3d3b1f80bf5(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$export$b9a6b53f9be3734 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        $78783784837c9463$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        $78783784837c9463$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        $78783784837c9463$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $78783784837c9463$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* INVALID_IDENTIFIER */ ]: "invalid-email" /* INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* MISSING_CONTINUE_URI */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* INVALID_PASSWORD */ ]: "wrong-password" /* INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* MISSING_PASSWORD */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* EMAIL_EXISTS */ ]: "email-already-in-use" /* EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* INVALID_IDP_RESPONSE */ ,
    ["INVALID_PENDING_TOKEN" /* INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* INVALID_IDP_RESPONSE */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* MISSING_REQ_TYPE */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* EMAIL_NOT_FOUND */ ]: "user-not-found" /* USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* EXPIRED_OOB_CODE */ ]: "expired-action-code" /* EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* INVALID_OOB_CODE */ ]: "invalid-action-code" /* INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* MISSING_OOB_CODE */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* INVALID_ID_TOKEN */ ]: "invalid-user-token" /* INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* TOKEN_EXPIRED */ ]: "user-token-expired" /* TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* USER_NOT_FOUND */ ]: "user-token-expired" /* TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* INVALID_CODE */ ]: "invalid-verification-code" /* INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* INVALID_IDP_RESPONSE */ ,
    ["MISSING_SESSION_INFO" /* MISSING_SESSION_INFO */ ]: "missing-verification-id" /* MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* SESSION_EXPIRED */ ]: "code-expired" /* CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* INTERNAL_ERROR */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$DEFAULT_API_TIMEOUT_MS = new $78783784837c9463$var$Delay(30000, 60000);
function $78783784837c9463$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $78783784837c9463$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $78783784837c9463$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $c38e0f42709c826a$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $78783784837c9463$export$b9a6b53f9be3734.fetch()($78783784837c9463$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: "no-referrer"
        }, body));
    });
}
async function $78783784837c9463$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $78783784837c9463$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $78783784837c9463$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $78783784837c9463$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $78783784837c9463$var$_makeTaggedError(auth, "credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* EMAIL_EXISTS */ ) throw $78783784837c9463$var$_makeTaggedError(auth, "email-already-in-use" /* EMAIL_EXISTS */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $78783784837c9463$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $78783784837c9463$export$6554612db691658e(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) throw e;
        $78783784837c9463$export$6554612db691658e(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ );
    }
}
async function $78783784837c9463$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $78783784837c9463$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $78783784837c9463$export$6554612db691658e(auth, "multi-factor-auth-required" /* MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $78783784837c9463$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $78783784837c9463$var$_emulatorUrl(auth.config, base);
}
class $78783784837c9463$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($78783784837c9463$export$d66dc83d8cfc8dd(this.auth, "timeout" /* TIMEOUT */ ));
            }, $78783784837c9463$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $78783784837c9463$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $78783784837c9463$export$d66dc83d8cfc8dd(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$deleteAccount(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:delete" /* DELETE_ACCOUNT */ , request);
}
async function $78783784837c9463$var$deleteLinkedAccounts(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , request);
}
async function $78783784837c9463$var$getAccountInfo(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:lookup" /* GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $78783784837c9463$export$995eb9fca571757(user, forceRefresh = false) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identitfy the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $78783784837c9463$export$f38c853ae54ed474(user, forceRefresh = false) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $78783784837c9463$var$_parseToken(token);
    $78783784837c9463$export$92108d983e8ee699(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $78783784837c9463$var$utcTimestampToDateString($78783784837c9463$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $78783784837c9463$var$utcTimestampToDateString($78783784837c9463$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $78783784837c9463$var$utcTimestampToDateString($78783784837c9463$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $78783784837c9463$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $78783784837c9463$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $78783784837c9463$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $c38e0f42709c826a$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $78783784837c9463$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $78783784837c9463$var$_logError("Caught error parsing JWT payload as JSON", e);
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $78783784837c9463$var$_tokenExpiresIn(token) {
    const parsedToken = $78783784837c9463$var$_parseToken(token);
    $78783784837c9463$export$92108d983e8ee699(parsedToken, "internal-error" /* INTERNAL_ERROR */ );
    $78783784837c9463$export$92108d983e8ee699(typeof parsedToken.exp !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
    $78783784837c9463$export$92108d983e8ee699(typeof parsedToken.iat !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56) && $78783784837c9463$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $78783784837c9463$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if (e.code === `auth/${"network-request-failed" /* NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $78783784837c9463$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $78783784837c9463$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $78783784837c9463$var$_logoutIfInvalidated(user, $78783784837c9463$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $78783784837c9463$export$92108d983e8ee699(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $78783784837c9463$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $78783784837c9463$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $78783784837c9463$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $78783784837c9463$export$ab83b03e4111b1d0(user) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $78783784837c9463$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $78783784837c9463$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $78783784837c9463$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$requestStsToken(auth, refreshToken) {
    const response = await $78783784837c9463$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $c38e0f42709c826a$export$ac4103b836844853)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $78783784837c9463$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $78783784837c9463$export$b9a6b53f9be3734.fetch()(url, {
            method: "POST" /* POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $78783784837c9463$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $78783784837c9463$export$92108d983e8ee699(response.idToken, "internal-error" /* INTERNAL_ERROR */ );
        $78783784837c9463$export$92108d983e8ee699(typeof response.idToken !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
        $78783784837c9463$export$92108d983e8ee699(typeof response.refreshToken !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $78783784837c9463$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        $78783784837c9463$export$92108d983e8ee699(!this.accessToken || this.refreshToken, auth, "user-token-expired" /* TOKEN_EXPIRED */ );
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $78783784837c9463$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $78783784837c9463$var$StsTokenManager();
        if (refreshToken) {
            $78783784837c9463$export$92108d983e8ee699(typeof refreshToken === "string", "internal-error" /* INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $78783784837c9463$export$92108d983e8ee699(typeof accessToken === "string", "internal-error" /* INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $78783784837c9463$export$92108d983e8ee699(typeof expirationTime === "number", "internal-error" /* INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $78783784837c9463$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $78783784837c9463$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$assertStringOrUndefined(assertion, appName) {
    $78783784837c9463$export$92108d983e8ee699(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $78783784837c9463$export$24baa2b76016ce0e {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* FIREBASE */ ;
        this.emailVerified = false;
        this.isAnonymous = false;
        this.tenantId = null;
        this.providerData = [];
        this.proactiveRefresh = new $78783784837c9463$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.metadata = new $78783784837c9463$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $78783784837c9463$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $78783784837c9463$export$92108d983e8ee699(accessToken, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $78783784837c9463$export$f38c853ae54ed474(this, forceRefresh);
    }
    reload() {
        return $78783784837c9463$export$ab83b03e4111b1d0(this);
    }
    _assign(user) {
        if (this === user) return;
        $78783784837c9463$export$92108d983e8ee699(this.uid === user.uid, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        return new $78783784837c9463$export$24baa2b76016ce0e(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $78783784837c9463$export$92108d983e8ee699(!this.reloadListener, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $78783784837c9463$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        const idToken = await this.getIdToken();
        await $78783784837c9463$var$_logoutIfInvalidated(this, $78783784837c9463$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $78783784837c9463$export$92108d983e8ee699(uid && plainObjectTokenManager, auth, "internal-error" /* INTERNAL_ERROR */ );
        const stsTokenManager = $78783784837c9463$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $78783784837c9463$export$92108d983e8ee699(typeof uid === "string", auth, "internal-error" /* INTERNAL_ERROR */ );
        $78783784837c9463$var$assertStringOrUndefined(displayName, auth.name);
        $78783784837c9463$var$assertStringOrUndefined(email, auth.name);
        $78783784837c9463$export$92108d983e8ee699(typeof emailVerified === "boolean", auth, "internal-error" /* INTERNAL_ERROR */ );
        $78783784837c9463$export$92108d983e8ee699(typeof isAnonymous === "boolean", auth, "internal-error" /* INTERNAL_ERROR */ );
        $78783784837c9463$var$assertStringOrUndefined(phoneNumber, auth.name);
        $78783784837c9463$var$assertStringOrUndefined(photoURL, auth.name);
        $78783784837c9463$var$assertStringOrUndefined(tenantId, auth.name);
        $78783784837c9463$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $78783784837c9463$var$assertStringOrUndefined(createdAt, auth.name);
        $78783784837c9463$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $78783784837c9463$export$24baa2b76016ce0e({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $78783784837c9463$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $78783784837c9463$export$24baa2b76016ce0e({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $78783784837c9463$var$_reloadWithoutSaving(user);
        return user;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$78783784837c9463$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $78783784837c9463$export$3466f893ebf79586 = $78783784837c9463$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$export$28f7fcd39efa255(key, apiKey, appName) {
    return `${"firebase" /* PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $78783784837c9463$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $78783784837c9463$export$28f7fcd39efa255(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $78783784837c9463$export$28f7fcd39efa255("persistence" /* PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $78783784837c9463$export$24baa2b76016ce0e._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $78783784837c9463$var$PersistenceUserManager($78783784837c9463$export$9fa96a7d116ea3ce($78783784837c9463$export$3466f893ebf79586), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $78783784837c9463$export$9fa96a7d116ea3ce($78783784837c9463$export$3466f893ebf79586);
        const key = $78783784837c9463$export$28f7fcd39efa255(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $78783784837c9463$export$24baa2b76016ce0e._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $78783784837c9463$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $78783784837c9463$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $78783784837c9463$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* OPERA */ ;
    else if ($78783784837c9463$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* EDGE */ ;
    else if ($78783784837c9463$var$_isFirefox(ua)) return "Firefox" /* FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* SILK */ ;
    else if ($78783784837c9463$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BLACKBERRY */ ;
    else if ($78783784837c9463$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* WEBOS */ ;
    else if ($78783784837c9463$var$_isSafari(ua)) return "Safari" /* SAFARI */ ;
    else if ((ua.includes("chrome/") || $78783784837c9463$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* CHROME */ ;
    else if ($78783784837c9463$export$d24c54395ce0c509(ua)) // Android stock browser.
    return "Android" /* ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* OTHER */ ;
}
function $78783784837c9463$var$_isFirefox(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $78783784837c9463$var$_isSafari(userAgent = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $78783784837c9463$var$_isChromeIOS(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $78783784837c9463$var$_isIEMobile(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $78783784837c9463$export$d24c54395ce0c509(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $78783784837c9463$var$_isBlackBerry(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $78783784837c9463$var$_isWebOS(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $78783784837c9463$export$8a5498727ef6be21(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua);
}
function $78783784837c9463$export$7a38258bbe170828(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $78783784837c9463$var$_isIOSStandalone(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    var _a;
    return $78783784837c9463$export$8a5498727ef6be21(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $78783784837c9463$var$_isIE10() {
    return (0, $c38e0f42709c826a$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $78783784837c9463$var$_isMobileBrowser(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $78783784837c9463$export$8a5498727ef6be21(ua) || $78783784837c9463$export$d24c54395ce0c509(ua) || $78783784837c9463$var$_isWebOS(ua) || $78783784837c9463$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $78783784837c9463$var$_isIEMobile(ua);
}
function $78783784837c9463$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $78783784837c9463$export$cf2f7c5792f80b46(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $78783784837c9463$var$_getBrowserName((0, $c38e0f42709c826a$export$c36915b22ce77c19)());
            break;
        case "Worker" /* WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$78783784837c9463$var$_getBrowserName((0, $c38e0f42709c826a$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* CORE */ }/${0, $57d436074e210fb5$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$export$158acd800e1ef08b {
    constructor(app, config){
        this.app = app;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $78783784837c9463$var$Subscription(this);
        this.idTokenSubscription = new $78783784837c9463$var$Subscription(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $78783784837c9463$var$_DEFAULT_AUTH_ERROR_FACTORY;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $78783784837c9463$export$9fa96a7d116ea3ce(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $78783784837c9463$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {}
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        await this._updateCurrentUser(user);
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        // First check to see if we have a pending redirect event.
        let storedUser = await this.assertedPersistence.getCurrentUser();
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = storedUser === null || storedUser === void 0 ? void 0 : storedUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) storedUser = result.user;
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!storedUser) return this.directlySetCurrentUser(null);
        if (!storedUser._redirectEventId) // This isn't a redirect user, we can reload and bail
        // This will also catch the redirected user, if available, as that method
        // strips the _redirectEventId
        return this.reloadAndSetCurrentUserOrClear(storedUser);
        $78783784837c9463$export$92108d983e8ee699(this._popupRedirectResolver, this, "argument-error" /* ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === storedUser._redirectEventId) return this.directlySetCurrentUser(storedUser);
        return this.reloadAndSetCurrentUserOrClear(storedUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $78783784837c9463$var$_reloadWithoutSaving(user);
        } catch (e) {
            if (e.code !== `auth/${"network-request-failed" /* NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $78783784837c9463$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $78783784837c9463$export$92108d983e8ee699(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user) {
        if (this._deleted) return;
        if (user) $78783784837c9463$export$92108d983e8ee699(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* TENANT_ID_MISMATCH */ );
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        return this._updateCurrentUser(null);
    }
    setPersistence(persistence) {
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($78783784837c9463$export$9fa96a7d116ea3ce(persistence));
        });
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $78783784837c9463$export$9fa96a7d116ea3ce(popupRedirectResolver) || this._popupRedirectResolver;
            $78783784837c9463$export$92108d983e8ee699(resolver, this, "argument-error" /* ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $78783784837c9463$var$PersistenceUserManager.create(this, [
                $78783784837c9463$export$9fa96a7d116ea3ce(resolver._redirectPersistence)
            ], "redirectUser" /* REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $78783784837c9463$export$92108d983e8ee699(promise, this, "internal-error" /* INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>cb(this.currentUser));
        if (typeof nextOrObserver === "function") return subscription.addObserver(nextOrObserver, error, completed);
        else return subscription.addObserver(nextOrObserver);
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) {
            this._currentUser._stopProactiveRefresh();
            if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        }
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $78783784837c9463$export$92108d983e8ee699(this.persistenceManager, this, "internal-error" /* INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $78783784837c9463$export$cf2f7c5792f80b46(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* X_FIREBASE_GMPID */ ] = this.app.options.appId;
        return headers;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $78783784837c9463$export$890c4ad488842ce7(auth) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $78783784837c9463$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $c38e0f42709c826a$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $78783784837c9463$export$92108d983e8ee699(this.observer, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $78783784837c9463$export$a9c23c6ac3fc3eca(auth, url, options) {
    const authInternal = $78783784837c9463$export$890c4ad488842ce7(auth);
    $78783784837c9463$export$92108d983e8ee699(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* EMULATOR_CONFIG_FAILED */ );
    $78783784837c9463$export$92108d983e8ee699(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $78783784837c9463$var$extractProtocol(url);
    const { host: host, port: port } = $78783784837c9463$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $78783784837c9463$var$emitEmulatorWarning();
}
function $78783784837c9463$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $78783784837c9463$var$extractHostAndPort(url) {
    const protocol = $78783784837c9463$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $78783784837c9463$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $78783784837c9463$var$parsePort(port)
        };
    }
}
function $78783784837c9463$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $78783784837c9463$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $78783784837c9463$export$2329c99376c9d0a4 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $78783784837c9463$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $78783784837c9463$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $78783784837c9463$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $78783784837c9463$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$resetPassword(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:resetPassword" /* RESET_PASSWORD */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
async function $78783784837c9463$var$updateEmailPassword(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , request);
}
async function $78783784837c9463$var$applyActionCode$1(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$signInWithPassword(auth, request) {
    return $78783784837c9463$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPassword" /* SIGN_IN_WITH_PASSWORD */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
async function $78783784837c9463$var$sendOobCode(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:sendOobCode" /* SEND_OOB_CODE */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
async function $78783784837c9463$var$sendEmailVerification$1(auth, request) {
    return $78783784837c9463$var$sendOobCode(auth, request);
}
async function $78783784837c9463$var$sendPasswordResetEmail$1(auth, request) {
    return $78783784837c9463$var$sendOobCode(auth, request);
}
async function $78783784837c9463$var$sendSignInLinkToEmail$1(auth, request) {
    return $78783784837c9463$var$sendOobCode(auth, request);
}
async function $78783784837c9463$var$verifyAndChangeEmail(auth, request) {
    return $78783784837c9463$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$signInWithEmailLink$1(auth, request) {
    return $78783784837c9463$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithEmailLink" /* SIGN_IN_WITH_EMAIL_LINK */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
async function $78783784837c9463$var$signInWithEmailLinkForLinking(auth, request) {
    return $78783784837c9463$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithEmailLink" /* SIGN_IN_WITH_EMAIL_LINK */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $78783784837c9463$export$7f8ddf7c7c20b3cd extends $78783784837c9463$export$2329c99376c9d0a4 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $78783784837c9463$export$7f8ddf7c7c20b3cd(email, password, "password" /* EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $78783784837c9463$export$7f8ddf7c7c20b3cd(email, oobCode, "emailLink" /* EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* EMAIL_PASSWORD */ :
                return $78783784837c9463$var$signInWithPassword(auth, {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* EMAIL_LINK */ :
                return $78783784837c9463$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $78783784837c9463$export$6554612db691658e(auth, "internal-error" /* INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* EMAIL_PASSWORD */ :
                return $78783784837c9463$var$updateEmailPassword(auth, {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* EMAIL_LINK */ :
                return $78783784837c9463$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $78783784837c9463$export$6554612db691658e(auth, "internal-error" /* INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$signInWithIdp(auth, request) {
    return $78783784837c9463$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithIdp" /* SIGN_IN_WITH_IDP */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $78783784837c9463$export$9bb611d729802a56 extends $78783784837c9463$export$2329c99376c9d0a4 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $78783784837c9463$export$9bb611d729802a56(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $78783784837c9463$export$6554612db691658e("argument-error" /* ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $78783784837c9463$export$9bb611d729802a56(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $78783784837c9463$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $78783784837c9463$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $78783784837c9463$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $78783784837c9463$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $c38e0f42709c826a$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$sendPhoneVerificationCode(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:sendVerificationCode" /* SEND_VERIFICATION_CODE */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
async function $78783784837c9463$var$signInWithPhoneNumber$1(auth, request) {
    return $78783784837c9463$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
async function $78783784837c9463$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $78783784837c9463$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $78783784837c9463$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* NEED_CONFIRMATION */ , response);
    return response;
}
const $78783784837c9463$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* USER_NOT_FOUND */ ]: "user-not-found" /* USER_DELETED */ 
};
async function $78783784837c9463$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $78783784837c9463$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */ , $78783784837c9463$var$_addTidIfNecessary(auth, apiRequest), $78783784837c9463$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $78783784837c9463$export$b4171a6734a65d42 extends $78783784837c9463$export$2329c99376c9d0a4 {
    constructor(params){
        super("phone" /* PHONE */ , "phone" /* PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $78783784837c9463$export$b4171a6734a65d42({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $78783784837c9463$export$b4171a6734a65d42({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $78783784837c9463$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $78783784837c9463$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $78783784837c9463$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $78783784837c9463$export$b4171a6734a65d42({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $78783784837c9463$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $78783784837c9463$var$parseDeepLink(url) {
    const link = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $78783784837c9463$export$2219238a014317b0 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $78783784837c9463$var$parseMode((_c = searchParams["mode" /* MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $78783784837c9463$export$92108d983e8ee699(apiKey && code && operation, "argument-error" /* ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $78783784837c9463$var$parseDeepLink(link);
        try {
            return new $78783784837c9463$export$2219238a014317b0(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $78783784837c9463$export$4c3d22f3d993c33f(link) {
    return $78783784837c9463$export$2219238a014317b0.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $78783784837c9463$export$61196ced6d74a310 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $78783784837c9463$export$61196ced6d74a310.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $78783784837c9463$export$7f8ddf7c7c20b3cd._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $78783784837c9463$export$2219238a014317b0.parseLink(emailLink);
        $78783784837c9463$export$92108d983e8ee699(actionCodeUrl, "argument-error" /* ARGUMENT_ERROR */ );
        return $78783784837c9463$export$7f8ddf7c7c20b3cd._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $78783784837c9463$export$61196ced6d74a310.PROVIDER_ID = "password" /* PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $78783784837c9463$export$61196ced6d74a310.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $78783784837c9463$export$61196ced6d74a310.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $78783784837c9463$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $78783784837c9463$var$BaseOAuthProvider extends $78783784837c9463$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $78783784837c9463$export$971d5caa766a69d7 extends $78783784837c9463$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $78783784837c9463$export$92108d983e8ee699("providerId" in obj && "signInMethod" in obj, "argument-error" /* ARGUMENT_ERROR */ );
        return $78783784837c9463$export$9bb611d729802a56._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $78783784837c9463$export$92108d983e8ee699(params.idToken || params.accessToken, "argument-error" /* ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $78783784837c9463$export$9bb611d729802a56._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $78783784837c9463$export$971d5caa766a69d7.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $78783784837c9463$export$971d5caa766a69d7.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $78783784837c9463$export$971d5caa766a69d7(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $78783784837c9463$export$3a1a48c8f6ef640e extends $78783784837c9463$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $78783784837c9463$export$9bb611d729802a56._fromParams({
            providerId: $78783784837c9463$export$3a1a48c8f6ef640e.PROVIDER_ID,
            signInMethod: $78783784837c9463$export$3a1a48c8f6ef640e.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $78783784837c9463$export$3a1a48c8f6ef640e.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $78783784837c9463$export$3a1a48c8f6ef640e.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $78783784837c9463$export$3a1a48c8f6ef640e.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $78783784837c9463$export$3a1a48c8f6ef640e.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $78783784837c9463$export$3a1a48c8f6ef640e.PROVIDER_ID = "facebook.com" /* FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $78783784837c9463$export$a07804094c3ecf2d extends $78783784837c9463$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $78783784837c9463$export$9bb611d729802a56._fromParams({
            providerId: $78783784837c9463$export$a07804094c3ecf2d.PROVIDER_ID,
            signInMethod: $78783784837c9463$export$a07804094c3ecf2d.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $78783784837c9463$export$a07804094c3ecf2d.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $78783784837c9463$export$a07804094c3ecf2d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $78783784837c9463$export$a07804094c3ecf2d.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $78783784837c9463$export$a07804094c3ecf2d.GOOGLE_SIGN_IN_METHOD = "google.com" /* GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $78783784837c9463$export$a07804094c3ecf2d.PROVIDER_ID = "google.com" /* GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $78783784837c9463$export$3722cfe417b6ed86 extends $78783784837c9463$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* GITHUB */ );
    }
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ static credential(accessToken) {
        return $78783784837c9463$export$9bb611d729802a56._fromParams({
            providerId: $78783784837c9463$export$3722cfe417b6ed86.PROVIDER_ID,
            signInMethod: $78783784837c9463$export$3722cfe417b6ed86.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $78783784837c9463$export$3722cfe417b6ed86.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $78783784837c9463$export$3722cfe417b6ed86.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $78783784837c9463$export$3722cfe417b6ed86.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $78783784837c9463$export$3722cfe417b6ed86.GITHUB_SIGN_IN_METHOD = "github.com" /* GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $78783784837c9463$export$3722cfe417b6ed86.PROVIDER_ID = "github.com" /* GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $78783784837c9463$export$a05254e7c3aeba6e extends $78783784837c9463$export$2329c99376c9d0a4 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $78783784837c9463$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $78783784837c9463$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $78783784837c9463$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $78783784837c9463$export$a05254e7c3aeba6e(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $78783784837c9463$export$a05254e7c3aeba6e(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $78783784837c9463$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $78783784837c9463$export$3a6d5c9ae78a2c08 extends $78783784837c9463$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $78783784837c9463$export$92108d983e8ee699(providerId.startsWith($78783784837c9463$var$SAML_PROVIDER_PREFIX), "argument-error" /* ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $78783784837c9463$export$3a6d5c9ae78a2c08.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $78783784837c9463$export$3a6d5c9ae78a2c08.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $78783784837c9463$export$a05254e7c3aeba6e.fromJSON(json);
        $78783784837c9463$export$92108d983e8ee699(credential, "argument-error" /* ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $78783784837c9463$export$a05254e7c3aeba6e._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $78783784837c9463$export$e7c866399fa523f5 extends $78783784837c9463$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $78783784837c9463$export$9bb611d729802a56._fromParams({
            providerId: $78783784837c9463$export$e7c866399fa523f5.PROVIDER_ID,
            signInMethod: $78783784837c9463$export$e7c866399fa523f5.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $78783784837c9463$export$e7c866399fa523f5.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $78783784837c9463$export$e7c866399fa523f5.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $78783784837c9463$export$e7c866399fa523f5.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $78783784837c9463$export$e7c866399fa523f5.TWITTER_SIGN_IN_METHOD = "twitter.com" /* TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $78783784837c9463$export$e7c866399fa523f5.PROVIDER_ID = "twitter.com" /* TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$signUp(auth, request) {
    return $78783784837c9463$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signUp" /* SIGN_UP */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $78783784837c9463$export$24baa2b76016ce0e._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $78783784837c9463$var$providerIdForResponse(idTokenResponse);
        const userCred = new $78783784837c9463$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $78783784837c9463$var$providerIdForResponse(response);
        return new $78783784837c9463$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $78783784837c9463$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $78783784837c9463$export$71cec2538cb2c617(auth) {
    var _a;
    const authInternal = $78783784837c9463$export$890c4ad488842ce7(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $78783784837c9463$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* SIGN_IN */ 
    });
    const response = await $78783784837c9463$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $78783784837c9463$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$var$MultiFactorError extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $78783784837c9463$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $78783784837c9463$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $78783784837c9463$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* MFA_REQUIRED */ }`) throw $78783784837c9463$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $78783784837c9463$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $78783784837c9463$export$3b513254972cfc9c(user, providerId) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $78783784837c9463$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $78783784837c9463$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $78783784837c9463$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $78783784837c9463$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $78783784837c9463$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $78783784837c9463$var$UserCredentialImpl._forOperation(user, "link" /* LINK */ , response);
}
async function $78783784837c9463$var$_assertLinkedStatus(expected, user, provider) {
    await $78783784837c9463$var$_reloadWithoutSaving(user);
    const providerIds = $78783784837c9463$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* NO_SUCH_PROVIDER */ ;
    $78783784837c9463$export$92108d983e8ee699(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    const operationType = "reauthenticate" /* REAUTHENTICATE */ ;
    try {
        const response = await $78783784837c9463$var$_logoutIfInvalidated(user, $78783784837c9463$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $78783784837c9463$export$92108d983e8ee699(response.idToken, auth, "internal-error" /* INTERNAL_ERROR */ );
        const parsed = $78783784837c9463$var$_parseToken(response.idToken);
        $78783784837c9463$export$92108d983e8ee699(parsed, auth, "internal-error" /* INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $78783784837c9463$export$92108d983e8ee699(user.uid === localId, auth, "user-mismatch" /* USER_MISMATCH */ );
        return $78783784837c9463$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* USER_DELETED */ }`) $78783784837c9463$export$6554612db691658e(auth, "user-mismatch" /* USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    const operationType = "signIn" /* SIGN_IN */ ;
    const response = await $78783784837c9463$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $78783784837c9463$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $78783784837c9463$export$78acf4525d8a74c4(auth, credential) {
    return $78783784837c9463$var$_signInWithCredential($78783784837c9463$export$890c4ad488842ce7(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $78783784837c9463$export$8743009a87fcb00f(user, credential) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $78783784837c9463$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $78783784837c9463$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $78783784837c9463$export$dc98b0b04f4c7758(user, credential) {
    return $78783784837c9463$var$_reauthenticate((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$signInWithCustomToken$1(auth, request) {
    return $78783784837c9463$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithCustomToken" /* SIGN_IN_WITH_CUSTOM_TOKEN */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $78783784837c9463$export$71511d61b312f219(auth, customToken) {
    const authInternal = $78783784837c9463$export$890c4ad488842ce7(auth);
    const response = await $78783784837c9463$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $78783784837c9463$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $78783784837c9463$var$PhoneMultiFactorInfo._fromServerResponse(auth, enrollment);
        return $78783784837c9463$export$6554612db691658e(auth, "internal-error" /* INTERNAL_ERROR */ );
    }
}
class $78783784837c9463$var$PhoneMultiFactorInfo extends $78783784837c9463$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $78783784837c9463$var$PhoneMultiFactorInfo(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $78783784837c9463$export$92108d983e8ee699(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* INVALID_CONTINUE_URI */ );
    $78783784837c9463$export$92108d983e8ee699(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $78783784837c9463$export$92108d983e8ee699(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $78783784837c9463$export$92108d983e8ee699(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $78783784837c9463$export$3d8c2f653ac9d0b9(auth, email, actionCodeSettings) {
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* PASSWORD_RESET */ ,
        email: email
    };
    if (actionCodeSettings) $78783784837c9463$var$_setActionCodeSettingsOnRequest(authModular, request, actionCodeSettings);
    await $78783784837c9463$var$sendPasswordResetEmail$1(authModular, request);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $78783784837c9463$export$34aec0b863436764(auth, oobCode, newPassword) {
    await $78783784837c9463$var$resetPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $78783784837c9463$export$3c2fa207a37baaea(auth, oobCode) {
    await $78783784837c9463$var$applyActionCode$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $78783784837c9463$export$ce26c07117d59d6a(auth, oobCode) {
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const response = await $78783784837c9463$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $78783784837c9463$export$92108d983e8ee699(operation, authModular, "internal-error" /* INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */ :
            $78783784837c9463$export$92108d983e8ee699(response.newEmail, authModular, "internal-error" /* INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* REVERT_SECOND_FACTOR_ADDITION */ :
            $78783784837c9463$export$92108d983e8ee699(response.mfaInfo, authModular, "internal-error" /* INTERNAL_ERROR */ );
        // fall through
        default:
            $78783784837c9463$export$92108d983e8ee699(response.email, authModular, "internal-error" /* INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $78783784837c9463$var$MultiFactorInfoImpl._fromServerResponse($78783784837c9463$export$890c4ad488842ce7(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $78783784837c9463$export$6559d589eb85fbb6(auth, code) {
    const { data: data } = await $78783784837c9463$export$ce26c07117d59d6a((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $78783784837c9463$export$efca4cbe5dd06740(auth, email, password) {
    const authInternal = $78783784837c9463$export$890c4ad488842ce7(auth);
    const response = await $78783784837c9463$var$signUp(authInternal, {
        returnSecureToken: true,
        email: email,
        password: password
    });
    const userCredential = await $78783784837c9463$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $78783784837c9463$export$a8550f7dbe79f93a(auth, email, password) {
    return $78783784837c9463$export$78acf4525d8a74c4((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), $78783784837c9463$export$61196ced6d74a310.credential(email, password));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink('user@example.com', 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $78783784837c9463$export$2e2af4578d910ddf(auth, email, actionCodeSettings) {
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ ,
        email: email
    };
    $78783784837c9463$export$92108d983e8ee699(actionCodeSettings.handleCodeInApp, authModular, "argument-error" /* ARGUMENT_ERROR */ );
    if (actionCodeSettings) $78783784837c9463$var$_setActionCodeSettingsOnRequest(authModular, request, actionCodeSettings);
    await $78783784837c9463$var$sendSignInLinkToEmail$1(authModular, request);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $78783784837c9463$export$a93c5207d687da10(auth, emailLink) {
    const actionCodeUrl = $78783784837c9463$export$2219238a014317b0.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink('user@example.com', 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $78783784837c9463$export$c3950d9923825c02(auth, email, emailLink) {
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const credential = $78783784837c9463$export$61196ced6d74a310.credentialWithLink(email, emailLink || $78783784837c9463$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $78783784837c9463$export$92108d983e8ee699(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* TENANT_ID_MISMATCH */ );
    return $78783784837c9463$export$78acf4525d8a74c4(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$createAuthUri(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:createAuthUri" /* CREATE_AUTH_URI */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */ async function $78783784837c9463$export$a9c996f45e5784d0(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $78783784837c9463$var$_isHttpOrHttps() ? $78783784837c9463$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $78783784837c9463$var$createAuthUri((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $78783784837c9463$export$7910e0436ed8d1de(user, actionCodeSettings) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $78783784837c9463$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $78783784837c9463$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $78783784837c9463$export$555508cbc6add439(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $78783784837c9463$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $78783784837c9463$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$updateProfile$1(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $78783784837c9463$export$f787f51d84a910ad(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $78783784837c9463$var$_logoutIfInvalidated(userInternal, $78783784837c9463$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */ function $78783784837c9463$export$c9170ad7d4cd7e57(user, newEmail) {
    return $78783784837c9463$var$updateEmailOrPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $78783784837c9463$export$ee7c8ad385a60b7b(user, newPassword) {
    return $78783784837c9463$var$updateEmailOrPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $78783784837c9463$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $78783784837c9463$var$_logoutIfInvalidated(user, $78783784837c9463$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $78783784837c9463$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $78783784837c9463$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ANONYMOUS */  && signInProvider !== "custom" /* CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $78783784837c9463$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* FACEBOOK */ :
            return new $78783784837c9463$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* GITHUB */ :
            return new $78783784837c9463$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* GOOGLE */ :
            return new $78783784837c9463$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* TWITTER */ :
            return new $78783784837c9463$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* CUSTOM */ :
        case "anonymous" /* ANONYMOUS */ :
            return new $78783784837c9463$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $78783784837c9463$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $78783784837c9463$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $78783784837c9463$var$FederatedAdditionalUserInfoWithUsername extends $78783784837c9463$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $78783784837c9463$var$FacebookAdditionalUserInfo extends $78783784837c9463$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* FACEBOOK */ , profile);
    }
}
class $78783784837c9463$var$GithubAdditionalUserInfo extends $78783784837c9463$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $78783784837c9463$var$GoogleAdditionalUserInfo extends $78783784837c9463$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* GOOGLE */ , profile);
    }
}
class $78783784837c9463$var$TwitterAdditionalUserInfo extends $78783784837c9463$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $78783784837c9463$export$21579262ef46735b(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $78783784837c9463$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $78783784837c9463$export$ffb5f4729a158638(auth, persistence) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Adds an observer for changes to the signed-in user's ID token, which includes sign-in,
 * sign-out, and token refresh events.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - callback triggered on error.
 * @param completed - callback triggered when observer is removed.
 *
 * @public
 */ function $78783784837c9463$export$9e5f44173e64f162(auth, nextOrObserver, error, completed) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - callback triggered on error.
 * @param completed - callback triggered when observer is removed.
 *
 * @public
 */ function $78783784837c9463$export$625550452a3fa3ec(auth, nextOrObserver, error, completed) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $78783784837c9463$export$90a7f3efeed30595(auth) {
    (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $78783784837c9463$export$efccba1c4a2ef57b(auth, user) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $78783784837c9463$export$d141bba7fdc215a3(auth) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $78783784837c9463$export$4a5767248b18ef41(user) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user).delete();
}
class $78783784837c9463$var$MultiFactorSessionImpl {
    constructor(type, credential){
        this.type = type;
        this.credential = credential;
    }
    static _fromIdtoken(idToken) {
        return new $78783784837c9463$var$MultiFactorSessionImpl("enroll" /* ENROLL */ , idToken);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $78783784837c9463$var$MultiFactorSessionImpl("signin" /* SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $78783784837c9463$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $78783784837c9463$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $78783784837c9463$export$890c4ad488842ce7(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$78783784837c9463$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $78783784837c9463$export$92108d983e8ee699(serverResponse.mfaPendingCredential, auth, "internal-error" /* INTERNAL_ERROR */ );
        const session = $78783784837c9463$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $78783784837c9463$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* SIGN_IN */ :
                    const userCredential = await $78783784837c9463$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* REAUTHENTICATE */ :
                    $78783784837c9463$export$92108d983e8ee699(error.user, auth, "internal-error" /* INTERNAL_ERROR */ );
                    return $78783784837c9463$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $78783784837c9463$export$6554612db691658e(auth, "internal-error" /* INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $78783784837c9463$export$1a82df3d29112e01(auth, error) {
    var _a;
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $78783784837c9463$export$92108d983e8ee699(error.customData.operationType, authModular, "argument-error" /* ARGUMENT_ERROR */ );
    $78783784837c9463$export$92108d983e8ee699((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* ARGUMENT_ERROR */ );
    return $78783784837c9463$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$startEnrollPhoneMfa(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaEnrollment:start" /* START_PHONE_MFA_ENROLLMENT */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
function $78783784837c9463$var$finalizeEnrollPhoneMfa(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaEnrollment:finalize" /* FINALIZE_PHONE_MFA_ENROLLMENT */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
function $78783784837c9463$var$withdrawMfa(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* WITHDRAW_MFA */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
class $78783784837c9463$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$78783784837c9463$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $78783784837c9463$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $78783784837c9463$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken());
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $78783784837c9463$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        const idTokenResponse = await $78783784837c9463$var$_logoutIfInvalidated(this.user, $78783784837c9463$var$withdrawMfa(this.user.auth, {
            idToken: idToken,
            mfaEnrollmentId: mfaEnrollmentId
        }));
        // Remove the second factor from the user's list.
        this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
        // Depending on whether the backend decided to revoke the user's session,
        // the tokenResponse may be empty. If the tokens were not updated (and they
        // are now invalid), reloading the user will discover this and invalidate
        // the user's state accordingly.
        await this.user._updateTokensIfNecessary(idTokenResponse);
        try {
            await this.user.reload();
        } catch (e) {
            if (e.code !== `auth/${"user-token-expired" /* TOKEN_EXPIRED */ }`) throw e;
        }
    }
}
const $78783784837c9463$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $78783784837c9463$export$306ddfe3a8403e2(user) {
    const userModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if (!$78783784837c9463$var$multiFactorUserCache.has(userModular)) $78783784837c9463$var$multiFactorUserCache.set(userModular, $78783784837c9463$var$MultiFactorUserImpl._fromUser(userModular));
    return $78783784837c9463$var$multiFactorUserCache.get(userModular);
}
const $78783784837c9463$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $78783784837c9463$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($78783784837c9463$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($78783784837c9463$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$_iframeCannotSyncWebStorage() {
    const ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)();
    return $78783784837c9463$var$_isSafari(ua) || $78783784837c9463$export$8a5498727ef6be21(ua);
}
// The polling period in case events are not supported
const $78783784837c9463$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $78783784837c9463$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $78783784837c9463$var$BrowserLocalPersistence extends $78783784837c9463$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = $78783784837c9463$var$_iframeCannotSyncWebStorage() && $78783784837c9463$var$_isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $78783784837c9463$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) // Value changed from current value.
                this.storage.setItem(key, event.newValue);
                else // Current value deleted.
                this.storage.removeItem(key);
            } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
            return;
        }
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($78783784837c9463$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $78783784837c9463$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $78783784837c9463$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$78783784837c9463$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $78783784837c9463$export$8b22cf2602fb60ce = $78783784837c9463$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$var$BrowserSessionPersistence extends $78783784837c9463$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$78783784837c9463$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $78783784837c9463$export$407448d2b89b1813 = $78783784837c9463$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $78783784837c9463$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $78783784837c9463$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $78783784837c9463$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $78783784837c9463$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$78783784837c9463$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$export$53a70dd1ebbae346(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $78783784837c9463$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $78783784837c9463$export$53a70dd1ebbae346("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* TIMEOUT */ ));
                            }, 3000 /* COMPLETION */ );
                            break;
                        case "done" /* DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $78783784837c9463$var$_window() {
    return window;
}
function $78783784837c9463$var$_setWindowLocation(url) {
    $78783784837c9463$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$_isWorker() {
    return typeof $78783784837c9463$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $78783784837c9463$var$_window()["importScripts"] === "function";
}
async function $78783784837c9463$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $78783784837c9463$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $78783784837c9463$var$_getWorkerGlobalScope() {
    return $78783784837c9463$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$DB_NAME = "firebaseLocalStorageDb";
const $78783784837c9463$var$DB_VERSION = 1;
const $78783784837c9463$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $78783784837c9463$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $78783784837c9463$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $78783784837c9463$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $78783784837c9463$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($78783784837c9463$var$DB_OBJECTSTORE_NAME);
}
function $78783784837c9463$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($78783784837c9463$var$DB_NAME);
    return new $78783784837c9463$var$DBPromise(request).toPromise();
}
function $78783784837c9463$var$_openDatabase() {
    const request = indexedDB.open($78783784837c9463$var$DB_NAME, $78783784837c9463$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($78783784837c9463$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $78783784837c9463$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($78783784837c9463$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $78783784837c9463$var$_deleteDatabase();
                resolve(await $78783784837c9463$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $78783784837c9463$var$_putObject(db, key, value) {
    const request = $78783784837c9463$var$getObjectStore(db, true).put({
        [$78783784837c9463$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $78783784837c9463$var$DBPromise(request).toPromise();
}
async function $78783784837c9463$var$getObject(db, key) {
    const request = $78783784837c9463$var$getObjectStore(db, false).get(key);
    const data = await new $78783784837c9463$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $78783784837c9463$var$_deleteObject(db, key) {
    const request = $78783784837c9463$var$getObjectStore(db, true).delete(key);
    return new $78783784837c9463$var$DBPromise(request).toPromise();
}
const $78783784837c9463$var$_POLLING_INTERVAL_MS = 800;
const $78783784837c9463$var$_TRANSACTION_RETRY_COUNT = 3;
class $78783784837c9463$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $78783784837c9463$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $78783784837c9463$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $78783784837c9463$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $78783784837c9463$var$Receiver._getInstance($78783784837c9463$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $78783784837c9463$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $78783784837c9463$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* PING */ , {}, 800 /* LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $78783784837c9463$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* LONG_ACK */  : 50 /* ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $78783784837c9463$var$_openDatabase();
            await $78783784837c9463$var$_putObject(db, $78783784837c9463$var$STORAGE_AVAILABLE_KEY, "1");
            await $78783784837c9463$var$_deleteObject(db, $78783784837c9463$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$78783784837c9463$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$78783784837c9463$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$78783784837c9463$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $78783784837c9463$var$getObjectStore(db, false).getAll();
            return new $78783784837c9463$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $78783784837c9463$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$78783784837c9463$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $78783784837c9463$export$23f2a1d2818174ef = $78783784837c9463$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$startSignInPhoneMfa(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaSignIn:start" /* START_PHONE_MFA_SIGN_IN */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
function $78783784837c9463$var$finalizeSignInPhoneMfa(auth, request) {
    return $78783784837c9463$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaSignIn:finalize" /* FINALIZE_PHONE_MFA_SIGN_IN */ , $78783784837c9463$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$var$getRecaptchaParams(auth) {
    return (await $78783784837c9463$var$_performApiRequest(auth, "GET" /* GET */ , "/v1/recaptchaParams" /* GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function $78783784837c9463$var$_loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise((resolve, reject)=>{
        const el = document.createElement("script");
        el.setAttribute("src", url);
        el.onload = resolve;
        el.onerror = (e)=>{
            const error = $78783784837c9463$export$d66dc83d8cfc8dd("internal-error" /* INTERNAL_ERROR */ );
            error.customData = e;
            reject(error);
        };
        el.type = "text/javascript";
        el.charset = "UTF-8";
        $78783784837c9463$var$getScriptParentElement().appendChild(el);
    });
}
function $78783784837c9463$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$_SOLVE_TIME_MS = 500;
const $78783784837c9463$var$_EXPIRATION_TIME_MS = 60000;
const $78783784837c9463$var$_WIDGET_ID_START = 1000000000000;
class $78783784837c9463$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $78783784837c9463$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $78783784837c9463$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $78783784837c9463$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $78783784837c9463$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $78783784837c9463$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $78783784837c9463$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $78783784837c9463$export$92108d983e8ee699(container, "argument-error" /* ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $78783784837c9463$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $78783784837c9463$var$_EXPIRATION_TIME_MS);
        }, $78783784837c9463$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $78783784837c9463$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $78783784837c9463$var$_JSLOAD_CALLBACK = $78783784837c9463$var$_generateCallbackName("rcb");
const $78783784837c9463$var$NETWORK_TIMEOUT_DELAY = new $78783784837c9463$var$Delay(30000, 60000);
const $78783784837c9463$var$RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $78783784837c9463$var$ReCaptchaLoaderImpl {
    constructor(){
        this.hostLanguage = "";
        this.counter = 0;
        this.librarySeparatelyLoaded = !!$78783784837c9463$var$_window().grecaptcha;
    }
    load(auth, hl = "") {
        $78783784837c9463$export$92108d983e8ee699($78783784837c9463$var$isHostLanguageValid(hl), auth, "argument-error" /* ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl)) return Promise.resolve($78783784837c9463$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $78783784837c9463$var$_window().setTimeout(()=>{
                reject($78783784837c9463$export$d66dc83d8cfc8dd(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ ));
            }, $78783784837c9463$var$NETWORK_TIMEOUT_DELAY.get());
            $78783784837c9463$var$_window()[$78783784837c9463$var$_JSLOAD_CALLBACK] = ()=>{
                $78783784837c9463$var$_window().clearTimeout(networkTimeout);
                delete $78783784837c9463$var$_window()[$78783784837c9463$var$_JSLOAD_CALLBACK];
                const recaptcha = $78783784837c9463$var$_window().grecaptcha;
                if (!recaptcha) {
                    reject($78783784837c9463$export$d66dc83d8cfc8dd(auth, "internal-error" /* INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$78783784837c9463$var$RECAPTCHA_BASE}?${(0, $c38e0f42709c826a$export$ac4103b836844853)({
                onload: $78783784837c9463$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $78783784837c9463$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($78783784837c9463$export$d66dc83d8cfc8dd(auth, "internal-error" /* INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!$78783784837c9463$var$_window().grecaptcha && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $78783784837c9463$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $78783784837c9463$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $78783784837c9463$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $78783784837c9463$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @public
 */ class $78783784837c9463$export$db202ddc8be9136 {
    /**
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @remarks
     * If none is provided, the default Firebase {@link Auth} instance is used. A Firebase {@link Auth} instance
     * must be initialized with an API key, otherwise an error will be thrown.
     */ constructor(containerOrId, parameters = Object.assign({}, $78783784837c9463$var$DEFAULT_PARAMS), authExtern){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $78783784837c9463$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $78783784837c9463$export$890c4ad488842ce7(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $78783784837c9463$export$92108d983e8ee699(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $78783784837c9463$export$92108d983e8ee699(container, this.auth, "argument-error" /* ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $78783784837c9463$var$MockReCaptchaLoaderImpl() : new $78783784837c9463$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $78783784837c9463$export$92108d983e8ee699(!this.parameters.sitekey, this.auth, "argument-error" /* ARGUMENT_ERROR */ );
        $78783784837c9463$export$92108d983e8ee699(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* ARGUMENT_ERROR */ );
        $78783784837c9463$export$92108d983e8ee699(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $78783784837c9463$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $78783784837c9463$export$92108d983e8ee699(!this.destroyed, this.auth, "internal-error" /* INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $78783784837c9463$export$92108d983e8ee699($78783784837c9463$var$_isHttpOrHttps() && !$78783784837c9463$var$_isWorker(), this.auth, "internal-error" /* INTERNAL_ERROR */ );
        await $78783784837c9463$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $78783784837c9463$var$getRecaptchaParams(this.auth);
        $78783784837c9463$export$92108d983e8ee699(siteKey, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $78783784837c9463$export$92108d983e8ee699(this.recaptcha, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $78783784837c9463$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $78783784837c9463$export$b4171a6734a65d42._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $78783784837c9463$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    const authInternal = $78783784837c9463$export$890c4ad488842ce7(auth);
    const verificationId = await $78783784837c9463$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $78783784837c9463$var$ConfirmationResultImpl(verificationId, (cred)=>$78783784837c9463$export$78acf4525d8a74c4(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $78783784837c9463$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $78783784837c9463$var$_assertLinkedStatus(false, userInternal, "phone" /* PHONE */ );
    const verificationId = await $78783784837c9463$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $78783784837c9463$var$ConfirmationResultImpl(verificationId, (cred)=>$78783784837c9463$export$8743009a87fcb00f(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $78783784837c9463$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const verificationId = await $78783784837c9463$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $78783784837c9463$var$ConfirmationResultImpl(verificationId, (cred)=>$78783784837c9463$export$dc98b0b04f4c7758(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $78783784837c9463$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $78783784837c9463$export$92108d983e8ee699(typeof recaptchaToken === "string", auth, "argument-error" /* ARGUMENT_ERROR */ );
        $78783784837c9463$export$92108d983e8ee699(verifier.type === $78783784837c9463$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $78783784837c9463$export$92108d983e8ee699(session.type === "enroll" /* ENROLL */ , auth, "internal-error" /* INTERNAL_ERROR */ );
                const response = await $78783784837c9463$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $78783784837c9463$export$92108d983e8ee699(session.type === "signin" /* SIGN_IN */ , auth, "internal-error" /* INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $78783784837c9463$export$92108d983e8ee699(mfaEnrollmentId, auth, "missing-multi-factor-info" /* MISSING_MFA_INFO */ );
                const response = await $78783784837c9463$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $78783784837c9463$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $78783784837c9463$export$3b14a55fb2447963(user, credential) {
    await $78783784837c9463$var$_link$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $78783784837c9463$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $78783784837c9463$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $78783784837c9463$export$890c4ad488842ce7(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $78783784837c9463$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $78783784837c9463$export$b4171a6734a65d42._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $78783784837c9463$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if (e.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $78783784837c9463$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $78783784837c9463$export$b4171a6734a65d42._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $78783784837c9463$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $78783784837c9463$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $78783784837c9463$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $78783784837c9463$export$9fa96a7d116ea3ce(resolverOverride);
    $78783784837c9463$export$92108d983e8ee699(auth._popupRedirectResolver, auth, "argument-error" /* ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$var$IdpCredential extends $78783784837c9463$export$2329c99376c9d0a4 {
    constructor(params){
        super("custom" /* CUSTOM */ , "custom" /* CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $78783784837c9463$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $78783784837c9463$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $78783784837c9463$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $78783784837c9463$var$_signIn(params) {
    return $78783784837c9463$var$_signInWithCredential(params.auth, new $78783784837c9463$var$IdpCredential(params), params.bypassAuthState);
}
function $78783784837c9463$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $78783784837c9463$export$92108d983e8ee699(user, auth, "internal-error" /* INTERNAL_ERROR */ );
    return $78783784837c9463$var$_reauthenticate(user, new $78783784837c9463$var$IdpCredential(params), params.bypassAuthState);
}
async function $78783784837c9463$var$_link(params) {
    const { auth: auth, user: user } = params;
    $78783784837c9463$export$92108d983e8ee699(user, auth, "internal-error" /* INTERNAL_ERROR */ );
    return $78783784837c9463$var$_link$1(user, new $78783784837c9463$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $78783784837c9463$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ :
                return $78783784837c9463$var$_signIn;
            case "linkViaPopup" /* LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* LINK_VIA_REDIRECT */ :
                return $78783784837c9463$var$_link;
            case "reauthViaPopup" /* REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ :
                return $78783784837c9463$var$_reauth;
            default:
                $78783784837c9463$export$6554612db691658e(this.auth, "internal-error" /* INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $78783784837c9463$export$2f6ca3d3b1f80bf5(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $78783784837c9463$export$2f6ca3d3b1f80bf5(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $78783784837c9463$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */ async function $78783784837c9463$export$db3b6bfb95261072(auth, provider, resolver) {
    const authInternal = $78783784837c9463$export$890c4ad488842ce7(auth);
    $78783784837c9463$var$_assertInstanceOf(auth, provider, $78783784837c9463$var$FederatedAuthProvider);
    const resolverInternal = $78783784837c9463$var$_withDefaultResolver(authInternal, resolver);
    const action = new $78783784837c9463$var$PopupOperation(authInternal, "signInViaPopup" /* SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $78783784837c9463$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $78783784837c9463$var$_assertInstanceOf(userInternal.auth, provider, $78783784837c9463$var$FederatedAuthProvider);
    const resolverInternal = $78783784837c9463$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $78783784837c9463$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $78783784837c9463$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $78783784837c9463$var$_assertInstanceOf(userInternal.auth, provider, $78783784837c9463$var$FederatedAuthProvider);
    const resolverInternal = $78783784837c9463$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $78783784837c9463$var$PopupOperation(userInternal.auth, "linkViaPopup" /* LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $78783784837c9463$var$PopupOperation extends $78783784837c9463$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($78783784837c9463$var$PopupOperation.currentPopupAction) $78783784837c9463$var$PopupOperation.currentPopupAction.cancel();
        $78783784837c9463$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $78783784837c9463$export$92108d983e8ee699(result, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $78783784837c9463$export$2f6ca3d3b1f80bf5(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $78783784837c9463$export$53a70dd1ebbae346();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($78783784837c9463$export$d66dc83d8cfc8dd(this.auth, "web-storage-unsupported" /* WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($78783784837c9463$export$d66dc83d8cfc8dd(this.auth, "cancelled-popup-request" /* EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $78783784837c9463$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($78783784837c9463$export$d66dc83d8cfc8dd(this.auth, "popup-closed-by-user" /* POPUP_CLOSED_BY_USER */ ));
                }, 2000 /* AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $78783784837c9463$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$78783784837c9463$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $78783784837c9463$var$redirectOutcomeMap = new Map();
class $78783784837c9463$var$RedirectAction extends $78783784837c9463$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ ,
            "unknown" /* UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $78783784837c9463$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $78783784837c9463$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $78783784837c9463$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $78783784837c9463$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $78783784837c9463$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $78783784837c9463$var$pendingRedirectKey(auth);
    const persistence = $78783784837c9463$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $78783784837c9463$var$_setPendingRedirectStatus(resolver, auth) {
    return $78783784837c9463$var$resolverPersistence(resolver)._set($78783784837c9463$var$pendingRedirectKey(auth), "true");
}
function $78783784837c9463$export$9d398bebfec1c039() {
    $78783784837c9463$var$redirectOutcomeMap.clear();
}
function $78783784837c9463$var$resolverPersistence(resolver) {
    return $78783784837c9463$export$9fa96a7d116ea3ce(resolver._redirectPersistence);
}
function $78783784837c9463$var$pendingRedirectKey(auth) {
    return $78783784837c9463$export$28f7fcd39efa255($78783784837c9463$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $78783784837c9463$export$2d1720544b23b823(auth, provider, resolver) {
    return $78783784837c9463$var$_signInWithRedirect(auth, provider, resolver);
}
async function $78783784837c9463$var$_signInWithRedirect(auth, provider, resolver) {
    const authInternal = $78783784837c9463$export$890c4ad488842ce7(auth);
    $78783784837c9463$var$_assertInstanceOf(auth, provider, $78783784837c9463$var$FederatedAuthProvider);
    const resolverInternal = $78783784837c9463$var$_withDefaultResolver(authInternal, resolver);
    await $78783784837c9463$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Link using a redirect.
 * await linkWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $78783784837c9463$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $78783784837c9463$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $78783784837c9463$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $78783784837c9463$var$_assertInstanceOf(userInternal.auth, provider, $78783784837c9463$var$FederatedAuthProvider);
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $78783784837c9463$var$_withDefaultResolver(userInternal.auth, resolver);
    await $78783784837c9463$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $78783784837c9463$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */ function $78783784837c9463$export$39b482c5e57630a8(user, provider, resolver) {
    return $78783784837c9463$var$_linkWithRedirect(user, provider, resolver);
}
async function $78783784837c9463$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $78783784837c9463$var$_assertInstanceOf(userInternal.auth, provider, $78783784837c9463$var$FederatedAuthProvider);
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $78783784837c9463$var$_withDefaultResolver(userInternal.auth, resolver);
    await $78783784837c9463$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $78783784837c9463$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $78783784837c9463$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns a {@link UserCredential}
 * with a null `user`.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $78783784837c9463$export$35e795649ee09318(auth, resolver) {
    await $78783784837c9463$export$890c4ad488842ce7(auth)._initializationPromise;
    return $78783784837c9463$export$91c6e00c14e7e6fd(auth, resolver, false);
}
async function $78783784837c9463$export$91c6e00c14e7e6fd(auth, resolverExtern, bypassAuthState = false) {
    const authInternal = $78783784837c9463$export$890c4ad488842ce7(auth);
    const resolver = $78783784837c9463$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $78783784837c9463$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $78783784837c9463$var$prepareUserForRedirect(user) {
    const eventId = $78783784837c9463$export$53a70dd1ebbae346(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $78783784837c9463$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $78783784837c9463$export$3d12bd131bb975d1 {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$78783784837c9463$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$78783784837c9463$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* INTERNAL_ERROR */ ;
            consumer.onError($78783784837c9463$export$d66dc83d8cfc8dd(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $78783784837c9463$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($78783784837c9463$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($78783784837c9463$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $78783784837c9463$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $78783784837c9463$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* NO_AUTH_EVENT */ }`;
}
function $78783784837c9463$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* UNKNOWN */ :
            return $78783784837c9463$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $78783784837c9463$export$1fbe638ecf81657e(auth, request = {}) {
    return $78783784837c9463$var$_performApiRequest(auth, "GET" /* GET */ , "/v1/projects" /* GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $78783784837c9463$var$HTTP_REGEX = /^https?/;
async function $78783784837c9463$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $78783784837c9463$export$1fbe638ecf81657e(auth);
    for (const domain of authorizedDomains)try {
        if ($78783784837c9463$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $78783784837c9463$export$6554612db691658e(auth, "unauthorized-domain" /* INVALID_ORIGIN */ );
}
function $78783784837c9463$var$matchDomain(expected) {
    const currentUrl = $78783784837c9463$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$78783784837c9463$var$HTTP_REGEX.test(protocol)) return false;
    if ($78783784837c9463$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$NETWORK_TIMEOUT = new $78783784837c9463$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $78783784837c9463$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $78783784837c9463$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $78783784837c9463$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $78783784837c9463$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $78783784837c9463$var$resetUnloadedGapiModules();
                    reject($78783784837c9463$export$d66dc83d8cfc8dd(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $78783784837c9463$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $78783784837c9463$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $78783784837c9463$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $78783784837c9463$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $78783784837c9463$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($78783784837c9463$export$d66dc83d8cfc8dd(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $78783784837c9463$var$_loadJS(`https://apis.google.com/js/api.js?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $78783784837c9463$var$cachedGApiLoader = null;
        throw error;
    });
}
let $78783784837c9463$var$cachedGApiLoader = null;
function $78783784837c9463$var$_loadGapi(auth) {
    $78783784837c9463$var$cachedGApiLoader = $78783784837c9463$var$cachedGApiLoader || $78783784837c9463$var$loadGapi(auth);
    return $78783784837c9463$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$PING_TIMEOUT = new $78783784837c9463$var$Delay(5000, 15000);
const $78783784837c9463$var$IFRAME_PATH = "__/auth/iframe";
const $78783784837c9463$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $78783784837c9463$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $78783784837c9463$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $78783784837c9463$var$getIframeUrl(auth) {
    const config = auth.config;
    $78783784837c9463$export$92108d983e8ee699(config.authDomain, auth, "auth-domain-config-required" /* MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $78783784837c9463$var$_emulatorUrl(config, $78783784837c9463$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$78783784837c9463$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $57d436074e210fb5$export$31499a9cd224b78c)
    };
    const eid = $78783784837c9463$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $c38e0f42709c826a$export$ac4103b836844853)(params).slice(1)}`;
}
async function $78783784837c9463$var$_openIframe(auth) {
    const context = await $78783784837c9463$var$_loadGapi(auth);
    const gapi1 = $78783784837c9463$var$_window().gapi;
    $78783784837c9463$export$92108d983e8ee699(gapi1, auth, "internal-error" /* INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $78783784837c9463$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $78783784837c9463$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $78783784837c9463$export$d66dc83d8cfc8dd(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $78783784837c9463$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $78783784837c9463$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $78783784837c9463$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $78783784837c9463$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $78783784837c9463$var$DEFAULT_WIDTH = 500;
const $78783784837c9463$var$DEFAULT_HEIGHT = 600;
const $78783784837c9463$var$TARGET_BLANK = "_blank";
const $78783784837c9463$var$FIREFOX_EMPTY_URL = "http://localhost";
class $78783784837c9463$export$a33b77bbdbb8366c {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $78783784837c9463$var$_open(auth, url, name, width = $78783784837c9463$var$DEFAULT_WIDTH, height = $78783784837c9463$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $78783784837c9463$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $78783784837c9463$var$_isChromeIOS(ua) ? $78783784837c9463$var$TARGET_BLANK : name;
    if ($78783784837c9463$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $78783784837c9463$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($78783784837c9463$var$_isIOSStandalone(ua) && target !== "_self") {
        $78783784837c9463$var$openAsNewWindowIOS(url || "", target);
        return new $78783784837c9463$export$a33b77bbdbb8366c(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $78783784837c9463$export$92108d983e8ee699(newWin, auth, "popup-blocked" /* POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $78783784837c9463$export$a33b77bbdbb8366c(newWin);
}
function $78783784837c9463$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $78783784837c9463$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $78783784837c9463$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
function $78783784837c9463$export$493d36ec626b6698(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $78783784837c9463$export$92108d983e8ee699(auth.config.authDomain, auth, "auth-domain-config-required" /* MISSING_AUTH_DOMAIN */ );
    $78783784837c9463$export$92108d983e8ee699(auth.config.apiKey, auth, "invalid-api-key" /* INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $57d436074e210fb5$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $78783784837c9463$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $78783784837c9463$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    return `${$78783784837c9463$var$getHandlerBase(auth)}?${(0, $c38e0f42709c826a$export$ac4103b836844853)(paramsDict).slice(1)}`;
}
function $78783784837c9463$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$78783784837c9463$var$WIDGET_PATH}`;
    return $78783784837c9463$var$_emulatorUrl(config, $78783784837c9463$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $78783784837c9463$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $78783784837c9463$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $78783784837c9463$export$407448d2b89b1813;
        this._completeRedirectFn = $78783784837c9463$export$91c6e00c14e7e6fd;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $78783784837c9463$export$2f6ca3d3b1f80bf5((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = $78783784837c9463$export$493d36ec626b6698(auth, provider, authType, $78783784837c9463$var$_getCurrentUrl(), eventId);
        return $78783784837c9463$var$_open(auth, url, $78783784837c9463$export$53a70dd1ebbae346());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        $78783784837c9463$var$_setWindowLocation($78783784837c9463$export$493d36ec626b6698(auth, provider, authType, $78783784837c9463$var$_getCurrentUrl(), eventId));
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $78783784837c9463$export$2f6ca3d3b1f80bf5(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $78783784837c9463$var$_openIframe(auth);
        const manager = new $78783784837c9463$export$3d12bd131bb975d1(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $78783784837c9463$export$92108d983e8ee699(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* ACK */  : "ERROR" /* ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($78783784837c9463$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $78783784837c9463$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$78783784837c9463$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $78783784837c9463$export$6554612db691658e(auth, "internal-error" /* INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $78783784837c9463$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $78783784837c9463$var$_isMobileBrowser() || $78783784837c9463$var$_isSafari() || $78783784837c9463$export$8a5498727ef6be21();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @public
 */ const $78783784837c9463$export$342063e11d6c3cad = $78783784837c9463$var$BrowserPopupRedirectResolver;
class $78783784837c9463$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $78783784837c9463$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $78783784837c9463$var$PhoneMultiFactorAssertionImpl extends $78783784837c9463$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $78783784837c9463$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $78783784837c9463$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $78783784837c9463$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $78783784837c9463$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $78783784837c9463$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $78783784837c9463$export$953cecd6e717a553.FACTOR_ID = "phone";
var $78783784837c9463$var$name = "@firebase/auth";
var $78783784837c9463$var$version = "0.19.5";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $78783784837c9463$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            var _a;
            listener(((_a = user) === null || _a === void 0 ? void 0 : _a.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $78783784837c9463$export$92108d983e8ee699(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $78783784837c9463$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* NODE */ :
            return "node";
        case "ReactNative" /* REACT_NATIVE */ :
            return "rn";
        case "Worker" /* WORKER */ :
            return "webworker";
        case "Cordova" /* CORDOVA */ :
            return "cordova";
        default:
            return undefined;
    }
}
/** @internal */ function $78783784837c9463$var$registerAuth(clientPlatform) {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("auth" /* AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        return ((app)=>{
            $78783784837c9463$export$92108d983e8ee699(apiKey && !apiKey.includes(":"), "invalid-api-key" /* INVALID_API_KEY */ , {
                appName: app.name
            });
            // Auth domain is optional if IdP sign in isn't being used
            $78783784837c9463$export$92108d983e8ee699(!(authDomain === null || authDomain === void 0 ? void 0 : authDomain.includes(":")), "argument-error" /* ARGUMENT_ERROR */ , {
                appName: app.name
            });
            const config = {
                apiKey: apiKey,
                authDomain: authDomain,
                clientPlatform: clientPlatform,
                apiHost: "identitytoolkit.googleapis.com" /* API_HOST */ ,
                tokenApiHost: "securetoken.googleapis.com" /* TOKEN_API_HOST */ ,
                apiScheme: "https" /* API_SCHEME */ ,
                sdkClientVersion: $78783784837c9463$export$cf2f7c5792f80b46(clientPlatform)
            };
            const authInstance = new $78783784837c9463$export$158acd800e1ef08b(app, config);
            $78783784837c9463$var$_initializeAuthInstance(authInstance, deps);
            return authInstance;
        })(app);
    }, "PUBLIC" /* PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("auth-internal" /* AUTH_INTERNAL */ , (container)=>{
        const auth = $78783784837c9463$export$890c4ad488842ce7(container.getProvider("auth" /* AUTH */ ).getImmediate());
        return ((auth)=>new $78783784837c9463$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* PRIVATE */ ).setInstantiationMode("EXPLICIT" /* EXPLICIT */ ));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($78783784837c9463$var$name, $78783784837c9463$var$version, $78783784837c9463$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($78783784837c9463$var$name, $78783784837c9463$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $78783784837c9463$export$7ccc53e8f1e7dfc5(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    return $78783784837c9463$export$96f57966bedc81b4(app, {
        popupRedirectResolver: $78783784837c9463$export$342063e11d6c3cad,
        persistence: [
            $78783784837c9463$export$23f2a1d2818174ef,
            $78783784837c9463$export$8b22cf2602fb60ce,
            $78783784837c9463$export$407448d2b89b1813
        ]
    });
}
$78783784837c9463$var$registerAuth("Browser" /* BROWSER */ );














var $acw62 = parcelRequire("acw62");

function $a67e83eea730647a$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $a67e83eea730647a$var$$2baaea4c71418dea$exports = {};
$a67e83eea730647a$var$$parcel$export($a67e83eea730647a$var$$2baaea4c71418dea$exports, "useField", ()=>$a67e83eea730647a$export$294aa081a6c6f55d);
var $a67e83eea730647a$var$$d191a55c9702f145$exports = {};
$a67e83eea730647a$var$$parcel$export($a67e83eea730647a$var$$d191a55c9702f145$exports, "useLabel", ()=>$a67e83eea730647a$export$8467354a121f1b9f);
function $a67e83eea730647a$export$8467354a121f1b9f(props) {
    let { id: id, label: label, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, labelElementType: labelElementType = "label" } = props;
    id = (0, $4d60a29ecf011a9e$export$f680877a34711e37)(id);
    let labelId = (0, $4d60a29ecf011a9e$export$f680877a34711e37)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${ariaLabelledby} ${labelId}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    let fieldProps = (0, $4d60a29ecf011a9e$export$d6875122194c7b44)({
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}
function $a67e83eea730647a$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = $a67e83eea730647a$export$8467354a121f1b9f(props);
    let descriptionId = (0, $4d60a29ecf011a9e$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        validationState
    ]);
    let errorMessageId = (0, $4d60a29ecf011a9e$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        validationState
    ]);
    fieldProps = (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}


const $7e0e6aad51cc8043$export$9c21a3269931e1e6 = {
    disabled: !1,
    bordered: !1,
    readOnly: !1,
    clearable: !1,
    rounded: !1,
    animated: !0,
    underlined: !1,
    shadow: !0,
    fullWidth: !1,
    contentClickable: !1,
    contentRightStyling: !0,
    contentLeftStyling: !0,
    required: !1,
    width: "initial",
    size: "md",
    color: "default",
    helperColor: "default",
    status: "default",
    borderWeight: "normal",
    autoComplete: "off",
    className: "",
    placeholder: "",
    initialValue: ""
};



var $acw62 = parcelRequire("acw62");

var $1b278c477febcfee$export$2e2bcd8739ae039 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $a1074736d4db0ca2$export$2e2bcd8739ae039));


var $116f27f1fc2ac09a$export$2e2bcd8739ae039 = (0, $1b278c477febcfee$export$2e2bcd8739ae039);





const $bf1f9a6abf0e8edc$export$c621cc86895692f = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    $$inputColor: "$colors$accents0",
    $$inputTextColor: "$colors$text",
    $$inputPlaceholderColor: "$colors$accents6",
    $$inputShadow: "$shadows$sm",
    $$inputBorderColor: "$colors$border",
    $$inputHoverBorderColor: "$colors$foreground",
    $$inputLabelColor: "$$inputHoverBorderColor",
    display: "inline-flex",
    flexDirection: "column",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitBoxAlign: "center",
    variants: {
        color: {
            default: {},
            primary: {
                $$inputHoverBorderColor: "$colors$primary",
                $$inputLabelColor: "$colors$primary"
            },
            secondary: {
                $$inputHoverBorderColor: "$colors$secondary",
                $$inputLabelColor: "$colors$secondary"
            },
            success: {
                $$inputHoverBorderColor: "$colors$success",
                $$inputLabelColor: "$colors$success"
            },
            warning: {
                $$inputHoverBorderColor: "$colors$warning",
                $$inputLabelColor: "$colors$warning"
            },
            error: {
                $$inputHoverBorderColor: "$colors$error",
                $$inputLabelColor: "$colors$error"
            }
        },
        status: {
            default: {},
            primary: {
                $$inputColor: "$colors$primaryLight",
                $$inputPlaceholderColor: "$colors$primaryLightContrast",
                $$inputTextColor: "$colors$primaryLightContrast",
                $$inputLabelColor: "$$inputTextColor",
                $$inputHoverBorderColor: "$colors$primary"
            },
            secondary: {
                $$inputColor: "$colors$secondaryLight",
                $$inputPlaceholderColor: "$colors$secondaryLightContrast",
                $$inputTextColor: "$colors$secondaryLightContrast",
                $$inputLabelColor: "$$inputTextColor",
                $$inputHoverBorderColor: "$colors$secondary"
            },
            success: {
                $$inputColor: "$colors$successLight",
                $$inputPlaceholderColor: "$colors$successLightContrast",
                $$inputTextColor: "$colors$successLightContrast",
                $$inputLabelColor: "$$inputTextColor",
                $$inputHoverBorderColor: "$colors$success"
            },
            warning: {
                $$inputColor: "$colors$warningLight",
                $$inputPlaceholderColor: "$colors$warningLightContrast",
                $$inputTextColor: "$colors$warningLightContrast",
                $$inputLabelColor: "$$inputTextColor",
                $$inputHoverBorderColor: "$colors$warning"
            },
            error: {
                $$inputColor: "$colors$errorLight",
                $$inputPlaceholderColor: "$colors$errorLightContrast",
                $$inputTextColor: "$colors$errorLightContrast",
                $$inputLabelColor: "$$inputTextColor",
                $$inputHoverBorderColor: "$colors$error"
            }
        },
        helperColor: {
            default: {
                $$inputHelperColor: "$colors$text"
            },
            primary: {
                $$inputHelperColor: "$colors$primary"
            },
            secondary: {
                $$inputHelperColor: "$colors$secondary"
            },
            success: {
                $$inputHelperColor: "$colors$success"
            },
            warning: {
                $$inputHelperColor: "$colors$warning"
            },
            error: {
                $$inputHelperColor: "$colors$error"
            }
        },
        borderWeight: {
            light: {
                $$inputBorderWeight: "$borderWeights$light"
            },
            normal: {
                $$inputBorderWeight: "$borderWeights$normal"
            },
            bold: {
                $$inputBorderWeight: "$borderWeights$bold"
            },
            extrabold: {
                $$inputBorderWeight: "$borderWeights$extrabold"
            },
            black: {
                $$inputBorderWeight: "$borderWeights$black"
            }
        },
        size: {
            xs: {
                $$inputBorderRadius: "$space$3",
                $$inputFontSize: "$fontSizes$xs",
                $$inputHeightRatio: "1.2",
                br: "$$inputBorderRadius"
            },
            sm: {
                $$inputBorderRadius: "$space$4",
                $$inputFontSize: "$fontSizes$xs",
                $$inputHeightRatio: "1.6",
                br: "$$inputBorderRadius"
            },
            md: {
                $$inputBorderRadius: "$space$6",
                $$inputFontSize: "$fontSizes$sm",
                $$inputHeightRatio: "2",
                br: "$$inputBorderRadius"
            },
            lg: {
                $$inputBorderRadius: "$space$7",
                $$inputFontSize: "$fontSizes$md",
                $$inputHeightRatio: "2.2",
                br: "$$inputBorderRadius"
            },
            xl: {
                $$inputBorderRadius: "$space$8",
                $$inputFontSize: "$fontSizes$lg",
                $$inputHeightRatio: "2.6",
                br: "$$inputBorderRadius"
            }
        },
        rounded: {
            true: {
                $$inputBorderRadius: "$radii$pill"
            }
        },
        disabled: {
            true: {
                $$inputColor: "$colors$accents1",
                $$inputTextColor: "$colors$accents7",
                $$inputPlaceholderColor: "$colors$accents7",
                $$inputShadow: "$shadows$sm"
            }
        }
    }
});
const $bf1f9a6abf0e8edc$export$b6fc3b0e5138327b = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    width: "100%",
    br: "$$inputBorderRadius",
    "@motion": {
        transition: "none"
    },
    variants: {
        isTextarea: {
            false: {
                display: "inline-flex",
                alignItems: "center",
                height: "calc($$inputHeightRatio * $9)"
            }
        },
        focused: {
            true: {}
        },
        isReadOnly: {
            false: {}
        },
        underlined: {
            true: {}
        },
        animated: {
            true: {
                transition: "$default"
            },
            false: {
                transition: "none"
            }
        }
    },
    compoundVariants: [
        {
            isReadOnly: !1,
            underlined: !0,
            css: {
                transform: "none"
            }
        },
        {
            focused: !0,
            animated: !0,
            isReadOnly: !1,
            underlined: !1,
            css: {
                transform: "translateY(-$space$1)"
            }
        }
    ]
});
const $bf1f9a6abf0e8edc$export$a195049fd73b3fe2 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("input", {
    padding: 0,
    fontSize: "$$inputFontSize",
    bg: "transparent",
    border: "none",
    color: "$$inputTextColor",
    br: 0,
    outline: "none",
    size: "100%",
    minWidth: 0,
    WebkitAppearance: "none",
    "::placeholder": {
        color: "$$inputPlaceholderColor",
        transition: "opacity 0.25s ease 0s",
        MozTransition: "opacity 0.25s ease 0s",
        MsTransition: "opacity 0.25s ease 0s",
        WebkitTransition: "opacity 0.25s ease 0s"
    },
    "@motion": {
        transition: "none",
        "&::placeholder": {
            transition: "none"
        }
    },
    "&:disabled": {
        pe: "none",
        color: "$accents4",
        cursor: "not-allowed"
    },
    variants: {
        isTextarea: {
            true: {
                boxShadow: "none",
                display: "block",
                size: "100%",
                resize: "none",
                border: "none",
                outline: "none"
            }
        },
        focused: {
            true: {
                "&::placeholder": {
                    opacity: 0,
                    transition: "opacity 0.25s ease 0s"
                }
            }
        },
        bordered: {
            true: {
                padding: "0 $3"
            }
        },
        rounded: {
            true: {
                padding: "0 $3"
            }
        },
        animated: {
            false: {
                transition: "none",
                "::placeholder": {
                    transition: "none"
                }
            }
        },
        hasLeftContent: {
            true: {
                ml: 0
            }
        },
        hasRightContent: {
            true: {
                mr: 0
            }
        }
    }
});
const $bf1f9a6abf0e8edc$export$479bffa770f4fc8b = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    flex: 1,
    position: "relative",
    br: "$$inputBorderRadius",
    bg: "$$inputColor",
    display: "inline-flex",
    verticalAlign: "middle",
    alignItems: "center",
    userSelect: "none",
    "@motion": {
        transition: "none",
        "&:before": {
            transition: "none"
        },
        "&:after": {
            transition: "none"
        }
    },
    variants: {
        focused: {
            true: {}
        },
        isReadOnly: {
            true: {}
        },
        bordered: {
            true: {
                bg: "transparent",
                border: "none",
                boxShadow: "0 0 0 $$inputBorderWeight $$inputBorderColor",
                transition: "box-shadow 0.25s ease"
            }
        },
        shadow: {
            true: {
                transition: "$default"
            }
        },
        disabled: {
            true: {
                cursor: "not-allowed"
            }
        },
        underlined: {
            true: {
                bg: "transparent",
                [`& ${$bf1f9a6abf0e8edc$export$a195049fd73b3fe2}`]: {
                    margin: "$2 $3"
                },
                "&:before": {
                    content: "",
                    position: "absolute",
                    zIndex: "$2",
                    width: 0,
                    bottom: 0,
                    height: "$1",
                    left: "50%",
                    transform: "translate(-50%)",
                    background: "$$inputHoverBorderColor",
                    transition: "width 0.25s ease"
                },
                "&:after": {
                    content: "",
                    position: "absolute",
                    zIndex: "$1",
                    bottom: 0,
                    width: "100%",
                    height: "$$inputBorderWeight",
                    bg: "$$inputBorderColor"
                }
            },
            false: {
                [`& ${$bf1f9a6abf0e8edc$export$a195049fd73b3fe2}`]: {
                    margin: "$2 $5"
                }
            }
        },
        animated: {
            false: {
                transition: "none",
                "&:before": {
                    transition: "none"
                },
                "&:after": {
                    transition: "none"
                }
            }
        },
        isTextarea: {
            true: {
                boxSizing: "border-box",
                width: "100%",
                maxWidth: "100%",
                height: "auto"
            },
            false: {
                height: "100%"
            }
        }
    },
    compoundVariants: [
        {
            bordered: !0,
            underlined: !0,
            css: {
                boxShadow: "0 0 0 0px $$inputBorderColor"
            }
        },
        {
            focused: !0,
            underlined: !0,
            css: {
                "&:before": {
                    width: "100%"
                }
            }
        },
        {
            focused: !0,
            shadow: !0,
            isReadOnly: !1,
            underlined: !1,
            css: {
                boxShadow: "$$inputShadow"
            }
        },
        {
            focused: !0,
            bordered: !0,
            isReadOnly: !1,
            underlined: !1,
            css: {
                boxShadow: "0 0 0 $$inputBorderWeight $$inputHoverBorderColor"
            }
        },
        {
            bordered: !0,
            isReadOnly: !1,
            underlined: !1,
            css: {
                "&:hover": {
                    boxShadow: "0 0 0 $$inputBorderWeight $$inputHoverBorderColor"
                }
            }
        },
        {
            isTextarea: !0,
            underlined: !1,
            css: {
                [`& ${$bf1f9a6abf0e8edc$export$a195049fd73b3fe2}`]: {
                    margin: "$xs $sm"
                }
            }
        }
    ]
});
const $bf1f9a6abf0e8edc$export$76a3ef0780916a27 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    opacity: 0,
    bottom: "calc($$inputHeightRatio * -$space$5)",
    "@motion": {
        transition: "none"
    },
    variants: {
        animated: {
            true: {
                transition: "opacity 0.25s ease"
            },
            false: {
                transition: "none"
            }
        },
        withValue: {
            true: {
                opacity: 1
            }
        }
    }
});
const $bf1f9a6abf0e8edc$export$cd0a7d3af414ca4a = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("p", {
    margin: "$1 0 0 $5",
    fontSize: "$space$5",
    color: "$$inputHelperColor"
});
const $bf1f9a6abf0e8edc$export$a9ee5a73a871e7de = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {}, (0, $eaf275b21629a4ec$export$74eab49e97f7dd3b));
const $bf1f9a6abf0e8edc$export$10fc4bf0607c33dc = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("label", {
    d: "block",
    fontWeight: "$normal",
    color: "$$inputLabelColor",
    p: "0 0 0 $2",
    mb: "$3",
    fs: "$$inputFontSize",
    lh: "$md",
    WebkitTouchCallout: "none",
    WebkitUserSelect: "none",
    KhtmlUserSelect: "none",
    MozUserSelect: "none",
    MsUserSelect: "none",
    us: "none",
    "> *:first-child": {
        marginTop: 0
    },
    "> *:last-child": {
        mb: 0
    },
    "@motion": {
        transition: "none"
    },
    variants: {
        rounded: {
            true: {
                padding: "0 0 0 $3"
            }
        },
        asPlaceholder: {
            true: {
                position: "absolute",
                padding: 0,
                zIndex: "$1",
                left: "$space$6",
                top: "20%",
                mb: 0,
                cursor: "text",
                color: "$$inputPlaceholderColor",
                transition: "left 0.25s ease 0s, color 0.25s ease 0s, top 0.25s ease 0s"
            }
        },
        animated: {
            false: {
                transition: "none"
            }
        },
        focused: {
            true: {
                color: "$$inputHoverBorderColor"
            }
        },
        underlined: {
            true: {}
        },
        withValue: {
            true: {}
        },
        isTextarea: {
            true: {}
        },
        bordered: {
            true: {}
        },
        hasContentLeft: {
            true: {}
        }
    },
    compoundVariants: [
        {
            underlined: !0,
            asPlaceholder: !0,
            css: {
                left: "$space$2"
            }
        },
        {
            asPlaceholder: !0,
            focused: !0,
            underlined: !1,
            isTextarea: !1,
            css: {
                top: "-72%",
                left: "$2",
                cursor: "inherit"
            }
        },
        {
            asPlaceholder: !0,
            focused: !0,
            underlined: !0,
            isTextarea: !1,
            css: {
                top: "-72%",
                left: "0px",
                cursor: "inherit"
            }
        },
        {
            asPlaceholder: !0,
            withValue: !0,
            underlined: !1,
            isTextarea: !1,
            css: {
                color: "$$inputTextColor",
                top: "-72%",
                left: "$2",
                cursor: "inherit"
            }
        },
        {
            asPlaceholder: !0,
            withValue: !0,
            underlined: !0,
            isTextarea: !1,
            css: {
                color: "$$inputTextColor",
                top: "-72%",
                left: "0px",
                cursor: "inherit"
            }
        },
        {
            asPlaceholder: !0,
            isTextarea: !0,
            css: {
                top: "$5"
            }
        },
        {
            asPlaceholder: !0,
            hasContentLeft: !0,
            css: {
                left: "calc($space$6 + $$inputHeightRatio * $space$7)"
            }
        },
        {
            asPlaceholder: !0,
            isTextarea: !0,
            focused: !0,
            css: {
                top: "calc(-$space$10 - $space$3)",
                left: "$2"
            }
        },
        {
            asPlaceholder: !0,
            isTextarea: !0,
            withValue: !0,
            css: {
                top: "-$11"
            }
        },
        {
            asPlaceholder: !0,
            focused: !0,
            isTextarea: !0,
            bordered: !0,
            css: {
                top: "-$12"
            }
        }
    ],
    defaultVariants: {
        asPlaceholder: !1
    }
});
const $bf1f9a6abf0e8edc$export$c19db8ea26d35118 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {
    position: "relative",
    display: "inline-flex",
    width: "initial",
    height: "100%",
    fontWeight: "$medium",
    ai: "center",
    pe: "none",
    margin: 0,
    padding: "0 $sm",
    color: "$$inputPlaceholderColor",
    fontSize: "$$inputFontSize",
    lineHeight: "$xs",
    variants: {
        isRight: {
            true: {
                btrr: "$$inputBorderRadius",
                bbrr: "$$inputBorderRadius"
            },
            false: {
                btlr: "$$inputBorderRadius",
                bblr: "$$inputBorderRadius"
            }
        },
        isDark: {
            true: {}
        },
        isDefaultStatus: {
            true: {}
        },
        underlined: {
            true: {
                bg: "transparent"
            }
        },
        bordered: {
            true: {
                "&:after": {
                    display: "none"
                },
                "&:before": {
                    display: "none"
                }
            }
        }
    },
    compoundVariants: [
        {
            isRight: !0,
            underlined: !0,
            css: {
                borderLeftColor: "$$inputPlaceholderColor",
                borderLeftStyle: "solid",
                marginLeft: "$2",
                borderLeftWidth: "calc($$inputBorderWeight / 2)",
                height: "40%"
            }
        },
        {
            isRight: !1,
            underlined: !0,
            css: {
                borderRightColor: "$$inputPlaceholderColor",
                borderRightStyle: "solid",
                marginRight: "$2",
                borderRightWidth: "calc($$inputBorderWeight / 1)",
                height: "40%"
            }
        },
        {
            isDefaultStatus: !0,
            bordered: !1,
            underlined: !1,
            css: {
                bg: "$accents2"
            }
        },
        {
            isDefaultStatus: !0,
            bordered: !1,
            underlined: !1,
            isDark: !0,
            css: {
                color: "$accents6"
            }
        },
        {
            isDefaultStatus: !1,
            bordered: !0,
            underlined: !1,
            css: {
                bg: "$$inputColor"
            }
        },
        {
            bordered: !0,
            isRight: !0,
            css: {
                peddingRight: "$sm",
                paddingLeft: 0
            }
        },
        {
            bordered: !0,
            isRight: !1,
            css: {
                peddingLeft: "$sm",
                paddingRight: 0
            }
        }
    ],
    defaultVariants: {
        isRight: !1
    }
});
const $bf1f9a6abf0e8edc$export$674641af68f172f = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {
    variants: {
        applyStyles: {
            true: {
                display: "flex",
                boxSizing: "content-box",
                width: "calc($$inputHeightRatio * $space$4)",
                height: "100%",
                alignItems: "center",
                verticalAlign: "center",
                margin: 0,
                padding: "0 calc($$inputHeightRatio * $3)",
                color: "$$inputTextColor",
                lineHeight: "$xs",
                position: "relative",
                cursor: "default",
                pe: "none"
            }
        },
        clickable: {
            true: {
                cursor: "pointer",
                pe: "auto"
            }
        }
    }
});
const $bf1f9a6abf0e8edc$export$4f17d3e4f705316 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("button", {
    position: "absolute",
    right: 0,
    margin: 0,
    d: "inline-flex",
    ai: "center",
    border: "none",
    bg: "transparent",
    width: "auto",
    height: "auto",
    cursor: "pointer",
    boxSizing: "border-box",
    transition: "color 250ms ease 0s, transform 250ms ease 0s, opacity 250ms ease 0s",
    color: "$$inputPlaceholderColor",
    visibility: "hidden",
    transform: "translateX(20%)",
    opacity: 0,
    "&:hover": {
        opacity: .85
    },
    svg: {
        color: "currentColor",
        size: "calc($space$5 * $$inputHeightRatio)"
    },
    "@motion": {
        transition: "none"
    },
    variants: {
        visible: {
            true: {
                visibility: "visible",
                transform: "translateX(0)",
                opacity: 1
            }
        },
        underlined: {
            true: {
                padding: "0 $1"
            }
        },
        animated: {
            false: {
                transition: "none"
            }
        },
        hasContentRight: {
            true: {
                padding: 0,
                position: "relative",
                transform: "translateX(30%)"
            }
        },
        disabled: {
            true: {
                cursor: "not-allowed",
                "&:hover": {
                    color: "$accents3"
                }
            }
        }
    }
});



var $acw62 = parcelRequire("acw62");


const $aea1449f5da8af64$var$a = ({ size: e, fill: i, plain: a, width: l, height: s, className: o, ...h })=>(0, $7b02d682eb115277$exports.jsx)("svg", a ? {
        width: e || l,
        height: e || s,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: i,
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: o,
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 6L6 18M6 6l12 12"
        })
    } : {
        width: e || l,
        height: e || s,
        viewBox: "0 0 24 24",
        className: o,
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 1010 10A10.016 10.016 0 0012 2zm3.36 12.3a.754.754 0 010 1.06.748.748 0 01-1.06 0l-2.3-2.3-2.3 2.3a.748.748 0 01-1.06 0 .754.754 0 010-1.06l2.3-2.3-2.3-2.3A.75.75 0 019.7 8.64l2.3 2.3 2.3-2.3a.75.75 0 011.06 1.06l-2.3 2.3z",
            fill: i
        })
    }), $aea1449f5da8af64$var$l = $acw62.memo($aea1449f5da8af64$var$a);
var $aea1449f5da8af64$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($aea1449f5da8af64$var$l, {
    width: 24,
    height: 24,
    plain: !1,
    className: ""
});





const $34934a756d51b45e$var$S = "nextui-input", $34934a756d51b45e$var$R = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ as: e = "input", label: o, labelPlaceholder: R, labelLeft: I, labelRight: L, size: P, helperText: D, color: T, helperColor: B, status: j, contentLeft: F, contentRight: O, contentClickable: V, contentLeftStyling: q, contentRightStyling: U, onContentClick: W, initialValue: z, onChange: E, readOnly: A, value: G, onClearClick: H, clearable: J, shadow: K, animated: M, required: Q, width: X, className: Y, onBlur: Z, onFocus: _, autoComplete: ee, placeholder: te, fullWidth: ae, borderWeight: re, disabled: le, bordered: ne, underlined: ie, rounded: oe, css: de, ...se }, ce)=>{
    const ue = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ce, ()=>ue.current);
    const [pe, me] = (0, $acw62.useState)(z), [he, fe] = (0, $acw62.useState)(!1), { isDark: be } = (0, $116f27f1fc2ac09a$export$2e2bcd8739ae039)(), $e = (0, $acw62.useMemo)(()=>void 0 !== G, [
        G
    ]), ge = (0, $acw62.useMemo)(()=>o || R, [
        o,
        R
    ]), ye = (0, $acw62.useMemo)(()=>R ? "" : te, [
        te,
        R
    ]), Ce = (0, $acw62.useMemo)(()=>ae ? "100%" : X || "initial", [
        ae,
        X
    ]);
    ie && (0, $9013ad1f954747ab$export$a866f231438cc228) && (ne && (0, $364cddea3adf1f69$export$2e2bcd8739ae039)("Using underlined and bordered at the same time will have no effect."), oe && (0, $364cddea3adf1f69$export$2e2bcd8739ae039)("Using underlined and rounded at the same time will have no effect."));
    const xe = (e, t)=>{
        le || W && W(e, t);
    };
    (0, $acw62.useEffect)(()=>{
        $e && me(G);
    });
    const we = (0, $acw62.useMemo)(()=>"textarea" === e, [
        e
    ]), Ne = {
        ...se,
        ...$e ? {
            value: pe
        } : {
            defaultValue: z
        }
    }, { labelProps: ve, fieldProps: ke } = (0, $a67e83eea730647a$export$8467354a121f1b9f)({
        ...Ne,
        label: ge
    }), Se = (0, $acw62.useMemo)(()=>he ? "hover" : le ? "disabled" : A ? "read-only" : pe ? "with-value" : "normal", [
        he,
        le,
        A,
        pe
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $bf1f9a6abf0e8edc$export$c621cc86895692f), {
        color: T,
        "data-state": Se,
        helperColor: B,
        borderWeight: re,
        status: j,
        size: P,
        rounded: oe,
        disabled: le,
        css: {
            width: Ce,
            ...de
        },
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)(`${$34934a756d51b45e$var$S}-main-container`, `${$34934a756d51b45e$var$S}-main-container--${Se}`),
        children: [
            ge && (0, $7b02d682eb115277$exports.jsx)((0, $bf1f9a6abf0e8edc$export$10fc4bf0607c33dc), {
                id: ve.id,
                className: `${$34934a756d51b45e$var$S}-block-label`,
                htmlFor: ve.htmlFor,
                isTextarea: we,
                underlined: ie,
                animated: M,
                bordered: ne,
                rounded: oe,
                hasContentLeft: !!F,
                withValue: !!pe,
                asPlaceholder: !!R,
                focused: he,
                children: ge
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $bf1f9a6abf0e8edc$export$b6fc3b0e5138327b), {
                animated: M,
                isTextarea: we,
                underlined: ie,
                isReadOnly: A,
                focused: he,
                className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)(`${$34934a756d51b45e$var$S}-container`, `${$34934a756d51b45e$var$S}-container--${Se}`, {
                    [`${$34934a756d51b45e$var$S}-container--input`]: !we,
                    [`${$34934a756d51b45e$var$S}-container--textarea`]: we,
                    [`${$34934a756d51b45e$var$S}-container--read-only`]: A
                }, Y),
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $bf1f9a6abf0e8edc$export$479bffa770f4fc8b), {
                    as: ge ? "div" : "label",
                    animated: M,
                    bordered: ne,
                    shadow: K,
                    disabled: le,
                    focused: he,
                    isReadOnly: A,
                    underlined: ie,
                    isTextarea: we,
                    className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)(`${$34934a756d51b45e$var$S}-wrapper`, `${$34934a756d51b45e$var$S}-wrapper--${Se}`, {
                        [`${$34934a756d51b45e$var$S}-wrapper--bordered`]: ne,
                        [`${$34934a756d51b45e$var$S}-wrapper--underlined`]: ie,
                        [`${$34934a756d51b45e$var$S}-wrapper--shadow`]: K
                    }),
                    children: [
                        !ge && te && (0, $7b02d682eb115277$exports.jsx)((0, $bf1f9a6abf0e8edc$export$a9ee5a73a871e7de), {
                            className: `${$34934a756d51b45e$var$S}-placeholder`,
                            children: te
                        }),
                        I && (0, $7b02d682eb115277$exports.jsx)((0, $bf1f9a6abf0e8edc$export$c19db8ea26d35118), {
                            className: `${$34934a756d51b45e$var$S}-label--left`,
                            isDefaultStatus: "default" === j,
                            underlined: ie,
                            bordered: ne,
                            isDark: be,
                            children: I
                        }),
                        F && (0, $7b02d682eb115277$exports.jsx)((0, $bf1f9a6abf0e8edc$export$674641af68f172f), {
                            className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)(`${$34934a756d51b45e$var$S}-content`, `${$34934a756d51b45e$var$S}-content--left`),
                            applyStyles: q,
                            clickable: V,
                            onClick: (e)=>xe("left", e),
                            children: F
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $bf1f9a6abf0e8edc$export$a195049fd73b3fe2), {
                            type: "text",
                            as: e,
                            ref: ue,
                            className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)({
                                [`${$34934a756d51b45e$var$S}`]: !we,
                                [`${$34934a756d51b45e$var$S}-textarea`]: we,
                                [`${$34934a756d51b45e$var$S}-disabled`]: le,
                                [`${$34934a756d51b45e$var$S}-rounded`]: oe,
                                [`${$34934a756d51b45e$var$S}-${$34934a756d51b45e$var$S}-right-content`]: O,
                                [`${$34934a756d51b45e$var$S}-left-content`]: F
                            }),
                            isTextarea: we,
                            focused: he,
                            bordered: ne,
                            placeholder: ye,
                            disabled: le,
                            readOnly: A,
                            required: Q,
                            onFocus: (e)=>{
                                fe(!0), _ && _(e);
                            },
                            onBlur: (e)=>{
                                fe(!1), Z && Z(e);
                            },
                            onChange: (e)=>{
                                le || A || (me(e.target.value), E && E(e));
                            },
                            autoComplete: ee,
                            hasLeftContent: !!F,
                            hasRightContent: !!O,
                            "data-state": Se,
                            "aria-placeholder": ye,
                            "aria-readonly": A,
                            "aria-required": Q,
                            "aria-multiline": we,
                            ...Ne,
                            ...ke
                        }),
                        J && (0, $7b02d682eb115277$exports.jsx)((0, $bf1f9a6abf0e8edc$export$4f17d3e4f705316), {
                            type: "button",
                            className: `${$34934a756d51b45e$var$S}-clear-button`,
                            animated: M,
                            underlined: ie,
                            visible: Boolean(pe),
                            hasContentRight: !!O,
                            disabled: le || A,
                            onClick: (e)=>{
                                if (e.preventDefault(), e.stopPropagation(), e.nativeEvent.stopImmediatePropagation(), me(""), H && H(e), !ue.current) return;
                                const t = ((e, t)=>({
                                        ...t,
                                        target: e,
                                        currentTarget: e
                                    }))(ue.current, e);
                                t.target.value = "", E && E(t), ue.current.focus();
                            },
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $aea1449f5da8af64$export$2e2bcd8739ae039), {
                                fill: "currentColor"
                            })
                        }),
                        O && (0, $7b02d682eb115277$exports.jsx)((0, $bf1f9a6abf0e8edc$export$674641af68f172f), {
                            className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)(`${$34934a756d51b45e$var$S}-content`, `${$34934a756d51b45e$var$S}-content--right`),
                            applyStyles: U,
                            clickable: V,
                            onClick: (e)=>xe("right", e),
                            children: O
                        }),
                        L && (0, $7b02d682eb115277$exports.jsx)((0, $bf1f9a6abf0e8edc$export$c19db8ea26d35118), {
                            className: `${$34934a756d51b45e$var$S}-label--right`,
                            isDefaultStatus: "default" === j,
                            underlined: ie,
                            bordered: ne,
                            isRight: !0,
                            isDark: be,
                            children: L
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $bf1f9a6abf0e8edc$export$76a3ef0780916a27), {
                className: `${$34934a756d51b45e$var$S}-helper-text-container`,
                withValue: !!D,
                children: D && (0, $7b02d682eb115277$exports.jsx)((0, $bf1f9a6abf0e8edc$export$cd0a7d3af414ca4a), {
                    className: `${$34934a756d51b45e$var$S}-helper-text`,
                    children: D
                })
            })
        ]
    });
});
$34934a756d51b45e$var$R.displayName = "NextUI.Input", $34934a756d51b45e$var$R.defaultProps = (0, $7e0e6aad51cc8043$export$9c21a3269931e1e6), $34934a756d51b45e$var$R.toString = ()=>".nextui-input";
var $34934a756d51b45e$export$2e2bcd8739ae039 = $34934a756d51b45e$var$R;



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
const $1025b45907e9388e$export$218c8c3169c024d2 = ()=>Math.random().toString(32).slice(2, 10);
const $1025b45907e9388e$export$2761644b2bd12a6d = (t, n)=>((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(t, (t)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(t) ? t.type : null) || []).includes(n);
const $1025b45907e9388e$export$357523c63a2253b9 = (e, t)=>e.reduce((e, n)=>(e[n] = t[n], e), {});
const $1025b45907e9388e$export$d23950bdb3876813 = (t, n)=>{
    let r = [];
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(t, (t)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(t) && t.type === n ? (r.push(t), null) : t),
        r.length >= 0 ? r : void 0
    ];
};
const $1025b45907e9388e$export$5415689f8a85d806 = (e, t)=>{
    const [n, r] = $1025b45907e9388e$export$d23950bdb3876813(e, t);
    let o = null;
    return r && r.length >= 1 && (o = r.length >= 0 ? r[0] : void 0), [
        n,
        o
    ];
};
const $1025b45907e9388e$export$1838f3a1c86ecfd4 = (e, t)=>{
    if (!e || !t) return !1;
    let n = t;
    for(; n;){
        if (n === e) return !0;
        n = n.parentNode;
    }
    return !1;
};
const $1025b45907e9388e$export$4e09c449d6c407f7 = ()=>Boolean("undefined" != typeof window && window.document && window.document.createElement);
const $1025b45907e9388e$export$9ac100e40613ea10 = ()=>!!Boolean("undefined" != typeof window && window.document && window.document.createElement) && navigator.platform.toUpperCase().indexOf("MAC") >= 0;
const $1025b45907e9388e$export$198aa85a0714ea8c = (t, n = [])=>{
    if (0 === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(t)) return [];
    const r = 0 === n.length, o = (t, n = {})=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(t, n);
    let i = 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(t, (t)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(t)) return t;
        if (i += 1, r) return o(t, {
            index: i
        });
        return n.find((e)=>e === t.type) ? o(t, {
            index: i
        }) : (i -= 1, t);
    });
};
const $1025b45907e9388e$export$2fae38c2d7691313 = (e)=>e.reduce((e, t)=>e.concat(Array.isArray(t) ? $1025b45907e9388e$export$2fae38c2d7691313(t) : t), []);


const $604ff53481cf0310$var$e = [
    "borderBottomWidth",
    "borderLeftWidth",
    "borderRightWidth",
    "borderTopWidth",
    "boxSizing",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "tabSize",
    "textIndent",
    "textRendering",
    "textTransform",
    "width",
    "wordBreak"
], $604ff53481cf0310$var$o = {
    "min-height": "0",
    "max-height": "none",
    height: "0",
    visibility: "hidden",
    overflow: "hidden",
    position: "absolute",
    "z-index": "-1000",
    top: "0",
    right: "0"
}, $604ff53481cf0310$var$i = "undefined" != typeof document && !!document.documentElement.currentStyle;
const $604ff53481cf0310$export$4293c0e82c2cf521 = (t)=>{
    Object.keys($604ff53481cf0310$var$o).forEach((e)=>{
        t.style.setProperty(e, $604ff53481cf0310$var$o[e], "important");
    });
};
const $604ff53481cf0310$export$f2c8ce1bfc73b0c5 = (o)=>{
    const r = window.getComputedStyle(o);
    if (null === r) return null;
    const d = (0, $1025b45907e9388e$export$357523c63a2253b9)($604ff53481cf0310$var$e, r), { boxSizing: n } = d;
    if ("" === n) return null;
    $604ff53481cf0310$var$i && "border-box" === n && (d.width = parseFloat(d.width) + parseFloat(d.borderRightWidth) + parseFloat(d.borderLeftWidth) + parseFloat(d.paddingRight) + parseFloat(d.paddingLeft) + "px");
    return {
        sizingStyle: d,
        paddingSize: parseFloat(d.paddingBottom) + parseFloat(d.paddingTop),
        borderSize: parseFloat(d.borderBottomWidth) + parseFloat(d.borderTopWidth)
    };
};
let $604ff53481cf0310$var$r = null;
const $604ff53481cf0310$export$ea72510638d806aa = (t, e, o = 1, i = 1 / 0)=>{
    $604ff53481cf0310$var$r || ($604ff53481cf0310$var$r = document.createElement("textarea"), $604ff53481cf0310$var$r.setAttribute("tabindex", "-1"), $604ff53481cf0310$var$r.setAttribute("aria-hidden", "true"), $604ff53481cf0310$export$4293c0e82c2cf521($604ff53481cf0310$var$r)), null === $604ff53481cf0310$var$r.parentNode && document.body.appendChild($604ff53481cf0310$var$r);
    const { paddingSize: d, borderSize: n, sizingStyle: a } = t, { boxSizing: l } = a;
    Object.keys(a).forEach((t)=>{
        const e = t;
        $604ff53481cf0310$var$r.style[e] = a[e];
    }), $604ff53481cf0310$export$4293c0e82c2cf521($604ff53481cf0310$var$r), $604ff53481cf0310$var$r.value = e;
    let s = ((t, e)=>{
        const o = t.scrollHeight;
        return "border-box" === e.sizingStyle.boxSizing ? o + e.borderSize : o - e.paddingSize;
    })($604ff53481cf0310$var$r, t);
    $604ff53481cf0310$var$r.value = "x";
    const p = $604ff53481cf0310$var$r.scrollHeight - d;
    let g = p * o;
    "border-box" === l && (g = g + d + n), s = Math.max(g, s);
    let h = p * i;
    return "border-box" === l && (h = h + d + n), s = Math.min(h, s), [
        s,
        p
    ];
};



const $91993c65282bc58e$var$f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((o, f)=>{
    const x = (0, $acw62.useRef)(null), h = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0), g = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(), { cacheMeasurements: d, rows: w, maxRows: y, minRows: R, onChange: H, onHeightChange: j, css: v, ...C } = o;
    Object.keys(C).forEach((e)=>{
        (0, $0440cfd24bed175b$export$eaab8d1ed846a202).indexOf(e) > -1 && delete C[e];
    });
    const P = void 0 !== C.value;
    (0, $9013ad1f954747ab$export$a866f231438cc228) && C.style && ("maxHeight" in C.style && (0, $364cddea3adf1f69$export$2e2bcd8739ae039)("Using `style.maxHeight` for <Textarea/> is not supported. Please use `maxRows`."), "minHeight" in C.style && (0, $364cddea3adf1f69$export$2e2bcd8739ae039)("Using `style.minHeight` for <Textarea/> is not supported. Please use `minRows`.")), (0, $acw62.useImperativeHandle)(f, ()=>x.current);
    const T = ()=>{
        const e = x.current, t = d && g.current ? g.current : (0, $604ff53481cf0310$export$f2c8ce1bfc73b0c5)(e);
        if (!t) return;
        g.current = t;
        const [r, s] = (0, $604ff53481cf0310$export$ea72510638d806aa)(t, e.value || e.placeholder || "x", w || R, w || y);
        h.current !== r && (h.current = r, e.style.setProperty("height", `${r}px`, "important"), j && j(r, {
            rowHeight: s
        }));
    };
    return "undefined" != typeof document && ((0, $acw62.useLayoutEffect)(T), (0, $c06a267e555cb80f$export$2e2bcd8739ae039)(T)), (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
        as: "textarea",
        ref: x,
        onChange: (e)=>{
            P || T(), H && H(e);
        },
        css: {
            ...v
        },
        ...C
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($91993c65282bc58e$var$f.displayName = "NextUI.Textarea"), $91993c65282bc58e$var$f.toString = ()=>".nextui-textarea";
var $91993c65282bc58e$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($91993c65282bc58e$var$f, {
    minRows: 3,
    maxRows: 6,
    cacheMeasurements: !0,
    initialValue: ""
});


var $b14948cc1f3936db$export$2e2bcd8739ae039 = (0, $91993c65282bc58e$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

const $ec08ea041ec2a78d$var$i = ({ visible: r })=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        width: "16",
        height: "16",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none",
        className: "nextui-input-password-icon",
        shapeRendering: "geometricPrecision",
        style: {
            color: "currentColor"
        },
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), r ? {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M1 1l22 22"
                })
            ]
        } : {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3"
                })
            ]
        })
    }), $ec08ea041ec2a78d$var$s = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($ec08ea041ec2a78d$var$i);
var $ec08ea041ec2a78d$export$2e2bcd8739ae039 = $ec08ea041ec2a78d$var$s;






const $aab7c34dd2fe879a$var$d = {
    ...(0, $7e0e6aad51cc8043$export$9c21a3269931e1e6),
    hideToggle: !1,
    visibleIcon: (0, $7b02d682eb115277$exports.jsx)((0, $ec08ea041ec2a78d$export$2e2bcd8739ae039), {
        visible: !0
    }),
    hiddenIcon: (0, $7b02d682eb115277$exports.jsx)((0, $ec08ea041ec2a78d$export$2e2bcd8739ae039), {
        visible: !1
    })
}, $aab7c34dd2fe879a$var$u = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ hideToggle: t, visibleIcon: n, hiddenIcon: s, children: l, ...m }, d)=>{
    const u = (0, $acw62.useRef)(null), [f, h] = (0, $acw62.useState)(!1);
    (0, $acw62.useImperativeHandle)(d, ()=>u.current);
    const x = ()=>{
        h((t)=>!t);
    }, w = (0, $acw62.useMemo)(()=>({
            ...m,
            ref: u,
            className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-input-password", m.className),
            contentClickable: !0,
            onContentClick: x,
            type: f ? "text" : "password"
        }), [
        m,
        x,
        f,
        u
    ]), g = (0, $acw62.useMemo)(()=>t ? null : f ? n : s, [
        t,
        f,
        n,
        s
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $34934a756d51b45e$export$2e2bcd8739ae039), {
        contentRight: g,
        ...w,
        children: l
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($aab7c34dd2fe879a$var$u.displayName = "NextUI.InputPassword"), $aab7c34dd2fe879a$var$u.toString = ()=>".nextui-input-password";
var $aab7c34dd2fe879a$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($aab7c34dd2fe879a$var$u, $aab7c34dd2fe879a$var$d);



(0, $34934a756d51b45e$export$2e2bcd8739ae039).Textarea = (0, $b14948cc1f3936db$export$2e2bcd8739ae039), (0, $34934a756d51b45e$export$2e2bcd8739ae039).Password = (0, $aab7c34dd2fe879a$export$2e2bcd8739ae039);
var $c78f4d7728e729df$export$2e2bcd8739ae039 = (0, $34934a756d51b45e$export$2e2bcd8739ae039);


var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));



var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $63c37e44f569564f$var$s = (0, $acw62.createContext)();
$63c37e44f569564f$var$s.displayName = "IconlyIconlyContext";
var $63c37e44f569564f$export$c2cf8bec8c063ca0 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($63c37e44f569564f$var$s.Provider, {
        value: {
            primaryColor: r.primaryColor || "currentColor",
            secondaryColor: r.secondaryColor || null,
            set: r.set || "light",
            size: r.size || "medium",
            stroke: r.stroke || "regular"
        }
    }, r.children);
}, $63c37e44f569564f$export$2e64b57d4c1eb2b8 = function() {
    var t = (0, $acw62.useContext)($63c37e44f569564f$var$s);
    if (void 0 === t) throw new Error("useIconlyTheme must be used within a IconlyProvider");
    return t;
};
function $63c37e44f569564f$var$u(t, r) {
    return t(r = {
        exports: {}
    }, r.exports), r.exports;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ }
var $63c37e44f569564f$var$d = "function" == typeof Symbol && Symbol.for, $63c37e44f569564f$var$k = $63c37e44f569564f$var$d ? Symbol.for("react.element") : 60103, $63c37e44f569564f$var$c = $63c37e44f569564f$var$d ? Symbol.for("react.portal") : 60106, $63c37e44f569564f$var$f = $63c37e44f569564f$var$d ? Symbol.for("react.fragment") : 60107, $63c37e44f569564f$var$p = $63c37e44f569564f$var$d ? Symbol.for("react.strict_mode") : 60108, $63c37e44f569564f$var$m = $63c37e44f569564f$var$d ? Symbol.for("react.profiler") : 60114, $63c37e44f569564f$var$h = $63c37e44f569564f$var$d ? Symbol.for("react.provider") : 60109, $63c37e44f569564f$var$M = $63c37e44f569564f$var$d ? Symbol.for("react.context") : 60110, $63c37e44f569564f$var$L = $63c37e44f569564f$var$d ? Symbol.for("react.async_mode") : 60111, $63c37e44f569564f$var$A = $63c37e44f569564f$var$d ? Symbol.for("react.concurrent_mode") : 60111, $63c37e44f569564f$var$y = $63c37e44f569564f$var$d ? Symbol.for("react.forward_ref") : 60112, $63c37e44f569564f$var$g = $63c37e44f569564f$var$d ? Symbol.for("react.suspense") : 60113, $63c37e44f569564f$var$W = $63c37e44f569564f$var$d ? Symbol.for("react.suspense_list") : 60120, $63c37e44f569564f$var$V = $63c37e44f569564f$var$d ? Symbol.for("react.memo") : 60115, $63c37e44f569564f$var$Z = $63c37e44f569564f$var$d ? Symbol.for("react.lazy") : 60116, $63c37e44f569564f$var$j = $63c37e44f569564f$var$d ? Symbol.for("react.block") : 60121, $63c37e44f569564f$var$C = $63c37e44f569564f$var$d ? Symbol.for("react.fundamental") : 60117, $63c37e44f569564f$var$v = $63c37e44f569564f$var$d ? Symbol.for("react.responder") : 60118, $63c37e44f569564f$var$H = $63c37e44f569564f$var$d ? Symbol.for("react.scope") : 60119;
function $63c37e44f569564f$var$b(t) {
    if ("object" == typeof t && null !== t) {
        var r = t.$$typeof;
        switch(r){
            case $63c37e44f569564f$var$k:
                switch(t = t.type){
                    case $63c37e44f569564f$var$L:
                    case $63c37e44f569564f$var$A:
                    case $63c37e44f569564f$var$f:
                    case $63c37e44f569564f$var$m:
                    case $63c37e44f569564f$var$p:
                    case $63c37e44f569564f$var$g:
                        return t;
                    default:
                        switch(t = t && t.$$typeof){
                            case $63c37e44f569564f$var$M:
                            case $63c37e44f569564f$var$y:
                            case $63c37e44f569564f$var$Z:
                            case $63c37e44f569564f$var$V:
                            case $63c37e44f569564f$var$h:
                                return t;
                            default:
                                return r;
                        }
                }
            case $63c37e44f569564f$var$c:
                return r;
        }
    }
}
function $63c37e44f569564f$var$w(t) {
    return $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$A;
}
var $63c37e44f569564f$var$S = {
    AsyncMode: $63c37e44f569564f$var$L,
    ConcurrentMode: $63c37e44f569564f$var$A,
    ContextConsumer: $63c37e44f569564f$var$M,
    ContextProvider: $63c37e44f569564f$var$h,
    Element: $63c37e44f569564f$var$k,
    ForwardRef: $63c37e44f569564f$var$y,
    Fragment: $63c37e44f569564f$var$f,
    Lazy: $63c37e44f569564f$var$Z,
    Memo: $63c37e44f569564f$var$V,
    Portal: $63c37e44f569564f$var$c,
    Profiler: $63c37e44f569564f$var$m,
    StrictMode: $63c37e44f569564f$var$p,
    Suspense: $63c37e44f569564f$var$g,
    isAsyncMode: function(t) {
        return $63c37e44f569564f$var$w(t) || $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$L;
    },
    isConcurrentMode: $63c37e44f569564f$var$w,
    isContextConsumer: function(t) {
        return $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$M;
    },
    isContextProvider: function(t) {
        return $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$h;
    },
    isElement: function(t) {
        return "object" == typeof t && null !== t && t.$$typeof === $63c37e44f569564f$var$k;
    },
    isForwardRef: function(t) {
        return $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$y;
    },
    isFragment: function(t) {
        return $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$f;
    },
    isLazy: function(t) {
        return $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$Z;
    },
    isMemo: function(t) {
        return $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$V;
    },
    isPortal: function(t) {
        return $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$c;
    },
    isProfiler: function(t) {
        return $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$m;
    },
    isStrictMode: function(t) {
        return $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$p;
    },
    isSuspense: function(t) {
        return $63c37e44f569564f$var$b(t) === $63c37e44f569564f$var$g;
    },
    isValidElementType: function(t) {
        return "string" == typeof t || "function" == typeof t || t === $63c37e44f569564f$var$f || t === $63c37e44f569564f$var$A || t === $63c37e44f569564f$var$m || t === $63c37e44f569564f$var$p || t === $63c37e44f569564f$var$g || t === $63c37e44f569564f$var$W || "object" == typeof t && null !== t && (t.$$typeof === $63c37e44f569564f$var$Z || t.$$typeof === $63c37e44f569564f$var$V || t.$$typeof === $63c37e44f569564f$var$h || t.$$typeof === $63c37e44f569564f$var$M || t.$$typeof === $63c37e44f569564f$var$y || t.$$typeof === $63c37e44f569564f$var$C || t.$$typeof === $63c37e44f569564f$var$v || t.$$typeof === $63c37e44f569564f$var$H || t.$$typeof === $63c37e44f569564f$var$j);
    },
    typeOf: $63c37e44f569564f$var$b
}, $63c37e44f569564f$var$T = $63c37e44f569564f$var$u(function(t, r) {}), $63c37e44f569564f$var$O = $63c37e44f569564f$var$u(function(t) {
    t.exports = $63c37e44f569564f$var$S;
}), $63c37e44f569564f$var$I = Object.getOwnPropertySymbols, $63c37e44f569564f$var$N = Object.prototype.hasOwnProperty, $63c37e44f569564f$var$x = Object.prototype.propertyIsEnumerable;
function $63c37e44f569564f$var$P(t) {
    if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(t);
}
var $63c37e44f569564f$var$E = function() {
    try {
        if (!Object.assign) return !1;
        var t = new String("abc");
        if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;
        for(var r = {}, n = 0; n < 10; n++)r["_" + String.fromCharCode(n)] = n;
        if ("0123456789" !== Object.getOwnPropertyNames(r).map(function(t) {
            return r[t];
        }).join("")) return !1;
        var e = {};
        return "abcdefghijklmnopqrst".split("").forEach(function(t) {
            e[t] = t;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, e)).join("");
    } catch (t) {
        return !1;
    }
}() ? Object.assign : function(t, r) {
    for(var n, e, o = $63c37e44f569564f$var$P(t), a = 1; a < arguments.length; a++){
        for(var s in n = Object(arguments[a]))$63c37e44f569564f$var$N.call(n, s) && (o[s] = n[s]);
        if ($63c37e44f569564f$var$I) {
            e = $63c37e44f569564f$var$I(n);
            for(var i = 0; i < e.length; i++)$63c37e44f569564f$var$x.call(n, e[i]) && (o[e[i]] = n[e[i]]);
        }
    }
    return o;
}, $63c37e44f569564f$var$D = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", $63c37e44f569564f$var$$ = function() {};
var $63c37e44f569564f$var$q, $63c37e44f569564f$var$U, $63c37e44f569564f$var$R;
function $63c37e44f569564f$var$_(t, r, n, e, o) {
    var a, s, i, t1, l;
}
$63c37e44f569564f$var$_.resetWarningCache = function() {};
var $63c37e44f569564f$var$F = $63c37e44f569564f$var$_, $63c37e44f569564f$var$z = Function.call.bind(Object.prototype.hasOwnProperty), $63c37e44f569564f$var$B = function() {};
function $63c37e44f569564f$var$G() {
    return null;
}
function $63c37e44f569564f$var$J() {}
function $63c37e44f569564f$var$Y() {}
$63c37e44f569564f$var$Y.resetWarningCache = $63c37e44f569564f$var$J;
var $63c37e44f569564f$var$Q = $63c37e44f569564f$var$u(function(t) {
    t.exports = function() {
        function t(t, r, n, e, o, a) {
            if (a !== $63c37e44f569564f$var$D) {
                var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw s.name = "Invariant Violation", s;
            }
        }
        function r() {
            return t;
        }
        t.isRequired = t;
        var n = {
            array: t,
            bool: t,
            func: t,
            number: t,
            object: t,
            string: t,
            symbol: t,
            any: t,
            arrayOf: r,
            element: t,
            elementType: t,
            instanceOf: r,
            node: t,
            objectOf: r,
            oneOf: r,
            oneOfType: r,
            shape: r,
            exact: r,
            checkPropTypes: $63c37e44f569564f$var$Y,
            resetWarningCache: $63c37e44f569564f$var$J
        };
        return n.PropTypes = n, n;
    }();
});
function $63c37e44f569564f$var$K() {
    return ($63c37e44f569564f$var$K = Object.assign || function(t) {
        for(var r = 1; r < arguments.length; r++){
            var n = arguments[r];
            for(var e in n)Object.prototype.hasOwnProperty.call(n, e) && (t[e] = n[e]);
        }
        return t;
    }).apply(this, arguments);
}
function $63c37e44f569564f$var$X(t, r) {
    if (null == t) return {};
    var n, e, o = {}, a = Object.keys(t);
    for(e = 0; e < a.length; e++)r.indexOf(n = a[e]) >= 0 || (o[n] = t[n]);
    return o;
}
var $63c37e44f569564f$var$tt = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
}, $63c37e44f569564f$var$rt = {
    light: "1px",
    regular: "1.5px",
    bold: "2px"
}, $63c37e44f569564f$var$nt = function(t) {
    return Number.isInteger(t) ? t + "px" : t && $63c37e44f569564f$var$tt[t] ? $63c37e44f569564f$var$tt[t] : null;
}, $63c37e44f569564f$var$et = function(t) {
    return t && $63c37e44f569564f$var$rt[t] ? $63c37e44f569564f$var$rt[t] : null;
}, $63c37e44f569564f$var$ot = function(t, r) {
    return r ? t === r ? "0.4" : "1" : "0.4";
}, $63c37e44f569564f$var$at = function(t, r) {
    return r && r[t] ? r[t] : null;
};
function $63c37e44f569564f$var$st(r) {
    var n = function(n) {
        var e, o;
        function a() {
            return n.apply(this, arguments) || this;
        }
        return o = n, (e = a).prototype = Object.create(o.prototype), e.prototype.constructor = e, e.__proto__ = o, a.prototype.render = function() {
            var n = this.props, e = n.size, o = n.label, a = n.primaryColor, s = n.secondaryColor, i = n.filled, l = n.set, u = n.style, d = n.stroke, k = $63c37e44f569564f$var$X(n, [
                "size",
                "label",
                "primaryColor",
                "secondaryColor",
                "filled",
                "set",
                "style",
                "stroke"
            ]), c = this.context, f = $63c37e44f569564f$var$nt(e) || $63c37e44f569564f$var$nt($63c37e44f569564f$var$at("size", c)) || "24px", p = a || $63c37e44f569564f$var$at("primaryColor", c) || "currentColor", m = s || $63c37e44f569564f$var$at("secondaryColor", c) || p || "currentColor";
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $63c37e44f569564f$var$K({
                xmlns: "http://www.w3.org/2000/svg",
                width: f,
                height: f,
                viewBox: "0 0 24 24",
                role: o ? "img" : "presentation",
                "aria-label": o || void 0,
                style: u
            }, k), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(r, {
                color: p,
                opacity: $63c37e44f569564f$var$ot(a, s),
                secondaryColor: m,
                set: i ? "bold" : l || $63c37e44f569564f$var$at("set", c) || "light",
                strokeWidth: d ? $63c37e44f569564f$var$et(d) : $63c37e44f569564f$var$et($63c37e44f569564f$var$at("stroke", c)) || "1.5px"
            }));
        }, a;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    return n.contextType = $63c37e44f569564f$var$s, n.propTypes = {
        label: $63c37e44f569564f$var$Q.string,
        filled: $63c37e44f569564f$var$Q.bool,
        primaryColor: $63c37e44f569564f$var$Q.string,
        secondaryColor: $63c37e44f569564f$var$Q.string,
        size: $63c37e44f569564f$var$Q.oneOfType([
            $63c37e44f569564f$var$Q.number,
            $63c37e44f569564f$var$Q.oneOf([
                "small",
                "medium",
                "large",
                "xlarge"
            ])
        ]),
        set: $63c37e44f569564f$var$Q.oneOf([
            "bold",
            "bulk",
            "light",
            "broken",
            "two-tone",
            "curved"
        ]),
        stroke: $63c37e44f569564f$var$Q.oneOf([
            "light",
            "regular",
            "bold"
        ]),
        style: $63c37e44f569564f$var$Q.oneOfType([
            $63c37e44f569564f$var$Q.object,
            $63c37e44f569564f$var$Q.array
        ])
    }, (0, $acw62.memo)(n);
}
var $63c37e44f569564f$var$it = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M17.741,19.608l-2.12-2.43a1.083,1.083,0,0,1,0-1.524.986.986,0,0,1,1.393,0l2.554,2.062h.045a1.348,1.348,0,0,1,0,1.892,1.315,1.315,0,0,1-1.872,0ZM0,8.67A8.624,8.624,0,0,1,8.578,0a8.531,8.531,0,0,1,6.065,2.54,8.716,8.716,0,0,1,2.512,6.13A8.624,8.624,0,0,1,8.578,17.34,8.624,8.624,0,0,1,0,8.67Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("ellipse", {
            cx: "8.599",
            cy: "8.653",
            rx: "8.599",
            ry: "8.653",
            transform: "translate(0 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M3.278,4.577a1.321,1.321,0,0,1-.889-.385L.352,1.812A1.088,1.088,0,0,1,.272.29h0A.974.974,0,0,1,1.66.29L4.221,2.339a1.348,1.348,0,0,1,.291,1.431,1.335,1.335,0,0,1-1.18.851Z",
            transform: "translate(15.397 15.379)",
            fill: e,
            opacity: n
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            strokeWidth: a
        }, (0, $acw62.createElement)("circle", {
            cx: 8.989,
            cy: 8.989,
            r: 8.989,
            transform: "translate(.778 .778)"
        }), (0, $acw62.createElement)("path", {
            d: "M16.018 16.485L19.542 20"
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M19.756,18.607l-3.437-3.361h0l-.081-.123a.809.809,0,0,0-1.137,0h0a8.113,8.113,0,0,1-10.519.34A7.679,7.679,0,0,1,2.876,5.31,8.075,8.075,0,0,1,12.953,2.342a7.741,7.741,0,0,1,4.314,9.385.779.779,0,0,0,.182.772.822.822,0,0,0,.774.232.8.8,0,0,0,.593-.54h0a9.334,9.334,0,0,0-5-11.25A9.754,9.754,0,0,0,1.689,4.085,9.256,9.256,0,0,0,3.049,16.28a9.789,9.789,0,0,0,12.535.515l3.044,2.976a.819.819,0,0,0,1.137,0,.784.784,0,0,0,0-1.12h0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("circle", {
            cx: "8.989",
            cy: "8.989",
            r: "8.989",
            transform: "translate(0.778 0.778)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,3.524,3.515",
            transform: "translate(16.018 16.485)",
            fill: "none",
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a,
            opacity: n
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.561,0A8.561,8.561,0,1,1,0,8.561,8.561,8.561,0,0,1,8.561,0Z",
            transform: "translate(0.714 0.714)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M1.411,0A1.411,1.411,0,1,1,0,1.41,1.411,1.411,0,0,1,1.411,0Z",
            transform: "translate(16.488 16.488)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$it.displayName = "IconlySearch", $63c37e44f569564f$var$it.propTypes = {
    color: $63c37e44f569564f$var$Q.string,
    opacity: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$4b85d3515bd863a5 = $63c37e44f569564f$var$st($63c37e44f569564f$var$it), $63c37e44f569564f$var$ut = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.75,20H6.24C2.391,20,0,17.606,0,13.75V6.241C0,2.1,1.84,0,5.47,0H7.081A2.956,2.956,0,0,1,9.42,1.15L10.3,2.32a1.472,1.472,0,0,0,1.15.56h3.07a5.446,5.446,0,0,1,4,1.361A6.36,6.36,0,0,1,20,8.89v4.87a6.278,6.278,0,0,1-1.674,4.568A6.3,6.3,0,0,1,13.75,20ZM5.37,11.79a.743.743,0,0,0-.751.751.751.751,0,0,0,.751.75h9.26a.746.746,0,0,0,.74-.75.737.737,0,0,0-.74-.751Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.884,3.115H11.941a2.429,2.429,0,0,1-1.894-.887L9.078.888A2.367,2.367,0,0,0,7.193,0H5.113C1.378,0,0,2.192,0,5.919V9.947c0,.443,20,.442,20,0V8.776C20.015,5.049,18.672,3.115,14.884,3.115Z",
            fill: e,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M14.367,16.9h0c-.1,0-.207,0-.309-.008H5.931c-.1.005-.2.008-.307.008a6.017,6.017,0,0,1-4.068-1.578,4.487,4.487,0,0,1-.667-.887,5.8,5.8,0,0,1-.782-2.183A8.148,8.148,0,0,1,0,10.93V5.677A12.144,12.144,0,0,1,.071,4.363c.01-.076.025-.151.04-.224a1.894,1.894,0,0,0,.049-.37A5.619,5.619,0,0,1,.649,2.252C1.353.747,2.808.015,5.095.015h9.78c.133-.01.269-.016.4-.016A5.241,5.241,0,0,1,18.5,1.116a2.78,2.78,0,0,1,.329.329,3.935,3.935,0,0,1,.729,1.269A8.51,8.51,0,0,1,20,5.677V10.93a9.441,9.441,0,0,1-.1,1.322,5.961,5.961,0,0,1-.8,2.183,4.445,4.445,0,0,1-.676.887A5.983,5.983,0,0,1,14.367,16.9Zm-9.4-8.11a.825.825,0,1,0,0,1.651H15.09a.826.826,0,0,0,.825-.8.742.742,0,0,0-.177-.533.788.788,0,0,0-.623-.319Z",
            transform: "translate(0 3.099)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1.5 1.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M19.169,13.482c0,3.578-2.109,5.687-5.687,5.687H5.7c-3.587,0-5.7-2.109-5.7-5.687v-7.8C0,2.109,1.314,0,4.893,0h2A2.282,2.282,0,0,1,8.717.913L9.63,2.127a2.291,2.291,0,0,0,1.826.913h2.83c3.587,0,4.911,1.826,4.911,5.477Z",
            transform: "translate(0.776 0.776)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,.456H9.593",
            transform: "translate(5.559 12.533)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M19.235,10.677A.765.765,0,0,0,20,9.912V8.892c0-4.046-1.8-6.016-5.495-6.016H11.78a1.424,1.424,0,0,1-1.134-.554l-.879-1.17A2.989,2.989,0,0,0,7.4,0H5.486C1.846,0,0,2.1,0,6.253v7.5C0,17.608,2.391,20,6.251,20h7.49c3.851,0,6.251-2.392,6.251-6.245a.774.774,0,0,0-1.538,0c0,3.034-1.67,4.714-4.712,4.714h-7.5C3.2,18.47,1.53,16.8,1.53,13.755v-.73H13.837a.765.765,0,0,0,0-1.53H1.53V6.218C1.53,2.911,2.708,1.5,5.477,1.5H7.411a1.468,1.468,0,0,1,1.134.563l.879,1.161A2.962,2.962,0,0,0,11.78,4.4H14.5c2.857,0,3.965,1.275,3.965,4.494v1.02a.765.765,0,0,0,.774.765Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 1.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M19.169,13.482c0,3.578-2.109,5.687-5.687,5.687H5.7c-3.587,0-5.7-2.109-5.7-5.687v-7.8C0,2.109,1.314,0,4.893,0h2A2.282,2.282,0,0,1,8.717.913L9.63,2.127a2.291,2.291,0,0,0,1.826.913h2.83c3.587,0,4.911,1.826,4.911,5.477Z",
            transform: "translate(0.776 0.776)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,.456H9.593",
            transform: "translate(5.559 12.533)",
            fill: "none",
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a,
            opacity: n
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,.476H9.593",
            transform: "translate(4.806 11.598)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,5.3C0,2.856,1.25.759,3.622.273a8.088,8.088,0,0,1,5.67.489c1.5.808,1.069,2,2.608,2.875s4.017-.44,5.635,1.306c1.694,1.828,1.685,4.633,1.685,6.422,0,6.8-3.807,7.335-9.61,7.335S0,18.229,0,11.364Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$ut.displayName = "IconlyFolder", $63c37e44f569564f$var$ut.propTypes = {
    color: $63c37e44f569564f$var$Q.string,
    opacity: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$80729fed35a16515 = $63c37e44f569564f$var$st($63c37e44f569564f$var$ut), $63c37e44f569564f$var$kt = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.515,18H5.485a5.64,5.64,0,0,1-4.036-1.411A5.323,5.323,0,0,1,0,12.661V5.339A5.323,5.323,0,0,1,1.449,1.411,5.64,5.64,0,0,1,5.485,0h9.031a5.618,5.618,0,0,1,4.036,1.417A5.392,5.392,0,0,1,20,5.382H15.769v.034a3.583,3.583,0,0,0-2.513,1.017,3.4,3.4,0,0,0-1.043,2.449,3.516,3.516,0,0,0,3.556,3.467H20v.311a5.323,5.323,0,0,1-1.449,3.928A5.64,5.64,0,0,1,14.515,18ZM4.738,3.892a.757.757,0,0,0-.764.736.766.766,0,0,0,.764.754h5.645a.745.745,0,1,0,0-1.49Zm14.515,6.967H15.819A2.1,2.1,0,0,1,13.76,9.265a1.977,1.977,0,0,1,.433-1.652,2.089,2.089,0,0,1,1.576-.74h3.484A.739.739,0,0,1,20,7.6v2.531A.75.75,0,0,1,19.253,10.858ZM15.91,8.042a.757.757,0,0,0-.53.212.732.732,0,0,0-.225.524.766.766,0,0,0,.765.754h.329a.745.745,0,1,0,0-1.49H15.91Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.517,18H5.484a5.633,5.633,0,0,1-4.034-1.413A5.332,5.332,0,0,1,0,12.654V5.338A5.32,5.32,0,0,1,1.449,1.409,5.641,5.641,0,0,1,5.484,0h9.03a5.639,5.639,0,0,1,4.034,1.409A5.321,5.321,0,0,1,20,5.338v.037H15.762a3.54,3.54,0,0,0-3.57,3.482,3.421,3.421,0,0,0,1.044,2.467,3.6,3.6,0,0,0,2.527,1.024H20v.306a5.333,5.333,0,0,1-1.449,3.933A5.632,5.632,0,0,1,14.517,18ZM4.739,3.875a.759.759,0,0,0-.761.744.731.731,0,0,0,.222.528.769.769,0,0,0,.54.221H10.39a.769.769,0,0,0,.54-.221.733.733,0,0,0,.222-.529.759.759,0,0,0-.767-.743Z",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M.037,2.4a2.018,2.018,0,0,0,2,1.6h3.25A.726.726,0,0,0,6,3.266V.734A.728.728,0,0,0,5.283,0H1.956A1.985,1.985,0,0,0,0,2.01,2.031,2.031,0,0,0,.037,2.4",
            transform: "translate(14 6.9)",
            fill: e,
            opacity: n
        }), (0, $acw62.createElement)("circle", {
            id: "Oval",
            cx: "1",
            cy: "1",
            r: "1",
            transform: "translate(15 7.9)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.74,5.383H2.692A2.691,2.691,0,1,1,2.692,0H6.74",
            transform: "translate(12.398 6.013)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M.612.456H.3",
            transform: "translate(14.937 8.187)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M5.248,0h8.643a5.248,5.248,0,0,1,5.248,5.248v7.177a5.248,5.248,0,0,1-5.248,5.248H5.248A5.248,5.248,0,0,1,0,12.425V5.248A5.248,5.248,0,0,1,5.248,0Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,.456H5.4",
            transform: "translate(4.536 4.082)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.548,18.318a.675.675,0,0,1,.667-.682,4.509,4.509,0,0,0,4.452-4.554V7.365H15.383a2,2,0,0,0,0,4.008h1.364a.682.682,0,0,1,0,1.364H15.383a3.369,3.369,0,0,1,0-6.736h3.284V5.919a4.509,4.509,0,0,0-4.452-4.555H5.785A4.455,4.455,0,0,0,1.567,4.528h8.788a.682.682,0,0,1,0,1.364H1.336c0,.009,0,.017,0,.027v7.162a4.508,4.508,0,0,0,4.452,4.554h4.241a.682.682,0,0,1,0,1.364H5.785A5.859,5.859,0,0,1,0,13.082V5.919A5.859,5.859,0,0,1,5.785,0h8.429A5.86,5.86,0,0,1,20,5.919v7.162A5.86,5.86,0,0,1,14.215,19,.675.675,0,0,1,13.548,18.318Zm1.98-8.329a.682.682,0,0,1,0-1.364h.3a.682.682,0,0,1,0,1.364Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.74,5.383H2.692A2.691,2.691,0,1,1,2.692,0H6.74",
            transform: "translate(12.398 6.013)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M.612.456H.3",
            transform: "translate(14.937 8.187)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M5.248,0h8.643a5.248,5.248,0,0,1,5.248,5.248v7.177a5.248,5.248,0,0,1-5.248,5.248H5.248A5.248,5.248,0,0,1,0,12.425V5.248A5.248,5.248,0,0,1,5.248,0Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,.456H5.4",
            transform: "translate(4.536 4.082)",
            fill: "none",
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a,
            opacity: n
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.45,5.127H2.563A2.563,2.563,0,0,1,2.563,0H6.419",
            transform: "translate(12.722 6.549)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M.625.476h-.3",
            transform: "translate(15.097 8.577)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,.476H4.06",
            transform: "translate(5.606 4.668)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,8.539C0,2.134,2.325,0,9.3,0s9.3,2.134,9.3,8.539-2.325,8.539-9.3,8.539S0,14.943,0,8.539Z",
            transform: "translate(0.714 0.714)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$kt.displayName = "IconlyWallet", $63c37e44f569564f$var$kt.propTypes = {
    color: $63c37e44f569564f$var$Q.string,
    opacity: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$bcca3ea514774656 = $63c37e44f569564f$var$st($63c37e44f569564f$var$kt), $63c37e44f569564f$var$ft = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.088,15.514A8.2,8.2,0,0,1,.065,12.378,5.93,5.93,0,0,1,0,11.391,8.694,8.694,0,0,1,6.956,2.959a1.1,1.1,0,0,1,1.2.6,1.1,1.1,0,0,1,.127.257c.136,2.1.281,4.158.417,6.22a1.851,1.851,0,0,0,.1.63,1.023,1.023,0,0,0,1.005.631l6.656-.426.046.017a1.085,1.085,0,0,1,.756.322,1.048,1.048,0,0,1,.3.753A8.671,8.671,0,0,1,10.683,19.8a8.948,8.948,0,0,1-1.889.2A8.813,8.813,0,0,1,1.088,15.514Zm9.784-6.423a.88.88,0,0,1-.293-.658L10.062.889V.765A.793.793,0,0,1,10.327.21.823.823,0,0,1,10.913,0,9.422,9.422,0,0,1,20,7.89a.3.3,0,0,1,0,.08.786.786,0,0,1-.2.575.813.813,0,0,1-.555.269l-7.679.507q-.041,0-.082,0A.915.915,0,0,1,10.872,9.091Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.153.644a1.06,1.06,0,0,1,.1.329l.278,4.14h0l.138,2.081a2.14,2.14,0,0,0,.1.631,1.043,1.043,0,0,0,1.005.631l6.657-.435a1.1,1.1,0,0,1,.774.3,1.06,1.06,0,0,1,.319.609l.012.14a8.682,8.682,0,0,1-6.884,7.818,8.856,8.856,0,0,1-9.592-4.263,8.214,8.214,0,0,1-1-3.146A6.018,6.018,0,0,1,0,8.491,8.7,8.7,0,0,1,6.984.013,1.091,1.091,0,0,1,8.153.644Z",
            transform: "translate(0 2.911)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M.849,0a9.444,9.444,0,0,1,9.13,7.811l-.007.033h0l-.02.047,0,.13a.8.8,0,0,1-.192.472.827.827,0,0,1-.462.271l-.11.015-7.681.5a.917.917,0,0,1-.7-.227.884.884,0,0,1-.288-.537L.007.845a.122.122,0,0,1,0-.08A.785.785,0,0,1,.265.21.815.815,0,0,1,.849,0Z",
            transform: "translate(10.021 0)",
            fill: e,
            opacity: n
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.7,6.975A8.311,8.311,0,0,0,.741,0,.714.714,0,0,0,0,.687H0V.751L.449,7.461a.824.824,0,0,0,.87.769l6.728-.449A.714.714,0,0,0,8.7,7.012Z",
            transform: "translate(10.819 0.777)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M6.145.024A.915.915,0,0,1,7.189.545a.824.824,0,0,1,.082.3c.092,1.3.284,4.146.394,5.684a1.043,1.043,0,0,0,1.117.97h0l5.648-.348a.915.915,0,0,1,.97.915h0A7.7,7.7,0,0,1,.974,11.264a7.323,7.323,0,0,1-.915-2.8A4.723,4.723,0,0,1,0,7.548,7.707,7.707,0,0,1,6.136.024",
            transform: "translate(0.756 4.745)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.511,18.085a8.249,8.249,0,0,1-4.447-6.4A5.112,5.112,0,0,1,0,10.721,8.287,8.287,0,0,1,6.629,2.613a.8.8,0,1,1,.316,1.568,6.708,6.708,0,0,0-5.339,6.566,4.152,4.152,0,0,0,.044.74,6.732,6.732,0,0,0,13.149,1,.808.808,0,0,1,.982-.549.794.794,0,0,1,.495.362.779.779,0,0,1,.083.6A8.367,8.367,0,0,1,8.312,19,8.345,8.345,0,0,1,4.511,18.085ZM11.924,9.58a1.61,1.61,0,0,1-1.6-1.463L9.89,1.577A1.472,1.472,0,0,1,10.3.462,1.561,1.561,0,0,1,11.408,0h.033a8.92,8.92,0,0,1,8.547,7.438H20v.14a1.47,1.47,0,0,1-.367,1.072,1.488,1.488,0,0,1-1.026.495l-6.575.436Zm0-1.568,6.486-.427a7.3,7.3,0,0,0-2.4-4.21,7.391,7.391,0,0,0-4.525-1.789Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.7,6.975A8.311,8.311,0,0,0,.741,0,.714.714,0,0,0,0,.687H0V.751L.449,7.461a.824.824,0,0,0,.87.769l6.728-.449A.714.714,0,0,0,8.7,7.012Z",
            transform: "translate(10.819 0.777)",
            fill: "none",
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M6.145.024A.915.915,0,0,1,7.189.545a.824.824,0,0,1,.082.3c.092,1.3.284,4.146.394,5.684a1.043,1.043,0,0,0,1.117.97h0l5.648-.348a.915.915,0,0,1,.97.915h0A7.7,7.7,0,0,1,.974,11.264a7.323,7.323,0,0,1-.915-2.8A4.723,4.723,0,0,1,0,7.548,7.707,7.707,0,0,1,6.136.024",
            transform: "translate(0.756 4.745)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.67.6C-.038,1.414-.32,6.539.5,7.363s5.768.406,6.956-.529C10.317,4.583,2.93-2,.67.6Z",
            transform: "translate(10.809 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M15.188,7.984c1.084,1.084-1.79,7.264-7.486,7.264A7.7,7.7,0,0,1,0,7.547c0-5.3,5.229-8.69,6.728-7.191.863.863-.109,4.924,1.439,6.473S14.1,6.9,15.188,7.984Z",
            transform: "translate(0.75 3.806)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$ft.displayName = "IconlyGraph", $63c37e44f569564f$var$ft.propTypes = {
    color: $63c37e44f569564f$var$Q.string,
    opacity: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$614db49f3febe941 = $63c37e44f569564f$var$st($63c37e44f569564f$var$ft), $63c37e44f569564f$var$mt = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.986,20a1.026,1.026,0,0,1-.515-.141L7.99,16.62,1.5,19.86a1.069,1.069,0,0,1-.491.13A1.016,1.016,0,0,1,0,18.97V3.79A3.316,3.316,0,0,1,1.437.875,6.154,6.154,0,0,1,4.9,0h6.17a6.181,6.181,0,0,1,3.47.875A3.362,3.362,0,0,1,16,3.79V18.97a1.022,1.022,0,0,1-.74.99A.933.933,0,0,1,14.986,20ZM4.22,6.04a.79.79,0,0,0,0,1.58h7.53a.79.79,0,0,0,0-1.58Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.991,4.913,1.5,8.155a1.019,1.019,0,0,1-1.376-.4A1.09,1.09,0,0,1,0,7.258V0C0,.72.406,1.164,1.473,1.661Z",
            transform: "translate(0 11.709)",
            fill: e,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M14.98,20a1.012,1.012,0,0,1-.506-.136L7.991,16.621,1.473,13.37C.4,12.87,0,12.419,0,11.709V3.793A3.322,3.322,0,0,1,1.435.874,6.145,6.145,0,0,1,4.9,0h6.174A6.188,6.188,0,0,1,14.54.874,3.36,3.36,0,0,1,16,3.793V18.967a1.065,1.065,0,0,1-.123.489,1.023,1.023,0,0,1-.616.5A1.012,1.012,0,0,1,14.98,20ZM4.225,6.041a.791.791,0,0,0,0,1.581h7.524a.791.791,0,0,0,0-1.581Z",
            transform: "translate(0)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.368,15.854,1.437,19.1a.989.989,0,0,1-1.318-.394h0A1.043,1.043,0,0,1,0,18.243V3.844C0,1.1,1.876,0,4.577,0H10.92C13.538,0,15.5,1.025,15.5,3.661V18.243a.979.979,0,0,1-.979.979,1.08,1.08,0,0,1-.476-.119L8.073,15.854A.741.741,0,0,0,7.368,15.854Z",
            transform: "translate(0.796 0.778)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,.458H7.3",
            transform: "translate(4.87 6.865)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M11.526,0h-6.9C1.784,0,0,1.986,0,5.172V18.323A1.658,1.658,0,0,0,1.638,20a1.625,1.625,0,0,0,.784-.2l5.612-3.116,6.534,3.133a.709.709,0,0,0,.555,0,.733.733,0,0,0,.394-.4.759.759,0,0,0-.319-.883L8.707,15.428a1.385,1.385,0,0,0-1.362,0L1.724,18.535a.211.211,0,0,1-.207,0,.213.213,0,0,1-.095-.185V5.172c.009-2.357,1.164-3.7,3.233-3.7h6.9c2.655,0,3.043,2.207,3.043,3.53v.6H7.129a.708.708,0,0,0-.5.233.743.743,0,0,0-.191.526.715.715,0,0,0,.69.706h7.44v7.723A.716.716,0,1,0,16,14.8h0V5C16,1.915,14.293,0,11.526,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.368,15.854,1.437,19.1a.989.989,0,0,1-1.318-.394h0A1.043,1.043,0,0,1,0,18.243V3.844C0,1.1,1.876,0,4.577,0H10.92C13.538,0,15.5,1.025,15.5,3.661V18.243a.979.979,0,0,1-.979.979,1.08,1.08,0,0,1-.476-.119L8.073,15.854A.741.741,0,0,0,7.368,15.854Z",
            transform: "translate(0.796 0.778)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,.458H7.3",
            transform: "translate(4.87 6.865)",
            fill: "none",
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a,
            opacity: n
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,.5H6.855",
            transform: "translate(4.042 6.218)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M7.47,0C1.083,0,0,.932,0,8.429,0,16.822-.153,19,1.443,19s4.2-3.684,6.027-3.684S11.9,19,13.5,19s1.439-2.178,1.439-10.571C14.936.932,13.857,0,7.47,0Z",
            transform: "translate(0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$mt.displayName = "IconlyBookmark", $63c37e44f569564f$var$mt.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$301ef70c5c7bdf65 = $63c37e44f569564f$var$st($63c37e44f569564f$var$mt), $63c37e44f569564f$var$Mt = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.081,20a2.549,2.549,0,0,1-2.541-2.56V14.031a2.543,2.543,0,0,1,2.541-2.561h3.38A2.549,2.549,0,0,1,20,14.031v3.408A2.554,2.554,0,0,1,17.46,20ZM2.54,20A2.555,2.555,0,0,1,0,17.439V14.031A2.549,2.549,0,0,1,2.54,11.47H5.92a2.543,2.543,0,0,1,2.54,2.561v3.408A2.548,2.548,0,0,1,5.92,20ZM14.081,8.53A2.542,2.542,0,0,1,11.54,5.97V2.561A2.549,2.549,0,0,1,14.081,0h3.38A2.554,2.554,0,0,1,20,2.561V5.97a2.548,2.548,0,0,1-2.54,2.56ZM2.54,8.53A2.548,2.548,0,0,1,0,5.97V2.561A2.555,2.555,0,0,1,2.54,0H5.92A2.549,2.549,0,0,1,8.46,2.561V5.97A2.542,2.542,0,0,1,5.92,8.53Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.539,0H5.924A2.549,2.549,0,0,1,8.463,2.56V5.975a2.549,2.549,0,0,1-2.539,2.56H2.539A2.549,2.549,0,0,1,0,5.975V2.56A2.549,2.549,0,0,1,2.539,0",
            transform: "translate(11.537 0)",
            fill: e,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M14.075,20a2.549,2.549,0,0,1-2.538-2.56V14.026a2.549,2.549,0,0,1,2.538-2.561h3.387A2.549,2.549,0,0,1,20,14.026V17.44A2.549,2.549,0,0,1,17.462,20ZM2.539,20A2.55,2.55,0,0,1,0,17.44V14.026a2.55,2.55,0,0,1,2.539-2.561H5.925a2.549,2.549,0,0,1,2.538,2.561V17.44A2.549,2.549,0,0,1,5.925,20Zm0-11.465A2.549,2.549,0,0,1,0,5.974V2.56A2.549,2.549,0,0,1,2.539,0H5.925A2.548,2.548,0,0,1,8.463,2.56V5.974A2.549,2.549,0,0,1,5.925,8.535Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.449,0H5.716A2.459,2.459,0,0,1,8.163,2.47V5.764a2.46,2.46,0,0,1-2.448,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.47A2.46,2.46,0,0,1,2.449,0Z",
            transform: "translate(11.837 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M2.449,0H5.714A2.46,2.46,0,0,1,8.163,2.47V5.764a2.46,2.46,0,0,1-2.449,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.47A2.46,2.46,0,0,1,2.449,0Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M2.449,0H5.714A2.46,2.46,0,0,1,8.163,2.471V5.764a2.46,2.46,0,0,1-2.449,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.471A2.46,2.46,0,0,1,2.449,0Z",
            transform: "translate(0 11.766)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M2.449,0H5.716A2.46,2.46,0,0,1,8.163,2.471V5.764a2.459,2.459,0,0,1-2.448,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.471A2.46,2.46,0,0,1,2.449,0Z",
            transform: "translate(11.837 11.766)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.3,19a2.932,2.932,0,0,1-2.875-2.944V13.186A2.908,2.908,0,0,1,13.3,10.252h2.813A2.931,2.931,0,0,1,19,13.186v2.871A2.943,2.943,0,0,1,16.117,19Zm-1.332-5.815v2.871a1.36,1.36,0,0,0,.388.964,1.3,1.3,0,0,0,.934.4h2.832a1.3,1.3,0,0,0,.934-.4,1.357,1.357,0,0,0,.387-.964V13.186a1.368,1.368,0,0,0-.39-.961,1.311,1.311,0,0,0-.941-.4H13.3A1.347,1.347,0,0,0,11.973,13.186Zm-9.09,5.8A2.976,2.976,0,0,1,0,16.048V13.186a2.966,2.966,0,0,1,.845-2.078,2.842,2.842,0,0,1,2.038-.856H4.038a.769.769,0,0,1,.74.367.805.805,0,0,1,0,.84.77.77,0,0,1-.74.368H2.883a1.354,1.354,0,0,0-1.34,1.359v2.835a1.381,1.381,0,0,0,1.34,1.359H5.713a1.313,1.313,0,0,0,.947-.4,1.371,1.371,0,0,0,.393-.964V11.764a.8.8,0,0,1,.347-.813.763.763,0,0,1,.869.025.8.8,0,0,1,.3.832v4.239a2.913,2.913,0,0,1-2.883,2.943ZM14.989,8.776a.794.794,0,0,1,0-1.576h1.129a1.323,1.323,0,0,0,.948-.41,1.386,1.386,0,0,0,.383-.977V2.943a1.364,1.364,0,0,0-1.331-1.359H13.3a1.346,1.346,0,0,0-1.332,1.359V7.236a.791.791,0,0,1-.793.774.761.761,0,0,1-.541-.245A.794.794,0,0,1,10.43,7.2V2.943A2.967,2.967,0,0,1,11.269.862,2.846,2.846,0,0,1,13.3,0h2.813a2.976,2.976,0,0,1,2.874,2.943V5.805a2.966,2.966,0,0,1-.816,2.085,2.85,2.85,0,0,1-2.022.886ZM5.7,8.749H2.883A2.933,2.933,0,0,1,0,5.814V2.943A2.943,2.943,0,0,1,2.883,0H5.7A2.93,2.93,0,0,1,8.579,2.943V5.814a2.946,2.946,0,0,1-.845,2.078A2.829,2.829,0,0,1,5.7,8.749ZM1.924,1.973a1.381,1.381,0,0,0-.4.97V5.814a1.378,1.378,0,0,0,.39.988,1.319,1.319,0,0,0,.939.4H5.7a1.318,1.318,0,0,0,.949-.41,1.377,1.377,0,0,0,.383-.977V2.943A1.361,1.361,0,0,0,5.7,1.584H2.857A1.311,1.311,0,0,0,1.924,1.973Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.449,0H5.716A2.459,2.459,0,0,1,8.163,2.47V5.764a2.46,2.46,0,0,1-2.448,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.47A2.46,2.46,0,0,1,2.449,0Z",
            transform: "translate(11.837 0)",
            fill: "none",
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M2.449,0H5.714A2.46,2.46,0,0,1,8.163,2.47V5.764a2.46,2.46,0,0,1-2.449,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.47A2.46,2.46,0,0,1,2.449,0Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M2.449,0H5.714A2.46,2.46,0,0,1,8.163,2.471V5.764a2.46,2.46,0,0,1-2.449,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.471A2.46,2.46,0,0,1,2.449,0Z",
            transform: "translate(0 11.766)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M2.449,0H5.716A2.46,2.46,0,0,1,8.163,2.471V5.764a2.459,2.459,0,0,1-2.448,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.471A2.46,2.46,0,0,1,2.449,0Z",
            transform: "translate(11.837 11.766)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.347,3.674A3.673,3.673,0,1,1,3.673,0,3.674,3.674,0,0,1,7.347,3.674Z",
            transform: "translate(10.654 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M7.347,3.674A3.673,3.673,0,1,1,3.673,0,3.674,3.674,0,0,1,7.347,3.674Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M7.347,3.674A3.673,3.673,0,1,1,3.673,0,3.674,3.674,0,0,1,7.347,3.674Z",
            transform: "translate(10.654 10.588)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M7.347,3.674A3.673,3.673,0,1,1,3.673,0,3.673,3.673,0,0,1,7.347,3.674Z",
            transform: "translate(0 10.588)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Mt.displayName = "IconlyCategory", $63c37e44f569564f$var$Mt.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$3a8840c5b2ecf003 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Mt), $63c37e44f569564f$var$At = function(t) {
    var r = t.color, n = t.strokeWidth, e = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.635,18.773V15.716A1.419,1.419,0,0,1,8.058,14.3h2.874a1.429,1.429,0,0,1,1.007.414,1.408,1.408,0,0,1,.417,1v3.058a1.213,1.213,0,0,0,.356.867,1.231,1.231,0,0,0,.871.36h1.961a3.46,3.46,0,0,0,2.443-1A3.41,3.41,0,0,0,19,16.578V7.867a2.473,2.473,0,0,0-.9-1.9L11.434.676A3.1,3.1,0,0,0,7.485.747L.967,5.965A2.474,2.474,0,0,0,0,7.867v8.7A3.444,3.444,0,0,0,3.456,20H5.372a1.231,1.231,0,0,0,1.236-1.218Z",
            fill: r
        }));
    }, a = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.657,18.771V15.7a1.426,1.426,0,0,1,1.424-1.419h2.886A1.426,1.426,0,0,1,12.4,15.7h0v3.076A1.225,1.225,0,0,0,13.6,20h1.924A3.456,3.456,0,0,0,19,16.562h0V7.838a2.439,2.439,0,0,0-.962-1.9L11.458.685a3.18,3.18,0,0,0-3.944,0L.962,5.943A2.42,2.42,0,0,0,0,7.847v8.714A3.456,3.456,0,0,0,3.473,20H5.4a1.235,1.235,0,0,0,1.241-1.229h0",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: n
        }));
    }, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2.004)"
        }, (0, $acw62.createElement)("path", {
            d: "M3.921,19.84A3.93,3.93,0,0,1,0,15.917V7.952A3.025,3.025,0,0,1,1.174,5.6L1.9,5.065a.783.783,0,0,1,.9,1.244l-.7.522a1.469,1.469,0,0,0-.531,1.121v7.957a2.365,2.365,0,0,0,2.356,2.347h4v.018a.783.783,0,0,1,0,1.565Zm9.2-.009a1.9,1.9,0,0,1-1.9-1.9v-3.6a.5.5,0,0,0-.5-.5H8.1a.5.5,0,0,0-.5.513v1.373a.783.783,0,1,1-1.565,0V14.344a2.08,2.08,0,0,1,2.078-2.079h2.609a2.079,2.079,0,0,1,2.07,2.079v3.591a.33.33,0,0,0,.33.33H14.9a2.348,2.348,0,0,0,2.348-2.348V7.952a1.471,1.471,0,0,0-.556-1.13L10.687,2.03a2.052,2.052,0,0,0-2.608,0L6.148,3.474a.8.8,0,1,1-.931-1.3L7.122.8a3.609,3.609,0,0,1,4.522,0l6.009,4.792a3.052,3.052,0,0,1,1.138,2.348l-.008,7.974a3.922,3.922,0,0,1-3.922,3.921Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.657,18.771V15.7a1.426,1.426,0,0,1,1.424-1.419h2.886A1.426,1.426,0,0,1,12.4,15.7h0v3.076A1.225,1.225,0,0,0,13.6,20h1.924A3.456,3.456,0,0,0,19,16.562h0V7.838a2.439,2.439,0,0,0-.962-1.9L11.458.685a3.18,3.18,0,0,0-3.944,0L.962,5.943A2.42,2.42,0,0,0,0,7.847v8.714A3.456,3.456,0,0,0,3.473,20H5.4a1.235,1.235,0,0,0,1.241-1.229h0",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: n
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,.5H5.815",
            transform: "translate(6.679 13.635)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: n
        }), (0, $acw62.createElement)("path", {
            d: "M0,11.713c0-5.631.614-5.238,3.919-8.3C5.365,2.246,7.615,0,9.558,0s4.237,2.235,5.7,3.41c3.305,3.065,3.918,2.672,3.918,8.3C19.172,20,17.213,20,9.586,20S0,20,0,11.713Z",
            transform: "translate(0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: n
        }));
    };
    switch(t.set){
        case "bold":
        case "bulk":
            return (0, $acw62.createElement)(e, null);
        case "broken":
            return (0, $acw62.createElement)(s, null);
        case "two-tone":
            return (0, $acw62.createElement)(i, null);
        case "curved":
            return (0, $acw62.createElement)(l, null);
        default:
            return (0, $acw62.createElement)(a, null);
    }
};
$63c37e44f569564f$var$At.displayName = "IconlyHome", $63c37e44f569564f$var$At.propTypes = {
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$b94310965bed44e6 = $63c37e44f569564f$var$st($63c37e44f569564f$var$At), $63c37e44f569564f$var$gt = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.983,19.967a3.619,3.619,0,0,1-1.714-.733,1.551,1.551,0,0,1-.7-1.173c0-.5.462-.734.889-.833a25.955,25.955,0,0,1,4.046,0c.427.1.889.329.889.833a1.553,1.553,0,0,1-.695,1.174,3.635,3.635,0,0,1-1.713.732A4,4,0,0,1,8.48,20,3.667,3.667,0,0,1,7.983,19.967ZM3.764,15.747a4.535,4.535,0,0,1-2.9-1.413A3.615,3.615,0,0,1,0,11.956a3.368,3.368,0,0,1,.731-2.31A3.8,3.8,0,0,0,1.794,6.8V6.37A5.625,5.625,0,0,1,3.077,2.512,7.073,7.073,0,0,1,8.456,0h.09a7.041,7.041,0,0,1,5.467,2.624,5.546,5.546,0,0,1,1.2,3.746V6.8a3.889,3.889,0,0,0,1.062,2.849A3.364,3.364,0,0,1,17,11.956a3.614,3.614,0,0,1-.863,2.379,4.539,4.539,0,0,1-2.9,1.413c-1.571.133-3.144.247-4.737.247A41.689,41.689,0,0,1,3.764,15.747Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M16.27,9.645A3.884,3.884,0,0,1,15.207,6.8V6.37a5.546,5.546,0,0,0-1.2-3.746A7.041,7.041,0,0,0,8.544,0H8.456A7.071,7.071,0,0,0,3.077,2.513,5.623,5.623,0,0,0,1.793,6.37V6.8A3.8,3.8,0,0,1,.73,9.645,3.363,3.363,0,0,0,0,11.956a3.608,3.608,0,0,0,.864,2.378,4.532,4.532,0,0,0,2.9,1.413,41.646,41.646,0,0,0,4.737.247c1.593,0,3.164-.113,4.737-.247a4.532,4.532,0,0,0,2.9-1.413A3.614,3.614,0,0,0,17,11.956a3.363,3.363,0,0,0-.73-2.31",
            transform: "translate(0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M4.936.08A25.6,25.6,0,0,0,.89.08C.462.179,0,.408,0,.912A1.55,1.55,0,0,0,.7,2.085h0a3.635,3.635,0,0,0,1.714.732,3.836,3.836,0,0,0,1.008,0A3.636,3.636,0,0,0,5.13,2.086h0a1.55,1.55,0,0,0,.7-1.173c0-.5-.462-.733-.89-.832",
            transform: "translate(5.573 17.148)",
            fill: e,
            opacity: n
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,11.787v-.219A3.6,3.6,0,0,1,.6,9.75,4.87,4.87,0,0,0,1.8,7.436c0-.666,0-1.342.058-2.009C2.155,2.218,5.327,0,8.461,0h.078c3.134,0,6.306,2.218,6.617,5.427.058.666,0,1.342.049,2.009A4.955,4.955,0,0,0,16.4,9.759a3.506,3.506,0,0,1,.6,1.809v.209a3.566,3.566,0,0,1-.844,2.39A4.505,4.505,0,0,1,13.3,15.538a45.078,45.078,0,0,1-9.615,0A4.554,4.554,0,0,1,.835,14.167,3.6,3.6,0,0,1,0,11.787Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A3.061,3.061,0,0,0,2.037,1.127,3.088,3.088,0,0,0,4.288.5,2.886,2.886,0,0,0,4.812,0",
            transform: "translate(6.055 18.852)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.679,18.618a.756.756,0,0,1,.1-1.069.769.769,0,0,1,1.077.1,2.064,2.064,0,0,0,.418.413,1.987,1.987,0,0,0,2.777-.413h.009a.77.77,0,0,1,1.078-.1.755.755,0,0,1,.1,1.069,3.491,3.491,0,0,1-5.563,0Zm-1.641-2.78A4.834,4.834,0,0,1,.968,14.3,4.079,4.079,0,0,1,0,11.561v-.122a4.207,4.207,0,0,1,.728-2.1L.8,9.248a3.833,3.833,0,0,0,.887-1.76V5.675a.765.765,0,0,1,1.464.158V7.646a.431.431,0,0,1,0,.1,5.26,5.26,0,0,1-1.225,2.446,2.531,2.531,0,0,0-.39,1.25v.194a2.574,2.574,0,0,0,.585,1.715,3.319,3.319,0,0,0,2.076.986,40.05,40.05,0,0,0,8.588,0,3.326,3.326,0,0,0,2.12-1.03,2.543,2.543,0,0,0,.559-1.663v-.2a2.629,2.629,0,0,0-.381-1.258,5.269,5.269,0,0,1-1.3-2.446.584.584,0,0,1,0-.1V5.816c-.257-2.657-2.928-4.3-5.252-4.3a5.76,5.76,0,0,0-2.821.73.769.769,0,0,1-.777.005A.753.753,0,0,1,4.97.924,7.241,7.241,0,0,1,8.465,0c3.069,0,6.512,2.164,6.9,5.64V7.453a3.75,3.75,0,0,0,.887,1.76.747.747,0,0,1,.071.1A4.055,4.055,0,0,1,17,11.36l-.027.184a4.14,4.14,0,0,1-.941,2.754,4.884,4.884,0,0,1-3.123,1.54,40.7,40.7,0,0,1-4.435.242A40.723,40.723,0,0,1,4.038,15.838Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,11.787v-.219A3.6,3.6,0,0,1,.6,9.75,4.87,4.87,0,0,0,1.8,7.436c0-.666,0-1.342.058-2.009C2.155,2.218,5.327,0,8.461,0h.078c3.134,0,6.306,2.218,6.617,5.427.058.666,0,1.342.049,2.009A4.955,4.955,0,0,0,16.4,9.759a3.506,3.506,0,0,1,.6,1.809v.209a3.566,3.566,0,0,1-.844,2.39A4.505,4.505,0,0,1,13.3,15.538a45.078,45.078,0,0,1-9.615,0A4.554,4.554,0,0,1,.835,14.167,3.6,3.6,0,0,1,0,11.787Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A3.061,3.061,0,0,0,2.037,1.127,3.088,3.088,0,0,0,4.288.5,2.886,2.886,0,0,0,4.812,0",
            transform: "translate(6.055 18.852)",
            fill: "none",
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a,
            opacity: n
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4.615 2.514)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.382,0C2.947,0,1.021,4.015,1.021,6.67c0,1.984.288,1.4-.81,3.82-1.341,3.449,4.051,4.858,7.171,4.858s8.511-1.41,7.171-4.858c-1.1-2.42-.81-1.836-.81-3.82C13.743,4.015,11.815,0,7.382,0Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.62,0A2.992,2.992,0,0,1,0,0",
            transform: "translate(5.071 17.998)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$gt.displayName = "IconlyNotification", $63c37e44f569564f$var$gt.propTypes = {
    color: $63c37e44f569564f$var$Q.string,
    opacity: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$14834abbfce3b8cd = $63c37e44f569564f$var$st($63c37e44f569564f$var$gt), $63c37e44f569564f$var$Vt = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,20a9.955,9.955,0,0,1-4.92-1.3,2.2,2.2,0,0,0-1.107-.424,1.213,1.213,0,0,0-.383.063l-2.02.6a.754.754,0,0,1-.226.036.62.62,0,0,1-.5-.239.647.647,0,0,1-.094-.578l.67-2.244a1.046,1.046,0,0,0-.07-.9,10.566,10.566,0,0,1-1.35-5A10.158,10.158,0,0,1,2.831,3.032,9.89,9.89,0,0,1,10.02,0a9.865,9.865,0,0,1,7.12,2.994,10.058,10.058,0,0,1,2.1,3.182A9.89,9.89,0,0,1,20,9.985a10.138,10.138,0,0,1-.865,4.172,9.6,9.6,0,0,1-2.275,3.153A10.245,10.245,0,0,1,10,20ZM14.59,8.743a1.282,1.282,0,1,0,1.28,1.282A1.282,1.282,0,0,0,14.59,8.743Zm-4.629,0A1.268,1.268,0,0,0,8.7,10.015,1.28,1.28,0,1,0,9.98,8.743H9.961Zm-4.591,0a1.282,1.282,0,1,0,1.28,1.282A1.283,1.283,0,0,0,5.37,8.743Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.02,0A10,10,0,0,0,0,10a10.56,10.56,0,0,0,1.35,4.99,1.045,1.045,0,0,1,.07.9L.75,18.13a.624.624,0,0,0,.82.78l2.02-.6a1.7,1.7,0,0,1,1.491.36A9.987,9.987,0,1,0,10.02,0",
            fill: e,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M9.22,1.28A1.28,1.28,0,1,1,10.5,2.561,1.276,1.276,0,0,1,9.22,1.28Zm-4.61-.01a1.28,1.28,0,1,1,1.28,1.291A1.292,1.292,0,0,1,4.611,1.27ZM0,1.28a1.28,1.28,0,0,1,2.56,0A1.29,1.29,0,0,1,1.28,2.561,1.289,1.289,0,0,1,0,1.28Z",
            transform: "translate(4.09 8.73)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.085,1.166a1.169,1.169,0,1,1,1.169,1.169A1.169,1.169,0,0,1,9.085,1.166Zm-4.542,0A1.168,1.168,0,1,1,5.711,2.336,1.169,1.169,0,0,1,4.543,1.166ZM0,1.166A1.169,1.169,0,1,1,1.168,2.336,1.169,1.169,0,0,1,0,1.166Z",
            transform: "translate(4.527 9.056)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M10.02,0A10.006,10.006,0,0,0,0,10.015a10.584,10.584,0,0,0,1.35,5,1.051,1.051,0,0,1,.07.9L.75,18.157a.624.624,0,0,0,.82.78l2.02-.6a1.7,1.7,0,0,1,1.49.361A10,10,0,1,0,10.02,0Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.847,19.765A.749.749,0,0,1,8.172,18.3,8.5,8.5,0,1,0,10.006,1.5H10A8.5,8.5,0,0,0,2.46,13.931l.192.375a1.961,1.961,0,0,1,.135,1.482,17,17,0,0,0-.53,1.633C2.818,17.252,3.5,17,4,16.823l.2-.074a.749.749,0,0,1,.509,1.409l-.2.073a23.99,23.99,0,0,1-2.442.791.8.8,0,0,1-.177.018A1.206,1.206,0,0,1,1,18.7a1.309,1.309,0,0,1-.337-1,.828.828,0,0,1,.019-.148,17.461,17.461,0,0,1,.69-2.245.475.475,0,0,0-.049-.309l-.194-.374A10,10,0,0,1,10,0h.012a10,10,0,1,1-2.16,19.765ZM13.21,10A1.189,1.189,0,1,1,14.4,11.188,1.19,1.19,0,0,1,13.21,10Zm-4.4,0A1.189,1.189,0,1,1,10,11.188,1.19,1.19,0,0,1,8.807,10ZM4.4,10a1.189,1.189,0,1,1,1.189,1.189A1.19,1.19,0,0,1,4.4,10Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.057,0A10,10,0,0,0,1.138,14.629l.2.39a1.3,1.3,0,0,1,.1,1,19.8,19.8,0,0,0-.715,2.324c0,.4.114.629.544.619A18.271,18.271,0,0,0,3.5,18.314a1.481,1.481,0,0,1,.954.057c.277.133.839.476.859.476A10,10,0,1,0,10.057,0Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("ellipse", {
            cx: "0.477",
            cy: "0.476",
            rx: "1.477",
            ry: "1.476",
            transform: "translate(4.81 9.524)",
            fill: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            opacity: n
        }), (0, $acw62.createElement)("ellipse", {
            cx: "0.477",
            cy: "0.476",
            rx: "1.477",
            ry: "1.476",
            transform: "translate(9.58 9.524)",
            fill: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            opacity: n
        }), (0, $acw62.createElement)("ellipse", {
            cx: "0.477",
            cy: "0.476",
            rx: "1.477",
            ry: "1.476",
            transform: "translate(14.35 9.524)",
            fill: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            opacity: n
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(13.444 9.913)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(9.435 9.913)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(5.426 9.913)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M17.071,17.07a10.006,10.006,0,0,1-11.285,2c-.547-.22-4.085.76-4.853-.007s.213-4.307-.007-4.854A10,10,0,1,1,17.071,17.07Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Vt.displayName = "IconlyChat", $63c37e44f569564f$var$Vt.propTypes = {
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$d49dffca20dba6f7 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Vt), $63c37e44f569564f$var$jt = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.501)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.236,19.838a38.535,38.535,0,0,1-6.656-5.21A13.333,13.333,0,0,1,.412,9.55C-.777,5.834.612,1.579,4.5.319a6.579,6.579,0,0,1,6,1.016h0a6.589,6.589,0,0,1,6-1.016c3.887,1.259,5.286,5.514,4.1,9.231a13.333,13.333,0,0,1-3.168,5.078,38.535,38.535,0,0,1-6.656,5.21l-.26.162Z",
            transform: "translate(0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.754,18.837A36.258,36.258,0,0,1,3.426,13.88,12.668,12.668,0,0,1,.4,9.075C-.742,5.535.582,1.489,4.279.288A6.282,6.282,0,0,1,9.985,1.3h0A6.291,6.291,0,0,1,15.691.288c3.7,1.2,5.03,5.247,3.893,8.787a12.67,12.67,0,0,1-3.013,4.8,36.587,36.587,0,0,1-6.328,4.958L9.994,19Z",
            transform: "translate(0.022)",
            fill: e,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M10.011,19l-.235-.163a36.319,36.319,0,0,1-6.337-4.958,12.667,12.667,0,0,1-3.048-4.8C-.738,5.535.586,1.489,4.283.288A6.3,6.3,0,0,1,10.011,1.31Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.261,17.854a34.84,34.84,0,0,1-6.022-4.689A11.99,11.99,0,0,1,.373,8.6C-.7,5.25.554,1.421,4.071.288A5.978,5.978,0,0,1,9.5,1.2h0A5.987,5.987,0,0,1,14.921.288C18.438,1.421,19.7,5.25,18.628,8.6a11.99,11.99,0,0,1-2.866,4.57A34.84,34.84,0,0,1,9.74,17.854L9.505,18Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M19.235,3.494A6.208,6.208,0,0,0,15.521.3a6.565,6.565,0,0,0-5.515.737A6.565,6.565,0,0,0,4.491.3,6.208,6.208,0,0,0,.776,3.494,7.945,7.945,0,0,0,.406,9.427a12.364,12.364,0,0,0,2.974,4.764,34.307,34.307,0,0,0,5.991,4.683A.705.705,0,0,0,9.776,19a.743.743,0,0,0,.693-.537.763.763,0,0,0-.287-.838A33.042,33.042,0,0,1,4.429,13.13,10.981,10.981,0,0,1,1.782,8.959a6.4,6.4,0,0,1,.282-4.782A4.778,4.778,0,0,1,4.941,1.741a5.033,5.033,0,0,1,4.615.818.73.73,0,0,0,.882,0,5.042,5.042,0,0,1,4.615-.818A4.78,4.78,0,0,1,17.9,4.186a6.345,6.345,0,0,1,.3,4.8,10.946,10.946,0,0,1-2.647,4.18,23.352,23.352,0,0,1-2.647,2.328.738.738,0,0,0-.3.483.748.748,0,0,0,.128.559.724.724,0,0,0,1.006.2l.053-.045a23.865,23.865,0,0,0,2.815-2.472,12.518,12.518,0,0,0,2.965-4.764A7.9,7.9,0,0,0,19.235,3.494Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.748,17.854A36.489,36.489,0,0,1,3.41,13.165,11.922,11.922,0,0,1,.393,8.6C-.74,5.25.583,1.421,4.285.288A6.563,6.563,0,0,1,10,1.2h0a6.573,6.573,0,0,1,5.71-.914c3.7,1.133,5.035,4.963,3.9,8.308a11.922,11.922,0,0,1-3.017,4.57,36.489,36.489,0,0,1-6.339,4.689L10.005,18Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A2.814,2.814,0,0,1,2.018,2.422",
            transform: "translate(13.936 4.053)",
            fill: "none",
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a,
            opacity: n
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.55 3.55)"
        }, (0, $acw62.createElement)("path", {
            d: "M.372,8.9C-.7,5.546.554,1.381,4.071.249A4.869,4.869,0,0,1,9.5,1.939a4.73,4.73,0,0,1,5.42-1.69c3.516,1.132,4.778,5.3,3.706,8.647-1.67,5.31-7.5,8.076-9.126,8.076S2.1,14.268.372,8.9Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A2.154,2.154,0,0,1,1.917,2.422",
            transform: "translate(13.238 4.014)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$jt.displayName = "IconlyHeart", $63c37e44f569564f$var$jt.propTypes = {
    color: $63c37e44f569564f$var$Q.string,
    opacity: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$51def8c33e56fa36 = $63c37e44f569564f$var$st($63c37e44f569564f$var$jt), $63c37e44f569564f$var$vt = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.501)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.03,19h0l-.259-.16A38.164,38.164,0,0,1,3.4,13.879,12.993,12.993,0,0,1,.39,9.08,7.744,7.744,0,0,1,.533,3.805,6.084,6.084,0,0,1,4.321.269,4.5,4.5,0,0,1,5.21.06h.12A5.7,5.7,0,0,1,6.17,0h.11A6.266,6.266,0,0,1,8.111.33H8.17A.331.331,0,0,1,8.26.39a3.375,3.375,0,0,1,.63.261L9.27.82a2.627,2.627,0,0,1,.285.19c.057.042.106.077.145.1l.041.024A2.435,2.435,0,0,1,10,1.3,6.224,6.224,0,0,1,13.806,0h.044a5.826,5.826,0,0,1,1.86.291,6.019,6.019,0,0,1,3.755,3.517A7.915,7.915,0,0,1,19.62,9.08a12.781,12.781,0,0,1-3.009,4.81,38.6,38.6,0,0,1-6.332,4.96l-.25.15ZM14.937,3.118a.809.809,0,0,0-.757.543.82.82,0,0,0,.5,1.029,1.676,1.676,0,0,1,1.07,1.57V6.29a.86.86,0,0,0,.19.62.841.841,0,0,0,.57.29.823.823,0,0,0,.79-.76V6.321A3.3,3.3,0,0,0,15.19,3.16.78.78,0,0,0,14.937,3.118Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.754,18.837A36.258,36.258,0,0,1,3.426,13.88,12.668,12.668,0,0,1,.4,9.075C-.742,5.535.582,1.489,4.279.288A6.282,6.282,0,0,1,9.985,1.3h0A6.291,6.291,0,0,1,15.691.288c3.7,1.2,5.03,5.247,3.893,8.787a12.67,12.67,0,0,1-3.013,4.8,36.587,36.587,0,0,1-6.328,4.958L9.994,19Z",
            transform: "translate(0.022)",
            fill: e,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M10.011,19l-.235-.163a36.319,36.319,0,0,1-6.337-4.958,12.667,12.667,0,0,1-3.048-4.8C-.738,5.535.586,1.489,4.283.288A6.3,6.3,0,0,1,10.011,1.31Z",
            transform: "translate(0 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M2.23,4h0a.719.719,0,0,1-.517-.278.818.818,0,0,1-.167-.591h0A1.647,1.647,0,0,0,.552,1.54.787.787,0,0,1,.022.592.725.725,0,0,1,.886.019a.383.383,0,0,1,.139.052A3.2,3.2,0,0,1,3,3.226a.807.807,0,0,1-.229.56A.708.708,0,0,1,2.23,4Z",
            transform: "translate(14 3)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.261,17.854a34.84,34.84,0,0,1-6.022-4.689A11.99,11.99,0,0,1,.373,8.6C-.7,5.25.554,1.421,4.071.288A5.978,5.978,0,0,1,9.5,1.2h0A5.987,5.987,0,0,1,14.921.288C18.438,1.421,19.7,5.25,18.628,8.6a11.99,11.99,0,0,1-2.866,4.57A34.84,34.84,0,0,1,9.74,17.854L9.505,18Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A2.782,2.782,0,0,1,1.917,2.422",
            transform: "translate(13.239 4.053)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.371,18.874A34.311,34.311,0,0,1,3.38,14.191,12.375,12.375,0,0,1,.406,9.427,7.944,7.944,0,0,1,.777,3.494,6.208,6.208,0,0,1,4.491.3a6.565,6.565,0,0,1,5.515.737A6.563,6.563,0,0,1,15.521.3a6.209,6.209,0,0,1,3.715,3.191,7.9,7.9,0,0,1,.335,5.96,12.524,12.524,0,0,1-2.965,4.765,23.9,23.9,0,0,1-2.814,2.471l-.053.045a.724.724,0,0,1-1.006-.2.747.747,0,0,1-.128-.559.737.737,0,0,1,.3-.483,23.377,23.377,0,0,0,2.647-2.328A10.95,10.95,0,0,0,18.2,8.986a6.345,6.345,0,0,0-.3-4.8,4.782,4.782,0,0,0-2.849-2.445,5.043,5.043,0,0,0-4.615.818.729.729,0,0,1-.882,0,5.035,5.035,0,0,0-4.615-.818A4.782,4.782,0,0,0,2.065,4.177,6.4,6.4,0,0,0,1.782,8.96,10.991,10.991,0,0,0,4.43,13.13a33.016,33.016,0,0,0,5.753,4.495.762.762,0,0,1,.287.838A.744.744,0,0,1,9.777,19h0A.705.705,0,0,1,9.371,18.874ZM14.8,7.188a1.973,1.973,0,0,0-1.359-1.8.762.762,0,0,1-.311-.876A.741.741,0,0,1,13.888,4a3.467,3.467,0,0,1,2.374,3.011.751.751,0,0,1-.148.549.721.721,0,0,1-.488.278.734.734,0,0,1-.1.006A.746.746,0,0,1,14.8,7.188Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.748,17.854A36.489,36.489,0,0,1,3.41,13.165,11.922,11.922,0,0,1,.393,8.6C-.74,5.25.583,1.421,4.285.288A6.563,6.563,0,0,1,10,1.2h0a6.573,6.573,0,0,1,5.71-.914c3.7,1.133,5.035,4.963,3.9,8.308a11.922,11.922,0,0,1-3.017,4.57,36.489,36.489,0,0,1-6.339,4.689L10.005,18Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A2.814,2.814,0,0,1,2.018,2.422",
            transform: "translate(13.936 4.053)",
            fill: "none",
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a,
            opacity: n
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.55 3.55)"
        }, (0, $acw62.createElement)("path", {
            d: "M.372,8.9C-.7,5.546.554,1.381,4.071.249A4.869,4.869,0,0,1,9.5,1.939a4.73,4.73,0,0,1,5.42-1.69c3.516,1.132,4.778,5.3,3.706,8.647-1.67,5.31-7.5,8.076-9.126,8.076S2.1,14.268.372,8.9Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$vt.displayName = "IconlyHeart2", $63c37e44f569564f$var$vt.propTypes = {
    color: $63c37e44f569564f$var$Q.string,
    opacity: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$378339152ed5d642 = $63c37e44f569564f$var$st($63c37e44f569564f$var$vt), $63c37e44f569564f$var$bt = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.674,20A4.7,4.7,0,0,1,0,15.29V4.51A4.493,4.493,0,0,1,4.465,0H9.752a.458.458,0,0,1,.455.46V3.68a3.341,3.341,0,0,0,3.308,3.34c.423,0,.794,0,1.122.006.257,0,.481,0,.68,0,.141,0,.323,0,.521,0,.229,0,.486-.005.716-.005A.448.448,0,0,1,17,7.47v8.04A4.473,4.473,0,0,1,12.554,20Zm.01-6.359a.756.756,0,0,0,.743.75h5.386a.756.756,0,0,0,.743-.75.742.742,0,0,0-.743-.741H5.426A.742.742,0,0,0,4.684,13.64Zm0-4.99a.742.742,0,0,0,.743.74H8.772a.742.742,0,0,0,.743-.74.756.756,0,0,0-.743-.75H5.426A.756.756,0,0,0,4.684,8.65Zm8.964-3.091a2.018,2.018,0,0,1-2-2.017V.906a.473.473,0,0,1,.814-.334l3.986,4.187a.477.477,0,0,1-.34.806h-.691C14.793,5.567,14.149,5.564,13.648,5.559Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.309,7.021c-.452,0-1.05-.01-1.794-.01a3.336,3.336,0,0,1-3.309-3.336V.459A.456.456,0,0,0,9.753,0H4.464A4.489,4.489,0,0,0,0,4.509V15.284A4.692,4.692,0,0,0,4.67,20h7.877A4.476,4.476,0,0,0,17,15.5V7.471a.453.453,0,0,0-.453-.458c-.423,0-.93.008-1.239.008",
            fill: e,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M.821.147A.477.477,0,0,0,0,.481V3.118A2.026,2.026,0,0,0,2.017,5.134c.7.008,1.665.01,2.487.008a.477.477,0,0,0,.343-.808C3.792,3.237,1.9,1.271.821.147",
            transform: "translate(11.763 0.42)",
            fill: e,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M.744,6.484a.745.745,0,0,1,0-1.49H6.188a.745.745,0,0,1,0,1.49Zm0-5A.744.744,0,1,1,.744,0H4.129a.744.744,0,1,1,0,1.489Z",
            transform: "translate(4.73 7.899)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.487,0H3.834A3.82,3.82,0,0,0,0,3.729V14.442a3.827,3.827,0,0,0,3.834,3.911h7.989a3.887,3.887,0,0,0,3.729-3.911V5.276Z",
            transform: "translate(0.75 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.574,2.574,0,0,0,2.568,5.484c1.317,0,2.664,0,2.755,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M5.4.5H0",
            transform: "translate(5.387 13.058)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M3.356.5H0",
            transform: "translate(5.386 8.106)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.57,20A4.583,4.583,0,0,1,0,15.308V12.785a.752.752,0,0,1,.748-.755.752.752,0,0,1,.748.755v2.523A3.1,3.1,0,0,0,4.57,18.49h7.964a3.162,3.162,0,0,0,2.97-3.182V6.383L11.688,2.369V3.685A1.831,1.831,0,0,0,13.5,5.522a.755.755,0,0,1,0,1.51h0a3.337,3.337,0,0,1-3.307-3.348V1.522H4.57a3.078,3.078,0,0,0-3.074,3V8.681a.752.752,0,0,1-.748.755A.752.752,0,0,1,0,8.681V4.522A4.6,4.6,0,0,1,4.57.012h6.313C10.9.01,10.92,0,10.94,0s.037.01.057.012H11.2a.745.745,0,0,1,.54.233l5.049,5.312A.76.76,0,0,1,17,6.08v9.228A4.644,4.644,0,0,1,12.534,20Zm.8-5.594a.755.755,0,0,1,0-1.51h5.381a.755.755,0,0,1,0,1.51Zm0-4.986a.755.755,0,0,1,0-1.51H8.716a.755.755,0,0,1,0,1.51Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.487,0H3.834A3.82,3.82,0,0,0,0,3.729V14.442a3.827,3.827,0,0,0,3.834,3.911h7.989a3.887,3.887,0,0,0,3.729-3.911V5.276Z",
            transform: "translate(0.75 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.574,2.574,0,0,0,2.568,5.484c1.317,0,2.664,0,2.755,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M5.4.5H0",
            transform: "translate(5.387 13.058)",
            fill: "none",
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M3.356.5H0",
            transform: "translate(5.386 8.106)",
            fill: "none",
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a,
            opacity: n
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.65 2.75)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.4.5H0",
            transform: "translate(5.255 12.2)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M3.356.5H0",
            transform: "translate(5.255 8.189)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M16.51,5.55,10.84.15A18.2,18.2,0,0,0,8.39,0C2.1,0,0,2.32,0,9.25S2.1,18.5,8.39,18.5s8.4-2.31,8.4-9.25A21.045,21.045,0,0,0,16.51,5.55Z",
            transform: "translate(0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.661A3.363,3.363,0,0,0,3.364,6.024H6.315",
            transform: "translate(10.284 0.083)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$bt.displayName = "IconlyPaper", $63c37e44f569564f$var$bt.propTypes = {
    color: $63c37e44f569564f$var$Q.string,
    opacity: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$e01703dff029898a = $63c37e44f569564f$var$st($63c37e44f569564f$var$bt), $63c37e44f569564f$var$St = function(t) {
    var r = t.color, n = t.opacity, e = t.secondaryColor, a = t.strokeWidth, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.674,20A4.7,4.7,0,0,1,0,15.29V4.51A4.493,4.493,0,0,1,4.465,0H9.752a.458.458,0,0,1,.455.46V3.68a3.341,3.341,0,0,0,3.308,3.34c.423,0,.794,0,1.122.006.257,0,.481,0,.68,0,.141,0,.323,0,.521,0,.229,0,.486-.005.716-.005A.448.448,0,0,1,17,7.47v8.04A4.478,4.478,0,0,1,12.544,20Zm.455-9.01a.742.742,0,0,0,.742.74h1.7V13.46a.738.738,0,1,0,1.475,0V11.73h1.713a.745.745,0,0,0,0-1.49H9.05V8.51a.738.738,0,1,0-1.475,0v1.73h-1.7A.747.747,0,0,0,5.129,10.99Zm8.518-5.431a2.017,2.017,0,0,1-2-2.017V.906a.472.472,0,0,1,.814-.334l3.986,4.187a.477.477,0,0,1-.339.807h-.645C14.824,5.568,14.161,5.565,13.647,5.559Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.309,7.021c-.452,0-1.05-.01-1.794-.01a3.336,3.336,0,0,1-3.309-3.336V.459A.456.456,0,0,0,9.753,0H4.464A4.489,4.489,0,0,0,0,4.509V15.284A4.692,4.692,0,0,0,4.67,20h7.876A4.476,4.476,0,0,0,17,15.5V7.471a.454.454,0,0,0-.453-.458c-.422,0-.93.008-1.238.008",
            fill: e,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M.821.147A.477.477,0,0,0,0,.481V3.118A2.026,2.026,0,0,0,2.016,5.134c.7.008,1.666.01,2.488.008a.477.477,0,0,0,.343-.808C3.792,3.237,1.9,1.271.821.147",
            transform: "translate(11.763 0.42)",
            fill: e,
            opacity: n
        }), (0, $acw62.createElement)("path", {
            d: "M5.688,2.472H3.96V.745a.745.745,0,1,0-1.489,0V2.472H.744a.745.745,0,0,0,0,1.49H2.471V5.688a.745.745,0,1,0,1.489,0V3.962H5.688a.745.745,0,0,0,0-1.49",
            transform: "translate(5.179 7.764)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.486,0H3.834A3.82,3.82,0,0,0,0,3.729V14.578a3.713,3.713,0,0,0,3.834,3.775h7.988a3.769,3.769,0,0,0,3.73-3.775v-9.3Z",
            transform: "translate(0.75 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.575,2.575,0,0,0,2.569,5.484c1.316,0,2.663,0,2.754,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.9.5H0",
            transform: "translate(5.893 10.414)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5,4.9V0",
            transform: "translate(7.844 8.464)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.57,20A4.463,4.463,0,0,1,0,15.443V12.92a.752.752,0,0,1,.748-.755.752.752,0,0,1,.748.755v2.523A2.96,2.96,0,0,0,4.57,18.49h7.963A3.013,3.013,0,0,0,15.5,15.443V6.383L11.687,2.369V3.686A1.831,1.831,0,0,0,13.5,5.522a.755.755,0,0,1,0,1.509h0a3.336,3.336,0,0,1-3.308-3.346V1.522H4.57a3.078,3.078,0,0,0-3.074,3V8.816a.752.752,0,0,1-.748.755A.752.752,0,0,1,0,8.816V4.522A4.6,4.6,0,0,1,4.57.012h6.312C10.9.01,10.92,0,10.939,0s.038.01.058.012h.2a.745.745,0,0,1,.54.233l5.05,5.312A.756.756,0,0,1,17,6.08v9.364A4.518,4.518,0,0,1,12.533,20Zm3-6.544V11.744H5.875a.755.755,0,0,1,0-1.51H7.57V8.521a.748.748,0,1,1,1.5,0v1.713h1.7a.755.755,0,0,1,0,1.51h-1.7v1.712a.748.748,0,1,1-1.5,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.486,0H3.834A3.82,3.82,0,0,0,0,3.729V14.578a3.713,3.713,0,0,0,3.834,3.775h7.988a3.769,3.769,0,0,0,3.73-3.775v-9.3Z",
            transform: "translate(0.75 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.575,2.575,0,0,0,2.569,5.484c1.316,0,2.663,0,2.754,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.9.5H0",
            transform: "translate(5.893 10.414)",
            fill: "none",
            opacity: n,
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5,4.9V0",
            transform: "translate(7.844 8.464)",
            fill: "none",
            opacity: n,
            stroke: e,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.65 2.75)"
        }, (0, $acw62.createElement)("path", {
            d: "M16.51,5.55,10.84.15A18.2,18.2,0,0,0,8.39,0C2.1,0,0,2.32,0,9.25S2.1,18.5,8.39,18.5s8.4-2.31,8.4-9.25A21.045,21.045,0,0,0,16.51,5.55Z",
            transform: "translate(0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.661A3.363,3.363,0,0,0,3.364,6.024H6.315",
            transform: "translate(10.284 0.083)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.9.5H0",
            transform: "translate(5.762 9.731)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5,4.9V0",
            transform: "translate(7.713 7.781)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: a
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$St.displayName = "IconlyPaperPlus", $63c37e44f569564f$var$St.propTypes = {
    color: $63c37e44f569564f$var$Q.string,
    opacity: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$7a3a035e61089aa9 = $63c37e44f569564f$var$st($63c37e44f569564f$var$St), $63c37e44f569564f$var$Ot = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.674,20A4.7,4.7,0,0,1,0,15.29V4.51A4.493,4.493,0,0,1,4.465,0H9.752a.458.458,0,0,1,.455.46V3.68a3.341,3.341,0,0,0,3.308,3.34c.423,0,.794,0,1.122.006.257,0,.481,0,.68,0,.141,0,.323,0,.521,0,.229,0,.486-.005.716-.005A.448.448,0,0,1,17,7.47v8.04A4.478,4.478,0,0,1,12.544,20Zm.455-9.01a.742.742,0,0,0,.742.74h4.891a.745.745,0,0,0,0-1.49H5.872A.747.747,0,0,0,5.129,10.99Zm8.518-5.431a2.017,2.017,0,0,1-2-2.017V.906a.472.472,0,0,1,.814-.334l3.986,4.187a.477.477,0,0,1-.339.807h-.645C14.824,5.568,14.161,5.565,13.647,5.559Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.309,7.021c-.451,0-1.05-.01-1.794-.01a3.336,3.336,0,0,1-3.309-3.336V.459A.457.457,0,0,0,9.752,0H4.463A4.49,4.49,0,0,0,0,4.509V15.284A4.693,4.693,0,0,0,4.67,20h7.875A4.476,4.476,0,0,0,17,15.5V7.471a.454.454,0,0,0-.453-.458c-.423,0-.93.008-1.238.008",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.821.147A.477.477,0,0,0,0,.481V3.118A2.026,2.026,0,0,0,2.017,5.134c.7.008,1.665.01,2.488.008a.477.477,0,0,0,.342-.808C3.792,3.237,1.9,1.271.821.147",
            transform: "translate(11.763 0.42)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M5.688,1.489H.745A.745.745,0,1,1,.745,0H5.688a.745.745,0,1,1,0,1.489",
            transform: "translate(5.179 11.08)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.486,0H3.834A3.819,3.819,0,0,0,0,3.729V14.578a3.713,3.713,0,0,0,3.834,3.775h7.988a3.769,3.769,0,0,0,3.73-3.775v-9.3Z",
            transform: "translate(0.751 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.575,2.575,0,0,0,2.569,5.484c1.316,0,2.663,0,2.754,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.9.5H0",
            transform: "translate(5.893 11.247)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.57,20A4.463,4.463,0,0,1,0,15.443V12.92a.752.752,0,0,1,.748-.755.752.752,0,0,1,.748.755v2.523A2.96,2.96,0,0,0,4.57,18.49h7.963A3.013,3.013,0,0,0,15.5,15.443V6.383L11.687,2.369V3.686A1.831,1.831,0,0,0,13.5,5.522a.755.755,0,0,1,0,1.509h0a3.336,3.336,0,0,1-3.308-3.346V1.522H4.57a3.078,3.078,0,0,0-3.074,3V8.816a.752.752,0,0,1-.748.755A.752.752,0,0,1,0,8.816V4.522A4.6,4.6,0,0,1,4.57.012h6.312c.02,0,.037-.012.058-.012s.038.01.058.012h.2a.745.745,0,0,1,.54.233l5.05,5.312A.756.756,0,0,1,17,6.08v9.364A4.518,4.518,0,0,1,12.533,20Zm1.305-7.418a.755.755,0,0,1,0-1.51h4.886a.755.755,0,0,1,0,1.51Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.486,0H3.834A3.819,3.819,0,0,0,0,3.729V14.578a3.713,3.713,0,0,0,3.834,3.775h7.988a3.769,3.769,0,0,0,3.73-3.775v-9.3Z",
            transform: "translate(0.751 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.575,2.575,0,0,0,2.569,5.484c1.316,0,2.663,0,2.754,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.9.5H0",
            transform: "translate(5.893 11.247)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.65 2.75)"
        }, (0, $acw62.createElement)("path", {
            d: "M16.51,5.55,10.84.15A18.2,18.2,0,0,0,8.39,0C2.1,0,0,2.32,0,9.25S2.1,18.5,8.39,18.5s8.4-2.31,8.4-9.25A21.045,21.045,0,0,0,16.51,5.55Z",
            transform: "translate(0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.661A3.363,3.363,0,0,0,3.364,6.024H6.315",
            transform: "translate(10.284 0.083)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.9.5H0",
            transform: "translate(5.762 9.731)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Ot.displayName = "IconlyPaperNegative", $63c37e44f569564f$var$Ot.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$f496dcd9fa9dd77e = $63c37e44f569564f$var$st($63c37e44f569564f$var$Ot), $63c37e44f569564f$var$Nt = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.674,20A4.7,4.7,0,0,1,0,15.29V4.51A4.493,4.493,0,0,1,4.465,0H9.752a.464.464,0,0,1,.455.46V3.68a3.341,3.341,0,0,0,3.308,3.34c.418,0,.79,0,1.119.006.256,0,.48,0,.673,0,.142,0,.328,0,.528,0,.239,0,.485-.005.709-.005A.448.448,0,0,1,17,7.47v8.04A4.478,4.478,0,0,1,12.544,20ZM8.3,12.041,9.5,13.26a.735.735,0,0,0,1.049,0,.749.749,0,0,0,0-1.049L9.347,10.99l1.208-1.22a.75.75,0,0,0,0-1.05.724.724,0,0,0-1.049,0L8.3,9.94,7.089,8.72a.713.713,0,0,0-1.04,0,.75.75,0,0,0,0,1.05l1.208,1.22L6.05,12.21a.749.749,0,0,0,0,1.049.691.691,0,0,0,.515.22.711.711,0,0,0,.525-.22L8.3,12.041h0Zm5.345-6.482a2.017,2.017,0,0,1-2-2.017V.906a.472.472,0,0,1,.813-.334C13.531,1.7,15.4,3.661,16.447,4.759a.477.477,0,0,1-.341.807h-.645C14.82,5.568,14.157,5.565,13.643,5.559Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.309,7.021c-.451,0-1.05-.01-1.794-.01a3.336,3.336,0,0,1-3.309-3.336V.459A.457.457,0,0,0,9.752,0H4.463A4.49,4.49,0,0,0,0,4.509V15.284A4.693,4.693,0,0,0,4.67,20h7.875A4.476,4.476,0,0,0,17,15.5V7.471a.454.454,0,0,0-.453-.458c-.423,0-.93.008-1.238.008",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.821.147A.477.477,0,0,0,0,.481V3.118A2.026,2.026,0,0,0,2.017,5.134c.7.008,1.665.01,2.487.008a.477.477,0,0,0,.343-.808C3.792,3.237,1.9,1.271.821.147",
            transform: "translate(11.763 0.42)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M3.546,2.492,4.767,1.27A.744.744,0,0,0,3.714.218L2.493,1.438,1.272.218A.745.745,0,0,0,.218,1.27L1.44,2.492.218,3.713A.745.745,0,1,0,1.272,4.765l1.221-1.22,1.221,1.22A.744.744,0,0,0,4.767,3.713Z",
            transform: "translate(5.889 8.493)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.487,0H3.729A3.729,3.729,0,0,0,0,3.729V14.578a3.8,3.8,0,0,0,3.94,3.775h7.883a3.768,3.768,0,0,0,3.729-3.775v-9.3Z",
            transform: "translate(0.75 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.574,2.574,0,0,0,2.568,5.484c1.317,0,2.664,0,2.755,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.466,3.466,0,0",
            transform: "translate(6.61 9.182)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,3.466,3.466,0",
            transform: "translate(6.611 9.182)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.675,20A4.568,4.568,0,0,1,0,15.443V12.92a.752.752,0,0,1,.748-.755.752.752,0,0,1,.748.755v2.523A3.046,3.046,0,0,0,4.675,18.49h7.859A3.013,3.013,0,0,0,15.5,15.443V6.383L11.687,2.369V3.686A1.831,1.831,0,0,0,13.5,5.522a.755.755,0,0,1,0,1.509h0a3.336,3.336,0,0,1-3.308-3.346V1.522H4.464a2.988,2.988,0,0,0-2.968,3V8.816a.752.752,0,0,1-.748.755A.752.752,0,0,1,0,8.816V4.522A4.492,4.492,0,0,1,4.464.012h6.419C10.9.01,10.92,0,10.939,0s.038.01.058.012h.2a.745.745,0,0,1,.54.233l5.05,5.312A.756.756,0,0,1,17,6.08v9.364A4.518,4.518,0,0,1,12.533,20Zm4.843-6.733-1.2-1.21-1.2,1.21a.743.743,0,0,1-1.058,0,.762.762,0,0,1,0-1.068l1.2-1.21-1.2-1.211a.761.761,0,0,1,0-1.067.745.745,0,0,1,1.058,0l1.2,1.211,1.2-1.211a.743.743,0,0,1,1.057,0,.759.759,0,0,1,0,1.067l-1.2,1.211,1.2,1.21a.76.76,0,0,1,0,1.068.741.741,0,0,1-1.057,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.487,0H3.729A3.729,3.729,0,0,0,0,3.729V14.578a3.8,3.8,0,0,0,3.94,3.775h7.883a3.768,3.768,0,0,0,3.729-3.775v-9.3Z",
            transform: "translate(0.75 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.574,2.574,0,0,0,2.568,5.484c1.317,0,2.664,0,2.755,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M1.733,1.733,0,3.466,1.733,1.733,0,0,1.733,1.733,3.466,0,1.733,1.733,3.466,3.466Z",
            transform: "translate(6.61 9.182)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.65 2.75)"
        }, (0, $acw62.createElement)("path", {
            d: "M16.51,5.55,10.84.15A18.2,18.2,0,0,0,8.39,0C2.1,0,0,2.32,0,9.25S2.1,18.5,8.39,18.5s8.4-2.31,8.4-9.25A21.045,21.045,0,0,0,16.51,5.55Z",
            transform: "translate(0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.661A3.363,3.363,0,0,0,3.364,6.024H6.315",
            transform: "translate(10.284 0.083)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.466,3.466,0,0",
            transform: "translate(6.479 8.498)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,3.466,3.466,0",
            transform: "translate(6.48 8.498)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Nt.displayName = "IconlyPaperFail", $63c37e44f569564f$var$Nt.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$f47919df086bcc4d = $63c37e44f569564f$var$st($63c37e44f569564f$var$Nt), $63c37e44f569564f$var$Pt = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.674,20A4.7,4.7,0,0,1,0,15.29V4.51A4.493,4.493,0,0,1,4.465,0H9.752a.464.464,0,0,1,.455.46V3.68a3.341,3.341,0,0,0,3.308,3.34c.418,0,.79,0,1.119.006.256,0,.48,0,.673,0,.141,0,.323,0,.521,0,.229,0,.486-.005.716-.005A.448.448,0,0,1,17,7.47v8.04A4.478,4.478,0,0,1,12.544,20Zm.109-9.29a.755.755,0,0,0,0,1.06l2.831,2.87a.78.78,0,0,0,.238.159.7.7,0,0,0,.287.06.644.644,0,0,0,.277-.06.78.78,0,0,0,.238-.159l2.841-2.87a.747.747,0,0,0-.01-1.06.729.729,0,0,0-1.04,0l-1.574,1.6V7.49a.734.734,0,0,0-.733-.75.747.747,0,0,0-.743.75v4.82l-1.574-1.6a.729.729,0,0,0-1.04,0Zm8.86-5.151a2.017,2.017,0,0,1-2-2.017V.906a.472.472,0,0,1,.813-.334l3.987,4.187a.477.477,0,0,1-.34.807H15.46C14.819,5.568,14.156,5.565,13.642,5.559Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.309,7.021c-.451,0-1.05-.01-1.794-.01a3.336,3.336,0,0,1-3.309-3.336V.459A.457.457,0,0,0,9.752,0H4.464A4.49,4.49,0,0,0,0,4.509V15.284A4.693,4.693,0,0,0,4.67,20h7.875A4.476,4.476,0,0,0,17,15.5V7.471a.454.454,0,0,0-.453-.458c-.423,0-.93.008-1.238.008",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.821.147A.477.477,0,0,0,0,.481V3.118A2.026,2.026,0,0,0,2.016,5.134c.7.008,1.666.01,2.488.008a.477.477,0,0,0,.343-.808C3.792,3.237,1.9,1.271.821.147",
            transform: "translate(11.763 0.42)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M7,3.973a.745.745,0,0,0-1.054,0l-1.589,1.6V.745a.745.745,0,1,0-1.49,0V5.572l-1.59-1.6A.745.745,0,0,0,.216,5.026L3.079,7.9h0a.745.745,0,0,0,.24.161.757.757,0,0,0,.287.057A.741.741,0,0,0,3.9,8.062.753.753,0,0,0,4.133,7.9h0L7,5.026A.744.744,0,0,0,7,3.973",
            transform: "translate(4.61 6.736)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.486,0H3.834A3.82,3.82,0,0,0,0,3.729V14.466a3.806,3.806,0,0,0,3.834,3.887h7.988a3.867,3.867,0,0,0,3.73-3.887V5.276Z",
            transform: "translate(0.75 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.575,2.575,0,0,0,2.569,5.484c1.316,0,2.663,0,2.754,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,6.573V0",
            transform: "translate(7.641 7.441)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.838,2.851,5.677,0",
            transform: "translate(5.302 11.163)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.57,20A4.57,4.57,0,0,1,0,15.332V12.809a.748.748,0,1,1,1.5,0v2.523A3.048,3.048,0,0,0,4.57,18.49h7.963A3.11,3.11,0,0,0,15.5,15.332V6.383L11.687,2.368V3.685A1.832,1.832,0,0,0,13.5,5.522a.755.755,0,0,1,0,1.51h0a3.338,3.338,0,0,1-3.308-3.348V1.522H4.57a3.078,3.078,0,0,0-3.074,3V8.7a.752.752,0,0,1-.748.755A.752.752,0,0,1,0,8.7V4.522A4.6,4.6,0,0,1,4.57.012h6.312C10.9.01,10.92,0,10.939,0s.038.01.058.012h.2a.745.745,0,0,1,.54.233l5.05,5.312A.76.76,0,0,1,17,6.08v9.251A4.631,4.631,0,0,1,12.533,20Zm3.256-5.194a.772.772,0,0,1-.24-.163L4.756,11.772a.761.761,0,0,1,0-1.067.743.743,0,0,1,1.058,0l1.552,1.574V7.492a.748.748,0,1,1,1.5,0V12.28l1.552-1.573a.742.742,0,0,1,1.057,0,.759.759,0,0,1,0,1.067L8.646,14.643h0a.742.742,0,0,1-.816.162Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.486,0H3.834A3.82,3.82,0,0,0,0,3.729V14.466a3.806,3.806,0,0,0,3.834,3.887h7.988a3.867,3.867,0,0,0,3.73-3.887V5.276Z",
            transform: "translate(0.75 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.575,2.575,0,0,0,2.569,5.484c1.316,0,2.663,0,2.754,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,6.573V0",
            transform: "translate(7.641 7.441)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            opacity: a,
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.838,2.851,5.677,0",
            transform: "translate(5.302 11.163)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            opacity: a,
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.65 2.75)"
        }, (0, $acw62.createElement)("path", {
            d: "M16.51,5.55,10.84.15A18.2,18.2,0,0,0,8.39,0C2.1,0,0,2.32,0,9.25S2.1,18.5,8.39,18.5s8.4-2.31,8.4-9.25A21.045,21.045,0,0,0,16.51,5.55Z",
            transform: "translate(0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.661A3.363,3.363,0,0,0,3.364,6.024H6.315",
            transform: "translate(10.284 0.083)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,6.041V0",
            transform: "translate(7.51 7.226)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.345,2.355,4.69,0",
            transform: "translate(5.665 10.912)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Pt.displayName = "IconlyPaperDownload", $63c37e44f569564f$var$Pt.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$718d642b32ef9a7c = $63c37e44f569564f$var$st($63c37e44f569564f$var$Pt), $63c37e44f569564f$var$Dt = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.674,20A4.7,4.7,0,0,1,0,15.29V4.51A4.493,4.493,0,0,1,4.465,0H9.752a.464.464,0,0,1,.455.46V3.68a3.341,3.341,0,0,0,3.308,3.34c.416,0,.785,0,1.11.005.256,0,.482,0,.682,0,.141,0,.323,0,.521,0,.229,0,.486-.005.716-.005A.453.453,0,0,1,17,7.47v8.04A4.478,4.478,0,0,1,12.544,20ZM7.4,9.293V14.12a.738.738,0,1,0,1.475,0V9.29l1.574,1.6a.731.731,0,0,0,1.04,0,.739.739,0,0,0,.01-1.05L8.654,6.96A.78.78,0,0,0,8.416,6.8a.644.644,0,0,0-.277-.06.7.7,0,0,0-.287.06.78.78,0,0,0-.238.159L4.783,9.84a.748.748,0,0,0,0,1.05.731.731,0,0,0,1.04,0l1.572-1.6,0,0Zm6.246-3.733a2.018,2.018,0,0,1-2-2.017V.906a.472.472,0,0,1,.813-.334C13.53,1.7,15.4,3.661,16.445,4.759a.477.477,0,0,1-.34.806h-.691C14.787,5.567,14.144,5.564,13.642,5.559Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.309,7.021c-.452,0-1.05-.01-1.794-.01a3.336,3.336,0,0,1-3.309-3.336V.459A.456.456,0,0,0,9.753,0H4.464A4.489,4.489,0,0,0,0,4.509V15.284A4.692,4.692,0,0,0,4.67,20h7.876A4.476,4.476,0,0,0,17,15.5V7.471a.454.454,0,0,0-.453-.458c-.422,0-.93.008-1.238.008",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.821.147A.477.477,0,0,0,0,.481V3.118A2.026,2.026,0,0,0,2.016,5.134c.7.008,1.666.01,2.488.008a.477.477,0,0,0,.343-.808C3.792,3.237,1.9,1.271.821.147",
            transform: "translate(11.763 0.42)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M6.995,4.147a.745.745,0,0,1-1.054,0l-1.589-1.6V7.375a.745.745,0,1,1-1.489,0V2.548l-1.591,1.6A.745.745,0,0,1,.217,3.094L3.079.219h0a.745.745,0,0,1,.815-.16.753.753,0,0,1,.238.159s0,0,0,0L7,3.094a.744.744,0,0,1,0,1.053",
            transform: "translate(4.61 6.737)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.486,0H3.834A3.82,3.82,0,0,0,0,3.729V14.466a3.806,3.806,0,0,0,3.834,3.887h7.988a3.867,3.867,0,0,0,3.73-3.887V5.276Z",
            transform: "translate(0.75 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.575,2.575,0,0,0,2.569,5.484c1.316,0,2.663,0,2.754,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V6.573",
            transform: "translate(7.641 7.441)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.851,2.838,0,5.677,2.851",
            transform: "translate(5.302 7.44)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.57,20A4.57,4.57,0,0,1,0,15.332V12.809a.748.748,0,1,1,1.5,0v2.523A3.048,3.048,0,0,0,4.57,18.49h7.963A3.11,3.11,0,0,0,15.5,15.332V6.383L11.687,2.368V3.685A1.832,1.832,0,0,0,13.5,5.522a.755.755,0,0,1,0,1.51h0a3.338,3.338,0,0,1-3.308-3.348V1.522H4.57a3.078,3.078,0,0,0-3.074,3V8.7a.752.752,0,0,1-.748.755A.752.752,0,0,1,0,8.7V4.522A4.6,4.6,0,0,1,4.57.012h6.312C10.9.01,10.92,0,10.939,0s.038.01.058.012h.2a.745.745,0,0,1,.54.233l5.05,5.312A.76.76,0,0,1,17,6.08v9.251A4.631,4.631,0,0,1,12.533,20Zm2.8-5.89V9.319L5.816,10.895a.743.743,0,0,1-1.058,0,.762.762,0,0,1,0-1.068l2.831-2.87h0a.745.745,0,0,1,1.058,0h0l2.831,2.87a.761.761,0,0,1,0,1.068.744.744,0,0,1-1.057,0L8.863,9.319v4.791a.748.748,0,1,1-1.5,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.486,0H3.834A3.82,3.82,0,0,0,0,3.729V14.466a3.806,3.806,0,0,0,3.834,3.887h7.988a3.867,3.867,0,0,0,3.73-3.887V5.276Z",
            transform: "translate(0.75 0.762)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.909A2.575,2.575,0,0,0,2.569,5.484c1.316,0,2.663,0,2.754,0",
            transform: "translate(10.974 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V6.573",
            transform: "translate(7.641 7.441)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            opacity: a,
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.851,2.838,0,5.677,2.851",
            transform: "translate(5.302 7.44)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            opacity: a,
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.65 2.75)"
        }, (0, $acw62.createElement)("path", {
            d: "M16.51,5.55,10.84.15A18.2,18.2,0,0,0,8.39,0C2.1,0,0,2.32,0,9.25S2.1,18.5,8.39,18.5s8.4-2.31,8.4-9.25A21.045,21.045,0,0,0,16.51,5.55Z",
            transform: "translate(0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V2.661A3.363,3.363,0,0,0,3.364,6.024H6.315",
            transform: "translate(10.284 0.083)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V6.041",
            transform: "translate(7.51 7.226)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.69,2.355,2.345,0,0,2.355",
            transform: "translate(5.665 7.227)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Dt.displayName = "IconlyPaperUpload", $63c37e44f569564f$var$Dt.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$e9463168469b9532 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Dt), $63c37e44f569564f$var$qt = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M19.435.582A1.933,1.933,0,0,0,17.5.079L1.408,4.76A1.919,1.919,0,0,0,.024,6.281a2.253,2.253,0,0,0,1,2.1L6.06,11.477a1.3,1.3,0,0,0,1.61-.193l5.763-5.8a.734.734,0,0,1,1.06,0,.763.763,0,0,1,0,1.067l-5.773,5.8a1.324,1.324,0,0,0-.193,1.619L11.6,19.054A1.91,1.91,0,0,0,13.263,20a2.078,2.078,0,0,0,.25-.01A1.95,1.95,0,0,0,15.144,18.6L19.916,2.525a1.964,1.964,0,0,0-.48-1.943",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M19.427.578a1.938,1.938,0,0,0-1.93-.5L1.407,4.727A1.914,1.914,0,0,0,.024,6.238a2.235,2.235,0,0,0,1,2.09L6.057,11.4a1.308,1.308,0,0,0,1.609-.191l5.761-5.761a.735.735,0,0,1,1.06,0,.754.754,0,0,1,0,1.06L8.716,12.269a1.31,1.31,0,0,0-.193,1.609l3.074,5.05a2,2,0,0,0,1.91.929,1.944,1.944,0,0,0,1.63-1.38l4.77-15.969a1.943,1.943,0,0,0-.48-1.93",
            transform: "translate(0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M4.765,7.626a.75.75,0,0,1,0-1.06L6.13,5.2A.75.75,0,0,1,7.191,6.26L5.825,7.626a.75.75,0,0,1-1.06,0ZM3.981,3.838a.75.75,0,0,1,0-1.06L5.346,1.411A.75.75,0,0,1,6.407,2.472L5.041,3.838a.75.75,0,0,1-1.06,0ZM.22,2.645a.75.75,0,0,1,0-1.06L1.585.219A.75.75,0,0,1,2.646,1.28L1.28,2.645a.75.75,0,0,1-1.06,0Z",
            transform: "translate(0.261 11.943)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.855,5.121l-5.664,5.7L.561,6.741A1.182,1.182,0,0,1,.847,4.6L16.5.047a1.176,1.176,0,0,1,1.447,1.471L13.3,17.158a1.168,1.168,0,0,1-2.123.274l-3.989-6.61",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M11.6,19.054l-4.1-6.79a.76.76,0,0,1,.112-.926L13.434,5.48a.745.745,0,0,1,1.06,0,.759.759,0,0,1,0,1.067l-5.4,5.44,3.794,6.282a.452.452,0,0,0,.822-.105l2.322-7.816a.748.748,0,0,1,.934-.507.756.756,0,0,1,.5.94L15.144,18.6a1.933,1.933,0,0,1-1.625,1.387,1.787,1.787,0,0,1-.258.017A1.925,1.925,0,0,1,11.6,19.054ZM4.323,10.407.936,8.322a1.97,1.97,0,0,1,.477-3.567L17.5.077a1.943,1.943,0,0,1,1.93.5,1.975,1.975,0,0,1,.484,1.948l-1.249,4.2A.75.75,0,1,1,17.232,6.3l1.248-4.2a.455.455,0,0,0-.56-.57L1.83,6.206a.458.458,0,0,0-.112.828L5.1,9.118a.758.758,0,0,1,.247,1.039.747.747,0,0,1-.64.361A.735.735,0,0,1,4.323,10.407Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.821,0,0,5.821",
            transform: "translate(7.391 5.227)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M7.391,11.048.576,6.881A1.2,1.2,0,0,1,.87,4.7L16.96.049a1.2,1.2,0,0,1,1.487,1.5L13.673,17.514a1.2,1.2,0,0,1-2.182.28l-4.1-6.746",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.8 2.8)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.693,9.638S-3.283,7.161.879,4.758C4.391,2.731,16.495-.755,18.186.146c.9,1.691-2.585,13.795-4.612,17.307C11.171,21.615,8.693,9.638,8.693,9.638Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.492,9.492,0",
            transform: "translate(8.693 0.146)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$qt.displayName = "IconlySend", $63c37e44f569564f$var$qt.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$8689cbce9c2c90e9 = $63c37e44f569564f$var$st($63c37e44f569564f$var$qt), $63c37e44f569564f$var$Rt = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 1.999)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.666,20C2.277,20,0,17.623,0,14.084V5.917C0,2.378,2.277,0,5.666,0h8.669C17.724,0,20,2.378,20,5.917v8.168C20,17.623,17.723,20,14.334,20Zm7.266-9.25h1.329v1.1a.75.75,0,0,0,1.5,0V10a.751.751,0,0,0-.75-.75H9.319a2.6,2.6,0,1,0,0,1.5h2.112v1.1a.75.75,0,0,0,1.5,0v-1.1h0ZM5.739,10a1.1,1.1,0,1,1,1.1,1.1A1.1,1.1,0,0,1,5.739,10Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.334,0H5.665C2.276,0,0,2.378,0,5.917v8.167C0,17.622,2.276,20,5.665,20h8.668C17.722,20,20,17.622,20,14.084V5.917C20,2.378,17.723,0,14.334,0",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M10.78,5.2a.743.743,0,0,1-.751-.751V3.35H8.7v1.1A.751.751,0,0,1,7.95,5.2.742.742,0,0,1,7.2,4.45V3.35H5.08A2.567,2.567,0,0,1,2.61,5.2a2.6,2.6,0,1,1,0-5.2A2.566,2.566,0,0,1,5.08,1.85h5.7a.751.751,0,0,1,.75.75V4.45A.751.751,0,0,1,10.78,5.2ZM2.61,1.5a1.1,1.1,0,1,0,1.1,1.1A1.106,1.106,0,0,0,2.61,1.5Z",
            transform: "translate(4.234 7.399)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.885,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.7,1.852A1.852,1.852,0,1,1,1.851,0,1.852,1.852,0,0,1,3.7,1.852Z",
            transform: "translate(4.989 8.148)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0H6.318V1.852",
            transform: "translate(8.692 10)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,1.852V0",
            transform: "translate(11.682 10)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.953,20a.75.75,0,1,1,0-1.5h5.38c2.531,0,4.167-1.733,4.167-4.416V5.916c0-2.683-1.636-4.415-4.166-4.415H5.665C3.135,1.5,1.5,3.233,1.5,5.916v8.168c0,2.683,1.634,4.416,4.164,4.416a.75.75,0,1,1,0,1.5C2.276,20,0,17.622,0,14.084V5.916C0,2.378,2.276,0,5.665,0h8.67C17.723,0,20,2.378,20,5.916v8.168C20,17.622,17.722,20,14.333,20Zm5.306-8.149v-1.1H12.931v1.1a.75.75,0,1,1-1.5,0v-1.1H9.318A2.6,2.6,0,1,1,4.467,8.932a.75.75,0,1,1,1.368.615A1.1,1.1,0,1,0,6.84,8.9a.75.75,0,1,1,0-1.5,2.6,2.6,0,0,1,2.478,1.85H15.01a.751.751,0,0,1,.75.751v1.851a.75.75,0,1,1-1.5,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.885,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M3.7,1.852A1.852,1.852,0,1,1,1.851,0,1.852,1.852,0,0,1,3.7,1.852Z",
            transform: "translate(4.989 8.148)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0H6.318V1.852",
            transform: "translate(8.692 10)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,1.852V0",
            transform: "translate(11.682 10)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.75 2.75)"
        }, (0, $acw62.createElement)("path", {
            d: "M3.7,1.852A1.852,1.852,0,1,1,1.852,0h0A1.851,1.851,0,0,1,3.7,1.852Z",
            transform: "translate(4.235 7.398)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0H6.318V1.852",
            transform: "translate(7.942 9.25)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,1.852V0",
            transform: "translate(10.932 9.25)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.25C0,2.313,2.313,0,9.25,0S18.5,2.313,18.5,9.25,16.187,18.5,9.25,18.5,0,16.187,0,9.25Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Rt.displayName = "IconlyPassword", $63c37e44f569564f$var$Rt.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$5e47cc20a502b05f = $63c37e44f569564f$var$st($63c37e44f569564f$var$Rt), $63c37e44f569564f$var$Ft = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.454,17.721a4.445,4.445,0,0,1-.434-.394A17.665,17.665,0,0,1,10.909,12.7a4.061,4.061,0,0,1-.32-1.078V11.57a1.461,1.461,0,0,1,.779-1.288,6.515,6.515,0,0,1,1.04-.28A20.9,20.9,0,0,1,15.3,9.83a17.926,17.926,0,0,1,2.985.2,7.45,7.45,0,0,1,.835.209,1.5,1.5,0,0,1,.709.65,1.633,1.633,0,0,1,.171.732,3.875,3.875,0,0,1-.264.963,17.773,17.773,0,0,1-3.155,4.736c-.16.162-.355.337-.4.382a1.43,1.43,0,0,1-.891.3A1.363,1.363,0,0,1,14.454,17.721Zm-10.94-2.3.257-4.578a.934.934,0,1,1,1.867,0L5.9,15.417a1.191,1.191,0,1,1-2.381,0Zm-1.8-7.444A7.4,7.4,0,0,1,.88,7.764a1.491,1.491,0,0,1-.709-.65A1.62,1.62,0,0,1,0,6.384a3.943,3.943,0,0,1,.262-.963A17.762,17.762,0,0,1,3.418.685c.161-.162.355-.337.4-.383A1.433,1.433,0,0,1,4.712,0a1.368,1.368,0,0,1,.834.278,4.586,4.586,0,0,1,.435.4A17.751,17.751,0,0,1,9.091,5.3a4.108,4.108,0,0,1,.321,1.079v.047a1.464,1.464,0,0,1-.778,1.287A6.442,6.442,0,0,1,7.593,8,20.9,20.9,0,0,1,4.7,8.17,17.926,17.926,0,0,1,1.715,7.973Zm12.647-.811L14.1,2.583a1.191,1.191,0,1,1,2.381,0l-.257,4.579a.934.934,0,1,1-1.867,0Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.191,0A.941.941,0,0,0,.257.948L0,5.527A1.2,1.2,0,0,0,1.191,6.734a1.2,1.2,0,0,0,1.19-1.208L2.125.948A.941.941,0,0,0,1.191,0",
            transform: "translate(3.514 9.891)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M5.98.673a4.62,4.62,0,0,0-.434-.4A1.371,1.371,0,0,0,4.712,0a1.432,1.432,0,0,0-.893.3c-.046.046-.24.221-.4.384A17.743,17.743,0,0,0,.262,5.421,3.917,3.917,0,0,0,0,6.384a1.628,1.628,0,0,0,.171.73,1.491,1.491,0,0,0,.709.65,7.394,7.394,0,0,0,.834.209,17.975,17.975,0,0,0,2.986.2A20.868,20.868,0,0,0,7.593,8a6.358,6.358,0,0,0,1.04-.279A1.465,1.465,0,0,0,9.412,6.43V6.384A4.123,4.123,0,0,0,9.091,5.3,17.742,17.742,0,0,0,5.98.673",
            transform: "translate(0 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M1.191,6.735a.941.941,0,0,0,.934-.948l.256-4.579A1.2,1.2,0,0,0,1.191,0,1.2,1.2,0,0,0,0,1.208L.257,5.787a.941.941,0,0,0,.934.948",
            transform: "translate(14.103 1.375)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M9.241,1.056a1.5,1.5,0,0,0-.709-.65A7.457,7.457,0,0,0,7.7.2,17.975,17.975,0,0,0,4.712,0,20.868,20.868,0,0,0,1.819.173,6.484,6.484,0,0,0,.778.453,1.463,1.463,0,0,0,0,1.741v.046A4.065,4.065,0,0,0,.321,2.866,17.694,17.694,0,0,0,3.431,7.5a4.5,4.5,0,0,0,.434.394,1.361,1.361,0,0,0,.836.279,1.434,1.434,0,0,0,.892-.3c.046-.046.24-.221.4-.382A17.777,17.777,0,0,0,9.148,2.751a3.881,3.881,0,0,0,.263-.963,1.629,1.629,0,0,0-.171-.732",
            transform: "translate(10.588 9.829)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M.556,13.618V0",
            transform: "translate(14.284 3.546)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M8.156,0,4.078,4.1,0,0",
            transform: "translate(10.762 13.068)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.556,0V13.618",
            transform: "translate(4.356 0.833)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.1,4.078,0,8.156,4.1",
            transform: "translate(0.833 0.832)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.359,17.937a.834.834,0,0,1-.509-.77V3.546a.824.824,0,1,1,1.648,0v11.6l2.042-2.077a.82.82,0,0,1,1.166,0,.842.842,0,0,1,0,1.179l-3.451,3.506a.816.816,0,0,1-.9.183Zm-2.7-2.65-1.6-1.629a.841.841,0,0,1,0-1.179.817.817,0,0,1,1.165,0l1.6,1.631a.84.84,0,0,1,0,1.178.818.818,0,0,1-1.166,0Zm-7.628-.835V.833a.832.832,0,0,1,.509-.77.817.817,0,0,1,.9.182l4.033,4.1a.84.84,0,0,1,0,1.179.817.817,0,0,1-1.165,0L5.681,2.852v11.6a.824.824,0,1,1-1.648,0ZM.243,5.519a.839.839,0,0,1,0-1.178l1.6-1.63a.818.818,0,0,1,1.166,0,.842.842,0,0,1,0,1.18l-1.6,1.629a.815.815,0,0,1-1.165,0Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M.556,13.618V0",
            transform: "translate(14.284 3.546)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M8.156,0,4.078,4.1,0,0",
            transform: "translate(10.762 13.068)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.556,0V13.618",
            transform: "translate(4.356 0.833)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.1,4.078,0,8.156,4.1",
            transform: "translate(0.833 0.832)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.9 4.6)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,0V12.618",
            transform: "translate(3.579 0.001)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.1S2.169,0,4.078,0,8.156,4.1,8.156,4.1",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,12.618V0",
            transform: "translate(13.506 2.21)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M8.156,0S5.986,4.1,4.078,4.1,0,0,0,0",
            transform: "translate(9.929 10.728)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Ft.displayName = "IconlySwap", $63c37e44f569564f$var$Ft.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$bdb5f0a1b77546f4 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Ft), $63c37e44f569564f$var$Bt = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M3.972,20a3.829,3.829,0,0,1-3.8-3.847L.1,10.987a.211.211,0,0,1,.09-.172.128.128,0,0,1,.071-.02.207.207,0,0,1,.119.041,17.072,17.072,0,0,0,7,2.632.722.722,0,0,0,.1.006.753.753,0,0,0,.722-.554,1.824,1.824,0,0,1,1.78-1.377h.031a1.824,1.824,0,0,1,1.78,1.377.753.753,0,0,0,.723.554.718.718,0,0,0,.1-.006,17.072,17.072,0,0,0,7-2.632l.04-.021a.183.183,0,0,1,.08-.019.132.132,0,0,1,.07.019.211.211,0,0,1,.09.172l-.08,5.165A3.829,3.829,0,0,1,16.018,20Zm5.273-6.248v1.307a.755.755,0,0,0,.75.759.746.746,0,0,0,.751-.759V13.752a.756.756,0,0,0-.751-.76A.765.765,0,0,0,9.245,13.752Zm3.6-2.078A3.3,3.3,0,0,0,10,10.025a3.358,3.358,0,0,0-2.873,1.642.327.327,0,0,1-.276.166.286.286,0,0,1-.056-.005A15.524,15.524,0,0,1,1.171,9.56L.21,8.891a.289.289,0,0,1-.13-.243C.051,8.141,0,6.487,0,6.471A3.839,3.839,0,0,1,3.812,2.613H5.783A2.977,2.977,0,0,1,8.7,0h2.581a2.977,2.977,0,0,1,2.921,2.613h1.981A3.839,3.839,0,0,1,20,6.471c0,.009-.059.913-.08,2.154a.33.33,0,0,1-.129.256c-.471.347-.918.647-.961.669a15.328,15.328,0,0,1-5.647,2.288.3.3,0,0,1-.057.005A.325.325,0,0,1,12.848,11.674ZM7.3,2.613h5.383a1.447,1.447,0,0,0-1.4-1.093H8.7A1.448,1.448,0,0,0,7.3,2.613Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0C.05,2.338.19,6.337.21,6.778A4.651,4.651,0,0,0,1.2,9.346,3.689,3.689,0,0,0,4.292,10.71c1.856.01,3.9.01,5.889.01s3.931,0,5.566-.01a3.733,3.733,0,0,0,3.089-1.364,4.514,4.514,0,0,0,.974-2.568c.02-.371.12-4.712.18-6.778Z",
            transform: "translate(0 9.078)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,.75V2.044a.75.75,0,0,0,1.5,0V.75A.75.75,0,0,0,0,.75",
            transform: "translate(9.245 12.634)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M12.473,13.117a.749.749,0,0,1-.727-.564A1.8,1.8,0,0,0,9.99,11.2a1.826,1.826,0,0,0-1.779,1.357.754.754,0,0,1-.726.552.783.783,0,0,1-.1-.007,17.159,17.159,0,0,1-7.047-2.62A.747.747,0,0,1,0,9.855V6.389A3.817,3.817,0,0,1,3.817,2.581H5.784A2.959,2.959,0,0,1,8.7,0h2.582a2.957,2.957,0,0,1,2.92,2.581h1.977A3.812,3.812,0,0,1,19.99,6.389V9.855a.752.752,0,0,1-.336.626,17.143,17.143,0,0,1-7.078,2.629A.8.8,0,0,1,12.473,13.117ZM8.7,1.5A1.46,1.46,0,0,0,7.3,2.581h5.387a1.46,1.46,0,0,0-1.4-1.081Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0S.142,1.738.175,2.286a3.823,3.823,0,0,0,.8,2.126A2.968,2.968,0,0,0,3.486,5.507c1.237,0,10.232,0,11.469,0a2.968,2.968,0,0,0,2.509-1.095,3.832,3.832,0,0,0,.8-2.126C18.3,1.738,18.441,0,18.441,0",
            transform: "translate(0.804 13.477)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.579V2.208A2.207,2.207,0,0,1,2.208,0H4.79A2.208,2.208,0,0,1,7,2.208v.371",
            transform: "translate(6.496 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,1.294V0",
            transform: "translate(9.495 13.384)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,3.058V6.525a16.327,16.327,0,0,0,6.738,2.5,2.58,2.58,0,0,1,4.985.01A16.326,16.326,0,0,0,18.49,6.525V3.058A3.051,3.051,0,0,0,15.433,0H3.067A3.059,3.059,0,0,0,0,3.058Z",
            transform: "translate(0.75 3.331)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.78,18.985a.751.751,0,0,1,.751-.751l6.2,0a2.219,2.219,0,0,0,1.932-.823,3.11,3.11,0,0,0,.633-1.693c.031-.553.185-2.3.185-2.3a.743.743,0,0,1,1.484.058c0,.023-.141,1.789-.173,2.334a4.569,4.569,0,0,1-.974,2.561,3.733,3.733,0,0,1-3.085,1.365l-6.2,0A.75.75,0,0,1,8.78,18.985Zm-4.52.748a3.73,3.73,0,0,1-3.086-1.366A4.557,4.557,0,0,1,.2,15.806C.168,15.262.027,13.5.027,13.473a.743.743,0,0,1,1.484-.057s.154,1.749.187,2.3a3.091,3.091,0,0,0,.631,1.692,2.217,2.217,0,0,0,1.933.824H5.4a.75.75,0,1,1,0,1.5Zm4.984-5.055V13.383a.75.75,0,0,1,1.5,0v1.294a.75.75,0,1,1-1.5,0Zm2.5-2.126A1.8,1.8,0,0,0,9.99,11.2a1.828,1.828,0,0,0-1.779,1.356.748.748,0,0,1-.716.554.763.763,0,0,1-.111-.008A17.148,17.148,0,0,1,.337,10.481.75.75,0,0,1,0,9.855V6.388A3.817,3.817,0,0,1,3.817,2.581H5.77A2.964,2.964,0,0,1,8.7,0h2.582A2.964,2.964,0,0,1,14.22,2.581h1.963A3.812,3.812,0,0,1,19.99,6.388V9.855a.752.752,0,0,1-.336.626,17.158,17.158,0,0,1-7.078,2.629.761.761,0,0,1-.1.006A.749.749,0,0,1,11.746,12.551Zm1.213-1.02A15.725,15.725,0,0,0,18.49,9.445V6.388a2.31,2.31,0,0,0-2.307-2.308H10a.75.75,0,1,1,0-1.5h2.7A1.462,1.462,0,0,0,11.286,1.5H8.7A1.46,1.46,0,0,0,7.245,2.958v.37a.748.748,0,0,1-.75.751l-2.678,0A2.315,2.315,0,0,0,1.5,6.388V9.445a15.673,15.673,0,0,0,5.511,2.078A3.336,3.336,0,0,1,9.99,9.7,3.288,3.288,0,0,1,12.959,11.532Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0S.142,1.738.175,2.286a3.823,3.823,0,0,0,.8,2.126A2.968,2.968,0,0,0,3.486,5.507c1.237,0,10.232,0,11.469,0a2.968,2.968,0,0,0,2.509-1.095,3.832,3.832,0,0,0,.8-2.126C18.3,1.738,18.441,0,18.441,0",
            transform: "translate(0.804 13.477)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.579V2.208A2.207,2.207,0,0,1,2.208,0H4.79A2.208,2.208,0,0,1,7,2.208v.371",
            transform: "translate(6.496 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,1.294V0",
            transform: "translate(9.495 13.384)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,3.058V6.525a16.327,16.327,0,0,0,6.738,2.5,2.58,2.58,0,0,1,4.985.01A16.326,16.326,0,0,0,18.49,6.525V3.058A3.051,3.051,0,0,0,15.433,0H3.067A3.059,3.059,0,0,0,0,3.058Z",
            transform: "translate(0.75 3.331)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.75 2.45)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,2.628V0",
            transform: "translate(8.711 11.439)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M18.257,0l-.029.021a17.52,17.52,0,0,1-9.1,2.393A17.48,17.48,0,0,1,.03.021L0,0",
            transform: "translate(0.082 9.027)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,8.2C0,2.051,2.3,0,9.211,0s9.211,2.051,9.211,8.2-2.3,8.2-9.211,8.2S0,14.355,0,8.2Z",
            transform: "translate(0 2.697)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M6.525,2.919v-.63A2.184,2.184,0,0,0,4.465,0H2.06A2.184,2.184,0,0,0,0,2.289v.63",
            transform: "translate(5.949 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Bt.displayName = "IconlyWork", $63c37e44f569564f$var$Bt.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$66faccf4f494e531 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Bt), $63c37e44f569564f$var$Jt = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.6,18a.747.747,0,1,1,0-1.493h1.593a2.44,2.44,0,0,0,2.462-2.414v-3.56H16.032v.992a2.269,2.269,0,0,1-2.27,2.266H8.238a2.269,2.269,0,0,1-2.269-2.266v-.992H3.346V14.1A2.437,2.437,0,0,0,5.8,16.506H7.428a.747.747,0,1,1,0,1.493H5.8a3.946,3.946,0,0,1-3.974-3.9V10.534H.762a.746.746,0,1,1,0-1.492H21.239a.746.746,0,1,1,0,1.492H20.177v3.56A3.95,3.95,0,0,1,16.194,18ZM6.24,7.523a.278.278,0,0,1-.27-.269V6.008A2.268,2.268,0,0,1,8.239,3.743h5.524a2.26,2.26,0,0,1,2.27,2.265V7.254a.28.28,0,0,1-.273.269Zm12.415-1.76V3.906a2.44,2.44,0,0,0-2.461-2.413H14.6a.754.754,0,0,1-.761-.745A.755.755,0,0,1,14.6,0h1.593a3.948,3.948,0,0,1,3.983,3.906V5.763a.761.761,0,0,1-1.522,0Zm-16.831,0V3.9A3.945,3.945,0,0,1,5.8,0h1.63a.755.755,0,0,1,.761.747.753.753,0,0,1-.761.746H5.8A2.436,2.436,0,0,0,3.347,3.9V5.762a.762.762,0,0,1-1.524,0Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.415,7.523a.279.279,0,0,1-.27-.269V6.008a2.269,2.269,0,0,1,2.27-2.265h5.523a2.26,2.26,0,0,1,2.271,2.265V7.254a.281.281,0,0,1-.274.269Zm12.416-1.76V3.906A2.44,2.44,0,0,0,14.37,1.493H12.777a.754.754,0,0,1-.761-.745A.755.755,0,0,1,12.777,0H14.37a3.948,3.948,0,0,1,3.983,3.906V5.763a.761.761,0,0,1-1.522,0ZM0,5.762V3.9A3.945,3.945,0,0,1,3.974,0H5.6a.754.754,0,0,1,.76.747.753.753,0,0,1-.76.746H3.975A2.436,2.436,0,0,0,1.523,3.9V5.762a.755.755,0,0,1-.761.747A.755.755,0,0,1,0,5.762Z",
            transform: "translate(1.824 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M21.239,0H.762A.755.755,0,0,0,0,.747a.754.754,0,0,0,.762.745H1.823V5.056A3.946,3.946,0,0,0,5.8,8.958H7.427a.747.747,0,1,0,0-1.493H5.8A2.436,2.436,0,0,1,3.346,5.056V1.492H5.969v.991A2.269,2.269,0,0,0,8.238,4.75h5.524a2.269,2.269,0,0,0,2.27-2.266V1.492h2.623v3.56a2.44,2.44,0,0,1-2.461,2.413H14.6a.747.747,0,1,0,0,1.493h1.593a3.949,3.949,0,0,0,3.983-3.907V1.492h1.062A.753.753,0,0,0,22,.747.754.754,0,0,0,21.239,0",
            transform: "translate(0 9.041)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1.5 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M21.132.524H0",
            transform: "translate(0 8.991)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.969,5.278V3.325A3.335,3.335,0,0,0,1.644,0H0",
            transform: "translate(14.281 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,5.278V3.321A3.32,3.32,0,0,1,3.317,0H5",
            transform: "translate(1.882 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.969,0V4.531A3.335,3.335,0,0,1,1.644,7.856H0",
            transform: "translate(14.281 9.514)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V4.535a3.32,3.32,0,0,0,3.317,3.32H5",
            transform: "translate(1.882 9.514)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.6,18a.747.747,0,1,1,0-1.493h1.593a2.44,2.44,0,0,0,2.462-2.414V10.535H3.346V14.1A2.437,2.437,0,0,0,5.8,16.506H7.428a.747.747,0,1,1,0,1.493H5.8a3.947,3.947,0,0,1-3.975-3.9V10.535H.761a.747.747,0,1,1,0-1.493H21.239a.747.747,0,1,1,0,1.493H20.177v3.559A3.95,3.95,0,0,1,16.194,18ZM9.142,14.267a.747.747,0,1,1,0-1.493h3.717a.747.747,0,1,1,0,1.493Zm0-7.757a.747.747,0,1,1,0-1.494h3.717a.747.747,0,1,1,0,1.494ZM1.823,5.762V3.9A3.945,3.945,0,0,1,5.8,0h1.63a.755.755,0,0,1,.761.747.753.753,0,0,1-.761.746H5.8A2.436,2.436,0,0,0,3.347,3.9V5.762a.762.762,0,0,1-1.524,0Zm16.832,0V3.906a2.441,2.441,0,0,0-2.462-2.413H14.6a.753.753,0,0,1-.76-.746A.753.753,0,0,1,14.6,0h1.593a3.949,3.949,0,0,1,3.983,3.905V5.763a.761.761,0,0,1-1.522,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1.5 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M21.132.524H0",
            transform: "translate(0 8.991)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.969,5.278V3.325A3.335,3.335,0,0,0,1.644,0H0",
            transform: "translate(14.281 0)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,5.278V3.321A3.32,3.32,0,0,1,3.317,0H5",
            transform: "translate(1.882 0)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.969,0V4.531A3.335,3.335,0,0,1,1.644,7.856H0",
            transform: "translate(14.281 9.514)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V4.535a3.32,3.32,0,0,0,3.317,3.32H5",
            transform: "translate(1.882 9.514)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1.45 2.95)"
        }, (0, $acw62.createElement)("path", {
            d: "M21.132.5H0",
            transform: "translate(0 9.35)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,5.77C.57,2.29,2.29.57,5.77,0",
            transform: "translate(1.546 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M5.981,8.186C2.5,7.606.781,5.9.211,2.416v0A17.035,17.035,0,0,1,0,0",
            transform: "translate(1.335 9.854)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M5.979,0a17.183,17.183,0,0,1-.21,2.42l0,0C5.2,5.9,3.48,7.606,0,8.186",
            transform: "translate(13.816 9.854)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0C3.48.57,5.2,2.29,5.77,5.77",
            transform: "translate(13.816 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Jt.displayName = "IconlyScan", $63c37e44f569564f$var$Jt.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$f2b7c70641756fd4 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Jt), $63c37e44f569564f$var$Qt = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.4,20a5.469,5.469,0,0,1-3.976-1.428A5.474,5.474,0,0,1,0,14.6V7.2A5.5,5.5,0,0,1,1.425,3.215,5.455,5.455,0,0,1,5.4,1.78H13.45a4.858,4.858,0,0,0-.059.75A4.069,4.069,0,0,0,17.45,6.6a4.668,4.668,0,0,0,.74-.068V14.6a5.47,5.47,0,0,1-1.425,3.973A5.466,5.466,0,0,1,12.79,20ZM7.19,8.96a.781.781,0,0,0-.5.3L3.731,13.11l-.061.09a.747.747,0,0,0,.21.95.832.832,0,0,0,.46.15h.026A.715.715,0,0,0,4.93,14l2.51-3.231,2.849,2.141.09.058a.749.749,0,0,0,.95-.21l2.89-3.729-.04.02A.75.75,0,0,0,14.26,8.3a.736.736,0,0,0-.608-.439c-.028,0-.056,0-.084,0a.768.768,0,0,0-.617.314L10.531,11.3,7.76,9.121a.783.783,0,0,0-.481-.165C7.25,8.956,7.22,8.958,7.19,8.96Zm7.99-6.55a2.41,2.41,0,1,1,2.41,2.41A2.411,2.411,0,0,1,15.18,2.41Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.662,18H5.346A5.415,5.415,0,0,1,1.41,16.588,5.4,5.4,0,0,1,0,12.661V5.356A5.428,5.428,0,0,1,1.41,1.42,5.4,5.4,0,0,1,5.346,0h7.967a3.909,3.909,0,0,0-.07.738A4.029,4.029,0,0,0,17.27,4.759a4.142,4.142,0,0,0,.73-.07v7.972a5.405,5.405,0,0,1-1.409,3.927A5.4,5.4,0,0,1,12.662,18ZM7.222,7.079a.752.752,0,0,0-.1.006.741.741,0,0,0-.493.29L3.676,11.186a.728.728,0,0,0-.158.457.739.739,0,0,0,1.363.43l2.47-3.2,2.743,2.152a.747.747,0,0,0,.464.163.741.741,0,0,0,.592-.3l2.858-3.687V7.191a.75.75,0,0,0-.14-1.045.73.73,0,0,0-1.038.149L10.42,9.4,7.677,7.235A.742.742,0,0,0,7.222,7.079Z",
            transform: "translate(0 2)",
            fill: r
        }), (0, $acw62.createElement)("circle", {
            cx: "2.5",
            cy: "2.5",
            r: "2.5",
            transform: "translate(15)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 1.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,4.989,2.993,1.1,6.407,3.78,9.336,0",
            transform: "translate(5.245 8.293)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("circle", {
            cx: "1.922",
            cy: "1.922",
            r: "1.922",
            transform: "translate(16.073 0.778)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.146,0H4.879C1.867,0,0,2.133,0,5.144v8.082c0,3.011,1.831,5.135,4.879,5.135h8.6c3.011,0,4.879-2.124,4.879-5.135V6.188",
            transform: "translate(0.778 1.62)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.305,20a.741.741,0,0,1-.743-.732.751.751,0,0,1,.743-.741h2.952c2.925,0,4.542-1.6,4.568-4.532V7.522a.729.729,0,1,1,1.459,0v6.473c0,3.7-2.316,6-6.027,6ZM0,13.995v-7.2C0,3.078,2.307.776,6.018.776h6.505a.743.743,0,0,1,.733.741.734.734,0,0,1-.742.733h-6.5c-2.925,0-4.542,1.614-4.542,4.541v7.2c0,2.928,1.617,4.532,4.542,4.532a.75.75,0,0,1,.743.741A.741.741,0,0,1,6.018,20C2.307,20,0,17.7,0,13.995Zm4.648-.608a.741.741,0,0,1-.132-1.032L7.406,8.6a.745.745,0,0,1,1.043-.132l2.713,2.126,2.387-3.043A.733.733,0,0,1,14.7,8.43l-2.828,3.642a.789.789,0,0,1-.5.282.742.742,0,0,1-.539-.158L8.122,10.071,5.683,13.236a.737.737,0,0,1-.592.3A.737.737,0,0,1,4.648,13.387ZM14.8,2.6a2.6,2.6,0,1,1,2.6,2.583A2.585,2.585,0,0,1,14.8,2.6Zm1.476,0A1.122,1.122,0,1,0,17.4,1.481,1.122,1.122,0,0,0,16.279,2.6Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 1.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,4.989,2.993,1.1,6.407,3.78,9.336,0",
            transform: "translate(5.245 8.293)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("circle", {
            cx: "1.922",
            cy: "1.922",
            r: "1.922",
            transform: "translate(16.073 0.778)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.146,0H4.879C1.867,0,0,2.133,0,5.144v8.082c0,3.011,1.831,5.135,4.879,5.135h8.6c3.011,0,4.879-2.124,4.879-5.135V6.188",
            transform: "translate(0.778 1.62)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.45 2.35)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,4.989,2.993,1.1,6.407,3.78,9.336,0",
            transform: "translate(4.468 7.515)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M1.922,0A1.922,1.922,0,1,1,0,1.922,1.921,1.921,0,0,1,1.922,0Z",
            transform: "translate(15.296 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M18.306,6.216A20.809,20.809,0,0,1,18.5,9.25c0,6.938-2.312,9.25-9.25,9.25S0,16.188,0,9.25,2.313,0,9.25,0a20.931,20.931,0,0,1,2.983.187",
            transform: "translate(0 0.703)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Qt.displayName = "IconlyActivity", $63c37e44f569564f$var$Qt.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$9c16c1426311996d = $63c37e44f569564f$var$st($63c37e44f569564f$var$Qt), $63c37e44f569564f$var$Xt = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.152,20H5.141A5.152,5.152,0,0,1,1.4,18.619,5.139,5.139,0,0,1,.011,14.88L0,6.553a5.089,5.089,0,0,1,1.219-3.5A4.939,4.939,0,0,1,4.506,1.53V.78a.773.773,0,0,1,.22-.553.766.766,0,0,1,1.3.552v.7l5.865-.008V.77a.77.77,0,0,1,.218-.552.766.766,0,0,1,1.3.55v.75a4.966,4.966,0,0,1,3.321,1.487A4.993,4.993,0,0,1,17.989,6.49L18,14.916c0,3.125-1.961,5.07-5.128,5.074Zm7.891-5.808a.833.833,0,0,0-.809.851.83.83,0,1,0,.819-.851Zm-8.126,0h0a.851.851,0,0,0-.808.86.823.823,0,0,0,.811.8h.039a.809.809,0,0,0,.565-.265.821.821,0,0,0,.215-.6.813.813,0,0,0-.819-.8Zm4.068-.005h0a.855.855,0,0,0-.808.861.823.823,0,0,0,.814.8h.036a.823.823,0,0,0,.779-.861.813.813,0,0,0-.819-.8ZM4.912,10.594h0a.851.851,0,0,0-.808.86.821.821,0,0,0,.812.8h.039a.806.806,0,0,0,.563-.265.823.823,0,0,0,.214-.6.812.812,0,0,0-.818-.8Zm4.069-.035h0a.851.851,0,0,0-.809.86.823.823,0,0,0,.815.8h.036a.825.825,0,0,0,.778-.861.813.813,0,0,0-.818-.8Zm4.07.006h0a.826.826,0,0,0-.808.839v.012a.813.813,0,0,0,.821.8h.019a.825.825,0,0,0-.028-1.649ZM4.508,3.058c-1.985.2-2.991,1.375-2.988,3.493l0,.311,14.948-.02v-.35C16.428,4.379,15.4,3.22,13.414,3.047v.77a.764.764,0,0,1-1.3.547.773.773,0,0,1-.217-.545V3.01l-5.865.008,0,.808a.765.765,0,0,1-1.3.547.773.773,0,0,1-.217-.546v-.77Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.127,12.743A4.776,4.776,0,0,1,0,7.613V0H18V7.674c0,3.138-1.976,5.069-5.137,5.069Z",
            transform: "translate(0 7.257)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M0,5.767A15.855,15.855,0,0,1,.155,3.64,4.591,4.591,0,0,1,4.541,0h8.911a4.639,4.639,0,0,1,4.386,3.64,15.892,15.892,0,0,1,.154,2.127Z",
            transform: "translate(0.003 1.49)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.761,4.59a.747.747,0,0,0,.761-.77V.771A.748.748,0,0,0,.761,0,.748.748,0,0,0,0,.771V3.82a.747.747,0,0,0,.761.77",
            transform: "translate(4.544 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M.761,4.59a.753.753,0,0,0,.761-.77V.771A.754.754,0,0,0,.761,0,.748.748,0,0,0,0,.771V3.82a.747.747,0,0,0,.761.77",
            transform: "translate(11.934 0)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,.473H17.824",
            transform: "translate(0.093 6.931)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.459.473H.468",
            transform: "translate(12.984 10.837)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.459.473H.468",
            transform: "translate(8.546 10.837)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.459.473H.468",
            transform: "translate(4.099 10.837)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.459.473H.468",
            transform: "translate(12.984 14.723)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.459.473H.468",
            transform: "translate(8.546 14.723)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.459.473H.468",
            transform: "translate(4.099 14.723)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.463,0V3.291",
            transform: "translate(12.581 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.463,0V3.291",
            transform: "translate(4.502 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M13.238,0H4.771C1.834,0,0,1.636,0,4.643v9.05c0,3.054,1.834,4.728,4.771,4.728h8.458c2.946,0,4.771-1.645,4.771-4.652V4.643C18.009,1.636,16.184,0,13.238,0Z",
            transform: "translate(0 1.579)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.626,20C1.9,20,0,18.311,0,14.985V6.715A4.542,4.542,0,0,1,2.07,2.469.685.685,0,0,1,2.8,2.442a.713.713,0,0,1-.071,1.265A3.143,3.143,0,0,0,1.374,6.715V6.98H14.061a.7.7,0,0,1,0,1.4H1.374v6.608c0,2.538,1.235,3.591,4.252,3.609h6.748c2.974,0,4.243-1.079,4.243-3.618V6.706c0-2.211-.966-3.282-3.165-3.539v.672a.694.694,0,0,1-1.382-.053V.673a.7.7,0,0,1,.222-.49.677.677,0,0,1,.5-.183.712.712,0,0,1,.661.734V1.77C16.461,2.062,18,3.725,18,6.715v8.27C18,18.311,16.1,20,12.374,20Zm6.7-4.918a.877.877,0,0,1,.869-.885h-.009a.863.863,0,0,1,.621.256.894.894,0,0,1,.257.629.87.87,0,1,1-1.739,0Zm-4.174,0a.87.87,0,1,1,.869.885A.877.877,0,0,1,8.148,15.082Zm-4.165,0a.877.877,0,0,1,.869-.885H4.844a.861.861,0,0,1,.62.256.89.89,0,0,1,.257.629.87.87,0,1,1-1.739,0ZM12.322,11.5a.877.877,0,0,1,.869-.884h-.009a.859.859,0,0,1,.621.256.893.893,0,0,1,.257.628.87.87,0,1,1-1.739,0Zm-4.174,0a.87.87,0,1,1,.869.885A.877.877,0,0,1,8.148,11.5Zm-4.165,0a.877.877,0,0,1,.869-.884H4.844a.857.857,0,0,1,.62.256.889.889,0,0,1,.257.628.87.87,0,1,1-1.739,0Zm1.235-7a.694.694,0,0,1-.67-.708V.735a.694.694,0,0,1,1.382,0V1.7H9.861a.7.7,0,0,1,0,1.4H5.913v.7a.706.706,0,0,1-.2.5.683.683,0,0,1-.485.2Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,.473H17.824",
            transform: "translate(0.093 6.931)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M9.343,4.36h.009Zm-4.438,0h.01Zm-4.446,0H.468ZM9.343.473h.009Zm-4.438,0h.01ZM.459.473H.468Z",
            transform: "translate(4.099 10.837)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.463,0V3.291",
            transform: "translate(12.581 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.463,0V3.291",
            transform: "translate(4.502 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M13.238,0H4.771C1.834,0,0,1.636,0,4.643v9.05c0,3.054,1.834,4.728,4.771,4.728h8.458c2.946,0,4.771-1.645,4.771-4.652V4.643C18.009,1.636,16.184,0,13.238,0Z",
            transform: "translate(0 1.579)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.75 2.05)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.274C0,2.318,2.319,0,9.274,0s9.275,2.318,9.275,9.274-2.319,9.274-9.275,9.274S0,16.23,0,9.274Z",
            transform: "translate(0 1.452)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.5H18.008",
            transform: "translate(0.275 6.774)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(13.183 10.711)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(8.784 10.711)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(4.376 10.711)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(13.183 14.563)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(8.784 14.563)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(4.376 14.563)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V3.262",
            transform: "translate(12.783 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V3.262",
            transform: "translate(4.775 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Xt.displayName = "IconlyCalendar", $63c37e44f569564f$var$Xt.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$e1aef45b828286de = $63c37e44f569564f$var$st($63c37e44f569564f$var$Xt), $63c37e44f569564f$var$rr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.939,18H5.06A5.061,5.061,0,0,1,0,12.95V5.05A5.061,5.061,0,0,1,5.06,0h9.879a5.091,5.091,0,0,1,3.58,1.481A5.012,5.012,0,0,1,20,5.05v7.9A5.061,5.061,0,0,1,14.939,18ZM4.034,5.246A.733.733,0,0,0,3.5,5.47a.764.764,0,0,0-.071,1l.131.13L8.11,10.15a3.129,3.129,0,0,0,1.95.68,3.18,3.18,0,0,0,1.958-.68L16.53,6.54l.08-.08a.774.774,0,0,0-.012-1,.831.831,0,0,0-.528-.26h-.042a.76.76,0,0,0-.519.2L11,9a1.565,1.565,0,0,1-1,.36A1.592,1.592,0,0,1,9,9L4.5,5.4A.778.778,0,0,0,4.034,5.246Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", null, (0, $acw62.createElement)("path", {
            d: "M20,7.143a5.047,5.047,0,0,1-5.03,5.06H5.05A5.047,5.047,0,0,1,0,7.163v-.01S.006,2.727.014.5A.5.5,0,0,1,.822.109C3.2,1.994,7.447,5.431,7.5,5.476a4.067,4.067,0,0,0,2.53.89,4.013,4.013,0,0,0,2.53-.9C12.613,5.43,16.767,2.1,19.179.18a.5.5,0,0,1,.811.39C20,2.779,20,7.143,20,7.143",
            transform: "translate(2 8.797)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M18.973,2.674A5.035,5.035,0,0,0,14.527,0H4.547A5.035,5.035,0,0,0,.1,2.674.864.864,0,0,0,.322,3.752L7.747,9.691a2.826,2.826,0,0,0,1.78.629h.02a2.826,2.826,0,0,0,1.78-.629l7.425-5.939a.864.864,0,0,0,.221-1.078",
            transform: "translate(2.503 3)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M11.314,0,7.048,3.434a2.223,2.223,0,0,1-2.746,0L0,0",
            transform: "translate(3.954 5.561)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.888,0h9.428A4.957,4.957,0,0,1,17.9,1.59a5.017,5.017,0,0,1,1.326,3.7v6.528a5.017,5.017,0,0,1-1.326,3.7,4.957,4.957,0,0,1-3.58,1.59H4.888C1.968,17.116,0,14.741,0,11.822V5.294C0,2.375,1.968,0,4.888,0Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.8,18A5.832,5.832,0,0,1,0,12.155V5.845A5.824,5.824,0,0,1,5.8,0h8.4A5.842,5.842,0,0,1,20,5.845V7.307a.71.71,0,0,1-.707.713L19.283,8a.705.705,0,0,1-.5-.209.716.716,0,0,1-.207-.5V5.845A4.439,4.439,0,0,0,14.2,1.435H5.8A4.44,4.44,0,0,0,1.424,5.845v6.309A4.44,4.44,0,0,0,5.8,16.565h8.4a4.439,4.439,0,0,0,4.378-4.411.716.716,0,0,1,1.424,0A5.842,5.842,0,0,1,14.2,18ZM8.05,9.98,3.928,6.656a.725.725,0,0,1-.106-1.007.7.7,0,0,1,.991-.107L8.969,8.858a1.425,1.425,0,0,0,1.769,0l4.113-3.316h.009a.711.711,0,1,1,.885,1.114L11.632,9.98a2.84,2.84,0,0,1-3.582,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M11.314,0,7.048,3.434a2.223,2.223,0,0,1-2.746,0L0,0",
            transform: "translate(3.954 5.561)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.888,0h9.428A4.957,4.957,0,0,1,17.9,1.59a5.017,5.017,0,0,1,1.326,3.7v6.528a5.017,5.017,0,0,1-1.326,3.7,4.957,4.957,0,0,1-3.58,1.59H4.888C1.968,17.116,0,14.741,0,11.822V5.294C0,2.375,1.968,0,4.888,0Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.452 2.852)"
        }, (0, $acw62.createElement)("path", {
            d: "M11.151,0S7.941,3.853,5.593,3.853,0,0,0,0",
            transform: "translate(3.942 6.167)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.117C0,2.279,2.381,0,9.524,0s9.524,2.279,9.524,9.117-2.381,9.117-9.524,9.117S0,15.954,0,9.117Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$rr.displayName = "IconlyMessage", $63c37e44f569564f$var$rr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$f69c19e57285b83a = $63c37e44f569564f$var$st($63c37e44f569564f$var$rr), $63c37e44f569564f$var$er = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.113,15A3.91,3.91,0,0,1,0,10.939V4.061A3.91,3.91,0,0,1,4.113,0H9.905a3.91,3.91,0,0,1,4.113,4.061v6.879A3.91,3.91,0,0,1,9.905,15Zm13.844-2.38-1.48-.747a1.624,1.624,0,0,1-.888-1.457V4.583a1.618,1.618,0,0,1,.888-1.455l1.481-.749a1.384,1.384,0,0,1,1.373.064A1.432,1.432,0,0,1,20,3.662v7.676a1.43,1.43,0,0,1-.669,1.219,1.4,1.4,0,0,1-.743.216A1.384,1.384,0,0,1,17.957,12.621Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 5)"
        }, (0, $acw62.createElement)("path", {
            d: "M3.743.216A1.383,1.383,0,0,0,2.37.152L.888.9A1.618,1.618,0,0,0,0,2.356V8.19A1.622,1.622,0,0,0,.888,9.647l1.481.747A1.372,1.372,0,0,0,3,10.547a1.4,1.4,0,0,0,.743-.216,1.429,1.429,0,0,0,.669-1.218V1.435A1.432,1.432,0,0,0,3.743.216",
            transform: "translate(15.588 2.226)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M9.905,15H4.113A3.91,3.91,0,0,1,0,10.939V4.061A3.91,3.91,0,0,1,4.113,0H9.905a3.91,3.91,0,0,1,4.113,4.061v6.878A3.91,3.91,0,0,1,9.905,15",
            transform: "translate(0 0)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1.8 4.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.266,10.37a3.272,3.272,0,0,1-3.53,3.4H3.519A3.265,3.265,0,0,1,0,10.37V3.41A3.275,3.275,0,0,1,3.53,0H9.736a3.28,3.28,0,0,1,3.53,3.41Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,3.582,4.1.228a1,1,0,0,1,1.637.777V7.877A1,1,0,0,1,4.1,8.654L0,5.3",
            transform: "translate(14.016 3.194)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M19.02,2.569a1.686,1.686,0,0,0-1.813.223l-1.575,1.3a.741.741,0,0,0-.1,1.037.73.73,0,0,0,1.03.1l1.575-1.3a.234.234,0,0,1,.259-.031.241.241,0,0,1,.142.226v6.749a.241.241,0,0,1-.142.226.234.234,0,0,1-.26-.031L14.406,7.995V4.087A3.953,3.953,0,0,0,10.23,0H4.176A3.953,3.953,0,0,0,0,4.087v6.836A3.944,3.944,0,0,0,4.166,15a.737.737,0,0,0,0-1.473,2.462,2.462,0,0,1-2.7-2.6V4.087A2.471,2.471,0,0,1,4.176,1.473H10.23a2.471,2.471,0,0,1,2.712,2.614v6.836a2.467,2.467,0,0,1-2.712,2.6H8.543a.737.737,0,0,0,0,1.473H10.23a3.949,3.949,0,0,0,4.176-4.076V9.9l2.8,2.309a1.684,1.684,0,0,0,1.076.391A1.721,1.721,0,0,0,20,10.875V4.125a1.709,1.709,0,0,0-.98-1.557",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1.8 4.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,3.582,4.1.228a1,1,0,0,1,1.637.777V7.877A1,1,0,0,1,4.1,8.654L0,5.3",
            transform: "translate(14.016 3.194)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M13.266,10.37a3.272,3.272,0,0,1-3.53,3.4H3.519A3.265,3.265,0,0,1,0,10.37V3.41A3.275,3.275,0,0,1,3.53,0H9.736a3.28,3.28,0,0,1,3.53,3.41Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.514 5.114)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,2.466C1.838,1.009,4.3-.4,4.771.1c.771.829.7,8.714,0,9.467-.429.467-2.914-.943-4.771-2.39",
            transform: "translate(13.637 2.092)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,6.923C0,1.73,1.725,0,6.9,0s6.9,1.73,6.9,6.923-1.725,6.923-6.9,6.923S0,12.114,0,6.923Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$er.displayName = "IconlyVideo", $63c37e44f569564f$var$er.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$ae01dedf5c052bb = $63c37e44f569564f$var$st($63c37e44f569564f$var$er), $63c37e44f569564f$var$ar = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.67,20H5.33a5.349,5.349,0,0,1-3.944-1.394A5.356,5.356,0,0,1,0,14.67V5.33A5.358,5.358,0,0,1,1.386,1.386,5.358,5.358,0,0,1,5.33,0h9.33a5.372,5.372,0,0,1,3.945,1.386A5.345,5.345,0,0,1,20,5.33v9.34C20,18.057,18.057,20,14.67,20ZM6.33,9.16a.819.819,0,0,0-.83.83.839.839,0,0,0,.83.84H9.16V13.66a.83.83,0,1,0,1.66,0V10.83h2.84a.835.835,0,0,0,0-1.669H10.82V6.34a.83.83,0,1,0-1.66,0V9.16Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.667,0H5.333C1.929,0,0,1.929,0,5.333v9.333C0,18.062,1.92,20,5.333,20h9.333C18.071,20,20,18.062,20,14.667V5.333C20,1.929,18.071,0,14.667,0Z",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M7.32,4.708H4.75V7.257a.75.75,0,0,1-1.5,0V4.708H.68a.75.75,0,0,1,0-1.494H3.242V.674a.758.758,0,0,1,1.507,0V3.214H7.32a.75.75,0,0,1,0,1.494Z",
            transform: "translate(6 6)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.476,0V7.326",
            transform: "translate(9.524 6.327)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.333.476H0",
            transform: "translate(6.333 9.515)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M14.686,0H5.314C2.048,0,0,2.312,0,5.585v8.83C0,17.688,2.038,20,5.314,20h9.371C17.962,20,20,17.688,20,14.415V5.585C20,2.312,17.962,0,14.686,0Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.253,20C2.392,20,0,17.608,0,13.756v-7.5C0,2.392,2.392,0,6.253,0h7.5C17.59,0,20,2.392,20,6.253V8.822a.756.756,0,0,1-.765.756V9.56a.764.764,0,0,1-.765-.765V6.253C18.47,3.2,16.8,1.53,13.756,1.53h-7.5C3.21,1.53,1.53,3.21,1.53,6.253v7.5c0,3.034,1.68,4.714,4.723,4.714h7.5c3.043,0,4.714-1.68,4.714-4.714a.765.765,0,1,1,1.53,0C20,17.608,17.608,20,13.756,20Zm3.765-5.857a.774.774,0,0,1-.739-.792v-.967a.765.765,0,1,1,1.53.053V13.4a.764.764,0,0,1-.764.739Zm3.4-3.588H6.658a.817.817,0,0,1-.792-.774.756.756,0,0,1,.757-.765H9.261v-2.4a.783.783,0,0,1,.774-.765.758.758,0,0,1,.225.034.766.766,0,0,1,.567.74V9.015h2.6a.772.772,0,0,1,.792.774.766.766,0,0,1-.748.765Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.476,0V7.326",
            transform: "translate(9.524 6.327)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M7.333.476H0",
            transform: "translate(6.333 9.515)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M14.686,0H5.314C2.048,0,0,2.312,0,5.585v8.83C0,17.688,2.038,20,5.314,20h9.371C17.962,20,20,17.688,20,14.415V5.585C20,2.312,17.962,0,14.686,0Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.3 2.3)"
        }, (0, $acw62.createElement)("path", {
            d: "M.526,0V7.148",
            transform: "translate(9.211 6.163)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.156.526H0",
            transform: "translate(6.159 9.211)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.737C0,2.435,2.435,0,9.737,0s9.737,2.435,9.737,9.737-2.435,9.737-9.737,9.737S0,17.039,0,9.737Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$ar.displayName = "IconlyPlus", $63c37e44f569564f$var$ar.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$2d9ac7aa84f97a08 = $63c37e44f569564f$var$st($63c37e44f569564f$var$ar), $63c37e44f569564f$var$ir = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.669,20H5.33a5.352,5.352,0,0,1-3.94-1.39A5.353,5.353,0,0,1,0,14.67V5.33a5.353,5.353,0,0,1,1.389-3.94A5.353,5.353,0,0,1,5.33,0h9.339a5.345,5.345,0,0,1,3.937,1.389A5.38,5.38,0,0,1,20,5.33v9.34a5.352,5.352,0,0,1-1.39,3.94A5.354,5.354,0,0,1,14.669,20Zm-.02-9.087a.865.865,0,0,0-.449.128.807.807,0,0,0-.38.789v3.28a.826.826,0,0,0,.83.75.843.843,0,0,0,.83-.75V11.83a.839.839,0,0,0-.391-.789A.823.823,0,0,0,14.649,10.913ZM10.051,4a.823.823,0,0,0-.44.128.847.847,0,0,0-.392.79V15.11a.843.843,0,0,0,.831.75.827.827,0,0,0,.83-.75V4.92a.816.816,0,0,0-.379-.79A.872.872,0,0,0,10.051,4ZM5.39,7.282a.822.822,0,0,0-.44.128.843.843,0,0,0-.39.79v6.91a.834.834,0,0,0,1.659,0V8.2a.845.845,0,0,0-.389-.79A.825.825,0,0,0,5.39,7.282Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.676,0H5.333C1.929,0,0,1.929,0,5.333v9.333C0,18.071,1.929,20,5.333,20h9.342C18.08,20,20,18.071,20,14.667V5.333C20,1.929,18.08,0,14.676,0",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.827,0A.833.833,0,0,0,0,.836V7.707a.831.831,0,0,0,1.662,0V.836A.835.835,0,0,0,.827,0",
            transform: "translate(4.542 7.369)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M.827,0A.833.833,0,0,0,0,.836V10.987a.831.831,0,0,0,1.662,0V.836A.835.835,0,0,0,.827,0",
            transform: "translate(9.209 4.089)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M.836,0A.835.835,0,0,0,0,.836V4.08a.831.831,0,0,0,1.662,0V.836A.833.833,0,0,0,.836,0",
            transform: "translate(13.804 10.996)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.476,0V6.86",
            transform: "translate(4.895 8.202)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.476,0V10.143",
            transform: "translate(9.562 4.919)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.476,0V3.235",
            transform: "translate(14.152 11.827)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M14.686,0H5.314C2.048,0,0,2.312,0,5.585v8.83C0,17.688,2.038,20,5.314,20h9.371C17.962,20,20,17.688,20,14.415V5.585C20,2.312,17.962,0,14.686,0Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.253,20C2.392,20,0,17.608,0,13.756v-7.5C0,2.392,2.392,0,6.253,0h7.493C17.59,0,20,2.392,20,6.253V8.575a.764.764,0,0,1-.765.765h-.009a.756.756,0,0,1-.756-.774V6.253c0-3.043-1.68-4.723-4.723-4.723H6.253C3.2,1.53,1.53,3.21,1.53,6.253v7.5c0,3.043,1.68,4.714,4.723,4.714h7.493c3.052,0,4.723-1.68,4.723-4.714a.765.765,0,1,1,1.53,0C20,17.608,17.608,20,13.756,20ZM5.7,15.479a.765.765,0,0,1-.738-.791v-6.4a.757.757,0,0,1,.791-.731.766.766,0,0,1,.739.792V14.74a.765.765,0,0,1-.765.739ZM9.27,14.7V5.321a.765.765,0,1,1,1.53,0V14.7a.765.765,0,1,1-1.53,0Zm4.239-.009V11.7a.765.765,0,0,1,1.531,0v2.991a.765.765,0,0,1-1.531,0ZM9.27,5.277v.044Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.476,0V6.86",
            transform: "translate(4.895 8.202)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.476,0V10.143",
            transform: "translate(9.562 4.919)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.476,0V3.235",
            transform: "translate(14.152 11.827)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M14.686,0H5.314C2.048,0,0,2.312,0,5.585v8.83C0,17.688,2.038,20,5.314,20h9.371C17.962,20,20,17.688,20,14.415V5.585C20,2.312,17.962,0,14.686,0Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.3 2.3)"
        }, (0, $acw62.createElement)("path", {
            d: "M.526,0V6.694",
            transform: "translate(4.657 7.961)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.526,0V9.9",
            transform: "translate(9.211 4.757)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.526,0V3.157",
            transform: "translate(13.689 11.498)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.737C0,2.435,2.435,0,9.737,0s9.737,2.435,9.737,9.737-2.435,9.737-9.737,9.737S0,17.039,0,9.737Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$ir.displayName = "IconlyChart", $63c37e44f569564f$var$ir.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$acaa6426d77a227e = $63c37e44f569564f$var$st($63c37e44f569564f$var$ir), $63c37e44f569564f$var$ur = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.01,20c-1.6,0-2.909-.012-4.122-.039A5.643,5.643,0,0,1,0,14.181V9.875A5.648,5.648,0,0,1,5.9,4.094C7.1,4.076,8.47,4.056,9.833,4.056V3.892a1.217,1.217,0,0,0-1.227-1.2H7.635A1.991,1.991,0,0,1,5.623.723.739.739,0,0,1,6.359,0,.73.73,0,0,1,7.1.723a.531.531,0,0,0,.539.52h.972a2.7,2.7,0,0,1,2.7,2.64v.183c.6,0,1.213.008,1.8.016l1,.012A5.644,5.644,0,0,1,20,9.875v4.307a5.643,5.643,0,0,1-5.888,5.78C12.9,19.987,11.6,20,10.01,20Zm-4.7-8.7a.739.739,0,0,0-.736.723.73.73,0,0,0,.736.723h1.04v1.021a.73.73,0,0,0,.736.722.738.738,0,0,0,.735-.722V12.746h1.03a.73.73,0,0,0,.736-.723.739.739,0,0,0-.736-.723H7.821V10.289a.736.736,0,0,0-1.472,0V11.3ZM14.7,12.986a.73.73,0,0,0-.736.723.722.722,0,0,0,.736.723h.1a.73.73,0,0,0,.736-.723.739.739,0,0,0-.736-.723ZM13.023,9.672a.73.73,0,0,0-.736.723.722.722,0,0,0,.736.723h.1a.723.723,0,1,0,0-1.445Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.682,3.882v.183c-.491-.01-.981-.01-1.472-.01V3.892a1.222,1.222,0,0,0-1.227-1.2H2.012A1.994,1.994,0,0,1,0,.723.735.735,0,0,1,.736,0a.728.728,0,0,1,.736.723.532.532,0,0,0,.54.52h.972a2.7,2.7,0,0,1,2.7,2.64",
            transform: "translate(5.623 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M10.01,15.944c-1.54,0-2.888-.013-4.122-.039A5.644,5.644,0,0,1,0,10.125V5.819A5.648,5.648,0,0,1,5.9.039C7.223.018,8.521,0,9.833,0c.482,0,.981,0,1.472.01.629,0,1.27.009,1.889.017l.918.012A5.643,5.643,0,0,1,20,5.819v4.306a5.644,5.644,0,0,1-5.888,5.781C12.878,15.932,11.536,15.944,10.01,15.944Zm-4.7-8.7a.739.739,0,0,0-.736.722.73.73,0,0,0,.736.723h1.04V9.711a.736.736,0,0,0,1.472,0V8.69h1.03a.73.73,0,0,0,.736-.723.739.739,0,0,0-.736-.722H7.821V6.233a.736.736,0,0,0-1.472,0V7.245ZM14.7,8.931a.73.73,0,0,0-.736.723.721.721,0,0,0,.736.722h.1a.73.73,0,0,0,.736-.722.739.739,0,0,0-.736-.723ZM13.023,5.617a.73.73,0,0,0-.736.722.722.722,0,0,0,.736.723h.1a.73.73,0,0,0,.735-.723.738.738,0,0,0-.735-.722Z",
            transform: "translate(0 4.056)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.53,0V3.745",
            transform: "translate(6.318 10.314)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.821.519H0",
            transform: "translate(4.938 11.667)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.583.519H.476",
            transform: "translate(12.783 9.909)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.583.519H.476",
            transform: "translate(14.596 13.483)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0H0A1.355,1.355,0,0,0,1.368,1.341H2.424A2.1,2.1,0,0,1,4.54,3.413v.675",
            transform: "translate(6.072 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M14.428,15.589q-4.508.076-8.856,0A5.34,5.34,0,0,1,0,10.138V5.488A5.34,5.34,0,0,1,5.573.037q4.374-.075,8.856,0A5.34,5.34,0,0,1,20,5.488v4.65A5.339,5.339,0,0,1,14.428,15.589Z",
            transform: "translate(0 4.373)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.871,19.962A5.646,5.646,0,0,1,.005,14.55C0,14.426,0,14.3,0,14.18V9.87A5.668,5.668,0,0,1,5.541,4.1c.122,0,.246,0,.371.005H9.871v-.23A1.255,1.255,0,0,0,8.617,2.643h-1a2.058,2.058,0,0,1-1.383-.562A1.948,1.948,0,0,1,5.649.7.7.7,0,0,1,6.34,0h.008a.7.7,0,0,1,.7.691.552.552,0,0,0,.169.4.558.558,0,0,0,.391.161H8.621a2.656,2.656,0,0,1,2.646,2.616V4.8a.7.7,0,0,1-.7.7H5.882c-.122,0-.216-.006-.308,0A4.273,4.273,0,0,0,1.4,9.854v4.34c0,.109,0,.2,0,.3a4.262,4.262,0,0,0,4.452,4.077c2.718.046,5.481.046,8.256,0,.134,0,.228.006.321,0A4.268,4.268,0,0,0,18.6,14.209V9.87c0-.111,0-.2,0-.3A4.265,4.265,0,0,0,14.128,5.5.7.7,0,0,1,14.11,4.1,5.744,5.744,0,0,1,20,9.516c.005.124.006.248,0,.372v4.306a5.661,5.661,0,0,1-5.537,5.771c-.122,0-.247,0-.372,0-1.378.025-2.763.036-4.142.036S7.212,19.986,5.871,19.962Zm1.205-5.474a.759.759,0,0,1-.753-.756v-1H5.314a.763.763,0,0,1-.728-.35.752.752,0,0,1,0-.8.763.763,0,0,1,.728-.35H6.323v-.994a.762.762,0,0,1,1.524,0v.994H8.855a.763.763,0,0,1,.728.35.752.752,0,0,1,0,.8.763.763,0,0,1-.728.35H7.846v1a.769.769,0,0,1-.762.756Zm7.1-.247a.744.744,0,0,1,0-1.055.766.766,0,0,1,.823-.167.964.964,0,0,1,.248.167.744.744,0,0,1-.005,1.055.758.758,0,0,1-1.062,0Zm-1.7-3.341a.725.725,0,0,1,0-1.064.68.68,0,0,1,.239-.167.745.745,0,0,1,.567,0,.9.9,0,0,1,.257.167.764.764,0,0,1,.168.818.61.61,0,0,1-.168.246.772.772,0,0,1-1.062,0Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.53,0V3.745",
            transform: "translate(6.318 10.314)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.821.519H0",
            transform: "translate(4.938 11.667)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.583.519H.476",
            transform: "translate(12.783 9.909)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.583.519H.476",
            transform: "translate(14.596 13.483)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0H0A1.355,1.355,0,0,0,1.368,1.341H2.424A2.1,2.1,0,0,1,4.54,3.413v.675",
            transform: "translate(6.072 0)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M14.428,15.589q-4.508.076-8.856,0A5.34,5.34,0,0,1,0,10.138V5.488A5.34,5.34,0,0,1,5.573.037q4.374-.075,8.856,0A5.34,5.34,0,0,1,20,5.488v4.65A5.339,5.339,0,0,1,14.428,15.589Z",
            transform: "translate(0 4.373)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 1.977)"
        }, (0, $acw62.createElement)("path", {
            d: "M.477,0V3.575",
            transform: "translate(6.777 10.085)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.648.477H0",
            transform: "translate(5.432 11.395)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.528.477h-.1",
            transform: "translate(12.949 9.716)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.528.477h-.1",
            transform: "translate(14.68 13.128)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0H0A1.293,1.293,0,0,0,1.306,1.28H2.314a2.005,2.005,0,0,1,2.02,1.978V4.265",
            transform: "translate(6.514 0.239)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M19.1,7.414C19.1,1.854,16.709,0,9.549,0S0,1.854,0,7.414s2.387,7.414,9.549,7.414S19.1,12.975,19.1,7.414Z",
            transform: "translate(0.716 4.504)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$ur.displayName = "IconlyGame", $63c37e44f569564f$var$ur.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$985739bfa5723e08 = $63c37e44f569564f$var$st($63c37e44f569564f$var$ur), $63c37e44f569564f$var$kr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.159,20H4.868c-1.88,0-3.175-.438-3.958-1.338C.091,17.72-.172,16.3.105,14.314L.883,8.12A4.081,4.081,0,0,1,2.076,5.708,2.736,2.736,0,0,1,3.932,5H4.01a.679.679,0,0,1,0-.226,5,5,0,0,1,9.991,0h-.026A.517.517,0,0,1,13.93,5h.157a2.668,2.668,0,0,1,1.827.731,4.388,4.388,0,0,1,1.23,2.389l.769,6.195a5.133,5.133,0,0,1-.906,4.23A4.914,4.914,0,0,1,13.159,20ZM11.885,8.33a.91.91,0,1,0,.884.909A.9.9,0,0,0,11.885,8.33ZM6.1,8.33a.91.91,0,1,0,.884.909A.9.9,0,0,0,6.1,8.33ZM8.966,1.3A3.482,3.482,0,0,0,5.482,4.774a.633.633,0,0,1,0,.226h7.011a.653.653,0,0,1-.043-.226A3.482,3.482,0,0,0,8.966,1.3Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.159,15H4.868c-1.88,0-3.175-.438-3.958-1.339C.091,12.72-.172,11.3.105,9.315L.883,3.12A4.083,4.083,0,0,1,2.076.707,2.736,2.736,0,0,1,3.932,0H14.087a2.667,2.667,0,0,1,1.827.731,4.391,4.391,0,0,1,1.23,2.389l.769,6.195a5.132,5.132,0,0,1-.906,4.23A4.914,4.914,0,0,1,13.159,15ZM11.885,3.329a.91.91,0,1,0,.884.91A.9.9,0,0,0,11.885,3.329Zm-5.789,0a.91.91,0,1,0,.884.91A.9.9,0,0,0,6.1,3.329Z",
            transform: "translate(0 5)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M9.974,4.774A.5.5,0,0,1,9.93,5H8.493a.649.649,0,0,1-.044-.226,3.484,3.484,0,0,0-6.968,0,.649.649,0,0,1,0,.226H.01a.649.649,0,0,1,0-.226,5,5,0,0,1,9.99,0Z",
            transform: "translate(4)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 1.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.213,14.682H4.865C1.8,14.682-.554,13.574.114,9.117L.892,3.076C1.3.851,2.723,0,3.968,0H14.146c1.263,0,2.6.915,3.076,3.076L18,9.117C18.567,13.071,16.279,14.682,13.213,14.682Z",
            transform: "translate(0.801 5.318)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M8.659,4.32A4.32,4.32,0,0,0,4.339,0h0A4.32,4.32,0,0,0,0,4.32H0",
            transform: "translate(5.492 0.778)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.481.458H.435",
            transform: "translate(12.316 9.144)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.481.458H.435",
            transform: "translate(6.485 9.144)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.2,18.287A4.93,4.93,0,0,1,.183,13.739a.768.768,0,1,1,1.52.22,4.064,4.064,0,0,0,.659,3.323,4.2,4.2,0,0,0,3.172,1.142h8.012c1.59,0,2.688-.334,3.259-1.028a4.4,4.4,0,0,0,.572-3.437l-.747-5.81c-.264-1.407-1.081-2.286-2.187-2.286h-9.8c-1.054,0-1.871.879-2.2,2.347L2.23,9.5A.773.773,0,0,1,.71,9.238L.93,7.919c.58-2.681,2.293-3.56,3.707-3.56h8.24a3.438,3.438,0,0,0-1.089-2.021A3.372,3.372,0,0,0,7.026,2.6v.088A.774.774,0,0,1,5.893,1.634a4.919,4.919,0,0,1,8.548,2.724c1.475,0,3.224.879,3.707,3.516l.755,5.872a5.789,5.789,0,0,1-.967,4.659c-.878,1.046-2.318,1.556-4.392,1.556h-8A4.924,4.924,0,0,1,1.2,18.287Zm10.813-8.258a.881.881,0,0,1-.387-.483.735.735,0,0,1-.061-.334.58.58,0,0,1,0-.176V8.869l.087-.149a.388.388,0,0,1,.106-.132l.131-.114a.686.686,0,0,1,.158-.079.6.6,0,0,1,.167-.052.761.761,0,0,1,.343,0,1.12,1.12,0,0,1,.325.131,1.259,1.259,0,0,1,.238.247.346.346,0,0,1,.078.149.522.522,0,0,1,.053.167.58.58,0,0,1,0,.176.738.738,0,0,1-.07.334.7.7,0,0,1-.211.29.882.882,0,0,1-.616.264A1.063,1.063,0,0,1,12.008,10.029ZM6.166,9.835a.871.871,0,0,1-.194-.29.883.883,0,0,1-.062-.334.58.58,0,0,1,0-.176.522.522,0,0,1,.053-.167.5.5,0,0,1,.079-.149.4.4,0,0,1,.105-.132.593.593,0,0,1,.131-.105A.5.5,0,0,1,6.429,8.4.543.543,0,0,1,6.6,8.349a.761.761,0,0,1,.343,0,.545.545,0,0,1,.167.053.5.5,0,0,1,.149.079A.592.592,0,0,1,7.4,8.6a.4.4,0,0,1,.105.131.865.865,0,0,1,.088.15l.052.166a.953.953,0,0,1,0,.176.857.857,0,0,1-1.475.616Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 1.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.213,14.682H4.865C1.8,14.682-.554,13.574.114,9.117L.892,3.076C1.3.851,2.723,0,3.968,0H14.146c1.263,0,2.6.915,3.076,3.076L18,9.117C18.567,13.071,16.279,14.682,13.213,14.682Z",
            transform: "translate(0.801 5.318)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M8.659,4.32A4.32,4.32,0,0,0,4.339,0h0A4.32,4.32,0,0,0,0,4.32H0",
            transform: "translate(5.492 0.778)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.481.458H.435",
            transform: "translate(12.316 9.144)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.481.458H.435",
            transform: "translate(6.485 9.144)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.95 2.55)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.659,4.32A4.33,4.33,0,0,0,0,4.3V4.32",
            transform: "translate(4.755 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.523.5H.477",
            transform: "translate(11.5 8.324)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.523.5H.477",
            transform: "translate(5.669 8.324)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M9.084,14.934c-6.508,0-7.257-2.05-8.718-7.467C-1.1,2.033,1.841,0,9.084,0S19.268,2.033,17.8,7.467C16.341,12.884,15.592,14.934,9.084,14.934Z",
            transform: "translate(0 4.006)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$kr.displayName = "IconlyBag", $63c37e44f569564f$var$kr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$9570723381ca8f3b = $63c37e44f569564f$var$st($63c37e44f569564f$var$kr), $63c37e44f569564f$var$fr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.123,20H4.877A4.945,4.945,0,0,1,0,15V9.48A4.95,4.95,0,0,1,4.877,4.47h.2A4.577,4.577,0,0,1,6.388,1.31,4.44,4.44,0,0,1,9.509,0a4.324,4.324,0,0,1,3.1,1.309A4.56,4.56,0,0,1,13.918,4.47h.2A4.95,4.95,0,0,1,19,9.48V15A4.945,4.945,0,0,1,14.123,20ZM13.207,5.66a.742.742,0,0,0-.732.75V7.57a.732.732,0,1,0,1.463,0V6.41A.742.742,0,0,0,13.207,5.66Zm-7.5,0a.751.751,0,0,0-.732.75V7.57a.732.732,0,1,0,1.463,0V6.41A.742.742,0,0,0,5.706,5.66Zm3.8-4.16a2.979,2.979,0,0,0-2.1.879A3.092,3.092,0,0,0,6.545,4.47h5.91A3,3,0,0,0,9.509,1.5Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.12,15H4.88A4.863,4.863,0,0,1,0,10.165V4.835A4.863,4.863,0,0,1,4.88,0H14.12A4.863,4.863,0,0,1,19,4.835v5.329A4.863,4.863,0,0,1,14.12,15",
            transform: "translate(0 5)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M8.255,8a.734.734,0,0,1-.745-.722V4.357a2.961,2.961,0,0,0-3-2.912,3.131,3.131,0,0,0-2.13.843A2.847,2.847,0,0,0,1.49,4.343V7.278A.734.734,0,0,1,.745,8,.734.734,0,0,1,0,7.278V4.357A4.27,4.27,0,0,1,1.33,1.263,4.641,4.641,0,0,1,4.512,0,4.43,4.43,0,0,1,9,4.357V7.278A.734.734,0,0,1,8.255,8",
            transform: "translate(5)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.562,6.805V3.773A3.781,3.781,0,0,0,0,3.756V6.805",
            transform: "translate(5.211 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M13.742,14.026H4.258A4.256,4.256,0,0,1,0,9.771V4.255A4.256,4.256,0,0,1,4.258,0h9.484A4.256,4.256,0,0,1,18,4.255V9.771A4.256,4.256,0,0,1,13.742,14.026Z",
            transform: "translate(0 4.474)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.12,4.474h-.207A4.467,4.467,0,0,0,9.512,0,4.35,4.35,0,0,0,6.387,1.311a4.558,4.558,0,0,0-1.3,3.163H4.88A4.949,4.949,0,0,0,0,9.479v5.516A4.949,4.949,0,0,0,4.88,20a.75.75,0,0,0,0-1.5,3.466,3.466,0,0,1-3.417-3.505V9.479A3.466,3.466,0,0,1,4.88,5.974h.2V7.555a.732.732,0,1,0,1.463,0V4.509a3.043,3.043,0,0,1,.872-2.134A3.127,3.127,0,0,1,9.509,1.5a2.985,2.985,0,0,1,2.942,2.974h-3.2a.75.75,0,0,0,0,1.5h3.2V7.555a.732.732,0,1,0,1.463,0V5.974h.2a3.466,3.466,0,0,1,3.417,3.505v5.516A3.466,3.466,0,0,1,14.12,18.5H8.863a.75.75,0,0,0,0,1.5H14.12A4.949,4.949,0,0,0,19,14.995V9.479a4.949,4.949,0,0,0-4.88-5.005",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.562,6.805V3.773A3.781,3.781,0,0,0,0,3.756V6.805",
            transform: "translate(5.211 0)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M13.742,14.026H4.258A4.256,4.256,0,0,1,0,9.771V4.255A4.256,4.256,0,0,1,4.258,0h9.484A4.256,4.256,0,0,1,18,4.255V9.771A4.256,4.256,0,0,1,13.742,14.026Z",
            transform: "translate(0 4.474)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.95 2.65)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.562,6.822V3.79A3.781,3.781,0,1,0,0,3.773V6.822",
            transform: "translate(5.238 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,7.059C0,1.765,2.255,0,9.019,0s9.019,1.765,9.019,7.059-2.255,7.058-9.019,7.058S0,12.352,0,7.059Z",
            transform: "translate(0 4.499)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$fr.displayName = "IconlyBag2", $63c37e44f569564f$var$fr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$c061a17fad15d938 = $63c37e44f569564f$var$st($63c37e44f569564f$var$fr), $63c37e44f569564f$var$mr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.858,18H4.143A4.128,4.128,0,0,1,0,13.9V11.219a.747.747,0,0,1,.75-.743A1.484,1.484,0,0,0,2.24,9,1.411,1.411,0,0,0,.75,7.612.748.748,0,0,1,0,6.869L0,4.1A4.128,4.128,0,0,1,4.144,0H15.856A4.129,4.129,0,0,1,20,4.1V6.782a.745.745,0,0,1-.75.743,1.475,1.475,0,1,0,0,2.95.747.747,0,0,1,.75.743V13.9A4.128,4.128,0,0,1,15.858,18ZM10,11.27h0l1.455.757a.751.751,0,0,0,.349.088.741.741,0,0,0,.726-.859l-.279-1.608L13.431,8.51a.72.72,0,0,0,.187-.753.729.729,0,0,0-.6-.5l-1.629-.236-.729-1.463a.743.743,0,0,0-1.327,0L8.608,7.025,6.982,7.26a.736.736,0,0,0-.6.5.723.723,0,0,0,.187.753L7.748,9.648,7.47,11.256a.727.727,0,0,0,.3.718.741.741,0,0,0,.777.055L10,11.27Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M19.25,10.476a1.476,1.476,0,1,1,0-2.952.754.754,0,0,0,.53-.217A.741.741,0,0,0,20,6.781V4.1A4.129,4.129,0,0,0,15.856,0H4.144A4.129,4.129,0,0,0,0,4.1V6.868a.741.741,0,0,0,.22.526.754.754,0,0,0,.53.217A1.41,1.41,0,0,1,2.239,9,1.484,1.484,0,0,1,.75,10.476.747.747,0,0,0,0,11.22v2.675A4.129,4.129,0,0,0,4.143,18H15.857A4.129,4.129,0,0,0,20,13.895V11.22a.747.747,0,0,0-.75-.743",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M7.086,3.388,5.907,4.536l.279,1.623a.741.741,0,0,1-1.076.779L3.655,6.173,2.2,6.939a.739.739,0,0,1-1.072-.78L1.4,4.536.224,3.388A.739.739,0,0,1,.637,2.126l1.626-.237L2.992.412A.738.738,0,0,1,3.655,0h0a.736.736,0,0,1,.662.413l.729,1.476,1.629.238a.739.739,0,0,1,.409,1.261",
            transform: "translate(6.344 5.201)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.107,16.667A3.392,3.392,0,0,0,18.5,13.274v-2.7a2.239,2.239,0,1,1,0-4.478l0-2.7A3.392,3.392,0,0,0,15.106,0H3.394A3.393,3.393,0,0,0,0,3.393v2.79A2.163,2.163,0,0,1,2.239,8.335,2.236,2.236,0,0,1,0,10.574v2.7a3.392,3.392,0,0,0,3.392,3.393Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.205,5.179l1.74.915a.223.223,0,0,0,.323-.234L4.935,3.921,6.344,2.55a.222.222,0,0,0-.123-.379L4.275,1.888,3.4.124a.222.222,0,0,0-.4,0L2.135,1.888.19,2.171a.222.222,0,0,0-.123.379L1.475,3.921,1.142,5.86a.223.223,0,0,0,.323.234l1.74-.915Z",
            transform: "translate(6.794 5.676)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.4,18a.743.743,0,1,1,0-1.486h5.463A2.634,2.634,0,0,0,18.5,13.9V11.868a2.956,2.956,0,0,1,0-5.735l0-2.029a2.634,2.634,0,0,0-2.642-2.619H4.144A2.634,2.634,0,0,0,1.5,4.1V6.213A2.863,2.863,0,0,1,3.739,9,2.969,2.969,0,0,1,1.5,11.868V13.9a2.634,2.634,0,0,0,2.642,2.619h1.79a.743.743,0,1,1,0,1.486H4.143A4.128,4.128,0,0,1,0,13.9V11.219a.747.747,0,0,1,.75-.743A1.484,1.484,0,0,0,2.239,9,1.409,1.409,0,0,0,.75,7.612a.749.749,0,0,1-.53-.219A.741.741,0,0,1,0,6.869L0,4.1A4.128,4.128,0,0,1,4.144,0H15.856A4.129,4.129,0,0,1,20,4.1V6.782a.744.744,0,0,1-.22.526.752.752,0,0,1-.53.218,1.475,1.475,0,1,0,0,2.95.747.747,0,0,1,.75.743V13.9A4.128,4.128,0,0,1,15.858,18ZM7.571,12.808a1.007,1.007,0,0,1-.385-.977l.276-1.653L6.294,9.005a1.013,1.013,0,0,1-.246-1.023A.97.97,0,0,1,6.832,7.3l1.612-.242.723-1.506a.958.958,0,0,1,1.738,0L11.691,7.1a.775.775,0,0,1-.312,1.031.716.716,0,0,1-.563.053.743.743,0,0,1-.436-.373l-.331-.649L9.6,8.1a.74.74,0,0,1-.558.418l-.968.145.7.706a.775.775,0,0,1,.213.675l-.166.994.868-.469a.719.719,0,0,1,.689,0l.868.469-.165-.994a.777.777,0,0,1,.212-.676l1.446-1.452a.689.689,0,0,1,.524-.216.727.727,0,0,1,.525.23.776.776,0,0,1-.014,1.078l-1.167,1.173.276,1.653a1,1,0,0,1-.386.977.945.945,0,0,1-1.022.075L10.034,12.1l-1.443.779A.928.928,0,0,1,8.14,13,.946.946,0,0,1,7.571,12.808Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.107,16.667A3.392,3.392,0,0,0,18.5,13.274v-2.7a2.239,2.239,0,1,1,0-4.478l0-2.7A3.392,3.392,0,0,0,15.106,0H3.394A3.393,3.393,0,0,0,0,3.393v2.79A2.163,2.163,0,0,1,2.239,8.335,2.236,2.236,0,0,1,0,10.574v2.7a3.392,3.392,0,0,0,3.392,3.393Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.205,5.179l1.74.915a.223.223,0,0,0,.323-.234L4.935,3.921,6.344,2.55a.222.222,0,0,0-.123-.379L4.275,1.888,3.4.124a.222.222,0,0,0-.4,0L2.135,1.888.19,2.171a.222.222,0,0,0-.123.379L1.475,3.921,1.142,5.86a.223.223,0,0,0,.323.234l1.74-.915Z",
            transform: "translate(6.794 5.676)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.65 3.411)"
        }, (0, $acw62.createElement)("path", {
            d: "M18.79,10.583c-2.661,0-2.661-4.114,0-4.114C18.79,1.7,18.79,0,9.4,0S0,1.7,0,6.469c2.661,0,2.661,4.114,0,4.114,0,4.768,0,6.47,9.4,6.47S18.79,15.351,18.79,10.583Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.018,0C2.335,0,2.27,1.089,1.864,1.475S.194,1.42.018,2.1s.962.916,1.1,1.5S.567,5.016,1.16,5.427s1.233-.518,1.858-.518,1.264.927,1.858.518-.1-1.235.039-1.822,1.278-.819,1.1-1.5S4.579,1.86,4.172,1.475,3.7,0,3.018,0Z",
            transform: "translate(6.377 5.76)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$mr.displayName = "IconlyTicketStar", $63c37e44f569564f$var$mr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$98055a51547a6dad = $63c37e44f569564f$var$st($63c37e44f569564f$var$mr), $63c37e44f569564f$var$Mr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,20A10,10,0,0,1,2.926,2.93,10,10,0,1,1,10,20ZM14.48,8.8A1.2,1.2,0,1,0,15.67,10,1.2,1.2,0,0,0,14.48,8.8ZM10,8.8A1.2,1.2,0,1,0,11.19,10,1.2,1.2,0,0,0,10,8.8Zm-4.48,0A1.2,1.2,0,1,0,6.71,10,1.2,1.2,0,0,0,5.52,8.8Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", null, (0, $acw62.createElement)("path", {
            d: "M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10",
            transform: "translate(2 2)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M8.959,1.2a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,8.959,1.2Zm-4.479,0a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,4.479,1.2ZM0,1.2a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,0,1.2Z",
            transform: "translate(6.323 10.804)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.25,0A9.25,9.25,0,1,1,0,9.25,9.251,9.251,0,0,1,9.25,0Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(4.323 8.802)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(8.802 8.802)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(13.281 8.802)",
            fill: r
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.073,16.1a.727.727,0,1,1,1.152-.888A8.547,8.547,0,1,0,1.454,10a8.636,8.636,0,0,0,.1,1.3.727.727,0,0,1-1.437.22A10,10,0,1,1,2.073,16.1ZM13.28,10a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,13.28,10ZM8.8,10A1.2,1.2,0,1,1,10,11.2,1.2,1.2,0,0,1,8.8,10Zm-4.48,0a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,4.322,10Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.25,0A9.25,9.25,0,1,1,0,9.25,9.251,9.251,0,0,1,9.25,0Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(4.323 8.802)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(8.802 8.802)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(13.281 8.802)",
            fill: n,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25C0,2.313,2.313,0,9.25,0S18.5,2.313,18.5,9.25,16.187,18.5,9.25,18.5,0,16.187,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(12.709 11.4)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(9.709 7.4)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(6.7 11.4)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Mr.displayName = "IconlyMoreCircle", $63c37e44f569564f$var$Mr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$ae0f70bfddaf6a56 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Mr), $63c37e44f569564f$var$Ar = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.34,20H5.67C2.279,20,0,17.625,0,14.09V5.92C0,2.379,2.279,0,5.67,0h8.67C17.725,0,20,2.379,20,5.92v8.17C20,17.625,17.725,20,14.34,20Zm.14-11.2A1.2,1.2,0,1,0,15.67,10,1.2,1.2,0,0,0,14.48,8.8ZM10,8.8A1.2,1.2,0,1,0,11.2,10,1.2,1.2,0,0,0,10,8.8Zm-4.48,0A1.2,1.2,0,1,0,6.72,10,1.2,1.2,0,0,0,5.52,8.8Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", null, (0, $acw62.createElement)("path", {
            d: "M14.34,0H5.67C2.28,0,0,2.38,0,5.92v8.17C0,17.62,2.28,20,5.67,20h8.67C17.73,20,20,17.62,20,14.09V5.92C20,2.38,17.73,0,14.34,0",
            transform: "translate(2 2)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M8.959,1.2a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,8.959,1.2Zm-4.479,0a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,4.479,1.2ZM0,1.2a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,0,1.2Z",
            transform: "translate(6.323 10.804)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.884,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.751 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(4.323 8.802)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(8.802 8.802)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(13.281 8.802)",
            fill: r
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.244,20C2.392,20,0,17.608,0,13.753a.765.765,0,0,1,1.53,0c0,3.034,1.671,4.714,4.723,4.714h7.492c3.044,0,4.723-1.671,4.723-4.714v-7.5c0-3.043-1.67-4.723-4.723-4.723H6.253C3.21,1.53,1.53,3.21,1.53,6.253V8.584a.756.756,0,0,1-.756.756H.763A.763.763,0,0,1,0,8.575V6.253C0,2.393,2.41,0,6.254,0h7.492C17.608,0,20,2.393,20,6.256v7.5C20,17.608,17.608,20,13.747,20Zm7.037-10a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,13.281,10ZM8.8,10A1.2,1.2,0,1,1,10,11.2,1.2,1.2,0,0,1,8.8,10ZM4.323,10a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,4.323,10Z",
            transform: "translate(0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.884,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.751 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(4.323 8.802)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(8.802 8.802)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M1.2,2.395A1.2,1.2,0,1,1,2.4,1.2a1.2,1.2,0,0,1-1.2,1.2",
            transform: "translate(13.281 8.802)",
            fill: n,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25C0,2.313,2.313,0,9.25,0S18.5,2.313,18.5,9.25,16.187,18.5,9.25,18.5,0,16.187,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(13.498 9.5)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(9.499 9.5)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(5.5 9.5)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Ar.displayName = "IconlyMoreSquare", $63c37e44f569564f$var$Ar.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$75d1c9702603e023 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Ar), $63c37e44f569564f$var$gr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.001)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.006,20a3.024,3.024,0,0,1-2.131-.868l-.73-.732a1.489,1.489,0,0,0-1.06-.438H5.054a3.015,3.015,0,0,1-3.011-3.011V13.917a1.538,1.538,0,0,0-.44-1.071l-.72-.71a3.021,3.021,0,0,1-.01-4.259l.73-.732a1.5,1.5,0,0,0,.44-1.07V5.055A3.013,3.013,0,0,1,5.054,2.047h1.03a1.511,1.511,0,0,0,1.06-.441l.72-.72A3.017,3.017,0,0,1,12.127.877l.731.729a1.49,1.49,0,0,0,1.06.441h1.03a3.013,3.013,0,0,1,3.011,3.009V6.087A1.485,1.485,0,0,0,18.4,7.145l.72.72a3.03,3.03,0,0,1,.02,4.251l-.02.02-.01.01-.71.71a1.488,1.488,0,0,0-.441,1.061v1.029a3.014,3.014,0,0,1-3.011,3.011h-1.03a1.489,1.489,0,0,0-1.06.438l-.721.72A2.986,2.986,0,0,1,10.006,20Zm2.571-8.3a.875.875,0,1,0,.87.87A.877.877,0,0,0,12.578,11.7Zm-.005-5.144a.866.866,0,0,0-.616.254l-5.142,5.14a.88.88,0,0,0,0,1.239.829.829,0,0,0,.61.26.837.837,0,0,0,.62-.26l5.143-5.139a.875.875,0,0,0-.616-1.495Zm-5.137,0a.875.875,0,1,0,.87.869A.876.876,0,0,0,7.435,6.556Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", null, (0, $acw62.createElement)("path", {
            d: "M10,20a3,3,0,0,1-2.124-.875l-.73-.73a1.5,1.5,0,0,0-1.064-.439H5.054a3.015,3.015,0,0,1-3.011-3.011V13.916a1.509,1.509,0,0,0-.44-1.065l-.718-.717A3.015,3.015,0,0,1,.874,7.877l.73-.731a1.5,1.5,0,0,0,.439-1.064V5.056A3.015,3.015,0,0,1,5.054,2.044H6.082A1.5,1.5,0,0,0,7.146,1.6L7.865.886A3.014,3.014,0,0,1,12.122.875l.73.73a1.5,1.5,0,0,0,1.063.439h1.028a3.015,3.015,0,0,1,3.011,3.012V6.083a1.509,1.509,0,0,0,.44,1.065l.718.718a3.009,3.009,0,0,1,.02,4.247c-.01.01-.019.021-.029.03l-.71.71a1.5,1.5,0,0,0-.439,1.064v1.027a3.015,3.015,0,0,1-3.011,3.011H13.915a1.5,1.5,0,0,0-1.064.44l-.719.718A3,3,0,0,1,10,20",
            transform: "translate(2 2)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M5.4,6.638a.9.9,0,0,1-.189-.282.845.845,0,0,1-.061-.34.854.854,0,0,1,.061-.341A1.2,1.2,0,0,1,5.39,5.4a.885.885,0,0,1,.964-.194.786.786,0,0,1,.289.187.9.9,0,0,1,0,1.237.907.907,0,0,1-.619.257A.894.894,0,0,1,5.4,6.638Zm-5.138,0a.877.877,0,0,1,0-1.238L5.4.256A.875.875,0,0,1,6.638,1.494L1.5,6.634a.876.876,0,0,1-1.237,0ZM.26,1.5A.877.877,0,0,1,0,.876.914.914,0,0,1,.254.261a.794.794,0,0,1,.3-.194A.856.856,0,0,1,1.5.26a.917.917,0,0,1,.194.275.852.852,0,0,1-.2.962.854.854,0,0,1-.616.254A.9.9,0,0,1,.26,1.5Z",
            transform: "translate(8.552 8.554)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.044,4.305A2.262,2.262,0,0,1,4.305,2.043H5.334a2.262,2.262,0,0,0,1.593-.657l.719-.72a2.262,2.262,0,0,1,3.2-.008l.009.008.72.72a2.258,2.258,0,0,0,1.593.657h1.028a2.262,2.262,0,0,1,2.262,2.262V5.332a2.26,2.26,0,0,0,.657,1.594l.72.72a2.262,2.262,0,0,1,.009,3.2l-.009.009-.72.72a2.256,2.256,0,0,0-.657,1.592v1.029a2.261,2.261,0,0,1-2.262,2.261H13.166a2.259,2.259,0,0,0-1.593.658l-.72.719a2.261,2.261,0,0,1-3.2.009l-.009-.009-.719-.719a2.263,2.263,0,0,0-1.593-.658H4.305a2.261,2.261,0,0,1-2.261-2.261V13.165a2.257,2.257,0,0,0-.658-1.592l-.719-.72a2.261,2.261,0,0,1-.009-3.2l.009-.009.719-.72a2.261,2.261,0,0,0,.658-1.594V4.305",
            transform: "translate(0.75 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,5.14,5.14,0",
            transform: "translate(7.43 7.43)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.75,1.49a.749.749,0,0,1-.53-.22.821.821,0,0,1-.16-.25A.668.668,0,0,1,0,.74.717.717,0,0,1,.06.45.776.776,0,0,1,.22.21a.774.774,0,0,1,1.06,0,.807.807,0,0,1,.17.24A.929.929,0,0,1,1.5.74a.863.863,0,0,1-.05.28.852.852,0,0,1-.17.25.749.749,0,0,1-.53.22",
            transform: "translate(11.817 11.832)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M.75,1.491A.672.672,0,0,1,.47,1.43a.818.818,0,0,1-.25-.159.963.963,0,0,1-.16-.25A.674.674,0,0,1,0,.741.714.714,0,0,1,.06.451.674.674,0,0,1,.22.211a.772.772,0,0,1,1.06,0,.748.748,0,0,1,.22.53.666.666,0,0,1-.05.28,1.006,1.006,0,0,1-.17.25.773.773,0,0,1-.24.159.718.718,0,0,1-.29.061",
            transform: "translate(6.677 6.692)",
            fill: r
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.876,19.126l-.73-.731a1.512,1.512,0,0,0-1.065-.439H5.055a3.015,3.015,0,0,1-3.011-3.01.75.75,0,1,1,1.5,0,1.511,1.511,0,0,0,1.511,1.51H6.083a3,3,0,0,1,2.122.877l.721.722A1.506,1.506,0,0,0,10,18.5a1.424,1.424,0,0,0,1.072-.445.751.751,0,1,1,1.064,1.059,3.018,3.018,0,0,1-4.259.011Zm6.318-1.92a.75.75,0,0,1,.75-.75,1.513,1.513,0,0,0,1.511-1.512V13.917a2.99,2.99,0,0,1,.878-2.123l.72-.721a1.512,1.512,0,0,0,0-2.146l-.721-.722a3,3,0,0,1-.878-2.123V5.053a1.511,1.511,0,0,0-1.511-1.511.751.751,0,0,1,0-1.5,3.015,3.015,0,0,1,3.011,3.012V6.081a1.505,1.505,0,0,0,.44,1.065l.717.718a3.013,3.013,0,0,1,.012,4.259l-.73.73a1.528,1.528,0,0,0-.439,1.065v1.027a3.016,3.016,0,0,1-3.011,3.012A.75.75,0,0,1,14.194,17.206ZM11.7,12.572a.868.868,0,1,1,.868.868A.868.868,0,0,1,11.7,12.572ZM6.9,13.1a.752.752,0,0,1,0-1.062L12.039,6.9A.75.75,0,1,1,13.1,7.959L7.961,13.1a.753.753,0,0,1-1.061,0ZM.887,12.136a3.018,3.018,0,0,1-.01-4.262l.73-.73a1.5,1.5,0,0,0,.44-1.06V5.053a3.014,3.014,0,0,1,3.01-3.011h1.03A1.49,1.49,0,0,0,7.146,1.6l.72-.719a3.009,3.009,0,0,1,4.14-.111,1.073,1.073,0,0,1,.121.1.763.763,0,0,1,.21.52.75.75,0,0,1-1.26.55l-.02-.019a1.531,1.531,0,0,0-2.13.019l-.72.721a2.974,2.974,0,0,1-2.12.88H5.056a1.516,1.516,0,0,0-1.51,1.51V6.083A2.97,2.97,0,0,1,2.667,8.2l-.72.722a1.525,1.525,0,0,0,0,2.149.756.756,0,0,1,0,1.061.77.77,0,0,1-.53.22A.743.743,0,0,1,.887,12.136ZM6.553,7.444a.868.868,0,1,1,.868.867A.868.868,0,0,1,6.553,7.444Z",
            transform: "translate(0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.044,4.305A2.262,2.262,0,0,1,4.305,2.043H5.334a2.262,2.262,0,0,0,1.593-.657l.719-.72a2.262,2.262,0,0,1,3.2-.008l.009.008.72.72a2.258,2.258,0,0,0,1.593.657h1.028a2.262,2.262,0,0,1,2.262,2.262V5.332a2.26,2.26,0,0,0,.657,1.594l.72.72a2.262,2.262,0,0,1,.009,3.2l-.009.009-.72.72a2.256,2.256,0,0,0-.657,1.592v1.029a2.261,2.261,0,0,1-2.262,2.261H13.166a2.259,2.259,0,0,0-1.593.658l-.72.719a2.261,2.261,0,0,1-3.2.009l-.009-.009-.719-.719a2.263,2.263,0,0,0-1.593-.658H4.305a2.261,2.261,0,0,1-2.261-2.261V13.165a2.257,2.257,0,0,0-.658-1.592l-.719-.72a2.261,2.261,0,0,1-.009-3.2l.009-.009.719-.72a2.261,2.261,0,0,0,.658-1.594V4.305",
            transform: "translate(0.75 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,5.14,5.14,0",
            transform: "translate(7.43 7.43)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.75,1.49a.749.749,0,0,1-.53-.22.821.821,0,0,1-.16-.25A.668.668,0,0,1,0,.74.717.717,0,0,1,.06.45.776.776,0,0,1,.22.21a.774.774,0,0,1,1.06,0,.807.807,0,0,1,.17.24A.929.929,0,0,1,1.5.74a.863.863,0,0,1-.05.28.852.852,0,0,1-.17.25.749.749,0,0,1-.53.22",
            transform: "translate(11.817 11.832)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.75,1.491A.672.672,0,0,1,.47,1.43a.818.818,0,0,1-.25-.159.963.963,0,0,1-.16-.25A.674.674,0,0,1,0,.741.714.714,0,0,1,.06.451.674.674,0,0,1,.22.211a.772.772,0,0,1,1.06,0,.748.748,0,0,1,.22.53.666.666,0,0,1-.05.28,1.006,1.006,0,0,1-.17.25.773.773,0,0,1-.24.159.718.718,0,0,1-.29.061",
            transform: "translate(6.677 6.692)",
            fill: n,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25C0,2.313,2.313,0,9.25,0S18.5,2.313,18.5,9.25,16.187,18.5,9.25,18.5,0,16.187,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,5.14,5.14,0",
            transform: "translate(7.43 7.43)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(12 12)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(7 7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$gr.displayName = "IconlyDiscount", $63c37e44f569564f$var$gr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$5f0fddd75cd8dcd7 = $63c37e44f569564f$var$st($63c37e44f569564f$var$gr), $63c37e44f569564f$var$Vr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.149,18.459A1.514,1.514,0,1,1,16.668,20,1.535,1.535,0,0,1,15.149,18.459Zm-11.241,0A1.514,1.514,0,1,1,5.426,20,1.534,1.534,0,0,1,3.908,18.459Zm1.679-3.164a2.509,2.509,0,0,1-1.726-.689,2.616,2.616,0,0,1-.812-1.7L2.129,1.784.62,1.518A.766.766,0,0,1,.765,0,.817.817,0,0,1,.88.009L3.263.375a.768.768,0,0,1,.619.694l.19,2.286a.617.617,0,0,0,.609.572H18.176a1.689,1.689,0,0,1,1.409.684,2.251,2.251,0,0,1,.38,1.754l-.95,6.694a2.582,2.582,0,0,1-2.528,2.235Zm5.785-6.826a.758.758,0,0,0,.75.765h2.767a.758.758,0,0,0,.75-.765.75.75,0,0,0-.75-.766H12.121A.75.75,0,0,0,11.372,8.468Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M11.25,1.52a1.515,1.515,0,1,1,1.52,1.51A1.52,1.52,0,0,1,11.25,1.52ZM0,1.52A1.515,1.515,0,1,1,1.52,3.03,1.52,1.52,0,0,1,0,1.52Z",
            transform: "translate(3.911 16.569)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M16.5,14.989H5.591a2.549,2.549,0,0,1-2.54-2.339L2.13,1.749.621,1.489A.747.747,0,0,1,.14,1.181.732.732,0,0,1,.011.628.761.761,0,0,1,.768,0,.793.793,0,0,1,.881.008l2.385.36a.759.759,0,0,1,.619.68l.191,2.24a.612.612,0,0,0,.609.561H18.191a1.706,1.706,0,0,1,1.41.67,2.169,2.169,0,0,1,.38,1.719l-.95,6.56A2.566,2.566,0,0,1,16.5,14.989Zm-4.37-7.44a.742.742,0,0,0-.751.75.751.751,0,0,0,.751.751H14.9a.751.751,0,0,0,.751-.751.742.742,0,0,0-.751-.75Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M.764,0A.765.765,0,1,1,0,.765.766.766,0,0,1,.764,0Z",
            transform: "translate(4.658 17.32)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.765,0A.765.765,0,1,1,0,.765.766.766,0,0,1,.765,0Z",
            transform: "translate(15.91 17.32)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.08.36l.963,11.473a1.8,1.8,0,0,0,1.8,1.653H15.752a1.8,1.8,0,0,0,1.785-1.546l.949-6.558a1.341,1.341,0,0,0-1.327-1.533H2.414",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.5H2.773",
            transform: "translate(12.125 7.795)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.161,18.455A1.515,1.515,0,1,1,16.674,20,1.532,1.532,0,0,1,15.161,18.455Zm-11.253,0A1.515,1.515,0,1,1,5.423,20,1.533,1.533,0,0,1,3.908,18.455Zm1.683-3.163A2.56,2.56,0,0,1,3.046,12.9L2.132,1.786.622,1.519A.765.765,0,0,1,.011.635.752.752,0,0,1,.877.01L2.959.379a.758.758,0,0,1,.618.69l.963,11.707a1.056,1.056,0,0,0,1.05.985H16.5a1.067,1.067,0,0,0,1.043-.921l.949-6.693a.606.606,0,0,0-.138-.482.582.582,0,0,0-.447-.208H7.164a.766.766,0,0,1,0-1.531H17.908a2.071,2.071,0,0,1,1.581.738,2.161,2.161,0,0,1,.489,1.7l-.95,6.693A2.583,2.583,0,0,1,16.5,15.292Zm6.535-6.062a.766.766,0,0,1,0-1.531H14.9a.766.766,0,0,1,0,1.531Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M.764,0A.765.765,0,1,1,0,.765.766.766,0,0,1,.764,0Z",
            transform: "translate(4.658 17.32)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.765,0A.765.765,0,1,1,0,.765.766.766,0,0,1,.765,0Z",
            transform: "translate(15.91 17.32)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.08.36l.963,11.473a1.8,1.8,0,0,0,1.8,1.653H15.752a1.8,1.8,0,0,0,1.785-1.546l.949-6.558a1.341,1.341,0,0,0-1.327-1.533H2.414",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.5H2.773",
            transform: "translate(12.125 7.795)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.65 2.85)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.044,3.58c9.848-1.337,12.187-.6,13.717,1.14s1.261,6.917-.528,8.516-9.553,1.751-12.013,0C.621,11.386,2.129,5.692,2.044,2.243,2.1.313,0,0,0,0",
            transform: "translate(0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.5H2.773",
            transform: "translate(10.506 7.37)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.545,0A.545.545,0,1,1,0,.544.545.545,0,0,1,.545,0Z",
            transform: "translate(3.069 17.277)",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.544,0A.545.545,0,1,1,0,.544.545.545,0,0,1,.544,0Z",
            transform: "translate(13.401 17.277)",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Vr.displayName = "IconlyBuy", $63c37e44f569564f$var$Vr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$4abaa06179fa6649 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Vr), $63c37e44f569564f$var$jr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 1.999)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,20a10,10,0,1,1,7.074-2.929A10.011,10.011,0,0,1,10,20Zm0-7.069a.871.871,0,0,0-.87.869.875.875,0,1,0,.87-.869Zm0-7.6a.892.892,0,0,0-.88.88v4.42a.875.875,0,0,0,1.751,0V6.21A.876.876,0,0,0,10,5.33Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", null, (0, $acw62.createElement)("path", {
            d: "M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10",
            transform: "translate(2 2)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.005,8.468a.878.878,0,1,1,.879.875A.874.874,0,0,1,.005,8.468ZM0,5.295V.875a.875.875,0,0,1,1.75,0v4.42a.875.875,0,1,1-1.75,0Z",
            transform: "translate(11.12 7.336)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.25,0A9.25,9.25,0,1,1,0,9.25,9.25,9.25,0,0,1,9.25,0Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V4.419",
            transform: "translate(9.495 6.204)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(9.5 13.296)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.073,16.1a.727.727,0,0,1,1.152-.888A8.547,8.547,0,1,0,1.454,10a8.636,8.636,0,0,0,.1,1.3.727.727,0,0,1-.608.828.719.719,0,0,1-.828-.608A10,10,0,1,1,2.073,16.1Zm7.183-2.3A.746.746,0,0,1,10,13.046h.01a.75.75,0,1,1-.754.751ZM9.25,10.625V6.2a.75.75,0,1,1,1.5,0v4.421a.75.75,0,0,1-1.5,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.25,0A9.25,9.25,0,1,1,0,9.25,9.25,9.25,0,0,1,9.25,0Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V4.419",
            transform: "translate(9.495 6.204)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(9.5 13.296)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25C0,2.313,2.313,0,9.25,0S18.5,2.313,18.5,9.25,16.187,18.5,9.25,18.5,0,16.187,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V3.895",
            transform: "translate(9.5 6.105)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(9.5 13)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$jr.displayName = "IconlyInfoCircle", $63c37e44f569564f$var$jr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$6e50c69d980cc044 = $63c37e44f569564f$var$st($63c37e44f569564f$var$jr), $63c37e44f569564f$var$vr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 1.999)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.34,20H5.67C2.279,20,0,17.625,0,14.091V5.92C0,2.379,2.279,0,5.67,0h8.67C17.725,0,20,2.379,20,5.92v8.171C20,17.625,17.725,20,14.34,20ZM9.99,8.481a.876.876,0,0,0-.87.88v4.42a.875.875,0,0,0,1.751,0V9.361A.881.881,0,0,0,9.99,8.481Zm.02-3.17a.875.875,0,1,0,.87.88A.871.871,0,0,0,10.01,5.311Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", null, (0, $acw62.createElement)("path", {
            d: "M14.34,0H5.67C2.28,0,0,2.38,0,5.92v8.17C0,17.62,2.28,20,5.67,20h8.67C17.73,20,20,17.62,20,14.09V5.92C20,2.38,17.73,0,14.34,0",
            transform: "translate(2 2)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,8.468V4.048a.875.875,0,1,1,1.75,0v4.42a.875.875,0,0,1-1.75,0ZM.005.875a.878.878,0,1,1,.869.875A.878.878,0,0,1,.005.875Z",
            transform: "translate(11.12 7.314)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,4.419V0",
            transform: "translate(9.49 9.377)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(9.495 5.704)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.885,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.751 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.244,20C2.392,20,0,17.608,0,13.753a.765.765,0,0,1,1.53,0c0,3.034,1.671,4.714,4.723,4.714h7.492c3.044,0,4.723-1.671,4.723-4.714v-7.5c0-3.043-1.67-4.723-4.723-4.723H6.253C3.21,1.53,1.53,3.21,1.53,6.253V8.584a.756.756,0,0,1-.756.756H.763A.763.763,0,0,1,0,8.575V6.253C0,2.393,2.41,0,6.254,0h7.492C17.608,0,20,2.393,20,6.256v7.5C20,17.608,17.608,20,13.747,20Zm3-6.2V9.376a.75.75,0,1,1,1.5,0V13.8a.75.75,0,0,1-1.5,0Zm.75-6.842A.746.746,0,0,1,9.25,6.2.752.752,0,1,1,10,6.954Z",
            transform: "translate(0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,4.419V0",
            transform: "translate(9.49 9.377)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(9.495 5.704)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.885,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.751 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.75 2.75)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25C0,2.313,2.313,0,9.25,0S18.5,2.313,18.5,9.25,16.187,18.5,9.25,18.5,0,16.187,0,9.25Z",
            transform: "translate(18.5 18.5) rotate(180)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V3.895",
            transform: "translate(9.75 13.145) rotate(180)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(9.75 6.25) rotate(180)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$vr.displayName = "IconlyInfoSquare", $63c37e44f569564f$var$vr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$92b5cd1177d01936 = $63c37e44f569564f$var$st($63c37e44f569564f$var$vr), $63c37e44f569564f$var$br = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M17.316,18H2.679a3.129,3.129,0,0,1-.91-.2A2.809,2.809,0,0,1,.218,16.275,2.747,2.747,0,0,1,.21,14.146L7.529,1.433a2.746,2.746,0,0,1,1.1-1.08A2.819,2.819,0,0,1,9.993,0a2.853,2.853,0,0,1,2.484,1.442l7.268,12.615a2.936,2.936,0,0,1,.25,1,2.753,2.753,0,0,1-.73,2.021A2.841,2.841,0,0,1,17.316,18ZM10,12.272a.873.873,0,1,0,0,1.745.877.877,0,0,0,.869-.883A.867.867,0,0,0,10,12.272ZM10,6.09a.872.872,0,0,0-.88.862v2.8a.888.888,0,0,0,.88.873.872.872,0,0,0,.869-.873v-2.8A.867.867,0,0,0,10,6.09Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", null, (0, $acw62.createElement)("path", {
            d: "M2.723,18.167H2.684a2.828,2.828,0,0,1-2.476-3.89L7.529,1.45a2.83,2.83,0,0,1,4.946.009l7.273,12.728A2.872,2.872,0,0,1,20,15.194a2.829,2.829,0,0,1-2.681,2.972H2.723Z",
            transform: "translate(2 3.001)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,7.124A.875.875,0,1,1,.875,8,.879.879,0,0,1,0,7.124ZM0,3.7V.875a.875.875,0,0,1,1.75,0V3.7A.875.875,0,1,1,0,3.7Z",
            transform: "translate(11.125 9.146)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,.756A.755.755,0,0,1,.75,0,.746.746,0,0,1,1.5.745V.756a.75.75,0,1,1-1.5,0Z",
            transform: "translate(9.25 12.514)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M2.045,16.668H16.527a2.077,2.077,0,0,0,1.819-2.859L11.069,1.073a2.08,2.08,0,0,0-3.639,0L.153,13.809A2.08,2.08,0,0,0,1.3,16.518a2.125,2.125,0,0,0,.676.15",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,3.1V0",
            transform: "translate(9.49 7.296)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.81,17.418a.75.75,0,0,1,.75-.75H17.278a1.334,1.334,0,0,0,1.221-1.4,1.332,1.332,0,0,0-.081-.392L11.169,2.2a1.333,1.333,0,0,0-1.812-.528,1.316,1.316,0,0,0-.519.519l-7.255,12.7a1.332,1.332,0,0,0,1.179,1.787.75.75,0,0,1-.038,1.5H2.687A2.83,2.83,0,0,1,.21,14.276a.637.637,0,0,1,.043-.09L7.53,1.451a2.829,2.829,0,0,1,4.946.009l7.272,12.726a.7.7,0,0,1,.044.091,2.83,2.83,0,0,1-2.477,3.89H6.559A.75.75,0,0,1,5.81,17.418Zm3.442-4.149a.754.754,0,0,1,.75-.755.747.747,0,0,1,.751.745v.01a.75.75,0,1,1-1.5,0Zm0-3.421V7.021a.75.75,0,0,1,1.5,0V9.848a.75.75,0,1,1-1.5,0Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,7a.755.755,0,0,1,.75-.756.746.746,0,0,1,.75.745V7A.75.75,0,0,1,0,7Z",
            transform: "translate(9.25 6.272)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M2.045,16.668H16.527a2.077,2.077,0,0,0,1.819-2.859L11.069,1.073a2.08,2.08,0,0,0-3.639,0L.153,13.809A2.08,2.08,0,0,0,1.3,16.518a2.125,2.125,0,0,0,.676.15",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,3.1V0",
            transform: "translate(9.49 7.296)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25C0,2.313,2.313,0,9.25,0S18.5,2.313,18.5,9.25,16.187,18.5,9.25,18.5,0,16.187,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V3.895",
            transform: "translate(9.5 6.105)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(9.5 13)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$br.displayName = "IconlyDanger", $63c37e44f569564f$var$br.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$95d05bdc75950145 = $63c37e44f569564f$var$st($63c37e44f569564f$var$br), $63c37e44f569564f$var$Sr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 1.999)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.34,20H5.67C2.279,20,0,17.625,0,14.091V5.92C0,2.379,2.279,0,5.67,0h8.67C17.725,0,20,2.379,20,5.92v8.171C20,17.625,17.725,20,14.34,20ZM10,11.231h0L11.78,13a.815.815,0,0,0,.61.261A.873.873,0,0,0,13.01,13a.869.869,0,0,0,0-1.228l-1.78-1.78L13.01,8.21a.875.875,0,0,0-.616-1.494.89.89,0,0,0-.624.256L10,8.75,8.22,6.971A.89.89,0,0,0,7.6,6.716.876.876,0,0,0,6.98,8.21L8.76,9.991,6.98,11.761a.88.88,0,0,0,.619,1.5A.873.873,0,0,0,8.22,13L10,11.232Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", null, (0, $acw62.createElement)("path", {
            d: "M14.34,0H5.67C2.28,0,0,2.38,0,5.92v8.17C0,17.62,2.28,20,5.67,20h8.67C17.73,20,20,17.62,20,14.09V5.92C20,2.38,17.73,0,14.34,0",
            transform: "translate(2 2)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M6.29,5.052,4.511,3.274,6.289,1.5A.875.875,0,0,0,5.052.258L3.273,2.036,1.494.256A.875.875,0,1,0,.256,1.494l1.78,1.78L.26,5.049A.875.875,0,0,0,1.5,6.287L3.273,4.511,5.053,6.29A.875.875,0,0,0,6.29,5.052",
            transform: "translate(8.726 8.719)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.792,0,0,4.792",
            transform: "translate(7.603 7.595)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.8,4.8,0,0",
            transform: "translate(7.601 7.593)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.885,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.751 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.253,20C2.392,20,0,17.608,0,13.756v-7.5C0,2.392,2.392,0,6.253,0h7.5C17.59,0,20,2.392,20,6.253V8.822a.756.756,0,0,1-.756.756h-.009V9.56A.765.765,0,0,1,18.47,8.8V6.253c0-3.053-1.67-4.723-4.714-4.723h-7.5C3.21,1.53,1.53,3.21,1.53,6.253v7.5c0,3.034,1.68,4.714,4.723,4.714h7.5c3.043,0,4.714-1.68,4.714-4.714a.765.765,0,0,1,1.53,0C20,17.608,17.608,20,13.756,20Zm.861-7.072-.022-.016a.773.773,0,0,1,.038-1.082l.684-.684a.765.765,0,1,1,1.044,1.119l-.681.681a.764.764,0,0,1-1.063-.018Zm4.958-.112-.038-.037L7.255,8a.817.817,0,0,1-.013-1.108.755.755,0,0,1,1.069-.013l.008.006,1.865,1.867,1.7-1.7a.783.783,0,0,1,1.088.007.745.745,0,0,1,.135.183.768.768,0,0,1-.122.925l-1.69,1.689L13.129,11.7a.77.77,0,0,1,.029,1.091c0,.006-.011.01-.015.016a.767.767,0,0,1-1.07.012Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.4,2.4,0,4.794,2.4,2.4,0,0,2.4,2.4,4.794,0,2.4,2.4,4.8,4.8Z",
            transform: "translate(7.601 7.593)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.885,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.751 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.792,0,0,4.792",
            transform: "translate(7.602 7.595)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.8,4.8,0,0",
            transform: "translate(7.6 7.593)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Sr.displayName = "IconlyCloseSquare", $63c37e44f569564f$var$Sr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$690403bf78a2c747 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Sr), $63c37e44f569564f$var$Or = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.34,20H5.67C2.279,20,0,17.625,0,14.091V5.92C0,2.379,2.279,0,5.67,0h8.67C17.725,0,20,2.379,20,5.92v8.171C20,17.625,17.725,20,14.34,20ZM6.44,9.125a.875.875,0,0,0-.62,1.5L8.2,12.99a.881.881,0,0,0,1.23,0L14.18,8.24A.877.877,0,0,0,12.94,7L8.81,11.13,7.06,9.38A.868.868,0,0,0,6.44,9.125Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.34,0H5.67C2.28,0,0,2.38,0,5.92v8.17C0,17.62,2.28,20,5.67,20h8.67C17.73,20,20,17.62,20,14.09V5.92C20,2.38,17.73,0,14.34,0",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M3.249,6.5a.872.872,0,0,1-.619-.256L.257,3.868A.875.875,0,0,1,1.493,2.629L3.249,4.385,7.377.257A.875.875,0,0,1,8.613,1.495L3.868,6.24a.872.872,0,0,1-.619.256",
            transform: "translate(5.565 6.752)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.885,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.373,2.374,4.746,7.12,0",
            transform: "translate(6.44 7.627)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.253,20C2.392,20,0,17.608,0,13.756v-7.5C0,2.392,2.392,0,6.253,0h7.5C17.59,0,20,2.392,20,6.253V8.822a.756.756,0,0,1-.756.756h-.009V9.56A.765.765,0,0,1,18.47,8.8V6.253c0-3.053-1.67-4.723-4.714-4.723h-7.5C3.21,1.53,1.53,3.21,1.53,6.253v7.5c0,3.034,1.68,4.714,4.723,4.714h7.5c3.043,0,4.714-1.68,4.714-4.714a.765.765,0,0,1,1.53,0C20,17.608,17.608,20,13.756,20Zm2.03-7.1L5.909,10.531A.75.75,0,1,1,6.97,9.47l1.843,1.844L13.029,7.1A.75.75,0,0,1,14.09,8.158L9.344,12.9a.751.751,0,0,1-1.061,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.885,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.373,2.374,4.746,7.12,0",
            transform: "translate(6.44 7.627)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,2.373,2.374,4.746,7.12,0",
            transform: "translate(6.44 7.627)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Or.displayName = "IconlyTickSquare", $63c37e44f569564f$var$Or.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$2525b0c1ef18f936 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Or), $63c37e44f569564f$var$Nr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,20A10,10,0,0,1,2.926,2.93,10,10,0,1,1,17.07,17.074,9.936,9.936,0,0,1,10,20ZM13.428,6.118a.459.459,0,0,0-.137.021L8.17,7.74a.669.669,0,0,0-.44.44l-1.6,5.13a.435.435,0,0,0,.064.393.45.45,0,0,0,.361.188.437.437,0,0,0,.135-.022l5.1-1.6a.644.644,0,0,0,.44-.44L13.85,6.71a.454.454,0,0,0-.066-.409A.445.445,0,0,0,13.428,6.118Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M7.742.592l-1.62,5.12a.651.651,0,0,1-.44.441l-5.1,1.6a.448.448,0,0,1-.56-.56l1.6-5.13a.668.668,0,0,1,.44-.44l5.12-1.6a.449.449,0,0,1,.56.57",
            transform: "translate(6.118 6.113)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,6.682,1.593,1.593,6.682,0,5.089,5.089Z",
            transform: "translate(6.27 6.27)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("circle", {
            cx: "9.611",
            cy: "9.611",
            r: "9.611",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.741,19.05A10,10,0,0,1,10,0a9.659,9.659,0,0,1,2.174.246,9.982,9.982,0,0,1,7.576,11.984.781.781,0,1,1-1.508-.386,8.4,8.4,0,1,0-1.561,3.319.781.781,0,0,1,1.211.957A9.978,9.978,0,0,1,5.741,19.05Zm.826-5.108a.775.775,0,0,1-.509-.975L7.584,8.086a.781.781,0,0,1,.509-.5l4.876-1.527a.671.671,0,0,1,.455,0,.763.763,0,0,1,.509.966l-1.561,4.89a.773.773,0,0,1-.394.465l-.877.439a.781.781,0,0,1-.666-1.4l.588-.29L12,7.98l-3.069.966-1.4,4.486a.772.772,0,0,1-.965.509Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,6.682,1.593,1.593,6.682,0,5.089,5.089Z",
            transform: "translate(6.27 6.27)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("circle", {
            cx: "9.611",
            cy: "9.611",
            r: "9.611",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,6.6l1.574-5.03L6.6,0,5.03,5.029Z",
            transform: "translate(6.698 6.698)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Nr.displayName = "IconlyDiscovery", $63c37e44f569564f$var$Nr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$fc67dfdccdde59ae = $63c37e44f569564f$var$st($63c37e44f569564f$var$Nr), $63c37e44f569564f$var$Pr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.5,20a1.358,1.358,0,0,1-.734-.247,21.513,21.513,0,0,1-5.54-5.141A10.384,10.384,0,0,1,0,8.318,8.168,8.168,0,0,1,2.5,2.434,8.53,8.53,0,0,1,8.493,0,8.423,8.423,0,0,1,17,8.318a10.39,10.39,0,0,1-2.23,6.294,21.92,21.92,0,0,1-5.541,5.141A1.319,1.319,0,0,1,8.5,20ZM8.493,5.777a2.8,2.8,0,0,0-2.8,2.8,2.712,2.712,0,0,0,.821,1.954,2.823,2.823,0,0,0,4.79-1.954,2.824,2.824,0,0,0-2.813-2.8Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.042,17h0a.823.823,0,0,1-.39-.119,18.454,18.454,0,0,1-4.838-4.548A9.227,9.227,0,0,1,0,7.134,7.166,7.166,0,0,1,3.532.937a6.889,6.889,0,0,1,7.034.058,7.254,7.254,0,0,1,2.525,2.674A7.419,7.419,0,0,1,14,7.261a10.515,10.515,0,0,1-3.192,6.775,18.751,18.751,0,0,1-3.359,2.82A1.173,1.173,0,0,1,7.042,17ZM6.993,4.848a2.342,2.342,0,0,0-1.679.706,2.445,2.445,0,0,0-.519,2.641,2.369,2.369,0,0,0,2.2,1.5h.017a2.327,2.327,0,0,0,1.667-.7,2.455,2.455,0,0,0-.768-3.956A2.328,2.328,0,0,0,6.993,4.848Z",
            transform: "translate(0)",
            fill: r
        }), (0, $acw62.createElement)("ellipse", {
            cx: "5",
            cy: "1",
            rx: "5",
            ry: "1",
            transform: "translate(2 18)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,7.652A7.678,7.678,0,1,1,15.357,7.7v.087a11.338,11.338,0,0,1-3.478,7.3,20.183,20.183,0,0,1-3.591,2.957.93.93,0,0,1-1.217,0,19.817,19.817,0,0,1-5.052-4.73A9.826,9.826,0,0,1,0,7.678Z",
            transform: "translate(0.739 0.739)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("circle", {
            cx: "2.461",
            cy: "2.461",
            r: "2.461",
            transform: "translate(5.957 6.078)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.856,19.879a23.973,23.973,0,0,1-5.7-5.3A10.6,10.6,0,0,1,0,8.513,8.516,8.516,0,0,1,8.5,0h.033A8.5,8.5,0,0,1,17,8.522v.094c-.064,3.344-2.075,6.12-3.749,7.859a20.427,20.427,0,0,1-1.508,1.42.746.746,0,0,1-.968-1.134,19.168,19.168,0,0,0,1.4-1.319c1.49-1.547,3.279-3.992,3.333-6.854a7.027,7.027,0,0,0-6.979-7.1H8.5A7.01,7.01,0,0,0,1.493,8.461a9.119,9.119,0,0,0,1.859,5.225A22.377,22.377,0,0,0,8.672,18.63a.746.746,0,0,1-.815,1.249ZM5.262,8.614a.747.747,0,0,1,1.493,0A1.742,1.742,0,1,0,8.5,6.873a.745.745,0,1,1,0-1.49,3.23,3.23,0,1,1-3.235,3.23Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,7.652A7.678,7.678,0,1,1,15.357,7.7v.087a11.338,11.338,0,0,1-3.478,7.3,20.183,20.183,0,0,1-3.591,2.957.93.93,0,0,1-1.217,0,19.817,19.817,0,0,1-5.052-4.73A9.826,9.826,0,0,1,0,7.678Z",
            transform: "translate(0.739 0.739)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("circle", {
            cx: "2.461",
            cy: "2.461",
            r: "2.461",
            transform: "translate(5.957 6.078)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M5,2.5A2.5,2.5,0,1,0,2.5,5,2.5,2.5,0,0,0,5,2.5Z",
            transform: "translate(5.01 5.21)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,18C4.6,18,0,12.959,0,7.6A7.549,7.549,0,0,1,7.5,0,7.55,7.55,0,0,1,15,7.6C15,12.959,10.4,18,7.5,18Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Pr.displayName = "IconlyLocation", $63c37e44f569564f$var$Pr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$18a2be9195644f38 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Pr), $63c37e44f569564f$var$Dr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.191,20H4.81C1.753,20,0,18.236,0,15.16V4.83A4.91,4.91,0,0,1,1.265,1.271,4.863,4.863,0,0,1,4.81,0h8.382C16.247,0,18,1.761,18,4.83V15.16a4.891,4.891,0,0,1-1.246,3.583A4.819,4.819,0,0,1,13.191,20ZM5,13.736a.78.78,0,0,0-.668.374.786.786,0,0,0,.653,1.206.7.7,0,0,0,.1-.006H12.92a.79.79,0,0,0,0-1.57H5.08A.8.8,0,0,0,5,13.736ZM5.08,9.179a.78.78,0,0,0,0,1.561H12.92a.78.78,0,0,0,0-1.561Zm0-4.529v.01h0a.779.779,0,0,0,0,1.559h2.99a.785.785,0,0,0,0-1.57Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.191,0H4.81C1.77,0,0,1.78,0,4.83V15.16C0,18.26,1.77,20,4.81,20h8.381C16.28,20,18,18.26,18,15.16V4.83C18,1.78,16.28,0,13.191,0",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.12,10.3a.8.8,0,0,1,0-.84A.785.785,0,0,1,.87,9.09H8.71a.79.79,0,0,1,0,1.57H.87a.732.732,0,0,1-.1.007A.783.783,0,0,1,.12,10.3ZM.87,6.09a.781.781,0,0,1,0-1.562H8.71a.781.781,0,0,1,0,1.562Zm0-4.521A.78.78,0,1,1,.87.01V0H3.859a.785.785,0,0,1,0,1.57Z",
            transform: "translate(4.21 4.65)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.22.5H0",
            transform: "translate(5.496 13.723)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.22.5H0",
            transform: "translate(5.496 9.537)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M2.755.5H0",
            transform: "translate(5.496 5.36)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.158,0,4.469,0A4.251,4.251,0,0,0,0,4.607v9.2A4.254,4.254,0,0,0,4.506,18.41l7.689,0a4.252,4.252,0,0,0,4.47-4.6v-9.2A4.255,4.255,0,0,0,12.158,0Z",
            transform: "translate(0.751 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.006,20a.734.734,0,0,1,0-1.457h2.848c2.455,0,3.692-1.263,3.692-3.752V5.21c0-2.49-1.237-3.753-3.692-3.753H5.138c-2.456,0-3.7,1.263-3.7,3.753v9.581c0,2.489,1.245,3.752,3.7,3.752a.734.734,0,0,1,0,1.457C1.924,20,0,18.049,0,14.791V5.21C0,1.942,1.924,0,5.138,0h7.716C16.067,0,17.991,1.951,18,5.21v9.581C18,18.049,16.084,20,12.862,20ZM5.39,14.958H5.382a.724.724,0,0,1,0-1.448h7.21a.724.724,0,0,1,0,1.448Zm7.2-4.229H5.382a.734.734,0,0,1,0-1.457h7.21a.72.72,0,0,1,.692.338.745.745,0,0,1,0,.779.724.724,0,0,1-.613.344A.712.712,0,0,1,12.592,10.729ZM5.39,6.5a.734.734,0,0,1,0-1.457H8.133a.734.734,0,0,1,0,1.457Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.22.5H0",
            transform: "translate(5.496 13.723)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M7.22.5H0",
            transform: "translate(5.496 9.537)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M2.755.5H0",
            transform: "translate(5.496 5.36)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M12.158,0,4.469,0A4.251,4.251,0,0,0,0,4.607v9.2A4.254,4.254,0,0,0,4.506,18.41l7.689,0a4.252,4.252,0,0,0,4.47-4.6v-9.2A4.255,4.255,0,0,0,12.158,0Z",
            transform: "translate(0.751 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.61 2.75)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.22.5H0",
            transform: "translate(4.766 12.446)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.22.5H0",
            transform: "translate(4.766 8.686)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M2.755.5H0",
            transform: "translate(4.766 4.927)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.1,9.25,8.391,9.25s8.391-2.313,8.391-9.25S14.685,0,8.391,0,0,2.313,0,9.25Z",
            transform: "translate(0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Dr.displayName = "IconlyDocument", $63c37e44f569564f$var$Dr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$b34a105447964f9f = $63c37e44f569564f$var$st($63c37e44f569564f$var$Dr), $63c37e44f569564f$var$qr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.2,20H8.807a2.066,2.066,0,0,1-2.125-2.05A1.9,1.9,0,0,0,4.8,16.13a1.58,1.58,0,0,0-.9.23,2.163,2.163,0,0,1-1.084.3A2.122,2.122,0,0,1,1,15.62l-.7-1.2a2,2,0,0,1-.021-2.05,2.108,2.108,0,0,1,.817-.789,1.653,1.653,0,0,0,.644-.64,1.782,1.782,0,0,0,.19-1.365A1.837,1.837,0,0,0,1.071,8.44,2.045,2.045,0,0,1,.314,5.61L1,4.43a2.123,2.123,0,0,1,2.882-.76,1.894,1.894,0,0,0,.9.224A1.959,1.959,0,0,0,6.446,2.98a1.538,1.538,0,0,0,.236-.88A1.788,1.788,0,0,1,6.968,1.04,2.2,2.2,0,0,1,8.776,0h1.441a2.154,2.154,0,0,1,1.82,1.04A1.781,1.781,0,0,1,12.312,2.1a1.545,1.545,0,0,0,.235.88,1.964,1.964,0,0,0,1.672.914,1.926,1.926,0,0,0,.9-.224,2.111,2.111,0,0,1,2.872.76l.684,1.18a2.027,2.027,0,0,1-.756,2.831,1.829,1.829,0,0,0-.853,1.138,1.771,1.771,0,0,0,.2,1.362,1.571,1.571,0,0,0,.634.64,2.307,2.307,0,0,1,.828.789,2.031,2.031,0,0,1-.02,2.05l-.715,1.2a2.1,2.1,0,0,1-2.893.74,1.621,1.621,0,0,0-.9-.23,1.9,1.9,0,0,0-1.891,1.82A2.061,2.061,0,0,1,10.2,20ZM9.512,7.18a2.87,2.87,0,0,0-2.9,2.83,2.763,2.763,0,0,0,.849,2,2.93,2.93,0,0,0,2.053.821A2.822,2.822,0,0,0,11.55,8.006,2.877,2.877,0,0,0,9.512,7.18Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.9,5.65A2.853,2.853,0,0,1,0,2.83,2.861,2.861,0,0,1,2.9,0a2.825,2.825,0,1,1,0,5.65",
            transform: "translate(6.61 7.18)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M18.73,12.37a2.3,2.3,0,0,0-.828-.79,1.547,1.547,0,0,1-.634-.64,1.822,1.822,0,0,1,.654-2.5,2.027,2.027,0,0,0,.756-2.83l-.685-1.18a2.112,2.112,0,0,0-2.872-.76,1.973,1.973,0,0,1-2.575-.69,1.546,1.546,0,0,1-.235-.88,1.778,1.778,0,0,0-.276-1.06A2.152,2.152,0,0,0,10.217,0H8.776A2.195,2.195,0,0,0,6.967,1.04,1.785,1.785,0,0,0,6.681,2.1a1.546,1.546,0,0,1-.235.88,1.963,1.963,0,0,1-2.565.69A2.124,2.124,0,0,0,1,4.43L.314,5.61a2.044,2.044,0,0,0,.756,2.83,1.834,1.834,0,0,1,.664,2.5,1.634,1.634,0,0,1-.644.64,2.118,2.118,0,0,0-.818.79,2,2,0,0,0,.02,2.05L1,15.62a2.134,2.134,0,0,0,1.819,1.04,2.161,2.161,0,0,0,1.083-.3,1.586,1.586,0,0,1,.9-.23,1.892,1.892,0,0,1,1.88,1.82A2.07,2.07,0,0,0,8.807,20H10.2a2.068,2.068,0,0,0,2.115-2.05A1.908,1.908,0,0,1,14.2,16.13a1.63,1.63,0,0,1,.9.23,2.1,2.1,0,0,0,2.892-.74l.715-1.2a2.018,2.018,0,0,0,.02-2.05",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 1.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M17.528,5.346l-.622-1.08a1.913,1.913,0,0,0-2.609-.7h0a1.9,1.9,0,0,1-2.609-.677,1.831,1.831,0,0,1-.256-.915h0A1.913,1.913,0,0,0,9.519,0H8.265a1.9,1.9,0,0,0-1.9,1.913h0A1.913,1.913,0,0,1,4.448,3.8a1.831,1.831,0,0,1-.915-.256h0a1.913,1.913,0,0,0-2.609.7l-.668,1.1a1.913,1.913,0,0,0,.7,2.609h0a1.913,1.913,0,0,1,.957,1.657,1.913,1.913,0,0,1-.957,1.657h0a1.9,1.9,0,0,0-.7,2.6h0l.632,1.089A1.913,1.913,0,0,0,3.5,15.7h0a1.895,1.895,0,0,1,2.6.7,1.831,1.831,0,0,1,.256.915h0a1.913,1.913,0,0,0,1.913,1.913H9.519a1.913,1.913,0,0,0,1.913-1.9h0a1.9,1.9,0,0,1,1.913-1.913,1.95,1.95,0,0,1,.915.256h0a1.913,1.913,0,0,0,2.609-.7h0l.659-1.1a1.9,1.9,0,0,0-.7-2.609h0a1.9,1.9,0,0,1-.7-2.609,1.876,1.876,0,0,1,.7-.7h0a1.913,1.913,0,0,0,.7-2.6h0Z",
            transform: "translate(0.779 0.778)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("circle", {
            cx: "2.636",
            cy: "2.636",
            r: "2.636",
            transform: "translate(7.039 7.753)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.175,17.365a.991.991,0,0,0-.143-.527,1.112,1.112,0,0,0-1.493-.4,2.736,2.736,0,0,1-3.6-.949L.329,14.449A2.6,2.6,0,0,1,1.3,10.935a1.1,1.1,0,0,0,.4-.386,1.043,1.043,0,0,0,.179-.85A1.07,1.07,0,0,0,1.345,9,2.6,2.6,0,0,1,.374,5.49a.785.785,0,0,1,.5-.327.8.8,0,0,1,.589.115A.745.745,0,0,1,1.687,6.3a1.05,1.05,0,0,0,.4,1.449,2.586,2.586,0,0,1-.036,4.47,1.051,1.051,0,0,0-.405,1.45l.621,1.045a1.067,1.067,0,0,0,.662.5,1.091,1.091,0,0,0,.831-.118,2.648,2.648,0,0,1,1.322-.342,2.667,2.667,0,0,1,2.7,2.635,1.086,1.086,0,0,0,1.1,1.063l-.009.017a.787.787,0,0,1,.678.383.75.75,0,0,1,0,.764A.789.789,0,0,1,8.874,20,2.668,2.668,0,0,1,6.175,17.365Zm5.028.079a2.628,2.628,0,0,1,1.346-2.227,2.758,2.758,0,0,1,2.648-.031,1.093,1.093,0,0,0,.827.114,1.124,1.124,0,0,0,.666-.5l.611-1.046a1.033,1.033,0,0,0,.113-.806,1.059,1.059,0,0,0-.509-.644,2.571,2.571,0,0,1-.98-1.045A2.6,2.6,0,0,1,16.9,7.747a.811.811,0,0,1,1.062.29.754.754,0,0,1-.27,1.045,1.1,1.1,0,0,0-.4.387,1.038,1.038,0,0,0-.113.809,1.066,1.066,0,0,0,.509.649,2.6,2.6,0,0,1,.935,3.6l-.611,1.045a2.735,2.735,0,0,1-3.6.949,1.1,1.1,0,0,0-1.1-.01,1.05,1.05,0,0,0-.54.932.794.794,0,0,1-1.574,0Zm-4.1-5.1a3.237,3.237,0,0,1-.737-3.6A3.375,3.375,0,0,1,9.494,6.7H9.5a3.392,3.392,0,0,1,2.38.961A3.235,3.235,0,0,1,12.876,10a3.291,3.291,0,0,1-2.082,3.057,3.442,3.442,0,0,1-3.689-.71ZM7.7,10a1.8,1.8,0,1,0,1.8-1.757A1.78,1.78,0,0,0,7.7,10Zm9-4.726A1.112,1.112,0,0,0,15.2,4.892a2.754,2.754,0,0,1-2.644-.029A2.624,2.624,0,0,1,11.2,2.644a1.05,1.05,0,0,0-.306-.775,1.1,1.1,0,0,0-.782-.323H8.883a1.108,1.108,0,0,0-.786.323,1.056,1.056,0,0,0-.312.775,2.581,2.581,0,0,1-1.343,2.23,2.709,2.709,0,0,1-2.651-.017l-.036-.035A.755.755,0,0,1,3.5,3.768a.8.8,0,0,1,1.08-.246,1.151,1.151,0,0,0,.539.148,1.109,1.109,0,0,0,.789-.282,1.064,1.064,0,0,0,.353-.745A2.665,2.665,0,0,1,8.883,0h1.232a2.667,2.667,0,0,1,2.7,2.635.989.989,0,0,0,.144.526,1.084,1.084,0,0,0,.662.5,1.114,1.114,0,0,0,.831-.106,2.735,2.735,0,0,1,3.6.949.772.772,0,0,1-.288,1.045.8.8,0,0,1-.392.1A.794.794,0,0,1,16.691,5.279Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 1.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M17.528,5.346l-.622-1.08a1.913,1.913,0,0,0-2.609-.7h0a1.9,1.9,0,0,1-2.609-.677,1.831,1.831,0,0,1-.256-.915h0A1.913,1.913,0,0,0,9.519,0H8.265a1.9,1.9,0,0,0-1.9,1.913h0A1.913,1.913,0,0,1,4.448,3.8a1.831,1.831,0,0,1-.915-.256h0a1.913,1.913,0,0,0-2.609.7l-.668,1.1a1.913,1.913,0,0,0,.7,2.609h0a1.913,1.913,0,0,1,.957,1.657,1.913,1.913,0,0,1-.957,1.657h0a1.9,1.9,0,0,0-.7,2.6h0l.632,1.089A1.913,1.913,0,0,0,3.5,15.7h0a1.895,1.895,0,0,1,2.6.7,1.831,1.831,0,0,1,.256.915h0a1.913,1.913,0,0,0,1.913,1.913H9.519a1.913,1.913,0,0,0,1.913-1.9h0a1.9,1.9,0,0,1,1.913-1.913,1.95,1.95,0,0,1,.915.256h0a1.913,1.913,0,0,0,2.609-.7h0l.659-1.1a1.9,1.9,0,0,0-.7-2.609h0a1.9,1.9,0,0,1-.7-2.609,1.876,1.876,0,0,1,.7-.7h0a1.913,1.913,0,0,0,.7-2.6h0Z",
            transform: "translate(0.779 0.778)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("circle", {
            cx: "2.636",
            cy: "2.636",
            r: "2.636",
            transform: "translate(7.039 7.753)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.5,0A2.5,2.5,0,1,1,0,2.5,2.5,2.5,0,0,1,2.5,0Z",
            transform: "translate(6 7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M16.668,4.75h0a2.464,2.464,0,0,0-3.379-.912,1.543,1.543,0,0,1-2.314-1.346A2.484,2.484,0,0,0,8.5,0h0A2.484,2.484,0,0,0,6.025,2.492,1.543,1.543,0,0,1,3.712,3.839a2.465,2.465,0,0,0-3.38.912,2.5,2.5,0,0,0,.906,3.4,1.56,1.56,0,0,1,0,2.692,2.5,2.5,0,0,0-.906,3.4,2.465,2.465,0,0,0,3.379.913h0a1.542,1.542,0,0,1,2.313,1.345h0A2.484,2.484,0,0,0,8.5,19h0a2.484,2.484,0,0,0,2.474-2.492h0a1.543,1.543,0,0,1,2.314-1.345,2.465,2.465,0,0,0,3.379-.913,2.5,2.5,0,0,0-.905-3.4h0a1.56,1.56,0,0,1,0-2.692A2.5,2.5,0,0,0,16.668,4.75Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$qr.displayName = "IconlySetting", $63c37e44f569564f$var$qr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$805dc0bee9369f09 = $63c37e44f569564f$var$st($63c37e44f569564f$var$qr), $63c37e44f569564f$var$Rr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.34,20H5.67C2.279,20,0,17.624,0,14.089V5.919C0,2.379,2.279,0,5.67,0h8.67C17.725,0,20,2.379,20,5.919v8.169C20,17.624,17.725,20,14.34,20ZM9.65,4.919a.76.76,0,0,0-.75.75V10.72a.733.733,0,0,0,.37.64l3.92,2.34a.7.7,0,0,0,.39.11.745.745,0,0,0,.64-.37.72.72,0,0,0,.09-.552.762.762,0,0,0-.35-.477L10.4,10.29V5.669A.751.751,0,0,0,9.65,4.919Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.34,0H5.67C2.28,0,0,2.38,0,5.92v8.17C0,17.62,2.28,20,5.67,20h8.67C17.73,20,20,17.62,20,14.09V5.92C20,2.38,17.73,0,14.34,0",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.675,8.889a.756.756,0,0,1-.384-.1L.365,6.442A.754.754,0,0,1,0,5.8V.75a.75.75,0,0,1,1.5,0V5.371L5.06,7.494a.75.75,0,0,1-.385,1.395",
            transform: "translate(8.898 4.925)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.884,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.751 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.391,6.384,0,4.361V0",
            transform: "translate(10 5.634)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.244,20C2.392,20,0,17.608,0,13.753a.765.765,0,0,1,1.53,0c0,3.034,1.671,4.714,4.723,4.714h7.492c3.044,0,4.723-1.671,4.723-4.714v-7.5c0-3.043-1.67-4.723-4.723-4.723H6.253C3.21,1.53,1.53,3.21,1.53,6.253V8.584a.756.756,0,0,1-.756.756H.763A.763.763,0,0,1,0,8.575V6.253C0,2.393,2.41,0,6.254,0h7.492C17.608,0,20,2.393,20,6.256v7.5C20,17.608,17.608,20,13.747,20Zm6.763-7.338-3.39-2.023a.751.751,0,0,1-.366-.645V5.634a.75.75,0,1,1,1.5,0V9.569l3.026,1.8a.751.751,0,0,1-.769,1.29Z",
            transform: "translate(0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.884,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z",
            transform: "translate(0.751 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.391,6.384,0,4.361V0",
            transform: "translate(10 5.634)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.391,6.384,0,4.361V0",
            transform: "translate(9.999 5.634)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Rr.displayName = "IconlyTimeSquare", $63c37e44f569564f$var$Rr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$4599687b619f9bdc = $63c37e44f569564f$var$st($63c37e44f569564f$var$Rr), $63c37e44f569564f$var$Fr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,20A10,10,0,1,1,10,0a10,10,0,0,1,7.074,17.074A9.936,9.936,0,0,1,10,20ZM9.65,4.93a.751.751,0,0,0-.75.75v5.05a.747.747,0,0,0,.37.64l3.92,2.34a.764.764,0,0,0,.39.111.746.746,0,0,0,.64-.371.756.756,0,0,0-.26-1.03L10.4,10.3V5.68A.751.751,0,0,0,9.65,4.93Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.675,8.889a.756.756,0,0,1-.384-.1L.365,6.442A.754.754,0,0,1,0,5.8V.75a.75.75,0,0,1,1.5,0V5.371L5.06,7.494a.75.75,0,0,1-.385,1.395",
            transform: "translate(8.899 4.925)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M18.5,9.25A9.25,9.25,0,1,1,9.25,0,9.25,9.25,0,0,1,18.5,9.25Z",
            transform: "translate(0.75 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.77,7.1,0,4.847V0",
            transform: "translate(9.661 5.847)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M2.073,16.1a.727.727,0,0,1,1.152-.888A8.548,8.548,0,1,0,1.455,10a8.635,8.635,0,0,0,.1,1.3.727.727,0,0,1-.608.828.719.719,0,0,1-.828-.608A10,10,0,1,1,2.073,16.1Zm11-2.524L9.288,11.32a.73.73,0,0,1-.354-.625V5.837a.727.727,0,1,1,1.453,0v4.446l3.425,2.042a.727.727,0,0,1-.744,1.249Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M18.5,9.25A9.25,9.25,0,1,1,9.25,0,9.25,9.25,0,0,1,18.5,9.25Z",
            transform: "translate(0.75 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.77,7.1,0,4.847V0",
            transform: "translate(9.661 5.847)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M18.5,9.25A9.25,9.25,0,1,1,9.25,0,9.25,9.25,0,0,1,18.5,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.53,4.921,0,4.847V0",
            transform: "translate(9.661 5.846)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Fr.displayName = "IconlyTimeCircle", $63c37e44f569564f$var$Fr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$81a9b13d3f8e805e = $63c37e44f569564f$var$st($63c37e44f569564f$var$Fr), $63c37e44f569564f$var$Br = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.677,18a2.693,2.693,0,0,1-1.588-.676l-3.526-2.94H2.752A2.645,2.645,0,0,1,.145,11.8a27.953,27.953,0,0,1,0-5.677,2.7,2.7,0,0,1,2.607-2.51H4.563l3.46-2.9A3.014,3.014,0,0,1,9.758,0a2.548,2.548,0,0,1,2.368,1.956,10.232,10.232,0,0,1,.231,1.495l.048.442a96.7,96.7,0,0,1,0,10.216l-.048.458a9.034,9.034,0,0,1-.224,1.453A2.54,2.54,0,0,1,9.782,18Zm8.614-.22a.957.957,0,0,1-.23-1.308A13.405,13.405,0,0,0,20.165,9,13.4,13.4,0,0,0,18.06,1.529.958.958,0,0,1,18.29.221a.9.9,0,0,1,1.277.236A15.319,15.319,0,0,1,22,9a15.318,15.318,0,0,1-2.433,8.544.912.912,0,0,1-.753.4A.9.9,0,0,1,18.291,17.78Zm-3.162-3.038a.957.957,0,0,1-.23-1.308A7.957,7.957,0,0,0,16.143,9,7.955,7.955,0,0,0,14.9,4.566a.957.957,0,0,1,.229-1.308.907.907,0,0,1,1.279.237A9.878,9.878,0,0,1,17.978,9a9.878,9.878,0,0,1-1.571,5.505.9.9,0,0,1-1.278.237Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.357,3.451a10.165,10.165,0,0,0-.232-1.494A2.547,2.547,0,0,0,9.758,0,3.014,3.014,0,0,0,8.022.719l-3.459,2.9H2.752A2.7,2.7,0,0,0,.145,6.127a27.9,27.9,0,0,0,0,5.677,2.644,2.644,0,0,0,2.607,2.579H4.563l3.526,2.941A2.694,2.694,0,0,0,9.677,18h.1a2.539,2.539,0,0,0,2.351-1.981,9.044,9.044,0,0,0,.224-1.453l.047-.458a96.5,96.5,0,0,0,0-10.215Z",
            transform: "translate(0 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M1.671.4A.907.907,0,0,0,.392.167.957.957,0,0,0,.164,1.475,7.956,7.956,0,0,1,1.407,5.909,7.959,7.959,0,0,1,.164,10.343a.956.956,0,0,0,.23,1.308.9.9,0,0,0,1.277-.236A9.876,9.876,0,0,0,3.242,5.909,9.876,9.876,0,0,0,1.671.4",
            transform: "translate(14.736 3.091)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M1.67.4A.905.905,0,0,0,.393.167a.958.958,0,0,0-.23,1.308,13.407,13.407,0,0,1,2.1,7.471,13.408,13.408,0,0,1-2.1,7.472.957.957,0,0,0,.231,1.308.9.9,0,0,0,.522.167.912.912,0,0,0,.754-.4A15.317,15.317,0,0,0,4.1,8.946,15.319,15.319,0,0,0,1.67.4",
            transform: "translate(17.898 0.054)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1.6 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.871,12.892a12.254,12.254,0,0,1-.252,1.759A1.728,1.728,0,0,1,8.98,16a1.963,1.963,0,0,1-1.143-.471L4.07,12.469h-2.1A1.831,1.831,0,0,1,.141,10.644a25.553,25.553,0,0,1,0-5.35A1.882,1.882,0,0,1,1.972,3.532h2.1L7.759.525A2.264,2.264,0,0,1,8.98,0a1.729,1.729,0,0,1,1.639,1.349,13.9,13.9,0,0,1,.252,1.76A93.1,93.1,0,0,1,10.871,12.892Z",
            transform: "translate(0 0.25)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A8.794,8.794,0,0,1,1.453,5.008,8.791,8.791,0,0,1,0,10.015",
            transform: "translate(14.843 3.06)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A14.165,14.165,0,0,1,2.341,8.068,14.169,14.169,0,0,1,0,16.137",
            transform: "translate(18.274 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M18.376,18.855a.831.831,0,0,1-.193-1.124,13.664,13.664,0,0,0,1.923-4.763.782.782,0,0,1,.919-.618.807.807,0,0,1,.59.961,15.348,15.348,0,0,1-2.165,5.343.765.765,0,0,1-.635.346A.743.743,0,0,1,18.376,18.855Zm-8.869-.323a2.626,2.626,0,0,1-1.562-.677L4.269,14.72a.832.832,0,0,1-.112-1.136.749.749,0,0,1,1.086-.116l3.688,3.145a1.086,1.086,0,0,0,.615.3c.381.027.739-.314.881-.812a7.923,7.923,0,0,0,.17-1.178c.015-.166.032-.329.05-.495.161-1.338.161-8.522,0-9.859L10.6,4.1a9.245,9.245,0,0,0-.18-1.234c-.134-.47-.5-.825-.833-.783a1.542,1.542,0,0,0-.719.346l-3.622,3.1a.75.75,0,0,1-.49.184H2.7c-.648,0-.955.575-1.027,1.114a26.916,26.916,0,0,0,0,5.278.8.8,0,0,1-.657.912.786.786,0,0,1-.872-.689,28.568,28.568,0,0,1,0-5.712A2.677,2.677,0,0,1,2.7,4.1h1.78l3.4-2.909A3.024,3.024,0,0,1,9.58.468a2.531,2.531,0,0,1,2.327,1.963,10.383,10.383,0,0,1,.228,1.5l.046.442a98.418,98.418,0,0,1,0,10.255l-.046.456a9.177,9.177,0,0,1-.222,1.46,2.505,2.505,0,0,1-2.307,1.989C9.571,18.532,9.54,18.531,9.507,18.532Zm5.336-2.975a.832.832,0,0,1-.193-1.125A8.982,8.982,0,0,0,16.008,9.5a8.984,8.984,0,0,0-1.359-4.933.831.831,0,0,1,.193-1.124.752.752,0,0,1,1.075.2A10.67,10.67,0,0,1,17.553,9.5a10.666,10.666,0,0,1-1.635,5.855.761.761,0,0,1-.634.346A.749.749,0,0,1,14.843,15.557ZM20.455,9.5a15,15,0,0,0-2.272-8.231A.835.835,0,0,1,18.375.143a.755.755,0,0,1,1.076.2A16.673,16.673,0,0,1,22,9.5a.773.773,0,1,1-1.544,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1.6 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.871,12.892a12.254,12.254,0,0,1-.252,1.759A1.728,1.728,0,0,1,8.98,16a1.963,1.963,0,0,1-1.143-.471L4.07,12.469h-2.1A1.831,1.831,0,0,1,.141,10.644a25.553,25.553,0,0,1,0-5.35A1.882,1.882,0,0,1,1.972,3.532h2.1L7.759.525A2.264,2.264,0,0,1,8.98,0a1.729,1.729,0,0,1,1.639,1.349,13.9,13.9,0,0,1,.252,1.76A93.1,93.1,0,0,1,10.871,12.892Z",
            transform: "translate(0 0.25)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A8.794,8.794,0,0,1,1.453,5.008,8.791,8.791,0,0,1,0,10.015",
            transform: "translate(14.843 3.06)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A14.165,14.165,0,0,1,2.341,8.068,14.169,14.169,0,0,1,0,16.137",
            transform: "translate(18.274 0)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0A11.128,11.128,0,0,1,0,12.357",
            transform: "translate(17.436 1.274)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A7.74,7.74,0,0,1,0,7.472",
            transform: "translate(14.989 3.717)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,6.771c0,1.246,0,2.708,1.029,3.582s1.846.514,3.178.952,3.2,3.146,5.261,1.924c1.115-.792,1.64-2.286,1.64-6.457s-.5-5.649-1.64-6.457C7.407-.908,5.54,1.8,4.208,2.238s-2.148.078-3.178.952S0,5.525,0,6.771Z",
            transform: "translate(0.682 0.682)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Br.displayName = "IconlyVolumeUp", $63c37e44f569564f$var$Br.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$dd4dac99f7f06e6c = $63c37e44f569564f$var$st($63c37e44f569564f$var$Br), $63c37e44f569564f$var$Jr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.689,18A2.694,2.694,0,0,1,8.1,17.323l-3.531-2.94H2.755A2.646,2.646,0,0,1,.145,11.8a27.888,27.888,0,0,1,0-5.677,2.7,2.7,0,0,1,2.61-2.51H4.568L8.032.719A3.022,3.022,0,0,1,9.769,0a2.548,2.548,0,0,1,2.37,1.956,10.116,10.116,0,0,1,.232,1.495l.048.442a96.7,96.7,0,0,1,0,10.216l-.048.458a9.034,9.034,0,0,1-.224,1.453A2.542,2.542,0,0,1,9.793,18Zm5.459-3.257a.955.955,0,0,1-.23-1.308A7.955,7.955,0,0,0,16.163,9a7.952,7.952,0,0,0-1.246-4.434.955.955,0,0,1,.23-1.308.91.91,0,0,1,1.278.237A9.869,9.869,0,0,1,18,9a9.869,9.869,0,0,1-1.574,5.505.914.914,0,0,1-.754.4A.9.9,0,0,1,15.148,14.742Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.372,3.451a10.154,10.154,0,0,0-.232-1.494A2.549,2.549,0,0,0,9.769,0,3.02,3.02,0,0,0,8.032.719l-3.463,2.9H2.755a2.7,2.7,0,0,0-2.61,2.51,27.871,27.871,0,0,0,0,5.677,2.646,2.646,0,0,0,2.61,2.579H4.568L8.1,17.324A2.7,2.7,0,0,0,9.688,18h.1a2.542,2.542,0,0,0,2.354-1.981,9.035,9.035,0,0,0,.225-1.453l.047-.458a96.385,96.385,0,0,0,0-10.215Z",
            transform: "translate(0 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M1.672.4A.91.91,0,0,0,.394.166a.955.955,0,0,0-.23,1.308A7.954,7.954,0,0,1,1.409,5.908,7.957,7.957,0,0,1,.164,10.342a.955.955,0,0,0,.23,1.308.9.9,0,0,0,.524.167.915.915,0,0,0,.755-.4A9.872,9.872,0,0,0,3.246,5.908,9.872,9.872,0,0,0,1.672.4",
            transform: "translate(14.754 3.092)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.871,12.892a12.254,12.254,0,0,1-.252,1.759A1.728,1.728,0,0,1,8.98,16a1.963,1.963,0,0,1-1.143-.471L4.07,12.469h-2.1A1.832,1.832,0,0,1,.14,10.644a25.623,25.623,0,0,1,0-5.35A1.883,1.883,0,0,1,1.971,3.532h2.1L7.759.525A2.264,2.264,0,0,1,8.98,0a1.729,1.729,0,0,1,1.639,1.349,13.9,13.9,0,0,1,.252,1.76A93.092,93.092,0,0,1,10.871,12.892Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A9.312,9.312,0,0,1,1.538,5.3,9.308,9.308,0,0,1,0,10.6",
            transform: "translate(14.717 2.574)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.75,18a2.736,2.736,0,0,1-1.6-.675L4.377,14.2a.813.813,0,0,1-.113-1.132.784.784,0,0,1,1.114-.116l3.781,3.135a1.114,1.114,0,0,0,.632.3.978.978,0,0,0,.9-.807,7.4,7.4,0,0,0,.175-1.174c.015-.165.031-.328.051-.494.164-1.334.164-8.491,0-9.823l-.05-.47a9.329,9.329,0,0,0-.183-1.229c-.139-.467-.511-.822-.855-.779a1.586,1.586,0,0,0-.738.345L5.379,5.045a.785.785,0,0,1-.5.183H2.77a1.128,1.128,0,0,0-1.054,1.11,25.983,25.983,0,0,0,0,5.259.8.8,0,0,1-.674.91.8.8,0,0,1-.894-.688,27.583,27.583,0,0,1,0-5.692A2.708,2.708,0,0,1,2.77,3.619H4.595L8.079.72A3.156,3.156,0,0,1,9.824,0a2.577,2.577,0,0,1,2.388,1.957,9.961,9.961,0,0,1,.233,1.5l.048.44a95.291,95.291,0,0,1,0,10.217l-.048.455a8.866,8.866,0,0,1-.228,1.454A2.55,2.55,0,0,1,9.851,18C9.816,18,9.784,18,9.75,18Zm5.472-2.965a.813.813,0,0,1-.2-1.12A8.773,8.773,0,0,0,16.417,9a8.764,8.764,0,0,0-1.392-4.914.816.816,0,0,1,.2-1.122.786.786,0,0,1,1.1.2A10.406,10.406,0,0,1,18,9a10.405,10.405,0,0,1-1.676,5.835.785.785,0,0,1-1.1.2Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.871,12.892a12.254,12.254,0,0,1-.252,1.759A1.728,1.728,0,0,1,8.98,16a1.963,1.963,0,0,1-1.143-.471L4.07,12.469h-2.1A1.832,1.832,0,0,1,.14,10.644a25.623,25.623,0,0,1,0-5.35A1.883,1.883,0,0,1,1.971,3.532h2.1L7.759.525A2.264,2.264,0,0,1,8.98,0a1.729,1.729,0,0,1,1.639,1.349,13.9,13.9,0,0,1,.252,1.76A93.092,93.092,0,0,1,10.871,12.892Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A9.312,9.312,0,0,1,1.538,5.3,9.308,9.308,0,0,1,0,10.6",
            transform: "translate(14.717 2.574)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0A7.568,7.568,0,0,1,0,7.306",
            transform: "translate(14.656 3.635)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,6.621c0,1.219,0,2.648,1.006,3.5s1.805.5,3.108.931,3.128,3.076,5.144,1.881c1.09-.774,1.6-2.236,1.6-6.314S10.371,1.1,9.258.307C7.242-.888,5.417,1.76,4.114,2.188s-2.1.076-3.108.931S0,5.4,0,6.621Z",
            transform: "translate(0.667 0.666)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Jr.displayName = "IconlyVolumeDown", $63c37e44f569564f$var$Jr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$1a45e6e3385a89f1 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Jr), $63c37e44f569564f$var$Qr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M.274,18.733a.929.929,0,0,1,0-1.314L3.1,14.593H3.068A2.637,2.637,0,0,1,.443,12.052a27.39,27.39,0,0,1,0-5.6A2.683,2.683,0,0,1,3.068,3.987H4.9L8.392,1.13A3.184,3.184,0,0,1,10.149.42a2.539,2.539,0,0,1,2.382,1.925,8.172,8.172,0,0,1,.234,1.472l.084.677c.014.1.026.2.037.309L17.42.271a.926.926,0,0,1,1.309,1.31L1.58,18.729A.947.947,0,0,1,.924,19,.964.964,0,0,1,.274,18.733Zm9.79-.572a2.746,2.746,0,0,1-1.6-.666l-1.3-1.006a.872.872,0,0,1-.071-1.294c.277-.338,4.648-4.322,4.792-4.463a.843.843,0,0,1,.607-.2c.389.1.464.656.458,1.094-.018,1.273-.06,2.157-.128,2.7l-.048.451a8.6,8.6,0,0,1-.228,1.432,2.546,2.546,0,0,1-2.372,1.952Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.765,17.743a2.756,2.756,0,0,1-1.6-.665l-1.3-1.007a.873.873,0,0,1-.071-1.294c.277-.339,4.648-4.321,4.792-4.463a.845.845,0,0,1,.607-.2c.389.1.464.658.459,1.1-.018,1.272-.061,2.156-.129,2.7l-.048.452a8.817,8.817,0,0,1-.227,1.432,2.547,2.547,0,0,1-2.372,1.952C9.836,17.744,9.8,17.744,9.765,17.743Zm-7-3.568a2.637,2.637,0,0,1-2.625-2.54,27.518,27.518,0,0,1,0-5.6A2.686,2.686,0,0,1,2.768,3.569H4.6L8.094.709A3.208,3.208,0,0,1,9.851,0a2.539,2.539,0,0,1,2.381,1.928,8.127,8.127,0,0,1,.233,1.47l.085.679c.022.158.042.3.053.487L2.991,14.174Z",
            transform: "translate(0.299 0.418)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M18.728.27a.926.926,0,0,0-1.307,0L.27,17.419a.929.929,0,0,0,0,1.314A.963.963,0,0,0,.925,19a.946.946,0,0,0,.655-.271L18.729,1.581a.927.927,0,0,0,0-1.311",
            transform: "translate(0 0)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.1,12.6H1.984A1.845,1.845,0,0,1,.141,10.753a25.917,25.917,0,0,1,0-5.406A1.9,1.9,0,0,1,1.984,3.568H4.1L7.809.53A2.278,2.278,0,0,1,9.039,0a1.742,1.742,0,0,1,1.651,1.363,14.268,14.268,0,0,1,.253,1.777A11.67,11.67,0,0,1,11.069,5.4",
            transform: "translate(0.795 1.286)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.574,0c-.019,1.336-.065,2.149-.123,2.618A12.555,12.555,0,0,1,4.2,4.394,1.741,1.741,0,0,1,2.548,5.757,1.968,1.968,0,0,1,1.4,5.281L0,4.142",
            transform: "translate(7.286 11.691)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M17.148,0,0,17.148",
            transform: "translate(0.848 0.794)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M.288,18.764a.809.809,0,0,1,0-1.139l10.9-10.934a11.738,11.738,0,0,0-.085-1.831L11.02,4.12a8.971,8.971,0,0,0-.184-1.231.985.985,0,0,0-.848-.779H9.967a1.654,1.654,0,0,0-.748.344L5.453,5.545a.8.8,0,0,1-.508.182H2.808A1.136,1.136,0,0,0,1.74,6.838a25.724,25.724,0,0,0,0,5.259.8.8,0,0,1-.683.909.683.683,0,0,1-.112.008A.8.8,0,0,1,.15,12.32a27.344,27.344,0,0,1,0-5.692,2.732,2.732,0,0,1,2.66-2.512h1.85l3.533-2.9A3.309,3.309,0,0,1,9.963.5,2.607,2.607,0,0,1,12.38,2.455a9.965,9.965,0,0,1,.237,1.495l.082.683c.023.162.041.3.056.491L17.629.235a.8.8,0,1,1,1.136,1.139L1.424,18.764a.8.8,0,0,1-1.136,0ZM9.881,18.5a2.794,2.794,0,0,1-1.621-.674l-1.4-1.147a.8.8,0,0,1,1.015-1.247l1.411,1.155a1.324,1.324,0,0,0,.635.3c.007,0,.015,0,.024,0a1,1,0,0,0,.9-.808,7.672,7.672,0,0,0,.176-1.175q.023-.246.052-.493c.06-.492.1-1.355.119-2.57A.79.79,0,0,1,12,11.051a.8.8,0,0,1,.791.817c-.018,1.292-.06,2.188-.129,2.741l-.049.457a8.787,8.787,0,0,1-.229,1.454,2.579,2.579,0,0,1-2.4,1.982Z",
            transform: "translate(0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.084,12.373a1.7,1.7,0,0,1-.631-.635,2.556,2.556,0,0,1-.311-.984,25.917,25.917,0,0,1,0-5.406A1.9,1.9,0,0,1,1.985,3.569H4.1L7.811.53A2.29,2.29,0,0,1,9.04,0a1.742,1.742,0,0,1,1.65,1.364,9.605,9.605,0,0,1,.256,1.481",
            transform: "translate(0 0.491)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.574,0c-.019,1.335-.065,2.148-.123,2.617A12.534,12.534,0,0,1,4.2,4.393,1.743,1.743,0,0,1,2.548,5.757,1.977,1.977,0,0,1,1.4,5.28L0,4.141",
            transform: "translate(6.492 10.898)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M17.148,0,0,17.148",
            transform: "translate(0.054 0)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M3.732,11.008c-1.083-.251-1.816-.054-2.72-.814C0,9.335-.008,7.895,0,6.669-.008,5.443,0,4,1.012,3.144s1.816-.51,3.132-.939,3.141-3.1,5.172-1.9c.823.582,1.306,1.53,1.5,3.615",
            transform: "translate(0.671 1.545)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.509,0c-.116,3.006-.635,4.214-1.593,4.894A2.583,2.583,0,0,1,0,4.509",
            transform: "translate(7.07 9.672)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M15.345,0,0,15.345",
            transform: "translate(0.941 0.671)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Qr.displayName = "IconlyVolumeOff", $63c37e44f569564f$var$Qr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$5cd3850cf086982a = $63c37e44f569564f$var$st($63c37e44f569564f$var$Qr), $63c37e44f569564f$var$Xr = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.919,11.82a1.1,1.1,0,0,0-.319.97l.889,4.92a1.08,1.08,0,0,1-.45,1.08,1.1,1.1,0,0,1-1.17.08L10.44,16.56a1.131,1.131,0,0,0-.5-.131H9.669a.812.812,0,0,0-.27.09L4.969,18.84a1.168,1.168,0,0,1-.71.11,1.112,1.112,0,0,1-.89-1.271l.89-4.92a1.119,1.119,0,0,0-.319-.979L.329,8.28A1.08,1.08,0,0,1,.06,7.15,1.123,1.123,0,0,1,.949,6.4l4.97-.721A1.112,1.112,0,0,0,6.8,5.07L8.989.58a1.041,1.041,0,0,1,.2-.27l.09-.07A.671.671,0,0,1,9.44.11L9.549.07,9.719,0h.421a1.119,1.119,0,0,1,.88.6l2.219,4.47a1.111,1.111,0,0,0,.83.609l4.97.721a1.134,1.134,0,0,1,.91.75,1.086,1.086,0,0,1-.29,1.13Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.976.614,13.2,5.088a1.112,1.112,0,0,0,.838.6l5,.728a1.121,1.121,0,0,1,.736.43,1.082,1.082,0,0,1,.21.815,1.112,1.112,0,0,1-.321.632l-3.624,3.513a1.056,1.056,0,0,0-.321.963l.892,4.939a1.115,1.115,0,0,1-.892,1.272,1.168,1.168,0,0,1-.714-.114l-4.461-2.324a1.169,1.169,0,0,0-1.053,0L5.033,18.866A1.143,1.143,0,0,1,3.5,18.419a1.131,1.131,0,0,1-.116-.7l.892-4.94a1.061,1.061,0,0,0-.321-.964L.332,8.3A1.084,1.084,0,0,1,.3,6.772l.029-.029a1.078,1.078,0,0,1,.642-.315l5-.729a1.114,1.114,0,0,0,.838-.6L8.96.614A1.107,1.107,0,0,1,9.977,0h.134a1.116,1.116,0,0,1,.865.613",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M9.992,16.417a1.226,1.226,0,0,0-.552.151L5,18.887a1.158,1.158,0,0,1-1.5-.461,1.106,1.106,0,0,1-.116-.694L4.274,12.8a1.1,1.1,0,0,0-.321-.975L.328,8.318A1.093,1.093,0,0,1,.311,6.774l.017-.016A1.134,1.134,0,0,1,.96,6.441L5.965,5.7A1.083,1.083,0,0,0,6.8,5.1L8.978.563A1.106,1.106,0,0,1,10,0c-.008.3-.008,16.213-.008,16.415",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.214.441,12.53,5.1a.8.8,0,0,0,.6.437l5.185.749a.8.8,0,0,1,.528.306.77.77,0,0,1-.085,1.032L15,11.258a.762.762,0,0,0-.226.7l.9,5.128a.787.787,0,0,1-.652.892.868.868,0,0,1-.516-.08L9.888,15.478a.776.776,0,0,0-.742,0L4.494,17.912a.812.812,0,0,1-1.077-.33.8.8,0,0,1-.081-.5l.9-5.128a.788.788,0,0,0-.226-.7L.232,7.621a.786.786,0,0,1,0-1.112l0,0a.909.909,0,0,1,.452-.222L5.87,5.534a.812.812,0,0,0,.6-.438L8.784.441a.787.787,0,0,1,.458-.4.8.8,0,0,1,.61.044A.82.82,0,0,1,10.214.441Z",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.5,19.919a.67.67,0,0,1-.352-.09l-5.138-2.706L5.484,19.559a1.521,1.521,0,0,1-2.062-.613l-.015-.028a1.64,1.64,0,0,1-.158-1l.88-5.194L.451,9a1.6,1.6,0,0,1,0-2.227,1.494,1.494,0,0,1,.88-.451l5.043-.766L8.617.883a1.515,1.515,0,0,1,2.754,0l2.253,4.689,5.06.775a1.525,1.525,0,0,1,1.016.624,1.649,1.649,0,0,1-.162,2.081l-3.661,3.68.51,2.8a.782.782,0,0,1-.625.9.758.758,0,0,1-.88-.613l-.519-2.8a1.623,1.623,0,0,1,.44-1.408l3.67-3.706-5.06-.785a1.52,1.52,0,0,1-1.153-.9L10.008,1.551,7.728,6.294a1.518,1.518,0,0,1-1.153.9L1.532,7.96l3.643,3.7a1.591,1.591,0,0,1,.44,1.389l-.88,5.194,4.523-2.426a1.472,1.472,0,0,1,1.443,0l5.131,2.706a.788.788,0,0,1,.387.879.77.77,0,0,1-.739.6Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9,0C6.964,0,6.771,3.547,5.559,4.8S.578,4.62.055,6.844s2.868,2.98,3.286,4.889-1.651,4.591.119,5.926S7.134,15.975,9,15.975s3.771,3.019,5.541,1.685-.3-4.017.119-5.926,3.808-2.664,3.286-4.889-4.292-.791-5.5-2.044S11.036,0,9,0Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "curved":
            return (0, $acw62.createElement)(d, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Xr.displayName = "IconlyStar", $63c37e44f569564f$var$Xr.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$1644ba17714857f1 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Xr), $63c37e44f569564f$var$rn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M16.219,16H13.066a.583.583,0,0,1-.59-.573V13.4a.708.708,0,0,0-.725-.7.716.716,0,0,0-.725.7v2.03a.582.582,0,0,1-.589.573H3.782A3.733,3.733,0,0,1,0,12.326V9.916a.693.693,0,0,1,.739-.661A1.283,1.283,0,0,0,2.021,8a1.212,1.212,0,0,0-1.3-1.174.734.734,0,0,1-.513-.207A.69.69,0,0,1,0,6.116V3.683A3.742,3.742,0,0,1,3.791,0h6.646a.582.582,0,0,1,.589.573v2.4a.725.725,0,0,0,.725.7.716.716,0,0,0,.725-.7V.573A.583.583,0,0,1,13.066,0h3.153A3.733,3.733,0,0,1,20,3.674V6.041a.694.694,0,0,1-.212.5.734.734,0,0,1-.513.206,1.255,1.255,0,1,0-.014,2.509A.693.693,0,0,1,20,9.916v2.41A3.733,3.733,0,0,1,16.219,16ZM11.75,5.7a.724.724,0,0,0-.725.7v3.758a.725.725,0,0,0,.725.7.716.716,0,0,0,.725-.7V6.407A.716.716,0,0,0,11.75,5.7Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M11.75,5.7V3.683a.72.72,0,0,1-.725-.7V.573A.577.577,0,0,0,10.435,0H3.791A3.744,3.744,0,0,0,0,3.683V6.115a.694.694,0,0,0,.213.5.739.739,0,0,0,.513.206,1.216,1.216,0,0,1,1.3,1.174A1.274,1.274,0,0,1,.735,9.253.692.692,0,0,0,0,9.92v2.406A3.734,3.734,0,0,0,3.781,16h6.654a.579.579,0,0,0,.59-.573V13.4a.715.715,0,0,1,.725-.7V10.87a.721.721,0,0,1-.725-.7V6.407a.72.72,0,0,1,.725-.7",
            transform: "translate(0 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M6.228,7.995A1.282,1.282,0,0,0,7.515,9.254a.691.691,0,0,1,.735.658v2.414A3.728,3.728,0,0,1,4.468,16H1.315a.585.585,0,0,1-.59-.574V13.4a.708.708,0,0,0-.725-.7V10.871a.715.715,0,0,0,.725-.7V6.408A.714.714,0,0,0,0,5.7V3.683a.714.714,0,0,0,.725-.7V.574A.584.584,0,0,1,1.315,0H4.468A3.728,3.728,0,0,1,8.25,3.673V6.041a.692.692,0,0,1-.213.5.736.736,0,0,1-.513.207,1.277,1.277,0,0,0-1.3,1.249",
            transform: "translate(11.75)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4)"
        }, (0, $acw62.createElement)("g", {
            transform: "translate(11.35 0.25)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,0V2.42",
            transform: "translate(0 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V2.024",
            transform: "translate(0 13.51)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,4.821V0",
            transform: "translate(0 5.253)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        })), (0, $acw62.createElement)("path", {
            d: "M16.7,16A3.277,3.277,0,0,0,20,12.743V10.151a2.15,2.15,0,1,1,0-4.3V3.257A3.277,3.277,0,0,0,16.7,0H3.3A3.277,3.277,0,0,0,0,3.257V5.935A2.09,2.09,0,0,1,2.177,8,2.159,2.159,0,0,1,0,10.151v2.593A3.277,3.277,0,0,0,3.3,16Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M3.786,16A3.734,3.734,0,0,1,0,12.326L0,9.884a.7.7,0,0,1,.212-.5.741.741,0,0,1,.513-.206A1.213,1.213,0,0,0,2.019,8,1.277,1.277,0,0,0,.725,6.743.716.716,0,0,1,0,6.038V3.675A3.735,3.735,0,0,1,3.785,0H5.009a.716.716,0,0,1,.725.7.715.715,0,0,1-.725.7H3.785A2.3,2.3,0,0,0,1.451,3.675V5.429A2.682,2.682,0,0,1,3.47,8a2.584,2.584,0,0,1-2.018,2.5v1.826a2.3,2.3,0,0,0,2.334,2.265h7.241v-1.2a.726.726,0,0,1,1.451,0v1.2h3.736a2.3,2.3,0,0,0,2.334-2.265V10.57a2.646,2.646,0,0,1,0-5.141V3.675a2.3,2.3,0,0,0-2.333-2.266H12.479v1.57a.726.726,0,0,1-1.451,0V1.409H9.064A.715.715,0,0,1,8.339.7.716.716,0,0,1,9.064,0h7.152A3.735,3.735,0,0,1,20,3.675V6.038a.716.716,0,0,1-.725.7,1.257,1.257,0,1,0,0,2.513.735.735,0,0,1,.513.206.7.7,0,0,1,.212.5v2.366A3.734,3.734,0,0,1,16.214,16Zm7.241-5.832V6.411a.726.726,0,0,1,1.451,0v3.758a.726.726,0,0,1-1.451,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4)"
        }, (0, $acw62.createElement)("g", {
            transform: "translate(11.35 0.25)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,0V2.42",
            transform: "translate(0 0)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V2.024",
            transform: "translate(0 13.51)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5,4.821V0",
            transform: "translate(0 5.253)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        })), (0, $acw62.createElement)("path", {
            d: "M16.7,16A3.277,3.277,0,0,0,20,12.743V10.151a2.15,2.15,0,1,1,0-4.3V3.257A3.277,3.277,0,0,0,16.7,0H3.3A3.277,3.277,0,0,0,0,3.257V5.935A2.09,2.09,0,0,1,2.177,8,2.159,2.159,0,0,1,0,10.151v2.593A3.277,3.277,0,0,0,3.3,16Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M.475,0V2.655",
            transform: "translate(10.384 0.6)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.475,0V2.22",
            transform: "translate(10.384 14.544)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.475,5.289V0",
            transform: "translate(10.384 6.255)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M19,10.55a2.051,2.051,0,0,1,0-4.1C19,1.7,19,0,9.5,0S0,1.7,0,6.449a2.051,2.051,0,0,1,0,4.1C0,15.3,0,17,9.5,17S19,15.3,19,10.55Z",
            transform: "translate(0 0.5)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$rn.displayName = "IconlyTicket", $63c37e44f569564f$var$rn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$ed207b05bbcf0a37 = $63c37e44f569564f$var$st($63c37e44f569564f$var$rn), $63c37e44f569564f$var$en = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.64,18H4.36A4.362,4.362,0,0,1,0,13.645V7.711A4.362,4.362,0,0,1,4.36,3.356a.2.2,0,0,0,.191-.12l.059-.12.083-.175c.261-.55.557-1.173.737-1.533A2.433,2.433,0,0,1,7.64,0h4.71a2.44,2.44,0,0,1,2.22,1.408c.157.315.4.82.627,1.308l.142.3.1.22a.225.225,0,0,0,.2.12A4.362,4.362,0,0,1,20,7.711v5.934A4.362,4.362,0,0,1,15.64,18ZM10,6.4A3.922,3.922,0,0,0,7.21,7.562a3.867,3.867,0,0,0-1.14,2.767A3.924,3.924,0,0,0,10,14.254a3.9,3.9,0,0,0,2.77-1.148,3.915,3.915,0,0,0,.01-5.554A3.9,3.9,0,0,0,10,6.4Zm5.61-.239a.9.9,0,1,0,.911.909A.906.906,0,0,0,15.61,6.163ZM10,12.756a2.423,2.423,0,0,1-2.43-2.427v-.01a2.337,2.337,0,0,1,.7-1.7A2.43,2.43,0,1,1,10,12.756Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.15,6.942A3.931,3.931,0,0,1,0,4.165,3.871,3.871,0,0,1,1.14,1.4a3.926,3.926,0,1,1,.01,5.544ZM2.2,2.457a2.334,2.334,0,0,0-.7,1.7v.01A2.423,2.423,0,0,0,3.93,6.593,2.444,2.444,0,0,0,6.36,4.165,2.433,2.433,0,0,0,2.2,2.457ZM8.64.909a.9.9,0,1,1,.9.9A.9.9,0,0,1,8.64.909Z",
            transform: "translate(6.07 6.163)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M15.44,3.236l-.1-.22c-.27-.569-.58-1.229-.77-1.608A2.442,2.442,0,0,0,12.35,0H7.64A2.428,2.428,0,0,0,5.43,1.408c-.2.4-.54,1.119-.82,1.708l-.06.12a.2.2,0,0,1-.19.12A4.361,4.361,0,0,0,0,7.711v5.933A4.361,4.361,0,0,0,4.36,18H15.64A4.368,4.368,0,0,0,20,13.645V7.711a4.368,4.368,0,0,0-4.36-4.355A.227.227,0,0,1,15.44,3.236Z",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.888,3.36h0a.962.962,0,0,1-.87-.551C13.731,2.2,13.366,1.424,13.15,1A1.675,1.675,0,0,0,11.6,0c-.012,0-4.684,0-4.7,0A1.676,1.676,0,0,0,5.35,1c-.215.423-.58,1.2-.867,1.808a.963.963,0,0,1-.87.551h0A3.612,3.612,0,0,0,0,6.972v5.936A3.613,3.613,0,0,0,3.613,16.52H14.888A3.612,3.612,0,0,0,18.5,12.908V6.972A3.612,3.612,0,0,0,14.888,3.36Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,3.182A3.179,3.179,0,1,0,3.182,0,3.19,3.19,0,0,0,0,3.182Z",
            transform: "translate(6.821 7.152)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.9,2a1.085,1.085,0,0,1-.3-.078A1.008,1.008,0,0,1,.282,1.7,1.021,1.021,0,0,1,0,1,.971.971,0,0,1,.082.607,1.018,1.018,0,0,1,.318.265,1.144,1.144,0,0,1,.622.07,1.023,1.023,0,0,1,1.7.285a.962.962,0,0,1,.19.261L1.917.6A.974.974,0,0,1,2,1a1.016,1.016,0,0,1-.292.705A1,1,0,0,1,1.1,2L1,2Z",
            transform: "translate(14 6)",
            fill: r
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.58,18a.749.749,0,1,1,0-1.5h7.059A2.864,2.864,0,0,0,18.5,13.642V7.713a2.864,2.864,0,0,0-2.862-2.859,1.718,1.718,0,0,1-1.548-.979c-.314-.665-.655-1.385-.859-1.788a.93.93,0,0,0-.889-.588H7.653a.928.928,0,0,0-.884.589c-.2.391-.526,1.084-.8,1.663l-.059.124a1.719,1.719,0,0,1-1.548.979A2.864,2.864,0,0,0,1.5,7.713v5.929A2.864,2.864,0,0,0,4.363,16.5h.745a.749.749,0,1,1,0,1.5H4.363A4.365,4.365,0,0,1,0,13.642V7.713A4.365,4.365,0,0,1,4.363,3.355a.211.211,0,0,0,.192-.121l.059-.124c.279-.592.614-1.3.816-1.7A2.425,2.425,0,0,1,7.646,0h4.7a2.426,2.426,0,0,1,2.221,1.409c.209.411.557,1.147.841,1.751.071.148.146.2.229.2A4.365,4.365,0,0,1,20,7.713v5.929A4.365,4.365,0,0,1,15.638,18ZM10,14.254a3.928,3.928,0,0,1-3.74-5.121.75.75,0,0,1,1.43.454,2.383,2.383,0,0,0-.115.733A2.435,2.435,0,0,0,10,12.756h0a2.419,2.419,0,0,0,1.724-.723,2.376,2.376,0,0,0,.7-1.7A2.438,2.438,0,0,0,10,7.895h0a2.475,2.475,0,0,0-.529.057.748.748,0,1,1-.327-1.461A3.836,3.836,0,0,1,10,6.4h0a3.936,3.936,0,0,1,3.928,3.931,3.857,3.857,0,0,1-1.139,2.762A3.91,3.91,0,0,1,10,14.254Zm4.923-6.5a.745.745,0,0,1-.22-.528.7.7,0,0,1,.06-.279,1.081,1.081,0,0,1,.16-.25,1.055,1.055,0,0,1,.25-.161.807.807,0,0,1,.57,0,.832.832,0,0,1,.24.161.88.88,0,0,1,.17.25.7.7,0,0,1,.059.279.718.718,0,0,1-.229.528.8.8,0,0,1-.24.17.7.7,0,0,1-.29.051A.743.743,0,0,1,14.92,7.752Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.888,3.36h0a.962.962,0,0,1-.87-.551C13.731,2.2,13.366,1.424,13.15,1A1.675,1.675,0,0,0,11.6,0c-.012,0-4.684,0-4.7,0A1.676,1.676,0,0,0,5.35,1c-.215.423-.58,1.2-.867,1.808a.963.963,0,0,1-.87.551h0A3.612,3.612,0,0,0,0,6.972v5.936A3.613,3.613,0,0,0,3.613,16.52H14.888A3.612,3.612,0,0,0,18.5,12.908V6.972A3.612,3.612,0,0,0,14.888,3.36Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,3.182A3.179,3.179,0,1,0,3.182,0,3.19,3.19,0,0,0,0,3.182Z",
            transform: "translate(6.821 7.152)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.9,2a1.085,1.085,0,0,1-.3-.078A1.008,1.008,0,0,1,.282,1.7,1.021,1.021,0,0,1,0,1,.971.971,0,0,1,.082.607,1.018,1.018,0,0,1,.318.265,1.144,1.144,0,0,1,.622.07,1.023,1.023,0,0,1,1.7.285a.962.962,0,0,1,.19.261L1.917.6A.974.974,0,0,1,2,1a1.016,1.016,0,0,1-.292.705A1,1,0,0,1,1.1,2L1,2Z",
            transform: "translate(14 6)",
            fill: n,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 3.042)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.291,3.145A3.145,3.145,0,1,0,3.145,6.291,3.146,3.146,0,0,0,6.291,3.145Z",
            transform: "translate(6.648 6.311)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M9,17.158c8.045,0,9-2.411,9-7.634,0-3.661-.484-5.62-3.534-6.462a1.927,1.927,0,0,1-.842-.534c-.406-.445-.7-1.813-1.684-2.226A14.475,14.475,0,0,0,6.06.3C5.1.7,4.782,2.083,4.376,2.529a1.921,1.921,0,0,1-.842.534C.484,3.9,0,5.863,0,9.525,0,14.748.958,17.158,9,17.158Z",
            transform: "translate(0.789 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5.5H.5",
            transform: "translate(14.209 5.458)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$en.displayName = "IconlyCamera", $63c37e44f569564f$var$en.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$79f141de891a5fed = $63c37e44f569564f$var$st($63c37e44f569564f$var$en), $63c37e44f569564f$var$an = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,16.575c0-2.722,3.686-3.4,8-3.4,4.339,0,8,.7,8,3.424S12.315,20,8,20C3.662,20,0,19.3,0,16.575ZM2.706,5.291A5.294,5.294,0,1,1,8,10.583,5.274,5.274,0,0,1,2.706,5.291Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8,0C3.684,0,0,.68,0,3.4S3.661,6.825,8,6.825c4.313,0,8-.679,8-3.4S12.334,0,8,0",
            transform: "translate(0 13.175)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M5.292,10.584A5.292,5.292,0,1,0,0,5.292a5.273,5.273,0,0,0,5.292,5.292",
            transform: "translate(2.705 0)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2.5)"
        }, (0, $acw62.createElement)("circle", {
            cx: "4.778",
            cy: "4.778",
            r: "4.778",
            transform: "translate(2.801 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,3.016a2.215,2.215,0,0,1,.22-.97A4.042,4.042,0,0,1,3.039.426,16.787,16.787,0,0,1,5.382.1,25.053,25.053,0,0,1,9.767.1a16.979,16.979,0,0,1,2.343.33c1.071.22,2.362.659,2.819,1.62a2.27,2.27,0,0,1,0,1.95c-.458.961-1.748,1.4-2.819,1.611a15.716,15.716,0,0,1-2.343.339A25.822,25.822,0,0,1,6.2,6a4.066,4.066,0,0,1-.815-.055,15.423,15.423,0,0,1-2.334-.339C1.968,5.4.687,4.957.22,4A2.279,2.279,0,0,1,0,3.016Z",
            transform: "translate(0 13.185)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.978,19.985a.717.717,0,0,1-.7-.738.737.737,0,0,1,.742-.7q.483.014.981.014c4.349,0,6.555-.751,6.555-2.233,0-1.5-2.206-2.255-6.555-2.255s-6.555.752-6.555,2.235c0,.485.173,1.188,1.675,1.694a.718.718,0,1,1-.464,1.359C.461,18.624,0,17.3,0,16.31c0-3.29,4.566-3.67,8-3.67,1.978,0,8,0,8,3.691C16,19.619,11.435,20,8,20Q7.48,20,6.978,19.985ZM2.613,5.354A5.387,5.387,0,1,1,8,10.706,5.377,5.377,0,0,1,2.613,5.354Zm1.446,0A3.942,3.942,0,1,0,8,1.437,3.933,3.933,0,0,0,4.059,5.354Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("circle", {
            cx: "4.778",
            cy: "4.778",
            r: "4.778",
            transform: "translate(2.801 0)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,3.016a2.215,2.215,0,0,1,.22-.97A4.042,4.042,0,0,1,3.039.426,16.787,16.787,0,0,1,5.382.1,25.053,25.053,0,0,1,9.767.1a16.979,16.979,0,0,1,2.343.33c1.071.22,2.362.659,2.819,1.62a2.27,2.27,0,0,1,0,1.95c-.458.961-1.748,1.4-2.819,1.611a15.716,15.716,0,0,1-2.343.339A25.822,25.822,0,0,1,6.2,6a4.066,4.066,0,0,1-.815-.055,15.423,15.423,0,0,1-2.334-.339C1.968,5.4.687,4.957.22,4A2.279,2.279,0,0,1,0,3.016Z",
            transform: "translate(0 13.185)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(5 2.4)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.845,7.3C3.153,7.3,0,6.726,0,4.425S3.133,0,6.845,0c3.692,0,6.845,2.1,6.845,4.4S10.556,7.3,6.845,7.3Z",
            transform: "translate(0 11.962)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.387,8.774a4.372,4.372,0,1,0-.031,0Z",
            transform: "translate(2.45 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$an.displayName = "IconlyUser", $63c37e44f569564f$var$an.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$1f44aaf2ec115b54 = $63c37e44f569564f$var$st($63c37e44f569564f$var$an), $63c37e44f569564f$var$ln = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,15.746c0-2.585,3.454-3.231,7.5-3.231,4.067,0,7.5.669,7.5,3.253S11.545,19,7.5,19C3.434,19,0,18.329,0,15.746Zm16.1-5.658V8.911H14.9a.912.912,0,0,1,0-1.823h1.2V5.911a.9.9,0,1,1,1.8,0V7.088h1.2a.912.912,0,0,1,0,1.823H17.9v1.177a.9.9,0,1,1-1.8,0ZM2.537,5.027a4.963,4.963,0,1,1,9.925,0,4.963,4.963,0,1,1-9.925,0Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.1,2.088H3.9V.912a.9.9,0,1,0-1.8,0V2.088H.9a.912.912,0,0,0,0,1.823H2.1V5.088a.9.9,0,1,0,1.8,0V3.911H5.1a.912.912,0,0,0,0-1.823",
            transform: "translate(14 5)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0C3.454,0,0,.647,0,3.231S3.433,6.484,7.5,6.484c4.045,0,7.5-.647,7.5-3.231S11.567,0,7.5,0",
            transform: "translate(0 12.516)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M4.963,10.054A4.977,4.977,0,0,0,9.925,5.028,4.963,4.963,0,1,0,0,5.028a4.977,4.977,0,0,0,4.963,5.027",
            transform: "translate(2.537 0)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.127,0C3.283,0,0,.581,0,2.909s3.262,2.93,7.127,2.93c3.844,0,7.127-.582,7.127-2.909S10.992,0,7.127,0Z",
            transform: "translate(0.75 13.206)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.568,9.136A4.568,4.568,0,1,0,0,4.568,4.552,4.552,0,0,0,4.568,9.136Z",
            transform: "translate(3.309 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V4.01",
            transform: "translate(16.704 6.669)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.09.5H0",
            transform: "translate(15.16 8.174)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.909,19.987a.718.718,0,0,1-.694-.74.734.734,0,0,1,.735-.7q.477.015.971.014c4.306,0,6.49-.751,6.49-2.235s-2.183-2.254-6.49-2.254-6.491.752-6.491,2.234c0,.485.171,1.188,1.659,1.694a.718.718,0,0,1-.459,1.361C.456,18.625,0,17.3,0,16.31c0-3.29,4.521-3.67,7.922-3.67,1.958,0,7.921,0,7.921,3.69,0,3.289-4.521,3.67-7.921,3.67C7.579,20,7.24,20,6.909,19.987Zm9.557-9.193V9.538H15.178a.75.75,0,0,1,0-1.5h1.289V6.784a.747.747,0,1,1,1.495,0V8.039h1.292a.75.75,0,0,1,0,1.5H17.961v1.255a.747.747,0,1,1-1.495,0ZM2.588,5.354a5.334,5.334,0,1,1,5.333,5.354A5.35,5.35,0,0,1,2.588,5.354Zm1.431,0a3.9,3.9,0,1,0,3.9-3.917A3.914,3.914,0,0,0,4.019,5.354Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.127,0C3.283,0,0,.581,0,2.909s3.262,2.93,7.127,2.93c3.844,0,7.127-.582,7.127-2.909S10.992,0,7.127,0Z",
            transform: "translate(0.75 13.206)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.568,9.136A4.568,4.568,0,1,0,0,4.568,4.552,4.552,0,0,0,4.568,9.136Z",
            transform: "translate(3.309 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V4.01",
            transform: "translate(16.704 6.669)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.09.5H0",
            transform: "translate(15.16 8.174)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.85 2.15)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.072,7.3C3.258,7.3,0,6.721,0,4.411S3.237,0,7.072,0c3.814,0,7.072,2.081,7.072,4.39S10.907,7.3,7.072,7.3Z",
            transform: "translate(0 12.36)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.533,9.066a4.517,4.517,0,1,0-.032,0Z",
            transform: "translate(2.539 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V4.01",
            transform: "translate(15.781 5.979)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.09.5H0",
            transform: "translate(14.237 7.484)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$ln.displayName = "IconlyAddUser", $63c37e44f569564f$var$ln.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$a2fae8d9b81b1013 = $63c37e44f569564f$var$st($63c37e44f569564f$var$ln), $63c37e44f569564f$var$dn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,14.918c0-2.447,3.386-3.06,7.349-3.06,3.985,0,7.349.634,7.349,3.083S11.313,18,7.349,18C3.364,18,0,17.366,0,14.918Zm16.633.475c.341-3.112-2.366-4.588-3.067-4.927a.053.053,0,0,1-.033-.054.041.041,0,0,1,.037-.028,18.394,18.394,0,0,1,3.748.319,3.193,3.193,0,0,1,2.462,1.468,2.106,2.106,0,0,1,0,1.877c-.532,1.123-2.246,1.485-2.912,1.578l-.03,0A.208.208,0,0,1,16.633,15.393ZM2.487,4.763A4.8,4.8,0,0,1,7.349,0a4.8,4.8,0,0,1,4.863,4.763A4.8,4.8,0,0,1,7.349,9.525,4.8,4.8,0,0,1,2.487,4.763ZM13.719,8.822a4.069,4.069,0,0,1-.56-.052.177.177,0,0,1-.122-.274,6.432,6.432,0,0,0-.1-7.439.11.11,0,0,1-.018-.123.148.148,0,0,1,.095-.056A4.2,4.2,0,0,1,13.834.8a4.045,4.045,0,0,1,3.957,5.076A4.04,4.04,0,0,1,13.83,8.823Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.349,0C3.386,0,0,.612,0,3.06S3.364,6.142,7.349,6.142c3.964,0,7.349-.612,7.349-3.06S11.335,0,7.349,0",
            transform: "translate(0 11.858)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M4.863,9.525A4.8,4.8,0,0,0,9.726,4.762,4.8,4.8,0,0,0,4.863,0,4.8,4.8,0,0,0,0,4.762,4.8,4.8,0,0,0,4.863,9.525",
            transform: "translate(2.486 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M1.265,4.053A6.368,6.368,0,0,1,.128,7.7a.177.177,0,0,0,.122.275,3.968,3.968,0,0,0,.56.052,4.045,4.045,0,0,0,4.072-2.95A4.045,4.045,0,0,0,.925,0,4.159,4.159,0,0,0,.107.081.148.148,0,0,0,.012.137.111.111,0,0,0,.031.261,6.414,6.414,0,0,1,1.265,4.053",
            transform: "translate(12.909 0.795)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M6.247,1.789A3.19,3.19,0,0,0,3.785.322,18.354,18.354,0,0,0,.038,0,.043.043,0,0,0,0,.031.054.054,0,0,0,.034.085C.734.424,3.442,1.9,3.1,5.012a.207.207,0,0,0,.234.232C4,5.151,5.716,4.79,6.247,3.667a2.107,2.107,0,0,0,0-1.878",
            transform: "translate(13.532 10.38)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,6.594A3.3,3.3,0,0,0,3.3,3.3,3.3,3.3,0,0,0,0,0",
            transform: "translate(14.02 1.819)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A10.9,10.9,0,0,1,1.617.233,2.664,2.664,0,0,1,3.562,1.346a1.568,1.568,0,0,1,0,1.345A2.683,2.683,0,0,1,1.617,3.809",
            transform: "translate(15.536 11.996)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M6.841,0c3.69,0,6.842.559,6.842,2.792S10.551,5.6,6.841,5.6C3.151,5.6,0,5.046,0,2.812S3.131,0,6.841,0Z",
            transform: "translate(0.75 12.706)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.384,8.769A4.385,4.385,0,1,1,8.769,4.384,4.369,4.369,0,0,1,4.384,8.769Z",
            transform: "translate(3.207 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.842,18.252a.749.749,0,0,1,.75-.747c2.779,0,6.09-.356,6.09-2.056,0-1.351-2.048-2.037-6.09-2.037-2.779,0-6.091.356-6.091,2.056,0,.381.112.872.984,1.3a5.764,5.764,0,0,0,1.328.43A.747.747,0,1,1,3.5,18.66a7.279,7.279,0,0,1-1.676-.548A2.855,2.855,0,0,1,0,15.469c0-3.551,5.713-3.551,7.592-3.551,3.259,0,7.591.366,7.591,3.532C15.182,19,9.468,19,7.592,19A.748.748,0,0,1,6.842,18.252Zm9.576-2.346A.746.746,0,0,1,17,15.024c.762-.156,1.28-.412,1.418-.7a.812.812,0,0,0,0-.7c-.141-.293-.656-.547-1.414-.7a10.216,10.216,0,0,0-1.523-.22.746.746,0,0,1-.7-.8.758.758,0,0,1,.8-.7,11.913,11.913,0,0,1,1.728.249,3.19,3.19,0,0,1,2.46,1.517,2.288,2.288,0,0,1,0,1.984A3.236,3.236,0,0,1,17.3,16.488a.791.791,0,0,1-.152.014A.747.747,0,0,1,16.418,15.906ZM4.432,9.161a.749.749,0,1,1,.922-1.18,3.626,3.626,0,1,0-1.4-2.863.75.75,0,0,1-1.5,0A5.112,5.112,0,1,1,4.432,9.161Zm8.837-.774a.749.749,0,0,1,.75-.747,2.539,2.539,0,1,0,0-5.078.748.748,0,1,1,0-1.5,4.034,4.034,0,1,1,0,8.069A.749.749,0,0,1,13.27,8.387Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,6.594A3.3,3.3,0,0,0,3.3,3.3,3.3,3.3,0,0,0,0,0",
            transform: "translate(14.02 1.819)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A10.9,10.9,0,0,1,1.617.233,2.664,2.664,0,0,1,3.562,1.346a1.568,1.568,0,0,1,0,1.345A2.683,2.683,0,0,1,1.617,3.809",
            transform: "translate(15.536 11.996)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M6.841,0c3.69,0,6.842.559,6.842,2.792S10.551,5.6,6.841,5.6C3.151,5.6,0,5.046,0,2.812S3.131,0,6.841,0Z",
            transform: "translate(0.75 12.706)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.384,8.769A4.385,4.385,0,1,1,8.769,4.384,4.369,4.369,0,0,1,4.384,8.769Z",
            transform: "translate(3.207 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.75 2.549)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.809,7.007C3.137,7.007,0,6.452,0,4.228S3.117,0,6.809,0c3.672,0,6.808,1.985,6.808,4.208S10.5,7.007,6.809,7.007Z",
            transform: "translate(0 11.9)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.364,8.728a4.349,4.349,0,1,0-.031,0Z",
            transform: "translate(2.445 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.187,6.4A3.289,3.289,0,0,0,2.624,3.221,3.288,3.288,0,0,0,0,0",
            transform: "translate(13.865 1.132)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0C1.988,0,3.686,1.348,3.686,2.551A1.814,1.814,0,0,1,2.211,4.2",
            transform: "translate(14.711 11.104)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$dn.displayName = "IconlyTwoUsers", $63c37e44f569564f$var$dn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$907727a0d23f5455 = $63c37e44f569564f$var$st($63c37e44f569564f$var$dn), $63c37e44f569564f$var$cn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.588,13.28c0-2.177,2.911-2.741,6.361-2.741,3.431,0,6.36.544,6.36,2.721S14.4,16,10.949,16C7.518,16,4.588,15.456,4.588,13.28Zm14.5.4A4.453,4.453,0,0,0,16.431,9.3a.045.045,0,0,1-.029-.047.038.038,0,0,1,.032-.026,15.49,15.49,0,0,1,3.244.284,2.76,2.76,0,0,1,2.131,1.3,1.927,1.927,0,0,1,0,1.67c-.461,1-1.944,1.319-2.521,1.4l-.027,0A.183.183,0,0,1,19.086,13.684Zm-16.375.205c-.576-.083-2.06-.4-2.52-1.4a1.913,1.913,0,0,1,0-1.669,2.756,2.756,0,0,1,2.13-1.305,15.644,15.644,0,0,1,3.244-.283.037.037,0,0,1,.032.025.046.046,0,0,1-.028.048,4.449,4.449,0,0,0-2.656,4.38.182.182,0,0,1-.176.208ZM6.74,4.233a4.209,4.209,0,1,1,8.419,0,4.209,4.209,0,1,1-8.419,0Zm9.823,3.609a3.4,3.4,0,0,1-.483-.047.159.159,0,0,1-.106-.245A5.841,5.841,0,0,0,15.889.939a.106.106,0,0,1-.016-.111.13.13,0,0,1,.083-.049,3.507,3.507,0,0,1,.708-.073A3.576,3.576,0,0,1,20.088,5.22a3.51,3.51,0,0,1-3.429,2.623ZM1.912,5.22A3.576,3.576,0,0,1,5.336.706a3.53,3.53,0,0,1,.709.073.135.135,0,0,1,.082.049.1.1,0,0,1-.016.11A5.84,5.84,0,0,0,6.027,7.55a.159.159,0,0,1-.107.245,3.281,3.281,0,0,1-.483.047h-.1A3.512,3.512,0,0,1,1.912,5.22Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.361,0C2.911,0,0,.564,0,2.739S2.93,5.46,6.361,5.46c3.45,0,6.361-.564,6.361-2.739S9.792,0,6.361,0",
            transform: "translate(4.588 10.54)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M4.209,8.467A4.207,4.207,0,0,0,8.419,4.234,4.209,4.209,0,1,0,0,4.234,4.207,4.207,0,0,0,4.209,8.467",
            transform: "translate(6.74 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.225,4.513A3.574,3.574,0,0,0,.8,0,3.587,3.587,0,0,0,.092.073.136.136,0,0,0,.01.122a.1.1,0,0,0,.017.11A5.807,5.807,0,0,1,1.094,3.6,5.762,5.762,0,0,1,.11,6.844a.158.158,0,0,0,.107.244A3.282,3.282,0,0,0,.7,7.135,3.513,3.513,0,0,0,4.225,4.513",
            transform: "translate(15.863 0.707)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M5.407,1.59A2.755,2.755,0,0,0,3.276.286,15.555,15.555,0,0,0,.033,0,.037.037,0,0,0,0,.027.046.046,0,0,0,.029.075,4.451,4.451,0,0,1,2.684,4.456a.181.181,0,0,0,.2.205c.577-.083,2.06-.4,2.521-1.4a1.922,1.922,0,0,0,0-1.67",
            transform: "translate(16.402 9.227)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M4.252.073A3.514,3.514,0,0,0,3.543,0,3.573,3.573,0,0,0,.12,4.513,3.511,3.511,0,0,0,3.644,7.135a3.4,3.4,0,0,0,.484-.047.158.158,0,0,0,.107-.244A5.841,5.841,0,0,1,4.318.232a.1.1,0,0,0,.016-.11.129.129,0,0,0-.082-.05",
            transform: "translate(1.793 0.707)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M2.322.285a2.753,2.753,0,0,0-2.13,1.3,1.918,1.918,0,0,0,0,1.671c.46,1,1.944,1.319,2.521,1.4a.18.18,0,0,0,.2-.205A4.45,4.45,0,0,1,5.569.075.047.047,0,0,0,5.6.027.034.034,0,0,0,5.566,0,15.517,15.517,0,0,0,2.322.285",
            transform: "translate(0 9.228)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,5.8A2.9,2.9,0,1,0,0,0",
            transform: "translate(16.595 1.629)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A9.435,9.435,0,0,1,1.423.206a2.337,2.337,0,0,1,1.712.978,1.381,1.381,0,0,1,0,1.184,2.361,2.361,0,0,1-1.712.984",
            transform: "translate(17.929 10.585)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M2.9,5.8A2.9,2.9,0,1,1,2.9,0",
            transform: "translate(2.388 1.629)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.268,0A9.435,9.435,0,0,0,1.845.206a2.334,2.334,0,0,0-1.711.978,1.375,1.375,0,0,0,0,1.184,2.358,2.358,0,0,0,1.711.984",
            transform: "translate(0.688 10.585)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M6.021,0c3.247,0,6.021.491,6.021,2.458S9.286,4.933,6.021,4.933C2.773,4.933,0,4.441,0,2.475S2.756,0,6.021,0Z",
            transform: "translate(4.917 11.21)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.858,7.717A3.859,3.859,0,1,1,7.716,3.858,3.845,3.845,0,0,1,3.858,7.717Z",
            transform: "translate(7.08 0.688)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.308,16.3a.694.694,0,0,1,.692-.7c2.443,0,5.356-.313,5.356-1.8,0-1.186-1.8-1.786-5.356-1.786-2.443,0-5.355.312-5.355,1.8,0,.332.1.76.853,1.132a5.118,5.118,0,0,0,1.167.381A.7.7,0,0,1,7.377,16.7a6.575,6.575,0,0,1-1.489-.491,2.574,2.574,0,0,1-1.628-2.383c0-3.2,5.072-3.2,6.739-3.2,1.844,0,6.74,0,6.74,3.179C17.74,17,12.668,17,11,17A.7.7,0,0,1,10.308,16.3Zm8.467-2.085a.7.7,0,0,1,.539-.823c.944-.2,1.177-.492,1.233-.611a.693.693,0,0,0,0-.6c-.118-.25-.577-.476-1.229-.606a9.063,9.063,0,0,0-1.341-.2A.7.7,0,0,1,18.069,10a10.223,10.223,0,0,1,1.534.221A2.855,2.855,0,0,1,21.8,11.588a2.085,2.085,0,0,1,0,1.8,2.891,2.891,0,0,1-2.2,1.376.621.621,0,0,1-.14.015A.694.694,0,0,1,18.775,14.218Zm-16.362.535A2.892,2.892,0,0,1,.2,13.374a2.091,2.091,0,0,1,0-1.8A2.865,2.865,0,0,1,2.417,10.2a10.04,10.04,0,0,1,1.52-.219.7.7,0,0,1,.094,1.389,8.737,8.737,0,0,0-1.328.193c-.671.133-1.13.359-1.25.61a.707.707,0,0,0,0,.6c.058.12.29.418,1.238.614a.7.7,0,0,1-.139,1.377A.74.74,0,0,1,2.413,14.754ZM8.191,8.222a.7.7,0,0,1-.122-.977.688.688,0,0,1,.972-.122A3.156,3.156,0,0,0,11,7.793a3.2,3.2,0,1,0-3.184-3.2.692.692,0,1,1-1.384,0A4.568,4.568,0,1,1,11,9.185,4.517,4.517,0,0,1,8.191,8.222Zm7.8-.714a.694.694,0,0,1,.692-.7,2.234,2.234,0,0,0,0-4.468.7.7,0,0,1,0-1.392,3.627,3.627,0,0,1,0,7.253A.694.694,0,0,1,15.991,7.508ZM1.714,4.548A3.629,3.629,0,0,1,5.328.913a.7.7,0,0,1,0,1.392,2.242,2.242,0,0,0,0,4.484.7.7,0,0,1,0,1.392A3.628,3.628,0,0,1,1.714,4.548Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,5.8A2.9,2.9,0,1,0,0,0",
            transform: "translate(16.595 1.629)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A9.435,9.435,0,0,1,1.423.206a2.337,2.337,0,0,1,1.712.978,1.381,1.381,0,0,1,0,1.184,2.361,2.361,0,0,1-1.712.984",
            transform: "translate(17.929 10.585)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M2.9,5.8A2.9,2.9,0,1,1,2.9,0",
            transform: "translate(2.388 1.629)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M3.268,0A9.435,9.435,0,0,0,1.845.206a2.334,2.334,0,0,0-1.711.978,1.375,1.375,0,0,0,0,1.184,2.358,2.358,0,0,0,1.711.984",
            transform: "translate(0.688 10.585)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M6.021,0c3.247,0,6.021.491,6.021,2.458S9.286,4.933,6.021,4.933C2.773,4.933,0,4.441,0,2.475S2.756,0,6.021,0Z",
            transform: "translate(4.917 11.21)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.858,7.717A3.859,3.859,0,1,1,7.716,3.858,3.845,3.845,0,0,1,3.858,7.717Z",
            transform: "translate(7.08 0.688)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.006,6.122C2.767,6.122,0,5.632,0,3.67S2.749,0,6.006,0c3.239,0,6.006,1.692,6.006,3.653S9.263,6.122,6.006,6.122Z",
            transform: "translate(4.966 11.246)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.85,7.7a3.837,3.837,0,1,0-.027,0Z",
            transform: "translate(7.122 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.166,5.643a2.9,2.9,0,0,0,2.149-2.8A2.9,2.9,0,0,0,0,0",
            transform: "translate(17.196 1.749)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0C1.754,0,3.252,1.189,3.252,2.251a1.64,1.64,0,0,1-1.3,1.49",
            transform: "translate(17.943 10.544)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M2.15,5.643A2.9,2.9,0,0,1,2.315,0",
            transform: "translate(2.434 1.749)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.252,0C1.5,0,0,1.189,0,2.251a1.64,1.64,0,0,0,1.3,1.49",
            transform: "translate(0.75 10.544)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$cn.displayName = "IconlyPeople", $63c37e44f569564f$var$cn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$8d3edc4d62e152ad = $63c37e44f569564f$var$st($63c37e44f569564f$var$cn), $63c37e44f569564f$var$pn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.376,20a4.522,4.522,0,0,1-4.586-4.43v-4.8H.781a.77.77,0,1,1,0-1.541H4.791V4.45A4.534,4.534,0,0,1,9.386,0h5.039A4.521,4.521,0,0,1,19,4.44V15.56A4.519,4.519,0,0,1,14.4,20Zm1.817-9.229-1.652,1.6a.757.757,0,0,0,0,1.091.831.831,0,0,0,1.126,0l3.015-2.911a.744.744,0,0,0,0-1.09L10.667,6.55a.816.816,0,0,0-1.126,0,.756.756,0,0,0,0,1.09l1.652,1.59h-6.4v1.54Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,4.446A4.526,4.526,0,0,1,4.591,0H9.624A4.515,4.515,0,0,1,14.2,4.436V15.552A4.526,4.526,0,0,1,9.613,20H4.581A4.517,4.517,0,0,1,0,15.562V4.446Z",
            transform: "translate(4.796)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M13.537,3.134,10.569.225a.79.79,0,0,0-1.106,0,.762.762,0,0,0,0,1.089l1.625,1.593H.782a.77.77,0,1,0,0,1.54H11.091L9.465,6.043a.762.762,0,0,0,0,1.089.79.79,0,0,0,1.106,0l2.968-2.909a.761.761,0,0,0,0-1.091",
            transform: "translate(0 6.32)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.041.5H0",
            transform: "translate(0.771 9.522)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.928,2.916,0,5.832",
            transform: "translate(9.885 7.106)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.617V3.684A3.684,3.684,0,0,1,3.685,0H8.569a3.675,3.675,0,0,1,3.675,3.675v11.14A3.685,3.685,0,0,1,8.559,18.5H3.674A3.675,3.675,0,0,1,0,14.825v-.942",
            transform: "translate(5.504 0.772)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.31,20A4.532,4.532,0,0,1,4.7,15.563v-.941a.8.8,0,0,1,1.6,0v.941a2.96,2.96,0,0,0,3.01,2.9h5.067A2.969,2.969,0,0,0,17.4,15.553a.8.8,0,0,1,1.6,0A4.543,4.543,0,0,1,14.377,20Zm-.039-6.547a.774.774,0,0,1,0-1.089l1.592-1.593H.766a.77.77,0,0,1,0-1.541H12.722a.766.766,0,0,1,.708.477.774.774,0,0,1-.167.84l-2.908,2.908a.765.765,0,0,1-1.084,0Zm8.127-1.4V4.437a2.959,2.959,0,0,0-3.01-2.9H9.32A2.969,2.969,0,0,0,6.3,4.447v.931a.8.8,0,0,1-1.6,0V4.447A4.543,4.543,0,0,1,9.32,0h5.067A4.533,4.533,0,0,1,19,4.437v7.614a.8.8,0,0,1-1.6,0ZM10.007,8.366l-.732-.726A.773.773,0,0,1,9.269,6.55a.763.763,0,0,1,1.084-.006l.734.728a.771.771,0,0,1,0,1.088.753.753,0,0,1-.544.229A.763.763,0,0,1,10.007,8.366Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.041.5H0",
            transform: "translate(0.771 9.522)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.928,2.916,0,5.832",
            transform: "translate(9.885 7.106)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.617V3.684A3.684,3.684,0,0,1,3.685,0H8.569a3.675,3.675,0,0,1,3.675,3.675v11.14A3.685,3.685,0,0,1,8.559,18.5H3.674A3.675,3.675,0,0,1,0,14.825v-.942",
            transform: "translate(5.504 0.772)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.041.5H0",
            transform: "translate(0.75 9.621)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.928,2.916,0,5.832",
            transform: "translate(9.864 7.205)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.88C.33,1.3,1.67,0,7,0c7.1,0,7.1,2.31,7.1,9.25s0,9.25-7.1,9.25c-5.33,0-6.67-1.3-7-4.88",
            transform: "translate(5.259 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$pn.displayName = "IconlyLogin", $63c37e44f569564f$var$pn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$21a94553ffa41578 = $63c37e44f569564f$var$st($63c37e44f569564f$var$pn), $63c37e44f569564f$var$hn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.517,20A4.482,4.482,0,0,1,0,15.56V4.45A4.493,4.493,0,0,1,4.528,0H9.492A4.48,4.48,0,0,1,14,4.44V9.23H7.9a.77.77,0,1,0,0,1.54H14v4.78A4.493,4.493,0,0,1,9.472,20ZM16.54,13.451a.773.773,0,0,1,0-1.09l1.6-1.59H14V9.23h4.14l-1.6-1.59a.773.773,0,0,1,0-1.09.764.764,0,0,1,1.09-.01l2.92,2.91a.766.766,0,0,1,.229.55.741.741,0,0,1-.229.54l-2.92,2.911a.762.762,0,0,1-1.09,0Z",
            transform: "translate(0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,4.447A4.492,4.492,0,0,1,4.525,0H9.486A4.481,4.481,0,0,1,14,4.437V15.553A4.492,4.492,0,0,1,9.474,20H4.515A4.481,4.481,0,0,1,0,15.563V4.447Z",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M12.98,3.134,10.135.225a.736.736,0,0,0-1.061,0,.785.785,0,0,0,0,1.089l1.559,1.593H.75a.77.77,0,0,0,0,1.54h9.885L9.076,6.042a.785.785,0,0,0,0,1.089.735.735,0,0,0,1.061,0L12.98,4.225a.784.784,0,0,0,0-1.091",
            transform: "translate(6.799 6.321)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.244,4.618V3.685A3.685,3.685,0,0,0,8.559,0H3.684A3.685,3.685,0,0,0,0,3.685v11.13A3.685,3.685,0,0,0,3.684,18.5H8.569a3.675,3.675,0,0,0,3.675-3.674v-.943",
            transform: "translate(0.772 0.771)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.041.5H0",
            transform: "translate(7.768 9.521)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.928,2.915,0,5.831",
            transform: "translate(16.881 7.106)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.33,19A4.284,4.284,0,0,1,0,14.775a.74.74,0,0,1,.75-.731.74.74,0,0,1,.75.731A2.8,2.8,0,0,0,4.33,17.537H9.077A2.79,2.79,0,0,0,11.9,14.785v-.894a.75.75,0,0,1,1.5,0v.894A4.273,4.273,0,0,1,9.077,19Zm11.543-6.219a.719.719,0,0,1,0-1.035l1.56-1.514H7.549a.732.732,0,1,1,0-1.464h11.7a.75.75,0,0,1,.693.453.721.721,0,0,1-.164.8l-2.846,2.764a.763.763,0,0,1-1.06,0ZM0,11.449V4.215A4.274,4.274,0,0,1,4.322,0H9.068A4.284,4.284,0,0,1,13.4,4.225v.885a.75.75,0,0,1-1.5,0V4.225A2.8,2.8,0,0,0,9.068,1.463H4.322A2.79,2.79,0,0,0,1.5,4.215v7.234a.742.742,0,0,1-.751.732A.741.741,0,0,1,0,11.449Zm16.594-3.5-.718-.692a.718.718,0,0,1,0-1.034.76.76,0,0,1,1.06-.005l.717.691a.719.719,0,0,1,.005,1.035.763.763,0,0,1-1.06.005Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.244,4.618V3.685A3.685,3.685,0,0,0,8.559,0H3.684A3.685,3.685,0,0,0,0,3.685v11.13A3.685,3.685,0,0,0,3.684,18.5H8.569a3.675,3.675,0,0,0,3.675-3.674v-.943",
            transform: "translate(0.772 0.771)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M12.041.5H0",
            transform: "translate(7.768 9.521)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.928,2.915,0,5.831",
            transform: "translate(16.881 7.106)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.041.5H0",
            transform: "translate(7.75 9.621)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.928,2.916,0,5.832",
            transform: "translate(16.864 7.205)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.88C-.33,1.3-1.67,0-7,0c-7.1,0-7.1,2.31-7.1,9.25s0,9.25,7.1,9.25c5.33,0,6.67-1.3,7-4.88",
            transform: "translate(14.36 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$hn.displayName = "IconlyLogout", $63c37e44f569564f$var$hn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$cad1a703886b4e3a = $63c37e44f569564f$var$st($63c37e44f569564f$var$hn), $63c37e44f569564f$var$Ln = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.23,4.791V.782a.769.769,0,0,1,1.533-.1l.007.1V4.791h4.78A4.527,4.527,0,0,1,20,9.17l0,.216v5.039A4.53,4.53,0,0,1,15.768,19l-.208,0H4.44A4.511,4.511,0,0,1,0,14.621L0,14.4V9.376A4.532,4.532,0,0,1,4.222,4.8l.208-.005h4.8v6.4L7.63,9.541a.755.755,0,0,0-1.09,0,.835.835,0,0,0-.08,1.027l.08.1,2.91,3.015a.746.746,0,0,0,1.015.071l.075-.071,2.91-3.015a.816.816,0,0,0,0-1.126.755.755,0,0,0-1-.077l-.086.077-1.59,1.652v-6.4Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,4.446A4.526,4.526,0,0,1,4.591,0H9.624A4.515,4.515,0,0,1,14.2,4.436V15.552A4.526,4.526,0,0,1,9.613,20H4.581A4.517,4.517,0,0,1,0,15.562V4.446Z",
            transform: "translate(20 4.796) rotate(90)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M13.537,3.134,10.569.225a.79.79,0,0,0-1.106,0,.762.762,0,0,0,0,1.089l1.625,1.593H.782a.77.77,0,1,0,0,1.54H11.091L9.465,6.043a.762.762,0,0,0,0,1.089.79.79,0,0,0,1.106,0l2.968-2.909a.761.761,0,0,0,0-1.091",
            transform: "translate(13.68 0) rotate(90)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.041.5H0",
            transform: "translate(10.622 0.395) rotate(90)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.928,2.916,0,5.832",
            transform: "translate(13.038 9.508) rotate(90)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.617V3.684A3.684,3.684,0,0,1,3.685,0H8.569a3.675,3.675,0,0,1,3.675,3.675v11.14A3.685,3.685,0,0,1,8.559,18.5H3.674A3.675,3.675,0,0,1,0,14.825v-.942",
            transform: "translate(19.372 5.128) rotate(90)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.949,19a.8.8,0,0,1,0-1.6h7.614a2.958,2.958,0,0,0,2.9-3.01V9.32A2.969,2.969,0,0,0,15.553,6.3h-.931a.8.8,0,0,1,0-1.6h.931A4.542,4.542,0,0,1,20,9.32v5.067A4.533,4.533,0,0,1,15.563,19ZM0,14.377V9.31A4.532,4.532,0,0,1,4.437,4.7h.94a.8.8,0,0,1,0,1.6h-.94a2.96,2.96,0,0,0-2.9,3.01v5.067A2.969,2.969,0,0,0,4.447,17.4a.8.8,0,0,1,0,1.6A4.543,4.543,0,0,1,0,14.377Zm9.454-1.114L6.546,10.354a.765.765,0,0,1,0-1.084.774.774,0,0,1,1.089,0l1.593,1.592V.766a.771.771,0,0,1,1.542,0V12.722a.77.77,0,0,1-.77.766A.778.778,0,0,1,9.454,13.262Zm2.187-2.172a.754.754,0,0,1-.229-.544.763.763,0,0,1,.223-.54l.727-.732a.773.773,0,0,1,1.089-.006.763.763,0,0,1,.005,1.084l-.728.734a.77.77,0,0,1-1.087,0Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.041.5H0",
            transform: "translate(10.622 0.395) rotate(90)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.928,2.916,0,5.832",
            transform: "translate(13.038 9.508) rotate(90)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.617V3.684A3.684,3.684,0,0,1,3.685,0H8.569a3.675,3.675,0,0,1,3.675,3.675v11.14A3.685,3.685,0,0,1,8.559,18.5H3.674A3.675,3.675,0,0,1,0,14.825v-.942",
            transform: "translate(19.372 5.128) rotate(90)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,12.041V0",
            transform: "translate(9.379 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M5.832,0,2.916,2.928,0,0",
            transform: "translate(6.963 9.864)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M13.62,0C17.2.33,18.5,1.67,18.5,7c0,7.1-2.311,7.1-9.25,7.1S0,14.1,0,7C0,1.67,1.3.33,4.88,0",
            transform: "translate(0.75 5.259)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Ln.displayName = "IconlyDownload", $63c37e44f569564f$var$Ln.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$a7aaed3e118dd255 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Ln), $63c37e44f569564f$var$yn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.45,20.78A4.489,4.489,0,0,1,0,16.465l0-.213V11.288a4.485,4.485,0,0,1,4.231-4.5l.209,0H9.23v6.1a.769.769,0,0,0,1.533.107l.007-.107v-6.1h4.78A4.489,4.489,0,0,1,20,11.094l0,.213v4.955a4.487,4.487,0,0,1-4.231,4.513l-.209,0Zm4.781-14V2.64L7.64,4.24a.773.773,0,0,1-1.09,0,.763.763,0,0,1-.085-1L6.54,3.15,9.45.23A.764.764,0,0,1,10,0a.754.754,0,0,1,.45.149l.09.082,2.911,2.92a.771.771,0,0,1-1,1.165l-.085-.075-1.59-1.6V6.78Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,4.447A4.492,4.492,0,0,1,4.525,0H9.486A4.481,4.481,0,0,1,14,4.437V15.553A4.492,4.492,0,0,1,9.474,20H4.515A4.481,4.481,0,0,1,0,15.563V4.447Z",
            transform: "translate(0 20) rotate(-90)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M12.98,3.134,10.135.225a.736.736,0,0,0-1.061,0,.785.785,0,0,0,0,1.089l1.559,1.593H.75a.77.77,0,0,0,0,1.54h9.885L9.076,6.042a.785.785,0,0,0,0,1.089.735.735,0,0,0,1.061,0L12.98,4.225a.784.784,0,0,0,0-1.091",
            transform: "translate(6.321 13.201) rotate(-90)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.244,4.618V3.685A3.685,3.685,0,0,0,8.559,0H3.684A3.685,3.685,0,0,0,0,3.685v11.13A3.685,3.685,0,0,0,3.684,18.5H8.569a3.675,3.675,0,0,0,3.675-3.674v-.943",
            transform: "translate(0.772 0.771)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.041.5H0",
            transform: "translate(7.768 9.521)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.928,2.915,0,5.831",
            transform: "translate(16.881 7.106)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.045,19.25a.74.74,0,0,1,.731-.75,2.8,2.8,0,0,0,2.761-2.831V10.923A2.789,2.789,0,0,0,14.785,8.1h-.894a.75.75,0,0,1,0-1.5h.894A4.274,4.274,0,0,1,19,10.923V15.67A4.284,4.284,0,0,1,14.775,20,.74.74,0,0,1,14.045,19.25ZM4.215,20A4.273,4.273,0,0,1,0,15.679V10.932A4.284,4.284,0,0,1,4.225,6.6h.885a.75.75,0,0,1,0,1.5H4.225a2.8,2.8,0,0,0-2.761,2.831v4.747A2.79,2.79,0,0,0,4.215,18.5h7.234a.75.75,0,0,1,0,1.5Zm4.553-7.549V.75A.75.75,0,0,1,9.22.057a.721.721,0,0,1,.8.164l2.764,2.846a.763.763,0,0,1,0,1.06.719.719,0,0,1-1.035,0L10.232,2.566v9.885a.732.732,0,1,1-1.464,0ZM6.223,4.128a.76.76,0,0,1-.005-1.06l.691-.716a.719.719,0,0,1,1.035-.006.763.763,0,0,1,.005,1.06l-.692.718a.718.718,0,0,1-1.034,0Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.244,4.618V3.685A3.685,3.685,0,0,0,8.559,0H3.684A3.685,3.685,0,0,0,0,3.685v11.13A3.685,3.685,0,0,0,3.684,18.5H8.569a3.675,3.675,0,0,0,3.675-3.674v-.943",
            transform: "translate(0.772 0.771)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M12.041.5H0",
            transform: "translate(7.768 9.521)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.928,2.915,0,5.831",
            transform: "translate(16.881 7.106)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.041.5H0",
            transform: "translate(7.75 9.621)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.928,2.916,0,5.832",
            transform: "translate(16.864 7.205)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.88C-.33,1.3-1.67,0-7,0c-7.1,0-7.1,2.31-7.1,9.25s0,9.25,7.1,9.25c5.33,0,6.67-1.3,7-4.88",
            transform: "translate(14.36 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$yn.displayName = "IconlyUpload", $63c37e44f569564f$var$yn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$c58532f0fb5faa97 = $63c37e44f569564f$var$st($63c37e44f569564f$var$yn), $63c37e44f569564f$var$Wn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.532,19.043V17.118A8.443,8.443,0,0,1,0,8.783a.962.962,0,0,1,.968-.957.963.963,0,0,1,.969.957,6.563,6.563,0,0,0,13.125,0,.969.969,0,0,1,1.938,0,8.443,8.443,0,0,1-7.531,8.335v1.925a.968.968,0,0,1-1.937,0Zm.793-5.826a4.326,4.326,0,0,1-4.351-4.3V4.3A4.324,4.324,0,0,1,8.325,0h.35a4.325,4.325,0,0,1,4.352,4.3V8.92a4.326,4.326,0,0,1-4.352,4.3Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M16.031,0a.962.962,0,0,0-.969.957,6.563,6.563,0,0,1-13.125,0A.962.962,0,0,0,.969,0,.962.962,0,0,0,0,.957,8.443,8.443,0,0,0,7.532,9.293v1.925a.969.969,0,0,0,1.937,0V9.293A8.443,8.443,0,0,0,17,.957.962.962,0,0,0,16.031,0",
            transform: "translate(0 7.826)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.351,13.217H4.7a4.325,4.325,0,0,0,4.351-4.3V4.3A4.324,4.324,0,0,0,4.7,0H4.351A4.324,4.324,0,0,0,0,4.3V8.921a4.325,4.325,0,0,0,4.351,4.3",
            transform: "translate(3.973 0)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0A7.4,7.4,0,1,0,14.808,0",
            transform: "translate(0.714 8.932)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.476,2.81V0",
            transform: "translate(7.642 16.336)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.912,11.87H3.66A3.66,3.66,0,0,1,0,8.21V3.66A3.661,3.661,0,0,1,3.66,0h.252a3.661,3.661,0,0,1,3.66,3.66V8.21A3.66,3.66,0,0,1,3.912,11.87Z",
            transform: "translate(4.332 0.714)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.3,19.28V16.45a.712.712,0,0,1,.7-.72,6.673,6.673,0,0,0,6.593-6.737.7.7,0,1,1,1.408,0,8.118,8.118,0,0,1-7.3,8.14V19.28a.7.7,0,1,1-1.408,0ZM4.455,16.324A8.15,8.15,0,0,1,0,8.994a.712.712,0,0,1,.7-.72.713.713,0,0,1,.7.72A6.72,6.72,0,0,0,5.08,15.036.726.726,0,0,1,5.4,16a.7.7,0,0,1-.631.4A.675.675,0,0,1,4.455,16.324Zm3.42-2.932a4.362,4.362,0,0,1-4.309-4.4V4.4A4.362,4.362,0,0,1,7.875,0h.248a4.363,4.363,0,0,1,4.311,4.4V8.987a4.363,4.363,0,0,1-4.311,4.4ZM4.973,4.4V8.987a2.938,2.938,0,0,0,2.9,2.965h.248a2.938,2.938,0,0,0,2.9-2.965V4.4a2.938,2.938,0,0,0-2.9-2.965H7.875A2.938,2.938,0,0,0,4.973,4.4Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0A7.4,7.4,0,1,0,14.808,0",
            transform: "translate(0.714 8.932)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.476,2.81V0",
            transform: "translate(7.642 16.336)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M3.912,11.87H3.66A3.66,3.66,0,0,1,0,8.21V3.66A3.661,3.661,0,0,1,3.66,0h.252a3.661,3.661,0,0,1,3.66,3.66V8.21A3.66,3.66,0,0,1,3.912,11.87Z",
            transform: "translate(4.332 0.714)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4.9 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0A5.669,5.669,0,0,0,5.669,5.669,5.669,5.669,0,0,0,11.339,0",
            transform: "translate(1.465 11.178)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M11.339,7.923V5.669A5.669,5.669,0,0,0,0,5.669V7.923",
            transform: "translate(1.465 0)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,2.152V0",
            transform: "translate(6.634 16.848)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.5H14.268",
            transform: "translate(0 10.678)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Wn.displayName = "IconlyVoice", $63c37e44f569564f$var$Wn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$6ff815dd9a1e7763 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Wn), $63c37e44f569564f$var$Zn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.532,19.043V17.118A8.443,8.443,0,0,1,0,8.783a.962.962,0,0,1,.968-.957.963.963,0,0,1,.969.957,6.563,6.563,0,0,0,13.125,0,.969.969,0,0,1,1.938,0,8.443,8.443,0,0,1-7.531,8.335v1.925a.968.968,0,0,1-1.937,0Zm.793-5.827a4.324,4.324,0,0,1-4.351-4.3V4.3A4.324,4.324,0,0,1,8.325,0h.35a4.345,4.345,0,0,1,4.189,3.131.388.388,0,0,1-.376.493H11.356a.616.616,0,0,0-.62.612h0a.616.616,0,0,0,.62.612H12.4a.618.618,0,1,1,0,1.236H11.356a.613.613,0,1,0,0,1.226H12.4a.618.618,0,1,1,0,1.236H11.356a.612.612,0,1,0,0,1.224h1.077a.387.387,0,0,1,.372.506,4.347,4.347,0,0,1-4.13,2.94Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.351,13.217H4.7a4.348,4.348,0,0,0,4.131-2.941.387.387,0,0,0-.372-.505H7.383a.612.612,0,1,1,0-1.225H8.427a.618.618,0,1,0,0-1.236H7.383a.613.613,0,1,1,0-1.225H8.427a.618.618,0,1,0,0-1.236H7.383a.613.613,0,1,1,0-1.225H8.515a.388.388,0,0,0,.376-.493A4.345,4.345,0,0,0,4.7,0h-.35A4.324,4.324,0,0,0,0,4.3V8.92a4.324,4.324,0,0,0,4.351,4.3",
            transform: "translate(3.974 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M16.031,0a.962.962,0,0,0-.969.957,6.563,6.563,0,0,1-13.125,0A.962.962,0,0,0,.969,0,.962.962,0,0,0,0,.957,8.443,8.443,0,0,0,7.532,9.293v1.925a.969.969,0,0,0,1.937,0V9.293A8.443,8.443,0,0,0,17,.957.962.962,0,0,0,16.031,0",
            transform: "translate(0 7.826)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0A7.4,7.4,0,0,0,7.4,7.4a7.4,7.4,0,0,0,7.4-7.4",
            transform: "translate(0.714 8.932)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.476,2.81V0",
            transform: "translate(7.642 16.336)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.912,11.87H3.66A3.66,3.66,0,0,1,0,8.21V3.66A3.661,3.661,0,0,1,3.66,0h.252a3.66,3.66,0,0,1,3.66,3.66V8.21A3.659,3.659,0,0,1,3.912,11.87Z",
            transform: "translate(4.332 0.714)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.476H1.9",
            transform: "translate(10.002 4.401)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.476H2.855",
            transform: "translate(9.049 7.572)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.3,19.28V16.45a.711.711,0,0,1,.7-.72,6.674,6.674,0,0,0,6.593-6.736.7.7,0,1,1,1.408,0,8.116,8.116,0,0,1-7.3,8.138V19.28a.7.7,0,1,1-1.408,0ZM4.455,16.324A8.15,8.15,0,0,1,0,8.994a.712.712,0,0,1,.7-.719.713.713,0,0,1,.7.719A6.718,6.718,0,0,0,5.08,15.036.728.728,0,0,1,5.4,16a.7.7,0,0,1-.633.4A.68.68,0,0,1,4.455,16.324Zm3.42-2.933a4.362,4.362,0,0,1-4.31-4.4V4.4A4.362,4.362,0,0,1,7.875,0h.249a4.362,4.362,0,0,1,4.31,4.4v.509a.711.711,0,0,1-.7.718H9.855a.719.719,0,0,1,0-1.437H11.02a2.933,2.933,0,0,0-2.9-2.754H7.875A2.937,2.937,0,0,0,4.973,4.4V8.987a2.937,2.937,0,0,0,2.9,2.965h.249a2.938,2.938,0,0,0,2.9-2.965V8.824H8.916a.72.72,0,0,1,0-1.439h2.814a.712.712,0,0,1,.7.72v.883a4.362,4.362,0,0,1-4.31,4.4Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(0.75 0.75)"
        }, (0, $acw62.createElement)("g", {
            transform: "translate(-0.714 -0.714)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0A7.4,7.4,0,0,0,7.4,7.4a7.4,7.4,0,0,0,7.4-7.4",
            transform: "translate(0.714 8.932)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.476,2.81V0",
            transform: "translate(7.642 16.336)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M3.66,11.87A3.66,3.66,0,0,1,0,8.211V3.66A3.66,3.66,0,0,1,3.66,0h.252a3.66,3.66,0,0,1,3.66,3.66v4.55a3.659,3.659,0,0,1-3.66,3.659Z",
            transform: "translate(4.332 0.714)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.476H1.9",
            transform: "translate(10.001 4.401)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,.476H2.855",
            transform: "translate(9.049 7.572)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        })));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0A5.386,5.386,0,0,0,5.386,5.386,5.385,5.385,0,0,0,10.772,0",
            transform: "translate(2.104 11.332)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M10.772,7.527V5.386A5.386,5.386,0,0,0,0,5.386V7.527",
            transform: "translate(2.104 0.713)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.475,2.044V0",
            transform: "translate(7.015 16.718)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.475H13.556",
            transform: "translate(0.712 10.857)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.475H2.985",
            transform: "translate(5.997 7.477)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M1,.475H0",
            transform: "translate(6.988 4.707)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Zn.displayName = "IconlyVoice2", $63c37e44f569564f$var$Zn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$19b08aa11ddb3401 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Zn), $63c37e44f569564f$var$Cn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.132,19.961A2.916,2.916,0,0,1,2.2,17.134c-.313-2.847-.836-9.577-.846-9.645a.791.791,0,0,1,.191-.558A.708.708,0,0,1,2.068,6.7H15.939a.724.724,0,0,1,.523.234.745.745,0,0,1,.181.558c0,.068-.533,6.809-.837,9.645a2.918,2.918,0,0,1-3,2.827C11.515,19.99,10.249,20,9,20,7.681,20,6.387,19.99,5.132,19.961ZM.714,5.091A.73.73,0,0,1,0,4.357v-.38a.724.724,0,0,1,.714-.734H3.63A1.282,1.282,0,0,0,4.871,2.228l.152-.682A1.989,1.989,0,0,1,6.935,0h4.129a1.987,1.987,0,0,1,1.9,1.5l.163.73a1.28,1.28,0,0,0,1.241,1.016h2.916A.723.723,0,0,1,18,3.977v.38a.73.73,0,0,1-.713.734Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.289.792c0,.068-.533,6.809-.837,9.646a2.918,2.918,0,0,1-3,2.827c-1.293.029-2.56.039-3.806.039-1.323,0-2.616-.01-3.872-.039A2.917,2.917,0,0,1,.847,10.438C.534,7.591.011.86,0,.792A.794.794,0,0,1,.192.234.71.71,0,0,1,.715,0H14.585a.73.73,0,0,1,.523.234.748.748,0,0,1,.181.558",
            transform: "translate(1.354 6.696)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M18,3.977a.722.722,0,0,0-.713-.733H14.371A1.281,1.281,0,0,1,13.13,2.227L12.967,1.5a1.985,1.985,0,0,0-1.9-1.5H6.936A1.988,1.988,0,0,0,5.023,1.546l-.153.682A1.283,1.283,0,0,1,3.63,3.244H.714A.722.722,0,0,0,0,3.977v.38a.729.729,0,0,0,.714.733H17.287A.729.729,0,0,0,18,4.357Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.191,0s-.543,6.735-.858,9.572a2.238,2.238,0,0,1-2.358,2.174c-2.609.047-5.221.05-7.829-.005A2.214,2.214,0,0,1,.857,9.579C.54,6.717,0,0,0,0",
            transform: "translate(2.134 7.468)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M16.958.5H0",
            transform: "translate(0.75 3.74)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M10.423,3.489A1.648,1.648,0,0,1,8.808,2.165L8.565.949A1.28,1.28,0,0,0,7.328,0H3.1A1.28,1.28,0,0,0,1.858.949L1.615,2.165A1.648,1.648,0,0,1,0,3.489",
            transform: "translate(4.018 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.191,20a.732.732,0,0,1,0-1.463h0c1.518,0,2.064-.008,3.583-.035a1.494,1.494,0,0,0,1.608-1.526c.3-2.8.832-9.5.836-9.571a.714.714,0,1,1,1.422.118c0,.067-.534,6.792-.84,9.613a2.917,2.917,0,0,1-3,2.828c-1.286.024-1.6.037-2.884.037Zm-4.065-.04a2.915,2.915,0,0,1-2.932-2.817C1.886,14.3,1.36,7.589,1.355,7.521a.727.727,0,0,1,.653-.788.73.73,0,0,1,.769.672c.005.067.53,6.752.836,9.574A1.475,1.475,0,0,0,5.154,18.5a.732.732,0,0,1-.014,1.462ZM.713,4.96a.732.732,0,0,1,0-1.463H3.907a.9.9,0,0,0,.878-.736l.238-1.22A1.99,1.99,0,0,1,6.932,0h4.136a1.977,1.977,0,0,1,1.9,1.494.735.735,0,0,1-.5.9.712.712,0,0,1-.874-.518.542.542,0,0,0-.52-.409H6.932a.542.542,0,0,0-.52.409L6.185,3.046a2.5,2.5,0,0,1-.139.451h11.24a.732.732,0,0,1,0,1.463Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.191,0s-.543,6.735-.858,9.572a2.238,2.238,0,0,1-2.358,2.174c-2.609.047-5.221.05-7.829-.005A2.214,2.214,0,0,1,.857,9.579C.54,6.717,0,0,0,0",
            transform: "translate(2.134 7.468)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M16.958.5H0",
            transform: "translate(0.75 3.74)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M10.423,3.489A1.648,1.648,0,0,1,8.808,2.165L8.565.949A1.28,1.28,0,0,0,7.328,0H3.1A1.28,1.28,0,0,0,1.858.949L1.615,2.165A1.648,1.648,0,0,1,0,3.489",
            transform: "translate(4.018 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.26,0c0,8.019,1.154,11.644-6.61,11.644S.064,8.019.064,0",
            transform: "translate(2.129 7.554)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M16.15.476H0",
            transform: "translate(0.715 4.004)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M6.874,3.766A3.207,3.207,0,0,0,3.448,0,3.207,3.207,0,0,0,.024,3.766",
            transform: "translate(5.341 0.714)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Cn.displayName = "IconlyVoice", $63c37e44f569564f$var$Cn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$bfadae053a633538 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Cn), $63c37e44f569564f$var$Hn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M11.28,18a1.023,1.023,0,0,1,0-2.047h5.71a1.023,1.023,0,0,1,0,2.047ZM.848,17.576l-.8-3.451a2.132,2.132,0,0,1,.4-1.8L6.684,4.268a.313.313,0,0,1,.424-.054L9.73,6.3a.846.846,0,0,0,.647.183.945.945,0,0,0,.817-1.043,1.053,1.053,0,0,0-.329-.635L8.319,2.763a.378.378,0,0,1-.064-.526L9.241.957A2.584,2.584,0,0,1,13.03.7l1.475,1.172a3.062,3.062,0,0,1,1.146,1.752,2.4,2.4,0,0,1-.488,2.042L6.377,17.028a2.105,2.105,0,0,1-1.634.817l-3.5.042A.4.4,0,0,1,.848,17.576Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.7,0H1.007A1.017,1.017,0,0,0,0,1.023,1.016,1.016,0,0,0,1.007,2.047H6.7A1.016,1.016,0,0,0,7.709,1.023,1.017,1.017,0,0,0,6.7,0",
            transform: "translate(10.291 15.953)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M7.309.067l5.4,4.36a.31.31,0,0,1,.051.429l-6.4,8.335a2.1,2.1,0,0,1-1.63.817l-3.492.043a.4.4,0,0,1-.392-.312L.052,10.289a2.137,2.137,0,0,1,.4-1.8L6.883.118A.3.3,0,0,1,7.309.067",
            transform: "translate(0 3.837)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M6.977,5.665l-1.04,1.3a.3.3,0,0,1-.423.048c-1.265-1.023-4.5-3.65-5.4-4.377A.308.308,0,0,1,.069,2.2l1-1.246A2.572,2.572,0,0,1,4.85.7L6.321,1.871A3.066,3.066,0,0,1,7.464,3.623a2.406,2.406,0,0,1-.487,2.042",
            transform: "translate(8.144 0)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,.5H6.377",
            transform: "translate(10.2 15.898)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M8.6.706A1.947,1.947,0,0,1,11.473.553l1.39,1.09A1.946,1.946,0,0,1,13.4,4.464L5.11,15.039a1.481,1.481,0,0,1-1.15.568l-3.2.041L.039,12.533a1.486,1.486,0,0,1,.277-1.252Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,4.794,3.758",
            transform: "translate(7.803 3.436)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.6,18a.788.788,0,0,1,0-1.575h6.624a.788.788,0,0,1,0,1.575ZM1.572,18a.782.782,0,0,1-.76-.609l-.752-3.27A2.355,2.355,0,0,1,.5,12.142l1.13-1.458a.772.772,0,0,1,1.094-.133.792.792,0,0,1,.131,1.105l-1.13,1.458a.773.773,0,0,0-.142.651l.61,2.652,2.7-.034a.755.755,0,0,0,.59-.3l8.61-11.1a1.063,1.063,0,0,0,.228-.907,1.732,1.732,0,0,0-.652-.949L12.218,1.983a1.256,1.256,0,0,0-1.886.028L9.194,3.477,11,4.94a.792.792,0,0,1,.121,1.106.771.771,0,0,1-1.1.122L8.233,4.717l-2.946,3.8a.773.773,0,0,1-1.1.133.8.8,0,0,1-.131-1.106L9.105,1.039a2.779,2.779,0,0,1,4.073-.3l1.444,1.145A3.3,3.3,0,0,1,15.835,3.74a2.65,2.65,0,0,1-.523,2.214L6.7,17.059a2.3,2.3,0,0,1-1.8.9L1.582,18Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,.5H6.377",
            transform: "translate(10.2 15.898)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M8.6.706A1.947,1.947,0,0,1,11.473.553l1.39,1.09A1.946,1.946,0,0,1,13.4,4.464L5.11,15.039a1.481,1.481,0,0,1-1.15.568l-3.2.041L.039,12.533a1.486,1.486,0,0,1,.277-1.252Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,4.794,3.758",
            transform: "translate(7.803 3.436)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,.5H6.377",
            transform: "translate(9.835 15.508)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M11.808.609h0a3.042,3.042,0,0,0-4.258.607l-6.752,9C-.941,12.529.7,15.4.7,15.4s3.244.746,4.958-1.539l6.752-8.995A3.042,3.042,0,0,0,11.808.609Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,4.864,3.651",
            transform: "translate(7.004 3.711)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Hn.displayName = "IconlyEdit", $63c37e44f569564f$var$Hn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$6ed0965c9443aaa6 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Hn), $63c37e44f569564f$var$wn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15,20c-.11,0-.222,0-.332-.01H5.335C5.225,20,5.112,20,5,20a5.321,5.321,0,0,1-3.6-1.4A5.371,5.371,0,0,1,.01,14.665V5.335A5.372,5.372,0,0,1,1.4,1.4,5.328,5.328,0,0,1,5,0c.11,0,.221,0,.331.01h9.33c.109-.007.219-.01.328-.01a5.317,5.317,0,0,1,3.6,1.4,5.416,5.416,0,0,1,1.4,3.937v9.33A5.4,5.4,0,0,1,18.6,18.6,5.323,5.323,0,0,1,15,20ZM10.38,6.464a.214.214,0,0,0-.15.059L5.465,11.289a1.8,1.8,0,0,0-.529,1.238L4.875,14.9a.467.467,0,0,0,.13.339.478.478,0,0,0,.34.14H7.692a1.84,1.84,0,0,0,1.289-.53L15.7,8.1a1.586,1.586,0,0,0,0-2.227l-1.3-1.3a1.58,1.58,0,0,0-2.237,0l-.67.68a.265.265,0,0,0,0,.369c.016.016,1.589,1.579,1.618,1.619a.678.678,0,0,1,.18.459.66.66,0,0,1-.659.66.626.626,0,0,1-.44-.18L10.529,6.523A.212.212,0,0,0,10.38,6.464Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.664,19.99H5.335A5.343,5.343,0,0,1,1.4,18.6,5.346,5.346,0,0,1,.01,14.665V5.335A5.345,5.345,0,0,1,1.4,1.4,5.347,5.347,0,0,1,5.335.01h9.329A5.338,5.338,0,0,1,18.6,1.4,5.372,5.372,0,0,1,19.99,5.335v9.33A5.35,5.35,0,0,1,18.6,18.6a5.347,5.347,0,0,1-3.937,1.389",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M10.555,3.9,4,10.483A1.8,1.8,0,0,1,2.746,11H.458a.463.463,0,0,1-.331-.137A.457.457,0,0,1,0,10.532L.058,8.22A1.759,1.759,0,0,1,.574,7.01L5.219,2.356a.211.211,0,0,1,.292,0L7.14,3.979a.615.615,0,0,0,.428.176.643.643,0,0,0,.643-.644.661.661,0,0,0-.175-.449c-.029-.039-1.58-1.583-1.58-1.583a.26.26,0,0,1,0-.361L7.108.454a1.538,1.538,0,0,1,2.181,0l1.266,1.268a1.551,1.551,0,0,1,0,2.176",
            transform: "translate(4.5 4.5)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.742,0H5C1.928,0,0,2.177,0,5.259v8.314c0,3.082,1.919,5.259,5,5.259h8.824c3.085,0,5-2.177,5-5.259V9.545",
            transform: "translate(0.75 0.789)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.729,8.17,8.2.7a2.385,2.385,0,0,1,3.371,0L12.79,1.914a2.383,2.383,0,0,1,0,3.371L5.281,12.795a2.171,2.171,0,0,1-1.535.636H0l.094-3.78A2.17,2.17,0,0,1,.729,8.17Z",
            transform: "translate(6.099 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,4.566,4.566",
            transform: "translate(13.165 2.602)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.658,20C2.273,20,0,17.629,0,14.1a.738.738,0,0,1,1.476,0c0,2.69,1.641,4.427,4.182,4.427h8.678c2.543,0,4.185-1.737,4.185-4.427V10.146a.737.737,0,0,1,1.474,0V14.1c0,3.529-2.273,5.9-5.659,5.9ZM6,14.658A.739.739,0,0,1,5.26,13.9l.094-3.71a2.859,2.859,0,0,1,.84-1.957L13.543.9A3.086,3.086,0,0,1,17.9.9l1.2,1.2a3.072,3.072,0,0,1,0,4.351l-7.384,7.373a2.853,2.853,0,0,1-2.03.84Zm1.24-5.379a1.389,1.389,0,0,0-.41.952l-.073,2.954H9.683a1.39,1.39,0,0,0,.987-.408l7.385-7.372a1.606,1.606,0,0,0,0-2.268l-1.2-1.2a1.61,1.61,0,0,0-2.272,0l-.606.6,1.875,1.871a.738.738,0,0,1-1.044,1.042L12.938,3.587ZM0,9.707V5.938C0,2.409,2.274.038,5.658.038H9.336a.736.736,0,1,1,0,1.472H5.658c-2.541,0-4.182,1.738-4.182,4.428V9.707A.738.738,0,0,1,0,9.707Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.742,0H5C1.928,0,0,2.177,0,5.259v8.314c0,3.082,1.919,5.259,5,5.259h8.824c3.085,0,5-2.177,5-5.259V9.545",
            transform: "translate(0.75 0.789)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.729,8.17,8.2.7a2.385,2.385,0,0,1,3.371,0L12.79,1.914a2.383,2.383,0,0,1,0,3.371L5.281,12.795a2.171,2.171,0,0,1-1.535.636H0l.094-3.78A2.17,2.17,0,0,1,.729,8.17Z",
            transform: "translate(6.099 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,4.566,4.566",
            transform: "translate(13.165 2.602)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.25,0C2.313,0,0,2.313,0,9.25S2.313,18.5,9.25,18.5s9.25-2.313,9.25-9.25",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M10.071.6h0A2.4,2.4,0,0,0,6.682.809S2.313,5.744.8,7.457s-.4,4.077-.4,4.077,2.5.793,4-.9l5.886-6.647A2.4,2.4,0,0,0,10.071.6Z",
            transform: "translate(7.457 1.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,3.6,3.183",
            transform: "translate(13.009 3.801)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$wn.displayName = "IconlyEditSquare", $63c37e44f569564f$var$wn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$59b55e53f81d8d44 = $63c37e44f569564f$var$st($63c37e44f569564f$var$wn), $63c37e44f569564f$var$Tn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,20a10,10,0,1,1,10-9.994A10.008,10.008,0,0,1,10,20ZM8.861,6.03a1.338,1.338,0,0,0-.608.145,1.252,1.252,0,0,0-.541.6,6.314,6.314,0,0,0-.174.7A15.391,15.391,0,0,0,7.375,10a17.717,17.717,0,0,0,.145,2.441,1.1,1.1,0,0,1,.024.11,3.911,3.911,0,0,0,.207.768,1.21,1.21,0,0,0,1.072.656h.039a3.188,3.188,0,0,0,.9-.27,14.727,14.727,0,0,0,3.851-2.624l.058-.058a3.94,3.94,0,0,0,.27-.309,1.161,1.161,0,0,0,.231-.7,1.217,1.217,0,0,0-.251-.754l-.063-.068c-.064-.07-.162-.176-.254-.269A14.777,14.777,0,0,0,9.662,6.251,3.356,3.356,0,0,0,8.861,6.03Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M20,10A10,10,0,1,1,10,0,10.012,10.012,0,0,1,20,10",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M7,4a1.153,1.153,0,0,1-.239.71,3.861,3.861,0,0,1-.278.311l-.06.058A15.152,15.152,0,0,1,2.456,7.728,3.475,3.475,0,0,1,1.531,8h-.04a1.254,1.254,0,0,1-1.1-.66,5.462,5.462,0,0,1-.239-.885A17.629,17.629,0,0,1,0,4,15.213,15.213,0,0,1,.169,1.458,6.381,6.381,0,0,1,.348.748,1.275,1.275,0,0,1,.9.146,1.422,1.422,0,0,1,1.531,0a3.443,3.443,0,0,1,.825.224A15.224,15.224,0,0,1,6.413,2.906c.139.136.288.3.328.34A1.21,1.21,0,0,1,7,4",
            transform: "translate(7 6)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M5.16,3.969A14.915,14.915,0,0,1,1.432,6.512a3.983,3.983,0,0,1-.664.214.5.5,0,0,1-.459-.27,5.24,5.24,0,0,1-.166-.689A16.6,16.6,0,0,1,0,3.364,15.624,15.624,0,0,1,.158.879C.186.723.268.364.292.306A.5.5,0,0,1,.518.06.494.494,0,0,1,.768,0a3.49,3.49,0,0,1,.575.178A14.782,14.782,0,0,1,5.15,2.746c.068.073.255.269.286.309a.5.5,0,0,1,.011.6C5.414,3.7,5.223,3.9,5.16,3.969Z",
            transform: "translate(7.89 6.498)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.987,19.162a.724.724,0,1,1,.582-1.325,8.558,8.558,0,1,0-3.447-2.753.724.724,0,0,1-1.164.861,9.982,9.982,0,1,1,4.028,3.217ZM8.82,13.969a1.213,1.213,0,0,1-1.067-.651,4.442,4.442,0,0,1-.229-.868l0-.014A16.433,16.433,0,0,1,7.375,10a15.607,15.607,0,0,1,.163-2.526,5.615,5.615,0,0,1,.176-.707,1.2,1.2,0,0,1,.536-.591,1.273,1.273,0,0,1,.6-.145h.018a3.176,3.176,0,0,1,.8.223A14.714,14.714,0,0,1,13.6,8.909l.079.085c.09.095.21.224.238.259a1.218,1.218,0,0,1,.257.747,1.2,1.2,0,0,1-.23.708c-.036.049-.191.219-.284.318l-.049.052A15.033,15.033,0,0,1,9.76,13.707a3.712,3.712,0,0,1-.9.262Zm.141-6.236A14.873,14.873,0,0,0,8.822,10a15.235,15.235,0,0,0,.129,2.2c.011.066.03.161.05.248l.117-.045.006,0,.076-.03a13.772,13.772,0,0,0,3.347-2.281.449.449,0,0,0,.058-.059l.005-.005A.226.226,0,0,1,12.635,10l-.007-.007-.007-.007L12.537,9.9A13.736,13.736,0,0,0,9.131,7.6L9,7.55C8.98,7.636,8.969,7.694,8.961,7.733Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M5.16,3.969A14.915,14.915,0,0,1,1.432,6.512a3.983,3.983,0,0,1-.664.214.5.5,0,0,1-.459-.27,5.24,5.24,0,0,1-.166-.689A16.6,16.6,0,0,1,0,3.364,15.624,15.624,0,0,1,.158.879C.186.723.268.364.292.306A.5.5,0,0,1,.518.06.494.494,0,0,1,.768,0a3.49,3.49,0,0,1,.575.178A14.782,14.782,0,0,1,5.15,2.746c.068.073.255.269.286.309a.5.5,0,0,1,.011.6C5.414,3.7,5.223,3.9,5.16,3.969Z",
            transform: "translate(7.89 6.498)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M5.513,3.338c0-.9-4.584-3.8-5.1-3.276s-.57,5.983,0,6.552S5.513,4.242,5.513,3.338Z",
            transform: "translate(7.903 6.517)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Tn.displayName = "IconlyPlay", $63c37e44f569564f$var$Tn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$480db61f4dcd7727 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Tn), $63c37e44f569564f$var$In = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.581,20a.759.759,0,0,1-.353-.086l-3.6-1.863a8.458,8.458,0,0,1-2.446-1.817A8.25,8.25,0,0,1,.042,10.759L0,4.124A1.813,1.813,0,0,1,1.229,2.413L7.841.106A1.889,1.889,0,0,1,9.071.1l6.637,2.227a1.81,1.81,0,0,1,1.249,1.7L17,10.662a8.241,8.241,0,0,1-2.065,5.5A8.448,8.448,0,0,1,12.513,18L8.945,19.91a.787.787,0,0,1-.358.09ZM5.9,9.007a.764.764,0,0,0-.539.219.722.722,0,0,0,.007,1.039l1.916,1.843a.758.758,0,0,0,.528.212h.007a.761.761,0,0,0,.533-.219l3.9-3.844a.722.722,0,0,0-.006-1.039.769.769,0,0,0-1.067.005L7.808,10.545,6.429,9.219A.76.76,0,0,0,5.9,9.007Z",
            transform: "translate(0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.586,20a.782.782,0,0,1-.359-.086l-3.6-1.864a8.453,8.453,0,0,1-2.445-1.816A8.243,8.243,0,0,1,.042,10.76L0,4.124A1.813,1.813,0,0,1,1.228,2.412L7.841.107A1.882,1.882,0,0,1,9.071.1l6.637,2.227a1.809,1.809,0,0,1,1.249,1.7L17,10.663a8.243,8.243,0,0,1-2.066,5.5A8.423,8.423,0,0,1,12.513,18L8.944,19.909A.764.764,0,0,1,8.586,20",
            transform: "translate(0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M2.676,5.315A.764.764,0,0,1,2.141,5.1L.224,3.26A.722.722,0,0,1,.218,2.22a.77.77,0,0,1,1.068-.007L2.665,3.539,6.033.219A.77.77,0,0,1,7.1.212a.721.721,0,0,1,.007,1.039L3.209,5.1a.76.76,0,0,1-.533.219",
            transform: "translate(5.143 7.006)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.615,2.375A1.089,1.089,0,0,1,15.344,3.4v6.773a7.781,7.781,0,0,1-1.9,5.1,7.771,7.771,0,0,1-2.2,1.7L7.678,18.9,4.114,16.972a7.767,7.767,0,0,1-2.208-1.7A7.783,7.783,0,0,1,0,10.172V3.4A1.089,1.089,0,0,1,.729,2.375L7.311.062a1.09,1.09,0,0,1,.722,0Z",
            transform: "translate(0.75 0.749)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.005,1.892,3.9,5.79,0",
            transform: "translate(5.823 7.913)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.147,19.912l-3.6-1.885A8.523,8.523,0,0,1,2.11,16.2,8.247,8.247,0,0,1,0,10.708a.748.748,0,0,1,.758-.736.747.747,0,0,1,.757.736,6.8,6.8,0,0,0,1.738,4.524,7.024,7.024,0,0,0,2.016,1.5l3.237,1.7,3.23-1.7a7,7,0,0,0,2.015-1.5,6.792,6.792,0,0,0,1.735-4.521V4.072a.335.335,0,0,0-.229-.315L8.614,1.49a.352.352,0,0,0-.228,0L1.744,3.757a.335.335,0,0,0-.229.315v1.9a.748.748,0,0,1-.757.737A.748.748,0,0,1,0,5.971v-1.9a1.815,1.815,0,0,1,1.243-1.7L7.885.1a1.932,1.932,0,0,1,1.23,0l6.643,2.266A1.814,1.814,0,0,1,17,4.072v6.64A8.238,8.238,0,0,1,14.9,16.2a8.486,8.486,0,0,1-2.438,1.831L8.866,19.912a.777.777,0,0,1-.719,0Zm-.9-7.81-1.91-1.856a.722.722,0,0,1,0-1.04.771.771,0,0,1,1.07,0l1.374,1.336,3.4-3.3a.772.772,0,0,1,1.07,0,.722.722,0,0,1,0,1.04L8.321,12.1a.771.771,0,0,1-1.07,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.615,2.375A1.089,1.089,0,0,1,15.344,3.4v6.773a7.781,7.781,0,0,1-1.9,5.1,7.771,7.771,0,0,1-2.2,1.7L7.678,18.9,4.114,16.972a7.767,7.767,0,0,1-2.208-1.7A7.783,7.783,0,0,1,0,10.172V3.4A1.089,1.089,0,0,1,.729,2.375L7.311.062a1.09,1.09,0,0,1,.722,0Z",
            transform: "translate(0.75 0.749)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.005,1.892,3.9,5.79,0",
            transform: "translate(5.823 7.913)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.735,18.855a8.4,8.4,0,0,0,7.672-8.727c0-6.4.278-6.905-.337-7.521A12.6,12.6,0,0,0,7.735,0,12.589,12.589,0,0,0,.4,2.607c-.616.616-.338,1.117-.338,7.521A8.4,8.4,0,0,0,7.735,18.855Z",
            transform: "translate(0.75 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.005,1.892,3.9,5.79,0",
            transform: "translate(5.886 7.87)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$In.displayName = "IconlyShieldDone", $63c37e44f569564f$var$In.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$f5760a0e054f6f6f = $63c37e44f569564f$var$st($63c37e44f569564f$var$In), $63c37e44f569564f$var$xn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.586,20a.78.78,0,0,1-.363-.088l-3.6-1.863a8.4,8.4,0,0,1-2.435-1.814A8.2,8.2,0,0,1,.04,10.763L0,4.123A1.8,1.8,0,0,1,1.228,2.416L7.841.1a1.838,1.838,0,0,1,.61-.1,1.9,1.9,0,0,1,.618.1L15.7,2.328a1.8,1.8,0,0,1,1.248,1.7L17,10.664a8.248,8.248,0,0,1-2.074,5.492A8.366,8.366,0,0,1,12.511,18L8.938,19.912A.747.747,0,0,1,8.586,20ZM8.5,10.763h0l1.358,1.323a.757.757,0,0,0,.533.214.74.74,0,0,0,.534-.214.727.727,0,0,0,0-1.04L9.562,9.723,10.921,8.4a.717.717,0,0,0,.219-.509.742.742,0,0,0-.219-.531.773.773,0,0,0-1.067,0L8.5,8.684,7.136,7.359a.753.753,0,0,0-.53-.213.78.78,0,0,0-.537.213.741.741,0,0,0-.219.531A.715.715,0,0,0,6.07,8.4L7.428,9.723,6.07,11.047a.725.725,0,0,0,0,1.04A.76.76,0,0,0,6.6,12.3a.718.718,0,0,0,.534-.214l1.358-1.323Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.586,20a.778.778,0,0,1-.358-.086l-3.6-1.864a8.426,8.426,0,0,1-2.446-1.816A8.243,8.243,0,0,1,.041,10.76L0,4.124A1.812,1.812,0,0,1,1.227,2.412L7.84.107A1.883,1.883,0,0,1,9.07.1l6.638,2.227a1.809,1.809,0,0,1,1.249,1.7L17,10.663a8.241,8.241,0,0,1-2.065,5.5A8.437,8.437,0,0,1,12.514,18L8.944,19.909A.768.768,0,0,1,8.586,20",
            transform: "translate(0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M3.715,2.578,5.073,1.255a.721.721,0,0,0,0-1.039A.77.77,0,0,0,4,.215L2.647,1.537,1.289.215a.77.77,0,0,0-1.068,0,.721.721,0,0,0,0,1.039L1.579,2.578.221,3.9a.721.721,0,0,0,0,1.039.769.769,0,0,0,1.068,0L2.647,3.618,4,4.94a.769.769,0,0,0,1.068,0,.721.721,0,0,0,0-1.039Z",
            transform: "translate(5.853 7.147)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.615,2.375A1.089,1.089,0,0,1,15.344,3.4v6.773a7.787,7.787,0,0,1-1.9,5.1,7.785,7.785,0,0,1-2.2,1.7L7.678,18.9,4.114,16.972a7.753,7.753,0,0,1-2.208-1.7A7.783,7.783,0,0,1,0,10.172V3.4A1.089,1.089,0,0,1,.729,2.375L7.311.062a1.09,1.09,0,0,1,.722,0Z",
            transform: "translate(0.75 0.749)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.758,3.758,0,0",
            transform: "translate(6.543 8.088)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,3.758,3.758,0",
            transform: "translate(6.543 8.088)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.147,19.912l-3.6-1.885A8.523,8.523,0,0,1,2.11,16.2,8.247,8.247,0,0,1,0,10.708a.748.748,0,0,1,.758-.736.747.747,0,0,1,.757.736,6.8,6.8,0,0,0,1.738,4.524,7.024,7.024,0,0,0,2.016,1.5l3.237,1.7,3.23-1.7a7.009,7.009,0,0,0,2.015-1.5,6.792,6.792,0,0,0,1.735-4.521V4.072a.335.335,0,0,0-.229-.315L8.614,1.49a.352.352,0,0,0-.228,0L1.744,3.757a.334.334,0,0,0-.229.315v1.9a.748.748,0,0,1-.757.737A.748.748,0,0,1,0,5.971v-1.9a1.815,1.815,0,0,1,1.243-1.7L7.885.1A1.929,1.929,0,0,1,9.114.1l6.644,2.266A1.814,1.814,0,0,1,17,4.072v6.64A8.238,8.238,0,0,1,14.9,16.2a8.5,8.5,0,0,1-2.438,1.831L8.866,19.912a.777.777,0,0,1-.719,0Zm1.7-7.748L8.486,10.841,7.125,12.163a.771.771,0,0,1-1.07,0,.72.72,0,0,1,0-1.04L7.416,9.8,6.055,8.477a.719.719,0,0,1,0-1.04.772.772,0,0,1,1.07,0L8.486,8.762,9.848,7.438a.772.772,0,0,1,1.07,0,.721.721,0,0,1,0,1.04L9.556,9.8l1.362,1.322a.722.722,0,0,1,0,1.04.771.771,0,0,1-1.07,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.615,2.375A1.089,1.089,0,0,1,15.344,3.4v6.773a7.787,7.787,0,0,1-1.9,5.1,7.785,7.785,0,0,1-2.2,1.7L7.678,18.9,4.114,16.972a7.753,7.753,0,0,1-2.208-1.7A7.783,7.783,0,0,1,0,10.172V3.4A1.089,1.089,0,0,1,.729,2.375L7.311.062a1.09,1.09,0,0,1,.722,0Z",
            transform: "translate(0.75 0.749)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M1.879,1.879,0,3.758,1.879,1.879,0,0,1.879,1.879,3.758,0,1.879,1.879,3.758,3.758Z",
            transform: "translate(6.543 8.088)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.736,18.855a8.4,8.4,0,0,0,7.672-8.727c0-6.4.278-6.905-.338-7.521A12.592,12.592,0,0,0,7.736,0,12.6,12.6,0,0,0,.4,2.607c-.616.616-.338,1.117-.338,7.521A8.4,8.4,0,0,0,7.736,18.855Z",
            transform: "translate(0.75 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.759,3.758,0,0",
            transform: "translate(6.605 8.066)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,3.758,3.759,0",
            transform: "translate(6.605 8.066)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$xn.displayName = "IconlyShieldFail", $63c37e44f569564f$var$xn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$7a5db7635b30a2d = $63c37e44f569564f$var$st($63c37e44f569564f$var$xn), $63c37e44f569564f$var$En = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.99,16C5.861,16,2.148,13.115.059,8.281a.724.724,0,0,1,0-.571C2.146,2.882,5.858,0,9.99,0H10a9.306,9.306,0,0,1,5.737,2.046,14.235,14.235,0,0,1,4.2,5.664.725.725,0,0,1,0,.571C17.851,13.115,14.135,16,10,16ZM6.1,8A3.9,3.9,0,1,0,10,4.121,3.89,3.89,0,0,0,6.1,8ZM7.562,8a2.487,2.487,0,0,1,.049-.475H7.66a2,2,0,0,0,2-1.921A1.989,1.989,0,0,1,10,5.574,2.419,2.419,0,1,1,7.562,8Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,16H9.99C5.861,16,2.148,13.114.058,8.281a.723.723,0,0,1,0-.571C2.145,2.882,5.858,0,9.99,0H10a9.307,9.307,0,0,1,5.737,2.046,14.231,14.231,0,0,1,4.2,5.664.723.723,0,0,1,0,.571C17.851,13.114,14.135,16,10,16ZM10,4.121A3.874,3.874,0,1,0,13.892,8,3.9,3.9,0,0,0,10,4.121Z",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.868,2.424A2.434,2.434,0,0,1,0,2.424,2.521,2.521,0,0,1,.049,1.95H.1A2,2,0,0,0,2.1.029,2.043,2.043,0,0,1,2.439,0,2.43,2.43,0,0,1,4.868,2.424",
            transform: "translate(7.563 5.573)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.323,3.162A3.162,3.162,0,1,1,3.161,0,3.162,3.162,0,0,1,6.323,3.162Z",
            transform: "translate(6.839 4.891)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M9.248,14.6c3.808,0,7.291-2.738,9.252-7.3C16.539,2.738,13.056,0,9.248,0h0C5.444,0,1.961,2.738,0,7.3c1.961,4.564,5.444,7.3,9.252,7.3Z",
            transform: "translate(0.75 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,16h0C5.863,16,2.147,13.115.059,8.287a.721.721,0,0,1,0-.573C2.147,2.886,5.863,0,10,0h0c4.136,0,7.852,2.886,9.939,7.714a.721.721,0,0,1,0,.573,17.051,17.051,0,0,1-.823,1.654.734.734,0,0,1-1,.277.726.726,0,0,1-.277-.991c.221-.391.432-.8.625-1.228C16.6,3.9,13.453,1.456,10,1.455S3.4,3.9,1.531,8C3.4,12.1,6.547,14.545,10,14.545a8.108,8.108,0,0,0,5.6-2.4.736.736,0,0,1,1.033.024.722.722,0,0,1-.023,1.027A9.545,9.545,0,0,1,10,16ZM8,11.324a.723.723,0,0,1-.25-1,.732.732,0,0,1,1-.247A2.419,2.419,0,1,0,7.564,8,.731.731,0,0,1,6.1,8,3.892,3.892,0,1,1,8,11.324Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.323,3.162A3.162,3.162,0,1,1,3.161,0,3.162,3.162,0,0,1,6.323,3.162Z",
            transform: "translate(6.839 4.891)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M9.248,14.6c3.808,0,7.291-2.738,9.252-7.3C16.539,2.738,13.056,0,9.248,0h0C5.444,0,1.961,2.738,0,7.3c1.961,4.564,5.444,7.3,9.252,7.3Z",
            transform: "translate(0.75 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 4)"
        }, (0, $acw62.createElement)("path", {
            id: "Stroke_1",
            "data-name": "Stroke 1",
            d: "M6.324,3.162A3.162,3.162,0,1,1,3.162,0,3.162,3.162,0,0,1,6.324,3.162Z",
            transform: "translate(6.84 4.89)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            id: "Stroke_3",
            "data-name": "Stroke 3",
            d: "M0,7.3c0,3.28,4.142,7.3,9.252,7.3S18.5,10.585,18.5,7.3,14.361,0,9.252,0,0,4.022,0,7.3Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$En.displayName = "IconlyShow", $63c37e44f569564f$var$En.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$f6a3d19be20f5819 = $63c37e44f569564f$var$st($63c37e44f569564f$var$En), $63c37e44f569564f$var$$n = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.784,16.783a.738.738,0,0,1-.088-.925l.029-.04L16.156,1.257A.247.247,0,0,0,16.2,1.2a.327.327,0,0,0,.049-.059l.917-.925A.743.743,0,0,1,17.691,0a.723.723,0,0,1,.514.214.722.722,0,0,1,.219.522.722.722,0,0,1-.219.521L16.43,3.049a14.776,14.776,0,0,1,3.513,5.159.765.765,0,0,1,0,.581C17.851,13.7,14.135,16.626,10,16.626h-.01a9.091,9.091,0,0,1-5.279-1.752l-1.893,1.91A.728.728,0,0,1,2.3,17,.7.7,0,0,1,1.784,16.783ZM7.8,11.752A3.892,3.892,0,0,0,13.892,8.5a3.989,3.989,0,0,0-.673-2.216L12.155,7.362A2.481,2.481,0,0,1,12.429,8.5,2.444,2.444,0,0,1,10,10.955a2.409,2.409,0,0,1-1.132-.275ZM.059,8.793a.747.747,0,0,1,0-.58C2.147,3.309,5.864.385,9.992.385H10a8.851,8.851,0,0,1,4,.965L10.743,4.639A4.506,4.506,0,0,0,10,4.569,3.92,3.92,0,0,0,6.1,8.508a4.566,4.566,0,0,0,.068.748L2.556,12.9A15.833,15.833,0,0,1,.059,8.793Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.99,16.244a9.053,9.053,0,0,1-5.278-1.752L7.8,11.372a3.892,3.892,0,0,0,6.088-3.249,4.007,4.007,0,0,0-.673-2.216l3.21-3.239a14.862,14.862,0,0,1,3.512,5.159.749.749,0,0,1,0,.581c-2.088,4.9-5.805,7.836-9.941,7.836ZM.059,8.408a.749.749,0,0,1,0-.581C2.147,2.924,5.864,0,9.99,0H10a8.862,8.862,0,0,1,4,.964l-3.259,3.29A4.487,4.487,0,0,0,10,4.184,3.919,3.919,0,0,0,6.1,8.123a4.676,4.676,0,0,0,.068.748l-3.61,3.642A15.827,15.827,0,0,1,.059,8.408Z",
            transform: "translate(0 0.382)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.212,16.784a.737.737,0,0,1-.088-.926l.029-.04L10.622,5.256l3.092-3.121.869-.877a.236.236,0,0,0,.049-.058.235.235,0,0,0,.049-.059L15.6.214a.734.734,0,0,1,1.034,1.043L14.856,3.049l-3.21,3.239-10.4,10.5A.725.725,0,0,1,.729,17,.706.706,0,0,1,.212,16.784Zm7.083-6.1,3.288-3.317a2.467,2.467,0,0,1-2.156,3.594A2.4,2.4,0,0,1,7.3,10.679Z",
            transform: "translate(1.574)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M.925,5.395A3.123,3.123,0,0,1,0,3.166,3.16,3.16,0,0,1,5.394.925",
            transform: "translate(6.836 5.472)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M2.537,0A3.158,3.158,0,0,1,0,2.542",
            transform: "translate(10.568 9.199)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.9,12.638A13.43,13.43,0,0,1,0,7.3,13.592,13.592,0,0,1,3.934,1.938,8.534,8.534,0,0,1,9.25,0a8.554,8.554,0,0,1,5.336,1.957",
            transform: "translate(0.75 1.334)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M9.98,0a15.359,15.359,0,0,1,1.8,3.146c-1.967,4.557-5.443,7.3-9.25,7.3A7.981,7.981,0,0,1,0,10.035",
            transform: "translate(7.468 5.491)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M15.774,0,0,15.774",
            transform: "translate(2.113 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.58,16.789a.712.712,0,0,1,0-1.018l5.2-5.116A3.749,3.749,0,0,1,6.1,8.5,3.876,3.876,0,0,1,10,4.659a3.919,3.919,0,0,1,2.191.666l2.034-2a7.712,7.712,0,0,0-9.1.45A12.62,12.62,0,0,0,1.532,8.5a14.426,14.426,0,0,0,1.4,2.43.711.711,0,0,1-.172,1,.738.738,0,0,1-1.021-.169A15.956,15.956,0,0,1,.059,8.784a.707.707,0,0,1,0-.569A14.218,14.218,0,0,1,4.221,2.642a9.23,9.23,0,0,1,11.056-.355L17.385.212a.739.739,0,0,1,1.035,0,.711.711,0,0,1,0,1.019L2.615,16.789a.739.739,0,0,1-1.035,0ZM7.561,8.5a2.324,2.324,0,0,0,.286,1.1L11.12,6.38A2.458,2.458,0,0,0,10,6.1,2.423,2.423,0,0,0,7.561,8.5Zm-.33,7.479a.719.719,0,0,1-.462-.912.736.736,0,0,1,.925-.456A7.369,7.369,0,0,0,10,14.983c3.445,0,6.592-2.417,8.468-6.483a14.169,14.169,0,0,0-1.59-2.67.712.712,0,0,1,.145-1.009.739.739,0,0,1,1.024.142A15.9,15.9,0,0,1,19.94,8.214a.715.715,0,0,1,0,.571c-2.1,4.783-5.813,7.639-9.941,7.639A8.867,8.867,0,0,1,7.231,15.98Zm2.618-4.289a.723.723,0,0,1,.59-.839A2.412,2.412,0,0,0,12.39,8.928a.733.733,0,0,1,.85-.582.72.72,0,0,1,.59.837,3.871,3.871,0,0,1-3.13,3.088.82.82,0,0,1-.132.011A.728.728,0,0,1,9.849,11.691Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M.925,5.395A3.123,3.123,0,0,1,0,3.166,3.16,3.16,0,0,1,5.394.925",
            transform: "translate(6.836 5.472)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M2.537,0A3.158,3.158,0,0,1,0,2.542",
            transform: "translate(10.568 9.199)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M3.9,12.638A13.43,13.43,0,0,1,0,7.3,13.592,13.592,0,0,1,3.934,1.938,8.534,8.534,0,0,1,9.25,0a8.554,8.554,0,0,1,5.336,1.957",
            transform: "translate(0.75 1.334)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M9.98,0a15.359,15.359,0,0,1,1.8,3.146c-1.967,4.557-5.443,7.3-9.25,7.3A7.981,7.981,0,0,1,0,10.035",
            transform: "translate(7.468 5.491)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M15.774,0,0,15.774",
            transform: "translate(2.113 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M3.67,12.89C1.44,11.43,0,9.23,0,7.3,0,4.02,4.14,0,9.25,0a10.118,10.118,0,0,1,5.59,1.71",
            transform: "translate(0.75 1.34)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M10.48,0a5.9,5.9,0,0,1,1.41,3.53c0,3.28-4.15,7.3-9.26,7.3A9.888,9.888,0,0,1,0,10.47",
            transform: "translate(7.37 5.11)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.925,5.4A3.12,3.12,0,0,1,0,3.166,3.16,3.16,0,0,1,5.394.925",
            transform: "translate(6.841 5.472)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M2.537,0A3.158,3.158,0,0,1,0,2.542",
            transform: "translate(10.573 9.199)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M15.774,0,0,15.774",
            transform: "translate(2.118 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$$n.displayName = "IconlyHide", $63c37e44f569564f$var$$n.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$bed28288a051538 = $63c37e44f569564f$var$st($63c37e44f569564f$var$$n), $63c37e44f569564f$var$Un = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.122,14.4a3.439,3.439,0,1,1,3.439,3.379A3.41,3.41,0,0,1,13.122,14.4ZM1.508,15.921a1.482,1.482,0,1,1,0-2.963H8.083a1.482,1.482,0,1,1,0,2.963ZM0,3.379A3.409,3.409,0,0,1,3.439,0,3.409,3.409,0,0,1,6.878,3.379,3.409,3.409,0,0,1,3.439,6.758,3.41,3.41,0,0,1,0,3.379ZM11.918,4.86a1.481,1.481,0,1,1,0-2.962h6.575a1.481,1.481,0,1,1,0,2.962Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.083,0H1.508A1.5,1.5,0,0,0,0,1.481,1.5,1.5,0,0,0,1.508,2.963H8.083A1.5,1.5,0,0,0,9.591,1.481,1.5,1.5,0,0,0,8.083,0",
            transform: "translate(0 12.958)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M9.59,1.48A1.5,1.5,0,0,0,8.083,0H1.508A1.5,1.5,0,0,0,0,1.48,1.5,1.5,0,0,0,1.508,2.962H8.083A1.5,1.5,0,0,0,9.59,1.48",
            transform: "translate(10.41 1.898)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M6.878,3.379a3.409,3.409,0,0,1-3.439,3.38A3.41,3.41,0,0,1,0,3.379,3.41,3.41,0,0,1,3.439,0,3.409,3.409,0,0,1,6.878,3.379",
            transform: "translate(0 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M6.878,3.38A3.409,3.409,0,0,1,3.439,6.758,3.41,3.41,0,0,1,0,3.38,3.41,3.41,0,0,1,3.439,0,3.409,3.409,0,0,1,6.878,3.38",
            transform: "translate(13.122 11.02)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.234.588H0",
            transform: "translate(0.883 14.898)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M5.76,2.88A2.88,2.88,0,1,1,2.88,0,2.88,2.88,0,0,1,5.76,2.88Z",
            transform: "translate(13.358 12.607)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.588H7.235",
            transform: "translate(11.883 3.174)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.88A2.88,2.88,0,1,0,2.88,0,2.879,2.879,0,0,0,0,2.88Z",
            transform: "translate(0.883 0.882)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.476,15.286a3.741,3.741,0,0,1,3.762-3.713,3.817,3.817,0,0,1,.84.093.87.87,0,0,1,.666,1.041.884.884,0,0,1-1.057.656,2.025,2.025,0,0,0-2.447,1.923,2,2,0,0,0,4,0,1.955,1.955,0,0,0-.027-.328.873.873,0,0,1,.725-1,.882.882,0,0,1,1.015.716,3.648,3.648,0,0,1,.051.615,3.762,3.762,0,0,1-7.524,0Zm-11.594.87a.871.871,0,1,1,0-1.742H8.117a.871.871,0,1,1,0,1.742ZM0,3.713A3.637,3.637,0,0,1,.052,3.1a.881.881,0,0,1,1.015-.716.873.873,0,0,1,.725,1,2.063,2.063,0,0,0-.027.328A2,2,0,1,0,3.318,1.791a.88.88,0,0,1-1.06-.651A.869.869,0,0,1,2.918.1,3.765,3.765,0,0,1,7.525,3.713,3.742,3.742,0,0,1,3.763,7.428,3.743,3.743,0,0,1,0,3.713Zm11.884.871a.871.871,0,1,1,0-1.742h7.234a.871.871,0,1,1,0,1.742Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.234.588H0",
            transform: "translate(0.883 14.898)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M5.76,2.88A2.88,2.88,0,1,1,2.88,0,2.88,2.88,0,0,1,5.76,2.88Z",
            transform: "translate(13.358 12.607)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.588H7.235",
            transform: "translate(11.883 3.174)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.88A2.88,2.88,0,1,0,2.88,0,2.879,2.879,0,0,0,0,2.88Z",
            transform: "translate(0.883 0.882)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.473.447H0",
            transform: "translate(0.671 13.435)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.722C0,4.764.681,5.444,2.722,5.444s2.722-.68,2.722-2.722S4.763,0,2.722,0,0,.68,0,2.722Z",
            transform: "translate(11.205 11.162)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,.447H6.472",
            transform: "translate(10.177 2.947)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M5.444,2.722C5.444.681,4.764,0,2.723,0S0,.681,0,2.722.681,5.444,2.723,5.444,5.444,4.764,5.444,2.722Z",
            transform: "translate(0.671 0.671)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Un.displayName = "IconlyFilter", $63c37e44f569564f$var$Un.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$ec91da630f36d5ea = $63c37e44f569564f$var$st($63c37e44f569564f$var$Un), $63c37e44f569564f$var$_n = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.085,19.874a.8.8,0,0,1-.356-.67V14.389a.558.558,0,0,1,.551-.565l4.855.015a.558.558,0,0,1,.548.565v2.731a.8.8,0,0,1-.454.724L7.823,19.929A.765.765,0,0,1,7.5,20,.754.754,0,0,1,7.085,19.874Zm5.35-7.83-5.447-.016a.591.591,0,0,1-.437-.2L.574,5.258A2.234,2.234,0,0,1,0,3.758V2.193A2.161,2.161,0,0,1,2.128,0H17.872A2.16,2.16,0,0,1,20,2.192V3.724a2.225,2.225,0,0,1-.637,1.563l-6.505,6.58a.582.582,0,0,1-.416.176Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M11.571,10.594,17.427,4.72A1.981,1.981,0,0,0,18,3.324V1.6C18,.52,17.142,0,16.084,0H1.916C.858,0,0,.52,0,1.6V3.355A1.983,1.983,0,0,0,.518,4.694L5.9,10.563a.537.537,0,0,0,.393.175l4.9.014a.528.528,0,0,0,.38-.158",
            transform: "translate(0 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M0,0V6.6a.715.715,0,0,0,.319.6.681.681,0,0,0,.375.113.7.7,0,0,0,.289-.063L4.95,5.4a.71.71,0,0,0,.407-.646V0Z",
            transform: "translate(6.056 10.686)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.564,18l4.3-2.023v-5.3L17.6,3.838a1.385,1.385,0,0,0,.4-.976v-1.5A1.345,1.345,0,0,0,16.677,0H1.323A1.345,1.345,0,0,0,0,1.366V2.9a1.389,1.389,0,0,0,.357.934l6.207,6.843Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.2,17.587a.727.727,0,0,1,.338-.952l3.486-1.67V10.542a.726.726,0,0,1,.209-.51l6.22-6.294a.547.547,0,0,0,.158-.385V1.974a.535.535,0,0,0-.527-.541H8.074A.707.707,0,0,1,7.379.715.707.707,0,0,1,8.074,0h8.009A1.949,1.949,0,0,1,18,1.974V3.353a2.012,2.012,0,0,1-.575,1.408l-6.011,6.08v4.58a.716.716,0,0,1-.4.648L7.124,17.933A.68.68,0,0,1,6.831,18,.7.7,0,0,1,6.2,17.587Zm-.143-3.346v-3.3L.517,4.784A2.034,2.034,0,0,1,0,3.419V2A1.959,1.959,0,0,1,1.916,0H4.7a.711.711,0,0,1,.695.725.71.71,0,0,1-.695.724H1.916A.538.538,0,0,0,1.39,2V3.419a.564.564,0,0,0,.142.374l5.727,6.368a.737.737,0,0,1,.188.494v3.586a.7.7,0,1,1-1.39,0Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M9,18c-2.011,0-2.02-2.006-2.02-5.4S0,6.827,0,3.1C0-.047,2.79,0,9,0s9-.047,9,3.1c0,3.726-6.983,6.1-6.983,9.5S11.014,18,9,18Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "curved":
            return (0, $acw62.createElement)(d, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$_n.displayName = "IconlyFilter2", $63c37e44f569564f$var$_n.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$7943ff505e308b76 = $63c37e44f569564f$var$st($63c37e44f569564f$var$_n), $63c37e44f569564f$var$zn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.332,20H5.666C2.277,20,0,17.622,0,14.083V5.917C0,2.378,2.277,0,5.666,0h8.667C17.723,0,20,2.378,20,5.917v8.167C20,17.622,17.722,20,14.332,20ZM6.307,13.241c-.5,0-1.018.383-1.724,1.279l-.038.048c-.45.569-.912,1.155-1.371,1.726a.8.8,0,0,0-.162.633.716.716,0,0,0,.328.5A4.112,4.112,0,0,0,5.529,18h8.428a4.524,4.524,0,0,0,1.407-.214,3.717,3.717,0,0,0,2.261-2.111,3.756,3.756,0,0,0,.2-2.741,2.263,2.263,0,0,0-.513-.784l0,0a10.811,10.811,0,0,0-1.868-1.6,1.429,1.429,0,0,0-.76-.235,1.874,1.874,0,0,0-1.363.806c-.177.238-.33.491-.492.759l-.1.171-.007.012a5.683,5.683,0,0,1-1.96,2.218,2.487,2.487,0,0,1-1.208.335,3.516,3.516,0,0,1-1.959-.785,5.491,5.491,0,0,0-.827-.49A1.12,1.12,0,0,0,6.307,13.241ZM6.5,4A2.5,2.5,0,1,0,9,6.5,2.5,2.5,0,0,0,6.5,4Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.333,20H5.666C2.277,20,0,17.623,0,14.084V5.917C0,2.378,2.277,0,5.666,0h8.668C17.723,0,20,2.378,20,5.917v8.168C20,17.623,17.723,20,14.333,20",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M2.515,13.567a4.184,4.184,0,0,1-2.177-.558.736.736,0,0,1-.165-1.1c.47-.57.934-1.142,1.4-1.719.892-1.1,1.492-1.424,2.161-1.143a5.581,5.581,0,0,1,.823.475,2.807,2.807,0,0,0,3.149.436A5.617,5.617,0,0,0,9.664,7.8c.194-.311.378-.621.592-.9a1.585,1.585,0,0,1,2.111-.553A10.687,10.687,0,0,1,14.229,7.9a2.181,2.181,0,0,1,.509.76,3.564,3.564,0,0,1-.2,2.656,3.635,3.635,0,0,1-2.247,2.046,4.585,4.585,0,0,1-1.4.207ZM1.1,2.486A2.485,2.485,0,1,1,3.588,4.971,2.488,2.488,0,0,1,1.1,2.486Z",
            transform: "translate(3.172 4.189)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M18.46,5.149V13.3c0,3.02-1.89,5.15-4.91,5.15H4.9c-3.02,0-4.9-2.13-4.9-5.15V5.149C0,2.129,1.89,0,4.9,0h8.65C16.57,0,18.46,2.129,18.46,5.149Z",
            transform: "translate(0.75 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.14,1.529,2.527a1.4,1.4,0,0,1,2.032-.008l.885.9a1.433,1.433,0,0,0,2.131-.094L8.806.617a1.687,1.687,0,0,1,2.515-.1L13.4,2.655",
            transform: "translate(3.281 10.292)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.507,1.754A1.754,1.754,0,1,1,1.753,0,1.755,1.755,0,0,1,3.507,1.754Z",
            transform: "translate(4.806 5.38)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.98,19.949a.75.75,0,0,1,0-1.5H14.3c2.527,0,4.16-1.727,4.16-4.4V5.9c0-2.673-1.633-4.4-4.16-4.4H5.65C3.129,1.5,1.5,3.226,1.5,5.9V14.05c0,2.672,1.629,4.4,4.15,4.4h.721a.75.75,0,0,1,0,1.5H5.65c-3.38,0-5.65-2.372-5.65-5.9V5.9C0,2.371,2.271,0,5.65,0H14.3c3.386,0,5.66,2.371,5.66,5.9V14.05c0,3.528-2.274,5.9-5.66,5.9ZM2.766,14.978a.751.751,0,0,1-.028-1.061L4.267,12.3a2.126,2.126,0,0,1,1.554-.672,2.345,2.345,0,0,1,1.561.661l.881.9a.65.65,0,0,0,.517.2.677.677,0,0,0,.5-.248l2.228-2.713a2.444,2.444,0,0,1,1.783-.887,2.471,2.471,0,0,1,1.849.739l2.077,2.141a.75.75,0,0,1-1.077,1.045l-2.077-2.141a.893.893,0,0,0-.711-.285.929.929,0,0,0-.685.342L10.438,14.1a2.185,2.185,0,0,1-1.59.795,2.244,2.244,0,0,1-1.655-.652l-.886-.9a.52.52,0,0,0-.479-.206.647.647,0,0,0-.472.2l-1.53,1.615a.752.752,0,0,1-1.06.03ZM4.056,7.133a2.5,2.5,0,1,1,2.5,2.5A2.507,2.507,0,0,1,4.056,7.133Zm1.5,0a1,1,0,1,0,1-1A1.005,1.005,0,0,0,5.557,7.133Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M18.46,5.149V13.3c0,3.02-1.89,5.15-4.91,5.15H4.9c-3.02,0-4.9-2.13-4.9-5.15V5.149C0,2.129,1.89,0,4.9,0h8.65C16.57,0,18.46,2.129,18.46,5.149Z",
            transform: "translate(0.75 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,4.14,1.529,2.527a1.4,1.4,0,0,1,2.032-.008l.885.9a1.433,1.433,0,0,0,2.131-.094L8.806.617a1.687,1.687,0,0,1,2.515-.1L13.4,2.655",
            transform: "translate(3.281 10.292)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M3.507,1.754A1.754,1.754,0,1,1,1.753,0,1.755,1.755,0,0,1,3.507,1.754Z",
            transform: "translate(4.806 5.38)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,3.71S.812,2.073,1.994,2.073,3.78,3.448,5.09,3.448,7.868,0,9.352,0,11.9,2.391,11.9,2.391",
            transform: "translate(4.071 10.749)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.115,1.558A1.558,1.558,0,1,1,1.557,0,1.558,1.558,0,0,1,3.115,1.558Z",
            transform: "translate(5.024 5.547)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$zn.displayName = "IconlyImage", $63c37e44f569564f$var$zn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$3e431a229df88919 = $63c37e44f569564f$var$st($63c37e44f569564f$var$zn), $63c37e44f569564f$var$Gn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(1.999 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.638,20a6.641,6.641,0,0,1-1.082-.094L4.524,19.9a5.232,5.232,0,0,1-3.268-1.872c-.005,0-.007,0-.011-.009a.053.053,0,0,0-.007-.01A6.2,6.2,0,0,1,0,14.1V5.888C0,2.366,2.265,0,5.638,0h8.717C17.731,0,20,2.366,20,5.888V14.1a2.3,2.3,0,0,1-.019.256c-.006.058-.013.116-.016.176,0,.034,0,.068,0,.1,0,.05,0,.1-.007.153a.537.537,0,0,1-.009.055.393.393,0,0,0-.01.057,6.709,6.709,0,0,1-.155.9c-.014.059-.03.119-.045.175l-.015.054a6.059,6.059,0,0,1-.287.807c-.021.047-.043.092-.066.138-.014.026-.025.05-.037.075a5.376,5.376,0,0,1-.407.7c-.031.043-.062.084-.094.122l-.055.07a4.914,4.914,0,0,1-.513.581c-.037.035-.076.067-.115.1s-.053.042-.078.065a5.246,5.246,0,0,1-.608.461c-.047.029-.1.054-.146.078-.033.016-.066.032-.1.05a5.223,5.223,0,0,1-.687.333,1.848,1.848,0,0,1-.186.055c-.042.012-.086.023-.129.036l-.076.023a5.194,5.194,0,0,1-.657.172,3.755,3.755,0,0,1-.42.041l-.188.014c-.068,0-.135.014-.2.021a2.608,2.608,0,0,1-.32.026ZM1.4,5.888V14.1a5.328,5.328,0,0,0,.385,2.038l.358-.436c.563-.687,1.611-1.963,1.619-1.971A3.616,3.616,0,0,1,6.4,12.259a2.71,2.71,0,0,1,1.05.22,6.455,6.455,0,0,1,1.01.561l.09.058a2.329,2.329,0,0,0,1.186.537c.024,0,.049,0,.074,0a1.04,1.04,0,0,0,.41-.143,13.5,13.5,0,0,0,2.123-2.619c.057-.081.094-.134.107-.15a3.345,3.345,0,0,1,2.619-1.4,2.983,2.983,0,0,1,1.551.441c.194.116,1.535,1.052,1.981,1.431v-5.3c0-2.73-1.669-4.493-4.251-4.493H5.638C3.061,1.395,1.4,3.158,1.4,5.888ZM4.06,6.993A2.4,2.4,0,0,1,4,6.468a2.5,2.5,0,0,1,5,.046,2.495,2.495,0,0,1-4.941.479Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M19.208,3.41V4.794c0,.23-.01.461-.03.691a5.407,5.407,0,0,1-5.641,5.223H4.88A5.5,5.5,0,0,1,.952,9.244,4.592,4.592,0,0,1,0,8.012c.331-.4.7-.842,1.062-1.283C1.673,6,2.265,5.274,2.635,4.8c.551-.682,2-2.476,4.018-1.634a7.191,7.191,0,0,1,1.1.622c.812.541,1.152.7,1.723.391a4.461,4.461,0,0,0,1.473-1.714c.23-.372.461-.732.711-1.063A3.115,3.115,0,0,1,15.842.443a10.544,10.544,0,0,1,1.864,1.493c.12.12.24.232.351.342.15.15.651.652,1.152,1.133",
            transform: "translate(0.791 9.292)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M14.339,0H5.671C2.275,0,0,2.376,0,5.914v8.172A6.435,6.435,0,0,0,.792,17.3c.331-.4.7-.842,1.062-1.284.611-.731,1.2-1.454,1.573-1.924.551-.682,2-2.476,4.018-1.634a7.191,7.191,0,0,1,1.1.622c.812.541,1.152.7,1.723.39a4.446,4.446,0,0,0,1.473-1.714c.23-.371.461-.731.711-1.062a3.115,3.115,0,0,1,4.178-.962A10.544,10.544,0,0,1,18.5,11.228c.12.12.24.232.351.342.15.149.651.651,1.152,1.133V5.914C20,2.376,17.725,0,14.339,0",
            transform: "translate(0 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M5.161,2.582A2.6,2.6,0,0,1,2.58,5.163,2.6,2.6,0,0,1,0,2.582,2.6,2.6,0,0,1,2.58,0,2.6,2.6,0,0,1,5.161,2.582",
            transform: "translate(4.293 4.215)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.553,0H4.9C1.889,0,0,2.134,0,5.154V13.3c0,3.02,1.881,5.154,4.9,5.154h8.648c3.024,0,4.905-2.134,4.905-5.154V5.154C18.457,2.134,16.576,0,13.553,0Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.691,1.846A1.846,1.846,0,1,1,1.845,0,1.847,1.847,0,0,1,3.691,1.846Z",
            transform: "translate(5.012 4.939)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M17.457,2.929a22.809,22.809,0,0,0-3-2.593A2.345,2.345,0,0,0,11.3,1.1c-.765.991-1.243,2.324-2.4,2.949-1.423.771-2.259-.472-3.446-.97-1.325-.555-2.331.443-3.105,1.4S.788,6.389,0,7.339",
            transform: "translate(1.75 10.022)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.641,20C2.267,20,0,17.632,0,14.107V5.893C0,2.368,2.267,0,5.641,0h8.717C17.733,0,20,2.368,20,5.893v2.37a.7.7,0,1,1-1.4,0V5.893c0-2.733-1.666-4.5-4.245-4.5H5.641c-2.579,0-4.246,1.764-4.246,4.5v8.213c0,2.733,1.667,4.5,4.246,4.5h8.717c2.579,0,4.246-1.764,4.246-4.5V13.022c-.152-.126-.307-.261-.464-.4-1.1-.951-2.236-1.933-3.477-1.646-.867.2-1.351.916-1.911,1.743a6.164,6.164,0,0,1-1.79,1.951c-1.205.746-2.477.191-3.406-.216L7.4,14.391a2.112,2.112,0,0,0-2.683.349.7.7,0,0,1-.99-.983,3.475,3.475,0,0,1,4.23-.647l.158.069c.923.4,1.57.645,2.113.308A5.046,5.046,0,0,0,11.6,11.939a4.667,4.667,0,0,1,2.75-2.32c1.932-.45,3.47.882,4.705,1.949.234.2.462.4.684.579a.7.7,0,0,1,.262.544v1.415C20,17.632,17.732,20,14.358,20ZM4.3,6.78a2.558,2.558,0,1,1,2.558,2.56A2.561,2.561,0,0,1,4.3,6.78Zm1.395,0A1.163,1.163,0,1,0,6.854,5.618,1.163,1.163,0,0,0,5.691,6.78Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.553,0H4.9C1.889,0,0,2.134,0,5.154V13.3c0,3.02,1.881,5.154,4.9,5.154h8.648c3.024,0,4.905-2.134,4.905-5.154V5.154C18.457,2.134,16.576,0,13.553,0Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.691,1.846A1.846,1.846,0,1,1,1.845,0,1.847,1.847,0,0,1,3.691,1.846Z",
            transform: "translate(5.012 4.939)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M17.457,2.929a22.809,22.809,0,0,0-3-2.593A2.345,2.345,0,0,0,11.3,1.1c-.765.991-1.243,2.324-2.4,2.949-1.423.771-2.259-.472-3.446-.97-1.325-.555-2.331.443-3.105,1.4S.788,6.389,0,7.339",
            transform: "translate(1.75 10.022)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.522,1.761A1.761,1.761,0,1,1,1.761,0,1.76,1.76,0,0,1,3.522,1.761Z",
            transform: "translate(5.077 5.023)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M16.654,2.737C15.773,1.831,14.527,0,12.238,0S9.9,4.038,7.563,4.038s-3.278-1.371-4.8-.655S0,6.944,0,6.944",
            transform: "translate(2.466 9.93)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Gn.displayName = "IconlyImage2", $63c37e44f569564f$var$Gn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$123574b31a344e28 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Gn), $63c37e44f569564f$var$Yn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2.001)"
        }, (0, $acw62.createElement)("path", {
            d: "M16.167,12.379a2.279,2.279,0,0,0-1.674.44c-.482.281-1.4,1.024-1.923.834a11.932,11.932,0,0,1-6.313-6.16c-.193-.536.547-1.458.825-1.946a2.335,2.335,0,0,0,.436-1.685A13.7,13.7,0,0,0,5.189.615,1.912,1.912,0,0,0,4.021,0C2.52-.063.844,1.94.549,2.419-.187,3.441-.183,4.8.562,6.45c1.8,4.428,8.586,11.112,13.031,12.974A5.371,5.371,0,0,0,15.837,20a2.919,2.919,0,0,0,1.751-.549c.381-.219,2.466-1.979,2.411-3.521a1.941,1.941,0,0,0-.608-1.166,13.8,13.8,0,0,0-3.224-2.385",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M.49,2.373C.807,1.849,2.549-.056,3.793,0a1.636,1.636,0,0,1,.967.517,16.863,16.863,0,0,1,2.468,3.34C7.471,5.026,6.078,5.7,6.5,6.878a9.873,9.873,0,0,0,5.619,5.616c1.177.426,1.851-.966,3.019-.723a16.894,16.894,0,0,1,3.34,2.468,1.639,1.639,0,0,1,.517.967c.046,1.309-1.977,3.077-2.371,3.3-.93.665-2.144.654-3.624-.034C8.874,16.757,2.274,10.282.524,6-.145,4.525-.192,3.3.49,2.373Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.1,19.41c-3.265-1.355-8.2-5.75-10.982-9.783a.749.749,0,1,1,1.235-.85c2.6,3.767,7.336,8.008,10.352,9.261,1.219.567,2.128.6,2.8.117.527-.319,2.024-1.805,2-2.579a.982.982,0,0,0-.29-.443,18.073,18.073,0,0,0-2.913-2.2c-.319-.068-.651.126-1.156.445l-.257.159a.75.75,0,1,1-.774-1.284l.231-.143a3.062,3.062,0,0,1,2.3-.633,15.579,15.579,0,0,1,3.636,2.611,2.3,2.3,0,0,1,.716,1.4c.065,1.842-2.4,3.767-2.686,3.929A3.138,3.138,0,0,1,15.435,20,5.59,5.59,0,0,1,13.1,19.41ZM9.982,12.353A10.4,10.4,0,0,1,6.391,7.727a2.428,2.428,0,0,1,.365-2.192c.226-.392.351-.625.3-.876A18.964,18.964,0,0,0,4.863,1.793.909.909,0,0,0,4.382,1.5C3.667,1.482,2.2,2.9,1.87,3.448c-.515.707-.479,1.615.074,2.829A.75.75,0,0,1,.58,6.9C-.208,5.171-.193,3.73.624,2.617.927,2.109,2.839-.1,4.479,0A2.305,2.305,0,0,1,5.91.718,15.6,15.6,0,0,1,8.524,4.352a2.645,2.645,0,0,1-.467,1.929c-.265.461-.357.658-.266.907a8.884,8.884,0,0,0,3.065,3.945.75.75,0,0,1-.873,1.22Z",
            fill: r
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M.49,2.373C.807,1.849,2.549-.056,3.793,0a1.636,1.636,0,0,1,.967.517,16.863,16.863,0,0,1,2.468,3.34C7.471,5.026,6.078,5.7,6.5,6.878a9.873,9.873,0,0,0,5.619,5.616c1.177.426,1.851-.966,3.019-.723a16.894,16.894,0,0,1,3.34,2.468,1.639,1.639,0,0,1,.517.967c.046,1.309-1.977,3.077-2.371,3.3-.93.665-2.144.654-3.624-.034C8.874,16.757,2.274,10.282.524,6-.145,4.525-.192,3.3.49,2.373Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,1.469,2.179",
            transform: "translate(1.883 1.294)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,2.188,1.71",
            transform: "translate(15.364 15.567)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M5.7,13.3C-1.2,6.4-.217,3.241.511,2.223.6,2.059,2.906-1.388,5.375.634,11.5,5.679,3.745,4.966,8.889,10.111s4.432-2.611,9.476,3.514c2.022,2.469-1.425,4.772-1.588,4.864C15.76,19.217,12.6,20.2,5.7,13.3Z",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
        case "bulk":
            return (0, $acw62.createElement)(s, null);
        case "broken":
            return (0, $acw62.createElement)(l, null);
        case "two-tone":
            return (0, $acw62.createElement)(u, null);
        case "curved":
            return (0, $acw62.createElement)(d, null);
        default:
            return (0, $acw62.createElement)(i, null);
    }
};
$63c37e44f569564f$var$Yn.displayName = "IconlyImage", $63c37e44f569564f$var$Yn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$e01e40655568efad = $63c37e44f569564f$var$st($63c37e44f569564f$var$Yn), $63c37e44f569564f$var$Kn = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.12,19.446C8.83,17.655,2.275,11.231.543,6.974-.176,5.389-.182,4.082.531,3.1.815,2.639,2.433.713,3.882.774a1.863,1.863,0,0,1,1.128.59A13.212,13.212,0,0,1,7.258,4.486a2.233,2.233,0,0,1-.422,1.62c-.267.468-.982,1.354-.8,1.871a11.491,11.491,0,0,0,6.093,5.92c.506.184,1.391-.53,1.857-.8a2.211,2.211,0,0,1,1.616-.424,13.422,13.422,0,0,1,3.112,2.293,1.856,1.856,0,0,1,.585,1.121c.054,1.482-1.96,3.174-2.327,3.385a2.822,2.822,0,0,1-1.69.527A5.191,5.191,0,0,1,13.12,19.446ZM14.835,7.931h0a3.461,3.461,0,0,0-2.743-2.75.86.86,0,0,1,.327-1.689,5.175,5.175,0,0,1,4.1,4.11.865.865,0,0,1-.678,1.011.945.945,0,0,1-.166.015A.86.86,0,0,1,14.835,7.931Zm3.456-.075a6.912,6.912,0,0,0-6.126-6.138A.863.863,0,0,1,11.731.184a.818.818,0,0,1,.625-.176,8.617,8.617,0,0,1,7.638,7.656.857.857,0,0,1-.756.95.705.705,0,0,1-.1.006A.856.856,0,0,1,18.291,7.856Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.02.015A.861.861,0,0,0,.693,1.7a3.462,3.462,0,0,1,2.744,2.75h0a.859.859,0,0,0,.841.7.933.933,0,0,0,.165-.015A.865.865,0,0,0,5.12,4.125,5.174,5.174,0,0,0,1.02.015",
            transform: "translate(11.398 3.475)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.954.008A.817.817,0,0,0,.328.184.863.863,0,0,0,.762,1.718,6.912,6.912,0,0,1,6.888,7.857a.857.857,0,0,0,.851.764.8.8,0,0,0,.1-.006A.847.847,0,0,0,8.411,8.3a.856.856,0,0,0,.181-.633A8.616,8.616,0,0,0,.954.008",
            transform: "translate(11.402 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M15.6,11.9a2.211,2.211,0,0,0-1.615.424c-.465.27-1.35.984-1.856.8A11.493,11.493,0,0,1,6.04,7.2c-.186-.517.528-1.4.8-1.871a2.235,2.235,0,0,0,.422-1.62A13.176,13.176,0,0,0,5.009.592,1.858,1.858,0,0,0,3.882,0C2.433-.06.815,1.866.531,2.327-.181,3.309-.176,4.616.543,6.2,2.276,10.458,8.83,16.883,13.12,18.674a5.2,5.2,0,0,0,2.166.554,2.825,2.825,0,0,0,1.69-.528c.366-.211,2.38-1.9,2.326-3.385a1.856,1.856,0,0,0-.586-1.121A13.372,13.372,0,0,0,15.6,11.9",
            transform: "translate(0 0.773)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.49,2.374C.806,1.849,2.55-.056,3.793,0A1.642,1.642,0,0,1,4.76.518h0a16.884,16.884,0,0,1,2.467,3.34C7.472,5.026,6.078,5.7,6.5,6.878a9.873,9.873,0,0,0,5.619,5.616c1.177.427,1.851-.965,3.019-.723a16.864,16.864,0,0,1,3.34,2.468h0a1.639,1.639,0,0,1,.517.967c.046,1.309-1.977,3.077-2.371,3.3-.93.666-2.144.654-3.624-.034C8.874,16.757,2.274,10.282.524,6-.146,4.525-.191,3.3.49,2.374Z",
            transform: "translate(0.5 0.5)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A7.971,7.971,0,0,1,7.041,7.032",
            transform: "translate(12.565 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A4.426,4.426,0,0,1,3.5,3.5",
            transform: "translate(12.565 4.293)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.86,19.418C9.653,18.076,4.8,13.727,2.076,9.736A.745.745,0,0,1,2.264,8.7.734.734,0,0,1,3.289,8.9c2.547,3.726,7.2,7.923,10.165,9.164,1.2.56,2.092.595,2.755.116.517-.317,1.987-1.787,1.961-2.552a.988.988,0,0,0-.285-.439,17.661,17.661,0,0,0-2.859-2.18c-.317-.065-.639.123-1.135.437l-.255.16a.735.735,0,0,1-1.011-.254.745.745,0,0,1,.251-1.019l.23-.143a2.988,2.988,0,0,1,2.262-.623,15.22,15.22,0,0,1,3.569,2.584,2.277,2.277,0,0,1,.7,1.389c.064,1.821-2.36,3.725-2.637,3.885A3.067,3.067,0,0,1,15.157,20,5.486,5.486,0,0,1,12.86,19.418ZM9.8,12.434A10.29,10.29,0,0,1,6.275,7.857a2.418,2.418,0,0,1,.36-2.17c.221-.388.345-.619.293-.867A18.756,18.756,0,0,0,4.774,1.985.886.886,0,0,0,4.3,1.694c-.662-.031-2.14,1.384-2.467,1.928-.506.7-.47,1.6.073,2.8a.744.744,0,0,1-.365.983.734.734,0,0,1-.975-.368C-.2,5.328-.19,3.9.612,2.8.78,2.514,2.65.1,4.4.214A2.257,2.257,0,0,1,5.8.923a15.353,15.353,0,0,1,2.566,3.6,2.631,2.631,0,0,1-.459,1.909c-.26.455-.35.651-.261.9a8.793,8.793,0,0,0,3.008,3.9.745.745,0,0,1,.171,1.035.733.733,0,0,1-1.027.173Zm5.26-4.586a3.607,3.607,0,0,0-2.854-2.873.742.742,0,0,1,.282-1.456,5.081,5.081,0,0,1,4.019,4.046.742.742,0,0,1-.582.87.759.759,0,0,1-.142.013A.737.737,0,0,1,15.062,7.848Zm3.47-.067a7.08,7.08,0,0,0-6.264-6.3.741.741,0,0,1-.652-.819.733.733,0,0,1,.814-.654A8.545,8.545,0,0,1,20,7.614a.739.739,0,0,1-.649.82.675.675,0,0,1-.084.005A.739.739,0,0,1,18.532,7.781Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.49,2.374C.806,1.849,2.55-.056,3.793,0A1.642,1.642,0,0,1,4.76.518h0a16.884,16.884,0,0,1,2.467,3.34C7.472,5.026,6.078,5.7,6.5,6.878a9.873,9.873,0,0,0,5.619,5.616c1.177.427,1.851-.965,3.019-.723a16.864,16.864,0,0,1,3.34,2.468h0a1.639,1.639,0,0,1,.517.967c.046,1.309-1.977,3.077-2.371,3.3-.93.666-2.144.654-3.624-.034C8.874,16.757,2.274,10.282.524,6-.146,4.525-.191,3.3.49,2.374Z",
            transform: "translate(0.5 0.5)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A7.971,7.971,0,0,1,7.041,7.032",
            transform: "translate(12.565 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A4.426,4.426,0,0,1,3.5,3.5",
            transform: "translate(12.565 4.293)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0A7.971,7.971,0,0,1,7.041,7.032",
            transform: "translate(12.352 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0A4.426,4.426,0,0,1,3.5,3.5",
            transform: "translate(12.352 4.293)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M5.7,13.3C-1.2,6.4-.217,3.241.511,2.223.6,2.059,2.906-1.388,5.375.634,11.5,5.679,3.745,4.966,8.889,10.111S13.32,7.5,18.366,13.625c2.022,2.469-1.425,4.772-1.588,4.864C15.76,19.217,12.6,20.2,5.7,13.3Z",
            transform: "translate(0 1)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Kn.displayName = "IconlyCalling", $63c37e44f569564f$var$Kn.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$5deb64e34838263 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Kn), $63c37e44f569564f$var$te = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.3,19.439C8.949,17.623,2.306,11.109.549,6.791-.178,5.185-.184,3.86.537,2.864.825,2.4,2.466.445,3.934.506a1.884,1.884,0,0,1,1.143.6A13.314,13.314,0,0,1,7.356,4.27a2.269,2.269,0,0,1-.427,1.643c-.273.474-1,1.372-.807,1.9a11.651,11.651,0,0,0,6.176,6c.514.186,1.41-.538,1.881-.812a2.241,2.241,0,0,1,1.638-.429A13.523,13.523,0,0,1,18.971,14.9a1.878,1.878,0,0,1,.594,1.138c.054,1.5-1.986,3.218-2.359,3.432A2.861,2.861,0,0,1,15.494,20,5.276,5.276,0,0,1,13.3,19.439ZM18.492,7.584l-2.4-2.413-2.4,2.413a.9.9,0,0,1-1.248,0,.89.89,0,0,1,0-1.254l2.4-2.413L12.435,1.5a.89.89,0,0,1,0-1.254.9.9,0,0,1,1.248,0l2.4,2.413,2.4-2.413a.9.9,0,0,1,1.248,0,.888.888,0,0,1,0,1.254l-2.4,2.413,2.4,2.413a.888.888,0,0,1,0,1.254.879.879,0,0,1-1.248,0Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M15.816,12.066a2.241,2.241,0,0,0-1.637.43c-.471.274-1.368,1-1.882.812a11.652,11.652,0,0,1-6.176-6c-.189-.524.535-1.423.808-1.9a2.271,2.271,0,0,0,.427-1.642A13.359,13.359,0,0,0,5.077.6,1.881,1.881,0,0,0,3.934,0C2.466-.06.825,1.892.537,2.359c-.721,1-.716,2.321.012,3.927C2.306,10.6,8.949,17.118,13.3,18.934a5.271,5.271,0,0,0,2.2.561,2.863,2.863,0,0,0,1.713-.535c.372-.214,2.413-1.929,2.359-3.432a1.884,1.884,0,0,0-.595-1.137,13.534,13.534,0,0,0-3.155-2.325",
            transform: "translate(0 0.505)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M5.16,3.918l2.4-2.413a.888.888,0,0,0,0-1.254.9.9,0,0,0-1.249,0l-2.4,2.414L1.507.251a.9.9,0,0,0-1.249,0,.89.89,0,0,0,0,1.254l2.4,2.413L.258,6.33a.89.89,0,0,0,0,1.254.9.9,0,0,0,1.249,0l2.4-2.414,2.4,2.414A.885.885,0,0,0,7.564,6.33Z",
            transform: "translate(12.177 0)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.49,2.374C.807,1.849,2.549-.056,3.793,0a1.642,1.642,0,0,1,.967.517,16.893,16.893,0,0,1,2.468,3.34C7.471,5.026,6.078,5.7,6.5,6.878a9.872,9.872,0,0,0,5.619,5.616c1.177.427,1.851-.965,3.019-.723a16.894,16.894,0,0,1,3.34,2.468,1.639,1.639,0,0,1,.517.967c.046,1.309-1.977,3.077-2.371,3.3-.93.666-2.144.654-3.624-.034C8.874,16.757,2.274,10.282.524,6-.145,4.525-.192,3.3.49,2.374Z",
            transform: "translate(0.5 0.5)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M6,0,0,6",
            transform: "translate(13.25 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,6,6",
            transform: "translate(13.25 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.1,19.412c-3.266-1.357-8.2-5.751-10.981-9.785A.749.749,0,1,1,3.349,8.78c2.594,3.765,7.334,8.006,10.35,9.26,1.22.566,2.128.6,2.8.117.526-.319,2.024-1.806,2-2.579a.992.992,0,0,0-.291-.444,18.045,18.045,0,0,0-2.912-2.2c-.316-.066-.65.126-1.156.443l-.258.161a.75.75,0,0,1-.773-1.286l.233-.143a3.066,3.066,0,0,1,2.3-.631,15.6,15.6,0,0,1,3.636,2.611,2.291,2.291,0,0,1,.715,1.4c.065,1.84-2.4,3.766-2.685,3.927A3.139,3.139,0,0,1,15.433,20,5.613,5.613,0,0,1,13.1,19.412ZM9.981,12.353A10.4,10.4,0,0,1,6.39,7.727a2.427,2.427,0,0,1,.366-2.193c.226-.391.351-.625.3-.876A19.039,19.039,0,0,0,4.862,1.792a.914.914,0,0,0-.48-.293C3.666,1.453,2.2,2.9,1.87,3.449c-.515.707-.479,1.614.074,2.829A.749.749,0,0,1,.58,6.9C-.208,5.171-.193,3.73.624,2.618.927,2.109,2.838-.106,4.479,0A2.315,2.315,0,0,1,5.91.718,15.543,15.543,0,0,1,8.523,4.353a2.647,2.647,0,0,1-.467,1.929c-.266.461-.357.658-.266.906a8.889,8.889,0,0,0,3.063,3.945.75.75,0,0,1-.871,1.22Zm8.738-5.076L16.25,4.81,13.781,7.277A.75.75,0,0,1,12.72,6.218l2.47-2.47L12.72,1.28A.75.75,0,0,1,13.781.221L16.25,2.688,18.2.736h0l.515-.515A.75.75,0,0,1,19.78,1.28L18.747,2.313h0L17.311,3.749l2.47,2.47a.75.75,0,0,1-1.061,1.059Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.49,2.374C.807,1.849,2.549-.056,3.793,0a1.642,1.642,0,0,1,.967.517,16.893,16.893,0,0,1,2.468,3.34C7.471,5.026,6.078,5.7,6.5,6.878a9.872,9.872,0,0,0,5.619,5.616c1.177.427,1.851-.965,3.019-.723a16.894,16.894,0,0,1,3.34,2.468,1.639,1.639,0,0,1,.517.967c.046,1.309-1.977,3.077-2.371,3.3-.93.666-2.144.654-3.624-.034C8.874,16.757,2.274,10.282.524,6-.145,4.525-.192,3.3.49,2.374Z",
            transform: "translate(0.5 0.5)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3,3,0,6,3,3,0,0,3,3,6,0,3,3,6,6Z",
            transform: "translate(13.25 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6,0,0,6",
            transform: "translate(13.328 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,6,6",
            transform: "translate(13.328 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M5.7,13.3C-1.2,6.4-.217,3.241.511,2.222.6,2.059,2.906-1.388,5.375.634,11.5,5.679,3.745,4.966,8.89,10.111s4.431-2.611,9.476,3.514c2.022,2.469-1.425,4.77-1.588,4.864C15.759,19.217,12.6,20.2,5.7,13.3Z",
            transform: "translate(0 1)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$te.displayName = "IconlyCallMissed", $63c37e44f569564f$var$te.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$bf38b58a1a7fd769 = $63c37e44f569564f$var$st($63c37e44f569564f$var$te), $63c37e44f569564f$var$ne = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 1.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M.245,20.746a.9.9,0,0,1-.129-1.058l.03-.041a.518.518,0,0,1,.069-.091L18.176,1.13A.814.814,0,0,1,18.77.864a.853.853,0,0,1,.6.266.892.892,0,0,1,0,1.229V2.37L9.958,12.015l-.572.587.8-.82a11.186,11.186,0,0,0,2.626,1.566c.506.192,1.378-.54,1.844-.814a2.163,2.163,0,0,1,1.606-.427,13.159,13.159,0,0,1,3.1,2.327,1.978,1.978,0,0,1,.585,1.139C20,17.087,18,18.8,17.63,19.018a2.792,2.792,0,0,1-1.686.539A5.046,5.046,0,0,1,13.794,19,24.043,24.043,0,0,1,7.52,14.516l-6.075,6.23A.857.857,0,0,1,.85,21,.9.9,0,0,1,.245,20.746ZM1.275,6.3C.562,4.7.552,3.366,1.265,2.37,1.543,1.9,3.158-.059,4.6,0a1.78,1.78,0,0,1,1.12.6,13.472,13.472,0,0,1,2.24,3.171,2.315,2.315,0,0,1-.417,1.657c-.267.468-.981,1.372-.793,1.9A10.335,10.335,0,0,0,7.827,9.3L5.141,12.056A21.819,21.819,0,0,1,1.275,6.3Z",
            transform: "translate(0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 1.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.092,9.3,4.406,12.056A21.819,21.819,0,0,1,.54,6.3C-.173,4.7-.183,3.366.53,2.37.808,1.9,2.423-.06,3.861,0a1.785,1.785,0,0,1,1.12.6,13.487,13.487,0,0,1,2.24,3.171A2.318,2.318,0,0,1,6.8,5.429c-.268.468-.981,1.372-.793,1.9A10.336,10.336,0,0,0,7.092,9.3",
            transform: "translate(0.735)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M12.429,3.79c.05,1.514-1.953,3.232-2.319,3.446a2.787,2.787,0,0,1-1.685.539,5.035,5.035,0,0,1-2.151-.559A24.046,24.046,0,0,1,0,2.733L2.666,0A11.193,11.193,0,0,0,5.293,1.565c.506.192,1.378-.54,1.844-.814A2.166,2.166,0,0,1,8.742.324a13.187,13.187,0,0,1,3.1,2.328,1.975,1.975,0,0,1,.585,1.138",
            transform: "translate(7.52 11.782)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M19.375,1.5v.01L9.958,11.151,1.444,19.882a.856.856,0,0,1-.595.254.9.9,0,0,1-.6-.254.9.9,0,0,1-.129-1.057l.03-.041a.517.517,0,0,1,.069-.091L18.175.265A.816.816,0,0,1,18.77,0a.855.855,0,0,1,.6.265.893.893,0,0,1,0,1.23",
            transform: "translate(0 0.864)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M3.532,10.475A19.223,19.223,0,0,1,.515,5.841c-.66-1.439-.7-2.63-.04-3.529C.785,1.8,2.485-.058,3.7,0a1.623,1.623,0,0,1,.94.5,17.785,17.785,0,0,1,1.389,1.67,7.222,7.222,0,0,1,1.01,1.58c.24,1.14-1.12,1.8-.7,2.941.093.227.191.448.3.662",
            transform: "translate(0.754 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,18.5,18.5,0",
            transform: "translate(0.75 0.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.811a24.78,24.78,0,0,0,6.98,5.18c1.44.67,2.62.679,3.52.03.39-.221,2.36-1.94,2.31-3.221a1.612,1.612,0,0,0-.5-.939,16,16,0,0,0-3.25-2.4c-1.14-.24-1.8,1.121-2.94.7A10,10,0,0,1,2.81,0",
            transform: "translate(6.44 10.751)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M13.1,19.411a24.29,24.29,0,0,1-6.658-4.8L1.28,19.772a.75.75,0,0,1-1.06-1.06L5.91,13.025a.77.77,0,0,1,1.059,0,23.929,23.929,0,0,0,6.737,5.014c1.218.568,2.123.6,2.795.116.534-.321,2.029-1.8,2-2.581a.952.952,0,0,0-.292-.451,18.068,18.068,0,0,0-2.9-2.193c-.214-.048-.448.082-.842.309a2.417,2.417,0,0,1-2.165.372A10.814,10.814,0,0,1,8.72,11.277a.749.749,0,0,1,0-1.06l10-9.995a.75.75,0,1,1,1.06,1.06l-9.446,9.44a9.578,9.578,0,0,0,2.51,1.49c.219.079.415-.011.873-.274a2.658,2.658,0,0,1,1.938-.464c.764.148,3.174,2.136,3.633,2.609a2.319,2.319,0,0,1,.709,1.4c.075,1.858-2.406,3.773-2.69,3.931a3.1,3.1,0,0,1-1.87.586A5.586,5.586,0,0,1,13.1,19.411ZM3.711,11.7A19.838,19.838,0,0,1,.577,6.874C-.2,5.173-.191,3.73.625,2.617.8,2.326,2.685-.113,4.488,0A2.31,2.31,0,0,1,5.91.713,17.8,17.8,0,0,1,7.38,2.471c1.066,1.419,1.118,1.72,1.149,1.9a2.633,2.633,0,0,1-.47,1.908c-.265.459-.355.655-.265.9.077.19.169.393.266.592a.75.75,0,0,1-1.348.659C6.6,8.2,6.494,7.962,6.4,7.718a2.41,2.41,0,0,1,.363-2.184c.225-.392.351-.628.3-.878h0A9.494,9.494,0,0,0,6.18,3.371a17.088,17.088,0,0,0-1.311-1.58A.886.886,0,0,0,4.388,1.5c-.646-.051-2.181,1.4-2.516,1.95-.514.706-.475,1.613.081,2.827a18.356,18.356,0,0,0,2.91,4.461.75.75,0,1,1-1.151.962Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M3.629,10.757A19.74,19.74,0,0,1,.529,6C-.148,4.521-.19,3.3.488,2.375.807,1.85,2.553-.059,3.8,0a1.668,1.668,0,0,1,.966.513A18.265,18.265,0,0,1,6.189,2.23,7.416,7.416,0,0,1,7.227,3.852c.247,1.171-1.15,1.848-.719,3.02.1.233.2.46.305.68",
            transform: "translate(1 0)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,2.887A25.454,25.454,0,0,0,7.17,8.206c1.479.688,2.691.7,3.616.031.4-.227,2.424-1.992,2.373-3.308a1.655,1.655,0,0,0-.514-.964A16.432,16.432,0,0,0,9.307,1.5c-1.171-.246-1.849,1.151-3.02.72A10.27,10.27,0,0,1,2.886,0",
            transform: "translate(6.84 10.27)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,18.333,18.333,0",
            transform: "translate(0.743 0.744)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M3.609,11.058C-.977,5.7-.129,3.127.509,2.225c.1-.17,2.4-3.61,4.861-1.592,4.851,4,1,4.385,1.742,6.922",
            transform: "translate(0 1)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M3.185,0c4.927,4.746,4.3-2.728,9.278,3.312C14.49,5.786,11.04,8.079,10.87,8.175,9.874,8.9,6.762,9.863,0,3.185",
            transform: "translate(5.901 11.314)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,18.5,18.5,0",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$ne.displayName = "IconlyCallSilent", $63c37e44f569564f$var$ne.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$5e9dd714d869f41c = $63c37e44f569564f$var$st($63c37e44f569564f$var$ne), $63c37e44f569564f$var$oe = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.732,20H4.269A4.227,4.227,0,0,1,0,15.826V10.888A4.165,4.165,0,0,1,2.977,6.929V5.4A5.472,5.472,0,0,1,8.485,0,5.576,5.576,0,0,1,12.4,1.58,5.3,5.3,0,0,1,14.023,5.4V6.929A4.165,4.165,0,0,1,17,10.888v4.937A4.227,4.227,0,0,1,12.732,20ZM8.5,11.384a.875.875,0,0,0-.884.865v2.206a.889.889,0,0,0,1.778,0V12.249A.881.881,0,0,0,8.5,11.384Zm.01-9.645A3.711,3.711,0,0,0,4.756,5.376V6.714h7.489V5.4A3.7,3.7,0,0,0,8.505,1.739Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.731,13.286H4.269A4.227,4.227,0,0,1,0,9.112V4.175A4.227,4.227,0,0,1,4.269,0h8.463A4.227,4.227,0,0,1,17,4.175V9.112A4.227,4.227,0,0,1,12.731,13.286ZM8.5,4.67a.875.875,0,0,0-.884.865V7.741a.889.889,0,0,0,1.778,0V5.535A.881.881,0,0,0,8.5,4.67Z",
            transform: "translate(0 6.714)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M11.045,5.4V6.867a4.153,4.153,0,0,0-1.118-.149h-.66V5.4A3.7,3.7,0,0,0,5.528,1.739a3.707,3.707,0,0,0-3.75,3.637V6.718h-.65A3.817,3.817,0,0,0,0,6.877V5.4A5.467,5.467,0,0,1,5.507,0a5.461,5.461,0,0,1,5.538,5.4",
            transform: "translate(2.977 0)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.121,6.7V4.551A4.561,4.561,0,0,0,0,4.531V6.7",
            transform: "translate(3.802 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M11.433,11.873H3.792A3.792,3.792,0,0,1,0,8.081V3.792A3.792,3.792,0,0,1,3.792,0h7.641a3.792,3.792,0,0,1,3.792,3.792V8.081A3.792,3.792,0,0,1,11.433,11.873Z",
            transform: "translate(0.75 7.377)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V2.221",
            transform: "translate(7.863 12.203)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.353,20H8.942a.75.75,0,1,1,0-1.5h3.411a3.07,3.07,0,0,0,3.092-3.042.364.364,0,0,1,.02-.105l.011-.041V11.169a3.071,3.071,0,0,0-3.093-3.042H4.617a3.071,3.071,0,0,0-3.092,3.042v4.144c0,.016.008.032.012.048a.351.351,0,0,1,.018.1A3.071,3.071,0,0,0,4.647,18.5a.75.75,0,1,1,0,1.5H4.622a4.632,4.632,0,0,1-3.269-1.331A4.472,4.472,0,0,1,0,15.458V11.169A4.55,4.55,0,0,1,3.1,6.9V5.3A5.367,5.367,0,0,1,8.49,0h.023A5.349,5.349,0,0,1,13.9,5.3V6.9A4.55,4.55,0,0,1,17,11.169v4.289A4.586,4.586,0,0,1,12.382,20ZM4.627,5.284V6.627h7.745V5.3A3.836,3.836,0,0,0,8.51,1.5H8.493A3.843,3.843,0,0,0,4.627,5.284Zm3.11,9.139V12.2a.762.762,0,0,1,1.525,0v2.22a.762.762,0,0,1-1.525,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.121,6.7V4.551A4.561,4.561,0,0,0,0,4.531V6.7",
            transform: "translate(3.802 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M11.433,11.873H3.792A3.792,3.792,0,0,1,0,8.081V3.792A3.792,3.792,0,0,1,3.792,0h7.641a3.792,3.792,0,0,1,3.792,3.792V8.081A3.792,3.792,0,0,1,11.433,11.873Z",
            transform: "translate(0.75 7.377)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V2.221",
            transform: "translate(7.863 12.203)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.121,6.653V4.5A4.561,4.561,0,0,0,0,4.484V6.653",
            transform: "translate(3.85 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V2.221",
            transform: "translate(7.91 12.156)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.66,0C1.915,0,0,1.568,0,6.271s1.915,6.272,7.66,6.272,7.661-1.568,7.661-6.272S13.4,0,7.66,0Z",
            transform: "translate(0.75 6.824)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$oe.displayName = "IconlyLock", $63c37e44f569564f$var$oe.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$5b9db7ce80343746 = $63c37e44f569564f$var$st($63c37e44f569564f$var$oe), $63c37e44f569564f$var$se = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.731,20H4.268A4.227,4.227,0,0,1,0,15.825V10.886A4.038,4.038,0,0,1,.872,8.372,4.337,4.337,0,0,1,3.071,6.9l-.111.014V5.387A5.548,5.548,0,0,1,13.711,3.628a.838.838,0,0,1-.041.666.85.85,0,0,1-.509.438.887.887,0,0,1-.291.049.91.91,0,0,1-.847-.585A3.761,3.761,0,0,0,4.739,5.368V6.709l-.013,0h8.006A4.227,4.227,0,0,1,17,10.886v4.938A4.227,4.227,0,0,1,12.731,20ZM8.5,11.382a.875.875,0,0,0-.884.865v2.207a.889.889,0,0,0,1.778,0V12.247A.881.881,0,0,0,8.5,11.382Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.778,6.709V5.367a3.709,3.709,0,0,1,3.76-3.628A3.727,3.727,0,0,1,9.064,4.2a.906.906,0,0,0,1.138.537.861.861,0,0,0,.549-1.1A5.53,5.53,0,0,0,5.518,0,5.482,5.482,0,0,0,0,5.387V6.911Z",
            transform: "translate(2.961 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M12.731,13.289H4.269A4.227,4.227,0,0,1,0,9.113V4.175A4.227,4.227,0,0,1,4.269,0h8.463A4.227,4.227,0,0,1,17,4.175V9.113A4.227,4.227,0,0,1,12.731,13.289ZM8.5,4.672a.875.875,0,0,0-.884.864V7.743a.889.889,0,0,0,1.778,0V5.536A.88.88,0,0,0,8.5,4.672Z",
            transform: "translate(0 6.711)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.872,3.062A4.563,4.563,0,0,0,0,4.531V6.7",
            transform: "translate(3.052)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M11.433,11.874H3.792A3.793,3.793,0,0,1,0,8.081V3.793A3.793,3.793,0,0,1,3.792,0h7.641a3.793,3.793,0,0,1,3.792,3.793V8.081A3.793,3.793,0,0,1,11.433,11.874Z",
            transform: "translate(0 6.626)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V2.222",
            transform: "translate(7.113 11.453)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M12.353,20H8.942a.75.75,0,1,1,0-1.5h3.411a3.071,3.071,0,0,0,3.092-3.042.67.67,0,0,1,.03-.144V11.169a3.071,3.071,0,0,0-3.092-3.042H4.617a3.071,3.071,0,0,0-3.092,3.042v4.145a.67.67,0,0,1,.03.144A3.071,3.071,0,0,0,4.648,18.5a.75.75,0,1,1,0,1.5l-.021,0-.01,0A4.584,4.584,0,0,1,0,15.458V11.169A4.542,4.542,0,0,1,3.1,6.9V5.3A5.357,5.357,0,0,1,8.49,0h.024A5.386,5.386,0,0,1,13.6,3.567a.747.747,0,0,1-.472.955.765.765,0,0,1-.969-.464A3.861,3.861,0,0,0,8.51,1.5H8.493A3.838,3.838,0,0,0,4.627,5.284V6.627h7.756A4.585,4.585,0,0,1,17,11.169v4.289A4.584,4.584,0,0,1,12.383,20ZM7.738,14.424V12.2a.762.762,0,0,1,1.525,0v2.221a.762.762,0,0,1-1.525,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4.5 2.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.872,3.062A4.563,4.563,0,0,0,0,4.531V6.7",
            transform: "translate(3.052)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M11.433,11.874H3.792A3.793,3.793,0,0,1,0,8.081V3.793A3.793,3.793,0,0,1,3.792,0h7.641a3.793,3.793,0,0,1,3.792,3.793V8.081A3.793,3.793,0,0,1,11.433,11.874Z",
            transform: "translate(0 6.626)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V2.222",
            transform: "translate(7.113 11.453)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3.5 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.927,3.237A4.562,4.562,0,0,0,0,4.484V6.653",
            transform: "translate(3.849 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,0V2.221",
            transform: "translate(7.91 12.156)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.66,0C1.915,0,0,1.568,0,6.271s1.915,6.272,7.66,6.272,7.661-1.568,7.661-6.272S13.406,0,7.66,0Z",
            transform: "translate(0.75 6.824)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$se.displayName = "IconlyUnlock", $63c37e44f569564f$var$se.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$a818bbe058f189e = $63c37e44f569564f$var$st($63c37e44f569564f$var$se), $63c37e44f569564f$var$le = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM6.525,7.8A.737.737,0,0,0,6,8.02a.75.75,0,0,0-.225.54A.727.727,0,0,0,6,9.08l3.47,3.49a.75.75,0,0,0,1.06,0L14,9.08a.7.7,0,0,0,.22-.52A.75.75,0,0,0,14,8.02a.76.76,0,0,0-.529-.216.733.733,0,0,0-.531.226L10,10.98,7.06,8.03A.737.737,0,0,0,6.525,7.8Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M20,10A10,10,0,1,1,10,0,10.011,10.011,0,0,1,20,10",
            transform: "translate(0 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M8.443.749a.747.747,0,0,1-.219.529L4.754,4.765a.752.752,0,0,1-1.063,0L.219,1.278A.75.75,0,0,1,1.282.22l2.94,2.953L7.162.22A.75.75,0,0,1,8.443.749",
            transform: "translate(5.778 7.808)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25A9.25,9.25,0,1,0,9.25,0,9.25,9.25,0,0,0,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,3.471,3.486,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,10A9.94,9.94,0,0,1,3.9,2.073.727.727,0,0,1,4.79,3.226,8.546,8.546,0,1,0,10,1.454a8.645,8.645,0,0,0-1.3.1A.727.727,0,0,1,8.481.114,10,10,0,1,1,0,10Zm9.468,2.573L6,9.087A.75.75,0,1,1,7.06,8.028L10,10.981l2.94-2.953A.75.75,0,0,1,14,9.087L10.53,12.573a.747.747,0,0,1-1.062,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25A9.25,9.25,0,1,0,9.25,0,9.25,9.25,0,0,0,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,3.471,3.486,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0S2.392,3.486,3.472,3.486,6.942,0,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$le.displayName = "IconlyChevronDownCircle", $63c37e44f569564f$var$le.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$473697e81eb6bba8 = $63c37e44f569564f$var$st($63c37e44f569564f$var$le), $63c37e44f569564f$var$de = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            i: !0,
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,20l-.28,0A10.011,10.011,0,1,1,10,20ZM8.56,5.78a.745.745,0,0,0-.53,1.28L10.98,10,8.03,12.94A.746.746,0,0,0,8.02,14a.752.752,0,0,0,.534.225A.727.727,0,0,0,9.08,14l3.49-3.47a.75.75,0,0,0,0-1.06L9.08,6A.7.7,0,0,0,8.56,5.78Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            i: !0,
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M20,10A10,10,0,1,1,10,0,10.011,10.011,0,0,1,20,10",
            transform: "translate(0 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M8.443.749a.747.747,0,0,1-.219.529L4.754,4.765a.752.752,0,0,1-1.063,0L.219,1.278A.75.75,0,0,1,1.282.22l2.94,2.953L7.162.22A.75.75,0,0,1,8.443.749",
            transform: "translate(5.778 7.808)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            i: !0,
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25A9.25,9.25,0,1,0,9.25,0,9.25,9.25,0,0,0,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,3.471,3.486,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            i: !0,
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,10A9.94,9.94,0,0,1,3.9,2.073.727.727,0,0,1,4.79,3.226,8.546,8.546,0,1,0,10,1.454a8.645,8.645,0,0,0-1.3.1A.727.727,0,0,1,8.481.114,10,10,0,1,1,0,10Zm9.468,2.573L6,9.087A.75.75,0,1,1,7.06,8.028L10,10.981l2.94-2.953A.75.75,0,0,1,14,9.087L10.53,12.573a.747.747,0,0,1-1.062,0Z",
            transform: "translate(0 20) rotate(-90)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            i: !0,
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25A9.25,9.25,0,1,0,9.25,0,9.25,9.25,0,0,0,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,3.471,3.486,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0S2.392,3.486,3.472,3.486,6.942,0,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$de.displayName = "IconlyChevronRightCircle", $63c37e44f569564f$var$de.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$422fa8e55ed6b825 = $63c37e44f569564f$var$st($63c37e44f569564f$var$de), $63c37e44f569564f$var$ce = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,20A10,10,0,1,1,20,10l0,.28A10,10,0,0,1,10,20ZM10,9.02h0l2.94,2.949a.746.746,0,0,0,1.06.01.751.751,0,0,0,.225-.539A.729.729,0,0,0,14,10.92L10.53,7.43a.747.747,0,0,0-1.06,0L6,10.92a.7.7,0,0,0-.22.52.747.747,0,0,0,.22.54.758.758,0,0,0,.529.216.733.733,0,0,0,.531-.226L10,9.021Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 22) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M20,10A10,10,0,1,1,10,0,10.011,10.011,0,0,1,20,10",
            transform: "translate(0 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M8.443.749a.747.747,0,0,1-.219.529L4.754,4.765a.752.752,0,0,1-1.063,0L.219,1.278A.75.75,0,0,1,1.282.22l2.94,2.953L7.162.22A.75.75,0,0,1,8.443.749",
            transform: "translate(5.778 7.808)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 22) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25A9.25,9.25,0,1,0,9.25,0,9.25,9.25,0,0,0,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,3.471,3.486,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,10A9.94,9.94,0,0,1,3.9,2.073.727.727,0,0,1,4.79,3.226,8.546,8.546,0,1,0,10,1.454a8.645,8.645,0,0,0-1.3.1A.727.727,0,0,1,8.481.114,10,10,0,1,1,0,10Zm9.468,2.573L6,9.087A.75.75,0,1,1,7.06,8.028L10,10.981l2.94-2.953A.75.75,0,0,1,14,9.087L10.53,12.573a.747.747,0,0,1-1.062,0Z",
            transform: "translate(0 20) rotate(-90)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 22) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25A9.25,9.25,0,1,0,9.25,0,9.25,9.25,0,0,0,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,3.471,3.486,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 22) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0S2.392,3.486,3.472,3.486,6.942,0,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$ce.displayName = "IconlyChevronUpCircle", $63c37e44f569564f$var$ce.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$88ef9e503a31b3bc = $63c37e44f569564f$var$st($63c37e44f569564f$var$ce), $63c37e44f569564f$var$pe = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,20A10,10,0,1,1,10,0l.28,0A10,10,0,0,1,10,20ZM11.446,5.775A.728.728,0,0,0,10.92,6L7.43,9.47a.747.747,0,0,0,0,1.06L10.92,14a.7.7,0,0,0,.52.22.745.745,0,0,0,.53-1.28L9.02,10l2.95-2.94A.745.745,0,0,0,11.98,6,.75.75,0,0,0,11.446,5.775Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 2) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M20,10A10,10,0,1,1,10,0,10.011,10.011,0,0,1,20,10",
            transform: "translate(0 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M8.443.749a.747.747,0,0,1-.219.529L4.754,4.765a.752.752,0,0,1-1.063,0L.219,1.278A.75.75,0,0,1,1.282.22l2.94,2.953L7.162.22A.75.75,0,0,1,8.443.749",
            transform: "translate(5.778 7.808)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 2) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25A9.25,9.25,0,1,0,9.25,0,9.25,9.25,0,0,0,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,3.471,3.486,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 22) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,10A9.94,9.94,0,0,1,3.9,2.073.727.727,0,0,1,4.79,3.226,8.546,8.546,0,1,0,10,1.454a8.645,8.645,0,0,0-1.3.1A.727.727,0,0,1,8.481.114,10,10,0,1,1,0,10Zm9.468,2.573L6,9.087A.75.75,0,1,1,7.06,8.028L10,10.981l2.94-2.953A.75.75,0,0,1,14,9.087L10.53,12.573a.747.747,0,0,1-1.062,0Z",
            transform: "translate(0 20) rotate(-90)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 2) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25A9.25,9.25,0,1,0,9.25,0,9.25,9.25,0,0,0,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,3.471,3.486,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 2) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0S2.392,3.486,3.472,3.486,6.942,0,6.942,0",
            transform: "translate(6.529 8.558)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$pe.displayName = "IconlyChevronLeftCircle", $63c37e44f569564f$var$pe.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$afaf052a4e71ca4a = $63c37e44f569564f$var$st($63c37e44f569564f$var$pe), $63c37e44f569564f$var$he = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6 7)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.869,9.631c-.058-.057-.306-.27-.51-.469a21.69,21.69,0,0,1-4.024-5.8A4.617,4.617,0,0,1,0,2.188a1.933,1.933,0,0,1,.218-.9A1.874,1.874,0,0,1,1.122.5,9.84,9.84,0,0,1,2.186.242,23.979,23.979,0,0,1,5.992,0,27.724,27.724,0,0,1,9.681.213a8.495,8.495,0,0,1,1.327.341A1.785,1.785,0,0,1,12,2.132v.057a4.879,4.879,0,0,1-.409,1.321A21.69,21.69,0,0,1,7.625,9.177a5.66,5.66,0,0,1-.554.482A1.783,1.783,0,0,1,6.007,10a1.875,1.875,0,0,1-1.138-.369",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6 7)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.867.214,9.086,7.062a.435.435,0,0,1-.026.493,13.057,13.057,0,0,1-1.436,1.62,5.369,5.369,0,0,1-.559.479A1.723,1.723,0,0,1,6.006,10a1.855,1.855,0,0,1-1.14-.368c-.057-.056-.308-.268-.513-.468A21.777,21.777,0,0,1,.33,3.341,4.49,4.49,0,0,1,0,2.161a1.938,1.938,0,0,1,.217-.9,1.866,1.866,0,0,1,.9-.79A9.271,9.271,0,0,1,2.188.213,17.671,17.671,0,0,1,4.457,0a.463.463,0,0,1,.41.214",
            transform: "translate(0 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M.065.668A.443.443,0,0,1,.476,0C1.318.037,2.06.1,2.612.175A7.427,7.427,0,0,1,3.934.521,1.778,1.778,0,0,1,4.926,2.1v.055a4.5,4.5,0,0,1-.41,1.326,13.808,13.808,0,0,1-.894,1.685.459.459,0,0,1-.778.007Z",
            transform: "translate(7.074 0.005)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(5 8.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M14,0,7,7,0,0",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("path", {
            d: "M7.417,8.753.24,1.427a.846.846,0,0,1,0-1.183.813.813,0,0,1,1.164,0L8.582,7.573a.846.846,0,0,1,0,1.184.813.813,0,0,1-1.164,0ZM9.832,6.3a.847.847,0,0,1,0-1.184L14.593.247a.814.814,0,0,1,1.165,0,.847.847,0,0,1,0,1.183L10.994,6.293a.812.812,0,0,1-1.163,0Z",
            transform: "translate(4 7.5)",
            fill: r
        });
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(5 8.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M14,0S9.856,7,7,7,0,0,0,0",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "curved":
            return (0, $acw62.createElement)(d, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$he.displayName = "IconlyChevronDown", $63c37e44f569564f$var$he.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$4e3778eb35f54199 = $63c37e44f569564f$var$st($63c37e44f569564f$var$he), $63c37e44f569564f$var$Le = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(7 6)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.631,7.131c-.057.058-.27.306-.469.51a21.69,21.69,0,0,1-5.8,4.024A4.617,4.617,0,0,1,2.188,12a1.933,1.933,0,0,1-.9-.218,1.874,1.874,0,0,1-.795-.9A9.84,9.84,0,0,1,.242,9.814,23.979,23.979,0,0,1,0,6.008,27.724,27.724,0,0,1,.213,2.319,8.495,8.495,0,0,1,.554.992,1.785,1.785,0,0,1,2.132,0h.057A4.879,4.879,0,0,1,3.509.409,21.69,21.69,0,0,1,9.177,4.375a5.66,5.66,0,0,1,.482.554A1.783,1.783,0,0,1,10,5.993a1.875,1.875,0,0,1-.369,1.138",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(7 18) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.867.214,9.086,7.062a.435.435,0,0,1-.026.493,13.057,13.057,0,0,1-1.436,1.62,5.369,5.369,0,0,1-.559.479A1.723,1.723,0,0,1,6.006,10a1.855,1.855,0,0,1-1.14-.368c-.057-.056-.308-.268-.513-.468A21.777,21.777,0,0,1,.33,3.341,4.49,4.49,0,0,1,0,2.161a1.938,1.938,0,0,1,.217-.9,1.866,1.866,0,0,1,.9-.79A9.271,9.271,0,0,1,2.188.213,17.671,17.671,0,0,1,4.457,0a.463.463,0,0,1,.41.214",
            transform: "translate(0 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M.065.668A.443.443,0,0,1,.476,0C1.318.037,2.06.1,2.612.175A7.427,7.427,0,0,1,3.934.521,1.778,1.778,0,0,1,4.926,2.1v.055a4.5,4.5,0,0,1-.41,1.326,13.808,13.808,0,0,1-.894,1.685.459.459,0,0,1-.778.007Z",
            transform: "translate(7.074 0.005)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(8.5 19) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M14,0,7,7,0,0",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(7.5 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M.244,15.758a.815.815,0,0,1-.073-1.08l.076-.084L7.573,7.418a.845.845,0,0,1,1.184,0A.813.813,0,0,1,8.829,8.5l-.076.084L1.427,15.759a.846.846,0,0,1-1.183,0ZM5.2,6.245l-.086-.074L.247,1.407a.813.813,0,0,1,0-1.164.847.847,0,0,1,1.1-.076l.086.073L6.293,5a.813.813,0,0,1,0,1.164.848.848,0,0,1-1.1.076Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(8.5 19) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M14,0S9.856,7,7,7,0,0,0,0",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "curved":
            return (0, $acw62.createElement)(d, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Le.displayName = "IconlyChevronRight", $63c37e44f569564f$var$Le.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$6172d85aadfc9b96 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Le), $63c37e44f569564f$var$ye = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6 7)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.131.369c.058.057.306.27.51.469a21.69,21.69,0,0,1,4.024,5.8A4.617,4.617,0,0,1,12,7.812a1.933,1.933,0,0,1-.218.9,1.874,1.874,0,0,1-.9.795,9.84,9.84,0,0,1-1.064.256A23.979,23.979,0,0,1,6.008,10a27.724,27.724,0,0,1-3.689-.213A8.495,8.495,0,0,1,.992,9.446,1.785,1.785,0,0,1,0,7.868V7.812A4.879,4.879,0,0,1,.409,6.491,21.69,21.69,0,0,1,4.375.823,5.66,5.66,0,0,1,4.929.341,1.783,1.783,0,0,1,5.993,0,1.875,1.875,0,0,1,7.131.369",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(18 17) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.867.214,9.086,7.062a.435.435,0,0,1-.026.493,13.057,13.057,0,0,1-1.436,1.62,5.369,5.369,0,0,1-.559.479A1.723,1.723,0,0,1,6.006,10a1.855,1.855,0,0,1-1.14-.368c-.057-.056-.308-.268-.513-.468A21.777,21.777,0,0,1,.33,3.341,4.49,4.49,0,0,1,0,2.161a1.938,1.938,0,0,1,.217-.9,1.866,1.866,0,0,1,.9-.79A9.271,9.271,0,0,1,2.188.213,17.671,17.671,0,0,1,4.457,0a.463.463,0,0,1,.41.214",
            transform: "translate(0 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M.065.668A.443.443,0,0,1,.476,0C1.318.037,2.06.1,2.612.175A7.427,7.427,0,0,1,3.934.521,1.778,1.778,0,0,1,4.926,2.1v.055a4.5,4.5,0,0,1-.41,1.326,13.808,13.808,0,0,1-.894,1.685.459.459,0,0,1-.778.007Z",
            transform: "translate(7.074 0.005)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(19 15.5) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M14,0,7,7,0,0",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 7.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M.242,8.756a.846.846,0,0,1,0-1.184L7.417.247,7.5.171A.813.813,0,0,1,8.581.244a.846.846,0,0,1,0,1.183L1.406,8.753l-.084.076a.814.814,0,0,1-1.08-.073Zm14.351,0L9.828,3.888,9.755,3.8a.847.847,0,0,1,.076-1.1.812.812,0,0,1,1.163,0l4.766,4.865.073.085a.847.847,0,0,1-.076,1.1.814.814,0,0,1-1.165,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(19 15.5) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M14,0S9.856,7,7,7,0,0,0,0",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "curved":
            return (0, $acw62.createElement)(d, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$ye.displayName = "IconlyChevronUp", $63c37e44f569564f$var$ye.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$9b80ee7d1e129684 = $63c37e44f569564f$var$st($63c37e44f569564f$var$ye), $63c37e44f569564f$var$We = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(7 6)"
        }, (0, $acw62.createElement)("path", {
            d: "M.369,4.869c.057-.058.27-.306.469-.51A21.69,21.69,0,0,1,6.633.335,4.617,4.617,0,0,1,7.812,0a1.933,1.933,0,0,1,.9.218,1.874,1.874,0,0,1,.795.9,9.84,9.84,0,0,1,.256,1.064A23.979,23.979,0,0,1,10,5.992a27.724,27.724,0,0,1-.213,3.689,8.495,8.495,0,0,1-.341,1.327A1.785,1.785,0,0,1,7.868,12H7.812a4.879,4.879,0,0,1-1.321-.409A21.69,21.69,0,0,1,.823,7.625a5.66,5.66,0,0,1-.482-.554A1.783,1.783,0,0,1,0,6.007,1.875,1.875,0,0,1,.369,4.869",
            transform: "translate(0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(17 6) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.867.214,9.086,7.062a.435.435,0,0,1-.026.493,13.057,13.057,0,0,1-1.436,1.62,5.369,5.369,0,0,1-.559.479A1.723,1.723,0,0,1,6.006,10a1.855,1.855,0,0,1-1.14-.368c-.057-.056-.308-.268-.513-.468A21.777,21.777,0,0,1,.33,3.341,4.49,4.49,0,0,1,0,2.161a1.938,1.938,0,0,1,.217-.9,1.866,1.866,0,0,1,.9-.79A9.271,9.271,0,0,1,2.188.213,17.671,17.671,0,0,1,4.457,0a.463.463,0,0,1,.41.214",
            transform: "translate(0 0)",
            fill: r
        }), (0, $acw62.createElement)("path", {
            d: "M.065.668A.443.443,0,0,1,.476,0C1.318.037,2.06.1,2.612.175A7.427,7.427,0,0,1,3.934.521,1.778,1.778,0,0,1,4.926,2.1v.055a4.5,4.5,0,0,1-.41,1.326,13.808,13.808,0,0,1-.894,1.685.459.459,0,0,1-.778.007Z",
            transform: "translate(7.074 0.005)",
            fill: n,
            opacity: a
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(15.5 5) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M14,0,7,7,0,0",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(7.5 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.573,15.759.247,8.582.171,8.5A.813.813,0,0,1,.244,7.42a.845.845,0,0,1,1.183,0l7.326,7.177.076.084a.815.815,0,0,1-.073,1.08.846.846,0,0,1-1.184,0ZM2.7,6.169A.813.813,0,0,1,2.707,5L7.573.239,7.658.167a.847.847,0,0,1,1.1.076.813.813,0,0,1,0,1.164L3.888,6.171,3.8,6.245a.848.848,0,0,1-1.1-.076Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(15.5 5) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M14,0S9.856,7,7,7,0,0,0,0",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "curved":
            return (0, $acw62.createElement)(d, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$We.displayName = "IconlyChevronLeft", $63c37e44f569564f$var$We.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$29ab0a58e0457c56 = $63c37e44f569564f$var$st($63c37e44f569564f$var$We), $63c37e44f569564f$var$Ze = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.33,20H5.66C2.275,20,0,17.621,0,14.08V5.91C0,2.375,2.275,0,5.66,0h8.67C17.721,0,20,2.375,20,5.91V14.08C20,17.621,17.721,20,14.33,20ZM6.25,9.57a.787.787,0,0,0-.529.22.753.753,0,0,0,0,1.06L9.47,14.62a.772.772,0,0,0,1.06,0l3.75-3.769a.751.751,0,0,0,0-1.06.767.767,0,0,0-1.07,0L10.75,12.27V5.92A.751.751,0,0,0,10,5.17a.742.742,0,0,0-.75.751v6.35L6.78,9.79A.763.763,0,0,0,6.25,9.57Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,5.916v8.168C0,17.623,2.276,20,5.665,20h8.67C17.724,20,20,17.623,20,14.084V5.916C20,2.378,17.723,0,14.334,0H5.665C2.276,0,0,2.378,0,5.916",
            transform: "translate(0 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.218,5.687,3.966,9.452a.773.773,0,0,0,1.064,0L8.778,5.687A.751.751,0,0,0,7.714,4.628L5.247,7.105V.75a.75.75,0,0,0-1.5,0V7.105L1.281,4.628A.75.75,0,0,0,.218,5.687",
            transform: "translate(5.502 5.168)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.916,18.5h8.669c3.02,0,4.915-2.139,4.915-5.166V5.166C18.5,2.139,16.615,0,13.585,0H4.916C1.886,0,0,2.139,0,5.166v8.168C0,16.361,1.886,18.5,4.916,18.5Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0,3.748,3.764,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.256,20C2.393,20,0,17.608,0,13.747v-7.5C0,2.41,2.393,0,6.253,0H8.822a.756.756,0,0,1,.756.756V.765H9.561A.765.765,0,0,1,8.8,1.53H6.253C3.2,1.53,1.53,3.2,1.53,6.244v7.5c0,3.046,1.68,4.726,4.723,4.726h7.5c3.034,0,4.714-1.679,4.714-4.723v-7.5c0-3.043-1.68-4.714-4.714-4.714a.765.765,0,0,1,0-1.53C17.608,0,20,2.392,20,6.244v7.5C20,17.608,17.608,20,13.756,20ZM10,14.837a.746.746,0,0,1-.286-.058.733.733,0,0,1-.243-.162h0L5.721,10.851A.75.75,0,0,1,6.783,9.793L9.25,12.27V5.914a.75.75,0,0,1,1.5,0v8.172a.759.759,0,0,1-.059.288.731.731,0,0,1-.163.243c-.007.008-.016.01-.023.017a.773.773,0,0,1-.22.144.757.757,0,0,1-.251.051c-.013,0-.022.007-.035.007Zm1.941-2.7a.749.749,0,0,1,0-1.06l1.278-1.284a.75.75,0,0,1,1.062,1.059L13,12.136a.75.75,0,0,1-1.061,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.916,18.5h8.669c3.02,0,4.915-2.139,4.915-5.166V5.166C18.5,2.139,16.615,0,13.585,0H4.916C1.886,0,0,2.139,0,5.166v8.168C0,16.361,1.886,18.5,4.916,18.5Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0,3.748,3.764,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0S4.972,3.764,3.748,3.764,0,0,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Ze.displayName = "IconlyArrowDownSquare", $63c37e44f569564f$var$Ze.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$ed3f7c87e4adf28b = $63c37e44f569564f$var$st($63c37e44f569564f$var$Ze), $63c37e44f569564f$var$Ce = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.08,20H5.91C2.375,20,0,17.725,0,14.34V5.67C0,2.279,2.375,0,5.91,0H14.08C17.621,0,20,2.279,20,5.67v8.67C20,17.725,17.621,20,14.08,20ZM5.92,9.25A.751.751,0,0,0,5.17,10a.742.742,0,0,0,.751.75h6.35L9.79,13.22a.763.763,0,0,0-.22.53.792.792,0,0,0,.22.53.755.755,0,0,0,1.06,0l3.769-3.75a.772.772,0,0,0,0-1.06L10.85,5.72a.753.753,0,0,0-1.06,0,.766.766,0,0,0,0,1.069L12.27,9.25Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,5.916v8.168C0,17.623,2.276,20,5.665,20h8.67C17.724,20,20,17.623,20,14.084V5.916C20,2.378,17.723,0,14.334,0H5.665C2.276,0,0,2.378,0,5.916",
            transform: "translate(0 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.218,5.687,3.966,9.452a.773.773,0,0,0,1.064,0L8.778,5.687A.751.751,0,0,0,7.714,4.628L5.247,7.105V.75a.75.75,0,0,0-1.5,0V7.105L1.281,4.628A.75.75,0,0,0,.218,5.687",
            transform: "translate(5.502 5.168)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.916,18.5h8.669c3.02,0,4.915-2.139,4.915-5.166V5.166C18.5,2.139,16.615,0,13.585,0H4.916C1.886,0,0,2.139,0,5.166v8.168C0,16.361,1.886,18.5,4.916,18.5Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0,3.748,3.764,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.256,20C2.393,20,0,17.608,0,13.747v-7.5C0,2.41,2.393,0,6.253,0H8.822a.756.756,0,0,1,.756.756V.765H9.561A.765.765,0,0,1,8.8,1.53H6.253C3.2,1.53,1.53,3.2,1.53,6.244v7.5c0,3.046,1.68,4.726,4.723,4.726h7.5c3.034,0,4.714-1.679,4.714-4.723v-7.5c0-3.043-1.68-4.714-4.714-4.714a.765.765,0,0,1,0-1.53C17.608,0,20,2.392,20,6.244v7.5C20,17.608,17.608,20,13.756,20ZM10,14.837a.746.746,0,0,1-.286-.058.733.733,0,0,1-.243-.162h0L5.721,10.851A.75.75,0,0,1,6.783,9.793L9.25,12.27V5.914a.75.75,0,0,1,1.5,0v8.172a.759.759,0,0,1-.059.288.731.731,0,0,1-.163.243c-.007.008-.016.01-.023.017a.773.773,0,0,1-.22.144.757.757,0,0,1-.251.051c-.013,0-.022.007-.035.007Zm1.941-2.7a.749.749,0,0,1,0-1.06l1.278-1.284a.75.75,0,0,1,1.062,1.059L13,12.136a.75.75,0,0,1-1.061,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.916,18.5h8.669c3.02,0,4.915-2.139,4.915-5.166V5.166C18.5,2.139,16.615,0,13.585,0H4.916C1.886,0,0,2.139,0,5.166v8.168C0,16.361,1.886,18.5,4.916,18.5Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0,3.748,3.764,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 22) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0S4.972,3.764,3.748,3.764,0,0,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Ce.displayName = "IconlyArrowRightSquare", $63c37e44f569564f$var$Ce.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$786fdd61896e8eed = $63c37e44f569564f$var$st($63c37e44f569564f$var$Ce), $63c37e44f569564f$var$He = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.34,20H5.67C2.279,20,0,17.625,0,14.09V5.92C0,2.379,2.279,0,5.67,0h8.67C17.725,0,20,2.379,20,5.92v8.17C20,17.625,17.725,20,14.34,20ZM9.25,7.73v6.35a.751.751,0,0,0,.75.751.742.742,0,0,0,.75-.751V7.73l2.47,2.479a.763.763,0,0,0,.53.22.792.792,0,0,0,.53-.22.75.75,0,0,0,0-1.059L10.53,5.38a.774.774,0,0,0-1.06,0L5.72,9.15a.752.752,0,0,0,0,1.059.764.764,0,0,0,1.069,0L9.248,7.732Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 22) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,5.916v8.168C0,17.623,2.276,20,5.665,20h8.67C17.724,20,20,17.623,20,14.084V5.916C20,2.378,17.723,0,14.334,0H5.665C2.276,0,0,2.378,0,5.916",
            transform: "translate(0 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.218,5.687,3.966,9.452a.773.773,0,0,0,1.064,0L8.778,5.687A.751.751,0,0,0,7.714,4.628L5.247,7.105V.75a.75.75,0,0,0-1.5,0V7.105L1.281,4.628A.75.75,0,0,0,.218,5.687",
            transform: "translate(5.502 5.168)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 22) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.916,18.5h8.669c3.02,0,4.915-2.139,4.915-5.166V5.166C18.5,2.139,16.615,0,13.585,0H4.916C1.886,0,0,2.139,0,5.166v8.168C0,16.361,1.886,18.5,4.916,18.5Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0,3.748,3.764,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 22) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.256,20C2.393,20,0,17.608,0,13.747v-7.5C0,2.41,2.393,0,6.253,0H8.822a.756.756,0,0,1,.756.756V.765H9.561A.765.765,0,0,1,8.8,1.53H6.253C3.2,1.53,1.53,3.2,1.53,6.244v7.5c0,3.046,1.68,4.726,4.723,4.726h7.5c3.034,0,4.714-1.679,4.714-4.723v-7.5c0-3.043-1.68-4.714-4.714-4.714a.765.765,0,0,1,0-1.53C17.608,0,20,2.392,20,6.244v7.5C20,17.608,17.608,20,13.756,20ZM10,14.837a.746.746,0,0,1-.286-.058.733.733,0,0,1-.243-.162h0L5.721,10.851A.75.75,0,0,1,6.783,9.793L9.25,12.27V5.914a.75.75,0,0,1,1.5,0v8.172a.759.759,0,0,1-.059.288.731.731,0,0,1-.163.243c-.007.008-.016.01-.023.017a.773.773,0,0,1-.22.144.757.757,0,0,1-.251.051c-.013,0-.022.007-.035.007Zm1.941-2.7a.749.749,0,0,1,0-1.06l1.278-1.284a.75.75,0,0,1,1.062,1.059L13,12.136a.75.75,0,0,1-1.061,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 22) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.916,18.5h8.669c3.02,0,4.915-2.139,4.915-5.166V5.166C18.5,2.139,16.615,0,13.585,0H4.916C1.886,0,0,2.139,0,5.166v8.168C0,16.361,1.886,18.5,4.916,18.5Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0,3.748,3.764,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 22) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0S4.972,3.764,3.748,3.764,0,0,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$He.displayName = "IconlyArrowUpSquare", $63c37e44f569564f$var$He.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$15064f172111aa33 = $63c37e44f569564f$var$st($63c37e44f569564f$var$He), $63c37e44f569564f$var$we = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2 2)"
        }, (0, $acw62.createElement)("path", {
            d: "M14.09,20H5.92C2.379,20,0,17.721,0,14.33V5.66C0,2.275,2.379,0,5.92,0h8.17C17.625,0,20,2.275,20,5.66v8.67C20,17.721,17.625,20,14.09,20ZM9.68,5.5a.742.742,0,0,0-.53.218L5.38,9.47a.774.774,0,0,0,0,1.06l3.77,3.75a.754.754,0,0,0,1.059,0,.766.766,0,0,0,0-1.07L7.73,10.75h6.35A.751.751,0,0,0,14.83,10a.742.742,0,0,0-.751-.75H7.73L10.21,6.78a.763.763,0,0,0,.22-.53.787.787,0,0,0-.22-.529A.742.742,0,0,0,9.68,5.5Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 2) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,5.916v8.168C0,17.623,2.276,20,5.665,20h8.67C17.724,20,20,17.623,20,14.084V5.916C20,2.378,17.723,0,14.334,0H5.665C2.276,0,0,2.378,0,5.916",
            transform: "translate(0 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.218,5.687,3.966,9.452a.773.773,0,0,0,1.064,0L8.778,5.687A.751.751,0,0,0,7.714,4.628L5.247,7.105V.75a.75.75,0,0,0-1.5,0V7.105L1.281,4.628A.75.75,0,0,0,.218,5.687",
            transform: "translate(5.502 5.168)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 2) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.916,18.5h8.669c3.02,0,4.915-2.139,4.915-5.166V5.166C18.5,2.139,16.615,0,13.585,0H4.916C1.886,0,0,2.139,0,5.166v8.168C0,16.361,1.886,18.5,4.916,18.5Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0,3.748,3.764,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 2) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.256,20C2.393,20,0,17.608,0,13.747v-7.5C0,2.41,2.393,0,6.253,0H8.822a.756.756,0,0,1,.756.756V.765H9.561A.765.765,0,0,1,8.8,1.53H6.253C3.2,1.53,1.53,3.2,1.53,6.244v7.5c0,3.046,1.68,4.726,4.723,4.726h7.5c3.034,0,4.714-1.679,4.714-4.723v-7.5c0-3.043-1.68-4.714-4.714-4.714a.765.765,0,0,1,0-1.53C17.608,0,20,2.392,20,6.244v7.5C20,17.608,17.608,20,13.756,20ZM10,14.837a.746.746,0,0,1-.286-.058.733.733,0,0,1-.243-.162h0L5.721,10.851A.75.75,0,0,1,6.783,9.793L9.25,12.27V5.914a.75.75,0,0,1,1.5,0v8.172a.759.759,0,0,1-.059.288.731.731,0,0,1-.163.243c-.007.008-.016.01-.023.017a.773.773,0,0,1-.22.144.757.757,0,0,1-.251.051c-.013,0-.022.007-.035.007Zm1.941-2.7a.749.749,0,0,1,0-1.06l1.278-1.284a.75.75,0,0,1,1.062,1.059L13,12.136a.75.75,0,0,1-1.061,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 2) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.916,18.5h8.669c3.02,0,4.915-2.139,4.915-5.166V5.166C18.5,2.139,16.615,0,13.585,0H4.916C1.886,0,0,2.139,0,5.166v8.168C0,16.361,1.886,18.5,4.916,18.5Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0,3.748,3.764,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(22 2) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.172V0",
            transform: "translate(9.5 5.914)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M7.5,0S4.972,3.764,3.748,3.764,0,0,0,0",
            transform: "translate(6.252 10.322)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,9.25c0,6.937,2.313,9.25,9.25,9.25s9.25-2.313,9.25-9.25S16.187,0,9.25,0,0,2.313,0,9.25Z",
            transform: "translate(0.75 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$we.displayName = "IconlyArrowLeftSquare", $63c37e44f569564f$var$we.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$62680667f88800e6 = $63c37e44f569564f$var$st($63c37e44f569564f$var$we), $63c37e44f569564f$var$Te = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.87,17.625c-.059-.058-.305-.274-.51-.477A22.081,22.081,0,0,1,.336,11.257,4.815,4.815,0,0,1,0,10.058a2,2,0,0,1,.22-.91,1.883,1.883,0,0,1,.9-.808,9.781,9.781,0,0,1,1.065-.261,23.616,23.616,0,0,1,3.805-.244,27.187,27.187,0,0,1,3.688.216,8.15,8.15,0,0,1,1.328.347A1.815,1.815,0,0,1,12,10v.058a5.023,5.023,0,0,1-.408,1.343,22.023,22.023,0,0,1-3.966,5.761,5.686,5.686,0,0,1-.553.491A1.771,1.771,0,0,1,6.008,18,1.853,1.853,0,0,1,4.87,17.625ZM4.81,5.2,4.483,1.5a1.518,1.518,0,0,1,3.036,0L7.191,5.2a1.191,1.191,0,0,1-2.381,0Z",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M.327,5.2,0,1.5a1.518,1.518,0,0,1,3.036,0L2.709,5.2a1.191,1.191,0,0,1-2.381,0",
            transform: "translate(4.483 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.87,9.79c-.058-.058-.305-.274-.51-.477A22.073,22.073,0,0,1,.336,3.422,4.828,4.828,0,0,1,0,2.223a2,2,0,0,1,.219-.91,1.886,1.886,0,0,1,.9-.808A9.79,9.79,0,0,1,2.188.244,23.636,23.636,0,0,1,5.993,0,27.291,27.291,0,0,1,9.681.216a8.26,8.26,0,0,1,1.327.347A1.815,1.815,0,0,1,12,2.165v.058a5.031,5.031,0,0,1-.408,1.343A22.044,22.044,0,0,1,7.626,9.327a5.693,5.693,0,0,1-.554.491,1.768,1.768,0,0,1-1.064.347A1.856,1.856,0,0,1,4.87,9.79",
            transform: "translate(0 7.835)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(5.5 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0,6.025,6.05,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.912,17.759l-6.67-6.6A.81.81,0,0,1,.244,10a.839.839,0,0,1,1.175,0L6.67,15.2V.818a.83.83,0,0,1,1.661,0V17.182a.818.818,0,0,1-.514.756.837.837,0,0,1-.9-.179ZM9.9,14.8a.807.807,0,0,1,0-1.156L13.581,10a.841.841,0,0,1,1.175,0,.811.811,0,0,1,0,1.157L11.079,14.8a.84.84,0,0,1-1.175,0Z",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(5.5 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0,6.025,6.05,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(5.5 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0S8.788,6.05,6.026,6.05,0,0,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Te.displayName = "IconlyArrowDown", $63c37e44f569564f$var$Te.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$1fa5a43af950a186 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Te), $63c37e44f569564f$var$Ie = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 6)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.149,11.781a1.889,1.889,0,0,1-.808-.9,9.727,9.727,0,0,1-.261-1.064A22.373,22.373,0,0,1,7.836,6.36V6.007a27.187,27.187,0,0,1,.216-3.688l.113-.544A3.886,3.886,0,0,1,8.4.992,1.814,1.814,0,0,1,10,0h.058A5.023,5.023,0,0,1,11.4.408,22.606,22.606,0,0,1,16.994,4.2l.379.4a3.481,3.481,0,0,1,.281.334A1.766,1.766,0,0,1,18,5.992a1.853,1.853,0,0,1-.375,1.138l-.39.42-.087.09a22.081,22.081,0,0,1-5.891,4.024l-.244.094a4.065,4.065,0,0,1-.955.242A2.005,2.005,0,0,1,9.149,11.781ZM0,6A1.511,1.511,0,0,1,1.5,4.482l3.7.327a1.191,1.191,0,0,1,0,2.381l-3.7.328A1.511,1.511,0,0,1,0,6Z",
            transform: "translate(0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 18) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.327,5.2,0,1.5a1.518,1.518,0,0,1,3.036,0L2.709,5.2a1.191,1.191,0,0,1-2.381,0",
            transform: "translate(4.483 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.87,9.79c-.058-.058-.305-.274-.51-.477A22.073,22.073,0,0,1,.336,3.422,4.828,4.828,0,0,1,0,2.223a2,2,0,0,1,.219-.91,1.886,1.886,0,0,1,.9-.808A9.79,9.79,0,0,1,2.188.244,23.636,23.636,0,0,1,5.993,0,27.291,27.291,0,0,1,9.681.216a8.26,8.26,0,0,1,1.327.347A1.815,1.815,0,0,1,12,2.165v.058a5.031,5.031,0,0,1-.408,1.343A22.044,22.044,0,0,1,7.626,9.327a5.693,5.693,0,0,1-.554.491,1.768,1.768,0,0,1-1.064.347A1.856,1.856,0,0,1,4.87,9.79",
            transform: "translate(0 7.835)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 18.5) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0,6.025,6.05,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 4.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M10,14.756a.839.839,0,0,1-.071-1.09L10,13.581,15.2,8.33H.818a.831.831,0,0,1-.1-1.654l.1-.006H17.182a.818.818,0,0,1,.756.513A.841.841,0,0,1,17.832,8l-.073.083-6.6,6.671a.81.81,0,0,1-1.156,0Zm3.726-9.584L13.645,5.1,10,1.418A.839.839,0,0,1,10,.244.81.81,0,0,1,11.075.167l.085.075L14.8,3.92a.841.841,0,0,1,0,1.175.808.808,0,0,1-1.073.077Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 18.5) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0,6.025,6.05,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4 18.5) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0S8.788,6.05,6.026,6.05,0,0,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Ie.displayName = "IconlyArrowRight", $63c37e44f569564f$var$Ie.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$acad20503ad73ac1 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Ie), $63c37e44f569564f$var$xe = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M4.482,16.5l.327-3.7a1.191,1.191,0,0,1,2.381,0l.328,3.7a1.518,1.518,0,0,1-3.036,0ZM2.318,9.949l-.544-.113A3.886,3.886,0,0,1,.992,9.6,1.814,1.814,0,0,1,0,8V7.942A5.023,5.023,0,0,1,.408,6.6,22.605,22.605,0,0,1,4.2,1.006l.4-.379A3.481,3.481,0,0,1,4.928.347,1.766,1.766,0,0,1,5.992,0,1.853,1.853,0,0,1,7.13.375l.42.39.09.087a22.081,22.081,0,0,1,4.024,5.891l.094.244A4.065,4.065,0,0,1,12,7.942a2.005,2.005,0,0,1-.219.91,1.889,1.889,0,0,1-.9.808,9.728,9.728,0,0,1-1.064.261,22.373,22.373,0,0,1-3.452.243H6.007A27.187,27.187,0,0,1,2.318,9.949Z",
            transform: "translate(0 0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(18 21) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M.327,5.2,0,1.5a1.518,1.518,0,0,1,3.036,0L2.709,5.2a1.191,1.191,0,0,1-2.381,0",
            transform: "translate(4.483 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.87,9.79c-.058-.058-.305-.274-.51-.477A22.073,22.073,0,0,1,.336,3.422,4.828,4.828,0,0,1,0,2.223a2,2,0,0,1,.219-.91,1.886,1.886,0,0,1,.9-.808A9.79,9.79,0,0,1,2.188.244,23.636,23.636,0,0,1,5.993,0,27.291,27.291,0,0,1,9.681.216a8.26,8.26,0,0,1,1.327.347A1.815,1.815,0,0,1,12,2.165v.058a5.031,5.031,0,0,1-.408,1.343A22.044,22.044,0,0,1,7.626,9.327a5.693,5.693,0,0,1-.554.491,1.768,1.768,0,0,1-1.064.347A1.856,1.856,0,0,1,4.87,9.79",
            transform: "translate(0 7.835)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(18.5 20) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0,6.025,6.05,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(4.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.676,17.285l-.006-.1V.818A.818.818,0,0,1,7.183.062.841.841,0,0,1,8,.168l.083.073,6.671,6.6a.81.81,0,0,1,0,1.157.839.839,0,0,1-1.09.071L13.581,8,8.33,2.8V17.182a.831.831,0,0,1-1.654.1ZM.244,8A.81.81,0,0,1,.167,6.925L.242,6.84,3.92,3.2A.841.841,0,0,1,5.1,3.2a.808.808,0,0,1,.077,1.073L5.1,4.355,1.418,8A.839.839,0,0,1,.244,8Z",
            transform: "translate(0)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(18.5 20) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0,6.025,6.05,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(18.5 20) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0S8.788,6.05,6.026,6.05,0,0,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$xe.displayName = "IconlyArrowUp", $63c37e44f569564f$var$xe.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$2624c5890f1bbcf7 = $63c37e44f569564f$var$st($63c37e44f569564f$var$xe), $63c37e44f569564f$var$Ee = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, a = t.opacity, s = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 6)"
        }, (0, $acw62.createElement)("path", {
            d: "M7.942,12A5.023,5.023,0,0,1,6.6,11.592,22.626,22.626,0,0,1,1.006,7.8l-.379-.4a3.6,3.6,0,0,1-.281-.334A1.771,1.771,0,0,1,0,6.008,1.853,1.853,0,0,1,.375,4.87l.39-.42.087-.09A22.081,22.081,0,0,1,6.743.336L6.987.242A4.065,4.065,0,0,1,7.942,0a2,2,0,0,1,.91.22,1.883,1.883,0,0,1,.808.9,9.781,9.781,0,0,1,.261,1.065,22.351,22.351,0,0,1,.243,3.451v.354a27.187,27.187,0,0,1-.216,3.688l-.113.544a3.9,3.9,0,0,1-.233.784A1.815,1.815,0,0,1,8,12ZM12.8,7.191a1.191,1.191,0,0,1,0-2.381l3.7-.327a1.518,1.518,0,0,1,0,3.036Z",
            transform: "translate(0)",
            fill: r
        }));
    }, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(21 6) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.327,5.2,0,1.5a1.518,1.518,0,0,1,3.036,0L2.709,5.2a1.191,1.191,0,0,1-2.381,0",
            transform: "translate(4.483 0)",
            fill: n,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M4.87,9.79c-.058-.058-.305-.274-.51-.477A22.073,22.073,0,0,1,.336,3.422,4.828,4.828,0,0,1,0,2.223a2,2,0,0,1,.219-.91,1.886,1.886,0,0,1,.9-.808A9.79,9.79,0,0,1,2.188.244,23.636,23.636,0,0,1,5.993,0,27.291,27.291,0,0,1,9.681.216a8.26,8.26,0,0,1,1.327.347A1.815,1.815,0,0,1,12,2.165v.058a5.031,5.031,0,0,1-.408,1.343A22.044,22.044,0,0,1,7.626,9.327a5.693,5.693,0,0,1-.554.491,1.768,1.768,0,0,1-1.064.347A1.856,1.856,0,0,1,4.87,9.79",
            transform: "translate(0 7.835)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(20 5.5) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0,6.025,6.05,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 4)"
        }, (0, $acw62.createElement)("path", {
            d: "M6.676,17.285l-.006-.1V.818A.818.818,0,0,1,7.183.062.841.841,0,0,1,8,.168l.083.073,6.671,6.6a.81.81,0,0,1,0,1.157.839.839,0,0,1-1.09.071L13.581,8,8.33,2.8V17.182a.831.831,0,0,1-1.654.1ZM.244,8A.81.81,0,0,1,.167,6.925L.242,6.84,3.92,3.2A.841.841,0,0,1,5.1,3.2a.808.808,0,0,1,.077,1.073L5.1,4.355,1.418,8A.839.839,0,0,1,.244,8Z",
            transform: "translate(0.5 15.5) rotate(-90)",
            fill: r
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(20 5.5) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: a
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0,6.025,6.05,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(20 5.5) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,15V0",
            transform: "translate(6.274 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M12.049,0S8.788,6.05,6.026,6.05,0,0,0,0",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(s, null);
        case "bulk":
            return (0, $acw62.createElement)(i, null);
        case "broken":
            return (0, $acw62.createElement)(u, null);
        case "two-tone":
            return (0, $acw62.createElement)(d, null);
        case "curved":
            return (0, $acw62.createElement)(k, null);
        default:
            return (0, $acw62.createElement)(l, null);
    }
};
$63c37e44f569564f$var$Ee.displayName = "IconlyArrowLeft", $63c37e44f569564f$var$Ee.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$e4c291d45fea4cd0 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Ee), $63c37e44f569564f$var$$e = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, s = t.opacity, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 6.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M9.141.09a.715.715,0,0,0-.38.627V4.783H.734a.717.717,0,1,0,0,1.435H8.762v4.065a.712.712,0,0,0,.38.627.748.748,0,0,0,.746-.02l7.77-4.783a.709.709,0,0,0,0-1.215L9.888.11A.748.748,0,0,0,9.141.09",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)((0, $acw62.Fragment), null, (0, $acw62.createElement)("defs", null, (0, $acw62.createElement)("clipPath", {
            id: "clip-path"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0H10.9V8.939H0Z",
            transform: "translate(0 0.534)",
            fill: "none"
        }))), (0, $acw62.createElement)("g", {
            transform: "translate(3 17.5) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.421.711V9.189A.711.711,0,1,1,0,9.189V.711a.711.711,0,0,1,1.421,0",
            transform: "translate(4.738 0)",
            fill: n,
            opacity: s
        }), (0, $acw62.createElement)("g", {
            transform: "translate(0 7.944)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0H10.9V8.939H0Z",
            transform: "translate(0 0.534)",
            fill: "none"
        }), (0, $acw62.createElement)("g", {
            clipPath: "url(#clip-path)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.9.711a.715.715,0,0,1-.109.379L6.05,8.608a.71.71,0,0,1-1.2,0L.109,1.089A.712.712,0,0,1,.711,0h9.476A.713.713,0,0,1,10.9.711",
            transform: "translate(0 0.534)",
            fill: r
        })))));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 17.5) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(5.251 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,5,7.937,10,0Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 6)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.283,8.762H6.217V.734a.717.717,0,1,0-1.435,0V8.762H.717a.714.714,0,0,0-.628.38.748.748,0,0,0,.021.745l4.783,7.77a.708.708,0,0,0,1.215,0l2.975-4.835a.744.744,0,0,0-.224-1.012.709.709,0,0,0-.99.231L5.5,15.887,2.016,10.23h8.267a.734.734,0,0,0,0-1.468",
            transform: "translate(0.5 11.5) rotate(-90)",
            fill: r
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 17.5) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(5.251 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: s
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,5,7.937,10,0Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, c = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 17.5) rotate(-90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(4.894 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.65,7.654C5.906,7.654,9.921,1.29,9.2.568S.892-.223.1.568,3.395,7.654,4.65,7.654Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(i, null);
        case "bulk":
            return (0, $acw62.createElement)(l, null);
        case "broken":
            return (0, $acw62.createElement)(d, null);
        case "two-tone":
            return (0, $acw62.createElement)(k, null);
        case "curved":
            return (0, $acw62.createElement)(c, null);
        default:
            return (0, $acw62.createElement)(u, null);
    }
};
$63c37e44f569564f$var$$e.displayName = "IconlyCaretRight", $63c37e44f569564f$var$$e.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$98ac0f496a0846de = $63c37e44f569564f$var$st($63c37e44f569564f$var$$e), $63c37e44f569564f$var$Ue = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, s = t.opacity, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.91,9.141a.715.715,0,0,0-.627-.38H6.217V.734a.717.717,0,1,0-1.435,0V8.762H.717a.712.712,0,0,0-.627.38.748.748,0,0,0,.02.746l4.783,7.77a.709.709,0,0,0,1.215,0l4.783-7.77a.748.748,0,0,0,.02-.746",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)((0, $acw62.Fragment), null, (0, $acw62.createElement)("defs", null, (0, $acw62.createElement)("clipPath", {
            id: "clip-path"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0H10.9V8.939H0Z",
            transform: "translate(0 0.534)",
            fill: "none"
        }))), (0, $acw62.createElement)("g", {
            transform: "translate(6.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.421.711V9.189A.711.711,0,1,1,0,9.189V.711a.711.711,0,0,1,1.421,0",
            transform: "translate(4.738 0)",
            fill: n,
            opacity: s
        }), (0, $acw62.createElement)("g", {
            transform: "translate(0 7.944)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0H10.9V8.939H0Z",
            transform: "translate(0 0.534)",
            fill: "none"
        }), (0, $acw62.createElement)("g", {
            clipPath: "url(#clip-path)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.9.711a.715.715,0,0,1-.109.379L6.05,8.608a.71.71,0,0,1-1.2,0L.109,1.089A.712.712,0,0,1,.711,0h9.476A.713.713,0,0,1,10.9.711",
            transform: "translate(0 0.534)",
            fill: r
        })))));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(5.251 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,5,7.937,10,0Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.283,8.762H6.217V.734a.717.717,0,1,0-1.435,0V8.762H.717a.714.714,0,0,0-.628.38.748.748,0,0,0,.021.745l4.783,7.77a.708.708,0,0,0,1.215,0l2.975-4.835a.744.744,0,0,0-.224-1.012.709.709,0,0,0-.99.231L5.5,15.887,2.016,10.23h8.267a.734.734,0,0,0,0-1.468",
            fill: r
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(5.251 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: s
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,5,7.937,10,0Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, c = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(4.894 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.65,7.654C5.906,7.654,9.921,1.29,9.2.568S.892-.223.1.568,3.395,7.654,4.65,7.654Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(i, null);
        case "bulk":
            return (0, $acw62.createElement)(l, null);
        case "broken":
            return (0, $acw62.createElement)(d, null);
        case "two-tone":
            return (0, $acw62.createElement)(k, null);
        case "curved":
            return (0, $acw62.createElement)(c, null);
        default:
            return (0, $acw62.createElement)(u, null);
    }
};
$63c37e44f569564f$var$Ue.displayName = "IconlyCaretDown", $63c37e44f569564f$var$Ue.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$14643e45770079c3 = $63c37e44f569564f$var$st($63c37e44f569564f$var$Ue), $63c37e44f569564f$var$_e = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, s = t.opacity, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M.09,8.859a.715.715,0,0,0,.627.38H4.783v8.027a.717.717,0,1,0,1.435,0V9.238h4.065a.712.712,0,0,0,.627-.38.748.748,0,0,0-.02-.746L6.107.343a.709.709,0,0,0-1.215,0L.11,8.112a.748.748,0,0,0-.02.746",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)((0, $acw62.Fragment), null, (0, $acw62.createElement)("defs", null, (0, $acw62.createElement)("clipPath", {
            id: "clip-path"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0H10.9V8.939H0Z",
            transform: "translate(0 0.534)",
            fill: "none"
        }))), (0, $acw62.createElement)("g", {
            transform: "translate(17.5 21) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.421.711V9.189A.711.711,0,1,1,0,9.189V.711a.711.711,0,0,1,1.421,0",
            transform: "translate(4.738 0)",
            fill: n,
            opacity: s
        }), (0, $acw62.createElement)("g", {
            transform: "translate(0 7.944)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0H10.9V8.939H0Z",
            transform: "translate(0 0.534)",
            fill: "none"
        }), (0, $acw62.createElement)("g", {
            clipPath: "url(#clip-path)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.9.711a.715.715,0,0,1-.109.379L6.05,8.608a.71.71,0,0,1-1.2,0L.109,1.089A.712.712,0,0,1,.711,0h9.476A.713.713,0,0,1,10.9.711",
            transform: "translate(0 0.534)",
            fill: r
        })))));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(17.5 21) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(5.251 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,5,7.937,10,0Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(6.5 3)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.283,8.762H6.217V.734a.717.717,0,1,0-1.435,0V8.762H.717a.714.714,0,0,0-.628.38.748.748,0,0,0,.021.745l4.783,7.77a.708.708,0,0,0,1.215,0l2.975-4.835a.744.744,0,0,0-.224-1.012.709.709,0,0,0-.99.231L5.5,15.887,2.016,10.23h8.267a.734.734,0,0,0,0-1.468",
            transform: "translate(11 18) rotate(180)",
            fill: r
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(17.5 21) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(5.251 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: s
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,5,7.937,10,0Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, c = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(17.5 21) rotate(180)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(4.894 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.65,7.654C5.906,7.654,9.921,1.29,9.2.568S.892-.223.1.568,3.395,7.654,4.65,7.654Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(i, null);
        case "bulk":
            return (0, $acw62.createElement)(l, null);
        case "broken":
            return (0, $acw62.createElement)(d, null);
        case "two-tone":
            return (0, $acw62.createElement)(k, null);
        case "curved":
            return (0, $acw62.createElement)(c, null);
        default:
            return (0, $acw62.createElement)(u, null);
    }
};
$63c37e44f569564f$var$_e.displayName = "IconlyCaretUp", $63c37e44f569564f$var$_e.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$b67edd7bdacb81b5 = $63c37e44f569564f$var$st($63c37e44f569564f$var$_e), $63c37e44f569564f$var$ze = function(t) {
    var r = t.color, n = t.secondaryColor, e = t.strokeWidth, s = t.opacity, i = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(3 6.5)"
        }, (0, $acw62.createElement)("path", {
            d: "M8.859,10.91a.715.715,0,0,0,.38-.627V6.217h8.027a.717.717,0,1,0,0-1.435H9.238V.717A.712.712,0,0,0,8.859.09a.748.748,0,0,0-.746.02L.343,4.893a.709.709,0,0,0,0,1.215l7.77,4.783a.748.748,0,0,0,.746.02",
            transform: "translate(0 0)",
            fill: r
        }));
    }, l = function() {
        return (0, $acw62.createElement)((0, $acw62.Fragment), null, (0, $acw62.createElement)("defs", null, (0, $acw62.createElement)("clipPath", {
            id: "clip-path"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0H10.9V8.939H0Z",
            transform: "translate(0 0.534)",
            fill: "none"
        }))), (0, $acw62.createElement)("g", {
            transform: "translate(21 6.5) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M1.421.711V9.189A.711.711,0,1,1,0,9.189V.711a.711.711,0,0,1,1.421,0",
            transform: "translate(4.738 0)",
            fill: n,
            opacity: s
        }), (0, $acw62.createElement)("g", {
            transform: "translate(0 7.944)"
        }, (0, $acw62.createElement)("path", {
            d: "M0,0H10.9V8.939H0Z",
            transform: "translate(0 0.534)",
            fill: "none"
        }), (0, $acw62.createElement)("g", {
            clipPath: "url(#clip-path)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.9.711a.715.715,0,0,1-.109.379L6.05,8.608a.71.71,0,0,1-1.2,0L.109,1.089A.712.712,0,0,1,.711,0h9.476A.713.713,0,0,1,10.9.711",
            transform: "translate(0 0.534)",
            fill: r
        })))));
    }, u = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(21 6.5) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(5.251 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,5,7.937,10,0Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, d = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(2.5 6)"
        }, (0, $acw62.createElement)("path", {
            d: "M10.283,8.762H6.217V.734a.717.717,0,1,0-1.435,0V8.762H.717a.714.714,0,0,0-.628.38.748.748,0,0,0,.021.745l4.783,7.77a.708.708,0,0,0,1.215,0l2.975-4.835a.744.744,0,0,0-.224-1.012.709.709,0,0,0-.99.231L5.5,15.887,2.016,10.23h8.267a.734.734,0,0,0,0-1.468",
            transform: "translate(18.5 0.5) rotate(90)",
            fill: r
        }));
    }, k = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(21 6.5) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(5.251 0.75)",
            fill: "none",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e,
            opacity: s
        }), (0, $acw62.createElement)("path", {
            d: "M0,0,5,7.937,10,0Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    }, c = function() {
        return (0, $acw62.createElement)("g", {
            transform: "translate(21 6.5) rotate(90)"
        }, (0, $acw62.createElement)("path", {
            d: "M.5,8.95V0",
            transform: "translate(4.894 0.75)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }), (0, $acw62.createElement)("path", {
            d: "M4.65,7.654C5.906,7.654,9.921,1.29,9.2.568S.892-.223.1.568,3.395,7.654,4.65,7.654Z",
            transform: "translate(0.75 9.7)",
            fill: "none",
            stroke: r,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            strokeWidth: e
        }));
    };
    switch(t.set){
        case "bold":
            return (0, $acw62.createElement)(i, null);
        case "bulk":
            return (0, $acw62.createElement)(l, null);
        case "broken":
            return (0, $acw62.createElement)(d, null);
        case "two-tone":
            return (0, $acw62.createElement)(k, null);
        case "curved":
            return (0, $acw62.createElement)(c, null);
        default:
            return (0, $acw62.createElement)(u, null);
    }
};
$63c37e44f569564f$var$ze.displayName = "IconlyCaretLeft", $63c37e44f569564f$var$ze.propTypes = {
    opacity: $63c37e44f569564f$var$Q.string,
    color: $63c37e44f569564f$var$Q.string,
    secondaryColor: $63c37e44f569564f$var$Q.string,
    set: $63c37e44f569564f$var$Q.string,
    strokeWidth: $63c37e44f569564f$var$Q.oneOfType([
        $63c37e44f569564f$var$Q.string,
        $63c37e44f569564f$var$Q.number
    ])
};
var $63c37e44f569564f$export$9de62fa342934f27 = $63c37e44f569564f$var$st($63c37e44f569564f$var$ze), $63c37e44f569564f$var$Ge = {
    Search: $63c37e44f569564f$export$4b85d3515bd863a5,
    Folder: $63c37e44f569564f$export$80729fed35a16515,
    Wallet: $63c37e44f569564f$export$bcca3ea514774656,
    Graph: $63c37e44f569564f$export$614db49f3febe941,
    Bookmark: $63c37e44f569564f$export$301ef70c5c7bdf65,
    Category: $63c37e44f569564f$export$3a8840c5b2ecf003,
    Home: $63c37e44f569564f$export$b94310965bed44e6,
    Notification: $63c37e44f569564f$export$14834abbfce3b8cd,
    Chat: $63c37e44f569564f$export$d49dffca20dba6f7,
    Heart: $63c37e44f569564f$export$51def8c33e56fa36,
    Heart2: $63c37e44f569564f$export$378339152ed5d642,
    Paper: $63c37e44f569564f$export$e01703dff029898a,
    PaperPlus: $63c37e44f569564f$export$7a3a035e61089aa9,
    PaperNegative: $63c37e44f569564f$export$f496dcd9fa9dd77e,
    PaperFail: $63c37e44f569564f$export$f47919df086bcc4d,
    PaperDownload: $63c37e44f569564f$export$718d642b32ef9a7c,
    PaperUpload: $63c37e44f569564f$export$e9463168469b9532,
    Send: $63c37e44f569564f$export$8689cbce9c2c90e9,
    Password: $63c37e44f569564f$export$5e47cc20a502b05f,
    Swap: $63c37e44f569564f$export$bdb5f0a1b77546f4,
    Work: $63c37e44f569564f$export$66faccf4f494e531,
    Scan: $63c37e44f569564f$export$f2b7c70641756fd4,
    Activity: $63c37e44f569564f$export$9c16c1426311996d,
    Calendar: $63c37e44f569564f$export$e1aef45b828286de,
    Message: $63c37e44f569564f$export$f69c19e57285b83a,
    Video: $63c37e44f569564f$export$ae01dedf5c052bb,
    Plus: $63c37e44f569564f$export$2d9ac7aa84f97a08,
    Chart: $63c37e44f569564f$export$acaa6426d77a227e,
    Game: $63c37e44f569564f$export$985739bfa5723e08,
    Bag: $63c37e44f569564f$export$9570723381ca8f3b,
    Bag2: $63c37e44f569564f$export$c061a17fad15d938,
    TicketStar: $63c37e44f569564f$export$98055a51547a6dad,
    MoreCircle: $63c37e44f569564f$export$ae0f70bfddaf6a56,
    MoreSquare: $63c37e44f569564f$export$75d1c9702603e023,
    Discount: $63c37e44f569564f$export$5f0fddd75cd8dcd7,
    Buy: $63c37e44f569564f$export$4abaa06179fa6649,
    InfoCircle: $63c37e44f569564f$export$6e50c69d980cc044,
    InfoSquare: $63c37e44f569564f$export$92b5cd1177d01936,
    Danger: $63c37e44f569564f$export$95d05bdc75950145,
    CloseSquare: $63c37e44f569564f$export$690403bf78a2c747,
    TickSquare: $63c37e44f569564f$export$2525b0c1ef18f936,
    Discovery: $63c37e44f569564f$export$fc67dfdccdde59ae,
    Location: $63c37e44f569564f$export$18a2be9195644f38,
    Document: $63c37e44f569564f$export$b34a105447964f9f,
    Setting: $63c37e44f569564f$export$805dc0bee9369f09,
    TimeSquare: $63c37e44f569564f$export$4599687b619f9bdc,
    TimeCircle: $63c37e44f569564f$export$81a9b13d3f8e805e,
    VolumeUp: $63c37e44f569564f$export$dd4dac99f7f06e6c,
    VolumeDown: $63c37e44f569564f$export$1a45e6e3385a89f1,
    VolumeOff: $63c37e44f569564f$export$5cd3850cf086982a,
    Star: $63c37e44f569564f$export$1644ba17714857f1,
    Ticket: $63c37e44f569564f$export$ed207b05bbcf0a37,
    Camera: $63c37e44f569564f$export$79f141de891a5fed,
    User: $63c37e44f569564f$export$1f44aaf2ec115b54,
    AddUser: $63c37e44f569564f$export$a2fae8d9b81b1013,
    TwoUsers: $63c37e44f569564f$export$907727a0d23f5455,
    People: $63c37e44f569564f$export$8d3edc4d62e152ad,
    Login: $63c37e44f569564f$export$21a94553ffa41578,
    Logout: $63c37e44f569564f$export$cad1a703886b4e3a,
    Download: $63c37e44f569564f$export$a7aaed3e118dd255,
    Upload: $63c37e44f569564f$export$c58532f0fb5faa97,
    Voice: $63c37e44f569564f$export$6ff815dd9a1e7763,
    Voice2: $63c37e44f569564f$export$19b08aa11ddb3401,
    Delete: $63c37e44f569564f$export$bfadae053a633538,
    Edit: $63c37e44f569564f$export$6ed0965c9443aaa6,
    EditSquare: $63c37e44f569564f$export$59b55e53f81d8d44,
    Play: $63c37e44f569564f$export$480db61f4dcd7727,
    ShieldDone: $63c37e44f569564f$export$f5760a0e054f6f6f,
    ShieldFail: $63c37e44f569564f$export$7a5db7635b30a2d,
    Show: $63c37e44f569564f$export$f6a3d19be20f5819,
    Hide: $63c37e44f569564f$export$bed28288a051538,
    Filter: $63c37e44f569564f$export$ec91da630f36d5ea,
    Filter2: $63c37e44f569564f$export$7943ff505e308b76,
    Image: $63c37e44f569564f$export$3e431a229df88919,
    Image2: $63c37e44f569564f$export$123574b31a344e28,
    Call: $63c37e44f569564f$export$e01e40655568efad,
    Calling: $63c37e44f569564f$export$5deb64e34838263,
    CallMissed: $63c37e44f569564f$export$bf38b58a1a7fd769,
    CallSilent: $63c37e44f569564f$export$5e9dd714d869f41c,
    Lock: $63c37e44f569564f$export$5b9db7ce80343746,
    Unlock: $63c37e44f569564f$export$a818bbe058f189e,
    ChevronDownCircle: $63c37e44f569564f$export$473697e81eb6bba8,
    ChevronRightCircle: $63c37e44f569564f$export$422fa8e55ed6b825,
    ChevronUpCircle: $63c37e44f569564f$export$88ef9e503a31b3bc,
    ChevronLeftCircle: $63c37e44f569564f$export$afaf052a4e71ca4a,
    ChevronDown: $63c37e44f569564f$export$4e3778eb35f54199,
    ChevronRight: $63c37e44f569564f$export$6172d85aadfc9b96,
    ChevronUp: $63c37e44f569564f$export$9b80ee7d1e129684,
    ChevronLeft: $63c37e44f569564f$export$29ab0a58e0457c56,
    ArrowDownSquare: $63c37e44f569564f$export$ed3f7c87e4adf28b,
    ArrowRightSquare: $63c37e44f569564f$export$786fdd61896e8eed,
    ArrowUpSquare: $63c37e44f569564f$export$15064f172111aa33,
    ArrowLeftSquare: $63c37e44f569564f$export$62680667f88800e6,
    ArrowDown: $63c37e44f569564f$export$1fa5a43af950a186,
    ArrowRight: $63c37e44f569564f$export$acad20503ad73ac1,
    ArrowUp: $63c37e44f569564f$export$2624c5890f1bbcf7,
    ArrowLeft: $63c37e44f569564f$export$e4c291d45fea4cd0,
    CaretRight: $63c37e44f569564f$export$98ac0f496a0846de,
    CaretDown: $63c37e44f569564f$export$14643e45770079c3,
    CaretUp: $63c37e44f569564f$export$b67edd7bdacb81b5,
    CaretLeft: $63c37e44f569564f$export$9de62fa342934f27
}, $63c37e44f569564f$export$7dab0c818a02b1cd = function(r) {
    var n = r.className, e = r.primaryColor, o = r.secondaryColor, a = r.strokeWidth, s = r.opacity, i = r.set, l = r.size, u = r.name, d = r.style, k = $63c37e44f569564f$var$X(r, [
        "className",
        "primaryColor",
        "secondaryColor",
        "strokeWidth",
        "opacity",
        "set",
        "size",
        "name",
        "style"
    ]), c = $63c37e44f569564f$var$Ge[u];
    if (!c) throw new Error("Icon '" + u + "' doesn't exists in react-iconly");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(c, $63c37e44f569564f$var$K({
        className: n,
        primaryColor: e,
        secondaryColor: o,
        strokeWidth: a,
        opacity: s,
        set: i,
        size: l,
        style: d
    }, k));
};



function $1fb3f02de1b1ab50$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
        direction: "column",
        css: {
            flex: 1,
            flexWrap: "no-wrap",
            height: "100%",
            padding: "$10"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                    children: props.title
                })
            }),
            props.actions ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1fb3f02de1b1ab50$export$e213cebad6250b4a, {
                actions: props.actions
            }) : null,
            props.children
        ]
    });
}
function $1fb3f02de1b1ab50$export$e213cebad6250b4a(props) {
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    function goBack() {
        navigate(-1);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
        css: {
            padding: "$10 0",
            gap: "$10"
        },
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                css: {
                    flex: 0
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                    auto: true,
                    flat: true,
                    color: "secondary",
                    onClick: goBack,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$e4c291d45fea4cd0), {})
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                css: {
                    flex: "1",
                    alignItems: "center"
                },
                children: props.middle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(props.middle, {}) : null
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                children: props.actions.map((action, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                        auto: true,
                        flat: true,
                        color: action.color,
                        onClick: action.onClick,
                        children: [
                            action.icon,
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                                color: action.color,
                                children: [
                                    "  ",
                                    action.value
                                ]
                            })
                        ]
                    }, `a-${i}`))
            })
        ]
    });
}



const $c80e29f43e2dfdb6$var$Login = (props)=>{
    const authContext = (0, $befcb7e46ce523f6$export$1d39dc5b47e56ff0)();
    const [loginState, updateLoginState] = (0, $acw62.useState)({
        email: "",
        password: ""
    });
    const handleChange = (e)=>{
        updateLoginState({
            ...loginState,
            [e.target.name]: e.target.value
        });
    };
    const handleLogin = (e)=>{
        const { email: email, password: password } = loginState;
        authContext.signin(email, password);
    };
    const handleLog = (e)=>{
        console.log(authContext);
    };
    const handleTest = async (e)=>{
        try {
            const a = await (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("https://api.staging.b1card.it/v1/service/corporations", {
                headers: {
                    "Authorization": `Bearer ${authContext.user.token}`
                }
            });
            console.log(a);
        } catch (error) {
            console.log("errror");
            console.log(error);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fb3f02de1b1ab50$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
            direction: "column",
            justify: "center",
            alignContent: "center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                sm: 6,
                direction: "column",
                css: {
                    marginTop: "200px"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
                        value: loginState.email,
                        name: "email",
                        onChange: handleChange,
                        width: "200px",
                        labelPlaceholder: "email",
                        css: {
                            width: "100%"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
                        value: loginState.password,
                        type: "password",
                        onChange: handleChange,
                        name: "password",
                        width: "200px",
                        css: {
                            mt: 30,
                            width: "100%"
                        },
                        labelPlaceholder: "password"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                        onClick: handleLogin,
                        size: "sm",
                        css: {
                            mt: 30
                        },
                        children: "Login"
                    })
                ]
            })
        })
    });
};
var $c80e29f43e2dfdb6$export$2e2bcd8739ae039 = $c80e29f43e2dfdb6$var$Login;



function $fd5baa1bcf92a6bb$export$3b164a006a884f7() {
    if (window.STAGING === true) return "https://api.staging.b1card.it";
    else return "https://api.b1card.it";
}
function $fd5baa1bcf92a6bb$export$8cca4e1da6b1437(dateRaw) {
    const date = new Date(dateRaw);
    const d = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    const hour = `${date.getHours}`;
    return d;
}
function $fd5baa1bcf92a6bb$export$28d8e40b69192e57(dateRaw) {
    const date = new Date(dateRaw);
    const d = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    const hour = `${date.getHours()}:${date.getMinutes()}`;
    return {
        date: d,
        hour: hour
    };
}
function $fd5baa1bcf92a6bb$export$34ec79c02ad28eae(str) {
    const firstChunk = str.split("-")[0];
    return !isNaN(Number(firstChunk));
}
function $fd5baa1bcf92a6bb$export$25df2e315be8e003(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = ()=>resolve(reader.result);
        reader.onerror = (error)=>reject(error);
    });
}
function $fd5baa1bcf92a6bb$export$cf51a7719174d526(order, val) {
    if (order.sku.toLocaleLowerCase().includes(val)) return true;
    if (order.item_description.toLocaleLowerCase().includes(val)) return true;
    if (order.item_name.toLocaleLowerCase().includes(val)) return true;
    if (order.owner_email?.toLocaleLowerCase().includes(val)) return true;
    return false;
}


const $3189fb41583a85b4$var$base = (0, $fd5baa1bcf92a6bb$export$3b164a006a884f7)();
const $3189fb41583a85b4$export$b5fe3f66a567bec0 = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).create({
    baseURL: $3189fb41583a85b4$var$base + "/v1"
});
const $3189fb41583a85b4$export$1755ac0df8a95d32 = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).create({
    baseURL: $3189fb41583a85b4$var$base + "/v1/service"
});
$3189fb41583a85b4$export$1755ac0df8a95d32.defaults.withCredentials = true;
$3189fb41583a85b4$export$1755ac0df8a95d32.defaults.headers.post["Content-Type"] = "application/json";
$3189fb41583a85b4$export$b5fe3f66a567bec0.defaults.withCredentials = true;
$3189fb41583a85b4$export$b5fe3f66a567bec0.defaults.headers.post["Content-Type"] = "application/json";


const $befcb7e46ce523f6$var$auth = (0, $78783784837c9463$export$7ccc53e8f1e7dfc5)((0, $21244af9bc38e1ad$export$2e2bcd8739ae039));
const $befcb7e46ce523f6$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $befcb7e46ce523f6$export$1d39dc5b47e56ff0() {
    const context = (0, $acw62.useContext)($befcb7e46ce523f6$export$a0fd8390cfe8ae69);
    return context;
}
const $befcb7e46ce523f6$export$87091915187a1a85 = (props)=>{
    const [user, setUser] = (0, $acw62.useState)({
        email: "",
        token: "",
        uid: ""
    });
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [logged, setLogged] = (0, $acw62.useState)(false);
    const value = {
        signin: signin,
        auth: $befcb7e46ce523f6$var$auth,
        user: user,
        loading: loading,
        logged: logged,
        signout: signout
    };
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    async function signin(email, password) {
        setLoading(true);
        await (0, $78783784837c9463$export$ffb5f4729a158638)($befcb7e46ce523f6$var$auth, (0, $78783784837c9463$export$407448d2b89b1813));
        await (0, $78783784837c9463$export$a8550f7dbe79f93a)($befcb7e46ce523f6$var$auth, email, password);
    }
    async function signout() {
        setLoading(true);
        await (0, $78783784837c9463$export$d141bba7fdc215a3)($befcb7e46ce523f6$var$auth);
        setLoading(false);
        setLogged(false);
    }
    (0, $acw62.useEffect)(()=>{
        const unsubscriber = $befcb7e46ce523f6$var$auth.onAuthStateChanged(async (user)=>{
            if (user && user.email) {
                const token = await user.getIdToken();
                setUser({
                    email: user.email,
                    token: token,
                    uid: user.uid
                });
                //IMPOSTANDO HEADERS PER CONFIG
                (0, $3189fb41583a85b4$export$b5fe3f66a567bec0).defaults.headers.common["Authorization"] = `Bearer ${token}`;
                (0, $3189fb41583a85b4$export$1755ac0df8a95d32).defaults.headers.common["Authorization"] = `Bearer ${token}`;
                setLoading(false);
                setLogged(true);
                return;
            } else {
                setLoading(false);
                return;
            //navigate("/login")
            }
        });
        return unsubscriber;
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($befcb7e46ce523f6$export$a0fd8390cfe8ae69.Provider, {
        value: value,
        children: logged ? props.children : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c80e29f43e2dfdb6$export$2e2bcd8739ae039), {})
    });
};




var $acw62 = parcelRequire("acw62");




const $88508dff620183cf$var$createAxiosInstance = (props)=>{
    const { endPoint: endPoint } = props;
    const data = props.data ?? null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).create({
        baseURL: `${(0, $fd5baa1bcf92a6bb$export$3b164a006a884f7)()}/v1/${endPoint}`,
        timeout: 1000,
        headers: {
            ...props.headers
        },
        data: data
    });
};
const $88508dff620183cf$export$2c024e0d8b6b8e4f = async (method, path, token, data)=>{
    const req = $88508dff620183cf$var$createAxiosInstance({
        endPoint: "service",
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    try {
        const result = (await req.request({
            method: method,
            data: data,
            url: path
        })).data;
        return [
            result,
            false
        ];
    } catch (error) {
        return [
            null,
            error
        ];
    }
};
const $88508dff620183cf$export$bff4290234d1ba54 = async (method, path, token, data)=>{
    const req = $88508dff620183cf$var$createAxiosInstance({
        endPoint: "corporations",
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    try {
        const result = (await req.request({
            method: method,
            data: data,
            url: path
        })).data;
        return [
            result,
            false
        ];
    } catch (error) {
        return [
            null,
            error
        ];
    }
};


const $6cdf033bc7603b4e$var$corpContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $6cdf033bc7603b4e$export$78c977097708e32c() {
    const context = (0, $acw62.useContext)($6cdf033bc7603b4e$var$corpContext);
    return context;
}
const $6cdf033bc7603b4e$export$43a1055884b5da6d = (props)=>{
    const auth = (0, $befcb7e46ce523f6$export$1d39dc5b47e56ff0)();
    const token = auth.user.token;
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [selected, setSelected] = (0, $acw62.useState)(false);
    const [corps, setCorps] = (0, $acw62.useState)([]);
    const [currentCorp, setCurrentCorp] = (0, $acw62.useState)(null);
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    async function selectCorp(corp) {
        setCurrentCorp(corp);
        setSelected(true);
        navigate(`/corps/${corp.id}`);
    }
    async function makeReq() {
        const [data, err] = await (0, $88508dff620183cf$export$2c024e0d8b6b8e4f)("GET", "/corporations", token);
        setCorps(data);
    }
    (0, $acw62.useEffect)(()=>{
        if (token) makeReq();
    }, [
        token
    ]);
    const value = {
        loading: loading,
        corps: corps,
        currentCorp: currentCorp,
        selected: selected,
        selectCorp: selectCorp
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6cdf033bc7603b4e$var$corpContext.Provider, {
        value: value,
        children: props.children
    });
};


const $462c5a39e9e16ee8$var$Layout = (props)=>{
    const auth = (0, $befcb7e46ce523f6$export$1d39dc5b47e56ff0)();
    const corp = (0, $6cdf033bc7603b4e$export$78c977097708e32c)();
    const headerHeight = auth.logged ? 50 : 0;
    const contentWidth = auth.logged && corp.selected ? 9 : 12;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
        css: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
            css: {
                height: `100%`
            },
            alignContent: "stretch",
            direction: "row",
            style: {
                padding: 20
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                    css: {
                        height: "100%",
                        width: "200px",
                        marginRight: 20
                    },
                    direction: "column",
                    children: (0, $5af3c10acd1e5147$export$481b2dde3f63f0a1).categories.map((cat, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($462c5a39e9e16ee8$var$SidebarCard, {
                            category: cat,
                            i: i
                        }, `sc-${i}`))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                    css: {
                        flex: 1,
                        height: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                            css: {
                                width: "100%",
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92b7149304f358a3$export$2e2bcd8739ae039), {
                                css: {
                                    height: "100%"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                                    direction: "column",
                                    css: {
                                        height: "100%"
                                    },
                                    children: props.children
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
function $462c5a39e9e16ee8$var$SidebarCard(props) {
    const { category: category } = props;
    const navigator = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    function navigate(item) {
        navigator(item.path);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
        direction: "column",
        gap: 1,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $92b7149304f358a3$export$2e2bcd8739ae039), {
            css: {
                marginBottom: 10
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                        css: {
                            textAlign: "center"
                        },
                        size: "small",
                        children: category.name
                    })
                }),
                category.items.map((item, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                            light: true,
                            size: "sm",
                            color: item.color ?? "default",
                            onPress: ()=>navigate(item),
                            children: item.name
                        }, `btn-${i}-${props.i}`)
                    }))
            ]
        })
    });
}
var $462c5a39e9e16ee8$export$2e2bcd8739ae039 = $462c5a39e9e16ee8$var$Layout;







parcelRequire("acw62");


parcelRequire("acw62");


const $fb5777539258543f$export$f01b3d7c7bbe3997 = ({ children: children })=>{
    const { loading: loading, logged: logged } = (0, $befcb7e46ce523f6$export$1d39dc5b47e56ff0)();
    const { pathname: pathname } = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    if (!logged && pathname != "/login") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
        to: "/login",
        replace: true
    });
    return children;
};




parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $b18592729fe32690$export$2e2bcd8739ae039() {
    const [state, setState] = (0, $acw62.useState)({
        corps: [],
        loading: true
    });
    async function fetchCorps() {
        try {
            const data = (await (0, $3189fb41583a85b4$export$1755ac0df8a95d32).get("/corporations")).data;
            setState((oldState)=>({
                    ...oldState,
                    corps: data,
                    loading: false
                }));
        } catch (err) {
            console.log(error);
            setState((oldState)=>({
                    ...oldState,
                    loading: false
                }));
        }
    }
    function getCorpById(id) {
        return state.corps.find((corp)=>corp.id == id);
    }
    async function createCorp(email, name) {
        try {
            const data = {
                admin_email: email,
                name: name
            };
            const corpData = await (0, $3189fb41583a85b4$export$1755ac0df8a95d32).post("/corporations", data);
            await fetchCorps();
        } catch (err) {
            console.log(err);
            throw new Error(err);
        }
    }
    (0, $acw62.useEffect)(()=>{
        fetchCorps();
    }, []);
    return {
        ...state,
        getCorpById: getCorpById,
        createCorp: createCorp
    };
}



var $acw62 = parcelRequire("acw62");

function $74fb9f12ab30645b$export$2e2bcd8739ae039(props) {
    const [state, setState] = (0, $acw62.useState)({
        orders: [],
        loading: true,
        searchValue: ""
    });
    async function fetchOrders() {
        try {
            const { data: data } = await (0, $3189fb41583a85b4$export$1755ac0df8a95d32).get("/orders/items");
            console.log(data);
            setState((oldState)=>({
                    ...oldState,
                    orders: data,
                    loading: false
                }));
        } catch (error) {
            console.log(error);
            setState((oldState)=>({
                    ...oldState,
                    orders: [],
                    loading: false
                }));
        }
    }
    async function deleteOrder() {}
    function updateSearchValue(val) {
        setState((oldState)=>({
                ...state,
                searchValue: val
            }));
    }
    (0, $acw62.useEffect)(()=>{
        fetchOrders();
    }, []);
    return {
        ...state,
        setOrders: setState,
        deleteOrder: deleteOrder,
        updateSearchValue: updateSearchValue
    };
}



var $acw62 = parcelRequire("acw62");

function $63f0f13c8d553523$export$371e338370561054(email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}


function $5db001663fa2fe66$export$2e2bcd8739ae039(props) {
    const [state, setState] = (0, $acw62.useState)({
        members: [],
        loading: true
    });
    async function fetchMembers() {
        try {
            const { data: data } = await (0, $3189fb41583a85b4$export$1755ac0df8a95d32).get("/members");
            setState((oldState)=>({
                    ...oldState,
                    members: data,
                    loading: false
                }));
        } catch (error) {
            console.log(error);
            setState((oldState)=>({
                    ...oldState,
                    members: [],
                    loading: false
                }));
        }
    }
    async function deleteMember(member) {
        try {
            const { data: data } = await (0, $3189fb41583a85b4$export$1755ac0df8a95d32).delete(`/members/${member.uid}`);
            setState((oldState)=>({
                    ...oldState,
                    members: oldState.members.filter((m)=>m.uid != member.uid)
                }));
        } catch (error) {
            alert("impossibile eliminare utente");
        }
    }
    async function addMember(email) {
        try {
            if (!(0, $63f0f13c8d553523$export$371e338370561054)(email)) throw new Error("invalid email");
            const { data: data } = await (0, $3189fb41583a85b4$export$1755ac0df8a95d32).post("/members/", {
                email: email
            });
            return;
        } catch (error) {
            console.log("ERROOOOR");
            alert(error);
        }
    }
    (0, $acw62.useEffect)(()=>{
        fetchMembers();
    }, []);
    return {
        ...state,
        setMembers: setState,
        deleteMember: deleteMember,
        addMember: addMember
    };
}



var $acw62 = parcelRequire("acw62");

function $e63cd1da8b871d94$export$2e2bcd8739ae039() {
    const [state, setState] = (0, $acw62.useState)({
        unlinkedItems: [],
        loading: true,
        cursor: 0,
        latestId: 0,
        direction: "right",
        idHistory: [
            0
        ],
        cursorEnd: false
    });
    const cursor = state.cursor;
    const limit = 24;
    async function fetchUnlinkedItems() {
        const { idHistory: idHistory, direction: direction } = state;
        const idLength = idHistory.length;
        setState((oldState)=>({
                ...oldState,
                loading: false
            }));
        // state.cursor
        // const latestId = direction === "left" ? idHistory[idLength - 2] : idHistory[idLength - 1]
        let idArray = [
            ...state.idHistory
        ];
        if (state.direction === "left") idArray = idArray.filter((el, i)=>i != cursor - 1);
        console.log(state.direction);
        console.log("history: ", idArray);
        console.log("ID ARRAY", idArray.length);
        const latestId = idArray[cursor] ?? 0;
        try {
            console.log("latest id: ", latestId);
            const { data: data } = await (0, $3189fb41583a85b4$export$1755ac0df8a95d32)(`/unlinked-items?cursor=${latestId ?? 0}&limit=${limit}`);
            const last = data[limit - 1];
            if (idArray.indexOf(last.id) > -1 && idArray.indexOf(last.id) < cursor) idArray = idArray.slice(0, idArray.indexOf(last.id));
            setState((oldState)=>({
                    ...oldState,
                    unlinkedItems: data,
                    idHistory: [
                        ...idArray,
                        last.id
                    ]
                }));
        // const isCursorEnd = data.length < limit
        // let idArray = [...idHistory]
        // if (data.length && data.length === limit) {
        //     if (direction === "left") {
        //         const arr = idHistory.slice(0, cursor)
        //         if (arr.length == 0) arr.push(0)
        //         idArray = arr
        //     }
        //     if (direction === "right") {
        //         const lastElement = data[data.length - 1]
        //         const idArrayIndex = idArray.indexOf(lastElement.id)
        //         idArray.push(lastElement.id)
        //     }
        // }
        // setState(oldState => ({
        //     ...oldState,
        //     unlinkedItems: data,
        //     loading: false,
        //     cursor,
        //     cursorEnd: isCursorEnd,
        //     idHistory: idArray
        // }))
        } catch (err) {
            setState((oldState)=>({
                    ...oldState,
                    loading: false,
                    cursor: cursor
                }));
        }
    }
    function updateCursorPosition(val, direct = null) {
        direct;
        if (val === -1 && cursor === 0) return;
        if (val === -1) setState((oldState)=>({
                ...oldState,
                cursor: oldState.cursor - 1,
                direction: "left"
            }));
        else if (val === 1) setState((oldState)=>({
                ...oldState,
                cursor: oldState.cursor + 1,
                direction: "right"
            }));
    }
    function handlePagination(i) {
        const index = i - 1;
        updateCursorPosition(index > cursor ? 1 : -1);
    }
    (0, $acw62.useEffect)(()=>{
        console.log("cursor", state.cursor);
        fetchUnlinkedItems();
    }, [
        state.cursor
    ]);
    return {
        ...state,
        cursor: cursor,
        methods: {
            handlePagination: handlePagination
        }
    };
}



const $1aae03441633a07a$var$appContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $1aae03441633a07a$export$fca13ab91e1a6240() {
    return (0, $acw62.useContext)($1aae03441633a07a$var$appContext);
}
function $1aae03441633a07a$export$c7dacf3845253dcf(props) {
    const auth = (0, $befcb7e46ce523f6$export$1d39dc5b47e56ff0)();
    const [page, setPage] = (0, $acw62.useState)({
        name: ""
    });
    const { corps: corps, getCorpById: getCorpById, loading: corpsLoading } = (0, $b18592729fe32690$export$2e2bcd8739ae039)();
    const { members: members, loading: loading, setMembers: setMembers, deleteMember: deleteMember, addMember: addMember } = (0, $5db001663fa2fe66$export$2e2bcd8739ae039)();
    const { orders: orders, updateSearchValue: updateSearchValue, searchValue: searchValue } = (0, $74fb9f12ab30645b$export$2e2bcd8739ae039)();
    // const [state, setState] = useState<AppState>({
    //     loading: false,
    //     unlinkedItems: [] as UnlinkedItem[],
    // })
    const { unlinkedItems: unlinkedItems, loading: unlinkedLoading, cursor: cursor, methods: methods, cursorEnd: cursorEnd, idHistory: idHistory } = (0, $e63cd1da8b871d94$export$2e2bcd8739ae039)();
    const pageMethods = {
        setPageTitle: (name)=>setPage((old)=>({
                    ...old,
                    name: name
                }))
    };
    const value = {
        page: page,
        corps: {
            state: {
                loading: corpsLoading,
                corps: corps
            },
            methods: {
                getCorpById: getCorpById
            }
        },
        pageMethods: pageMethods,
        serviceMembers: {
            state: members,
            methods: {
                deleteMember: deleteMember,
                addMember: addMember
            }
        },
        orders: {
            state: orders,
            searchValue: searchValue,
            methods: {
                updateSearchValue: updateSearchValue
            }
        },
        unlinked: {
            state: {
                loading: loading,
                unlinkedItems: unlinkedItems,
                cursor: cursor,
                idHistory: idHistory,
                cursorEnd: cursorEnd
            },
            methods: methods
        }
    };
    async function fetchItems(refresh = false) {
    //const data = await req.get("/unlinked-items")
    // if(!refresh && state.unlinkedItems.length) return
    // const [data,err] = await makeServiceRequest<UnlinkedItem[]>("GET", "/unlinked-items", auth.user.token)
    // console.log(data, err)
    // if(!err) setState(oldState => ({...oldState, unlinkedItems: data}))
    }
    (0, $acw62.useEffect)(()=>{
        fetchItems();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1aae03441633a07a$var$appContext.Provider, {
        value: value,
        children: unlinkedLoading ? "loading app" : props.children
    });
}


function $e8b5695e07ff1ccc$export$2e2bcd8739ae039(props) {
    const { cid: cid } = (0, $926608a7a86d7371$export$99eaa27ddbbb95ef)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const { state: { corps: corps }, methods: { getCorpById: getCorpById } } = (0, $1aae03441633a07a$export$fca13ab91e1a6240)().corps;
    const corp = getCorpById(cid);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fb3f02de1b1ab50$export$2e2bcd8739ae039), {
        title: corp.name,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fb3f02de1b1ab50$export$e213cebad6250b4a), {
            actions: [
                {
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$7a3a035e61089aa9), {}),
                    onClick: ()=>navigate("/corps/nuova"),
                    color: "success"
                }
            ]
        })
    });
}




parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $649ebcdbd7591ac7$var$n = (t)=>{
    const e = document.createElement("div");
    return e.setAttribute("id", t), e;
};
var $649ebcdbd7591ac7$export$2e2bcd8739ae039 = (s = (0, $1025b45907e9388e$export$218c8c3169c024d2)(), u)=>{
    const c = `nextui-${s}`, { isBrowser: i } = (0, $f4aea09d6c1ae125$export$2e2bcd8739ae039)(), [l, m] = (0, $acw62.useState)(i ? $649ebcdbd7591ac7$var$n(c) : null);
    return (0, $acw62.useEffect)(()=>{
        const t = (u ? u() : null) || document.body, e = t.querySelector(`#${c}`), r = e || $649ebcdbd7591ac7$var$n(c);
        e || t.appendChild(r), m(r);
    }, []), l;
};


var $e8d80009c0af0429$export$2e2bcd8739ae039 = (0, $649ebcdbd7591ac7$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $0df3637bce142719$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)(({ children: r, childrenRef: n, className: a, visible: m, enterTime: s, leaveTime: c, clearTime: o, name: u, onExited: T, onEntered: d, ...f })=>{
    const [p, v] = (0, $acw62.useState)(""), [N, $] = (0, $acw62.useState)(m);
    return (0, $acw62.useEffect)(()=>{
        const e = m ? "enter" : "leave", l = m ? s : c;
        m && !N && $(!0), v(`${u}-${e}`);
        const t = setTimeout(()=>{
            v(`${u}-${e} ${u}-${e}-active`), "leave" === e ? null == T || T() : null == d || d(), clearTimeout(t);
        }, l), r = setTimeout(()=>{
            m || (v(""), $(!1)), clearTimeout(r);
        }, l + o);
        return ()=>{
            clearTimeout(t), clearTimeout(r);
        };
    }, [
        m,
        N
    ]), (0, $acw62.useEffect)(()=>{
        if (null == n || !n.current) return;
        const e = p.split(" "), l = n.current.className.split(" ").filter((e)=>!e.includes(u));
        n.current.className = (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)(l, e);
    }, [
        n,
        p
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(r) && N ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(r, {
        ...f,
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)(r.props.className, a, null != n && n.current ? "" : p)
    }) : null;
}, {
    visible: !1,
    enterTime: 60,
    leaveTime: 60,
    clearTime: 60,
    className: "",
    name: "transition"
});




var $acw62 = parcelRequire("acw62");



const $2ec305f941bed65a$export$5d40ed2ff679155d = (0, $07d095cbefc9a288$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "scale(0.95)"
    },
    "40%": {
        transform: "scale(1.02)"
    },
    "80%": {
        transform: "scale(0.98)"
    },
    "100%": {
        transform: "scale(1)"
    }
});
const $2ec305f941bed65a$export$afb3a495443049b8 = (0, $07d095cbefc9a288$export$d25ddfdf17c3ad3e)({
    "0%": {
        opacity: 0,
        transform: "scale(0.95)"
    },
    "60%": {
        opacity: .75,
        transform: "scale(1.02)"
    },
    "100%": {
        opacity: 1,
        transform: "scale(1)"
    }
});
const $2ec305f941bed65a$export$ce4dfa327814c28b = (0, $07d095cbefc9a288$export$d25ddfdf17c3ad3e)({
    "0%": {
        opacity: 1,
        transform: "scale(1)"
    },
    "100%": {
        opacity: 0,
        transform: "scale(0.95)"
    }
});



const $35cecef2c7a950c4$export$1e89c3c0930493b9 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    outline: "none",
    overflow: "hidden",
    width: 0,
    height: 0,
    opacity: 0
});
const $35cecef2c7a950c4$export$bf2130e73c45c48 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("button", {
    position: "absolute",
    background: "transparent",
    border: "none",
    zIndex: "$1",
    top: "$space$3",
    right: "$space$2",
    margin: 0,
    d: "inline-flex",
    ai: "center",
    height: "auto",
    cursor: "pointer",
    boxSizing: "border-box",
    transition: "$default",
    padding: "calc($space$sm * 0.5)",
    color: "$accents4",
    br: "$space$5",
    svg: {
        color: "currentColor"
    },
    "&:hover": {
        svg: {
            opacity: .8
        }
    },
    variants: {
        disabled: {
            true: {
                cursor: "not-allowed"
            }
        }
    }
}, (0, $eaf275b21629a4ec$export$fcece08f39236f43));
const $35cecef2c7a950c4$export$d16d4758aede78d8 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexShrink: 0,
    ai: "center",
    ov: "hidden",
    color: "inherit",
    padding: "$sm $10",
    fs: "$xs",
    variants: {
        noPadding: {
            true: {
                padding: 0
            }
        },
        autoMargin: {
            true: {
                "> *:first-child": {
                    mt: 0
                },
                "> *:last-child": {
                    mb: 0
                }
            }
        }
    }
});
const $35cecef2c7a950c4$export$1333621ab58907ab = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    padding: "$sm $10",
    oy: "auto",
    position: "relative",
    ta: "left",
    variants: {
        noPadding: {
            true: {
                flex: 1,
                padding: 0
            }
        },
        autoMargin: {
            true: {
                "> *:first-child": {
                    mt: 0
                },
                "> *": {
                    mb: "$8"
                },
                "> *:last-child": {
                    mb: 0
                }
            }
        }
    }
});
const $35cecef2c7a950c4$export$466f612e40ab59db = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    d: "flex",
    flexWrap: "wrap",
    flexShrink: 0,
    overflow: "hidden",
    color: "inherit",
    ai: "center",
    fs: "$xs",
    padding: "$sm $lg",
    variants: {
        noPadding: {
            true: {
                padding: 0
            }
        },
        autoMargin: {
            true: {
                "> *": {
                    m: "$2"
                }
            }
        }
    }
});
const $35cecef2c7a950c4$export$8863cf9d79cd26ad = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("section", {
    maxWidth: "100%",
    verticalAlign: "middle",
    overflow: "hidden",
    height: "fit-content(20em)",
    maxHeight: "inherit",
    display: "flex",
    outline: "none",
    flexDirection: "column",
    position: "relative",
    boxSizing: "border-box",
    color: "$foreground",
    br: "$lg",
    boxShadow: "$lg",
    bg: "$backgroundContrast",
    animationFillMode: "forwards",
    "@motion": {
        transition: "none"
    },
    "&.nextui-modal-wrapper-enter:not(.nextui-modal-rendered)": {
        animationName: (0, $2ec305f941bed65a$export$afb3a495443049b8),
        animationDuration: "200ms",
        animationTimingFunction: "ease-in",
        animationDirection: "normal"
    },
    "&.nextui-modal-wrapper-leave": {
        animationName: (0, $2ec305f941bed65a$export$ce4dfa327814c28b),
        animationDuration: "50ms",
        animationTimingFunction: "ease-out"
    },
    variants: {
        fullScreen: {
            true: {
                size: "100%",
                maxHeight: "100%"
            },
            false: {
                "&.nextui-modal-rebound": {
                    animationDuration: "250ms",
                    animationName: (0, $2ec305f941bed65a$export$5d40ed2ff679155d),
                    animationTimingFunction: "ease",
                    animationFillMode: "forwards"
                }
            }
        },
        scroll: {
            true: {
                maxHeight: "calc(100vh - 200px)"
            }
        },
        closeButton: {
            true: {
                paddingTop: "$lg",
                [`& ${$35cecef2c7a950c4$export$bf2130e73c45c48}`]: {
                    svg: {
                        size: "$10"
                    }
                }
            }
        }
    },
    compoundVariants: [
        {
            scroll: !0,
            fullScreen: !0,
            css: {
                maxHeight: "100%"
            }
        }
    ]
});



const $d0c492004baef2c0$var$a = ({ onClick: o, ...a })=>(0, $7b02d682eb115277$exports.jsx)((0, $35cecef2c7a950c4$export$bf2130e73c45c48), {
        type: "button",
        onClick: (t)=>{
            t.preventDefault(), t.stopPropagation(), t.nativeEvent.stopImmediatePropagation(), o && o(t);
        },
        className: "nextui-modal-close-icon",
        "aria-label": "Close",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $aea1449f5da8af64$export$2e2bcd8739ae039), {
            plain: !0,
            size: 18,
            className: "nextui-modal-close-icon-svg",
            fill: "currentColor",
            "aria-hidden": !0
        })
    });
$d0c492004baef2c0$var$a.toString = ()=>".nextui-modal-close-icon";
const $d0c492004baef2c0$var$l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($d0c492004baef2c0$var$a);
var $d0c492004baef2c0$export$2e2bcd8739ae039 = $d0c492004baef2c0$var$l;


const $228cb05fefde7bd1$export$e9e0d96f49f57c33 = {
    Unknown: 0,
    Backspace: 8,
    Tab: 9,
    Enter: 13,
    Shift: 16,
    Ctrl: 17,
    Alt: 18,
    PauseBreak: 19,
    CapsLock: 20,
    Escape: 27,
    Space: 32,
    PageUp: 33,
    PageDown: 34,
    End: 35,
    Home: 36,
    LeftArrow: 37,
    UpArrow: 38,
    RightArrow: 39,
    DownArrow: 40,
    Insert: 45,
    Delete: 46,
    KEY_0: 48,
    KEY_1: 49,
    KEY_2: 50,
    KEY_3: 51,
    KEY_4: 52,
    KEY_5: 53,
    KEY_6: 54,
    KEY_7: 55,
    KEY_8: 56,
    KEY_9: 57,
    KEY_A: 65,
    KEY_B: 66,
    KEY_C: 67,
    KEY_D: 68,
    KEY_E: 69,
    KEY_F: 70,
    KEY_G: 71,
    KEY_H: 72,
    KEY_I: 73,
    KEY_J: 74,
    KEY_K: 75,
    KEY_L: 76,
    KEY_M: 77,
    KEY_N: 78,
    KEY_O: 79,
    KEY_P: 80,
    KEY_Q: 81,
    KEY_R: 82,
    KEY_S: 83,
    KEY_T: 84,
    KEY_U: 85,
    KEY_V: 86,
    KEY_W: 87,
    KEY_X: 88,
    KEY_Y: 89,
    KEY_Z: 90,
    Meta: 91,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    NumLock: 144,
    ScrollLock: 145,
    Equal: 187,
    Minus: 189,
    Backquote: 192,
    Backslash: 220
};
const $228cb05fefde7bd1$export$99d9bd61fa1bcb7a = {
    CtrlCmd: 2048,
    Shift: 1024,
    Alt: 512,
    WinCtrl: 256
};





const $02a8a7443def9dcd$var$x = "nextui-modal", $02a8a7443def9dcd$var$h = ({ className: e, children: l, visible: h, fullScreen: $, closeButton: T, rebound: v, animated: j, onCloseButtonClick: w, scroll: y, ...N })=>{
    const k = (0, $acw62.useRef)(null), C = (0, $acw62.useRef)(null), g = (0, $acw62.useRef)(null), [B, I] = (0, $acw62.useState)(!1);
    (0, $acw62.useEffect)(()=>{
        const e = setTimeout(()=>{
            I(!0), clearTimeout(e);
        }, 300);
        return ()=>clearTimeout(e);
    }, []), (0, $acw62.useEffect)(()=>{
        if (!h) return;
        const e = document.activeElement;
        (0, $1025b45907e9388e$export$1838f3a1c86ecfd4)(k.current, e) || C.current && C.current.focus();
    }, [
        h
    ]);
    const S = (e)=>{
        const r = e.keyCode === (0, $228cb05fefde7bd1$export$e9e0d96f49f57c33).Tab;
        if (!h || !r) return;
        const t = document.activeElement;
        e.shiftKey ? t === C.current && g.current && g.current.focus() : t === g.current && C.current && C.current.focus();
    }, E = ()=>{
        w && w();
    }, K = (0, $acw62.useMemo)(()=>h ? "open" : "closed", [
        h
    ]), D = (0, $acw62.useMemo)(()=>(0, $7b02d682eb115277$exports.jsxs)((0, $35cecef2c7a950c4$export$8863cf9d79cd26ad), {
            role: "dialog",
            tabIndex: -1,
            "aria-modal": h,
            ref: k,
            "data-state": K,
            fullScreen: $,
            scroll: y,
            closeButton: T,
            className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)($02a8a7443def9dcd$var$x, `${$02a8a7443def9dcd$var$x}--${K}`, {
                [`${$02a8a7443def9dcd$var$x}-fullscreen`]: $,
                [`${$02a8a7443def9dcd$var$x}-with-close-button`]: T,
                [`${$02a8a7443def9dcd$var$x}-rebound`]: v,
                [`${$02a8a7443def9dcd$var$x}-rendered`]: B
            }, e),
            ...N,
            onKeyDown: S,
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $35cecef2c7a950c4$export$1e89c3c0930493b9), {
                    role: "button",
                    tabIndex: 0,
                    className: `${$02a8a7443def9dcd$var$x}-hide-tab`,
                    "aria-hidden": "true",
                    ref: C
                }),
                T && (0, $7b02d682eb115277$exports.jsx)((0, $d0c492004baef2c0$export$2e2bcd8739ae039), {
                    onClick: E
                }),
                l,
                (0, $7b02d682eb115277$exports.jsx)((0, $35cecef2c7a950c4$export$1e89c3c0930493b9), {
                    role: "button",
                    tabIndex: 0,
                    className: `${$02a8a7443def9dcd$var$x}-hide-tab`,
                    "aria-hidden": "true",
                    ref: g
                })
            ]
        }), [
        v,
        l
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: j ? (0, $7b02d682eb115277$exports.jsx)((0, $0df3637bce142719$export$2e2bcd8739ae039), {
            name: `${$02a8a7443def9dcd$var$x}-wrapper`,
            visible: h,
            enterTime: 20,
            leaveTime: 20,
            clearTime: 300,
            children: D
        }) : h ? D : null
    });
};
$02a8a7443def9dcd$var$h.toString = ()=>".nextui-modal-wrapper";
var $02a8a7443def9dcd$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($02a8a7443def9dcd$var$h, {
    className: "",
    visible: !1,
    rebound: !1
});



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



const $4229e0c260f1fdec$export$db71fed57cf755af = ()=>({
        CtrlCmd: (0, $1025b45907e9388e$export$9ac100e40613ea10)() ? "metaKey" : "ctrlKey",
        WinCtrl: (0, $1025b45907e9388e$export$9ac100e40613ea10)() ? "ctrlKey" : "metaKey"
    });
const $4229e0c260f1fdec$export$53fbbdfe3b43a783 = (r)=>{
    const e = r.filter((r)=>!!(0, $611d0ac831719832$export$38eb86f225c9e34c)((0, $228cb05fefde7bd1$export$99d9bd61fa1bcb7a), r)), l = {
        CtrlCmd: !1,
        Shift: !1,
        Alt: !1,
        WinCtrl: !1
    };
    return e.forEach((r)=>{
        const e = (0, $611d0ac831719832$export$38eb86f225c9e34c)((0, $228cb05fefde7bd1$export$99d9bd61fa1bcb7a), r);
        l[e] = !0;
    }), l;
};



var $154b9fb181849825$export$2e2bcd8739ae039 = (p, s, i = {})=>{
    const a = Array.isArray(s) ? s : [
        s
    ], { disableGlobalEvent: y = !1, capture: l = !1, stopPropagation: d = !1, preventDefault: u = !1, event: m = "keydown" } = i, f = (0, $4229e0c260f1fdec$export$53fbbdfe3b43a783)(a), C = a.filter((t)=>!(0, $611d0ac831719832$export$38eb86f225c9e34c)((0, $228cb05fefde7bd1$export$99d9bd61fa1bcb7a), t)), { CtrlCmd: c, WinCtrl: k } = (0, $4229e0c260f1fdec$export$db71fed57cf755af)(), K = (e)=>{
        f.Shift && !e.shiftKey || f.Alt && !e.altKey || f.CtrlCmd && !e[c] || f.WinCtrl && !e[k] || C.length > 0 && !C.includes(e.keyCode) || (d && e.stopPropagation(), u && e.preventDefault(), p && p(e));
    };
    (0, $acw62.useEffect)(()=>(y || document.addEventListener(m, K), ()=>{
            document.removeEventListener(m, K);
        }), [
        y
    ]);
    const v = (e, t = !1)=>e !== m || t !== l ? ()=>{} : (e)=>K(e);
    return {
        bindings: {
            onKeyDown: v("keydown"),
            onKeyDownCapture: v("keydown", !0),
            onKeyPress: v("keypress"),
            onKeyPressCapture: v("keypress", !0),
            onKeyUp: v("keyup"),
            onKeyUpCapture: v("keyup", !0)
        }
    };
};



var $16fc602777d9433e$export$2e2bcd8739ae039 = (0, $154b9fb181849825$export$2e2bcd8739ae039);



const $f65db7524447969c$var$a = (0, $07d095cbefc9a288$export$d25ddfdf17c3ad3e)({
    "0%": {
        opacity: 0
    },
    "60%": {
        opacity: .75
    },
    "100%": {
        opacity: 1
    }
});
const $f65db7524447969c$export$c18c4da68ec90881 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    position: "relative",
    display: "inline-block",
    zIndex: "$max",
    outline: "none",
    width: "100%",
    margin: "$9 auto",
    verticalAlign: "middle",
    "@sm": {
        width: "90%",
        maxWidth: "90%"
    },
    variants: {
        animated: {
            true: {
                "&": {
                    animationName: $f65db7524447969c$var$a,
                    animationDuration: "200ms",
                    animationTimingFunction: "ease-in",
                    animationDirection: "normal"
                }
            },
            false: {
                transition: "none"
            }
        }
    }
});
const $f65db7524447969c$export$b383d22f0510bfa0 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    size: "100%",
    pe: "none",
    zIndex: "$max",
    "@motion": {
        transition: "none"
    },
    variants: {
        blur: {
            true: {
                bg: "$black",
                opacity: "$$backdropOpacity",
                transition: "opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                "@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none))": {
                    opacity: 1,
                    transition: "background 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                    backdropFilter: "saturate(180%) blur(20px)",
                    bg: "rgba(0, 0, 0, 0.1)"
                }
            },
            false: {
                bg: "$black",
                opacity: "$$backdropOpacity",
                transition: "opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1)"
            }
        },
        animated: {
            false: {
                transition: "none"
            }
        }
    }
});
const $f65db7524447969c$export$c407ef1eeb73b2e6 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "auto",
    zIndex: "$max",
    WebkitOverflowScrolling: "touch",
    boxSizing: "border-box",
    textAlign: "center",
    "&:before": {
        content: "",
        display: "inline-block",
        width: 0,
        height: "100%",
        verticalAlign: "middle"
    },
    ".nextui-backdrop-wrapper-enter .nextui-backdrop-layer-default": {
        opacity: 0
    },
    ".nextui-backdrop-wrapper-enter-active .nextui-backdrop-layer-default": {
        opacity: "$$backdropOpacity"
    },
    ".nextui-backdrop-wrapper-leave .nextui-backdrop-layer-default": {
        opacity: "$$backdropOpacity"
    },
    ".nextui-backdrop-wrapper-leave-active .nextui-backdrop-layer-default": {
        opacity: 0
    },
    ".nextui-backdrop-wrapper-enter .nextui-backdrop-layer-blur": {
        bg: "rgba(0, 0, 0, 0.1)"
    },
    ".nextui-backdrop-wrapper-enter-active .nextui-backdrop-layer-blur": {
        bg: "rgba(0, 0, 0, 0.4)"
    },
    ".nextui-backdrop-wrapper-leave .nextui-backdrop-layer-blur": {
        bg: "rgba(0, 0, 0, 0.4)"
    },
    ".nextui-backdrop-wrapper-leave-active .nextui-backdrop-layer-blur": {
        bg: "rgba(0, 0, 0, 0.1)"
    },
    variants: {
        fullScreen: {
            true: {
                display: "inline-flex",
                overflow: "hidden",
                [`& ${$f65db7524447969c$export$c18c4da68ec90881}`]: {
                    width: "100vw",
                    maxWidth: "100vw",
                    height: "100vh",
                    margin: 0
                },
                [`& ${$f65db7524447969c$export$b383d22f0510bfa0}`]: {
                    display: "none"
                }
            }
        }
    },
    defaultVariants: {
        fullScreen: !1
    }
});




const $8140cee568d7ee44$var$x = "nextui-backdrop", $8140cee568d7ee44$var$k = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ children: e, onClick: a, onKeyPress: u, visible: k, maxWidth: y, blur: h, animated: $, opacity: v, preventDefault: N, className: j, css: T, ...g })=>{
    const [, C, D] = (0, $a5e1d70388331739$export$2e2bcd8739ae039)(!1), w = (e)=>{
        D.current || a && a(e);
    }, E = (0, $acw62.useCallback)((e)=>{
        e.stopPropagation();
    }, []), I = ()=>{
        if (!D.current) return;
        const e = setTimeout(()=>{
            C(!1), clearTimeout(e);
        }, 0);
    }, { bindings: M } = (0, $16fc602777d9433e$export$2e2bcd8739ae039)((e)=>{
        u && u(e);
    }, [
        (0, $228cb05fefde7bd1$export$e9e0d96f49f57c33).Escape,
        (0, $228cb05fefde7bd1$export$e9e0d96f49f57c33).Space
    ], {
        disableGlobalEvent: !0,
        preventDefault: N
    }), P = (0, $acw62.useMemo)(()=>k ? "open" : "closed", [
        k
    ]), S = (0, $acw62.useMemo)(()=>(0, $7b02d682eb115277$exports.jsxs)((0, $f65db7524447969c$export$c407ef1eeb73b2e6), {
            tabIndex: -1,
            role: "button",
            "aria-hidden": !0,
            "data-state": P,
            onClick: w,
            onMouseUp: I,
            css: {
                $$backdropOpacity: v,
                ...T
            },
            className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)($8140cee568d7ee44$var$x, `${$8140cee568d7ee44$var$x}--${P}`, j),
            ...M,
            ...g,
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $f65db7524447969c$export$b383d22f0510bfa0), {
                    className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)(`${$8140cee568d7ee44$var$x}-layer`, h ? `${$8140cee568d7ee44$var$x}-layer-blur` : `${$8140cee568d7ee44$var$x}-layer-default`),
                    animated: $,
                    blur: h
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $f65db7524447969c$export$c18c4da68ec90881), {
                    animated: $,
                    className: `${$8140cee568d7ee44$var$x}-content`,
                    onClick: E,
                    css: {
                        maxWidth: y
                    },
                    onMouseDown: ()=>C(!0),
                    children: e
                })
            ]
        }), [
        e
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: $ ? (0, $7b02d682eb115277$exports.jsx)((0, $0df3637bce142719$export$2e2bcd8739ae039), {
            name: `${$8140cee568d7ee44$var$x}-wrapper`,
            visible: k,
            enterTime: 20,
            leaveTime: 20,
            clearTime: 150,
            children: S
        }) : k ? S : null
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($8140cee568d7ee44$var$k.displayName = "NextUI.Backdrop"), $8140cee568d7ee44$var$k.toString = ()=>".nextui-backdrop";
var $8140cee568d7ee44$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($8140cee568d7ee44$var$k, {
    onClick: ()=>{},
    visible: !1,
    blur: !1,
    animated: !0,
    preventDefault: !0,
    opacity: .5,
    className: ""
});



var $5350242a1fd144ea$export$2e2bcd8739ae039 = (0, $8140cee568d7ee44$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
const $d796d7c40f3b607b$var$o = {};
const $d796d7c40f3b607b$export$ab57792b9b6974a6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($d796d7c40f3b607b$var$o);
const $d796d7c40f3b607b$export$4cc1699d46f42cae = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($d796d7c40f3b607b$export$ab57792b9b6974a6);



var $acw62 = parcelRequire("acw62");
const $9eb1640becfad7d9$var$n = {
    scrollLayer: !1
}, $9eb1640becfad7d9$var$o = new Map, $9eb1640becfad7d9$var$u = (e)=>!!(e.touches && e.touches.length > 1) || (e.preventDefault(), !1);
var $9eb1640becfad7d9$export$2e2bcd8739ae039 = (c, s)=>{
    if ("undefined" == typeof document) return [
        !1,
        (e)=>e
    ];
    const d = c || (0, $acw62.useRef)(document.body), [i, a] = (0, $acw62.useState)(!1), l = {
        ...$9eb1640becfad7d9$var$n,
        ...s || {}
    }, f = ()=>!l.scrollLayer && !("undefined" == typeof window || !window.navigator) && /iP(ad|hone|od)/.test(window.navigator.platform);
    return (0, $acw62.useEffect)(()=>{
        if (!d || !d.current) return;
        const e = d.current.style.overflow;
        if (i) {
            if ($9eb1640becfad7d9$var$o.has(d.current)) return;
            return f() ? document.addEventListener("touchmove", $9eb1640becfad7d9$var$u, {
                passive: !1
            }) : d.current.style.overflow = "hidden", void $9eb1640becfad7d9$var$o.set(d.current, {
                last: e
            });
        }
        if ($9eb1640becfad7d9$var$o.has(d.current)) {
            if (f()) document.removeEventListener("touchmove", $9eb1640becfad7d9$var$u);
            else {
                const e = $9eb1640becfad7d9$var$o.get(d.current);
                d.current.style.overflow = e.last;
            }
            $9eb1640becfad7d9$var$o.delete(d.current);
        }
    }, [
        i,
        d
    ]), [
        i,
        a
    ];
};


var $a2509c6353536cdb$export$2e2bcd8739ae039 = (0, $9eb1640becfad7d9$export$2e2bcd8739ae039);






const $184a6dd52fff9136$var$b = ({ children: e, onClose: p, onOpen: b, open: v, autoMargin: x, width: g, className: h, preventClose: C, blur: N, animated: P, fullScreen: S, noPadding: k, ...y })=>{
    const w = (0, $e8d80009c0af0429$export$2e2bcd8739ae039)("modal"), [, M] = (0, $a2509c6353536cdb$export$2e2bcd8739ae039)(null, {
        scrollLayer: !0
    }), [j, B, E] = (0, $a5e1d70388331739$export$2e2bcd8739ae039)(!1), [T, D] = (0, $acw62.useState)(!1), G = ()=>{
        p && p(), B(!1), M(!1);
    };
    (0, $acw62.useEffect)(()=>{
        void 0 !== v && (v && b && b(), !v && E.current && p && p(), B(v), M(v));
    }, [
        v
    ]);
    const I = ()=>{
        D(!0);
        const e = setTimeout(()=>{
            D(!1), clearTimeout(e);
        }, 300);
    }, { bindings: L } = (0, $16fc602777d9433e$export$2e2bcd8739ae039)(()=>{
        C ? I() : G();
    }, (0, $228cb05fefde7bd1$export$e9e0d96f49f57c33).Escape, {
        disableGlobalEvent: !0,
        preventDefault: !0
    }), O = (0, $acw62.useMemo)(()=>({
            close: G,
            autoMargin: x,
            noPadding: k
        }), []);
    return w ? (0, $11492dca620dcaa5$exports.createPortal)((0, $7b02d682eb115277$exports.jsx)((0, $d796d7c40f3b607b$export$ab57792b9b6974a6).Provider, {
        value: O,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $5350242a1fd144ea$export$2e2bcd8739ae039), {
            onClick: ()=>{
                C ? I() : G();
            },
            visible: j,
            maxWidth: g,
            fullScreen: S,
            blur: N,
            animated: P,
            ...L,
            children: (0, $7b02d682eb115277$exports.jsx)((0, $02a8a7443def9dcd$export$2e2bcd8739ae039), {
                visible: j,
                onCloseButtonClick: G,
                className: h,
                fullScreen: S,
                rebound: T,
                animated: P,
                ...y,
                children: e
            })
        })
    }), w) : null;
};
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($184a6dd52fff9136$var$b.displayName = "NextUI.Modal"), $184a6dd52fff9136$var$b.toString = ()=>".nextui-modal", $184a6dd52fff9136$var$b.defaultProps = {
    width: "400px",
    className: "",
    preventClose: !1,
    fullScreen: !1,
    closeButton: !1,
    animated: !0,
    blur: !1,
    scroll: !1,
    noPadding: !1
};
var $184a6dd52fff9136$export$2e2bcd8739ae039 = $184a6dd52fff9136$var$b;



var $acw62 = parcelRequire("acw62");





const $b7e481a2f443589f$var$m = "nextui-modal-header", $b7e481a2f443589f$var$d = ({ children: t, className: r, justify: d, autoMargin: u, css: c, ...l })=>{
    const { autoMargin: f, noPadding: g } = (0, $acw62.useContext)((0, $d796d7c40f3b607b$export$ab57792b9b6974a6)), p = (0, $acw62.useMemo)(()=>void 0 !== f ? f : u, [
        u,
        f
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $35cecef2c7a950c4$export$d16d4758aede78d8), {
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)($b7e481a2f443589f$var$m, {
            [`${$b7e481a2f443589f$var$m}-auto-margin`]: p,
            [`${$b7e481a2f443589f$var$m}-no-padding`]: g
        }, r),
        noPadding: g,
        autoMargin: p,
        css: {
            justifyContent: d,
            ...c
        },
        ...l,
        children: t
    });
};
$b7e481a2f443589f$var$d.toString = ()=>".nextui-modal-header";
const $b7e481a2f443589f$var$u = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($b7e481a2f443589f$var$d);
var $b7e481a2f443589f$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($b7e481a2f443589f$var$u, {
    className: "",
    justify: "center",
    autoMargin: !0
});



var $acw62 = parcelRequire("acw62");





const $d13d0142b5d54cfd$var$d = "nextui-modal-body", $d13d0142b5d54cfd$var$e = ({ className: o, children: r, autoMargin: e, ...l })=>{
    const { autoMargin: u, noPadding: c } = (0, $acw62.useContext)((0, $d796d7c40f3b607b$export$ab57792b9b6974a6)), g = (0, $acw62.useMemo)(()=>void 0 !== u ? u : e, [
        e,
        u
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $35cecef2c7a950c4$export$1333621ab58907ab), {
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)($d13d0142b5d54cfd$var$d, {
            [`${$d13d0142b5d54cfd$var$d}-auto-margin`]: g,
            [`${$d13d0142b5d54cfd$var$d}-no-padding`]: c
        }, o),
        autoMargin: g,
        noPadding: c,
        ...l,
        children: r
    });
};
$d13d0142b5d54cfd$var$e.toString = ()=>".nextui-modal-body";
const $d13d0142b5d54cfd$var$l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($d13d0142b5d54cfd$var$e);
var $d13d0142b5d54cfd$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($d13d0142b5d54cfd$var$l, {
    className: "",
    autoMargin: !0
});



var $acw62 = parcelRequire("acw62");





const $34e771f64de6b98f$var$e = "nextui-modal-footer", $34e771f64de6b98f$var$d = ({ children: t, className: r, justify: d, autoMargin: l, css: u, ...c })=>{
    const { autoMargin: f, noPadding: g } = (0, $acw62.useContext)((0, $d796d7c40f3b607b$export$ab57792b9b6974a6)), p = (0, $acw62.useMemo)(()=>void 0 !== f ? f : l, [
        l,
        f
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $35cecef2c7a950c4$export$466f612e40ab59db), {
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)($34e771f64de6b98f$var$e, {
            [`${$34e771f64de6b98f$var$e}-auto-margin`]: p,
            [`${$34e771f64de6b98f$var$e}-no-padding`]: g
        }, r),
        noPadding: g,
        autoMargin: p,
        css: {
            justifyContent: d,
            ...u
        },
        ...c,
        children: t
    });
};
$34e771f64de6b98f$var$d.toString = ()=>".nextui-modal-footer";
const $34e771f64de6b98f$var$l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($34e771f64de6b98f$var$d);
var $34e771f64de6b98f$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($34e771f64de6b98f$var$l, {
    className: "",
    justify: "flex-end",
    autoMargin: !0
});



(0, $184a6dd52fff9136$export$2e2bcd8739ae039).Header = (0, $b7e481a2f443589f$export$2e2bcd8739ae039), (0, $184a6dd52fff9136$export$2e2bcd8739ae039).Body = (0, $d13d0142b5d54cfd$export$2e2bcd8739ae039), (0, $184a6dd52fff9136$export$2e2bcd8739ae039).Footer = (0, $34e771f64de6b98f$export$2e2bcd8739ae039);
var $bdb6eab2badaf8ed$export$2e2bcd8739ae039 = (0, $184a6dd52fff9136$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
const $afeee6e786e91a5d$var$modalContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $afeee6e786e91a5d$export$33ffd74ebf07f060() {
    return (0, $acw62.useContext)($afeee6e786e91a5d$var$modalContext);
}
function $afeee6e786e91a5d$export$178405afcd8c5eb(props) {
    const [visible, setVisible] = (0, $acw62.useState)(false);
    const [options, setOptions] = (0, $acw62.useState)({
        title: "",
        body: "",
        onConfirm: undefined,
        onCancel: undefined,
        hideActions: false
    });
    const modalBody = (0, $acw62.useRef)();
    function toggleModal(val) {
        setVisible((oldState)=>{
            const state = val != undefined ? val : !oldState;
            if (!state) modalBody.current = null;
            console.log(state, val);
            return state;
        });
    }
    function showModal(title, body, onConfirm, onCancel, hideActions = false) {
        setVisible(true);
        setOptions({
            title: title,
            body: body,
            onCancel: onCancel,
            onConfirm: onConfirm,
            hideActions: hideActions
        });
    }
    function newModal(modalData) {
        const { title: title, body: body, onCancel: onCancel, onConfirm: onConfirm, hideActions: hideActions } = modalData;
        setVisible(true);
        modalBody.current = body;
        setOptions({
            title: title,
            body: "",
            onCancel: onCancel || null,
            onConfirm: onConfirm || null,
            hideActions: hideActions ?? false
        });
    }
    const value = {
        state: {
            visible: visible
        },
        showModal: showModal,
        toggleModal: toggleModal,
        newModal: newModal
    };
    (0, $acw62.useEffect)(()=>{}, [
        visible
    ]);
    const ModalBody = modalBody.current ? ()=>modalBody.current : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($afeee6e786e91a5d$var$modalContext.Provider, {
        value: value,
        children: [
            visible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bdb6eab2badaf8ed$export$2e2bcd8739ae039), {
                open: visible,
                onClose: toggleModal,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdb6eab2badaf8ed$export$2e2bcd8739ae039).Header, {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                            size: 18,
                            children: options.title
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdb6eab2badaf8ed$export$2e2bcd8739ae039).Body, {
                        children: ModalBody != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ModalBody, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                            children: options.body
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdb6eab2badaf8ed$export$2e2bcd8739ae039).Footer, {
                        justify: "center",
                        children: options.hideActions ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                !!options.onCancel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    auto: true,
                                    light: true,
                                    color: "error",
                                    onClick: options.onCancel,
                                    children: "Chiudi"
                                }),
                                !!options.onConfirm && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    auto: true,
                                    ghost: true,
                                    color: "success",
                                    onClick: options.onConfirm,
                                    children: "Conferma"
                                })
                            ]
                        })
                    })
                ]
            }) : null,
            props.children
        ]
    });
}



function $af5407a329b2ef92$export$2e2bcd8739ae039() {
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const { selectCorp: selectCorp } = (0, $6cdf033bc7603b4e$export$78c977097708e32c)();
    const appState = (0, $1aae03441633a07a$export$fca13ab91e1a6240)();
    const { corps: corps } = appState.corps.state;
    console.log(corps);
    const cardHeight = 150;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1fb3f02de1b1ab50$export$2e2bcd8739ae039), {
        title: "Seleziona una corporazione",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fb3f02de1b1ab50$export$e213cebad6250b4a), {
                actions: [
                    {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$7a3a035e61089aa9), {}),
                        onClick: ()=>navigate("/corps/nuova"),
                        color: "success"
                    }
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                css: {
                    gap: "$5",
                    padding: "$5",
                    height: "100%",
                    overflowY: "auto"
                },
                children: corps.map((corp)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($af5407a329b2ef92$var$CardComponent, {
                        corp: corp
                    }, corp.id))
            })
        ]
    });
}
function $af5407a329b2ef92$var$CardComponent(props) {
    const { newModal: newModal, toggleModal: toggleModal } = (0, $afeee6e786e91a5d$export$33ffd74ebf07f060)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    function showItemModal() {
        navigate(`/corps/${props.corp.id}`);
    }
    async function deleteItem() {}
    function showDeleteModal() {
        newModal({
            title: `Conferma eliminazione card `,
            body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: "Eliminare Item?"
            }),
            onConfirm: deleteItem,
            onCancel: toggleModal
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $92b7149304f358a3$export$2e2bcd8739ae039), {
        variant: "flat",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $92b7149304f358a3$export$2e2bcd8739ae039).Header, {
                children: [
                    "Corp ID ",
                    props.corp.id
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92b7149304f358a3$export$2e2bcd8739ae039).Body, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                    direction: "row",
                    justify: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                            css: {
                                flex: "1 0"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                    children: props.corp.name
                                }),
                                " | ",
                                props.corp.description
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                            css: {
                                gap: "$5",
                                flex: "0 1",
                                flexWrap: "no-wrap"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    auto: true,
                                    light: true,
                                    color: "success",
                                    css: {
                                        gap: "$5",
                                        padding: 0
                                    },
                                    onClick: showItemModal,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$f6a3d19be20f5819), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    auto: true,
                                    light: true,
                                    color: "error",
                                    onClick: showDeleteModal,
                                    css: {
                                        gap: "$5",
                                        padding: 0
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$bfadae053a633538), {})
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");




function $5a7b0cb687e19b33$export$2e2bcd8739ae039() {
    const { createCorp: createCorp } = (0, $b18592729fe32690$export$2e2bcd8739ae039)();
    const { newModal: newModal } = (0, $afeee6e786e91a5d$export$33ffd74ebf07f060)();
    const [state, setState] = (0, $acw62.useState)({
        email: "",
        name: "",
        loading: false
    });
    function handleInputChange(e) {
        setState((oldState)=>({
                ...oldState,
                [e.target.name]: e.target.value
            }));
    }
    async function submit() {
        setState((oldState)=>({
                ...oldState,
                loading: true
            }));
        try {
            const data = await createCorp(state.email, state.name);
            newModal({
                title: "",
                body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                    h4: true,
                    children: "Corp creata con successo"
                }),
                hideActions: true
            });
            setState((oldState)=>({
                    ...oldState,
                    loading: false,
                    email: "",
                    name: ""
                }));
        } catch (err) {
            newModal({
                title: "",
                body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                    h4: true,
                    children: "Impossibile creare Corp"
                }),
                hideActions: true
            });
            setState((oldState)=>({
                    ...oldState,
                    loading: false
                }));
        }
    }
    const isDisabled = !((0, $63f0f13c8d553523$export$371e338370561054)(state.email) && state.name.length > 3) || state.loading;
    console.log(state.loading);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1fb3f02de1b1ab50$export$2e2bcd8739ae039), {
        title: "Nuova Corporazione",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fb3f02de1b1ab50$export$e213cebad6250b4a), {
                actions: []
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                direction: "column",
                css: {
                    height: "100%",
                    overflowY: "auto",
                    maxWidth: 500,
                    gap: "$10",
                    margin: "auto"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
                        value: state.email,
                        name: "email",
                        onChange: handleInputChange,
                        label: "Email Amministratore Corp"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
                        value: state.name,
                        name: "name",
                        onChange: handleInputChange,
                        label: "Corp name"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                        onPress: submit,
                        color: "success",
                        flat: true,
                        css: {
                            marginTop: "$10"
                        },
                        disabled: isDisabled,
                        children: "Crea Corp"
                    })
                ]
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");
function $d3db85e39e1ba4d0$export$2e2bcd8739ae039(props) {
    const { elements: elements } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
        direction: "column",
        css: {
            gap: "$5",
            padding: "$5",
            overflowY: "auto",
            height: "100%",
            flexWrap: "no-wrap"
        },
        children: elements.map((el, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d3db85e39e1ba4d0$var$ListElement, {
                ...el
            }))
    });
}
// function ListElement(props:IListElement){
//     return (
//         <Card shadow={false} bordered>
//             <Grid.Container direction="row" wrap="nowrap">
//                 <Grid.Container direction="column" css={{flexGrow: 1, justifyContent:"center"}}>
//                     <Grid>
//                         {props.label}
//                     </Grid>
//                     <Grid>
//                         {props.value}
//                     </Grid>
//                 </Grid.Container>
//                 <Grid.Container css={{flex: 0, alignItems: "center", flexWrap:"noWrap"}}>
//                     {props.actions.map(action => (
//                         <Button auto key={`${action.value}`} light color={action.color} onClick={() => action.onClick(props.data)} css={{gap: "$5"}}>
//                             {action.icon} <Text color={action.color}>  {action.value}</Text>
//                         </Button>
//                     ))}
//                 </Grid.Container>
//             </Grid.Container>
//         </Card>
//     )
// }
function $d3db85e39e1ba4d0$var$ListElement(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $92b7149304f358a3$export$2e2bcd8739ae039), {
        variant: "flat",
        css: {
            flexShrink: 0
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92b7149304f358a3$export$2e2bcd8739ae039).Header, {
                children: props.label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92b7149304f358a3$export$2e2bcd8739ae039).Body, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                    direction: "row",
                    justify: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                            css: {
                                flex: "1 0"
                            },
                            children: props.value
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                            css: {
                                gap: "$5",
                                flex: "0 1",
                                flexWrap: "no-wrap"
                            },
                            children: props.actions.map((action, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    auto: true,
                                    light: true,
                                    color: action.color,
                                    css: {
                                        gap: "$5",
                                        padding: "0"
                                    },
                                    onClick: ()=>action.onClick(props.data),
                                    children: action.icon
                                }, `list-${i}`))
                        })
                    ]
                })
            })
        ]
    });
}





function $105f993f66d4eb29$export$2e2bcd8739ae039() {
    const { serviceMembers: serviceMembers } = (0, $1aae03441633a07a$export$fca13ab91e1a6240)();
    const { state: state, methods: methods } = serviceMembers;
    const { toggleModal: toggleModal, showModal: showModal, newModal: newModal } = (0, $afeee6e786e91a5d$export$33ffd74ebf07f060)();
    const pageActions = [
        {
            onClick: addUser,
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$7a3a035e61089aa9), {}),
            color: "success"
        }
    ];
    const listElements = state.map((member, i)=>({
            value: `${member.display_name}`,
            label: member.email,
            data: member,
            key: `l-${i}`,
            actions: [
                {
                    onClick: onUserDelete,
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$bfadae053a633538), {}),
                    color: "error"
                }
            ]
        }));
    async function handleNewMember(email) {
        try {
            await methods.addMember(email);
            // toggleModal(false)
            return true;
        } catch (err) {
            return false;
        }
    }
    function addUser() {
        // showModal("aggiungere utente?", "" , () => {}, toggleModal)
        newModal({
            title: "Aggiungi utente service",
            body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($105f993f66d4eb29$var$NewUserModal, {
                currentMembers: serviceMembers.state,
                onClick: handleNewMember,
                onClose: ()=>toggleModal(false)
            }),
            hideActions: true
        });
    }
    function onUserDelete(data) {
        console.log("DATA", data);
        showModal("Attenzione!", `Eliminare ${data.display_name} - ${data.email} ? `, async ()=>{
            await methods.deleteMember(data);
            toggleModal();
        }, toggleModal);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fb3f02de1b1ab50$export$2e2bcd8739ae039), {
        title: "Prova",
        actions: pageActions,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3db85e39e1ba4d0$export$2e2bcd8739ae039), {
            elements: listElements
        })
    });
}
function $105f993f66d4eb29$var$NewUserModal(props) {
    const [state, setState] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)({
        type: "default",
        message: "",
        disabled: false
    });
    const ref = (0, $acw62.useRef)(null);
    function onPress() {
        const foundMember = props.currentMembers.find((member)=>member.email === state);
        if (status.type != "default" && !foundMember) setStatus({
            type: "default",
            message: "",
            disabled: false
        });
        props.onClick(state).then((res)=>{
            setStatus({
                type: "success",
                message: "Utente creato con successo",
                disabled: true
            });
        }).catch((err)=>{
            setStatus({
                type: "error",
                message: "Impossibile creare utente",
                disabled: false
            });
        });
    }
    (0, $acw62.useEffect)(()=>{
        const foundMember = props.currentMembers.find((member)=>member.email === state);
        if (foundMember) {
            setStatus({
                type: "error",
                message: "Email gi\xe0 presente",
                disabled: true
            });
            return;
        }
        if (status.type != "default" && !foundMember) setStatus({
            type: "default",
            message: "",
            disabled: false
        });
    }, [
        state
    ]);
    (0, $acw62.useEffect)(()=>{
        ref.current.focus();
    }, [
        status.type
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
        justify: "center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                css: {
                    marginBottom: "$5"
                },
                children: "Inserisci l'email"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
                ref: ref,
                status: status.type,
                label: status.message,
                value: state,
                onChange: (e)=>setState(e.target.value),
                width: "100%"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                color: "error",
                light: true,
                auto: true,
                css: {
                    marginTop: "$10"
                },
                onClick: props.onClose,
                children: "Chiudi"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                disabled: status.disabled,
                color: "success",
                ghost: true,
                auto: true,
                css: {
                    marginTop: "$10"
                },
                onClick: onPress,
                children: "Aggiungi"
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");







function $d3b1ba0d4a39fc57$export$2e2bcd8739ae039() {
    const { orders: orders } = (0, $1aae03441633a07a$export$fca13ab91e1a6240)();
    const { state: state, methods: methods } = orders;
    const { toggleModal: toggleModal, showModal: showModal, newModal: newModal } = (0, $afeee6e786e91a5d$export$33ffd74ebf07f060)();
    const [filtered, setFiltered] = (0, $acw62.useState)(state);
    const [searchValue, setSeachValue] = (0, $acw62.useState)("");
    const pageActions = [];
    function addOrder() {
        showModal("DA IMPLEMENTARE", "", ()=>{}, toggleModal);
    }
    function toggleOrderModal(order) {
        newModal({
            title: `Dettagli ordine ${order.sku}`,
            body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d3b1ba0d4a39fc57$var$ModalBody, {
                item: order
            }),
            onCancel: ()=>toggleModal(false)
        });
    }
    function onUserDelete(data) {
        console.log("DATA", data);
        showModal("Attenzione!", `Eliminare ${data.display_name} - ${data.email} ? `, methods.deleteMember, toggleModal);
    }
    function handleUserSearch(e) {
        console.log("change", state);
        methods.updateSearchValue(e);
    }
    const ordersFiltered = searchValue.length === 0 ? state : state.filter((order)=>{
        if ((0, $fd5baa1bcf92a6bb$export$34ec79c02ad28eae)(searchValue)) return order.sku === searchValue;
        if ((0, $63f0f13c8d553523$export$371e338370561054)(searchValue)) return order.owner_email === searchValue;
        if (searchValue.length === 16) return order.transaction_id === searchValue;
        return order.item_name.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;
    });
    function mapStateToListItemData(state) {
        return state.map((order, i)=>({
                value: `${order.item_name} | creato il ${(0, $fd5baa1bcf92a6bb$export$8cca4e1da6b1437)(order.created_at)}, ore: ${(0, $fd5baa1bcf92a6bb$export$28d8e40b69192e57)(order.created_at).hour}`,
                label: `SKU: ${order.sku} | ${order.owner_email}`,
                data: order,
                key: `l-${i}`,
                actions: [
                    {
                        onClick: (data)=>toggleOrderModal(order),
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$f6a3d19be20f5819), {}),
                        color: "success"
                    }
                ]
            }));
    }
    const listElements = mapStateToListItemData(filtered);
    (0, $acw62.useEffect)(()=>{
        const ordersFiltered = searchValue.length === 0 ? state : state.filter((order)=>(0, $fd5baa1bcf92a6bb$export$cf51a7719174d526)(order, searchValue));
        setFiltered(ordersFiltered);
    }, [
        searchValue
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1fb3f02de1b1ab50$export$2e2bcd8739ae039), {
        title: "Ordini",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fb3f02de1b1ab50$export$e213cebad6250b4a), {
                actions: pageActions,
                middle: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d3b1ba0d4a39fc57$var$InputSearchBar, {
                        onChange: (e)=>setSeachValue(e.target.value),
                        onClear: ()=>setSeachValue(""),
                        value: searchValue
                    })
            }),
            searchValue,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3db85e39e1ba4d0$export$2e2bcd8739ae039), {
                elements: listElements
            })
        ]
    });
}
function $d3b1ba0d4a39fc57$var$InputSearchBar(props) {
    const { orders: orders } = (0, $1aae03441633a07a$export$fca13ab91e1a6240)();
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        ref.current.focus();
    }, [
        props.value
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
        css: {
            width: "100%",
            gap: "$10"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                css: {
                    flex: 1
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
                    ref: ref,
                    value: props.value,
                    onChange: props.onChange,
                    width: "100%",
                    "aria-label": "Filtra per sku, email, transaction id o tipologia prodotto",
                    placeholder: "Filtra per sku, email o tipologia prodotto"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                    auto: true,
                    light: true,
                    onClick: props.onClear,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$bfadae053a633538), {
                            style: {
                                marginRight: 10
                            },
                            size: "small"
                        }),
                        " Cancella "
                    ]
                })
            })
        ]
    });
}
function $d3b1ba0d4a39fc57$var$ModalBody(props) {
    const { item: item } = props;
    const orderDate = (0, $fd5baa1bcf92a6bb$export$28d8e40b69192e57)(item.created_at);
    function downloadUrl(url) {
        const u = new URL(url);
        const imagePath = url + "?attachment=true";
        // const image = await saveAs(imagePath, "image.png")
        const a = document.createElement("a");
        a.setAttribute("href", imagePath);
        a.setAttribute("download", "image.png");
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
    function copyToClipboard(data) {
        navigator.clipboard.writeText(data);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
        direction: "column",
        css: {
            gap: "$5"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: [
                            "Copia Transaction ID",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                                h5: true,
                                small: true,
                                children: item.transaction_id
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                            light: true,
                            auto: true,
                            color: "primary",
                            css: {
                                padding: 0
                            },
                            onClick: ()=>copyToClipboard(item.transaction_id),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$7a3a035e61089aa9), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: [
                            "Copia lo sku ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                                h5: true,
                                small: true,
                                children: item.sku
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                            light: true,
                            auto: true,
                            color: "primary",
                            css: {
                                padding: 0
                            },
                            onClick: ()=>copyToClipboard(item.sku),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$7a3a035e61089aa9), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "URI: "
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                            small: true,
                            children: item.item_data.uri
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "Transaction ID"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: item.transaction_id
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "Immagine Fronte"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: item.item_data.front_url,
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    light: true,
                                    auto: true,
                                    color: "primary",
                                    css: {
                                        padding: 0
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$f6a3d19be20f5819), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                light: true,
                                auto: true,
                                color: "primary",
                                css: {
                                    padding: 0
                                },
                                onClick: ()=>downloadUrl(item.item_data.front_url),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$a7aaed3e118dd255), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "Immagine Retro"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: item.item_data.back_url,
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    light: true,
                                    auto: true,
                                    color: "primary",
                                    css: {
                                        padding: 0
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$f6a3d19be20f5819), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                light: true,
                                auto: true,
                                color: "primary",
                                css: {
                                    padding: 0
                                },
                                onClick: ()=>downloadUrl(item.item_data.back_url),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$a7aaed3e118dd255), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "Ordine creato il "
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                            h5: true,
                            css: {
                                textAlign: "right"
                            },
                            children: [
                                orderDate.date,
                                ", ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                " H ",
                                orderDate.hour
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "Email ordinante "
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                            h5: true,
                            children: item.owner_email
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $e7c772947e7beaf9$export$83ce4bc8280540e6(r, n, e) {
    return 100 * (r - n) / (e - n);
}
function $e7c772947e7beaf9$export$d02631cccf789723(r, n) {
    const e = n - r + 1;
    return Array.from({
        length: e
    }, (n, e)=>e + r);
}


const $4e3bbd437d25b7ab$export$fadfbce9325ec320 = "dots";
var $4e3bbd437d25b7ab$export$2e2bcd8739ae039 = ({ page: o, total: a, siblings: s = 1, boundaries: u = 1, initialPage: c = 1, onChange: f })=>{
    const [m, g] = (0, $acw62.useState)(o || c), l = (t)=>{
        g(t), f && f(t);
    };
    (0, $acw62.useEffect)(()=>{
        o && o !== m && g(o);
    }, [
        o
    ]);
    const p = (0, $acw62.useCallback)((t)=>{
        l(t <= 0 ? 1 : t > a ? a : t);
    }, [
        a
    ]);
    return {
        range: (0, $acw62.useMemo)(()=>{
            if (2 * s + 3 + 2 * u >= a) return (0, $e7c772947e7beaf9$export$d02631cccf789723)(1, a);
            const t = Math.max(m - s, u), r = Math.min(m + s, a - u), e = t > u + 2, n = r < a - (u + 1);
            if (!e && n) return [
                ...(0, $e7c772947e7beaf9$export$d02631cccf789723)(1, 2 * s + u + 2),
                $4e3bbd437d25b7ab$export$fadfbce9325ec320,
                ...(0, $e7c772947e7beaf9$export$d02631cccf789723)(a - (u - 1), a)
            ];
            if (e && !n) {
                const t = u + 1 + 2 * s;
                return [
                    ...(0, $e7c772947e7beaf9$export$d02631cccf789723)(1, u),
                    $4e3bbd437d25b7ab$export$fadfbce9325ec320,
                    ...(0, $e7c772947e7beaf9$export$d02631cccf789723)(a - t, a)
                ];
            }
            return [
                ...(0, $e7c772947e7beaf9$export$d02631cccf789723)(1, u),
                $4e3bbd437d25b7ab$export$fadfbce9325ec320,
                ...(0, $e7c772947e7beaf9$export$d02631cccf789723)(t, r),
                $4e3bbd437d25b7ab$export$fadfbce9325ec320,
                ...(0, $e7c772947e7beaf9$export$d02631cccf789723)(a - u + 1, a)
            ];
        }, [
            a,
            s,
            m
        ]),
        active: m,
        setPage: p,
        next: ()=>p(m + 1),
        previous: ()=>p(m - 1),
        first: ()=>p(1),
        last: ()=>p(a)
    };
};



var $acw62 = parcelRequire("acw62");





const $134bdfbf526ae75a$var$o = (0, $07d095cbefc9a288$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "scale(1)"
    },
    "60%": {
        transform: "scale($$paginationScaleTransform)"
    },
    "100%": {
        transform: "scale(1)"
    }
});
const $134bdfbf526ae75a$export$b5a669f8f36533fb = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("svg", {
    color: "currentColor",
    stroke: "currentColor",
    variants: {
        isEllipsis: {
            true: {
                transform: "0deg"
            }
        },
        isBefore: {
            true: {}
        }
    },
    compoundVariants: [
        {
            isEllipsis: !0,
            isBefore: !0,
            css: {
                transform: "rotate(180deg)"
            }
        }
    ]
});
const $134bdfbf526ae75a$export$92622e318f720da1 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("svg", {
    transform: "rotate(180deg)",
    variants: {
        isPrev: {
            true: {
                transform: "rotate(0deg)"
            }
        }
    }
});
const $134bdfbf526ae75a$export$ee5a8712893349af = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    top: 0,
    left: 0,
    zIndex: "$2"
});
const $134bdfbf526ae75a$export$f61d50680d8545 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("button", {
    border: "none",
    position: "relative",
    display: "inline-flex",
    margin: "0 $$paginationItemMargin",
    ai: "center",
    jc: "center",
    padding: 0,
    boxSizing: "border-box",
    tt: "capitalize",
    us: "none",
    whiteSpace: "nowrap",
    ta: "center",
    verticalAlign: "middle",
    bs: "none",
    outline: "none",
    height: "$$paginationSize",
    minWidth: "$$paginationSize",
    fs: "inherit",
    cursor: "pointer",
    br: "$$paginationItemRadius",
    color: "$text",
    bg: "$accents0",
    "@motion": {
        transition: "none"
    },
    "&:hover": {
        bg: "$accents1"
    },
    [`& ${$134bdfbf526ae75a$export$92622e318f720da1}`]: {
        size: "$$paginationFontSize"
    },
    [`& ${$134bdfbf526ae75a$export$b5a669f8f36533fb}`]: {
        size: "$$paginationFontSize"
    },
    variants: {
        active: {
            true: {
                fontWeight: "$bold",
                cursor: "default",
                boxShadow: "$sm",
                [`& ${$134bdfbf526ae75a$export$ee5a8712893349af}`]: {
                    color: "$white"
                }
            }
        },
        disabled: {
            true: {
                color: "$accents5",
                cursor: "not-allowed"
            }
        },
        bordered: {
            true: {
                bg: "transparent",
                border: "$$paginationItemBorderWeight solid $accents2"
            }
        },
        onlyDots: {
            true: {}
        },
        preserveContent: {
            true: {}
        },
        animated: {
            true: {
                transition: "transform 0.25s ease 0s, background 0.25s ease 0s, box-shadow 0.25s ease 0s"
            },
            false: {
                transition: "none"
            }
        }
    },
    compoundVariants: [
        {
            onlyDots: !0,
            preserveContent: !1,
            css: {
                [`& ${$134bdfbf526ae75a$export$ee5a8712893349af}`]: {
                    display: "none"
                }
            }
        },
        {
            animated: !0,
            disabled: !1,
            active: !1,
            css: {
                "&:active": {
                    transform: "scale($$paginationScaleTransform)",
                    fs: "calc($$paginationFontSize * 0.9)"
                }
            }
        }
    ]
}, (0, $eaf275b21629a4ec$export$fcece08f39236f43));
const $134bdfbf526ae75a$export$789b2a6099b5bb9a = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    contain: "strict",
    top: "0px",
    zIndex: "$1",
    bg: "$$paginationColor",
    br: "$$paginationItemRadius",
    height: "$$paginationSize",
    minWidth: "$$paginationSize",
    animationName: `${$134bdfbf526ae75a$var$o}`,
    animationDirection: "normal",
    "&.nextui-pagination-highlight--moving": {
        transform: "scale($$paginationScaleTransform)"
    },
    "@motion": {
        transition: "none",
        "&.nextui-pagination-highlight--moving": {
            transform: "scale(1)"
        }
    },
    variants: {
        animated: {
            true: {
                animationDuration: "350ms",
                animationTimingFunction: "ease",
                transition: "left 350ms ease 0s, transform 300ms ease 0s"
            },
            false: {
                animationDuration: "none",
                animationTimingFunction: "none",
                transition: "none",
                "&.nextui-pagination-highlight--moving": {
                    transform: "scale(1)"
                }
            }
        },
        noMargin: {
            true: {
                br: "$squared"
            }
        },
        rounded: {
            true: {}
        },
        shadow: {
            true: {
                normalShadowVar: "$$paginationShadowColor"
            }
        }
    },
    compoundVariants: [
        {
            rounded: !0,
            noMargin: !0,
            css: {
                br: "$pill"
            }
        }
    ]
});
const $134bdfbf526ae75a$export$a175c050888fcfc5 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("nav", {
    m: 0,
    p: 0,
    d: "inline-flex",
    position: "relative",
    fontVariant: "tabular-nums",
    fontFeatureSettings: "tnum",
    variants: {
        color: {
            default: {
                $$paginationColor: "$colors$primary",
                $$paginationShadowColor: "$colors$primaryShadow"
            },
            primary: {
                $$paginationColor: "$colors$primary",
                $$paginationShadowColor: "$colors$primaryShadow"
            },
            secondary: {
                $$paginationColor: "$colors$secondary",
                $$paginationShadowColor: "$colors$secondaryShadow"
            },
            success: {
                $$paginationColor: "$colors$success",
                $$paginationShadowColor: "$colors$successShadow"
            },
            warning: {
                $$paginationColor: "$colors$warning",
                $$paginationShadowColor: "$colors$warningShadow"
            },
            error: {
                $$paginationColor: "$colors$error",
                $$paginationShadowColor: "$colors$errorShadow"
            },
            gradient: {
                $$paginationColor: "$colors$gradient",
                $$paginationShadowColor: "$colors$primaryShadow"
            }
        },
        size: {
            xs: {
                $$paginationWidth: "$space$10",
                $$paginationFontSize: "$space$5",
                fs: "$$paginationFontSize"
            },
            sm: {
                $$paginationWidth: "$space$12",
                $$paginationFontSize: "$space$6",
                fs: "$$paginationFontSize"
            },
            md: {
                $$paginationWidth: "$space$13",
                $$paginationFontSize: "$space$7",
                fs: "$$paginationFontSize"
            },
            lg: {
                $$paginationWidth: "$space$14",
                $$paginationFontSize: "$space$8",
                fs: "$$paginationFontSize"
            },
            xl: {
                $$paginationWidth: "$space$15",
                $$paginationFontSize: "$space$9",
                fs: "$$paginationFontSize"
            }
        },
        borderWeight: {
            light: {
                $$paginationItemBorderWeight: "$borderWeights$light"
            },
            normal: {
                $$paginationItemBorderWeight: "$borderWeights$normal"
            },
            bold: {
                $$paginationItemBorderWeight: "$borderWeights$bold"
            },
            extrabold: {
                $$paginationItemBorderWeight: "$borderWeights$extrabold"
            },
            black: {
                $$paginationItemBorderWeight: "$borderWeights$black"
            }
        },
        bordered: {
            true: {}
        },
        onlyDots: {
            true: {
                $$paginationSize: "calc($$paginationWidth / 2)",
                $$paginationItemRadius: "$radii$pill",
                $$paginationScaleTransform: 1.05
            },
            false: {
                $$paginationSize: "$$paginationWidth",
                $$paginationScaleTransform: 1.1
            }
        },
        rounded: {
            true: {
                $$paginationItemRadius: "$radii$pill"
            },
            false: {
                $$paginationItemRadius: "$radii$squared"
            }
        },
        noMargin: {
            true: {
                $$paginationItemRadius: "0px",
                $$paginationItemMargin: "0",
                [`& ${$134bdfbf526ae75a$export$f61d50680d8545}:first-of-type`]: {
                    btlr: "$squared",
                    bblr: "$squared"
                },
                [`& ${$134bdfbf526ae75a$export$f61d50680d8545}:last-of-type`]: {
                    btrr: "$squared",
                    bbrr: "$squared"
                }
            },
            false: {
                $$paginationItemMargin: "$space$1"
            }
        }
    },
    compoundVariants: [
        {
            bordered: !0,
            noMargin: !0,
            css: {
                [`& ${$134bdfbf526ae75a$export$f61d50680d8545}:not(:last-child)`]: {
                    borderRight: 0
                }
            }
        },
        {
            noMargin: !0,
            rounded: !0,
            css: {
                $$paginationItemRadius: "0px"
            }
        },
        {
            rounded: !1,
            noMargin: !0,
            css: {
                $$paginationItemRadius: "0px"
            }
        }
    ],
    defaultVariants: {
        color: "default",
        size: "md",
        borderWeight: "normal",
        onlyDots: !1,
        noMargin: !1,
        rounded: !1
    }
});



const $08f62b69fb8cdba4$var$l = (e)=>{
    if (e) switch(e){
        case 0, $4e3bbd437d25b7ab$export$fadfbce9325ec320:
            return "dots element";
        case "<":
            return "previous page button";
        case ">":
            return "next page button";
        case "first":
            return "first page button";
        case "last":
            return "last page button";
        default:
            return `${e} item`;
    }
}, $08f62b69fb8cdba4$var$c = "nextui-pagination-item", $08f62b69fb8cdba4$var$d = ({ active: e, value: r, children: a, disabled: d, animated: m, bordered: u, onClick: p, onlyDots: b, preserveContent: f, ...v })=>{
    const g = (0, $acw62.useMemo)(()=>e ? `${$08f62b69fb8cdba4$var$l(r)} active` : $08f62b69fb8cdba4$var$l(r), [
        r,
        e
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $134bdfbf526ae75a$export$f61d50680d8545), {
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)($08f62b69fb8cdba4$var$c, {
            [`${$08f62b69fb8cdba4$var$c}-active`]: e,
            [`${$08f62b69fb8cdba4$var$c}-animated`]: m,
            [`${$08f62b69fb8cdba4$var$c}-disabled`]: d,
            [`${$08f62b69fb8cdba4$var$c}-bordered`]: u,
            [`${$08f62b69fb8cdba4$var$c}-only-dots`]: b,
            [`${$08f62b69fb8cdba4$var$c}-preserve-content`]: f
        }),
        animated: m,
        active: e,
        disabled: d,
        bordered: u,
        onlyDots: b,
        preserveContent: f,
        onClick: (e)=>{
            d || p && p(e);
        },
        "aria-label": g,
        tabIndex: d ? -1 : 0,
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $134bdfbf526ae75a$export$ee5a8712893349af), {
            className: `${$08f62b69fb8cdba4$var$c}-content`,
            children: a
        })
    });
};
$08f62b69fb8cdba4$var$d.toString = ()=>".nextui-pagination-item";
var $08f62b69fb8cdba4$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($08f62b69fb8cdba4$var$d, {
    preserveContent: !1
});



var $acw62 = parcelRequire("acw62");



var $e9b67afd9058449f$export$2e2bcd8739ae039 = ({ value: e, isBefore: s, onlyDots: l, animated: c, bordered: a, onClick: d })=>{
    const [p, m] = (0, $acw62.useState)(!1);
    return (0, $7b02d682eb115277$exports.jsx)((0, $08f62b69fb8cdba4$export$2e2bcd8739ae039), {
        value: e,
        onlyDots: l,
        animated: c,
        bordered: a,
        onClick: (e)=>d && d(e),
        onMouseEnter: ()=>m(!0),
        onMouseLeave: ()=>m(!1),
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $134bdfbf526ae75a$export$b5a669f8f36533fb), p ? {
            role: "presentation",
            focusable: "false",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none",
            shapeRendering: "geometricPrecision",
            className: "nextui-pagination-ellipsis",
            isEllipsis: !0,
            isBefore: s,
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M13 17l5-5-5-5"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M6 17l5-5-5-5"
                })
            ]
        } : {
            viewBox: "0 0 24 24",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none",
            shapeRendering: "geometricPrecision",
            isEllipsis: !1,
            isBefore: s,
            children: [
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "1",
                    fill: "currentColor"
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "19",
                    cy: "12",
                    r: "1",
                    fill: "currentColor"
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "5",
                    cy: "12",
                    r: "1",
                    fill: "currentColor"
                })
            ]
        })
    });
};



var $acw62 = parcelRequire("acw62");



const $63807de460114838$var$i = ({ isPrev: o, disabled: i, onlyDots: r, animated: a, bordered: s, onClick: l, ...d })=>(0, $7b02d682eb115277$exports.jsx)((0, $08f62b69fb8cdba4$export$2e2bcd8739ae039), {
        preserveContent: !0,
        value: o ? "<" : ">",
        bordered: s,
        animated: a,
        onlyDots: r,
        disabled: i,
        onClick: (o)=>l && l(o),
        children: (0, $7b02d682eb115277$exports.jsx)((0, $134bdfbf526ae75a$export$92622e318f720da1), {
            role: "presentation",
            focusable: "false",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "nextui-pagination-icon",
            isPrev: o,
            ...d,
            children: (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.5 19l-7-7 7-7",
                stroke: "currentColor",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
$63807de460114838$var$i.toString = ()=>".nextui-pagination-icon";
const $63807de460114838$var$r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($63807de460114838$var$i);
var $63807de460114838$export$2e2bcd8739ae039 = $63807de460114838$var$r;



var $acw62 = parcelRequire("acw62");




const $b421b8377e3c0116$var$c = "nextui-pagination-highlight", $b421b8377e3c0116$var$m = ({ active: i, shadow: m, noMargin: u, rounded: g, css: l, ...p })=>{
    const [d, x] = (0, $acw62.useState)(i), [f, h] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        if (i !== d) {
            x(i), h(`${$b421b8377e3c0116$var$c}--moving`);
            const t = setTimeout(()=>{
                h(""), clearTimeout(t);
            }, 350);
        }
    }, [
        i
    ]);
    const $ = (0, $acw62.useMemo)(()=>u ? `var(--nextui--paginationSize) * ${d}` : `var(--nextui--paginationSize) * ${d} + ${4 * d + 2}px`, [
        d,
        u
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $134bdfbf526ae75a$export$789b2a6099b5bb9a), {
        "aria-hidden": !0,
        shadow: m,
        rounded: g,
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)($b421b8377e3c0116$var$c, f, {
            [`${$b421b8377e3c0116$var$c}--rounded`]: g,
            [`${$b421b8377e3c0116$var$c}--active`]: i,
            [`${$b421b8377e3c0116$var$c}--no-margin`]: u,
            [`${$b421b8377e3c0116$var$c}--shadow`]: m
        }, p.className),
        noMargin: u,
        style: (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)({
            "--nextui--paginationLeft": `calc(${$})`
        }, (null == p ? void 0 : p.style) || {}),
        css: {
            left: "var(--nextui--paginationLeft)",
            ...l
        },
        ...p
    });
};
$b421b8377e3c0116$var$m.toString = ()=>".nextui-pagination-highlight";
var $b421b8377e3c0116$export$2e2bcd8739ae039 = $b421b8377e3c0116$var$m;






const $a964205e776c177a$var$u = "nextui-pagination", $a964205e776c177a$var$c = ({ page: o, initialPage: l, onlyDots: c, total: f, loop: b, siblings: x, boundaries: h, shadow: $, animated: y, bordered: v, dotsJump: D, controls: P, noMargin: C, onChange: j, rounded: k, ...w })=>{
    const { range: M, active: N, setPage: O, previous: J, next: B, first: I, last: S } = (0, $4e3bbd437d25b7ab$export$2e2bcd8739ae039)({
        page: o,
        initialPage: l,
        siblings: c ? 10 : x,
        boundaries: c ? 10 : h,
        total: f,
        onChange: j
    }), U = (0, $acw62.useCallback)((o, i)=>{
        if (o === (0, $4e3bbd437d25b7ab$export$fadfbce9325ec320)) {
            const n = i < M.indexOf(N);
            return (0, $7b02d682eb115277$exports.jsx)((0, $e9b67afd9058449f$export$2e2bcd8739ae039), {
                value: o,
                bordered: v,
                animated: y,
                isBefore: n,
                onlyDots: c,
                onClick: ()=>O(n ? N - D >= 1 ? N - D : 1 : N + D <= f ? N + D : f)
            }, `${$a964205e776c177a$var$u}-item-${o}-${i}`);
        }
        return (0, $7b02d682eb115277$exports.jsx)((0, $08f62b69fb8cdba4$export$2e2bcd8739ae039), {
            value: o,
            animated: y,
            bordered: v,
            active: o === N,
            onClick: ()=>o !== N && O(o),
            onlyDots: c,
            children: o
        }, `${$a964205e776c177a$var$u}-item-${o}-${i}`);
    }, [
        f,
        c,
        N,
        v,
        y
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $134bdfbf526ae75a$export$a175c050888fcfc5), {
        noMargin: C,
        bordered: v,
        rounded: k,
        onlyDots: c,
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)($a964205e776c177a$var$u, {
            [`${$a964205e776c177a$var$u}--no-margin`]: C,
            [`${$a964205e776c177a$var$u}--bordered`]: v,
            [`${$a964205e776c177a$var$u}--shadow`]: $,
            [`${$a964205e776c177a$var$u}--rounded`]: k
        }),
        ...w,
        children: [
            P && (0, $7b02d682eb115277$exports.jsx)((0, $63807de460114838$export$2e2bcd8739ae039), {
                isPrev: !0,
                bordered: v,
                animated: y,
                onlyDots: c,
                onClick: ()=>b && 1 === N ? S() : J(),
                disabled: !b && 1 === N
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $b421b8377e3c0116$export$2e2bcd8739ae039), {
                noMargin: C,
                animated: y,
                shadow: $,
                rounded: k,
                active: P ? M.indexOf(N) + 1 : M.indexOf(N)
            }),
            M.map(U),
            P && (0, $7b02d682eb115277$exports.jsx)((0, $63807de460114838$export$2e2bcd8739ae039), {
                bordered: v,
                animated: y,
                onlyDots: c,
                onClick: ()=>b && N === f ? I() : B(),
                disabled: !b && N === f
            })
        ]
    });
};
$a964205e776c177a$var$c.defaultProps = {
    shadow: !1,
    controls: !0,
    bordered: !1,
    initialPage: 1,
    siblings: 1,
    boundaries: 1,
    dotsJump: 5,
    total: 1,
    loop: !1,
    animated: !0,
    onlyDots: !1,
    noMargin: !1,
    rounded: !1
}, (0, $9013ad1f954747ab$export$a866f231438cc228) && ($a964205e776c177a$var$c.displayName = "NextUI.Pagination"), $a964205e776c177a$var$c.toString = ()=>".nextui-pagination";
var $a964205e776c177a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($a964205e776c177a$var$c);



var $0be6a2fedf21e6f2$export$2e2bcd8739ae039 = (0, $a964205e776c177a$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");






function $0257f19214483c41$export$2e2bcd8739ae039(props) {
    const { page: page, pageMethods: pageMethods, unlinked: unlinked } = (0, $1aae03441633a07a$export$fca13ab91e1a6240)();
    const { unlinkedItems: unlinkedItems, cursor: cursor, cursorEnd: cursorEnd, idHistory: idHistory, loading: loading } = unlinked.state;
    const { handlePagination: handlePagination } = unlinked.methods;
    const searchValue = "";
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const paginationIndex = cursor + 1;
    function handleUserSearch(e) {
        // console.log("change", state)
        // console.log(cursor)
        methods.updateSearchValue(e);
    }
    (0, $acw62.useEffect)(()=>{
        pageMethods.setPageTitle("Unlinked Items");
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1fb3f02de1b1ab50$export$2e2bcd8739ae039), {
        title: page.name,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fb3f02de1b1ab50$export$e213cebad6250b4a), {
                actions: [
                    {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$7a3a035e61089aa9), {}),
                        onClick: ()=>navigate("/unlinked-items/nuovo"),
                        color: "success"
                    }
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                css: {
                    height: "100%",
                    overflowY: "auto",
                    padding: "$5",
                    gap: "$5"
                },
                children: unlinkedItems.map((item, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0257f19214483c41$var$CardComponent, {
                        item: item
                    }, `unl-${i}`))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                css: {
                    marginTop: "$10",
                    gap: "$10",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0be6a2fedf21e6f2$export$2e2bcd8739ae039), {
                    color: "secondary",
                    noMargin: true,
                    initialPage: paginationIndex,
                    controls: true,
                    onChange: handlePagination,
                    total: cursorEnd ? paginationIndex : paginationIndex + 1
                })
            })
        ]
    });
}
function $0257f19214483c41$var$InputSearchBar(props) {
    const ref = (0, $acw62.useRef)(null);
    function filterElements() {
        props.onSearch(ref.current.value);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
        css: {
            width: "100%",
            gap: "$10"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                css: {
                    flex: 1
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
                    ref: ref,
                    width: "100%",
                    "aria-label": "Filtra per sku, email, transaction id o tipologia prodotto",
                    placeholder: "Filtra per sku, email o tipologia prodotto"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                    auto: true,
                    light: true,
                    onClick: filterElements,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$4b85d3515bd863a5), {
                            style: {
                                marginRight: 10
                            },
                            size: "small"
                        }),
                        " Cerca "
                    ]
                })
            })
        ]
    });
}
function $0257f19214483c41$var$CardComponent(props) {
    const { newModal: newModal, toggleModal: toggleModal } = (0, $afeee6e786e91a5d$export$33ffd74ebf07f060)();
    const itemDate = (0, $fd5baa1bcf92a6bb$export$28d8e40b69192e57)(props.item.created_at);
    function showItemModal() {
        newModal({
            title: `Dettagli card ${props.item.serial_id}`,
            body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0257f19214483c41$var$ModalBody, {
                item: props.item
            }),
            onCancel: ()=>toggleModal(false)
        });
    }
    async function deleteItem() {}
    function showDeleteModal() {
        newModal({
            title: `Conferma eliminazione card `,
            body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: "Eliminare Item?"
            }),
            onConfirm: deleteItem,
            onCancel: ()=>toggleModal(false)
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $92b7149304f358a3$export$2e2bcd8739ae039), {
        variant: "flat",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $92b7149304f358a3$export$2e2bcd8739ae039).Header, {
                children: [
                    props.item.uri,
                    " - ",
                    props.item.id
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92b7149304f358a3$export$2e2bcd8739ae039).Body, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                    direction: "row",
                    justify: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                            css: {
                                flex: "1 0"
                            },
                            children: [
                                "SERIAL ID: ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                    children: props.item.serial_id
                                }),
                                " | ",
                                props.item.shipped ? "SPEDITA" : "DA SPEDIRE",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                                    children: [
                                        "creato il ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("b", {
                                            children: [
                                                itemDate.date,
                                                ", ore ",
                                                itemDate.hour
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                            css: {
                                gap: "$5",
                                flex: "0 1",
                                flexWrap: "no-wrap"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    auto: true,
                                    light: true,
                                    color: "success",
                                    css: {
                                        gap: "$5",
                                        padding: 0
                                    },
                                    onClick: showItemModal,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$f6a3d19be20f5819), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    auto: true,
                                    light: true,
                                    color: "error",
                                    onClick: showDeleteModal,
                                    css: {
                                        gap: "$5",
                                        padding: 0
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$bfadae053a633538), {})
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $0257f19214483c41$var$ModalBody(props) {
    const { item: item } = props;
    const itemDate = (0, $fd5baa1bcf92a6bb$export$28d8e40b69192e57)(props.item.created_at);
    function downloadUrl(url) {
        const u = new URL(url);
        const imagePath = url + "?attachment=true";
        // const image = await saveAs(imagePath, "image.png")
        const a = document.createElement("a");
        a.setAttribute("href", imagePath);
        a.setAttribute("download", "image.png");
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
    function copyToClipboard() {
        navigator.clipboard.writeText(item.uri);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
        direction: "column",
        css: {
            gap: "$5"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "Copia il link"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                            light: true,
                            auto: true,
                            color: "primary",
                            css: {
                                padding: 0
                            },
                            onClick: copyToClipboard,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$7a3a035e61089aa9), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                    css: {
                        flex: "1 "
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                        h5: true,
                        small: true,
                        children: item.uri
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "Corporation ID"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: item.corporation_id ?? "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "Immagine Fronte"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: item.image_url_front,
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    light: true,
                                    auto: true,
                                    color: "primary",
                                    css: {
                                        padding: 0
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$f6a3d19be20f5819), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                light: true,
                                auto: true,
                                color: "primary",
                                css: {
                                    padding: 0
                                },
                                onClick: ()=>downloadUrl(item.image_url_front),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$a7aaed3e118dd255), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "Immagine Retro"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: item.image_url_rear,
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    light: true,
                                    auto: true,
                                    color: "primary",
                                    css: {
                                        padding: 0
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$f6a3d19be20f5819), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                light: true,
                                auto: true,
                                color: "primary",
                                css: {
                                    padding: 0
                                },
                                onClick: ()=>downloadUrl(item.image_url_rear),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$a7aaed3e118dd255), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "Data Creazione"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5",
                            textAlign: "right"
                        },
                        children: [
                            itemDate.date,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            " H ",
                            itemDate.hour
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                justify: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                        css: {
                            flex: "1 "
                        },
                        children: "Spedita"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                        css: {
                            width: "auto",
                            gap: "$5"
                        },
                        children: String(item.shipped)
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");
function $adbad999e88477eb$var$$c1d7fb2ec91bae71$var$Item(props) {
    return null;
}
$adbad999e88477eb$var$$c1d7fb2ec91bae71$var$Item.getCollectionNode = function* getCollectionNode(props, context) {
    let { childItems: childItems, title: title, children: children } = props;
    let rendered = props.title || props.children;
    let textValue = props.textValue || (typeof rendered === "string" ? rendered : "") || props["aria-label"] || "";
    // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.
    if (!textValue && !(context === null || context === void 0 ? void 0 : context.suppressTextValueWarning)) console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop.");
    yield {
        type: "item",
        props: props,
        rendered: rendered,
        textValue: textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: $adbad999e88477eb$var$$c1d7fb2ec91bae71$var$hasChildItems(props),
        *childNodes () {
            if (childItems) for (let child1 of childItems)yield {
                type: "item",
                value: child1
            };
            else if (title) {
                let items = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
function $adbad999e88477eb$var$$c1d7fb2ec91bae71$var$hasChildItems(props) {
    if (props.hasChildItems != null) return props.hasChildItems;
    if (props.childItems) return true;
    if (props.title && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(props.children) > 0) return true;
    return false;
}
// We don't want getCollectionNode to show up in the type definition
let $adbad999e88477eb$export$6d08773d2e66f8f2 = $adbad999e88477eb$var$$c1d7fb2ec91bae71$var$Item;
function $adbad999e88477eb$var$$9fc4852771d079eb$var$Section(props) {
    return null;
}
$adbad999e88477eb$var$$9fc4852771d079eb$var$Section.getCollectionNode = function* getCollectionNode(props) {
    let { children: children, title: title, items: items1 } = props;
    yield {
        type: "section",
        hasChildNodes: true,
        rendered: title,
        "aria-label": props["aria-label"],
        *childNodes () {
            if (typeof children === "function") {
                if (!items1) throw new Error("props.children was a function but props.items is missing");
                for (let item of items1)yield {
                    type: "item",
                    value: item,
                    renderer: children
                };
            } else {
                let items = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
// We don't want getCollectionNode to show up in the type definition
let $adbad999e88477eb$export$6e2c8f0811a474ce = $adbad999e88477eb$var$$9fc4852771d079eb$var$Section;
class $adbad999e88477eb$var$$eb2240fc39a57fa5$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $adbad999e88477eb$var$$eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children, items: items } = props;
        if (typeof children === "function") {
            if (!items) throw new Error("props.children was a function but props.items is missing");
            for (let item of props.items)yield* this.getFullNode({
                value: item
            }, {
                renderer: children
            });
        } else {
            let items = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === "cell" && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _key;
            let key = (_key = v.key) !== null && _key !== void 0 ? _key : v.id;
            if (key == null) throw new Error("No key found for item");
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== "function" && typeof type.getCollectionNode !== "function") {
                let name = typeof element.type === "function" ? element.type.name : element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key;
                if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $adbad999e88477eb$var$$eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value || partialNode.value;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$adbad999e88477eb$var$$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$adbad999e88477eb$var$$eb2240fc39a57fa5$var$capitalize(parentNode.type)}>. Only <${$adbad999e88477eb$var$$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null) return;
        // Create full node
        let builder = this;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue,
            "aria-label": partialNode["aria-label"],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes,
            childNodes: $adbad999e88477eb$var$$eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    child.index = index;
                    let nodes = builder.getFullNode(child, builder.getChildState(state, child), node.key, node);
                    for (let node1 of nodes){
                        index++;
                        yield node1;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $adbad999e88477eb$var$$eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item1 of iterable){
                cache.push(item1);
                yield item1;
            }
        }
    };
}
function $adbad999e88477eb$var$$eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $adbad999e88477eb$var$$eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
function $adbad999e88477eb$export$6cd28814d92fa9c9(props, factory, context, invalidators = []) {
    let builder = (0, $acw62.useMemo)(()=>new $adbad999e88477eb$var$$eb2240fc39a57fa5$export$bf788dd355e3a401(), []);
    let prev = (0, $acw62.useRef)(null);
    return (0, $acw62.useMemo)(()=>{
        let nodes = builder.build(props, context);
        prev.current = factory(nodes, prev.current);
        return prev.current;
    // Don't invalidate when any prop changes, just the two we care about.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        builder,
        props.children,
        props.items,
        context,
        ...invalidators
    ]);
}
const $adbad999e88477eb$var$$453cc9f0df89c0a5$var$cache = new WeakMap();
function $adbad999e88477eb$export$77d5aafae4e095b2(collection) {
    let count = $adbad999e88477eb$var$$453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    count = 0;
    for (let item of collection)if (item.type === "section") count += $adbad999e88477eb$export$77d5aafae4e095b2(item.childNodes);
    else count++;
    $adbad999e88477eb$var$$453cc9f0df89c0a5$var$cache.set(collection, count);
    return count;
}



const $98b61cdc3f5d815a$var$o = (0, $adbad999e88477eb$export$6d08773d2e66f8f2);
var $98b61cdc3f5d815a$export$2e2bcd8739ae039 = $98b61cdc3f5d815a$var$o;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $d496ba217ce8e4fb$export$40bfa8c7b0832715(value1, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $acw62.useState)(value1 || defaultValue);
    let ref = (0, $acw62.useRef)(value1 !== undefined);
    let wasControlled = ref.current;
    let isControlled = value1 !== undefined;
    // Internal state reference for useCallback
    let stateRef = (0, $acw62.useRef)(stateValue);
    if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
    ref.current = isControlled;
    let setValue = (0, $acw62.useCallback)((value2, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(stateRef.current, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) stateRef.current = value;
        };
        if (typeof value2 === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value2(isControlled ? stateRef.current : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value2);
            onChangeCaller(value2, ...args);
        }
    }, [
        isControlled,
        onChange
    ]);
    // If a controlled component's value prop changes, we need to update stateRef
    if (isControlled) stateRef.current = value1;
    else value1 = stateValue;
    return [
        value1,
        setValue
    ];
}
function $d496ba217ce8e4fb$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $d496ba217ce8e4fb$export$cb6e0bb50bc19463(value, min, max, step) {
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $d496ba217ce8e4fb$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}


function $92bbed67fcd60c87$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $92bbed67fcd60c87$var$$fc909762b330b746$exports = {};
$92bbed67fcd60c87$var$$parcel$export($92bbed67fcd60c87$var$$fc909762b330b746$exports, "useOverlayTriggerState", ()=>$92bbed67fcd60c87$export$61c6a8c84e605fb6);
function $92bbed67fcd60c87$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $d496ba217ce8e4fb$export$40bfa8c7b0832715)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open () {
            setOpen(true);
        },
        close () {
            setOpen(false);
        },
        toggle () {
            setOpen(!isOpen);
        }
    };
}



function $c5e08d37e4dd87be$export$d734136a7b018efe(e, n) {
    if (null != e) {
        if ((0, $9013ad1f954747ab$export$f6e2535fb5126e54)(e)) e(n);
        else try {
            e.current = n;
        } catch (r) {
            throw new Error(`Cannot assign value '${n}' to ref '${e}'`);
        }
    }
}
function $c5e08d37e4dd87be$export$c9058316764c140e(...r) {
    return (e)=>{
        r.forEach((r)=>$c5e08d37e4dd87be$export$d734136a7b018efe(r, e));
    };
}


const $6adccf1fad1dbe9e$export$2e2101229991bd1b = (t)=>t ? t.replace("-", " ") : "bottom";
const $6adccf1fad1dbe9e$export$96c92ef65bacbebd = (t)=>t ? t.replace("-", " ") : "bottom";
const $6adccf1fad1dbe9e$export$3b23a69c095b8e72 = (t)=>t ? t.replace(" ", "-") : "bottom";
const $6adccf1fad1dbe9e$export$ac94fefc82bff952 = (t)=>{
    if (!t) return "bottom";
    switch(t){
        case "bottom":
        default:
            return "top center";
        case "top":
            return "bottom center";
        case "left":
            return "right center";
        case "right":
            return "left center";
        case "bottom-left":
            return "top left";
        case "bottom-right":
            return "top right";
        case "top-left":
            return "bottom left";
        case "top-right":
            return "bottom right";
        case "left-top":
            return "right top";
        case "left-bottom":
            return "right bottom";
        case "right-top":
            return "left top";
        case "right-bottom":
            return "left bottom";
    }
};


function $8dbdb88037e00bd4$export$542a6fd13ac93354(d = {}) {
    const { ref: u, triggerRef: f, scrollRef: m, isOpen: g, defaultOpen: O, onOpenChange: c, isBordered: b, borderWeight: h, disableShadow: y, shouldFlip: P = !0, offset: v = 12, placement: C = "bottom", onClose: R, triggerType: D = "dialog", isDismissable: B = !0, shouldCloseOnBlur: x = !1, isKeyboardDismissDisabled: w = !1, disableAnimation: A = !1, shouldCloseOnInteractOutside: E } = d, F = (0, $acw62.useRef)(null), I = (0, $acw62.useRef)(null), K = u || F, S = f || I, T = (0, $92bbed67fcd60c87$export$61c6a8c84e605fb6)({
        isOpen: g,
        defaultOpen: O,
        onOpenChange: c
    }), [W, j] = (0, $acw62.useState)(!T.isOpen), k = (0, $acw62.useMemo)(()=>T.isOpen ? "open" : "closed", [
        T.isOpen
    ]), q = (0, $acw62.useCallback)(()=>{
        null == R || R(), T.close();
    }, [
        T,
        R
    ]), z = (0, $acw62.useCallback)(()=>{
        j(!1);
    }, []), G = (0, $acw62.useCallback)(()=>{
        j(!0);
    }, []), { triggerProps: H, overlayProps: J } = (0, $e0fe69584fec2898$export$f9d5c8beee7d008d)({
        type: D
    }, T, S), L = (0, $acw62.useMemo)(()=>(0, $6adccf1fad1dbe9e$export$2e2101229991bd1b)(C), [
        C
    ]), { overlayProps: M } = (0, $e0fe69584fec2898$export$d39e1813b3bdd0e1)({
        isOpen: T.isOpen,
        targetRef: S,
        scrollRef: m,
        placement: L,
        overlayRef: K,
        shouldFlip: P,
        offset: v
    }), N = (0, $acw62.useCallback)((e = {}, o = null)=>({
            ...null != f && f.current ? (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(H, e) : (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(e, H),
            ref: (0, $c5e08d37e4dd87be$export$c9058316764c140e)(S, o)
        }), [
        S,
        f,
        H
    ]), Q = (0, $acw62.useCallback)((e = {})=>({
            ...e,
            ...J,
            ...M,
            "data-state": k,
            "data-placement": C
        }), [
        k,
        M,
        J,
        C
    ]);
    return {
        state: T,
        exited: W,
        overlayRef: K,
        triggerRef: S,
        placement: C,
        disableShadow: y,
        disableAnimation: A,
        shouldCloseOnBlur: x,
        isDismissable: B,
        isBordered: b,
        borderWeight: h,
        isKeyboardDismissDisabled: w,
        shouldCloseOnInteractOutside: E,
        isOpen: T.isOpen,
        onClose: q,
        onExited: G,
        onEntered: z,
        triggerProps: H,
        overlayProps: J,
        positionProps: M,
        getTriggerProps: N,
        getPopoverProps: Q
    };
}



var $acw62 = parcelRequire("acw62");
function $7e6c82989473a86a$export$fd42f52fd3ae1109(t = {}) {
    const { strict: e = !0, errorMessage: o = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider", name: n } = t, c = $acw62.createContext(void 0);
    return c.displayName = n, [
        c.Provider,
        function t() {
            const n = $acw62.useContext(c);
            if (!n && e) {
                const r = new Error(o);
                throw r.name = "ContextError", null == Error.captureStackTrace || Error.captureStackTrace(r, t), r;
            }
            return n;
        },
        c
    ];
}


const [$6198816e2c9bc166$export$bf694c7c431c162a, $6198816e2c9bc166$export$1468d0761b26e6c8] = (0, $7e6c82989473a86a$export$fd42f52fd3ae1109)({
    name: "PopoverContext",
    errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
});




const $ec736fdcb6c67be4$var$p = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((i, p)=>{
    const { children: s, ...n } = i, f = (0, $8dbdb88037e00bd4$export$542a6fd13ac93354)({
        ref: p,
        ...n
    }), [c, l] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(s), x = f.state.isOpen || !f.exited;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $6198816e2c9bc166$export$bf694c7c431c162a), {
        value: f,
        children: [
            c,
            x && (0, $7b02d682eb115277$exports.jsx)((0, $e0fe69584fec2898$export$b47c3594eab58386), {
                children: l
            })
        ]
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($ec736fdcb6c67be4$var$p.displayName = "NextUI.Popover"), $ec736fdcb6c67be4$var$p.toString = ()=>".nextui-popover";
var $ec736fdcb6c67be4$export$2e2bcd8739ae039 = $ec736fdcb6c67be4$var$p;



var $acw62 = parcelRequire("acw62");






const $38b102f04427884a$var$s = $acw62.forwardRef((p, s)=>{
    const { state: m, triggerRef: l, getTriggerProps: a } = (0, $6198816e2c9bc166$export$1468d0761b26e6c8)(), { children: f, ...c } = p, g = ()=>m.open(), { buttonProps: d } = (0, $0765cc1e8d6648f2$export$ea18c227d4417cc3)({
        onPress: g,
        ...c
    }, l), u = $acw62.Children.only(f), [, v] = (0, $1025b45907e9388e$export$d23950bdb3876813)(p.children, (0, $f992dede62d0c3b0$export$2e2bcd8739ae039)), x = void 0 !== (null == v ? void 0 : v[0]);
    return $acw62.cloneElement(u, a((0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(u.props, x ? {
        onPress: g,
        ...c
    } : d), u.ref));
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($38b102f04427884a$var$s.displayName = "NextUI.PopoverTrigger"), $38b102f04427884a$var$s.toString = ()=>".nextui-popover-trigger";
var $38b102f04427884a$export$2e2bcd8739ae039 = $38b102f04427884a$var$s;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
function $be5241e7da331697$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $be5241e7da331697$var$$40df3f8667284809$exports = {};
$be5241e7da331697$var$$parcel$export($be5241e7da331697$var$$40df3f8667284809$exports, "useDialog", ()=>$be5241e7da331697$export$d55e7ee900f34e93);
function $be5241e7da331697$export$d55e7ee900f34e93(props, ref) {
    let { role: role = "dialog" } = props;
    let titleId = (0, $4d60a29ecf011a9e$export$b4cc09c592e8fdb8)();
    titleId = props["aria-label"] ? undefined : titleId;
    // Focus the dialog itself on mount, unless a child element is already focused.
    (0, $acw62.useEffect)(()=>{
        if (ref.current && !ref.current.contains(document.activeElement)) {
            (0, $066ee5e43859dd8f$export$80f3e147d781571c)(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            let timeout = setTimeout(()=>{
                if (document.activeElement === ref.current) {
                    ref.current.blur();
                    (0, $066ee5e43859dd8f$export$80f3e147d781571c)(ref.current);
                }
            }, 500);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        ref
    ]);
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: {
            ...(0, $4d60a29ecf011a9e$export$457c3d6518dd4c6f)(props, {
                labelable: true
            }),
            role: role,
            tabIndex: -1,
            "aria-labelledby": props["aria-labelledby"] || titleId
        },
        titleProps: {
            id: titleId
        }
    };
}









const $f08b4bd203126a59$export$afb3a495443049b8 = (0, $07d095cbefc9a288$export$d25ddfdf17c3ad3e)({
    "0%": {
        opacity: 0,
        transform: "scale(0.95)"
    },
    "60%": {
        opacity: .75,
        transform: "scale(1.05)"
    },
    "100%": {
        opacity: 1,
        transform: "scale(1)"
    }
});
const $f08b4bd203126a59$export$ce4dfa327814c28b = (0, $07d095cbefc9a288$export$d25ddfdf17c3ad3e)({
    "0%": {
        opacity: 1,
        transform: "scale(1)"
    },
    "100%": {
        opacity: 0,
        transform: "scale(0.5)"
    }
});
const $f08b4bd203126a59$export$68b2a230a4b4ad40 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    $$popoverMinWidth: "$space$13",
    $$popoverMinHeight: "$space$13",
    $$popoverBorderRadius: "$radii$lg",
    $$popoverBackground: "$colors$backgroundContrast",
    $$popoverBoxShadow: "$shadows$md",
    $$popoverBorderColor: "$colors$border",
    boxShadow: "$$popoverBoxShadow",
    outline: "none",
    overflow: "hidden auto",
    bg: "$$popoverBackground",
    display: "inline-flex",
    flexDirection: "column",
    boxSizing: "border-box",
    minWidth: "$$popoverMinWidth",
    minHeight: "$$popoverMinHeight",
    maxWidth: "calc(100% - $$popoverMinWidth)",
    maxHeight: "calc(100% - $$popoverMinWidth)",
    borderRadius: "$$popoverBorderRadius",
    animationFillMode: "forwards",
    willChange: "transform, opacity",
    "@motion": {
        transition: "none"
    },
    "&.nextui-popover-content-enter": {
        animationName: $f08b4bd203126a59$export$afb3a495443049b8,
        animationTimingFunction: "ease-out",
        animationDirection: "normal",
        animationDuration: "250ms"
    },
    "&.nextui-popover-content-leave": {
        animationName: $f08b4bd203126a59$export$ce4dfa327814c28b,
        animationTimingFunction: "ease-in",
        animationDuration: "60ms"
    },
    variants: {
        disableShadow: {
            true: {
                boxShadow: "none"
            }
        },
        isBordered: {
            true: {
                borderStyle: "solid",
                borderColor: "$$popoverBorderColor"
            }
        },
        borderWeight: {
            light: {
                bw: "$light",
                $$popoverBorderWeight: "$borderWeights$light"
            },
            normal: {
                bw: "$normal",
                $$popoverBorderWeight: "$borderWeights$normal"
            },
            bold: {
                bw: "$bold",
                $$popoverBorderWeight: "$borderWeights$bold"
            },
            extrabold: {
                bw: "$extrabold",
                $$popoverBorderWeight: "$borderWeights$extrabold"
            },
            black: {
                bw: "$black",
                $$popoverBorderWeight: "$borderWeights$black"
            }
        }
    },
    defaultVariants: {
        isBordered: !1,
        borderWeight: "light"
    }
}, (0, $eaf275b21629a4ec$export$ab780f34ea253ed3));
const $f08b4bd203126a59$export$86892ef006632c29 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    transform: "translateZ(0)",
    backfaceVisibility: "hidden"
});






const $b6b0490cd9f9a630$var$O = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((e, m)=>{
    const { children: O, as: g, css: D, className: y, ...C } = e, { state: P, placement: j, overlayRef: F, disableAnimation: N, disableShadow: B, shouldCloseOnBlur: E, isDismissable: w, isKeyboardDismissDisabled: I, shouldCloseOnInteractOutside: S, getPopoverProps: T, isBordered: K, borderWeight: R, onClose: V, onEntered: W, onExited: A } = (0, $6198816e2c9bc166$export$1468d0761b26e6c8)(), U = (0, $6adccf1fad1dbe9e$export$ac94fefc82bff952)(j), { modalProps: k } = (0, $e0fe69584fec2898$export$33ffd74ebf07f060)({
        isDisabled: !0
    }), { dialogProps: q } = (0, $be5241e7da331697$export$d55e7ee900f34e93)({
        role: "dialog"
    }, F), { overlayProps: z } = (0, $e0fe69584fec2898$export$ea8f71083e90600f)({
        onClose: V,
        isOpen: P.isOpen,
        isDismissable: w && P.isOpen,
        shouldCloseOnBlur: E,
        isKeyboardDismissDisabled: I,
        shouldCloseOnInteractOutside: S
    }, F), G = (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)({
        isBordered: K,
        disableShadow: B,
        borderWeight: R
    }, C), { isFocusVisible: H, focusProps: J } = (0, $066ee5e43859dd8f$export$4e328f61c538687f)(), L = (0, $7b02d682eb115277$exports.jsxs)((0, $f08b4bd203126a59$export$68b2a230a4b4ad40), {
        ref: (0, $c5e08d37e4dd87be$export$c9058316764c140e)(F, m),
        ...T((0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(z, k, q, J, G)),
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-popover-content-container", y),
        isFocusVisible: H,
        as: g,
        css: {
            transformOrigin: U,
            ...D
        },
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $e0fe69584fec2898$export$2317d149ed6f78c4), {
                onDismiss: V
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $f08b4bd203126a59$export$86892ef006632c29), {
                className: "nextui-popover-content",
                children: O
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $e0fe69584fec2898$export$2317d149ed6f78c4), {
                onDismiss: V
            })
        ]
    });
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: N ? P.isOpen ? (0, $7b02d682eb115277$exports.jsx)((0, $066ee5e43859dd8f$export$20e40289641fbbb6), {
            restoreFocus: !0,
            children: L
        }) : null : (0, $7b02d682eb115277$exports.jsx)((0, $066ee5e43859dd8f$export$20e40289641fbbb6), {
            restoreFocus: !0,
            children: (0, $7b02d682eb115277$exports.jsx)((0, $0df3637bce142719$export$2e2bcd8739ae039), {
                visible: P.isOpen,
                name: "nextui-popover-content",
                enterTime: 20,
                leaveTime: 60,
                clearTime: 300,
                onExited: A,
                onEntered: W,
                children: L
            })
        })
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($b6b0490cd9f9a630$var$O.displayName = "NextUI.PopoverContent"), $b6b0490cd9f9a630$var$O.toString = ()=>".nextui-popover-content";
var $b6b0490cd9f9a630$export$2e2bcd8739ae039 = $b6b0490cd9f9a630$var$O;



(0, $ec736fdcb6c67be4$export$2e2bcd8739ae039).Content = (0, $b6b0490cd9f9a630$export$2e2bcd8739ae039), (0, $ec736fdcb6c67be4$export$2e2bcd8739ae039).Trigger = (0, $38b102f04427884a$export$2e2bcd8739ae039);
var $8f68f1f95daa83c1$export$2e2bcd8739ae039 = (0, $ec736fdcb6c67be4$export$2e2bcd8739ae039);



const [$0a9da20457530022$export$8177a931fccf3109, $0a9da20457530022$export$28c3a9869c2838c2] = (0, $7e6c82989473a86a$export$fd42f52fd3ae1109)({
    name: "DropdownContext",
    errorMessage: "useDropdownContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Dropdown />`"
});




const $8ec1994aff100c6d$var$n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((r, e)=>{
    const { children: n, ...p } = r, { getMenuTriggerProps: m } = (0, $0a9da20457530022$export$28c3a9869c2838c2)();
    return (0, $7b02d682eb115277$exports.jsx)((0, $8f68f1f95daa83c1$export$2e2bcd8739ae039).Trigger, {
        ...m(p),
        children: n
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($8ec1994aff100c6d$var$n.displayName = "NextUI.DropdownTrigger"), $8ec1994aff100c6d$var$n.toString = ()=>".nextui-dropdown-trigger";
var $8ec1994aff100c6d$export$2e2bcd8739ae039 = $8ec1994aff100c6d$var$n;



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $0368794483ab6c58$var$$704cf1d3b684cc5c$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $0368794483ab6c58$var$$704cf1d3b684cc5c$var$SSRContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($0368794483ab6c58$var$$704cf1d3b684cc5c$var$defaultContext);
function $0368794483ab6c58$export$9f8ac96af4b1b2ae(props) {
    let cur = (0, $acw62.useContext)($0368794483ab6c58$var$$704cf1d3b684cc5c$var$SSRContext);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $0368794483ab6c58$var$$704cf1d3b684cc5c$var$defaultContext ? "" : `${cur.prefix}-${++cur.current}`,
            current: 0
        }), [
        cur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0368794483ab6c58$var$$704cf1d3b684cc5c$var$SSRContext.Provider, {
        value: value
    }, props.children);
}
let $0368794483ab6c58$var$$704cf1d3b684cc5c$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
function $0368794483ab6c58$export$619500959fc48b26(defaultId) {
    let ctx = (0, $acw62.useContext)($0368794483ab6c58$var$$704cf1d3b684cc5c$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $0368794483ab6c58$var$$704cf1d3b684cc5c$var$defaultContext && !$0368794483ab6c58$var$$704cf1d3b684cc5c$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    return (0, $acw62.useMemo)(()=>defaultId || `react-aria${ctx.prefix}-${++ctx.current}`, [
        defaultId
    ]);
}
function $0368794483ab6c58$export$535bd6ca7f90a273() {
    let cur = (0, $acw62.useContext)($0368794483ab6c58$var$$704cf1d3b684cc5c$var$SSRContext);
    let isInSSRContext = cur !== $0368794483ab6c58$var$$704cf1d3b684cc5c$var$defaultContext;
    let [isSSR, setIsSSR] = (0, $acw62.useState)(isInSSRContext);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof window !== "undefined" && isInSSRContext) // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return isSSR;
}



const $df6686ed111e5fc0$export$e5c5a5f917a5871c = typeof window !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};
let $df6686ed111e5fc0$var$$bdb11010cef70236$var$idsUpdaterMap = new Map();
function $df6686ed111e5fc0$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $acw62.useState)(defaultId);
    let nextId = (0, $acw62.useRef)(null);
    let res = (0, $0368794483ab6c58$export$619500959fc48b26)(value);
    let updateValue = (0, $acw62.useCallback)((val)=>{
        nextId.current = val;
    }, []);
    $df6686ed111e5fc0$var$$bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    $df6686ed111e5fc0$export$e5c5a5f917a5871c(()=>{
        let r = res;
        return ()=>{
            $df6686ed111e5fc0$var$$bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    // This cannot cause an infinite loop because the ref is updated first.
    // eslint-disable-next-line
    (0, $acw62.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $df6686ed111e5fc0$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $df6686ed111e5fc0$var$$bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $df6686ed111e5fc0$var$$bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $df6686ed111e5fc0$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $df6686ed111e5fc0$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = $df6686ed111e5fc0$export$14d238f342723f25(id);
    let updateId = (0, $acw62.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : null;
        });
    }, [
        id,
        setResolvedId
    ]);
    $df6686ed111e5fc0$export$e5c5a5f917a5871c(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}
function $df6686ed111e5fc0$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}
function $df6686ed111e5fc0$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = $df6686ed111e5fc0$export$e08e3b67e392101e(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(a, b);
            else if (key === "id" && a && b) result.id = $df6686ed111e5fc0$export$cd8c9cb68f842629(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}
function $df6686ed111e5fc0$export$c9058316764c140e(...refs) {
    return (value)=>{
        for (let ref of refs){
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        }
    };
}
const $df6686ed111e5fc0$var$$65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
const $df6686ed111e5fc0$var$$65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
const $df6686ed111e5fc0$var$$65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $df6686ed111e5fc0$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($df6686ed111e5fc0$var$$65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $df6686ed111e5fc0$var$$65484d02dcb7eb3e$var$labelablePropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $df6686ed111e5fc0$var$$65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}
function $df6686ed111e5fc0$export$de79e2c695e052f3(element) {
    if ($df6686ed111e5fc0$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $df6686ed111e5fc0$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $df6686ed111e5fc0$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $df6686ed111e5fc0$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $df6686ed111e5fc0$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($df6686ed111e5fc0$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $df6686ed111e5fc0$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            var focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $df6686ed111e5fc0$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $df6686ed111e5fc0$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $df6686ed111e5fc0$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $df6686ed111e5fc0$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}
function $df6686ed111e5fc0$export$622cea445a1c5b7d(element, reverse, orientation = "horizontal") {
    let rect = element.getBoundingClientRect();
    if (reverse) return orientation === "horizontal" ? rect.right : rect.bottom;
    return orientation === "horizontal" ? rect.left : rect.top;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    let onTransitionStart = (e)=>{
        // Add the transitioning property to the list for this element.
        let transitions = $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd);
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        // Remove property from list of transitioning properties.
        let properties = $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $df6686ed111e5fc0$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $df6686ed111e5fc0$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}
// Keep track of elements that we are currently handling dragging for via useDrag1D.
// If there's an ancestor and a descendant both using useDrag1D(), and the user starts
// dragging the descendant, we don't want useDrag1D events to fire for the ancestor.
const $df6686ed111e5fc0$var$$9cc09df9fd7676be$var$draggingElements = [];
function $df6686ed111e5fc0$export$7bbed75feba39706(props) {
    console.warn("useDrag1D is deprecated, please use `useMove` instead https://react-spectrum.adobe.com/react-aria/useMove.html");
    let { containerRef: containerRef, reverse: reverse, orientation: orientation, onHover: onHover, onDrag: onDrag, onPositionChange: onPositionChange, onIncrement: onIncrement, onDecrement: onDecrement, onIncrementToMax: onIncrementToMax, onDecrementToMin: onDecrementToMin, onCollapseToggle: onCollapseToggle } = props;
    let getPosition = (e)=>orientation === "horizontal" ? e.clientX : e.clientY;
    let getNextOffset = (e)=>{
        let containerOffset = $df6686ed111e5fc0$export$622cea445a1c5b7d(containerRef.current, reverse, orientation);
        let mouseOffset = getPosition(e);
        let nextOffset = reverse ? containerOffset - mouseOffset : mouseOffset - containerOffset;
        return nextOffset;
    };
    let dragging = (0, $acw62.useRef)(false);
    let prevPosition = (0, $acw62.useRef)(0);
    // Keep track of the current handlers in a ref so that the events can access them.
    let handlers = (0, $acw62.useRef)({
        onPositionChange: onPositionChange,
        onDrag: onDrag
    });
    handlers.current.onDrag = onDrag;
    handlers.current.onPositionChange = onPositionChange;
    let onMouseDragged = (e)=>{
        e.preventDefault();
        let nextOffset = getNextOffset(e);
        if (!dragging.current) {
            dragging.current = true;
            if (handlers.current.onDrag) handlers.current.onDrag(true);
            if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        }
        if (prevPosition.current === nextOffset) return;
        prevPosition.current = nextOffset;
        if (onPositionChange) onPositionChange(nextOffset);
    };
    let onMouseUp = (e)=>{
        const target = e.target;
        dragging.current = false;
        let nextOffset = getNextOffset(e);
        if (handlers.current.onDrag) handlers.current.onDrag(false);
        if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        $df6686ed111e5fc0$var$$9cc09df9fd7676be$var$draggingElements.splice($df6686ed111e5fc0$var$$9cc09df9fd7676be$var$draggingElements.indexOf(target), 1);
        window.removeEventListener("mouseup", onMouseUp, false);
        window.removeEventListener("mousemove", onMouseDragged, false);
    };
    let onMouseDown = (e)=>{
        const target = e.currentTarget;
        // If we're already handling dragging on a descendant with useDrag1D, then
        // we don't want to handle the drag motion on this target as well.
        if ($df6686ed111e5fc0$var$$9cc09df9fd7676be$var$draggingElements.some((elt)=>target.contains(elt))) return;
        $df6686ed111e5fc0$var$$9cc09df9fd7676be$var$draggingElements.push(target);
        window.addEventListener("mousemove", onMouseDragged, false);
        window.addEventListener("mouseup", onMouseUp, false);
    };
    let onMouseEnter = ()=>{
        if (onHover) onHover(true);
    };
    let onMouseOut = ()=>{
        if (onHover) onHover(false);
    };
    let onKeyDown = (e)=>{
        switch(e.key){
            case "Left":
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case "Up":
            case "ArrowUp":
                if (orientation === "vertical") {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case "Right":
            case "ArrowRight":
                if (orientation === "horizontal") {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case "Down":
            case "ArrowDown":
                if (orientation === "vertical") {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case "Home":
                e.preventDefault();
                if (onDecrementToMin) onDecrementToMin();
                break;
            case "End":
                e.preventDefault();
                if (onIncrementToMax) onIncrementToMax();
                break;
            case "Enter":
                e.preventDefault();
                if (onCollapseToggle) onCollapseToggle();
                break;
        }
    };
    return {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        onKeyDown: onKeyDown
    };
}
function $df6686ed111e5fc0$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $acw62.useRef)(new Map());
    let addGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        var ref;
        let fn = ((ref = globalListeners.current.get(listener)) === null || ref === void 0 ? void 0 : ref.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $acw62.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    // eslint-disable-next-line arrow-body-style
    (0, $acw62.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}
function $df6686ed111e5fc0$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id, "aria-label": label, "aria-labelledby": labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = $df6686ed111e5fc0$export$f680877a34711e37(id);
    if (labelledBy && label) {
        let ids = new Set([
            ...labelledBy.trim().split(/\s+/),
            id
        ]);
        labelledBy = [
            ...ids
        ].join(" ");
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        "aria-label": label,
        "aria-labelledby": labelledBy
    };
}
function $df6686ed111e5fc0$export$4338b53315abf666(forwardedRef) {
    const objRef = (0, $acw62.useRef)();
    /**
   * We're using `useLayoutEffect` here instead of `useEffect` because we want
   * to make sure that the `ref` value is up to date before other places in the
   * the execution cycle try to read it.
   */ $df6686ed111e5fc0$export$e5c5a5f917a5871c(()=>{
        if (!forwardedRef) return;
        if (typeof forwardedRef === "function") forwardedRef(objRef.current);
        else forwardedRef.current = objRef.current;
    }, [
        forwardedRef
    ]);
    return objRef;
}
function $df6686ed111e5fc0$export$496315a1608d9602(effect, dependencies) {
    const isInitialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}
function $df6686ed111e5fc0$var$$9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== "undefined";
}
function $df6686ed111e5fc0$export$683480f191c0e3ea(options) {
    const { ref: ref, onResize: onResize } = options;
    (0, $acw62.useEffect)(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$df6686ed111e5fc0$var$$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener("resize", onResize, false);
            return ()=>{
                window.removeEventListener("resize", onResize, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}
function $df6686ed111e5fc0$export$4debdb1a3f0fa79e(context, ref) {
    $df6686ed111e5fc0$export$e5c5a5f917a5871c(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                context.ref.current = null;
            };
        }
    }, [
        context,
        ref
    ]);
}
function $df6686ed111e5fc0$export$cfa2225e87938781(node) {
    while(node && !$df6686ed111e5fc0$var$$62d8ded9296f3872$var$isScrollable(node))node = node.parentElement;
    return node || document.scrollingElement || document.documentElement;
}
function $df6686ed111e5fc0$var$$62d8ded9296f3872$var$isScrollable(node) {
    let style = window.getComputedStyle(node);
    return /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
}
// @ts-ignore
let $df6686ed111e5fc0$var$$5df64b3807dc15ee$var$visualViewport = typeof window !== "undefined" && window.visualViewport;
function $df6686ed111e5fc0$export$d699905dd57c73ca() {
    let [size1, setSize] = (0, $acw62.useState)(()=>$df6686ed111e5fc0$var$$5df64b3807dc15ee$var$getViewportSize());
    (0, $acw62.useEffect)(()=>{
        // Use visualViewport api to track available height even on iOS virtual keyboard opening
        let onResize = ()=>{
            setSize((size)=>{
                let newSize = $df6686ed111e5fc0$var$$5df64b3807dc15ee$var$getViewportSize();
                if (newSize.width === size.width && newSize.height === size.height) return size;
                return newSize;
            });
        };
        if (!$df6686ed111e5fc0$var$$5df64b3807dc15ee$var$visualViewport) window.addEventListener("resize", onResize);
        else $df6686ed111e5fc0$var$$5df64b3807dc15ee$var$visualViewport.addEventListener("resize", onResize);
        return ()=>{
            if (!$df6686ed111e5fc0$var$$5df64b3807dc15ee$var$visualViewport) window.removeEventListener("resize", onResize);
            else $df6686ed111e5fc0$var$$5df64b3807dc15ee$var$visualViewport.removeEventListener("resize", onResize);
        };
    }, []);
    return size1;
}
function $df6686ed111e5fc0$var$$5df64b3807dc15ee$var$getViewportSize() {
    return {
        width: ($df6686ed111e5fc0$var$$5df64b3807dc15ee$var$visualViewport === null || $df6686ed111e5fc0$var$$5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $df6686ed111e5fc0$var$$5df64b3807dc15ee$var$visualViewport.width) || window.innerWidth,
        height: ($df6686ed111e5fc0$var$$5df64b3807dc15ee$var$visualViewport === null || $df6686ed111e5fc0$var$$5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $df6686ed111e5fc0$var$$5df64b3807dc15ee$var$visualViewport.height) || window.innerHeight
    };
}
let $df6686ed111e5fc0$var$$ef06256079686ba0$var$descriptionId = 0;
const $df6686ed111e5fc0$var$$ef06256079686ba0$var$descriptionNodes = new Map();
function $df6686ed111e5fc0$export$f8aeda7b10753fa1(description) {
    let [id1, setId] = (0, $acw62.useState)(null);
    $df6686ed111e5fc0$export$e5c5a5f917a5871c(()=>{
        if (!description) return;
        let desc = $df6686ed111e5fc0$var$$ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$df6686ed111e5fc0$var$$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $df6686ed111e5fc0$var$$ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (--desc.refCount === 0) {
                desc.element.remove();
                $df6686ed111e5fc0$var$$ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id1 : undefined
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $df6686ed111e5fc0$var$$c87311424ea30a05$var$testUserAgent(re) {
    var ref;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((ref = window.navigator["userAgentData"]) === null || ref === void 0 ? void 0 : ref.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $df6686ed111e5fc0$var$$c87311424ea30a05$var$testPlatform(re) {
    var ref;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((ref = window.navigator["userAgentData"]) === null || ref === void 0 ? void 0 : ref.platform) || window.navigator.platform) : false;
}
function $df6686ed111e5fc0$export$9ac100e40613ea10() {
    return $df6686ed111e5fc0$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $df6686ed111e5fc0$export$186c6964ca17d99() {
    return $df6686ed111e5fc0$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $df6686ed111e5fc0$export$7bef049ce92e4224() {
    return $df6686ed111e5fc0$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || $df6686ed111e5fc0$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $df6686ed111e5fc0$export$fedb369cb70207f1() {
    return $df6686ed111e5fc0$export$186c6964ca17d99() || $df6686ed111e5fc0$export$7bef049ce92e4224();
}
function $df6686ed111e5fc0$export$e1865c3bedcd822b() {
    return $df6686ed111e5fc0$export$9ac100e40613ea10() || $df6686ed111e5fc0$export$fedb369cb70207f1();
}
function $df6686ed111e5fc0$export$78551043582a6a98() {
    return $df6686ed111e5fc0$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$df6686ed111e5fc0$export$6446a186d09e379e();
}
function $df6686ed111e5fc0$export$6446a186d09e379e() {
    return $df6686ed111e5fc0$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
}
function $df6686ed111e5fc0$export$a11b0059900ceec8() {
    return $df6686ed111e5fc0$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
}
function $df6686ed111e5fc0$export$90fc3a17d93f704c(ref, event, handler1, options) {
    let handlerRef = (0, $acw62.useRef)(handler1);
    handlerRef.current = handler1;
    let isDisabled = handler1 == null;
    (0, $acw62.useEffect)(()=>{
        if (isDisabled) return;
        let element = ref.current;
        let handler = (e)=>handlerRef.current.call(this, e);
        element.addEventListener(event, handler, options);
        return ()=>{
            element.removeEventListener(event, handler, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled
    ]);
}
function $df6686ed111e5fc0$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $acw62.useState)(defaultValue);
    let valueRef = (0, $acw62.useRef)(value);
    let effect = (0, $acw62.useRef)(null);
    valueRef.current = value;
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $acw62.useRef)(null);
    nextRef.current = ()=>{
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef.current();
        else setValue(newValue.value);
    };
    $df6686ed111e5fc0$export$e5c5a5f917a5871c(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef.current();
    });
    let queue = (0, $acw62.useCallback)((fn)=>{
        effect.current = fn(valueRef.current);
        nextRef.current();
    }, [
        effect,
        nextRef
    ]);
    return [
        value,
        queue
    ];
}
function $df6686ed111e5fc0$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $df6686ed111e5fc0$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "left");
    let offsetY = $df6686ed111e5fc0$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "top");
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    let maxX = x + scrollView.offsetWidth;
    let maxY = y + scrollView.offsetHeight;
    if (offsetX <= x) x = offsetX;
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= y) y = offsetY;
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $df6686ed111e5fc0$var$$2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === "left" ? "offsetLeft" : "offsetTop";
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}




var $acw62 = parcelRequire("acw62");
// Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $1eef7302de9b85e9$var$$14c0b72509d70225$var$state = "default";
let $1eef7302de9b85e9$var$$14c0b72509d70225$var$savedUserSelect = "";
let $1eef7302de9b85e9$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $1eef7302de9b85e9$var$$14c0b72509d70225$export$16a4697467175487(target) {
    if ((0, $df6686ed111e5fc0$export$fedb369cb70207f1)()) {
        if ($1eef7302de9b85e9$var$$14c0b72509d70225$var$state === "default") {
            $1eef7302de9b85e9$var$$14c0b72509d70225$var$savedUserSelect = document.documentElement.style.webkitUserSelect;
            document.documentElement.style.webkitUserSelect = "none";
        }
        $1eef7302de9b85e9$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $1eef7302de9b85e9$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $1eef7302de9b85e9$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
    if ((0, $df6686ed111e5fc0$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($1eef7302de9b85e9$var$$14c0b72509d70225$var$state !== "disabled") return;
        $1eef7302de9b85e9$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            // Wait for any CSS transitions to complete so we don't recompute style
            // for the whole page in the middle of the animation and cause jank.
            (0, $df6686ed111e5fc0$export$24490316f764c430)(()=>{
                // Avoid race conditions
                if ($1eef7302de9b85e9$var$$14c0b72509d70225$var$state === "restoring") {
                    if (document.documentElement.style.webkitUserSelect === "none") document.documentElement.style.webkitUserSelect = $1eef7302de9b85e9$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $1eef7302de9b85e9$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $1eef7302de9b85e9$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $1eef7302de9b85e9$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $1eef7302de9b85e9$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $1eef7302de9b85e9$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}
function $1eef7302de9b85e9$var$$8a9cb279dc87e130$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    return event.detail === 0 && !event.pointerType;
}
class $1eef7302de9b85e9$var$$8a9cb279dc87e130$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $1eef7302de9b85e9$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $acw62.useRef)({
        isFocused: false,
        onBlur: onBlur,
        observer: null
    });
    stateRef.current.onBlur = onBlur;
    // Clean up MutationObserver on unmount. See below.
    // eslint-disable-next-line arrow-body-style
    (0, $df6686ed111e5fc0$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    // This function is called during a React onFocus event.
    return (0, $acw62.useCallback)((e1)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e1.target instanceof HTMLButtonElement || e1.target instanceof HTMLInputElement || e1.target instanceof HTMLTextAreaElement || e1.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e1.target;
            let onBlurHandler = (e)=>{
                var _current, ref;
                stateRef.current.isFocused = false;
                if (target.disabled) (ref = (_current = stateRef.current).onBlur) === null || ref === void 0 || ref.call(_current, new $1eef7302de9b85e9$var$$8a9cb279dc87e130$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    stateRef.current.observer.disconnect();
                    target.dispatchEvent(new FocusEvent("blur"));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, []);
}
const $1eef7302de9b85e9$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
$1eef7302de9b85e9$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $acw62.useContext)($1eef7302de9b85e9$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $df6686ed111e5fc0$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    (0, $df6686ed111e5fc0$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
function $1eef7302de9b85e9$export$45712eceda6fad21(props) {
    let { onPress: onPress1, onPressChange: onPressChange1, onPressStart: onPressStart1, onPressEnd: onPressEnd1, onPressUp: onPressUp1, isDisabled: isDisabled1, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let propsRef = (0, $acw62.useRef)(null);
    propsRef.current = {
        onPress: onPress1,
        onPressChange: onPressChange1,
        onPressStart: onPressStart1,
        onPressEnd: onPressEnd1,
        onPressUp: onPressUp1,
        isDisabled: isDisabled1,
        shouldCancelOnPointerExit: shouldCancelOnPointerExit
    };
    let [isPressed, setPressed] = (0, $acw62.useState)(false);
    let ref = (0, $acw62.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $df6686ed111e5fc0$export$4eaf04e54aa8eed6)();
    let pressProps1 = (0, $acw62.useMemo)(()=>{
        let state = ref.current;
        let triggerPressStart = (originalEvent, pointerType)=>{
            let { onPressStart: onPressStart, onPressChange: onPressChange, isDisabled: isDisabled } = propsRef.current;
            if (isDisabled || state.didFirePressStart) return;
            if (onPressStart) onPressStart({
                type: "pressstart",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
            if (onPressChange) onPressChange(true);
            state.didFirePressStart = true;
            setPressed(true);
        };
        let triggerPressEnd = (originalEvent, pointerType, wasPressed = true)=>{
            let { onPressEnd: onPressEnd, onPressChange: onPressChange, onPress: onPress, isDisabled: isDisabled } = propsRef.current;
            if (!state.didFirePressStart) return;
            state.ignoreClickAfterPress = true;
            state.didFirePressStart = false;
            if (onPressEnd) onPressEnd({
                type: "pressend",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
            if (onPressChange) onPressChange(false);
            setPressed(false);
            if (onPress && wasPressed && !isDisabled) onPress({
                type: "press",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let triggerPressUp = (originalEvent, pointerType)=>{
            let { onPressUp: onPressUp, isDisabled: isDisabled } = propsRef.current;
            if (isDisabled) return;
            if (onPressUp) onPressUp({
                type: "pressup",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let cancel = (e)=>{
            if (state.isPressed) {
                if (state.isOverTarget) triggerPressEnd($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isPressed = false;
                state.isOverTarget = false;
                state.activePointerId = null;
                state.pointerType = null;
                removeAllGlobalListeners();
                if (!allowTextSelectionOnPress) $1eef7302de9b85e9$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
            }
        };
        let pressProps = {
            onKeyDown (e) {
                if ($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent) && e.currentTarget.contains(e.target)) {
                    if ($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target)) e.preventDefault();
                    e.stopPropagation();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred.
                        addGlobalListener(document, "keyup", onKeyUp, false);
                    }
                }
            },
            onKeyUp (e) {
                if ($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent) && !e.repeat && e.currentTarget.contains(e.target)) triggerPressUp($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0) {
                    e.stopPropagation();
                    if (isDisabled1) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && (state.pointerType === "virtual" || $1eef7302de9b85e9$var$$8a9cb279dc87e130$export$60278871457622de(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled1 && !preventFocusOnPress) (0, $df6686ed111e5fc0$export$de79e2c695e052f3)(e.currentTarget);
                        triggerPressStart(e, "virtual");
                        triggerPressUp(e, "virtual");
                        triggerPressEnd(e, "virtual");
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                }
            }
        };
        let onKeyUp = (e)=>{
            if (state.isPressed && $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e)) {
                if ($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target)) e.preventDefault();
                e.stopPropagation();
                state.isPressed = false;
                let target = e.target;
                triggerPressEnd($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If the target is a link, trigger the click method to open the URL,
                // but defer triggering pressEnd until onClick event handler.
                if (state.target instanceof HTMLElement && (state.target.contains(target) && $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) || state.target.getAttribute("role") === "link")) state.target.click();
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isVirtualPointerEvent(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                e.stopPropagation();
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled1 && !preventFocusOnPress) (0, $df6686ed111e5fc0$export$de79e2c695e052f3)(e.currentTarget);
                    if (!allowTextSelectionOnPress) $1eef7302de9b85e9$var$$14c0b72509d70225$export$16a4697467175487(state.target);
                    triggerPressStart(e, state.pointerType);
                    addGlobalListener(document, "pointermove", onPointerMove, false);
                    addGlobalListener(document, "pointerup", onPointerUp, false);
                    addGlobalListener(document, "pointercancel", onPointerCancel, false);
                }
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if ($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        triggerPressStart($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    triggerPressEnd($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0) {
                    if ($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget) triggerPressEnd($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) $1eef7302de9b85e9$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                e.stopPropagation();
                if (state.ignoreEmulatedMouseEvents) return;
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = $1eef7302de9b85e9$var$$8a9cb279dc87e130$export$60278871457622de(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled1 && !preventFocusOnPress) (0, $df6686ed111e5fc0$export$de79e2c695e052f3)(e.currentTarget);
                triggerPressStart(e, state.pointerType);
                addGlobalListener(document, "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = true;
                    triggerPressStart(e, state.pointerType);
                }
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = false;
                    triggerPressEnd(e, state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType);
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if ($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.isOverTarget) triggerPressEnd($1eef7302de9b85e9$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                let touch = $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled1 && !preventFocusOnPress) (0, $df6686ed111e5fc0$export$de79e2c695e052f3)(e.currentTarget);
                if (!allowTextSelectionOnPress) $1eef7302de9b85e9$var$$14c0b72509d70225$export$16a4697467175487(state.target);
                triggerPressStart(e, state.pointerType);
                addGlobalListener(window, "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (!state.isPressed) return;
                let touch = $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                if (touch && $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    triggerPressEnd(e, state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (!state.isPressed) return;
                let touch = $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                if (touch && $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    triggerPressUp(e, state.pointerType);
                    triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget) triggerPressEnd(e, state.pointerType, false);
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (!allowTextSelectionOnPress) $1eef7302de9b85e9$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled1,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress
    ]);
    // Remove user-select: none in case component unmounts immediately after pressStart
    // eslint-disable-next-line arrow-body-style
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (!allowTextSelectionOnPress) $1eef7302de9b85e9$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(ref.current.target);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $df6686ed111e5fc0$export$9d1611c77c2fe928)(domProps, pressProps1)
    };
}
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event) {
    const { key: key, code: code, target: target } = event;
    const element = target;
    const { tagName: tagName, isContentEditable: isContentEditable } = element;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && tagName !== "INPUT" && tagName !== "TEXTAREA" && isContentEditable !== true && (!$1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element) || role === "button" && key !== "Enter") && // An element with role='link' should only trigger with Enter key
    !(role === "link" && key !== "Enter");
}
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = point.width / 2 || point.radiusX || 0;
    let offsetY = point.height / 2 || point.radiusY || 0;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.draggable;
}
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target) {
    return !((target.tagName === "INPUT" || target.tagName === "BUTTON") && target.type === "submit");
}
function $1eef7302de9b85e9$var$$f6c31cce2adf654f$var$isVirtualPointerEvent(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}
const $1eef7302de9b85e9$export$27c701ed9e449e99 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: children, ...props }, ref)=>{
    let newRef = (0, $acw62.useRef)();
    ref = ref !== null && ref !== void 0 ? ref : newRef;
    let { pressProps: pressProps } = $1eef7302de9b85e9$export$45712eceda6fad21({
        ...props,
        ref: ref
    });
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
        ref: ref,
        ...(0, $df6686ed111e5fc0$export$9d1611c77c2fe928)(child.props, pressProps)
    });
});
const $1eef7302de9b85e9$export$3351871ee4b288b8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $acw62.useRef)(false);
    let prevContext = (0, $acw62.useContext)($1eef7302de9b85e9$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    let context = (0, $df6686ed111e5fc0$export$9d1611c77c2fe928)(prevContext || {}, {
        ...props,
        ref: ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref),
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $df6686ed111e5fc0$export$4debdb1a3f0fa79e)(prevContext, ref);
    (0, $acw62.useEffect)(()=>{
        if (!isRegistered.current) console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1eef7302de9b85e9$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
});
function $1eef7302de9b85e9$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $acw62.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = $1eef7302de9b85e9$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    const onFocus = (0, $acw62.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : null
        }
    };
}
let $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$currentModality = null;
let $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasSetupGlobalListeners = false;
let $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $df6686ed111e5fc0$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($1eef7302de9b85e9$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ($1eef7302de9b85e9$var$$8a9cb279dc87e130$export$60278871457622de(e)) {
        $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents() {
    if (typeof window === "undefined" || $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasSetupGlobalListeners) return;
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function() {
        $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    document.addEventListener("keydown", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener("keyup", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener("click", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    window.addEventListener("focus", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    window.addEventListener("blur", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        document.addEventListener("pointerdown", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("pointermove", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("pointerup", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        document.addEventListener("mousedown", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("mousemove", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("mouseup", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$hasSetupGlobalListeners = true;
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    else document.addEventListener("DOMContentLoaded", $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents);
}
function $1eef7302de9b85e9$export$b9b3dfddab17db27() {
    return $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $1eef7302de9b85e9$export$630ff653c5ada6a9() {
    return $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$currentModality;
}
function $1eef7302de9b85e9$export$8397ddfc504fdb9a(modality) {
    $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$currentModality = modality;
    $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $1eef7302de9b85e9$export$98e20ec92f614cfe() {
    $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $acw62.useState)($1eef7302de9b85e9$var$$507fabe10e71c6fb$var$currentModality);
    (0, $acw62.useEffect)(()=>{
        let handler = ()=>{
            setModality($1eef7302de9b85e9$var$$507fabe10e71c6fb$var$currentModality);
        };
        $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return modality;
}
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    return !(isTextInput && modality === "keyboard" && e instanceof KeyboardEvent && !$1eef7302de9b85e9$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $1eef7302de9b85e9$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(autoFocus || $1eef7302de9b85e9$export$b9b3dfddab17db27());
    $1eef7302de9b85e9$export$ec71b4b83ac08ec3(($507fabe10e71c6fb$export$b9b3dfddab17db27)=>{
        setFocusVisible($507fabe10e71c6fb$export$b9b3dfddab17db27);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $1eef7302de9b85e9$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $acw62.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$1eef7302de9b85e9$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(opts === null || opts === void 0 ? void 0 : opts.isTextInput, modality, e)) return;
            fn($1eef7302de9b85e9$export$b9b3dfddab17db27());
        };
        $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $1eef7302de9b85e9$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, deps);
}
function $1eef7302de9b85e9$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $acw62.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $acw62.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = $1eef7302de9b85e9$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    let onFocus = (0, $acw62.useCallback)((e)=>{
        if (!state.current.isFocusWithin) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            onFocus: null,
            onBlur: null
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $1eef7302de9b85e9$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $1eef7302de9b85e9$var$$6179b936705e76d3$var$hoverCount = 0;
function $1eef7302de9b85e9$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $1eef7302de9b85e9$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $1eef7302de9b85e9$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $1eef7302de9b85e9$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $1eef7302de9b85e9$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $1eef7302de9b85e9$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $1eef7302de9b85e9$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $1eef7302de9b85e9$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $1eef7302de9b85e9$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $1eef7302de9b85e9$var$$6179b936705e76d3$var$hoverCount--;
        if ($1eef7302de9b85e9$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $1eef7302de9b85e9$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $1eef7302de9b85e9$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $1eef7302de9b85e9$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $acw62.useState)(false);
    let state = (0, $acw62.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $acw62.useEffect)($1eef7302de9b85e9$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps1, triggerHoverEnd: triggerHoverEnd1 } = (0, $acw62.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($1eef7302de9b85e9$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$1eef7302de9b85e9$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $acw62.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd1({
            currentTarget: state.target
        }, state.pointerType);
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps1,
        isHovered: isHovered
    };
}
function $1eef7302de9b85e9$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $acw62.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false,
        onInteractOutside: onInteractOutside,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let state = stateRef.current;
    state.onInteractOutside = onInteractOutside;
    state.onInteractOutsideStart = onInteractOutsideStart;
    (0, $acw62.useEffect)(()=>{
        if (isDisabled) return;
        let onPointerDown = (e)=>{
            if ($1eef7302de9b85e9$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref) && state.onInteractOutside) {
                if (state.onInteractOutsideStart) state.onInteractOutsideStart(e);
                state.isPointerDown = true;
            }
        };
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && state.onInteractOutside && $1eef7302de9b85e9$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            // changing these to capture phase fixed combobox
            document.addEventListener("pointerdown", onPointerDown, true);
            document.addEventListener("pointerup", onPointerUp, true);
            return ()=>{
                document.removeEventListener("pointerdown", onPointerDown, true);
                document.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && state.onInteractOutside && $1eef7302de9b85e9$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.onInteractOutside && state.isPointerDown && $1eef7302de9b85e9$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            document.addEventListener("mousedown", onPointerDown, true);
            document.addEventListener("mouseup", onMouseUp, true);
            document.addEventListener("touchstart", onPointerDown, true);
            document.addEventListener("touchend", onTouchEnd, true);
            return ()=>{
                document.removeEventListener("mousedown", onPointerDown, true);
                document.removeEventListener("mouseup", onMouseUp, true);
                document.removeEventListener("touchstart", onPointerDown, true);
                document.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        state,
        isDisabled
    ]);
}
function $1eef7302de9b85e9$var$$e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    // if the event target is no longer in the document
    if (event.target) {
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}
function $1eef7302de9b85e9$var$$93925083ecbb358c$export$48d1ea6320830260(handler) {
    if (!handler) return;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}
function $1eef7302de9b85e9$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: $1eef7302de9b85e9$var$$93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
            onKeyUp: $1eef7302de9b85e9$var$$93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
        }
    };
}
function $1eef7302de9b85e9$export$36da96379f79f245(props) {
    let { onMoveStart: onMoveStart, onMove: onMove, onMoveEnd: onMoveEnd } = props;
    let state = (0, $acw62.useRef)({
        didMove: false,
        lastPosition: null,
        id: null
    });
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $df6686ed111e5fc0$export$4eaf04e54aa8eed6)();
    let moveProps1 = (0, $acw62.useMemo)(()=>{
        let moveProps = {};
        let start = ()=>{
            $1eef7302de9b85e9$var$$14c0b72509d70225$export$16a4697467175487();
            state.current.didMove = false;
        };
        let move = (originalEvent, pointerType, deltaX, deltaY)=>{
            if (deltaX === 0 && deltaY === 0) return;
            if (!state.current.didMove) {
                state.current.didMove = true;
                onMoveStart === null || onMoveStart === void 0 || onMoveStart({
                    type: "movestart",
                    pointerType: pointerType,
                    shiftKey: originalEvent.shiftKey,
                    metaKey: originalEvent.metaKey,
                    ctrlKey: originalEvent.ctrlKey,
                    altKey: originalEvent.altKey
                });
            }
            onMove({
                type: "move",
                pointerType: pointerType,
                deltaX: deltaX,
                deltaY: deltaY,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let end = (originalEvent, pointerType)=>{
            $1eef7302de9b85e9$var$$14c0b72509d70225$export$b0d6fa1ab32e3295();
            if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 || onMoveEnd({
                type: "moveend",
                pointerType: pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        if (typeof PointerEvent === "undefined") {
            let onMouseMove = (e)=>{
                if (e.button === 0) {
                    move(e, "mouse", e.pageX - state.current.lastPosition.pageX, e.pageY - state.current.lastPosition.pageY);
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onMouseUp = (e)=>{
                if (e.button === 0) {
                    end(e, "mouse");
                    removeGlobalListener(window, "mousemove", onMouseMove, false);
                    removeGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            moveProps.onMouseDown = (e)=>{
                if (e.button === 0) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    addGlobalListener(window, "mousemove", onMouseMove, false);
                    addGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            let onTouchMove = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    let { pageX: pageX, pageY: pageY } = e.changedTouches[touch];
                    move(e, "touch", pageX - state.current.lastPosition.pageX, pageY - state.current.lastPosition.pageY);
                    state.current.lastPosition = {
                        pageX: pageX,
                        pageY: pageY
                    };
                }
            };
            let onTouchEnd = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    end(e, "touch");
                    state.current.id = null;
                    removeGlobalListener(window, "touchmove", onTouchMove);
                    removeGlobalListener(window, "touchend", onTouchEnd);
                    removeGlobalListener(window, "touchcancel", onTouchEnd);
                }
            };
            moveProps.onTouchStart = (e)=>{
                if (e.changedTouches.length === 0 || state.current.id != null) return;
                let { pageX: pageX, pageY: pageY, identifier: identifier } = e.changedTouches[0];
                start();
                e.stopPropagation();
                e.preventDefault();
                state.current.lastPosition = {
                    pageX: pageX,
                    pageY: pageY
                };
                state.current.id = identifier;
                addGlobalListener(window, "touchmove", onTouchMove, false);
                addGlobalListener(window, "touchend", onTouchEnd, false);
                addGlobalListener(window, "touchcancel", onTouchEnd, false);
            };
        } else {
            let onPointerMove = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || "mouse";
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    move(e, pointerType, e.pageX - state.current.lastPosition.pageX, e.pageY - state.current.lastPosition.pageY);
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || "mouse";
                    end(e, pointerType);
                    state.current.id = null;
                    removeGlobalListener(window, "pointermove", onPointerMove, false);
                    removeGlobalListener(window, "pointerup", onPointerUp, false);
                    removeGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
            moveProps.onPointerDown = (e)=>{
                if (e.button === 0 && state.current.id == null) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    state.current.id = e.pointerId;
                    addGlobalListener(window, "pointermove", onPointerMove, false);
                    addGlobalListener(window, "pointerup", onPointerUp, false);
                    addGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
        }
        let triggerKeyboardMove = (e, deltaX, deltaY)=>{
            start();
            move(e, "keyboard", deltaX, deltaY);
            end(e, "keyboard");
        };
        moveProps.onKeyDown = (e)=>{
            switch(e.key){
                case "Left":
                case "ArrowLeft":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case "Right":
                case "ArrowRight":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case "Up":
                case "ArrowUp":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case "Down":
                case "ArrowDown":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        state,
        onMoveStart,
        onMove,
        onMoveEnd,
        addGlobalListener,
        removeGlobalListener
    ]);
    return {
        moveProps: moveProps1
    };
}
function $1eef7302de9b85e9$export$2123ff2b87c81ca(props, ref) {
    let { onScroll: onScroll, isDisabled: isDisabled } = props;
    let onScrollHandler = (0, $acw62.useCallback)((e)=>{
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    (0, $df6686ed111e5fc0$export$90fc3a17d93f704c)(ref, "wheel", isDisabled ? null : onScrollHandler);
}
const $1eef7302de9b85e9$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $1eef7302de9b85e9$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $1eef7302de9b85e9$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $acw62.useRef)(null);
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $df6686ed111e5fc0$export$4eaf04e54aa8eed6)();
    let { pressProps: pressProps } = $1eef7302de9b85e9$export$45712eceda6fad21({
        isDisabled: isDisabled,
        onPressStart (e1) {
            if (e1.pointerType === "mouse" || e1.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e1,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e1.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e1,
                        type: "longpress"
                    });
                    timeRef.current = null;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e1.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e1.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e1.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $df6686ed111e5fc0$export$f8aeda7b10753fa1)(onLongPress && !isDisabled ? accessibilityDescription : null);
    return {
        longPressProps: (0, $df6686ed111e5fc0$export$9d1611c77c2fe928)(pressProps, descriptionProps)
    };
}



function $441e2d66603366d7$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    if ((0, $1eef7302de9b85e9$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = document.activeElement;
        (0, $df6686ed111e5fc0$export$24490316f764c430)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (document.activeElement === lastFocusedElement && document.contains(element)) (0, $df6686ed111e5fc0$export$de79e2c695e052f3)(element);
        });
    } else (0, $df6686ed111e5fc0$export$de79e2c695e052f3)(element);
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $441e2d66603366d7$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    if (!(element instanceof HTMLElement) && !(element instanceof SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $441e2d66603366d7$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $441e2d66603366d7$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $441e2d66603366d7$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $441e2d66603366d7$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $441e2d66603366d7$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}
const $441e2d66603366d7$var$$9bf71ea28793e738$var$FocusContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
let $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope = null;
let $441e2d66603366d7$var$$9bf71ea28793e738$var$scopes = new Map();
function $441e2d66603366d7$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $acw62.useRef)();
    let endRef = (0, $acw62.useRef)();
    let scopeRef = (0, $acw62.useRef)([]);
    let ctx = (0, $acw62.useContext)($441e2d66603366d7$var$$9bf71ea28793e738$var$FocusContext);
    let parentScope = ctx === null || ctx === void 0 ? void 0 : ctx.scopeRef;
    (0, $df6686ed111e5fc0$export$e5c5a5f917a5871c)(()=>{
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = startRef.current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children,
        parentScope
    ]);
    (0, $df6686ed111e5fc0$export$e5c5a5f917a5871c)(()=>{
        $441e2d66603366d7$var$$9bf71ea28793e738$var$scopes.set(scopeRef, parentScope);
        return ()=>{
            // Restore the active scope on unmount if this scope or a descendant scope is active.
            // Parent effect cleanups run before children, so we need to check if the
            // parent scope actually still exists before restoring the active scope to it.
            if ((scopeRef === $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope || $441e2d66603366d7$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $441e2d66603366d7$var$$9bf71ea28793e738$var$scopes.has(parentScope))) $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $441e2d66603366d7$var$$9bf71ea28793e738$var$scopes.delete(scopeRef);
        };
    }, [
        scopeRef,
        parentScope
    ]);
    $441e2d66603366d7$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $441e2d66603366d7$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $441e2d66603366d7$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    let focusManager = $441e2d66603366d7$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($441e2d66603366d7$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: {
            scopeRef: scopeRef,
            focusManager: focusManager
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $441e2d66603366d7$export$10c5169755ce7bd7() {
    var ref;
    return (ref = (0, $acw62.useContext)($441e2d66603366d7$var$$9bf71ea28793e738$var$FocusContext)) === null || ref === void 0 ? void 0 : ref.focusManager;
}
function $441e2d66603366d7$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[0].previousElementSibling;
            let walker = $441e2d66603366d7$export$2d6ec8fc375ceafa($441e2d66603366d7$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let walker = $441e2d66603366d7$export$2d6ec8fc375ceafa($441e2d66603366d7$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let walker = $441e2d66603366d7$export$2d6ec8fc375ceafa($441e2d66603366d7$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let walker = $441e2d66603366d7$export$2d6ec8fc375ceafa($441e2d66603366d7$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $441e2d66603366d7$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $441e2d66603366d7$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $441e2d66603366d7$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$441e2d66603366d7$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $441e2d66603366d7$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $441e2d66603366d7$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $441e2d66603366d7$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $441e2d66603366d7$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $acw62.useRef)();
    let raf = (0, $acw62.useRef)(null);
    (0, $df6686ed111e5fc0$export$e5c5a5f917a5871c)(()=>{
        let scope1 = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = null;
            }
            return;
        }
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || scopeRef !== $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope) return;
            let focusedElement = document.activeElement;
            let scope = scopeRef.current;
            if (!$441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let walker = $441e2d66603366d7$export$2d6ec8fc375ceafa($441e2d66603366d7$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: true
            }, scope);
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if (!$441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope || $441e2d66603366d7$var$$9bf71ea28793e738$var$isAncestorScope($441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope, scopeRef)) {
                $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if (scopeRef === $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope && !$441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusFirstInScope($441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope.current);
            } else if (scopeRef === $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (scopeRef === $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope && !$441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInChildScope(document.activeElement, scopeRef)) {
                    $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    focusedNode.current = e.target;
                    focusedNode.current.focus();
                }
            });
        };
        document.addEventListener("keydown", onKeyDown, false);
        document.addEventListener("focusin", onFocus, false);
        scope1.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope1.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            document.removeEventListener("keydown", onKeyDown, false);
            document.removeEventListener("focusin", onFocus, false);
            scope1.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope1.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    // eslint-disable-next-line arrow-body-style
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    for (let scope of $441e2d66603366d7$var$$9bf71ea28793e738$var$scopes.keys()){
        if ($441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(element, scope.current)) return true;
    }
    return false;
}
function $441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    return scope.some((node)=>node.contains(element));
}
function $441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope) {
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let s of $441e2d66603366d7$var$$9bf71ea28793e738$var$scopes.keys()){
        if ((s === scope || $441e2d66603366d7$var$$9bf71ea28793e738$var$isAncestorScope(scope, s)) && $441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $441e2d66603366d7$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    let parent = $441e2d66603366d7$var$$9bf71ea28793e738$var$scopes.get(scope);
    if (!parent) return false;
    if (parent === ancestor) return true;
    return $441e2d66603366d7$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, parent);
}
function $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        $441e2d66603366d7$export$80f3e147d781571c(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err1) {
    // ignore
    }
}
function $441e2d66603366d7$var$$9bf71ea28793e738$var$focusFirstInScope(scope) {
    let sentinel = scope[0].previousElementSibling;
    let walker = $441e2d66603366d7$export$2d6ec8fc375ceafa($441e2d66603366d7$var$$9bf71ea28793e738$var$getScopeRoot(scope), {
        tabbable: true
    }, scope);
    walker.currentNode = sentinel;
    $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(walker.nextNode());
}
function $441e2d66603366d7$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            if (!$441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(document.activeElement, $441e2d66603366d7$var$$9bf71ea28793e738$var$activeScope.current)) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, []);
}
function $441e2d66603366d7$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    const nodeToRestoreRef = (0, $acw62.useRef)(typeof document !== "undefined" ? document.activeElement : null);
    // useLayoutEffect instead of useEffect so the active element is saved synchronously instead of asynchronously.
    (0, $df6686ed111e5fc0$export$e5c5a5f917a5871c)(()=>{
        let nodeToRestore = nodeToRestoreRef.current;
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey) return;
            let focusedElement = document.activeElement;
            if (!$441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $441e2d66603366d7$export$2d6ec8fc375ceafa(document.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!document.body.contains(nodeToRestore) || nodeToRestore === document.body) nodeToRestore = null;
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) document.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) document.removeEventListener("keydown", onKeyDown, true);
            if (restoreFocus && nodeToRestore && $441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(document.activeElement, scopeRef.current)) requestAnimationFrame(()=>{
                // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                if (document.body.contains(nodeToRestore) && document.activeElement === document.body) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(nodeToRestore);
            });
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
}
function $441e2d66603366d7$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $441e2d66603366d7$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $441e2d66603366d7$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var ref;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (ref = opts.from) === null || ref === void 0 ? void 0 : ref.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && $441e2d66603366d7$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(node) && (!scope || $441e2d66603366d7$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $441e2d66603366d7$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || document.activeElement;
            let walker = $441e2d66603366d7$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || document.activeElement;
            let walker = $441e2d66603366d7$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $441e2d66603366d7$var$$9bf71ea28793e738$var$last(walker);
                if (next) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                previousNode = $441e2d66603366d7$var$$9bf71ea28793e738$var$last(walker);
            }
            if (previousNode) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $441e2d66603366d7$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $441e2d66603366d7$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $441e2d66603366d7$var$$9bf71ea28793e738$var$last(walker);
            if (next) $441e2d66603366d7$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next;
        }
    };
}
function $441e2d66603366d7$var$$9bf71ea28793e738$var$last(walker) {
    let next;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
function $441e2d66603366d7$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $acw62.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $1eef7302de9b85e9$export$b9b3dfddab17db27)()
    });
    let [isFocused1, setFocused] = (0, $acw62.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $acw62.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $acw62.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $1eef7302de9b85e9$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $1eef7302de9b85e9$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $1eef7302de9b85e9$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused1,
        isFocusVisible: state.current.isFocused && isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}
function $441e2d66603366d7$export$1a38b4ad7f578e1d(props) {
    let { children: children, focusClass: focusClass, focusRingClass: focusRingClass } = props;
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = $441e2d66603366d7$export$4e328f61c538687f(props);
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, (0, $df6686ed111e5fc0$export$9d1611c77c2fe928)(child.props, {
        ...focusProps,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [focusClass || ""]: isFocused,
            [focusRingClass || ""]: isFocusVisible
        })
    }));
}
let $441e2d66603366d7$var$$e6afbd83fe6ebbd2$var$FocusableContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $441e2d66603366d7$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $acw62.useContext)($441e2d66603366d7$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $df6686ed111e5fc0$export$4debdb1a3f0fa79e)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $441e2d66603366d7$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let context = {
        ...otherProps,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($441e2d66603366d7$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $441e2d66603366d7$export$13f3202a3e5ddd5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($441e2d66603366d7$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $441e2d66603366d7$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $1eef7302de9b85e9$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps } = (0, $1eef7302de9b85e9$export$8f71654801c2f7cd)(props);
    let interactions = (0, $df6686ed111e5fc0$export$9d1611c77c2fe928)(focusProps, keyboardProps);
    let domProps = $441e2d66603366d7$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $acw62.useRef)(props.autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) $441e2d66603366d7$export$80f3e147d781571c(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $df6686ed111e5fc0$export$9d1611c77c2fe928)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $aa3391c41265991b$var$$704cf1d3b684cc5c$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $aa3391c41265991b$var$$704cf1d3b684cc5c$var$SSRContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($aa3391c41265991b$var$$704cf1d3b684cc5c$var$defaultContext);
function $aa3391c41265991b$export$9f8ac96af4b1b2ae(props) {
    let cur = (0, $acw62.useContext)($aa3391c41265991b$var$$704cf1d3b684cc5c$var$SSRContext);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $aa3391c41265991b$var$$704cf1d3b684cc5c$var$defaultContext ? "" : `${cur.prefix}-${++cur.current}`,
            current: 0
        }), [
        cur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($aa3391c41265991b$var$$704cf1d3b684cc5c$var$SSRContext.Provider, {
        value: value
    }, props.children);
}
let $aa3391c41265991b$var$$704cf1d3b684cc5c$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
function $aa3391c41265991b$export$619500959fc48b26(defaultId) {
    let ctx = (0, $acw62.useContext)($aa3391c41265991b$var$$704cf1d3b684cc5c$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $aa3391c41265991b$var$$704cf1d3b684cc5c$var$defaultContext && !$aa3391c41265991b$var$$704cf1d3b684cc5c$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    return (0, $acw62.useMemo)(()=>defaultId || `react-aria${ctx.prefix}-${++ctx.current}`, [
        defaultId
    ]);
}
function $aa3391c41265991b$export$535bd6ca7f90a273() {
    let cur = (0, $acw62.useContext)($aa3391c41265991b$var$$704cf1d3b684cc5c$var$SSRContext);
    let isInSSRContext = cur !== $aa3391c41265991b$var$$704cf1d3b684cc5c$var$defaultContext;
    let [isSSR, setIsSSR] = (0, $acw62.useState)(isInSSRContext);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof window !== "undefined" && isInSSRContext) // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return isSSR;
}


class $62a3e9bf6f671e97$export$c17fa47878dc55b6 {
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = $62a3e9bf6f671e97$var$$5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    constructor(messages, defaultLocale = "en-US"){
        // Clone messages so we don't modify the original object.
        this.strings = {
            ...messages
        };
        this.defaultLocale = defaultLocale;
    }
}
function $62a3e9bf6f671e97$var$$5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = "en-US") {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $62a3e9bf6f671e97$var$$5b160d28a433310d$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + "-")) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $62a3e9bf6f671e97$var$$5b160d28a433310d$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split("-")[0];
}
const $62a3e9bf6f671e97$var$$6db58dc88e78b024$var$pluralRulesCache = new Map();
const $62a3e9bf6f671e97$var$$6db58dc88e78b024$var$numberFormatCache = new Map();
class $62a3e9bf6f671e97$export$2f817fcdc4b89ae0 {
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === "function" ? message(variables, this) : message;
    }
    plural(count, options, type = "cardinal") {
        let opt = options["=" + count];
        if (opt) return typeof opt === "function" ? opt() : opt;
        let key = this.locale + ":" + type;
        let pluralRules = $62a3e9bf6f671e97$var$$6db58dc88e78b024$var$pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type: type
            });
            $62a3e9bf6f671e97$var$$6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    number(value) {
        let numberFormat = $62a3e9bf6f671e97$var$$6db58dc88e78b024$var$numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            $62a3e9bf6f671e97$var$$6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
}


function $bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(amount, numerator) {
    return amount - numerator * Math.floor(amount / numerator);
}
function $bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$784d13d8ee351f07(date) {
    if (date.era) return new $bf6421eb07c6b637$export$99faa760c7908e4f(date.calendar, date.era, date.year, date.month, date.day);
    else return new $bf6421eb07c6b637$export$99faa760c7908e4f(date.calendar, date.year, date.month, date.day);
}
function $bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$27fa0172ae2644b3(date) {
    if (date.era) return new $bf6421eb07c6b637$export$ca871e8dbb80966f(date.calendar, date.era, date.year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
    else return new $bf6421eb07c6b637$export$ca871e8dbb80966f(date.calendar, date.year, date.month, date.day, date.hour, date.minute, date.second);
}
const $bf6421eb07c6b637$var$$3b62074eb05584b2$var$EPOCH = 1721426; // 001/01/03 Julian C.E.
function $bf6421eb07c6b637$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, month, day) {
    year = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(era, year);
    let y1 = year - 1;
    let monthOffset = -2;
    if (month <= 2) monthOffset = 0;
    else if ($bf6421eb07c6b637$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year)) monthOffset = -1;
    return $bf6421eb07c6b637$var$$3b62074eb05584b2$var$EPOCH - 1 + 365 * y1 + Math.floor(y1 / 4) - Math.floor(y1 / 100) + Math.floor(y1 / 400) + Math.floor((367 * month - 362) / 12 + monthOffset + day);
}
function $bf6421eb07c6b637$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $bf6421eb07c6b637$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(era, year) {
    return era === "BC" ? 1 - year : year;
}
function $bf6421eb07c6b637$var$$3b62074eb05584b2$export$4475b7e617eb123c(year) {
    let era = "AD";
    if (year <= 0) {
        era = "BC";
        year = 1 - year;
    }
    return [
        era,
        year
    ];
}
const $bf6421eb07c6b637$var$$3b62074eb05584b2$var$daysInMonth = {
    standard: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    leapyear: [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ]
};
class $bf6421eb07c6b637$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let jd0 = jd;
        let depoch = jd0 - $bf6421eb07c6b637$var$$3b62074eb05584b2$var$EPOCH;
        let quadricent = Math.floor(depoch / 146097);
        let dqc = $bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(depoch, 146097);
        let cent = Math.floor(dqc / 36524);
        let dcent = $bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(dqc, 36524);
        let quad = Math.floor(dcent / 1461);
        let dquad = $bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(dcent, 1461);
        let yindex = Math.floor(dquad / 365);
        let extendedYear = quadricent * 400 + cent * 100 + quad * 4 + yindex + (cent !== 4 && yindex !== 4 ? 1 : 0);
        let [era, year] = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$4475b7e617eb123c(extendedYear);
        let yearDay = jd0 - $bf6421eb07c6b637$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 1, 1);
        let leapAdj = 2;
        if (jd0 < $bf6421eb07c6b637$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 1)) leapAdj = 0;
        else if ($bf6421eb07c6b637$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year)) leapAdj = 1;
        let month = Math.floor(((yearDay + leapAdj) * 12 + 373) / 367);
        let day = jd0 - $bf6421eb07c6b637$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, month, 1) + 1;
        return new $bf6421eb07c6b637$export$99faa760c7908e4f(era, year, month, day);
    }
    toJulianDay(date) {
        return $bf6421eb07c6b637$var$$3b62074eb05584b2$export$f297eb839006d339(date.era, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        return $bf6421eb07c6b637$var$$3b62074eb05584b2$var$daysInMonth[$bf6421eb07c6b637$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? "leapyear" : "standard"][date.month - 1];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getMonthsInYear(date) {
        return 12;
    }
    getDaysInYear(date) {
        return $bf6421eb07c6b637$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? 366 : 365;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getYearsInEra(date) {
        return 9999;
    }
    getEras() {
        return [
            "BC",
            "AD"
        ];
    }
    isInverseEra(date) {
        return date.era === "BC";
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === "BC" ? "AD" : "BC";
            date.year = 1 - date.year;
        }
    }
    constructor(){
        this.identifier = "gregory";
    }
}
const $bf6421eb07c6b637$var$$2fe286d2fb449abb$export$7a5acbd77d414bd9 = {
    "001": 1,
    AD: 1,
    AE: 6,
    AF: 6,
    AI: 1,
    AL: 1,
    AM: 1,
    AN: 1,
    AT: 1,
    AX: 1,
    AZ: 1,
    BA: 1,
    BE: 1,
    BG: 1,
    BH: 6,
    BM: 1,
    BN: 1,
    BY: 1,
    CH: 1,
    CL: 1,
    CM: 1,
    CR: 1,
    CY: 1,
    CZ: 1,
    DE: 1,
    DJ: 6,
    DK: 1,
    DZ: 6,
    EC: 1,
    EE: 1,
    EG: 6,
    ES: 1,
    FI: 1,
    FJ: 1,
    FO: 1,
    FR: 1,
    GB: 1,
    GE: 1,
    GF: 1,
    GP: 1,
    GR: 1,
    HR: 1,
    HU: 1,
    IE: 1,
    IQ: 6,
    IR: 6,
    IS: 1,
    IT: 1,
    JO: 6,
    KG: 1,
    KW: 6,
    KZ: 1,
    LB: 1,
    LI: 1,
    LK: 1,
    LT: 1,
    LU: 1,
    LV: 1,
    LY: 6,
    MC: 1,
    MD: 1,
    ME: 1,
    MK: 1,
    MN: 1,
    MQ: 1,
    MV: 5,
    MY: 1,
    NL: 1,
    NO: 1,
    NZ: 1,
    OM: 6,
    PL: 1,
    QA: 6,
    RE: 1,
    RO: 1,
    RS: 1,
    RU: 1,
    SD: 6,
    SE: 1,
    SI: 1,
    SK: 1,
    SM: 1,
    SY: 6,
    TJ: 1,
    TM: 1,
    TR: 1,
    UA: 1,
    UY: 1,
    UZ: 1,
    VA: 1,
    VN: 1,
    XK: 1
};
function $bf6421eb07c6b637$export$ea39ec197993aef0(a, b) {
    b = $bf6421eb07c6b637$export$b4a036af3fc0b032(b, a.calendar);
    return a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function $bf6421eb07c6b637$export$a18c89cbd24170ff(a, b) {
    b = $bf6421eb07c6b637$export$b4a036af3fc0b032(b, a.calendar);
    // In the Japanese calendar, months can span multiple eras/years, so only compare the first of the month.
    a = $bf6421eb07c6b637$export$a5a3b454ada2268e(a);
    b = $bf6421eb07c6b637$export$a5a3b454ada2268e(b);
    return a.era === b.era && a.year === b.year && a.month === b.month;
}
function $bf6421eb07c6b637$export$5841f9eb9773f25f(a, b) {
    b = $bf6421eb07c6b637$export$b4a036af3fc0b032(b, a.calendar);
    a = $bf6421eb07c6b637$export$f91e89d3d0406102(a);
    b = $bf6421eb07c6b637$export$f91e89d3d0406102(b);
    return a.era === b.era && a.year === b.year;
}
function $bf6421eb07c6b637$export$91b62ebf2ba703ee(a, b) {
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function $bf6421eb07c6b637$export$5a8da0c44a3afdf2(a, b) {
    a = $bf6421eb07c6b637$export$a5a3b454ada2268e(a);
    b = $bf6421eb07c6b637$export$a5a3b454ada2268e(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month;
}
function $bf6421eb07c6b637$export$ea840f5a6dda8147(a, b) {
    a = $bf6421eb07c6b637$export$f91e89d3d0406102(a);
    b = $bf6421eb07c6b637$export$f91e89d3d0406102(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year;
}
function $bf6421eb07c6b637$export$629b0a497aa65267(date, timeZone) {
    return $bf6421eb07c6b637$export$ea39ec197993aef0(date, $bf6421eb07c6b637$export$d0bdf45af03a6ea3(timeZone));
}
function $bf6421eb07c6b637$export$2061056d06d7cdf7(date, locale) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let dayOfWeek = Math.ceil(julian + 1 - $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$getWeekStart(locale)) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    return dayOfWeek;
}
function $bf6421eb07c6b637$export$461939dd4422153(timeZone) {
    return $bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(Date.now(), timeZone);
}
function $bf6421eb07c6b637$export$d0bdf45af03a6ea3(timeZone) {
    return $bf6421eb07c6b637$export$93522d1a439f3617($bf6421eb07c6b637$export$461939dd4422153(timeZone));
}
function $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$export$68781ddf31c0090f(a, b) {
    return a.calendar.toJulianDay(a) - b.calendar.toJulianDay(b);
}
function $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$export$c19a80a9721b80f6(a, b) {
    return $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$timeToMs(a) - $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$timeToMs(b);
}
function $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$timeToMs(a) {
    return a.hour * 3600000 + a.minute * 60000 + a.second * 1000 + a.millisecond;
}
function $bf6421eb07c6b637$export$126c91c941de7e(a, timeZone) {
    let ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(a, timeZone);
    let tomorrow = a.add({
        days: 1
    });
    let tomorrowMs = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(tomorrow, timeZone);
    return (tomorrowMs - ms) / 3600000;
}
let $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$localTimeZone = null;
function $bf6421eb07c6b637$export$aa8b41735afcabd2() {
    // TODO: invalidate this somehow?
    if ($bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$localTimeZone == null) $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$localTimeZone;
}
function $bf6421eb07c6b637$export$a5a3b454ada2268e(date) {
    // Use `subtract` instead of `set` so we don't get constrained in an era.
    return date.subtract({
        days: date.day - 1
    });
}
function $bf6421eb07c6b637$export$a2258d9c4118825c(date) {
    return date.add({
        days: date.calendar.getDaysInMonth(date) - date.day
    });
}
function $bf6421eb07c6b637$export$f91e89d3d0406102(date) {
    return $bf6421eb07c6b637$export$a5a3b454ada2268e(date.subtract({
        months: date.month - 1
    }));
}
function $bf6421eb07c6b637$export$8b7aa55c66d5569e(date) {
    return $bf6421eb07c6b637$export$a2258d9c4118825c(date.add({
        months: date.calendar.getMonthsInYear(date) - date.month
    }));
}
function $bf6421eb07c6b637$export$5412ac11713b72ad(date) {
    if (date.calendar.getMinimumMonthInYear) return date.calendar.getMinimumMonthInYear(date);
    return 1;
}
function $bf6421eb07c6b637$export$b2f4953d301981d5(date) {
    if (date.calendar.getMinimumDayInMonth) return date.calendar.getMinimumDayInMonth(date);
    return 1;
}
function $bf6421eb07c6b637$export$42c81a444fbfb5d4(date, locale) {
    let dayOfWeek = $bf6421eb07c6b637$export$2061056d06d7cdf7(date, locale);
    return date.subtract({
        days: dayOfWeek
    });
}
function $bf6421eb07c6b637$export$ef8b6d9133084f4e(date, locale) {
    return $bf6421eb07c6b637$export$42c81a444fbfb5d4(date, locale).add({
        days: 6
    });
}
const $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$cachedRegions = new Map();
function $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$getRegion(locale) {
    // If the Intl.Locale API is available, use it to get the region for the locale.
    // @ts-ignore
    if (Intl.Locale) {
        // Constructing an Intl.Locale is expensive, so cache the result.
        let region = $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$cachedRegions.get(locale);
        if (!region) {
            // @ts-ignore
            region = new Intl.Locale(locale).maximize().region;
            $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$cachedRegions.set(locale, region);
        }
        return region;
    }
    // If not, just try splitting the string.
    // If the second part of the locale string is 'u',
    // then this is a unicode extension, so ignore it.
    // Otherwise, it should be the region.
    let part = locale.split("-")[1];
    return part === "u" ? null : part;
}
function $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$getWeekStart(locale) {
    // TODO: use Intl.Locale for this once browsers support the weekInfo property
    // https://github.com/tc39/proposal-intl-locale-info
    let region = $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$getRegion(locale);
    return $bf6421eb07c6b637$var$$2fe286d2fb449abb$export$7a5acbd77d414bd9[region] || 0;
}
function $bf6421eb07c6b637$export$ccc1b2479e7dd654(date, locale) {
    let days = date.calendar.getDaysInMonth(date);
    return Math.ceil(($bf6421eb07c6b637$export$2061056d06d7cdf7($bf6421eb07c6b637$export$a5a3b454ada2268e(date), locale) + days) / 7);
}
function $bf6421eb07c6b637$export$5c333a116e949cdd(a, b) {
    if (a && b) return a.compare(b) <= 0 ? a : b;
    return a || b;
}
function $bf6421eb07c6b637$export$a75f2bff57811055(a, b) {
    if (a && b) return a.compare(b) >= 0 ? a : b;
    return a || b;
}
const $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$WEEKEND_DATA = {
    AF: [
        4,
        5
    ],
    AE: [
        5,
        6
    ],
    BH: [
        5,
        6
    ],
    DZ: [
        5,
        6
    ],
    EG: [
        5,
        6
    ],
    IL: [
        5,
        6
    ],
    IQ: [
        5,
        6
    ],
    IR: [
        5,
        5
    ],
    JO: [
        5,
        6
    ],
    KW: [
        5,
        6
    ],
    LY: [
        5,
        6
    ],
    OM: [
        5,
        6
    ],
    QA: [
        5,
        6
    ],
    SA: [
        5,
        6
    ],
    SD: [
        5,
        6
    ],
    SY: [
        5,
        6
    ],
    YE: [
        5,
        6
    ]
};
function $bf6421eb07c6b637$export$618d60ea299da42(date, locale) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let dayOfWeek = Math.ceil(julian + 1) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    let region = $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$getRegion(locale);
    // Use Intl.Locale for this once weekInfo is supported.
    // https://github.com/tc39/proposal-intl-locale-info
    let [start, end] = $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$var$WEEKEND_DATA[region] || [
        6,
        0
    ];
    return dayOfWeek === start || dayOfWeek === end;
}
function $bf6421eb07c6b637$export$ee9d87258e1d19ed(date, locale) {
    return !$bf6421eb07c6b637$export$618d60ea299da42(date, locale);
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) {
    date = $bf6421eb07c6b637$export$b4a036af3fc0b032(date, new $bf6421eb07c6b637$export$80ee6245ec4f29ec());
    let year = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(date.era, date.year);
    return $bf6421eb07c6b637$var$$11d87f3f76e88657$var$epochFromParts(year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, millisecond) {
    // Note: Date.UTC() interprets one and two-digit years as being in the
    // 20th century, so don't use it
    let date = new Date();
    date.setUTCHours(hour, minute, second, millisecond);
    date.setUTCFullYear(year, month - 1, day);
    return date.getTime();
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms, timeZone) {
    // Fast path for UTC.
    if (timeZone === "UTC") return 0;
    // Fast path: for local timezone, use native Date.
    if (timeZone === $bf6421eb07c6b637$export$aa8b41735afcabd2()) return new Date(ms).getTimezoneOffset() * -60000;
    let { year: year, month: month, day: day, hour: hour, minute: minute, second: second } = $bf6421eb07c6b637$var$$11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone);
    let utc = $bf6421eb07c6b637$var$$11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, 0);
    return utc - Math.floor(ms / 1000) * 1000;
}
const $bf6421eb07c6b637$var$$11d87f3f76e88657$var$formattersByTimeZone = new Map();
function $bf6421eb07c6b637$var$$11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone) {
    let formatter = $bf6421eb07c6b637$var$$11d87f3f76e88657$var$formattersByTimeZone.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            hour12: false,
            era: "short",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        });
        $bf6421eb07c6b637$var$$11d87f3f76e88657$var$formattersByTimeZone.set(timeZone, formatter);
    }
    let parts = formatter.formatToParts(new Date(ms));
    let namedParts = {};
    for (let part of parts)if (part.type !== "literal") namedParts[part.type] = part.value;
    return {
        // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
        year: namedParts.era === "BC" || namedParts.era === "B" ? -namedParts.year + 1 : +namedParts.year,
        month: +namedParts.month,
        day: +namedParts.day,
        hour: namedParts.hour === "24" ? 0 : +namedParts.hour,
        minute: +namedParts.minute,
        second: +namedParts.second
    };
}
const $bf6421eb07c6b637$var$$11d87f3f76e88657$var$DAYMILLIS = 86400000;
function $bf6421eb07c6b637$var$$11d87f3f76e88657$export$136f38efe7caf549(date, timeZone) {
    let ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date);
    let earlier = ms - $bf6421eb07c6b637$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms - $bf6421eb07c6b637$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let later = ms - $bf6421eb07c6b637$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms + $bf6421eb07c6b637$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    return $bf6421eb07c6b637$var$$11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later);
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later) {
    let found = earlier === later ? [
        earlier
    ] : [
        earlier,
        later
    ];
    return found.filter((absolute)=>$bf6421eb07c6b637$var$$11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute));
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute) {
    let parts = $bf6421eb07c6b637$var$$11d87f3f76e88657$var$getTimeZoneParts(absolute, timeZone);
    return date.year === parts.year && date.month === parts.month && date.day === parts.day && date.hour === parts.hour && date.minute === parts.minute && date.second === parts.second;
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(date, timeZone, disambiguation = "compatible") {
    let dateTime = $bf6421eb07c6b637$export$b21e0b124e224484(date);
    // Fast path: if the time zone is UTC, use native Date.
    if (timeZone === "UTC") return $bf6421eb07c6b637$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime);
    // Fast path: if the time zone is the local timezone and disambiguation is compatible, use native Date.
    if (timeZone === $bf6421eb07c6b637$export$aa8b41735afcabd2() && disambiguation === "compatible") {
        dateTime = $bf6421eb07c6b637$export$b4a036af3fc0b032(dateTime, new $bf6421eb07c6b637$export$80ee6245ec4f29ec());
        // Don't use Date constructor here because two-digit years are interpreted in the 20th century.
        let date = new Date();
        let year = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(dateTime.era, dateTime.year);
        date.setFullYear(year, dateTime.month - 1, dateTime.day);
        date.setHours(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
        return date.getTime();
    }
    let ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime);
    let offsetBefore = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms - $bf6421eb07c6b637$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let offsetAfter = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms + $bf6421eb07c6b637$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let valid = $bf6421eb07c6b637$var$$11d87f3f76e88657$var$getValidWallTimes(dateTime, timeZone, ms - offsetBefore, ms - offsetAfter);
    if (valid.length === 1) return valid[0];
    if (valid.length > 1) switch(disambiguation){
        // 'compatible' means 'earlier' for "fall back" transitions
        case "compatible":
        case "earlier":
            return valid[0];
        case "later":
            return valid[valid.length - 1];
        case "reject":
            throw new RangeError("Multiple possible absolute times found");
    }
    switch(disambiguation){
        case "earlier":
            return Math.min(ms - offsetBefore, ms - offsetAfter);
        // 'compatible' means 'later' for "spring forward" transitions
        case "compatible":
        case "later":
            return Math.max(ms - offsetBefore, ms - offsetAfter);
        case "reject":
            throw new RangeError("No such absolute time found");
    }
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$export$e67a095c620b86fe(dateTime, timeZone, disambiguation = "compatible") {
    return new Date($bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(dateTime, timeZone, disambiguation));
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, timeZone) {
    let offset = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms, timeZone);
    let date = new Date(ms + offset);
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth() + 1;
    let day = date.getUTCDate();
    let hour = date.getUTCHours();
    let minute = date.getUTCMinutes();
    let second = date.getUTCSeconds();
    let millisecond = date.getUTCMilliseconds();
    return new $bf6421eb07c6b637$export$d3b7288e7994edea(year, month, day, timeZone, offset, hour, minute, second, millisecond);
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$export$e57ff100d91bd4b9(date, timeZone) {
    return $bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(date.getTime(), timeZone);
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$export$d7f92bcd3596b086(date) {
    return $bf6421eb07c6b637$var$$11d87f3f76e88657$export$e57ff100d91bd4b9(date, $bf6421eb07c6b637$export$aa8b41735afcabd2());
}
function $bf6421eb07c6b637$export$93522d1a439f3617(dateTime) {
    return new $bf6421eb07c6b637$export$99faa760c7908e4f(dateTime.calendar, dateTime.era, dateTime.year, dateTime.month, dateTime.day);
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$export$6f4d78149f3f53ac(date) {
    return {
        era: date.era,
        year: date.year,
        month: date.month,
        day: date.day
    };
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$export$4d0393e732857be5(date) {
    return {
        hour: date.hour,
        minute: date.minute,
        second: date.second,
        millisecond: date.millisecond
    };
}
function $bf6421eb07c6b637$export$b21e0b124e224484(date, time) {
    let hour = 0, minute = 0, second = 0, millisecond = 0;
    if ("timeZone" in date) ({ hour: hour, minute: minute, second: second, millisecond: millisecond } = date);
    else if ("hour" in date && !time) return date;
    if (time) ({ hour: hour, minute: minute, second: second, millisecond: millisecond } = time);
    return new $bf6421eb07c6b637$export$ca871e8dbb80966f(date.calendar, date.era, date.year, date.month, date.day, hour, minute, second, millisecond);
}
function $bf6421eb07c6b637$export$d33f79e3ffc3dc83(dateTime) {
    return new $bf6421eb07c6b637$export$680ea196effce5f(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
}
function $bf6421eb07c6b637$export$b4a036af3fc0b032(date, calendar) {
    if (date.calendar.identifier === calendar.identifier) return date;
    let calendarDate = calendar.fromJulianDay(date.calendar.toJulianDay(date));
    let copy = date.copy();
    copy.calendar = calendar;
    copy.era = calendarDate.era;
    copy.year = calendarDate.year;
    copy.month = calendarDate.month;
    copy.day = calendarDate.day;
    $bf6421eb07c6b637$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(copy);
    return copy;
}
function $bf6421eb07c6b637$export$84c95a83c799e074(date, timeZone, disambiguation) {
    if (date instanceof $bf6421eb07c6b637$export$d3b7288e7994edea) {
        if (date.timeZone === timeZone) return date;
        return $bf6421eb07c6b637$export$538b00033cc11c75(date, timeZone);
    }
    let ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(date, timeZone, disambiguation);
    return $bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, timeZone);
}
function $bf6421eb07c6b637$var$$11d87f3f76e88657$export$83aac07b4c37b25(date) {
    let ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
    return new Date(ms);
}
function $bf6421eb07c6b637$export$538b00033cc11c75(date, timeZone) {
    let ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
    return $bf6421eb07c6b637$export$b4a036af3fc0b032($bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, timeZone), date.calendar);
}
function $bf6421eb07c6b637$export$d9b67bc93c097491(date) {
    return $bf6421eb07c6b637$export$538b00033cc11c75(date, $bf6421eb07c6b637$export$aa8b41735afcabd2());
}
const $bf6421eb07c6b637$var$$735220c2d4774dd3$var$ONE_HOUR = 3600000;
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$e16d8520af44a096(date, duration) {
    let mutableDate = date.copy();
    let days = "hour" in mutableDate ? $bf6421eb07c6b637$var$$735220c2d4774dd3$var$addTimeFields(mutableDate, duration) : 0;
    $bf6421eb07c6b637$var$$735220c2d4774dd3$var$addYears(mutableDate, duration.years || 0);
    if (mutableDate.calendar.balanceYearMonth) mutableDate.calendar.balanceYearMonth(mutableDate, date);
    mutableDate.month += duration.months || 0;
    $bf6421eb07c6b637$var$$735220c2d4774dd3$var$balanceYearMonth(mutableDate);
    $bf6421eb07c6b637$var$$735220c2d4774dd3$var$constrainMonthDay(mutableDate);
    mutableDate.day += (duration.weeks || 0) * 7;
    mutableDate.day += duration.days || 0;
    mutableDate.day += days;
    $bf6421eb07c6b637$var$$735220c2d4774dd3$var$balanceDay(mutableDate);
    if (mutableDate.calendar.balanceDate) mutableDate.calendar.balanceDate(mutableDate);
    // Constrain in case adding ended up with a date outside the valid range for the calendar system.
    // The behavior here is slightly different than when constraining in the `set` function in that
    // we adjust smaller fields to their minimum/maximum values rather than constraining each field
    // individually. This matches the general behavior of `add` vs `set` regarding how fields are balanced.
    if (mutableDate.year < 1) {
        mutableDate.year = 1;
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxYear = mutableDate.calendar.getYearsInEra(mutableDate);
    if (mutableDate.year > maxYear) {
        var _calendar, ref;
        let isInverseEra = (ref = (_calendar = mutableDate.calendar).isInverseEra) === null || ref === void 0 ? void 0 : ref.call(_calendar, mutableDate);
        mutableDate.year = maxYear;
        mutableDate.month = isInverseEra ? 1 : mutableDate.calendar.getMonthsInYear(mutableDate);
        mutableDate.day = isInverseEra ? 1 : mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    if (mutableDate.month < 1) {
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxMonth = mutableDate.calendar.getMonthsInYear(mutableDate);
    if (mutableDate.month > maxMonth) {
        mutableDate.month = maxMonth;
        mutableDate.day = mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    mutableDate.day = Math.max(1, Math.min(mutableDate.calendar.getDaysInMonth(mutableDate), mutableDate.day));
    return mutableDate;
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$var$addYears(date, years) {
    var _calendar, ref;
    if ((ref = (_calendar = date.calendar).isInverseEra) === null || ref === void 0 ? void 0 : ref.call(_calendar, date)) years = -years;
    date.year += years;
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$var$balanceYearMonth(date) {
    while(date.month < 1){
        $bf6421eb07c6b637$var$$735220c2d4774dd3$var$addYears(date, -1);
        date.month += date.calendar.getMonthsInYear(date);
    }
    let monthsInYear = 0;
    while(date.month > (monthsInYear = date.calendar.getMonthsInYear(date))){
        date.month -= monthsInYear;
        $bf6421eb07c6b637$var$$735220c2d4774dd3$var$addYears(date, 1);
    }
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$var$balanceDay(date) {
    while(date.day < 1){
        date.month--;
        $bf6421eb07c6b637$var$$735220c2d4774dd3$var$balanceYearMonth(date);
        date.day += date.calendar.getDaysInMonth(date);
    }
    while(date.day > date.calendar.getDaysInMonth(date)){
        date.day -= date.calendar.getDaysInMonth(date);
        date.month++;
        $bf6421eb07c6b637$var$$735220c2d4774dd3$var$balanceYearMonth(date);
    }
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$var$constrainMonthDay(date) {
    date.month = Math.max(1, Math.min(date.calendar.getMonthsInYear(date), date.month));
    date.day = Math.max(1, Math.min(date.calendar.getDaysInMonth(date), date.day));
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(date) {
    if (date.calendar.constrainDate) date.calendar.constrainDate(date);
    date.year = Math.max(1, Math.min(date.calendar.getYearsInEra(date), date.year));
    $bf6421eb07c6b637$var$$735220c2d4774dd3$var$constrainMonthDay(date);
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration) {
    let inverseDuration = {};
    for(let key in duration)if (typeof duration[key] === "number") inverseDuration[key] = -duration[key];
    return inverseDuration;
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$4e2d2ead65e5f7e3(date, duration) {
    return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$e16d8520af44a096(date, $bf6421eb07c6b637$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be(date, fields) {
    let mutableDate = date.copy();
    if (fields.era != null) mutableDate.era = fields.era;
    if (fields.year != null) mutableDate.year = fields.year;
    if (fields.month != null) mutableDate.month = fields.month;
    if (fields.day != null) mutableDate.day = fields.day;
    $bf6421eb07c6b637$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(mutableDate);
    return mutableDate;
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(value, fields) {
    let mutableValue = value.copy();
    if (fields.hour != null) mutableValue.hour = fields.hour;
    if (fields.minute != null) mutableValue.minute = fields.minute;
    if (fields.second != null) mutableValue.second = fields.second;
    if (fields.millisecond != null) mutableValue.millisecond = fields.millisecond;
    $bf6421eb07c6b637$var$$735220c2d4774dd3$export$7555de1e070510cb(mutableValue);
    return mutableValue;
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$var$balanceTime(time) {
    time.second += Math.floor(time.millisecond / 1000);
    time.millisecond = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$nonNegativeMod(time.millisecond, 1000);
    time.minute += Math.floor(time.second / 60);
    time.second = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$nonNegativeMod(time.second, 60);
    time.hour += Math.floor(time.minute / 60);
    time.minute = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$nonNegativeMod(time.minute, 60);
    let days = Math.floor(time.hour / 24);
    time.hour = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$nonNegativeMod(time.hour, 24);
    return days;
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$7555de1e070510cb(time) {
    time.millisecond = Math.max(0, Math.min(time.millisecond, 1000));
    time.second = Math.max(0, Math.min(time.second, 59));
    time.minute = Math.max(0, Math.min(time.minute, 59));
    time.hour = Math.max(0, Math.min(time.hour, 23));
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$var$nonNegativeMod(a, b) {
    let result = a % b;
    if (result < 0) result += b;
    return result;
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$var$addTimeFields(time, duration) {
    time.hour += duration.hours || 0;
    time.minute += duration.minutes || 0;
    time.second += duration.seconds || 0;
    time.millisecond += duration.milliseconds || 0;
    return $bf6421eb07c6b637$var$$735220c2d4774dd3$var$balanceTime(time);
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$7ed87b6bc2506470(time, duration) {
    let res = time.copy();
    $bf6421eb07c6b637$var$$735220c2d4774dd3$var$addTimeFields(res, duration);
    return res;
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$fe34d3a381cd7501(time, duration) {
    return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$7ed87b6bc2506470(time, $bf6421eb07c6b637$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$d52ced6badfb9a4c(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case "era":
            {
                let eras = value.calendar.getEras();
                let eraIndex = eras.indexOf(value.era);
                if (eraIndex < 0) throw new Error("Invalid era: " + value.era);
                eraIndex = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$cycleValue(eraIndex, amount, 0, eras.length - 1, options === null || options === void 0 ? void 0 : options.round);
                mutable.era = eras[eraIndex];
                // Constrain the year and other fields within the era, so the era doesn't change when we balance below.
                $bf6421eb07c6b637$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(mutable);
                break;
            }
        case "year":
            var _calendar, ref;
            if ((ref = (_calendar = mutable.calendar).isInverseEra) === null || ref === void 0 ? void 0 : ref.call(_calendar, mutable)) amount = -amount;
            // The year field should not cycle within the era as that can cause weird behavior affecting other fields.
            // We need to also allow values < 1 so that decrementing goes to the previous era. If we get -Infinity back
            // we know we wrapped around after reaching 9999 (the maximum), so set the year back to 1.
            mutable.year = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$cycleValue(value.year, amount, -Infinity, 9999, options === null || options === void 0 ? void 0 : options.round);
            if (mutable.year === -Infinity) mutable.year = 1;
            if (mutable.calendar.balanceYearMonth) mutable.calendar.balanceYearMonth(mutable, value);
            break;
        case "month":
            mutable.month = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$cycleValue(value.month, amount, 1, value.calendar.getMonthsInYear(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        case "day":
            mutable.day = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$cycleValue(value.day, amount, 1, value.calendar.getDaysInMonth(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    if (value.calendar.balanceDate) value.calendar.balanceDate(mutable);
    $bf6421eb07c6b637$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(mutable);
    return mutable;
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case "hour":
            {
                let hours = value.hour;
                let min = 0;
                let max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    let isPM = hours >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                mutable.hour = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$cycleValue(hours, amount, min, max, options === null || options === void 0 ? void 0 : options.round);
                break;
            }
        case "minute":
            mutable.minute = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$cycleValue(value.minute, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "second":
            mutable.second = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$cycleValue(value.second, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "millisecond":
            mutable.millisecond = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$cycleValue(value.millisecond, amount, 0, 999, options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    return mutable;
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$var$cycleValue(value, amount, min, max, round = false) {
    if (round) {
        value += Math.sign(amount);
        if (value < min) value = max;
        let div = Math.abs(amount);
        if (amount > 0) value = Math.ceil(value / div) * div;
        else value = Math.floor(value / div) * div;
        if (value > max) value = min;
    } else {
        value += amount;
        if (value < min) value = max - (min - value - 1);
        else if (value > max) value = min + (value - max - 1);
    }
    return value;
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$96b1d28349274637(dateTime, duration) {
    let ms;
    if (duration.years != null && duration.years !== 0 || duration.months != null && duration.months !== 0 || duration.days != null && duration.days !== 0) {
        let res = $bf6421eb07c6b637$var$$735220c2d4774dd3$export$e16d8520af44a096($bf6421eb07c6b637$export$b21e0b124e224484(dateTime), {
            years: duration.years,
            months: duration.months,
            days: duration.days
        });
        // Changing the date may change the timezone offset, so we need to recompute
        // using the 'compatible' disambiguation.
        ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone);
    } else ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime) - dateTime.offset;
    // Perform time manipulation in milliseconds rather than on the original time fields to account for DST.
    // For example, adding one hour during a DST transition may result in the hour field staying the same or
    // skipping an hour. This results in the offset field changing value instead of the specified field.
    ms += duration.milliseconds || 0;
    ms += (duration.seconds || 0) * 1000;
    ms += (duration.minutes || 0) * 60000;
    ms += (duration.hours || 0) * 3600000;
    let res = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone);
    return $bf6421eb07c6b637$export$b4a036af3fc0b032(res, dateTime.calendar);
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$6814caac34ca03c7(dateTime, duration) {
    return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$96b1d28349274637(dateTime, $bf6421eb07c6b637$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$9a297d111fc86b79(dateTime, field, amount, options) {
    // For date fields, we want the time to remain consistent and the UTC offset to potentially change to account for DST changes.
    // For time fields, we want the time to change by the amount given. This may result in the hour field staying the same, but the UTC
    // offset changing in the case of a backward DST transition, or skipping an hour in the case of a forward DST transition.
    switch(field){
        case "hour":
            {
                let min = 0;
                let max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    let isPM = dateTime.hour >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                // The minimum and maximum hour may be affected by daylight saving time.
                // For example, it might jump forward at midnight, and skip 1am.
                // Or it might end at midnight and repeat the 11pm hour. To handle this, we get
                // the possible absolute times for the min and max, and find the maximum range
                // that is within the current day.
                let plainDateTime = $bf6421eb07c6b637$export$b21e0b124e224484(dateTime);
                let minDate = $bf6421eb07c6b637$export$b4a036af3fc0b032($bf6421eb07c6b637$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: min
                }), new $bf6421eb07c6b637$export$80ee6245ec4f29ec());
                let minAbsolute = [
                    $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(minDate, dateTime.timeZone, "earlier"),
                    $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(minDate, dateTime.timeZone, "later")
                ].filter((ms)=>$bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone).day === minDate.day)[0];
                let maxDate = $bf6421eb07c6b637$export$b4a036af3fc0b032($bf6421eb07c6b637$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: max
                }), new $bf6421eb07c6b637$export$80ee6245ec4f29ec());
                let maxAbsolute = [
                    $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(maxDate, dateTime.timeZone, "earlier"),
                    $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(maxDate, dateTime.timeZone, "later")
                ].filter((ms)=>$bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone).day === maxDate.day).pop();
                // Since hours may repeat, we need to operate on the absolute time in milliseconds.
                // This is done in hours from the Unix epoch so that cycleValue works correctly,
                // and then converted back to milliseconds.
                let ms1 = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime) - dateTime.offset;
                let hours = Math.floor(ms1 / $bf6421eb07c6b637$var$$735220c2d4774dd3$var$ONE_HOUR);
                let remainder = ms1 % $bf6421eb07c6b637$var$$735220c2d4774dd3$var$ONE_HOUR;
                ms1 = $bf6421eb07c6b637$var$$735220c2d4774dd3$var$cycleValue(hours, amount, Math.floor(minAbsolute / $bf6421eb07c6b637$var$$735220c2d4774dd3$var$ONE_HOUR), Math.floor(maxAbsolute / $bf6421eb07c6b637$var$$735220c2d4774dd3$var$ONE_HOUR), options === null || options === void 0 ? void 0 : options.round) * $bf6421eb07c6b637$var$$735220c2d4774dd3$var$ONE_HOUR + remainder;
                // Now compute the new timezone offset, and convert the absolute time back to local time.
                return $bf6421eb07c6b637$export$b4a036af3fc0b032($bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms1, dateTime.timeZone), dateTime.calendar);
            }
        case "minute":
        case "second":
        case "millisecond":
            // @ts-ignore
            return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(dateTime, field, amount, options);
        case "era":
        case "year":
        case "month":
        case "day":
            {
                let res = $bf6421eb07c6b637$var$$735220c2d4774dd3$export$d52ced6badfb9a4c($bf6421eb07c6b637$export$b21e0b124e224484(dateTime), field, amount, options);
                let ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone);
                return $bf6421eb07c6b637$export$b4a036af3fc0b032($bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone), dateTime.calendar);
            }
        default:
            throw new Error("Unsupported field " + field);
    }
}
function $bf6421eb07c6b637$var$$735220c2d4774dd3$export$31b5430eb18be4f8(dateTime, fields, disambiguation) {
    // Set the date/time fields, and recompute the UTC offset to account for DST changes.
    // We also need to validate by converting back to a local time in case hours are skipped during forward DST transitions.
    let plainDateTime = $bf6421eb07c6b637$export$b21e0b124e224484(dateTime);
    let res = $bf6421eb07c6b637$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56($bf6421eb07c6b637$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be(plainDateTime, fields), fields);
    // If the resulting plain date time values are equal, return the original time.
    // We don't want to change the offset when setting the time to the same value.
    if (res.compare(plainDateTime) === 0) return dateTime;
    let ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone, disambiguation);
    return $bf6421eb07c6b637$export$b4a036af3fc0b032($bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone), dateTime.calendar);
}
const $bf6421eb07c6b637$var$$fae977aafc393c5c$var$TIME_RE = /^(\d{2})(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const $bf6421eb07c6b637$var$$fae977aafc393c5c$var$DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const $bf6421eb07c6b637$var$$fae977aafc393c5c$var$DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const $bf6421eb07c6b637$var$$fae977aafc393c5c$var$ZONED_DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:([+-]\d{2})(?::(\d{2}))?)?\[(.*?)\]$/;
const $bf6421eb07c6b637$var$$fae977aafc393c5c$var$ABSOLUTE_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::(\d{2}))?)|Z)$/;
function $bf6421eb07c6b637$export$c9698ec7f05a07e1(value) {
    let m = value.match($bf6421eb07c6b637$var$$fae977aafc393c5c$var$TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 time string: " + value);
    return new $bf6421eb07c6b637$export$680ea196effce5f($bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[1], 0, 23), m[2] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[2], 0, 59) : 0, m[3] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, 59) : 0, m[4] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, Infinity) * 1000 : 0);
}
function $bf6421eb07c6b637$export$6b862160d295c8e(value) {
    let m = value.match($bf6421eb07c6b637$var$$fae977aafc393c5c$var$DATE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date string: " + value);
    let date = new $bf6421eb07c6b637$export$99faa760c7908e4f($bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[1], 0, 9999), $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1);
    date.day = $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function $bf6421eb07c6b637$export$588937bcd60ade55(value) {
    let m = value.match($bf6421eb07c6b637$var$$fae977aafc393c5c$var$DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new $bf6421eb07c6b637$export$ca871e8dbb80966f($bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[4] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function $bf6421eb07c6b637$export$fd7893f06e92a6a4(value, disambiguation) {
    let m = value.match($bf6421eb07c6b637$var$$fae977aafc393c5c$var$ZONED_DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new $bf6421eb07c6b637$export$d3b7288e7994edea($bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[10], 0, m[4] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    let plainDateTime = $bf6421eb07c6b637$export$b21e0b124e224484(date);
    let ms;
    if (m[8]) {
        var ref;
        date.offset = $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[8], -23, 23) * 3600000 + $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber((ref = m[9]) !== null && ref !== void 0 ? ref : "0", 0, 59) * 60000;
        ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
        // Validate offset against parsed date.
        let absolutes = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$136f38efe7caf549(plainDateTime, date.timeZone);
        if (!absolutes.includes(ms)) throw new Error(`Offset ${$bf6421eb07c6b637$var$$fae977aafc393c5c$var$offsetToString(date.offset)} is invalid for ${$bf6421eb07c6b637$var$$fae977aafc393c5c$export$4223de14708adc63(date)} in ${date.timeZone}`);
    } else ms = $bf6421eb07c6b637$var$$11d87f3f76e88657$export$5107c82f94518f5c($bf6421eb07c6b637$export$b21e0b124e224484(plainDateTime), date.timeZone, disambiguation);
    return $bf6421eb07c6b637$var$$11d87f3f76e88657$export$1b96692a1ba042ac(ms, date.timeZone);
}
function $bf6421eb07c6b637$export$5adfdab05168c219(value, timeZone) {
    let m = value.match($bf6421eb07c6b637$var$$fae977aafc393c5c$var$ABSOLUTE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new $bf6421eb07c6b637$export$d3b7288e7994edea($bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, timeZone, 0, m[4] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    var ref;
    if (m[8]) date.offset = $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(m[8], -23, 23) * 3600000 + $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber((ref = m[9]) !== null && ref !== void 0 ? ref : "0", 0, 59) * 60000;
    return $bf6421eb07c6b637$export$538b00033cc11c75(date, timeZone);
}
function $bf6421eb07c6b637$export$8e384432362ed0f0(value) {
    return $bf6421eb07c6b637$export$5adfdab05168c219(value, $bf6421eb07c6b637$export$aa8b41735afcabd2());
}
function $bf6421eb07c6b637$var$$fae977aafc393c5c$var$parseNumber(value, min, max) {
    let val = Number(value);
    if (val < min || val > max) throw new RangeError(`Value out of range: ${min} <= ${val} <= ${max}`);
    return val;
}
function $bf6421eb07c6b637$var$$fae977aafc393c5c$export$f59dee82248f5ad4(time) {
    return `${String(time.hour).padStart(2, "0")}:${String(time.minute).padStart(2, "0")}:${String(time.second).padStart(2, "0")}${time.millisecond ? String(time.millisecond / 1000).slice(1) : ""}`;
}
function $bf6421eb07c6b637$var$$fae977aafc393c5c$export$60dfd74aa96791bd(date) {
    let gregorianDate = $bf6421eb07c6b637$export$b4a036af3fc0b032(date, new $bf6421eb07c6b637$export$80ee6245ec4f29ec());
    return `${String(gregorianDate.year).padStart(4, "0")}-${String(gregorianDate.month).padStart(2, "0")}-${String(gregorianDate.day).padStart(2, "0")}`;
}
function $bf6421eb07c6b637$var$$fae977aafc393c5c$export$4223de14708adc63(date) {
    // @ts-ignore
    return `${$bf6421eb07c6b637$var$$fae977aafc393c5c$export$60dfd74aa96791bd(date)}T${$bf6421eb07c6b637$var$$fae977aafc393c5c$export$f59dee82248f5ad4(date)}`;
}
function $bf6421eb07c6b637$var$$fae977aafc393c5c$var$offsetToString(offset) {
    let sign = Math.sign(offset) < 0 ? "-" : "+";
    offset = Math.abs(offset);
    let offsetHours = Math.floor(offset / 3600000);
    let offsetMinutes = offset % 3600000 / 60000;
    return `${sign}${String(offsetHours).padStart(2, "0")}:${String(offsetMinutes).padStart(2, "0")}`;
}
function $bf6421eb07c6b637$var$$fae977aafc393c5c$export$bf79f1ebf4b18792(date) {
    return `${$bf6421eb07c6b637$var$$fae977aafc393c5c$export$4223de14708adc63(date)}${$bf6421eb07c6b637$var$$fae977aafc393c5c$var$offsetToString(date.offset)}[${date.timeZone}]`;
}
function $bf6421eb07c6b637$var$$35ea8db9cb2ccb90$var$shiftArgs(args) {
    let calendar = typeof args[0] === "object" ? args.shift() : new $bf6421eb07c6b637$export$80ee6245ec4f29ec();
    let era;
    if (typeof args[0] === "string") era = args.shift();
    else {
        let eras = calendar.getEras();
        era = eras[eras.length - 1];
    }
    let year = args.shift();
    let month = args.shift();
    let day = args.shift();
    return [
        calendar,
        era,
        year,
        month,
        day
    ];
}
class $bf6421eb07c6b637$export$99faa760c7908e4f {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $bf6421eb07c6b637$export$99faa760c7908e4f(this.calendar, this.era, this.year, this.month, this.day);
        else return new $bf6421eb07c6b637$export$99faa760c7908e4f(this.calendar, this.year, this.month, this.day);
    }
    /** Returns a new `CalendarDate` with the given duration added to it. */ add(duration) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$e16d8520af44a096(this, duration);
    }
    /** Returns a new `CalendarDate` with the given duration subtracted from it. */ subtract(duration) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$4e2d2ead65e5f7e3(this, duration);
    }
    /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be(this, fields);
    }
    /**
   * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$d52ced6badfb9a4c(this, field, amount, options);
    }
    /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */ toDate(timeZone) {
        return $bf6421eb07c6b637$var$$11d87f3f76e88657$export$e67a095c620b86fe(this, timeZone);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return $bf6421eb07c6b637$var$$fae977aafc393c5c$export$60dfd74aa96791bd(this);
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        return $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$export$68781ddf31c0090f(this, b);
    }
    constructor(...args){
        // This prevents TypeScript from allowing other types with the same fields to match.
        // i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
        // If that behavior is desired, use the AnyCalendarDate interface instead.
        $bf6421eb07c6b637$var$_type.set(this, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $bf6421eb07c6b637$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        $bf6421eb07c6b637$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
}
var $bf6421eb07c6b637$var$_type = new WeakMap();
class $bf6421eb07c6b637$export$680ea196effce5f {
    /** Returns a copy of this time. */ copy() {
        return new $bf6421eb07c6b637$export$680ea196effce5f(this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `Time` with the given duration added to it. */ add(duration) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$7ed87b6bc2506470(this, duration);
    }
    /** Returns a new `Time` with the given duration subtracted from it. */ subtract(duration) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$fe34d3a381cd7501(this, duration);
    }
    /** Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(this, fields);
    }
    /**
   * Returns a new `Time` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(this, field, amount, options);
    }
    /** Converts the time to an ISO 8601 formatted string. */ toString() {
        return $bf6421eb07c6b637$var$$fae977aafc393c5c$export$f59dee82248f5ad4(this);
    }
    /** Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after. */ compare(b) {
        return $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$export$c19a80a9721b80f6(this, b);
    }
    constructor(hour = 0, minute = 0, second = 0, millisecond = 0){
        // This prevents TypeScript from allowing other types with the same fields to match.
        $bf6421eb07c6b637$var$_type1.set(this, {
            writable: true,
            value: void 0
        });
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
        $bf6421eb07c6b637$var$$735220c2d4774dd3$export$7555de1e070510cb(this);
    }
}
var $bf6421eb07c6b637$var$_type1 = new WeakMap();
class $bf6421eb07c6b637$export$ca871e8dbb80966f {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $bf6421eb07c6b637$export$ca871e8dbb80966f(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
        else return new $bf6421eb07c6b637$export$ca871e8dbb80966f(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `CalendarDateTime` with the given duration added to it. */ add(duration) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$e16d8520af44a096(this, duration);
    }
    /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$4e2d2ead65e5f7e3(this, duration);
    }
    /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be($bf6421eb07c6b637$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(this, fields), fields);
    }
    /**
   * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        switch(field){
            case "era":
            case "year":
            case "month":
            case "day":
                return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$d52ced6badfb9a4c(this, field, amount, options);
            default:
                return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(this, field, amount, options);
        }
    }
    /** Converts the date to a native JavaScript Date object in the given time zone. */ toDate(timeZone, disambiguation) {
        return $bf6421eb07c6b637$var$$11d87f3f76e88657$export$e67a095c620b86fe(this, timeZone, disambiguation);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return $bf6421eb07c6b637$var$$fae977aafc393c5c$export$4223de14708adc63(this);
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        let res = $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$export$68781ddf31c0090f(this, b);
        if (res === 0) return $bf6421eb07c6b637$var$$14e0f24ef4ac5c92$export$c19a80a9721b80f6(this, $bf6421eb07c6b637$export$b21e0b124e224484(b));
        return res;
    }
    constructor(...args){
        // This prevents TypeScript from allowing other types with the same fields to match.
        $bf6421eb07c6b637$var$_type2.set(this, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $bf6421eb07c6b637$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        $bf6421eb07c6b637$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
}
var $bf6421eb07c6b637$var$_type2 = new WeakMap();
class $bf6421eb07c6b637$export$d3b7288e7994edea {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $bf6421eb07c6b637$export$d3b7288e7994edea(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
        else return new $bf6421eb07c6b637$export$d3b7288e7994edea(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `ZonedDateTime` with the given duration added to it. */ add(duration) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$96b1d28349274637(this, duration);
    }
    /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$6814caac34ca03c7(this, duration);
    }
    /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields, disambiguation) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$31b5430eb18be4f8(this, fields, disambiguation);
    }
    /**
   * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return $bf6421eb07c6b637$var$$735220c2d4774dd3$export$9a297d111fc86b79(this, field, amount, options);
    }
    /** Converts the date to a native JavaScript Date object. */ toDate() {
        return $bf6421eb07c6b637$var$$11d87f3f76e88657$export$83aac07b4c37b25(this);
    }
    /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */ toString() {
        return $bf6421eb07c6b637$var$$fae977aafc393c5c$export$bf79f1ebf4b18792(this);
    }
    /** Converts the date to an ISO 8601 formatted string in UTC. */ toAbsoluteString() {
        return this.toDate().toISOString();
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        // TODO: Is this a bad idea??
        return this.toDate().getTime() - $bf6421eb07c6b637$export$84c95a83c799e074(b, this.timeZone).toDate().getTime();
    }
    constructor(...args){
        // This prevents TypeScript from allowing other types with the same fields to match.
        $bf6421eb07c6b637$var$_type3.set(this, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $bf6421eb07c6b637$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        let timeZone = args.shift();
        let offset = args.shift();
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.timeZone = timeZone;
        this.offset = offset;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        $bf6421eb07c6b637$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
}
var $bf6421eb07c6b637$var$_type3 = new WeakMap();
const $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_START_DATES = [
    [
        1868,
        9,
        8
    ],
    [
        1912,
        7,
        30
    ],
    [
        1926,
        12,
        25
    ],
    [
        1989,
        1,
        8
    ],
    [
        2019,
        5,
        1
    ]
];
const $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_END_DATES = [
    [
        1912,
        7,
        29
    ],
    [
        1926,
        12,
        24
    ],
    [
        1989,
        1,
        7
    ],
    [
        2019,
        4,
        30
    ]
];
const $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_ADDENDS = [
    1867,
    1911,
    1925,
    1988,
    2018
];
const $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_NAMES = [
    "meiji",
    "taisho",
    "showa",
    "heisei",
    "reiwa"
];
function $bf6421eb07c6b637$var$$62225008020f0a13$var$findEraFromGregorianDate(date) {
    const idx = $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_START_DATES.findIndex(([year, month, day])=>{
        if (date.year < year) return true;
        if (date.year === year && date.month < month) return true;
        if (date.year === year && date.month === month && date.day < day) return true;
        return false;
    });
    if (idx === -1) return $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_START_DATES.length - 1;
    if (idx === 0) return 0;
    return idx - 1;
}
function $bf6421eb07c6b637$var$$62225008020f0a13$var$toGregorian(date) {
    let eraAddend = $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_ADDENDS[$bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era)];
    if (!eraAddend) throw new Error("Unknown era: " + date.era);
    return new $bf6421eb07c6b637$export$99faa760c7908e4f(date.year + eraAddend, date.month, date.day);
}
class $bf6421eb07c6b637$export$b746ab2b60cdffbf extends $bf6421eb07c6b637$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let era = $bf6421eb07c6b637$var$$62225008020f0a13$var$findEraFromGregorianDate(date);
        return new $bf6421eb07c6b637$export$99faa760c7908e4f(this, $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_NAMES[era], date.year - $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_ADDENDS[era], date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($bf6421eb07c6b637$var$$62225008020f0a13$var$toGregorian(date));
    }
    balanceDate(date) {
        let gregorianDate = $bf6421eb07c6b637$var$$62225008020f0a13$var$toGregorian(date);
        let era = $bf6421eb07c6b637$var$$62225008020f0a13$var$findEraFromGregorianDate(gregorianDate);
        if ($bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_NAMES[era] !== date.era) {
            date.era = $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_NAMES[era];
            date.year = gregorianDate.year - $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_ADDENDS[era];
        }
        // Constrain in case we went before the first supported era.
        this.constrainDate(date);
    }
    constrainDate(date) {
        let idx = $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        let end = $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_END_DATES[idx];
        if (end != null) {
            let [endYear, endMonth, endDay] = end;
            // Constrain the year to the maximum possible value in the era.
            // Then constrain the month and day fields within that.
            let maxYear = endYear - $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_ADDENDS[idx];
            date.year = Math.max(1, Math.min(maxYear, date.year));
            if (date.year === maxYear) {
                date.month = Math.min(endMonth, date.month);
                if (date.month === endMonth) date.day = Math.min(endDay, date.day);
            }
        }
        if (date.year === 1 && idx >= 0) {
            let [, startMonth, startDay] = $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_START_DATES[idx];
            date.month = Math.max(startMonth, date.month);
            if (date.month === startMonth) date.day = Math.max(startDay, date.day);
        }
    }
    getEras() {
        return $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_NAMES;
    }
    getYearsInEra(date) {
        // Get the number of years in the era, taking into account the date's month and day fields.
        let era = $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        let cur = $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_START_DATES[era];
        let next = $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_START_DATES[era + 1];
        if (next == null) return 9999 - cur[0] + 1;
        let years = next[0] - cur[0];
        if (date.month < next[1] || date.month === next[1] && date.day < next[2]) years++;
        return years;
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($bf6421eb07c6b637$var$$62225008020f0a13$var$toGregorian(date));
    }
    getMinimumMonthInYear(date) {
        let start = $bf6421eb07c6b637$var$$62225008020f0a13$var$getMinimums(date);
        return start ? start[1] : 1;
    }
    getMinimumDayInMonth(date) {
        let start = $bf6421eb07c6b637$var$$62225008020f0a13$var$getMinimums(date);
        return start && date.month === start[1] ? start[2] : 1;
    }
    constructor(...args){
        super(...args);
        this.identifier = "japanese";
    }
}
function $bf6421eb07c6b637$var$$62225008020f0a13$var$getMinimums(date) {
    if (date.year === 1) {
        let idx = $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        return $bf6421eb07c6b637$var$$62225008020f0a13$var$ERA_START_DATES[idx];
    }
}
const $bf6421eb07c6b637$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START = -543;
class $bf6421eb07c6b637$export$42d20a78301dee44 extends $bf6421eb07c6b637$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let gregorianDate = super.fromJulianDay(jd);
        let year = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(gregorianDate.era, gregorianDate.year);
        return new $bf6421eb07c6b637$export$99faa760c7908e4f(this, year - $bf6421eb07c6b637$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START, gregorianDate.month, gregorianDate.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($bf6421eb07c6b637$var$$8d73d47422ca7302$var$toGregorian(date));
    }
    getEras() {
        return [
            "BE"
        ];
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($bf6421eb07c6b637$var$$8d73d47422ca7302$var$toGregorian(date));
    }
    balanceDate() {}
    constructor(...args){
        super(...args);
        this.identifier = "buddhist";
    }
}
function $bf6421eb07c6b637$var$$8d73d47422ca7302$var$toGregorian(date) {
    let [era, year] = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$4475b7e617eb123c(date.year + $bf6421eb07c6b637$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START);
    return new $bf6421eb07c6b637$export$99faa760c7908e4f(era, year, date.month, date.day);
}
const $bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START = 1911;
function $bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$gregorianYear(date) {
    return date.era === "minguo" ? date.year + $bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START : 1 - date.year + $bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
}
function $bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan(year) {
    let y = year - $bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
    if (y > 0) return [
        "minguo",
        y
    ];
    else return [
        "before_minguo",
        1 - y
    ];
}
class $bf6421eb07c6b637$export$65e01080afcb0799 extends $bf6421eb07c6b637$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let extendedYear = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(date.era, date.year);
        let [era, year] = $bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan(extendedYear);
        return new $bf6421eb07c6b637$export$99faa760c7908e4f(this, era, year, date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$toGregorian(date));
    }
    getEras() {
        return [
            "before_minguo",
            "minguo"
        ];
    }
    balanceDate(date) {
        let [era, year] = $bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan($bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$gregorianYear(date));
        date.era = era;
        date.year = year;
    }
    isInverseEra(date) {
        return date.era === "before_minguo";
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$toGregorian(date));
    }
    getYearsInEra(date) {
        return date.era === "before_minguo" ? 9999 : 9999 - $bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
    }
    constructor(...args){
        super(...args);
        this.identifier // Republic of China
         = "roc";
    }
}
function $bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$toGregorian(date) {
    let [era, year] = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$4475b7e617eb123c($bf6421eb07c6b637$var$$5f31bd6f0c8940b2$var$gregorianYear(date));
    return new $bf6421eb07c6b637$export$99faa760c7908e4f(era, year, date.month, date.day);
}
const $bf6421eb07c6b637$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH = 1948321; // 622/03/19 Julian C.E.
function $bf6421eb07c6b637$var$$f3ed2e4472ae7e25$var$isLeapYear(year) {
    let y0 = year > 0 ? year - 474 : year - 473;
    let y1 = $bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(y0, 2820) + 474;
    return $bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1((y1 + 38) * 31, 128) < 31;
}
function $bf6421eb07c6b637$var$$f3ed2e4472ae7e25$var$persianToJulianDay(year, month, day) {
    let y0 = year > 0 ? year - 474 : year - 473;
    let y1 = $bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(y0, 2820) + 474;
    let offset = month <= 7 ? 31 * (month - 1) : 30 * (month - 1) + 6;
    return $bf6421eb07c6b637$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH - 1 + 1029983 * Math.floor(y0 / 2820) + 365 * (y1 - 1) + Math.floor((31 * y1 - 5) / 128) + offset + day;
}
class $bf6421eb07c6b637$export$37fccdbfd14c5939 {
    fromJulianDay(jd) {
        let d0 = jd - $bf6421eb07c6b637$var$$f3ed2e4472ae7e25$var$persianToJulianDay(475, 1, 1);
        let n2820 = Math.floor(d0 / 1029983);
        let d1 = $bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(d0, 1029983);
        let y2820 = d1 === 1029982 ? 2820 : Math.floor((128 * d1 + 46878) / 46751);
        let year = 474 + 2820 * n2820 + y2820;
        if (year <= 0) year--;
        let yDay = jd - $bf6421eb07c6b637$var$$f3ed2e4472ae7e25$var$persianToJulianDay(year, 1, 1) + 1;
        let month = yDay <= 186 ? Math.ceil(yDay / 31) : Math.ceil((yDay - 6) / 31);
        let day = jd - $bf6421eb07c6b637$var$$f3ed2e4472ae7e25$var$persianToJulianDay(year, month, 1) + 1;
        return new $bf6421eb07c6b637$export$99faa760c7908e4f(this, year, month, day);
    }
    toJulianDay(date) {
        return $bf6421eb07c6b637$var$$f3ed2e4472ae7e25$var$persianToJulianDay(date.year, date.month, date.day);
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInMonth(date) {
        if (date.month <= 6) return 31;
        if (date.month <= 11) return 30;
        return $bf6421eb07c6b637$var$$f3ed2e4472ae7e25$var$isLeapYear(date.year) ? 30 : 29;
    }
    getEras() {
        return [
            "AP"
        ];
    }
    getYearsInEra() {
        // 9378-10-10 persian is 9999-12-31 gregorian.
        // Round down to 9377 to set the maximum full year.
        return 9377;
    }
    constructor(){
        this.identifier = "persian";
    }
}
// Starts in 78 AD,
const $bf6421eb07c6b637$var$$82c358003bdda0a8$var$INDIAN_ERA_START = 78;
// The Indian year starts 80 days later than the Gregorian year.
const $bf6421eb07c6b637$var$$82c358003bdda0a8$var$INDIAN_YEAR_START = 80;
class $bf6421eb07c6b637$export$39f31c639fa15726 extends $bf6421eb07c6b637$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        // Gregorian date for Julian day
        let date = super.fromJulianDay(jd);
        // Year in Saka era
        let indianYear = date.year - $bf6421eb07c6b637$var$$82c358003bdda0a8$var$INDIAN_ERA_START;
        // Day number in Gregorian year (starting from 0)
        let yDay = jd - $bf6421eb07c6b637$var$$3b62074eb05584b2$export$f297eb839006d339(date.era, date.year, 1, 1);
        let leapMonth;
        if (yDay < $bf6421eb07c6b637$var$$82c358003bdda0a8$var$INDIAN_YEAR_START) {
            //  Day is at the end of the preceding Saka year
            indianYear--;
            // Days in leapMonth this year, previous Gregorian year
            leapMonth = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year - 1) ? 31 : 30;
            yDay += leapMonth + 155 + 90 + 10;
        } else {
            // Days in leapMonth this year
            leapMonth = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? 31 : 30;
            yDay -= $bf6421eb07c6b637$var$$82c358003bdda0a8$var$INDIAN_YEAR_START;
        }
        let indianMonth;
        let indianDay;
        if (yDay < leapMonth) {
            indianMonth = 1;
            indianDay = yDay + 1;
        } else {
            let mDay = yDay - leapMonth;
            if (mDay < 155) {
                indianMonth = Math.floor(mDay / 31) + 2;
                indianDay = mDay % 31 + 1;
            } else {
                mDay -= 155;
                indianMonth = Math.floor(mDay / 30) + 7;
                indianDay = mDay % 30 + 1;
            }
        }
        return new $bf6421eb07c6b637$export$99faa760c7908e4f(this, indianYear, indianMonth, indianDay);
    }
    toJulianDay(date) {
        let extendedYear = date.year + $bf6421eb07c6b637$var$$82c358003bdda0a8$var$INDIAN_ERA_START;
        let [era, year] = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$4475b7e617eb123c(extendedYear);
        let leapMonth;
        let jd;
        if ($bf6421eb07c6b637$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year)) {
            leapMonth = 31;
            jd = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 21);
        } else {
            leapMonth = 30;
            jd = $bf6421eb07c6b637$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 22);
        }
        if (date.month === 1) return jd + date.day - 1;
        jd += leapMonth + Math.min(date.month - 2, 5) * 31;
        if (date.month >= 8) jd += (date.month - 7) * 30;
        jd += date.day - 1;
        return jd;
    }
    getDaysInMonth(date) {
        if (date.month === 1 && $bf6421eb07c6b637$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year + $bf6421eb07c6b637$var$$82c358003bdda0a8$var$INDIAN_ERA_START)) return 31;
        if (date.month >= 2 && date.month <= 6) return 31;
        return 30;
    }
    getYearsInEra() {
        // 9999-12-31 gregorian is 9920-10-10 indian.
        // Round down to 9919 for the last full year.
        return 9919;
    }
    getEras() {
        return [
            "saka"
        ];
    }
    balanceDate() {}
    constructor(...args){
        super(...args);
        this.identifier = "indian";
    }
}
const $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC = 1948440; // CE 622 July 16 Friday (Julian calendar) / CE 622 July 19 (Gregorian calendar)
const $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC = 1948439; // CE 622 July 15 Thursday (Julian calendar)
const $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START = 1300;
const $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END = 1600;
const $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_START_DAYS = 460322;
function $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, day) {
    return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + epoch - 1;
}
function $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(calendar, epoch, jd) {
    let year = Math.floor((30 * (jd - epoch) + 10646) / 10631);
    let month = Math.min(12, Math.ceil((jd - (29 + $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, 1, 1))) / 29.5) + 1);
    let day = jd - $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, 1) + 1;
    return new $bf6421eb07c6b637$export$99faa760c7908e4f(calendar, year, month, day);
}
function $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$isLeapYear(year) {
    return (14 + 11 * year) % 30 < 11;
}
class $bf6421eb07c6b637$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        return $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(this, $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC, jd);
    }
    toJulianDay(date) {
        return $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$islamicToJulianDay($bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let length = 29 + date.month % 2;
        if (date.month === 12 && $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$isLeapYear(date.year)) length++;
        return length;
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInYear(date) {
        return $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$isLeapYear(date.year) ? 355 : 354;
    }
    getYearsInEra() {
        // 9999 gregorian
        return 9665;
    }
    getEras() {
        return [
            "AH"
        ];
    }
    constructor(){
        this.identifier = "islamic-civil";
    }
}
class $bf6421eb07c6b637$export$37f0887f2f9d22f7 extends $bf6421eb07c6b637$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        return $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(this, $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, jd);
    }
    toJulianDay(date) {
        return $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$islamicToJulianDay($bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, date.year, date.month, date.day);
    }
    constructor(...args){
        super(...args);
        this.identifier = "islamic-tbla";
    }
}
// Generated by scripts/generate-umalqura.js
const $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_DATA = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH;
let $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE;
function $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraYearStart(year) {
    return $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_START_DAYS + $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
function $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, month) {
    let idx = year - $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START;
    let mask = 1 << 11 - (month - 1);
    if (($bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH[idx] & mask) === 0) return 29;
    else return 30;
}
function $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(year, month) {
    let day = $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraYearStart(year);
    for(let i = 1; i < month; i++)day += $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
    return day;
}
function $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraYearLength(year) {
    return $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year + 1 - $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] - $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
class $bf6421eb07c6b637$export$5baab4758c231076 extends $bf6421eb07c6b637$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        let days = jd - $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC;
        let startDays = $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraYearStart($bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START);
        let endDays = $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraYearStart($bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END);
        if (days < startDays || days > endDays) return super.fromJulianDay(jd);
        else {
            let y = $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START - 1;
            let m = 1;
            let d = 1;
            while(d > 0){
                y++;
                d = days - $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraYearStart(y) + 1;
                let yearLength = $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraYearLength(y);
                if (d === yearLength) {
                    m = 12;
                    break;
                } else if (d < yearLength) {
                    let monthLength = $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                    m = 1;
                    while(d > monthLength){
                        d -= monthLength;
                        m++;
                        monthLength = $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                    }
                    break;
                }
            }
            return new $bf6421eb07c6b637$export$99faa760c7908e4f(this, y, m, days - $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(y, m) + 1);
        }
    }
    toJulianDay(date) {
        if (date.year < $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.toJulianDay(date);
        return $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC + $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(date.year, date.month) + (date.day - 1);
    }
    getDaysInMonth(date) {
        if (date.year < $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.getDaysInMonth(date);
        return $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(date.year, date.month);
    }
    getDaysInYear(date) {
        if (date.year < $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.getDaysInYear(date);
        return $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraYearLength(date.year);
    }
    constructor(){
        super();
        this.identifier = "islamic-umalqura";
        if (!$bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH) $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH = new Uint16Array(Uint8Array.from(atob($bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_DATA), (c)=>c.charCodeAt(0)).buffer);
        if (!$bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE) {
            $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE = new Uint32Array($bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END - $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START + 1);
            let yearStart = 0;
            for(let year = $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START; year <= $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END; year++){
                $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] = yearStart;
                for(let i = 1; i <= 12; i++)yearStart += $bf6421eb07c6b637$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
            }
        }
    }
}
const $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$HEBREW_EPOCH = 347997;
// Hebrew date calculations are performed in terms of days, hours, and
// "parts" (or halakim), which are 1/1080 of an hour, or 3 1/3 seconds.
const $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$HOUR_PARTS = 1080;
const $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$DAY_PARTS = 24 * $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$HOUR_PARTS;
// An approximate value for the length of a lunar month.
// It is used to calculate the approximate year and month of a given
// absolute date.
const $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$MONTH_DAYS = 29;
const $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$MONTH_FRACT = 12 * $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$HOUR_PARTS + 793;
const $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$MONTH_PARTS = $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$MONTH_DAYS * $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$DAY_PARTS + $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$MONTH_FRACT;
function $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$isLeapYear(year) {
    return $bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(year * 7 + 1, 19) < 7;
}
// Test for delay of start of new year and to avoid
// Sunday, Wednesday, and Friday as start of the new year.
function $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$hebrewDelay1(year) {
    let months = Math.floor((235 * year - 234) / 19);
    let parts = 12084 + 13753 * months;
    let day = months * 29 + Math.floor(parts / 25920);
    if ($bf6421eb07c6b637$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(3 * (day + 1), 7) < 3) day += 1;
    return day;
}
// Check for delay in start of new year due to length of adjacent years
function $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$hebrewDelay2(year) {
    let last = $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$hebrewDelay1(year - 1);
    let present = $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$hebrewDelay1(year);
    let next = $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$hebrewDelay1(year + 1);
    if (next - present === 356) return 2;
    if (present - last === 382) return 1;
    return 0;
}
function $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$startOfYear(year) {
    return $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$hebrewDelay1(year) + $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$hebrewDelay2(year);
}
function $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$getDaysInYear(year) {
    return $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$startOfYear(year + 1) - $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$startOfYear(year);
}
function $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$getYearType(year) {
    let yearLength = $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$getDaysInYear(year);
    if (yearLength > 380) yearLength -= 30; // Subtract length of leap month.
    switch(yearLength){
        case 353:
            return 0; // deficient
        case 354:
            return 1; // normal
        case 355:
            return 2; // complete
    }
}
function $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month) {
    // Normalize month numbers from 1 - 13, even on non-leap years
    if (month >= 6 && !$bf6421eb07c6b637$var$$7c5f6fbf42389787$var$isLeapYear(year)) month++;
    // First of all, dispose of fixed-length 29 day months
    if (month === 4 || month === 7 || month === 9 || month === 11 || month === 13) return 29;
    let yearType = $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$getYearType(year);
    // If it's Heshvan, days depend on length of year
    if (month === 2) return yearType === 2 ? 30 : 29;
    // Similarly, Kislev varies with the length of year
    if (month === 3) return yearType === 0 ? 29 : 30;
    // Adar I only exists in leap years
    if (month === 6) return $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$isLeapYear(year) ? 30 : 0;
    return 30;
}
class $bf6421eb07c6b637$export$ca405048b8fb5af {
    fromJulianDay(jd) {
        let d = jd - $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$HEBREW_EPOCH;
        let m = d * $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$DAY_PARTS / $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$MONTH_PARTS; // Months (approx)
        let year = Math.floor((19 * m + 234) / 235) + 1; // Years (approx)
        let ys = $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$startOfYear(year); // 1st day of year
        let dayOfYear = Math.floor(d - ys);
        // Because of the postponement rules, it's possible to guess wrong.  Fix it.
        while(dayOfYear < 1){
            year--;
            ys = $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$startOfYear(year);
            dayOfYear = Math.floor(d - ys);
        }
        // Now figure out which month we're in, and the date within that month
        let month = 1;
        let monthStart = 0;
        while(monthStart < dayOfYear){
            monthStart += $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month);
            month++;
        }
        month--;
        monthStart -= $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month);
        let day = dayOfYear - monthStart;
        return new $bf6421eb07c6b637$export$99faa760c7908e4f(this, year, month, day);
    }
    toJulianDay(date) {
        let jd = $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$startOfYear(date.year);
        for(let month = 1; month < date.month; month++)jd += $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$getDaysInMonth(date.year, month);
        return jd + date.day + $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$HEBREW_EPOCH;
    }
    getDaysInMonth(date) {
        return $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$getDaysInMonth(date.year, date.month);
    }
    getMonthsInYear(date) {
        return $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$isLeapYear(date.year) ? 13 : 12;
    }
    getDaysInYear(date) {
        return $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$getDaysInYear(date.year);
    }
    getYearsInEra() {
        // 6239 gregorian
        return 9999;
    }
    getEras() {
        return [
            "AM"
        ];
    }
    balanceYearMonth(date, previousDate) {
        // Keep date in the same month when switching between leap years and non leap years
        if (previousDate.year !== date.year) {
            if ($bf6421eb07c6b637$var$$7c5f6fbf42389787$var$isLeapYear(previousDate.year) && !$bf6421eb07c6b637$var$$7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month--;
            else if (!$bf6421eb07c6b637$var$$7c5f6fbf42389787$var$isLeapYear(previousDate.year) && $bf6421eb07c6b637$var$$7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month++;
        }
    }
    constructor(){
        this.identifier = "hebrew";
    }
}
const $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH = 1723856;
const $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH = 1824665;
// The delta between Amete Alem 1 and Amete Mihret 1
// AA 5501 = AM 1
const $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA = 5500;
function $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, day) {
    return epoch // difference from Julian epoch to 1,1,1
     + 365 * year // number of days from years
     + Math.floor(year / 4) // extra day of leap year
     + 30 * (month - 1 // number of days from months (1 based)
    ) + day - 1 // number of days for present month (1 based)
    ;
}
function $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$julianDayToCE(epoch, jd) {
    let year = Math.floor(4 * (jd - epoch) / 1461);
    let month = 1 + Math.floor((jd - $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, 1, 1)) / 30);
    let day = jd + 1 - $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, 1);
    return [
        year,
        month,
        day
    ];
}
function $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$getLeapDay(year) {
    return Math.floor(year % 4 / 3);
}
function $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$getDaysInMonth(year, month) {
    // The Ethiopian and Coptic calendars have 13 months, 12 of 30 days each and
    // an intercalary month at the end of the year of 5 or 6 days, depending whether
    // the year is a leap year or not. The Leap Year follows the same rules as the
    // Julian Calendar so that the extra month always has six days in the year before
    // a Julian Leap Year.
    if (month % 13 !== 0) return 30;
    else return $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$getLeapDay(year) + 5;
}
class $bf6421eb07c6b637$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$julianDayToCE($bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd);
        let era = "AM";
        if (year <= 0) {
            era = "AA";
            year += $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        }
        return new $bf6421eb07c6b637$export$99faa760c7908e4f(this, era, year, month, day);
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === "AA") year -= $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        return $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$ceToJulianDay($bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        return $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$getDaysInMonth(date.year, date.month);
    }
    getMonthsInYear() {
        return 13;
    }
    getDaysInYear(date) {
        return 365 + $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$getLeapDay(date.year);
    }
    getYearsInEra(date) {
        // 9999-12-31 gregorian is 9992-20-02 ethiopic.
        // Round down to 9991 for the last full year.
        // AA 9999-01-01 ethiopic is 4506-09-30 gregorian.
        return date.era === "AA" ? 9999 : 9991;
    }
    getEras() {
        return [
            "AA",
            "AM"
        ];
    }
    constructor(){
        this.identifier = "ethiopic";
    }
}
class $bf6421eb07c6b637$export$d72e0c37005a4914 extends $bf6421eb07c6b637$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$julianDayToCE($bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd);
        year += $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        return new $bf6421eb07c6b637$export$99faa760c7908e4f(this, "AA", year, month, day);
    }
    getEras() {
        return [
            "AA"
        ];
    }
    getYearsInEra() {
        // 9999-13-04 ethioaa is the maximum date, which is equivalent to 4506-09-29 gregorian.
        return 9999;
    }
    constructor(...args){
        super(...args);
        this.identifier // also known as 'ethiopic-amete-alem' in ICU
         = "ethioaa";
    }
}
class $bf6421eb07c6b637$export$fe6243cbe1a4b7c1 extends $bf6421eb07c6b637$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$julianDayToCE($bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH, jd);
        let era = "CE";
        if (year <= 0) {
            era = "BCE";
            year = 1 - year;
        }
        return new $bf6421eb07c6b637$export$99faa760c7908e4f(this, era, year, month, day);
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === "BCE") year = 1 - year;
        return $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$ceToJulianDay($bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let year = date.year;
        if (date.era === "BCE") year = 1 - year;
        return $bf6421eb07c6b637$var$$b956b2d7a6cf451f$var$getDaysInMonth(year, date.month);
    }
    isInverseEra(date) {
        return date.era === "BCE";
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === "BCE" ? "CE" : "BCE";
            date.year = 1 - date.year;
        }
    }
    getEras() {
        return [
            "BCE",
            "CE"
        ];
    }
    getYearsInEra(date) {
        // 9999-12-30 gregorian is 9716-02-20 coptic.
        // Round down to 9715 for the last full year.
        // BCE 9999-01-01 coptic is BC 9716-06-15 gregorian.
        return date.era === "BCE" ? 9999 : 9715;
    }
    constructor(...args){
        super(...args);
        this.identifier = "coptic";
    }
}
function $bf6421eb07c6b637$export$dd0bbc9b26defe37(name) {
    switch(name){
        case "buddhist":
            return new $bf6421eb07c6b637$export$42d20a78301dee44();
        case "ethiopic":
            return new $bf6421eb07c6b637$export$26ba6eab5e20cd7d();
        case "ethioaa":
            return new $bf6421eb07c6b637$export$d72e0c37005a4914();
        case "coptic":
            return new $bf6421eb07c6b637$export$fe6243cbe1a4b7c1();
        case "hebrew":
            return new $bf6421eb07c6b637$export$ca405048b8fb5af();
        case "indian":
            return new $bf6421eb07c6b637$export$39f31c639fa15726();
        case "islamic-civil":
            return new $bf6421eb07c6b637$export$2066795aadd37bfc();
        case "islamic-tbla":
            return new $bf6421eb07c6b637$export$37f0887f2f9d22f7();
        case "islamic-umalqura":
            return new $bf6421eb07c6b637$export$5baab4758c231076();
        case "japanese":
            return new $bf6421eb07c6b637$export$b746ab2b60cdffbf();
        case "persian":
            return new $bf6421eb07c6b637$export$37fccdbfd14c5939();
        case "roc":
            return new $bf6421eb07c6b637$export$65e01080afcb0799();
        case "gregory":
        default:
            return new $bf6421eb07c6b637$export$80ee6245ec4f29ec();
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$formatterCache = new Map();
class $bf6421eb07c6b637$export$ad991b66133851cf {
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === "function") return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === "function") return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if ($bf6421eb07c6b637$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12";
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === "ethiopic-amete-alem") resolvedOptions.calendar = "ethioaa";
        return resolvedOptions;
    }
    constructor(locale, options = {}){
        this.formatter = $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: "h11"
    },
    false: {}
};
function $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === "boolean" && $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split("-")[0]];
        let defaultHourCycle = options.hour12 ? "h12" : "h23";
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($bf6421eb07c6b637$var$$fb18d541ea1ad717$var$formatterCache.has(cacheKey)) return $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
    if ($bf6421eb07c6b637$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null) $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === "24";
    return $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
let $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
    if ($bf6421eb07c6b637$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null) $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat("fr", {
        hour: "numeric",
        hour12: false
    }).resolvedOptions().hourCycle === "h12";
    return $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
    locale += (locale.includes("-u-") ? "" : "-u") + "-nu-latn";
    let formatter = $bf6421eb07c6b637$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === "hour").value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === "hour").value, 10);
    if (min === 0 && max === 23) return "h23";
    if (min === 24 && max === 23) return "h24";
    if (min === 0 && max === 11) return "h11";
    if (min === 12 && max === 11) return "h12";
    throw new Error("Unexpected hour cycle result");
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $3b768374b28ed6fc$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $3b768374b28ed6fc$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $3b768374b28ed6fc$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) {
    // If the Intl.Locale API is available, use it to get the script for the locale.
    // This is more accurate than guessing by language, since languages can be written in multiple scripts.
    // @ts-ignore
    if (Intl.Locale) {
        // @ts-ignore
        let script = new Intl.Locale(locale).maximize().script;
        return $3b768374b28ed6fc$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = locale.split("-")[0];
    return $3b768374b28ed6fc$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}
function $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
    // @ts-ignore
    let locale = typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: $3b768374b28ed6fc$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    };
}
let $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$currentLocale = $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
let $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$currentLocale = $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
    for (let listener of $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$listeners)listener($3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $aa3391c41265991b$export$535bd6ca7f90a273)();
    let [defaultLocale, setDefaultLocale] = (0, $acw62.useState)($3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $acw62.useEffect)(()=>{
        if ($3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}
const $3b768374b28ed6fc$var$$18f2051aff69b9bf$var$I18nContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $3b768374b28ed6fc$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let value = locale ? {
        locale: locale,
        direction: $3b768374b28ed6fc$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    } : defaultLocale;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3b768374b28ed6fc$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $3b768374b28ed6fc$export$43bb16f9c6d9e3f7() {
    let defaultLocale = $3b768374b28ed6fc$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let context = (0, $acw62.useContext)($3b768374b28ed6fc$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}
var $3b768374b28ed6fc$var$$2aa2084a6c2b6b4f$exports = {};
"use strict";
const $3b768374b28ed6fc$var$$fca6afa0e843324b$var$cache = new WeakMap();
function $3b768374b28ed6fc$var$$fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $3b768374b28ed6fc$var$$fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $62a3e9bf6f671e97$export$c17fa47878dc55b6)(strings);
        $3b768374b28ed6fc$var$$fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $3b768374b28ed6fc$export$f12b703ca79dfbb1(strings) {
    let { locale: locale } = $3b768374b28ed6fc$export$43bb16f9c6d9e3f7();
    let dictionary = (0, $acw62.useMemo)(()=>$3b768374b28ed6fc$var$$fca6afa0e843324b$var$getCachedDictionary(strings), [
        strings
    ]);
    return (0, $acw62.useMemo)(()=>new (0, $62a3e9bf6f671e97$export$2f817fcdc4b89ae0)(locale, dictionary), [
        locale,
        dictionary
    ]);
}
function $3b768374b28ed6fc$export$85fd5fdf27bacc79(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    let lastOptions = (0, $acw62.useRef)(null);
    if (options && lastOptions.current && $3b768374b28ed6fc$var$$896ba0a80a8f4d36$var$isEqual(options, lastOptions.current)) options = lastOptions.current;
    lastOptions.current = options;
    let { locale: locale } = $3b768374b28ed6fc$export$43bb16f9c6d9e3f7();
    return (0, $acw62.useMemo)(()=>new (0, $bf6421eb07c6b637$export$ad991b66133851cf)(locale, options), [
        locale,
        options
    ]);
}
function $3b768374b28ed6fc$var$$896ba0a80a8f4d36$var$isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}
function $3b768374b28ed6fc$export$b7a616150fdb9f44(options = {}) {
    let { locale: locale } = $3b768374b28ed6fc$export$43bb16f9c6d9e3f7();
    return (0, $acw62.useMemo)(()=>new (0, $d937707f3e0c3d96$export$cc77c4ff7e8673c5)(locale, options), [
        locale,
        options
    ]);
}
let $3b768374b28ed6fc$var$$325a3faab7a68acd$var$cache = new Map();
function $3b768374b28ed6fc$export$a16aca283550c30d(options) {
    let { locale: locale } = $3b768374b28ed6fc$export$43bb16f9c6d9e3f7();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($3b768374b28ed6fc$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $3b768374b28ed6fc$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $3b768374b28ed6fc$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}
function $3b768374b28ed6fc$export$3274cf84b703fff(options) {
    let collator = $3b768374b28ed6fc$export$a16aca283550c30d({
        usage: "search",
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    return {
        startsWith (string, substring) {
            if (substring.length === 0) return true;
            // Normalize both strings so we can slice safely
            // TODO: take into account the ignorePunctuation option as well...
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            return collator.compare(string.slice(0, substring.length), substring) === 0;
        },
        endsWith (string, substring) {
            if (substring.length === 0) return true;
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            return collator.compare(string.slice(-substring.length), substring) === 0;
        },
        contains (string, substring) {
            if (substring.length === 0) return true;
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            let scan = 0;
            let sliceLen = substring.length;
            for(; scan + sliceLen <= string.length; scan++){
                let slice = string.slice(scan, scan + sliceLen);
                if (collator.compare(substring, slice) === 0) return true;
            }
            return false;
        }
    };
}



function $738dfcf8f6e5fd78$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $df6686ed111e5fc0$export$e1865c3bedcd822b)() ? e.altKey : e.ctrlKey;
}
function $738dfcf8f6e5fd78$var$$feb5ffebff200149$export$16792effe837dba3(e) {
    if ((0, $df6686ed111e5fc0$export$9ac100e40613ea10)()) return e.metaKey;
    return e.ctrlKey;
}
function $738dfcf8f6e5fd78$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $acw62.useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $738dfcf8f6e5fd78$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, 500);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $738dfcf8f6e5fd78$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}
function $738dfcf8f6e5fd78$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, selectOnFocus: selectOnFocus = manager.selectionBehavior === "replace", disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, isVirtualized: isVirtualized, scrollRef: scrollRef = ref } = options;
    let { direction: direction } = (0, $3b768374b28ed6fc$export$43bb16f9c6d9e3f7)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                manager.setFocusedKey(key, childFocus);
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !$738dfcf8f6e5fd78$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var ref4, ref1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (ref4 = delegate.getFirstKey) === null || ref4 === void 0 ? void 0 : ref4.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (ref1 = delegate.getFirstKey) === null || ref1 === void 0 ? void 0 : ref1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var ref2, ref3;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (ref2 = delegate.getLastKey) === null || ref2 === void 0 ? void 0 : ref2.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (ref3 = delegate.getLastKey) === null || ref3 === void 0 ? void 0 : ref3.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyLeftOf(manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyRightOf(manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, $738dfcf8f6e5fd78$var$$feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(firstKey);
                    if ($738dfcf8f6e5fd78$var$$feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, $738dfcf8f6e5fd78$var$$feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(lastKey);
                    if ($738dfcf8f6e5fd78$var$$feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "a":
                if ($738dfcf8f6e5fd78$var$$feb5ffebff200149$export$16792effe837dba3(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                e.preventDefault();
                if (!disallowEmptySelection) manager.clearSelection();
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $441e2d66603366d7$export$2d6ec8fc375ceafa)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, $df6686ed111e5fc0$export$de79e2c695e052f3)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = (0, $acw62.useRef)({
        top: 0,
        left: 0
    });
    (0, $df6686ed111e5fc0$export$90fc3a17d93f704c)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _lastSelectedKey, _firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_lastSelectedKey = manager.lastSelectedKey) !== null && _lastSelectedKey !== void 0 ? _lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_firstSelectedKey = manager.firstSelectedKey) !== null && _firstSelectedKey !== void 0 ? _firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${manager.focusedKey}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection
                (0, $df6686ed111e5fc0$export$de79e2c695e052f3)(element);
                (0, $df6686ed111e5fc0$export$53a0910f038337bd)(scrollRef.current, element);
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (0, $acw62.useRef)(autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) focusedKey = selectedKeys.values().next().value;
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) (0, $441e2d66603366d7$export$80f3e147d781571c)(ref.current);
        }
        autoFocusRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    (0, $acw62.useEffect)(()=>{
        if (!isVirtualized && manager.focusedKey && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${manager.focusedKey}"]`);
            if (element) (0, $df6686ed111e5fc0$export$53a0910f038337bd)(scrollRef.current, element);
        }
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey
    ]);
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (e.currentTarget.contains(e.target)) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = $738dfcf8f6e5fd78$export$e32c88dfddc6e1d8({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $df6686ed111e5fc0$export$9d1611c77c2fe928)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}
function $738dfcf8f6e5fd78$export$ecf600387e221c37(options) {
    let { selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, isVirtualized: isVirtualized, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin } = options;
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && $738dfcf8f6e5fd78$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && ($738dfcf8f6e5fd78$var$$feb5ffebff200149$export$16792effe837dba3(e) || e.pointerType === "touch" || e.pointerType === "virtual")) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    // Focus the associated DOM node when this item becomes the focusedKey
    (0, $acw62.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus && document.activeElement !== ref.current) {
            if (focus) focus();
            else (0, $441e2d66603366d7$export$80f3e147d781571c)(ref.current);
        }
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    isDisabled = isDisabled || manager.isDisabled(key);
    let allowsSelection = !isDisabled && manager.canSelectItem(key);
    let allowsActions = onAction && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $acw62.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $acw62.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $acw62.useRef)(false);
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || $738dfcf8f6e5fd78$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !$738dfcf8f6e5fd78$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                onAction();
            } else if (e.pointerType !== "keyboard") onSelect(e);
        };
        else {
            itemPressProps.onPressUp = (e)=>{
                if (e.pointerType !== "keyboard") onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? ()=>onAction() : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!onAction || $738dfcf8f6e5fd78$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && $738dfcf8f6e5fd78$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) onAction();
                else onSelect(e);
            }
        };
    }
    if (!isVirtualized) itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps, isPressed: isPressed } = (0, $1eef7302de9b85e9$export$45712eceda6fad21)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            onAction();
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $1eef7302de9b85e9$export$c24ed0104d07eab9)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    let onDragStart = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    return {
        itemProps: (0, $df6686ed111e5fc0$export$9d1611c77c2fe928)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStart: onDragStart
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $738dfcf8f6e5fd78$var$$880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function $738dfcf8f6e5fd78$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}
class $738dfcf8f6e5fd78$export$a05409b8bb224a5a {
    getKeyBelow(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
    }
    getKeyAbove(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
    }
    getItem(key) {
        return this.ref.current.querySelector(`[data-key="${key}"]`);
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        let pageY = Math.max(0, item.offsetTop + item.offsetHeight - menu.offsetHeight);
        while(item && item.offsetTop > pageY){
            key = this.getKeyAbove(key);
            item = this.getItem(key);
        }
        return key;
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        let pageY = Math.min(menu.scrollHeight, item.offsetTop - item.offsetHeight + menu.offsetHeight);
        while(item && item.offsetTop < pageY){
            key = this.getKeyBelow(key);
            item = this.getItem(key);
        }
        return key;
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(collection, disabledKeys, ref, collator){
        this.collection = collection;
        this.disabledKeys = disabledKeys;
        this.ref = ref;
        this.collator = collator;
    }
}
function $738dfcf8f6e5fd78$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate, autoFocus: autoFocus, shouldFocusWrap: shouldFocusWrap, isVirtualized: isVirtualized, disallowEmptySelection: disallowEmptySelection, selectOnFocus: selectOnFocus = selectionManager.selectionBehavior === "replace", disallowTypeAhead: disallowTypeAhead, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $3b768374b28ed6fc$export$a16aca283550c30d)({
        usage: "search",
        sensitivity: "base"
    });
    let delegate = (0, $acw62.useMemo)(()=>keyboardDelegate || new $738dfcf8f6e5fd78$export$a05409b8bb224a5a(collection, disabledKeys, ref, collator), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator
    ]);
    let { collectionProps: collectionProps } = $738dfcf8f6e5fd78$export$d6daf82dcd84e87c({
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate,
        autoFocus: autoFocus,
        shouldFocusWrap: shouldFocusWrap,
        disallowEmptySelection: disallowEmptySelection,
        selectOnFocus: selectOnFocus,
        disallowTypeAhead: disallowTypeAhead,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        allowsTabNavigation: allowsTabNavigation,
        isVirtualized: isVirtualized,
        scrollRef: ref
    });
    return {
        listProps: collectionProps
    };
}



function $63d14d584fe826ec$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $63d14d584fe826ec$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $63d14d584fe826ec$var$$168583247155ddda$exports = {};
$63d14d584fe826ec$var$$parcel$export($63d14d584fe826ec$var$$168583247155ddda$exports, "useMenuTrigger", ()=>$63d14d584fe826ec$export$dc9c12ed27dd1b49);
var $63d14d584fe826ec$var$$9bdd31893c9700c3$exports = {};
var $63d14d584fe826ec$var$$c0398ad35c3639b7$exports = {};
$63d14d584fe826ec$var$$c0398ad35c3639b7$exports = JSON.parse('{"longPressMessage":"\u0627\u0636\u063A\u0637 \u0645\u0637\u0648\u0644\u0627\u064B \u0623\u0648 \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 Alt + \u0627\u0644\u0633\u0647\u0645 \u0644\u0623\u0633\u0641\u0644 \u0644\u0641\u062A\u062D \u0627\u0644\u0642\u0627\u0626\u0645\u0629"}');
var $63d14d584fe826ec$var$$7af657c4165927c3$exports = {};
$63d14d584fe826ec$var$$7af657c4165927c3$exports = JSON.parse('{"longPressMessage":"\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E \u0438\u043B\u0438 \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 Alt+ \u0441\u0442\u0440\u0435\u043B\u043A\u0430 \u043D\u0430\u0434\u043E\u043B\u0443, \u0437\u0430 \u0434\u0430 \u043E\u0442\u0432\u043E\u0440\u0438\u0442\u0435 \u043C\u0435\u043D\u044E\u0442\u043E"}');
var $63d14d584fe826ec$var$$d95d4da6d531ab81$exports = {};
$63d14d584fe826ec$var$$d95d4da6d531ab81$exports = JSON.parse('{"longPressMessage":"Dlouh\xfdm stiskem nebo stisknut\xedm kl\xe1ves Alt + \u0161ipka dol\u016F otev\u0159ete nab\xeddku"}');
var $63d14d584fe826ec$var$$24ebda9c775dca17$exports = {};
$63d14d584fe826ec$var$$24ebda9c775dca17$exports = JSON.parse('{"longPressMessage":"Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen"}');
var $63d14d584fe826ec$var$$743e0dfca6cab1e9$exports = {};
$63d14d584fe826ec$var$$743e0dfca6cab1e9$exports = JSON.parse('{"longPressMessage":"Dr\xfccken Sie lange oder dr\xfccken Sie Alt + Nach-unten, um das Men\xfc zu \xf6ffnen"}');
var $63d14d584fe826ec$var$$a2f41026e05f1c84$exports = {};
$63d14d584fe826ec$var$$a2f41026e05f1c84$exports = JSON.parse('{"longPressMessage":"\u03A0\u03B9\u03AD\u03C3\u03C4\u03B5 \u03C0\u03B1\u03C1\u03B1\u03C4\u03B5\u03C4\u03B1\u03BC\u03AD\u03BD\u03B1 \u03AE \u03C0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Alt + \u03BA\u03AC\u03C4\u03C9 \u03B2\u03AD\u03BB\u03BF\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B1\u03BD\u03BF\u03AF\u03BE\u03B5\u03C4\u03B5 \u03C4\u03BF \u03BC\u03B5\u03BD\u03BF\u03CD"}');
var $63d14d584fe826ec$var$$43b800e97c901737$exports = {};
$63d14d584fe826ec$var$$43b800e97c901737$exports = JSON.parse('{"longPressMessage":"Long press or press Alt + ArrowDown to open menu"}');
var $63d14d584fe826ec$var$$442f5f6ac211e29f$exports = {};
$63d14d584fe826ec$var$$442f5f6ac211e29f$exports = JSON.parse('{"longPressMessage":"Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa"}');
var $63d14d584fe826ec$var$$dff280acfeb2d8ac$exports = {};
$63d14d584fe826ec$var$$dff280acfeb2d8ac$exports = JSON.parse('{"longPressMessage":"Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool"}');
var $63d14d584fe826ec$var$$51608325613944d7$exports = {};
$63d14d584fe826ec$var$$51608325613944d7$exports = JSON.parse('{"longPressMessage":"Avaa valikko painamalla pohjassa tai n\xe4pp\xe4inyhdistelm\xe4ll\xe4 Alt + Alanuoli"}');
var $63d14d584fe826ec$var$$c4a1b1eabeaa87be$exports = {};
$63d14d584fe826ec$var$$c4a1b1eabeaa87be$exports = JSON.parse('{"longPressMessage":"Appuyez de mani\xe8re prolong\xe9e ou appuyez sur Alt\xa0+\xa0Fl\xe8che vers le bas pour ouvrir le menu."}');
var $63d14d584fe826ec$var$$8c74815cdee18d1b$exports = {};
$63d14d584fe826ec$var$$8c74815cdee18d1b$exports = JSON.parse('{"longPressMessage":"\u05DC\u05D7\u05E5 \u05DC\u05D7\u05D9\u05E6\u05D4 \u05D0\u05E8\u05D5\u05DB\u05D4 \u05D0\u05D5 \u05D4\u05E7\u05E9 Alt + ArrowDown \u05DB\u05D3\u05D9 \u05DC\u05E4\u05EA\u05D5\u05D7 \u05D0\u05EA \u05D4\u05EA\u05E4\u05E8\u05D9\u05D8"}');
var $63d14d584fe826ec$var$$fd0e9ef6a7fe0ec9$exports = {};
$63d14d584fe826ec$var$$fd0e9ef6a7fe0ec9$exports = JSON.parse('{"longPressMessage":"Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"}');
var $63d14d584fe826ec$var$$a89a74a39eba465a$exports = {};
$63d14d584fe826ec$var$$a89a74a39eba465a$exports = JSON.parse('{"longPressMessage":"Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xedl gombot a men\xfc megnyit\xe1s\xe1hoz"}');
var $63d14d584fe826ec$var$$edc7c66594a0ae8a$exports = {};
$63d14d584fe826ec$var$$edc7c66594a0ae8a$exports = JSON.parse('{"longPressMessage":"Premere a lungo o premere Alt + Freccia gi\xf9 per aprire il menu"}');
var $63d14d584fe826ec$var$$f1ab51510712db52$exports = {};
$63d14d584fe826ec$var$$f1ab51510712db52$exports = JSON.parse('{"longPressMessage":"\u9577\u62BC\u3057\u307E\u305F\u306F Alt+\u4E0B\u77E2\u5370\u30AD\u30FC\u3067\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F"}');
var $63d14d584fe826ec$var$$f9b672d9b82fa3d6$exports = {};
$63d14d584fe826ec$var$$f9b672d9b82fa3d6$exports = JSON.parse('{"longPressMessage":"\uAE38\uAC8C \uB204\uB974\uAC70\uB098 Alt + \uC544\uB798\uCABD \uD654\uC0B4\uD45C\uB97C \uB20C\uB7EC \uBA54\uB274 \uC5F4\uAE30"}');
var $63d14d584fe826ec$var$$a385f3910feda499$exports = {};
$63d14d584fe826ec$var$$a385f3910feda499$exports = JSON.parse('{"longPressMessage":"Nor\u0117dami atidaryti meniu, nuspaud\u0119 palaikykite arba paspauskite \u201EAlt + ArrowDown\u201C."}');
var $63d14d584fe826ec$var$$4f1bde932c441789$exports = {};
$63d14d584fe826ec$var$$4f1bde932c441789$exports = JSON.parse('{"longPressMessage":"Lai atv\u0113rtu izv\u0113lni, turiet nospiestu vai nospiediet tausti\u0146u kombin\u0101ciju Alt + lejupv\u0113rst\u0101 bulti\u0146a"}');
var $63d14d584fe826ec$var$$914a51a8a594d5be$exports = {};
$63d14d584fe826ec$var$$914a51a8a594d5be$exports = JSON.parse('{"longPressMessage":"Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen"}');
var $63d14d584fe826ec$var$$89aaf803103bb500$exports = {};
$63d14d584fe826ec$var$$89aaf803103bb500$exports = JSON.parse('{"longPressMessage":"Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"}');
var $63d14d584fe826ec$var$$c685891476dbaaca$exports = {};
$63d14d584fe826ec$var$$c685891476dbaaca$exports = JSON.parse('{"longPressMessage":"Naci\u015Bnij i przytrzymaj lub naci\u015Bnij klawisze Alt + Strza\u0142ka w d\xf3\u0142, aby otworzy\u0107 menu"}');
var $63d14d584fe826ec$var$$885879b9b10c2959$exports = {};
$63d14d584fe826ec$var$$885879b9b10c2959$exports = JSON.parse('{"longPressMessage":"Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"}');
var $63d14d584fe826ec$var$$6b39616688a51692$exports = {};
$63d14d584fe826ec$var$$6b39616688a51692$exports = JSON.parse('{"longPressMessage":"Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"}');
var $63d14d584fe826ec$var$$f26362aed63f47e2$exports = {};
$63d14d584fe826ec$var$$f26362aed63f47e2$exports = JSON.parse('{"longPressMessage":"Ap\u0103sa\u021Bi lung sau ap\u0103sa\u021Bi pe Alt + s\u0103geat\u0103 \xeen jos pentru a deschide meniul"}');
var $63d14d584fe826ec$var$$06cbade644558bf0$exports = {};
$63d14d584fe826ec$var$$06cbade644558bf0$exports = JSON.parse('{"longPressMessage":"\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0438 \u0443\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 Alt + \u0421\u0442\u0440\u0435\u043B\u043A\u0430 \u0432\u043D\u0438\u0437, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043C\u0435\u043D\u044E"}');
var $63d14d584fe826ec$var$$0a391ff68f9d59b1$exports = {};
$63d14d584fe826ec$var$$0a391ff68f9d59b1$exports = JSON.parse('{"longPressMessage":"Ponuku otvor\xedte dlh\xfdm stla\u010Den\xedm alebo stla\u010Den\xedm kl\xe1vesu Alt + kl\xe1vesu so \u0161\xedpkou nadol"}');
var $63d14d584fe826ec$var$$8193cf0e649c7928$exports = {};
$63d14d584fe826ec$var$$8193cf0e649c7928$exports = JSON.parse('{"longPressMessage":"Za odprtje menija pritisnite in dr\u017Eite gumb ali pritisnite Alt+pu\u0161\u010Dica navzdol"}');
var $63d14d584fe826ec$var$$f398debcce5a5c55$exports = {};
$63d14d584fe826ec$var$$f398debcce5a5c55$exports = JSON.parse('{"longPressMessage":"Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"}');
var $63d14d584fe826ec$var$$9e9fef000aa4c013$exports = {};
$63d14d584fe826ec$var$$9e9fef000aa4c013$exports = JSON.parse('{"longPressMessage":"H\xe5ll nedtryckt eller tryck p\xe5 Alt + pil ned\xe5t f\xf6r att \xf6ppna menyn"}');
var $63d14d584fe826ec$var$$c016c8183bbe3d68$exports = {};
$63d14d584fe826ec$var$$c016c8183bbe3d68$exports = JSON.parse('{"longPressMessage":"Men\xfcy\xfc a\xe7mak i\xe7in uzun bas\u0131n veya Alt + A\u015Fa\u011F\u0131 Ok tu\u015Funa bas\u0131n"}');
var $63d14d584fe826ec$var$$ca4f6c8462244e62$exports = {};
$63d14d584fe826ec$var$$ca4f6c8462244e62$exports = JSON.parse('{"longPressMessage":"\u0414\u043E\u0432\u0433\u043E \u0430\u0431\u043E \u0437\u0432\u0438\u0447\u0430\u0439\u043D\u043E \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043A\u043E\u043C\u0431\u0456\u043D\u0430\u0446\u0456\u044E \u043A\u043B\u0430\u0432\u0456\u0448 Alt \u0456 \u0441\u0442\u0440\u0456\u043B\u043A\u0430 \u0432\u043D\u0438\u0437, \u0449\u043E\u0431 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043C\u0435\u043D\u044E"}');
var $63d14d584fe826ec$var$$2d9960c02ccac927$exports = {};
$63d14d584fe826ec$var$$2d9960c02ccac927$exports = JSON.parse('{"longPressMessage":"\u957F\u6309\u6216\u6309 Alt + \u5411\u4E0B\u65B9\u5411\u952E\u4EE5\u6253\u5F00\u83DC\u5355"}');
var $63d14d584fe826ec$var$$f1b682a4c8c5631c$exports = {};
$63d14d584fe826ec$var$$f1b682a4c8c5631c$exports = JSON.parse('{"longPressMessage":"\u9577\u6309\u6216\u6309 Alt+\u5411\u4E0B\u9375\u4EE5\u958B\u555F\u529F\u80FD\u8868"}');
$63d14d584fe826ec$var$$9bdd31893c9700c3$exports = {
    "ar-AE": $63d14d584fe826ec$var$$c0398ad35c3639b7$exports,
    "bg-BG": $63d14d584fe826ec$var$$7af657c4165927c3$exports,
    "cs-CZ": $63d14d584fe826ec$var$$d95d4da6d531ab81$exports,
    "da-DK": $63d14d584fe826ec$var$$24ebda9c775dca17$exports,
    "de-DE": $63d14d584fe826ec$var$$743e0dfca6cab1e9$exports,
    "el-GR": $63d14d584fe826ec$var$$a2f41026e05f1c84$exports,
    "en-US": $63d14d584fe826ec$var$$43b800e97c901737$exports,
    "es-ES": $63d14d584fe826ec$var$$442f5f6ac211e29f$exports,
    "et-EE": $63d14d584fe826ec$var$$dff280acfeb2d8ac$exports,
    "fi-FI": $63d14d584fe826ec$var$$51608325613944d7$exports,
    "fr-FR": $63d14d584fe826ec$var$$c4a1b1eabeaa87be$exports,
    "he-IL": $63d14d584fe826ec$var$$8c74815cdee18d1b$exports,
    "hr-HR": $63d14d584fe826ec$var$$fd0e9ef6a7fe0ec9$exports,
    "hu-HU": $63d14d584fe826ec$var$$a89a74a39eba465a$exports,
    "it-IT": $63d14d584fe826ec$var$$edc7c66594a0ae8a$exports,
    "ja-JP": $63d14d584fe826ec$var$$f1ab51510712db52$exports,
    "ko-KR": $63d14d584fe826ec$var$$f9b672d9b82fa3d6$exports,
    "lt-LT": $63d14d584fe826ec$var$$a385f3910feda499$exports,
    "lv-LV": $63d14d584fe826ec$var$$4f1bde932c441789$exports,
    "nb-NO": $63d14d584fe826ec$var$$914a51a8a594d5be$exports,
    "nl-NL": $63d14d584fe826ec$var$$89aaf803103bb500$exports,
    "pl-PL": $63d14d584fe826ec$var$$c685891476dbaaca$exports,
    "pt-BR": $63d14d584fe826ec$var$$885879b9b10c2959$exports,
    "pt-PT": $63d14d584fe826ec$var$$6b39616688a51692$exports,
    "ro-RO": $63d14d584fe826ec$var$$f26362aed63f47e2$exports,
    "ru-RU": $63d14d584fe826ec$var$$06cbade644558bf0$exports,
    "sk-SK": $63d14d584fe826ec$var$$0a391ff68f9d59b1$exports,
    "sl-SI": $63d14d584fe826ec$var$$8193cf0e649c7928$exports,
    "sr-SP": $63d14d584fe826ec$var$$f398debcce5a5c55$exports,
    "sv-SE": $63d14d584fe826ec$var$$9e9fef000aa4c013$exports,
    "tr-TR": $63d14d584fe826ec$var$$c016c8183bbe3d68$exports,
    "uk-UA": $63d14d584fe826ec$var$$ca4f6c8462244e62$exports,
    "zh-CN": $63d14d584fe826ec$var$$2d9960c02ccac927$exports,
    "zh-TW": $63d14d584fe826ec$var$$f1b682a4c8c5631c$exports
};
function $63d14d584fe826ec$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = "menu", isDisabled: isDisabled, trigger: trigger = "press" } = props;
    let menuTriggerId = (0, $4d60a29ecf011a9e$export$f680877a34711e37)();
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $e0fe69584fec2898$export$f9d5c8beee7d008d)({
        type: type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === "longPress" && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case "Enter":
            case " ":
                if (trigger === "longPress") return;
            // fallthrough
            case "ArrowDown":
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("first");
                break;
            case "ArrowUp":
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("last");
                break;
        }
    };
    let formatMessage = (0, $cc77112e47cb65f2$export$ec23bf898b1eed85)(/*@__PURE__*/ $63d14d584fe826ec$var$$parcel$interopDefault($63d14d584fe826ec$var$$9bdd31893c9700c3$exports));
    let { longPressProps: longPressProps } = (0, $895d146aa86f8a19$export$c24ed0104d07eab9)({
        isDisabled: isDisabled || trigger !== "longPress",
        accessibilityDescription: formatMessage("longPressMessage"),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open("first");
        }
    });
    let pressProps = {
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== "touch" && e.pointerType !== "keyboard" && !isDisabled) // Otherwise, the menu itself will be focused.
            state.toggle(e.pointerType === "virtual" ? "first" : null);
        },
        onPress (e) {
            if (e.pointerType === "touch" && !isDisabled) state.toggle();
        }
    };
    triggerProps = (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(triggerProps, trigger === "press" ? pressProps : longPressProps);
    return {
        menuTriggerProps: {
            ...triggerProps,
            id: menuTriggerId,
            onKeyDown: onKeyDown
        },
        menuProps: {
            ...overlayProps,
            "aria-labelledby": menuTriggerId
        }
    };
}
var $63d14d584fe826ec$var$$d5336fe17ce95402$exports = {};
$63d14d584fe826ec$var$$parcel$export($63d14d584fe826ec$var$$d5336fe17ce95402$exports, "useMenu", ()=>$63d14d584fe826ec$export$38eaa17faae8f579);
function $63d14d584fe826ec$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true, ...otherProps } = props;
    if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
    let domProps = (0, $4d60a29ecf011a9e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let { listProps: listProps } = (0, $738dfcf8f6e5fd78$export$b95089534ab7c1fd)({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap
    });
    return {
        menuProps: (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(domProps, {
            role: "menu",
            ...listProps
        })
    };
}
var $63d14d584fe826ec$var$$a2e5df62f93c7633$exports = {};
$63d14d584fe826ec$var$$parcel$export($63d14d584fe826ec$var$$a2e5df62f93c7633$exports, "useMenuItem", ()=>$63d14d584fe826ec$export$9d32628fc2aea7da);
function $63d14d584fe826ec$export$9d32628fc2aea7da(props, state, ref) {
    let { isSelected: isSelected, isDisabled: isDisabled, key: key, onClose: onClose, closeOnSelect: closeOnSelect, isVirtualized: isVirtualized, onAction: onAction } = props;
    let role = "menuitem";
    if (state.selectionManager.selectionMode === "single") role = "menuitemradio";
    else if (state.selectionManager.selectionMode === "multiple") role = "menuitemcheckbox";
    let labelId = (0, $4d60a29ecf011a9e$export$b4cc09c592e8fdb8)();
    let descriptionId = (0, $4d60a29ecf011a9e$export$b4cc09c592e8fdb8)();
    let keyboardId = (0, $4d60a29ecf011a9e$export$b4cc09c592e8fdb8)();
    let ariaProps = {
        "aria-disabled": isDisabled,
        role: role,
        "aria-label": props["aria-label"],
        "aria-labelledby": labelId,
        "aria-describedby": [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(" ") || undefined
    };
    if (state.selectionManager.selectionMode !== "none") ariaProps["aria-checked"] = isSelected;
    if (isVirtualized) {
        ariaProps["aria-posinset"] = state.collection.getItem(key).index;
        ariaProps["aria-setsize"] = (0, $adbad999e88477eb$export$77d5aafae4e095b2)(state.collection);
    }
    let onKeyDown = (e)=>{
        // Ignore repeating events, which may have started on the menu trigger before moving
        // focus to the menu item. We want to wait for a second complete key press sequence.
        if (e.repeat) return;
        switch(e.key){
            case " ":
                if (!isDisabled && state.selectionManager.selectionMode === "none" && closeOnSelect !== false && onClose) onClose();
                break;
            case "Enter":
                // The Enter key should always close on select, except if overridden.
                if (!isDisabled && closeOnSelect !== false && onClose) onClose();
                break;
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType === "keyboard" && onAction) onAction(key);
    };
    let onPressUp = (e)=>{
        if (e.pointerType !== "keyboard") {
            if (onAction) onAction(key);
            // Pressing a menu item should close by default in single selection mode but not multiple
            // selection mode, except if overridden by the closeOnSelect prop.
            if (onClose && (closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : state.selectionManager.selectionMode !== "multiple")) onClose();
        }
    };
    let { itemProps: itemProps } = (0, $738dfcf8f6e5fd78$export$ecf600387e221c37)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true
    });
    let { pressProps: pressProps } = (0, $895d146aa86f8a19$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressUp: onPressUp,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps } = (0, $895d146aa86f8a19$export$ae780daf29e6d456)({
        isDisabled: isDisabled,
        onHoverStart () {
            if (!(0, $895d146aa86f8a19$export$b9b3dfddab17db27)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    return {
        menuItemProps: {
            ...ariaProps,
            ...(0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(itemProps, pressProps, hoverProps, {
                onKeyDown: onKeyDown
            })
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        }
    };
}
var $63d14d584fe826ec$var$$3e5eb2498db5b506$exports = {};
$63d14d584fe826ec$var$$parcel$export($63d14d584fe826ec$var$$3e5eb2498db5b506$exports, "useMenuSection", ()=>$63d14d584fe826ec$export$73f7a44322579622);
function $63d14d584fe826ec$export$73f7a44322579622(props) {
    let { heading: heading, "aria-label": ariaLabel } = props;
    let headingId = (0, $4d60a29ecf011a9e$export$f680877a34711e37)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, and only use it
            // as a label for the nested group.
            id: headingId,
            "aria-hidden": true
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $acf7c577f084cfa2$export$40bfa8c7b0832715(value1, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $acw62.useState)(value1 || defaultValue);
    let ref = (0, $acw62.useRef)(value1 !== undefined);
    let wasControlled = ref.current;
    let isControlled = value1 !== undefined;
    // Internal state reference for useCallback
    let stateRef = (0, $acw62.useRef)(stateValue);
    if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
    ref.current = isControlled;
    let setValue = (0, $acw62.useCallback)((value2, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(stateRef.current, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) stateRef.current = value;
        };
        if (typeof value2 === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value2(isControlled ? stateRef.current : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value2);
            onChangeCaller(value2, ...args);
        }
    }, [
        isControlled,
        onChange
    ]);
    // If a controlled component's value prop changes, we need to update stateRef
    if (isControlled) stateRef.current = value1;
    else value1 = stateValue;
    return [
        value1,
        setValue
    ];
}
function $acf7c577f084cfa2$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $acf7c577f084cfa2$export$cb6e0bb50bc19463(value, min, max, step) {
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $acf7c577f084cfa2$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}


class $371f21ba002624f4$var$$e40ea825a81a3709$export$52baac22726c72bf extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof $371f21ba002624f4$var$$e40ea825a81a3709$export$52baac22726c72bf) {
            this.anchorKey = anchorKey || keys.anchorKey;
            this.currentKey = currentKey || keys.currentKey;
        } else {
            this.anchorKey = anchorKey;
            this.currentKey = currentKey;
        }
    }
}
function $371f21ba002624f4$var$$7af3f5b51489e0b5$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function $371f21ba002624f4$export$253fe78d46329472(props) {
    let { selectionMode: selectionMode = "none", disallowEmptySelection: disallowEmptySelection, allowDuplicateSelectionEvents: allowDuplicateSelectionEvents, selectionBehavior: selectionBehaviorProp = "toggle", disabledBehavior: disabledBehavior = "all" } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (0, $acw62.useRef)(false);
    let [, setFocused] = (0, $acw62.useState)(false);
    let focusedKeyRef = (0, $acw62.useRef)(null);
    let childFocusStrategyRef = (0, $acw62.useRef)(null);
    let [, setFocusedKey] = (0, $acw62.useState)(null);
    let selectedKeysProp = (0, $acw62.useMemo)(()=>$371f21ba002624f4$var$$7af3f5b51489e0b5$var$convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (0, $acw62.useMemo)(()=>$371f21ba002624f4$var$$7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new $371f21ba002624f4$var$$e40ea825a81a3709$export$52baac22726c72bf()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = (0, $acf7c577f084cfa2$export$40bfa8c7b0832715)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (0, $acw62.useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === "replace" && selectionBehavior === "toggle" && typeof selectedKeys === "object" && selectedKeys.size === 0) setSelectionBehavior("replace");
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (0, $acw62.useRef)(selectionBehaviorProp);
    (0, $acw62.useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = "first") {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !$371f21ba002624f4$var$$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $371f21ba002624f4$var$$7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === "all" ? "all" : new $371f21ba002624f4$var$$e40ea825a81a3709$export$52baac22726c72bf(selection);
}
class $371f21ba002624f4$export$6c8a5aaad13c9852 {
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === "none") return false;
        key = this.getKey(key);
        return this.state.selectedKeys === "all" ? this.canSelectItem(key) : this.state.selectedKeys.has(key);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === "all") return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || (item === null || item === void 0 ? void 0 : item.index) < first.index) first = item;
        }
        return first === null || first === void 0 ? void 0 : first.key;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || (item === null || item === void 0 ? void 0 : item.index) > last.index) last = item;
        }
        return last === null || last === void 0 ? void 0 : last.key;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            this.replaceSelection(toKey);
            return;
        }
        toKey = this.getKey(toKey);
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === "all") selection = new $371f21ba002624f4$var$$e40ea825a81a3709$export$52baac22726c72bf([
            toKey
        ], toKey, toKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            let anchorKey = selectedKeys.anchorKey || toKey;
            selection = new $371f21ba002624f4$var$$e40ea825a81a3709$export$52baac22726c72bf(selectedKeys, anchorKey, toKey);
            for (let key of this.getKeyRange(anchorKey, selectedKeys.currentKey || toKey))selection.delete(key);
            for (let key1 of this.getKeyRange(toKey, anchorKey))if (this.canSelectItem(key1)) selection.add(key1);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if (fromItem.index <= toItem.index) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        let keys = [];
        let key = from;
        while(key){
            let item = this.collection.getItem(key);
            if (item && item.type === "item" || item.type === "cell" && this.allowsCellSelection) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) return key;
        // If cell selection is allowed, just return the key.
        if (item.type === "cell" && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item.type !== "item" && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== "item") return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single" && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        key = this.getKey(key);
        if (key == null) return;
        let keys = new $371f21ba002624f4$var$$e40ea825a81a3709$export$52baac22726c72bf(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(key)) keys.delete(key);
        else if (this.canSelectItem(key)) {
            keys.add(key);
            keys.anchorKey = key;
            keys.currentKey = key;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === "none") return;
        key = this.getKey(key);
        if (key == null) return;
        let selection = this.canSelectItem(key) ? new $371f21ba002624f4$var$$e40ea825a81a3709$export$52baac22726c72bf([
            key
        ], key, key) : new $371f21ba002624f4$var$$e40ea825a81a3709$export$52baac22726c72bf();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === "none") return;
        let selection = new $371f21ba002624f4$var$$e40ea825a81a3709$export$52baac22726c72bf();
        for (let key of keys){
            key = this.getKey(key);
            if (key != null) {
                selection.add(key);
                if (this.selectionMode === "single") break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        let keys = [];
        let addKeys = (key)=>{
            while(key){
                if (this.canSelectItem(key)) {
                    let item = this.collection.getItem(key);
                    if (item.type === "item") keys.push(key);
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if (item.hasChildNodes && (this.allowsCellSelection || item.type !== "item")) addKeys([
                        ...item.childNodes
                    ][0].key);
                }
                key = this.collection.getKeyAfter(key);
            }
        };
        addKeys(this.collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (this.selectionMode === "multiple") this.state.setSelectedKeys("all");
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new $371f21ba002624f4$var$$e40ea825a81a3709$export$52baac22726c72bf());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === "toggle" || e && (e.pointerType === "touch" || e.pointerType === "virtual")) this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key2 of selectedKeys){
            if (!selection.has(key2)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        if (this.state.selectionMode === "none" || this.state.disabledKeys.has(key)) return false;
        let item = this.collection.getItem(key);
        if (!item || item.type === "cell" && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        return this.state.disabledKeys.has(key) && this.state.disabledBehavior === "all";
    }
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        var ref;
        this.allowsCellSelection = (ref = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && ref !== void 0 ? ref : false;
        this._isSelectAll = null;
    }
}




function $a5088832486da6f1$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $a5088832486da6f1$var$$875d6693e12af071$exports = {};
$a5088832486da6f1$var$$parcel$export($a5088832486da6f1$var$$875d6693e12af071$exports, "useTreeState", ()=>$a5088832486da6f1$export$728d6ba534403756);
var $a5088832486da6f1$var$tmp = Symbol.iterator;
class $a5088832486da6f1$var$$05ca4cd7c4a5a999$export$863faf230ee2118a {
    *[$a5088832486da6f1$var$tmp]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    constructor(nodes, { expandedKeys: expandedKeys } = {}){
        this.keyMap = new Map();
        this.iterable = nodes;
        expandedKeys = expandedKeys || new Set();
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && (node.type === "section" || expandedKeys.has(node.key))) for (let child of node.childNodes)visit(child);
        };
        for (let node2 of nodes)visit(node2);
        let last;
        let index = 0;
        for (let [key, node1] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node1.prevKey = last.key;
            } else {
                this.firstKey = key;
                node1.prevKey = undefined;
            }
            if (node1.type === "item") node1.index = index++;
            last = node1;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}
function $a5088832486da6f1$export$728d6ba534403756(props) {
    let [expandedKeys, setExpandedKeys] = (0, $acf7c577f084cfa2$export$40bfa8c7b0832715)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), props.onExpandedChange);
    let selectionState = (0, $371f21ba002624f4$export$253fe78d46329472)(props);
    let disabledKeys = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let tree = (0, $adbad999e88477eb$export$6cd28814d92fa9c9)(props, (nodes)=>new $a5088832486da6f1$var$$05ca4cd7c4a5a999$export$863faf230ee2118a(nodes, {
            expandedKeys: expandedKeys
        }), null, [
        expandedKeys
    ]);
    // Reset focused key if that item is deleted from the collection.
    (0, $acw62.useEffect)(()=>{
        if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    }, [
        tree,
        selectionState.focusedKey
    ]);
    let onToggle = (key)=>{
        setExpandedKeys($a5088832486da6f1$var$$875d6693e12af071$var$toggleKey(expandedKeys, key));
    };
    return {
        collection: tree,
        expandedKeys: expandedKeys,
        disabledKeys: disabledKeys,
        toggleKey: onToggle,
        selectionManager: new (0, $371f21ba002624f4$export$6c8a5aaad13c9852)(tree, selectionState)
    };
}
function $a5088832486da6f1$var$$875d6693e12af071$var$toggleKey(set, key) {
    let res = new Set(set);
    if (res.has(key)) res.delete(key);
    else res.add(key);
    return res;
}






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




parcelRequire("acw62");




const $8c9cfa2d335032e8$export$d9b706f8d0a70aef = (0, $07d095cbefc9a288$export$d25ddfdf17c3ad3e)({
    "100%": {
        strokeDashoffset: 0
    }
});
const $8c9cfa2d335032e8$var$a = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("svg", {
    d: "block",
    path: {
        transformOrigin: "50% 50%",
        strokeDasharray: 48,
        strokeDashoffset: 48,
        animation: `${$8c9cfa2d335032e8$export$d9b706f8d0a70aef} .25s cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards`
    }
}), $8c9cfa2d335032e8$var$c = (t)=>{
    const { width: r = 24, height: e = 24, size: o, strokeWidth: c = 3, fill: m = "currentColor", css: h, className: n } = t;
    return (0, $7b02d682eb115277$exports.jsx)($8c9cfa2d335032e8$var$a, {
        role: "img",
        width: o || r,
        height: o || e,
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-checkmark", n),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        css: {
            ...h
        },
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            stroke: m,
            strokeWidth: c,
            fill: "none",
            d: "M14.1 27.2l7.1 7.2 16.7-16.8"
        })
    });
};
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($8c9cfa2d335032e8$var$c.displayName = "NextUI.Checkmark"), $8c9cfa2d335032e8$var$c.toString = ()=>".nextui-checkmark";
var $8c9cfa2d335032e8$export$2e2bcd8739ae039 = $8c9cfa2d335032e8$var$c;





const $a0430fb1fea1fc30$export$5c8a2f763c06db40 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("ul", {
    $$dropdownItemHeight: "$space$13",
    $$dropdownMenuPadding: "$space$4",
    $$dropdownMenuWidth: "250px",
    listStyle: "none",
    position: "relative",
    width: "$$dropdownMenuWidth",
    p: "$$dropdownMenuPadding",
    m: 0,
    outline: "none"
});
const $a0430fb1fea1fc30$export$bffec919c1b0804f = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {
    dflex: "center",
    flexShrink: 0,
    mr: "$4"
});
const $a0430fb1fea1fc30$export$b45d1389a54548f6 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("kbd", {
    opacity: .8,
    ml: "$4",
    mr: 0,
    dflex: "center",
    color: "$$dropdownItemKeyboardColor",
    fontSize: "$xs",
    fontFamily: "$sans",
    boxShadow: "none",
    bg: "transparent",
    transition: "border 0.26s ease 0s"
});
const $a0430fb1fea1fc30$export$a0d1b96c5ba9b86b = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    d: "flex",
    flex: "1 1 0%",
    flexDirection: "column",
    alignItems: "flex-start",
    lineHeight: 1.2
});
const $a0430fb1fea1fc30$export$87d1d981382aadb3 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {
    flex: "1 1 0%"
});
const $a0430fb1fea1fc30$export$1a3d580156ab0b53 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {
    fontSize: "$xs",
    color: "$$dropdownItemDescriptionColor",
    truncateText: "calc($$dropdownMenuWidth * 0.9)",
    transition: "color 0.26s ease 0s",
    variants: {
        hasIcon: {
            true: {
                truncateText: "calc($$dropdownMenuWidth * 0.7)"
            }
        },
        hasCommand: {
            true: {
                truncateText: "calc($$dropdownMenuWidth * 0.7)"
            }
        }
    },
    compoundVariants: [
        {
            hasIcon: !0,
            hasCommand: !0,
            css: {
                truncateText: "calc($$dropdownMenuWidth * 0.6)"
            }
        }
    ]
});
const $a0430fb1fea1fc30$export$297f2fe7e344c781 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("li", {
    $$dropdownItemPressedScale: .97,
    $$dropdownItemTextColor: "$colors$text",
    $$dropdownItemBorderRadius: "$radii$sm",
    $$dropdownItemKeyboardColor: "$colors$accents8",
    $$dropdownItemDescriptionColor: "$colors$accents8",
    dflex: "center",
    outline: "none",
    cursor: "pointer",
    justifyContent: "space-between",
    bg: "transparent",
    position: "relative",
    height: "$$dropdownItemHeight",
    px: "$6",
    br: "$$dropdownItemBorderRadius",
    color: "$$dropdownItemTextColor",
    mb: 0,
    transition: "$dropdownItem",
    transform: "translateZ(0)",
    backfaceVisibility: "hidden",
    $$dropdownItemShadow: "$colors$primaryShadow",
    "@motion": {
        transition: "none",
        [`& ${$a0430fb1fea1fc30$export$b45d1389a54548f6}`]: {
            transition: "none"
        },
        [`& ${$a0430fb1fea1fc30$export$1a3d580156ab0b53}`]: {
            transition: "none"
        }
    },
    variants: {
        color: {
            default: {
                $$dropdownItemHoverBackground: "$colors$neutralLight",
                $$dropdownItemHoverTextColor: "$colors$neutralLightContrast",
                $$dropdownItemActiveBackground: "$colors$neutralLightActive",
                $$dropdownItemSolidHoverBackground: "$colors$neutral",
                $$dropdownItemSolidHoverTextColor: "$colors$neutralSolidContrast",
                $$dropdownItemShadow: "$colors$neutralShadow",
                $$dropdownItemHoverBorderColor: "$colors$neutralBorder"
            },
            primary: {
                $$dropdownItemHoverBackground: "$colors$primaryLight",
                $$dropdownItemHoverTextColor: "$colors$primaryLightContrast",
                $$dropdownItemActiveBackground: "$colors$primaryLightActive",
                $$dropdownItemSolidHoverBackground: "$colors$primary",
                $$dropdownItemSolidHoverTextColor: "$colors$primarySolidContrast",
                $$dropdownItemShadow: "$colors$primaryShadow",
                $$dropdownItemHoverBorderColor: "$colors$primaryBorder"
            },
            secondary: {
                $$dropdownItemHoverBackground: "$colors$secondaryLight",
                $$dropdownItemHoverTextColor: "$colors$secondaryLightContrast",
                $$dropdownItemActiveBackground: "$colors$secondaryLightActive",
                $$dropdownItemSolidHoverBackground: "$colors$secondary",
                $$dropdownItemSolidHoverTextColor: "$colors$secondarySolidContrast",
                $$dropdownItemShadow: "$colors$secondaryShadow",
                $$dropdownItemHoverBorderColor: "$colors$secondaryBorder"
            },
            success: {
                $$dropdownItemHoverBackground: "$colors$successLight",
                $$dropdownItemHoverTextColor: "$colors$successLightContrast",
                $$dropdownItemActiveBackground: "$colors$successLightActive",
                $$dropdownItemSolidHoverBackground: "$colors$success",
                $$dropdownItemSolidHoverTextColor: "$colors$successSolidContrast",
                $$dropdownItemShadow: "$colors$successShadow",
                $$dropdownItemHoverBorderColor: "$colors$successBorder"
            },
            warning: {
                $$dropdownItemHoverBackground: "$colors$warningLight",
                $$dropdownItemHoverTextColor: "$colors$warningLightContrast",
                $$dropdownItemActiveBackground: "$colors$warningLightActive",
                $$dropdownItemSolidHoverBackground: "$colors$warning",
                $$dropdownItemSolidHoverTextColor: "$colors$warningSolidContrast",
                $$dropdownItemShadow: "$colors$warningShadow",
                $$dropdownItemHoverBorderColor: "$colors$warningBorder"
            },
            error: {
                $$dropdownItemHoverBackground: "$colors$errorLight",
                $$dropdownItemHoverTextColor: "$colors$errorLightContrast",
                $$dropdownItemActiveBackground: "$colors$errorLightActive",
                $$dropdownItemSolidHoverBackground: "$colors$error",
                $$dropdownItemSolidHoverTextColor: "$colors$errorSolidContrast",
                $$dropdownItemShadow: "$colors$errorShadow",
                $$dropdownItemHoverBorderColor: "$colors$errorBorder"
            }
        },
        textColor: {
            default: {},
            primary: {
                $$dropdownItemTextColor: "$colors$primaryLightContrast",
                $$dropdownItemHoverTextColor: "$colors$primaryLightContrast"
            },
            secondary: {
                $$dropdownItemTextColor: "$colors$secondaryLightContrast",
                $$dropdownItemHoverTextColor: "$colors$secondaryLightContrast"
            },
            success: {
                $$dropdownItemTextColor: "$colors$successLightContrast",
                $$dropdownItemHoverTextColor: "$colors$successLightContrast"
            },
            warning: {
                $$dropdownItemTextColor: "$colors$warningLightContrast",
                $$dropdownItemHoverTextColor: "$colors$warningLightContrast"
            },
            error: {
                $$dropdownItemTextColor: "$colors$errorLightContrast",
                $$dropdownItemHoverTextColor: "$colors$errorLightContrast"
            }
        },
        variant: {
            flat: {
                true: {}
            },
            light: {
                true: {}
            },
            solid: {
                true: {}
            },
            shadow: {
                true: {}
            }
        },
        isPressed: {
            true: {
                bg: "$$dropdownItemActiveBackground"
            }
        },
        isFocused: {
            true: {
                bg: "$$dropdownItemHoverBackground",
                color: "$$dropdownItemHoverTextColor",
                [`& ${$a0430fb1fea1fc30$export$b45d1389a54548f6}`]: {
                    color: "$$dropdownItemHoverTextColor",
                    borderColor: "$$dropdownItemHoverBorderColor"
                },
                [`& ${$a0430fb1fea1fc30$export$1a3d580156ab0b53}`]: {
                    color: "currentColor"
                }
            }
        },
        isHovered: {
            true: {
                bg: "$$dropdownItemHoverBackground",
                color: "$$dropdownItemHoverTextColor",
                [`& ${$a0430fb1fea1fc30$export$b45d1389a54548f6}`]: {
                    color: "$$dropdownItemHoverTextColor",
                    borderColor: "$$dropdownItemHoverBorderColor"
                },
                [`& ${$a0430fb1fea1fc30$export$1a3d580156ab0b53}`]: {
                    color: "currentColor"
                }
            }
        },
        shouldShowOutline: {
            true: {
                outline: "solid 2px $$dropdownItemActiveBackground"
            }
        },
        isSelected: {
            true: {}
        },
        isSelectable: {
            true: {}
        },
        isDisabled: {
            true: {
                color: "$accents5",
                cursor: "default"
            }
        },
        withDescription: {
            true: {
                height: "calc($$dropdownItemHeight * 1.2)"
            }
        },
        withDivider: {
            true: {
                mt: "$6",
                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: "-$3",
                    left: "-$$dropdownMenuPadding",
                    right: "-$$dropdownMenuPadding",
                    height: "$$dropdownItemBorderWeight",
                    bg: "$border"
                }
            }
        },
        dividerWeight: {
            light: {
                $$dropdownItemBorderWeight: "$borderWeights$light"
            },
            normal: {
                $$dropdownItemBorderWeight: "$borderWeights$normal"
            },
            bold: {
                $$dropdownItemBorderWeight: "$borderWeights$bold"
            },
            extrabold: {
                $$dropdownItemBorderWeight: "$borderWeights$extrabold"
            },
            black: {
                $$dropdownItemBorderWeight: "$borderWeights$black"
            }
        },
        disableAnimation: {
            true: {
                transition: "none",
                [`& ${$a0430fb1fea1fc30$export$b45d1389a54548f6}`]: {
                    transition: "none"
                },
                [`& ${$a0430fb1fea1fc30$export$1a3d580156ab0b53}`]: {
                    transition: "none"
                }
            }
        }
    },
    compoundVariants: [
        {
            isPressed: !0,
            disableAnimation: !1,
            css: {
                transform: "scale($$dropdownItemPressedScale)"
            }
        },
        {
            isHovered: !0,
            variant: "light",
            css: {
                bg: "transparent"
            }
        },
        {
            isFocused: !0,
            variant: "light",
            css: {
                bg: "transparent"
            }
        },
        {
            isHovered: !0,
            variant: "solid",
            css: {
                bg: "$$dropdownItemSolidHoverBackground",
                color: "$$dropdownItemSolidHoverTextColor",
                [`& ${$a0430fb1fea1fc30$export$b45d1389a54548f6}`]: {
                    color: "$$dropdownItemSolidHoverTextColor"
                }
            }
        },
        {
            isFocused: !0,
            variant: "solid",
            css: {
                bg: "$$dropdownItemSolidHoverBackground",
                color: "$$dropdownItemSolidHoverTextColor",
                [`& ${$a0430fb1fea1fc30$export$b45d1389a54548f6}`]: {
                    color: "$$dropdownItemSolidHoverTextColor"
                }
            }
        },
        {
            isHovered: !0,
            variant: "shadow",
            css: {
                bg: "$$dropdownItemSolidHoverBackground",
                color: "$$dropdownItemSolidHoverTextColor",
                boxShadow: "0 3px 10px 0 $$dropdownItemShadow",
                [`& ${$a0430fb1fea1fc30$export$b45d1389a54548f6}`]: {
                    color: "$$dropdownItemSolidHoverTextColor"
                }
            }
        },
        {
            isFocused: !0,
            variant: "shadow",
            css: {
                bg: "$$dropdownItemSolidHoverBackground",
                color: "$$dropdownItemSolidHoverTextColor",
                boxShadow: "0 3px 10px 0 $$dropdownItemShadow",
                [`& ${$a0430fb1fea1fc30$export$b45d1389a54548f6}`]: {
                    color: "$$dropdownItemSolidHoverTextColor"
                }
            }
        },
        {
            variant: "flat",
            color: "default",
            css: {
                $$dropdownItemHoverTextColor: "$colors$foreground"
            }
        }
    ],
    defaultVariants: {
        color: "default",
        textColor: "default",
        dividerWeight: "light",
        variant: "flat"
    }
}, (0, $eaf275b21629a4ec$export$ab780f34ea253ed3));
const $a0430fb1fea1fc30$export$7d2594890ea8eb2a = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("li", {
    mb: 0
});
const $a0430fb1fea1fc30$export$77bfcd0ba4e2c41d = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("ul", {
    m: 0,
    p: 0,
    listStyle: "none"
});
const $a0430fb1fea1fc30$export$fff2352b6b9477be = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {
    fontWeight: "$medium",
    fontSize: "$xs",
    padding: "0 $4",
    color: "$accents8"
});





const $5820bc24525c1ed9$var$N = ({ as: e, css: b, item: N, state: y, color: D, icon: P, command: S, description: g, textColor: C, variant: k, autoFocus: F, isVirtualized: j, withDivider: A, dividerWeight: I, onAction: M, className: V })=>{
    const { onClose: W, closeOnSelect: O, disableAnimation: z, borderWeight: H } = (0, $0a9da20457530022$export$28c3a9869c2838c2)(), { rendered: K, key: U } = N, $ = y.selectionManager.isSelected(U), q = y.selectionManager.focusedKey === N.key, B = y.disabledKeys.has(U), E = (0, $acw62.useRef)(null), { pressProps: G, isPressed: J } = (0, $895d146aa86f8a19$export$45712eceda6fad21)({
        ref: E,
        isDisabled: B
    }), { isFocusVisible: L, focusProps: Q } = (0, $066ee5e43859dd8f$export$4e328f61c538687f)({
        autoFocus: F
    }), { hoverProps: R, isHovered: T } = (0, $895d146aa86f8a19$export$ae780daf29e6d456)({
        isDisabled: B
    }), X = "none" !== y.selectionManager.selectionMode && !B, { menuItemProps: Y, labelProps: Z, descriptionProps: _, keyboardShortcutProps: ee } = (0, $63d14d584fe826ec$export$9d32628fc2aea7da)({
        key: U,
        onClose: W,
        isSelected: $,
        isDisabled: B,
        "aria-label": N["aria-label"],
        closeOnSelect: O,
        isVirtualized: j,
        onAction: M
    }, y, E), oe = (0, $acw62.useMemo)(()=>T ? "hovered" : $ ? "selected" : J ? "pressed" : B ? "disabled" : "ready", [
        $,
        B,
        T,
        J
    ]), se = (0, $acw62.useMemo)(()=>N.props.textColor ? N.props.textColor : N.props.color && "default" === C ? N.props.color : C, [
        C,
        N.props.color,
        N.props.textColor
    ]), ie = (0, $acw62.useMemo)(()=>g || N.props.description, [
        g,
        N.props.description
    ]), re = (0, $acw62.useMemo)(()=>S || N.props.command, [
        S,
        N.props.command
    ]), te = (0, $acw62.useMemo)(()=>P || N.props.icon, [
        P,
        N.props.icon
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $a0430fb1fea1fc30$export$297f2fe7e344c781), {
        ref: E,
        ...(0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(Y, R, G, Q),
        as: N.props.as || e,
        css: {
            ...(0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(b, N.props.css)
        },
        "data-state": oe,
        color: N.props.color || D,
        variant: N.props.variant || k,
        textColor: se,
        isFocused: q,
        isFocusVisible: L,
        shouldShowOutline: L && "shadow" === k,
        isHovered: T,
        isSelected: $,
        isDisabled: B,
        isPressed: J,
        isSelectable: X,
        withDivider: A || N.props.withDivider,
        withDescription: !!ie,
        dividerWeight: I || N.props.dividerWeight || H,
        disableAnimation: z,
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-dropdown-item", {
            "is-disabled": B,
            "is-selected": $,
            "is-selectable": X,
            "is-hovered": T,
            "is-focused": q,
            "is-pressed": J
        }, V, N.props.className),
        children: [
            te && (0, $7b02d682eb115277$exports.jsx)((0, $a0430fb1fea1fc30$export$bffec919c1b0804f), {
                className: "nextui-dropdown-item-icon-wrapper",
                children: te
            }),
            ie ? (0, $7b02d682eb115277$exports.jsxs)((0, $a0430fb1fea1fc30$export$a0d1b96c5ba9b86b), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $a0430fb1fea1fc30$export$87d1d981382aadb3), {
                        className: "nextui-dropdown-item-content",
                        ...Z,
                        children: K
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $a0430fb1fea1fc30$export$1a3d580156ab0b53), {
                        className: "nextui-dropdown-item-description",
                        hasIcon: !!te,
                        hasCommand: !!re,
                        ..._,
                        children: ie
                    })
                ]
            }) : (0, $7b02d682eb115277$exports.jsx)((0, $a0430fb1fea1fc30$export$87d1d981382aadb3), {
                className: "nextui-dropdown-item-content",
                ...Z,
                children: K
            }),
            re && (0, $7b02d682eb115277$exports.jsx)((0, $a0430fb1fea1fc30$export$b45d1389a54548f6), {
                className: "nextui-dropdown-item-command",
                ...ee,
                children: re
            }),
            $ && (0, $7b02d682eb115277$exports.jsx)((0, $8c9cfa2d335032e8$export$2e2bcd8739ae039), {
                css: {
                    ml: "$4"
                }
            })
        ]
    });
};
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($5820bc24525c1ed9$var$N.displayName = "NextUI.DropdownItem"), $5820bc24525c1ed9$var$N.toString = ()=>".nextui-dropdown-item";
var $5820bc24525c1ed9$export$2e2bcd8739ae039 = $5820bc24525c1ed9$var$N;







const $e1c71bcf6e651c28$var$u = (r)=>{
    var p, u;
    const { item: x, state: w, css: f, as: h, color: v, textColor: N, variant: y, withDivider: g = !0, className: j, onAction: P } = r, { itemProps: b, headingProps: k, groupProps: A } = (0, $63d14d584fe826ec$export$73f7a44322579622)({
        heading: x.rendered,
        "aria-label": x["aria-label"]
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            x.key !== w.collection.getFirstKey() && g && (0, $7b02d682eb115277$exports.jsx)((0, $9d60ef386467ded1$export$2e2bcd8739ae039), {
                as: "li",
                className: "nextui-dropdown-section-divider",
                css: {
                    my: "$2"
                }
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $a0430fb1fea1fc30$export$7d2594890ea8eb2a), {
                ...b,
                className: "nextui-dropdown-section-wrapper",
                children: [
                    x.rendered && (0, $7b02d682eb115277$exports.jsx)((0, $a0430fb1fea1fc30$export$fff2352b6b9477be), {
                        ...k,
                        className: "nextui-dropdown-section-title",
                        children: x.rendered
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $a0430fb1fea1fc30$export$77bfcd0ba4e2c41d), {
                        ...A,
                        as: (null == (p = x.props) ? void 0 : p.as) || h,
                        css: {
                            ...(0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(f, null == (u = x.props) ? void 0 : u.css)
                        },
                        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-dropdown-section", j),
                        children: [
                            ...x.childNodes
                        ].map((r)=>{
                            let e = (0, $7b02d682eb115277$exports.jsx)((0, $5820bc24525c1ed9$export$2e2bcd8739ae039), {
                                item: r,
                                state: w,
                                onAction: P,
                                color: v,
                                textColor: N,
                                variant: y
                            }, r.key);
                            return r.wrapper && (e = r.wrapper(e)), e;
                        })
                    })
                ]
            })
        ]
    });
};
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($e1c71bcf6e651c28$var$u.displayName = "NextUI.DropdownSection"), $e1c71bcf6e651c28$var$u.toString = ()=>".nextui-dropdown-section";
var $e1c71bcf6e651c28$export$2e2bcd8739ae039 = $e1c71bcf6e651c28$var$u;







const $2ac05f2ed46d6b69$var$f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((o, l)=>{
    const { css: f = {}, as: u, color: x = "default", textColor: w = "default", variant: y = "flat", ...A } = o, N = (0, $0a9da20457530022$export$28c3a9869c2838c2)(), v = {
        ...(0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(N, A)
    }, C = (0, $97d849037ea9c63e$export$c2c55ef9111cafd8)(l), j = (0, $a5088832486da6f1$export$728d6ba534403756)(v), { menuProps: k } = (0, $63d14d584fe826ec$export$38eaa17faae8f579)(v, j, C);
    return (0, $97d849037ea9c63e$export$4debdb1a3f0fa79e)(N, C), (0, $7b02d682eb115277$exports.jsx)((0, $a0430fb1fea1fc30$export$5c8a2f763c06db40), {
        ref: C,
        as: u,
        css: {
            ...f
        },
        className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-dropdown-menu", o.className),
        ...k,
        children: [
            ...j.collection
        ].map((o)=>{
            if ("section" === o.type) return (0, $7b02d682eb115277$exports.jsx)((0, $e1c71bcf6e651c28$export$2e2bcd8739ae039), {
                item: o,
                state: j,
                onAction: v.onAction,
                color: x,
                textColor: w,
                variant: y
            }, o.key);
            let t = (0, $7b02d682eb115277$exports.jsx)((0, $5820bc24525c1ed9$export$2e2bcd8739ae039), {
                item: o,
                state: j,
                onAction: v.onAction,
                color: x,
                textColor: w,
                variant: y
            }, o.key);
            return o.wrapper && (t = o.wrapper(t)), t;
        })
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($2ac05f2ed46d6b69$var$f.displayName = "NextUI.DropdownMenu"), $2ac05f2ed46d6b69$var$f.toString = ()=>".nextui-dropdown-menu";
var $2ac05f2ed46d6b69$export$2e2bcd8739ae039 = $2ac05f2ed46d6b69$var$f;



var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");


const $a18786cd739a930c$var$r = ({ fill: t, size: i, height: r, width: e, ...n })=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        width: i || e || 24,
        height: i || r || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...n,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.9188 8.17969H11.6888H6.07877C5.11877 8.17969 4.63877 9.33969 5.31877 10.0197L10.4988 15.1997C11.3288 16.0297 12.6788 16.0297 13.5088 15.1997L15.4788 13.2297L18.6888 10.0197C19.3588 9.33969 18.8788 8.17969 17.9188 8.17969Z",
            fill: t
        })
    });
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($a18786cd739a930c$var$r.displayName = "NextUI.DropdownIcon"), $a18786cd739a930c$var$r.toString = ()=>".nextui-dropdown-icon";
var $a18786cd739a930c$export$2e2bcd8739ae039 = $a18786cd739a930c$var$r;






const $0a84baaf7b29c635$var$c = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((o, d)=>{
    const { children: c, className: p, iconRight: l, iconRightCss: f, auto: u = !0, animated: x, ...g } = o, { disableAnimation: h } = (0, $0a9da20457530022$export$28c3a9869c2838c2)(), w = (0, $97d849037ea9c63e$export$c2c55ef9111cafd8)(d), R = (0, $acw62.useMemo)(()=>l || (0, $7b02d682eb115277$exports.jsx)((0, $a18786cd739a930c$export$2e2bcd8739ae039), {
            size: 14,
            fill: "currentColor"
        }), [
        l
    ]), N = (0, $acw62.useMemo)(()=>x || !h, [
        x,
        h
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $8ec1994aff100c6d$export$2e2bcd8739ae039), {
        children: (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
            ref: w,
            auto: u,
            className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)("nextui-dropdown-button", p),
            iconRight: R,
            animated: N,
            iconRightCss: {
                mt: "$1",
                ...f
            },
            ...g,
            children: c
        })
    });
});
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($0a84baaf7b29c635$var$c.displayName = "NextUI.DropdownButton"), $0a84baaf7b29c635$var$c.toString = ()=>".nextui-dropdown-button";
var $0a84baaf7b29c635$export$2e2bcd8739ae039 = $0a84baaf7b29c635$var$c;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $1e9a1d2f0def6cb0$export$40bfa8c7b0832715(value1, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $acw62.useState)(value1 || defaultValue);
    let ref = (0, $acw62.useRef)(value1 !== undefined);
    let wasControlled = ref.current;
    let isControlled = value1 !== undefined;
    // Internal state reference for useCallback
    let stateRef = (0, $acw62.useRef)(stateValue);
    if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
    ref.current = isControlled;
    let setValue = (0, $acw62.useCallback)((value2, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(stateRef.current, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) stateRef.current = value;
        };
        if (typeof value2 === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value2(isControlled ? stateRef.current : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value2);
            onChangeCaller(value2, ...args);
        }
    }, [
        isControlled,
        onChange
    ]);
    // If a controlled component's value prop changes, we need to update stateRef
    if (isControlled) stateRef.current = value1;
    else value1 = stateValue;
    return [
        value1,
        setValue
    ];
}
function $1e9a1d2f0def6cb0$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $1e9a1d2f0def6cb0$export$cb6e0bb50bc19463(value, min, max, step) {
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $1e9a1d2f0def6cb0$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}


function $a6f030961405fd52$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $1e9a1d2f0def6cb0$export$40bfa8c7b0832715)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open () {
            setOpen(true);
        },
        close () {
            setOpen(false);
        },
        toggle () {
            setOpen(!isOpen);
        }
    };
}



var $acw62 = parcelRequire("acw62");
function $78c3152446a2701f$export$79fefeb1c2091ac3(props) {
    let overlayTriggerState = (0, $a6f030961405fd52$export$61c6a8c84e605fb6)(props);
    let [focusStrategy1, setFocusStrategy] = (0, $acw62.useState)(null);
    return {
        focusStrategy: focusStrategy1,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        }
    };
}



function $873b9b8ddeea79f7$export$8c32fdb3462273b4(s = {}) {
    const { triggerRef: l, type: u = "menu", trigger: m = "press", isDisabled: a = !1, borderWeight: p, closeOnSelect: g, disableAnimation: c = !1, ...f } = s, d = (0, $acw62.useRef)(null), b = l || d, P = (0, $acw62.useRef)(null), y = (0, $acw62.useRef)(null), R = (0, $78c3152446a2701f$export$79fefeb1c2091ac3)(s), { menuTriggerProps: D, menuProps: S } = (0, $63d14d584fe826ec$export$dc9c12ed27dd1b49)({
        type: u,
        trigger: m,
        isDisabled: a
    }, R, b), T = (0, $acw62.useCallback)((e = {}, r = null)=>({
            ...null != l && l.current ? (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(D, e) : (0, $4d60a29ecf011a9e$export$9d1611c77c2fe928)(e, D),
            ref: (0, $c5e08d37e4dd87be$export$c9058316764c140e)(d, r)
        }), [
        d,
        l,
        D
    ]);
    return {
        ...S,
        popoverProps: f,
        state: R,
        ref: P,
        onClose: R.close,
        autoFocus: R.focusStrategy || !0,
        disableAnimation: c,
        menuRef: P,
        borderWeight: p,
        menuPopoverRef: y,
        menuTriggerRef: b,
        closeOnSelect: g,
        getMenuTriggerProps: T
    };
}




const $96157e9f1610a292$var$m = (i)=>{
    const { children: m, ...p } = i, d = (0, $873b9b8ddeea79f7$export$8c32fdb3462273b4)(p), [a, l] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(m);
    return (0, $7b02d682eb115277$exports.jsx)((0, $0a9da20457530022$export$8177a931fccf3109), {
        value: d,
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $8f68f1f95daa83c1$export$2e2bcd8739ae039), {
            ref: d.menuPopoverRef,
            ...d.popoverProps,
            triggerRef: d.menuTriggerRef,
            scrollRef: d.menuRef,
            isOpen: d.state.isOpen,
            onClose: d.state.close,
            borderWeight: d.borderWeight,
            disableAnimation: d.disableAnimation,
            children: [
                a,
                (0, $7b02d682eb115277$exports.jsx)((0, $8f68f1f95daa83c1$export$2e2bcd8739ae039).Content, {
                    children: l
                })
            ]
        })
    });
};
(0, $9013ad1f954747ab$export$a866f231438cc228) && ($96157e9f1610a292$var$m.displayName = "NextUI.Dropdown"), $96157e9f1610a292$var$m.toString = ()=>".nextui-dropdown";
var $96157e9f1610a292$export$2e2bcd8739ae039 = $96157e9f1610a292$var$m;



(0, $96157e9f1610a292$export$2e2bcd8739ae039).Trigger = (0, $8ec1994aff100c6d$export$2e2bcd8739ae039), (0, $96157e9f1610a292$export$2e2bcd8739ae039).Button = (0, $0a84baaf7b29c635$export$2e2bcd8739ae039), (0, $96157e9f1610a292$export$2e2bcd8739ae039).Menu = (0, $2ac05f2ed46d6b69$export$2e2bcd8739ae039), (0, $96157e9f1610a292$export$2e2bcd8739ae039).Section = (0, $adbad999e88477eb$export$6e2c8f0811a474ce), (0, $96157e9f1610a292$export$2e2bcd8739ae039).Item = (0, $98b61cdc3f5d815a$export$2e2bcd8739ae039);
var $ae1adc4fb7ae7f25$export$2e2bcd8739ae039 = (0, $96157e9f1610a292$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");



const $91ab0372e2970d4e$export$7d9de5b59a5583f2 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {
    size: "1px",
    variants: {
        inline: {
            true: {
                display: "inline-block"
            },
            false: {
                display: "block"
            }
        }
    },
    defaultVariants: {
        inline: !1
    }
});



const $3756176995fd9c31$var$m = ({ x: t, y: r, inline: m, css: e, ...n })=>{
    const a = (0, $5dc879e0b33094f3$export$1bc603050bd777b1)(t), p = (0, $5dc879e0b33094f3$export$1bc603050bd777b1)(r);
    return (0, $7b02d682eb115277$exports.jsx)((0, $91ab0372e2970d4e$export$7d9de5b59a5583f2), {
        css: {
            marginLeft: `${a} !important`,
            marginTop: `${p} !important`,
            ...e
        },
        "aria-hidden": "true",
        ...n
    });
};
$3756176995fd9c31$var$m.toString = ()=>".nextui-spacer";
const $3756176995fd9c31$var$e = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($3756176995fd9c31$var$m);
var $3756176995fd9c31$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($3756176995fd9c31$var$e, {
    x: 1,
    y: 1
});



var $7bebbdb3c09143e6$export$2e2bcd8739ae039 = (0, $3756176995fd9c31$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");





const $be84b330791ee60b$export$51b3cbad79d6035d = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("label", {
    WebkitTapHighlightColor: "transparent",
    d: "inline-block",
    verticalAlign: "center",
    whiteSpace: "nowrap",
    us: "none",
    transition: "$default",
    padding: "$1 0",
    position: "relative",
    cursor: "pointer",
    "@motion": {
        transition: "none"
    },
    variants: {
        color: {
            default: {
                $$switchColor: "$colors$primary",
                $$switchColorShadow: "$colors$primaryShadow",
                $$switchColorHover: "$colors$primarySolidHover"
            },
            primary: {
                $$switchColor: "$colors$primary",
                $$switchColorShadow: "$colors$primaryShadow",
                $$switchColorHover: "$colors$primarySolidHover"
            },
            secondary: {
                $$switchColor: "$colors$secondary",
                $$switchColorShadow: "$colors$secondaryShadow",
                $$switchColorHover: "$colors$secondarySolidHover"
            },
            success: {
                $$switchColor: "$colors$success",
                $$switchColorShadow: "$colors$successShadow",
                $$switchColorHover: "$colors$successSolidHover"
            },
            warning: {
                $$switchColor: "$colors$warning",
                $$switchColorShadow: "$colors$warningShadow",
                $$switchColorHover: "$colors$warningSolidHover"
            },
            error: {
                $$switchColor: "$colors$error",
                $$switchColorShadow: "$colors$errorShadow",
                $$switchColorHover: "$colors$errorSolidHover"
            }
        },
        size: {
            xs: {
                $$switchWidth: "$space$12",
                $$switchHeight: "$space$9",
                width: " $$switchWidth",
                maxWidth: "$$switchWidth",
                height: "$$switchHeight"
            },
            sm: {
                $$switchWidth: "$space$14",
                $$switchHeight: "$space$10",
                width: "$$switchWidth",
                maxWidth: "$$switchWidth",
                height: "$$switchHeight"
            },
            md: {
                $$switchWidth: "$space$15",
                $$switchHeight: "$space$11",
                width: "$$switchWidth",
                maxWidth: "$$switchWidth",
                height: "$$switchHeight"
            },
            lg: {
                $$switchWidth: "$space$17",
                $$switchHeight: "$space$12",
                width: "$$switchWidth",
                maxWidth: "$$switchWidth",
                height: "$$switchHeight"
            },
            xl: {
                $$switchWidth: "$space$18",
                $$switchHeight: "$space$13",
                width: "$$switchWidth",
                maxWidth: "$$switchWidth",
                height: "$$switchHeight"
            }
        },
        borderWeight: {
            light: {
                $$switchBorderW: "$borderWeights$light"
            },
            normal: {
                $$switchBorderW: "$borderWeights$normal"
            },
            bold: {
                $$switchBorderW: "$borderWeights$bold"
            },
            extrabold: {
                $$switchBorderW: "$borderWeights$extrabold"
            },
            black: {
                $$switchBorderW: "$borderWeights$black"
            }
        },
        disabled: {
            true: {
                cursor: "not-allowed"
            }
        },
        animated: {
            false: {
                transition: "none"
            }
        }
    },
    defaultVariants: {
        color: "default",
        size: "md",
        borderWeight: "normal"
    }
});
const $be84b330791ee60b$export$6cfcd6c5a2289b2a = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("input", {}, (0, $eaf275b21629a4ec$export$74eab49e97f7dd3b));
const $be84b330791ee60b$export$af97499c2f031e88 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("span", {
    position: "absolute",
    display: "flex",
    size: "calc($$switchHeight * 0.7)",
    jc: "center",
    ai: "center",
    top: "50%",
    transform: "translateY(-50%)",
    left: "calc($$switchWidth / 15)",
    transition: "left 0.25s ease, width 0.2s ease",
    bg: "$background",
    br: "$pill",
    "& svg": {
        bg: "transparent",
        size: "calc($$switchHeight * 0.44)"
    },
    "@motion": {
        transition: "none"
    }
});
const $be84b330791ee60b$export$72a2d32c474a0267 = (0, $07d095cbefc9a288$export$3817b7a54a07cec7)("div", {
    opacity: 1,
    width: "$$switchWidth",
    height: "$$switchHeight",
    transition: "$default",
    position: "relative",
    overflow: "hidden",
    padding: 0,
    br: "$pill",
    bg: "$accents2",
    "@motion": {
        transition: "none"
    },
    variants: {
        checked: {
            true: {
                bg: "$$switchColor",
                [`& ${$be84b330791ee60b$export$af97499c2f031e88}`]: {
                    left: "calc(100% - ($$switchWidth / 15) - $$switchHeight * 0.7)"
                },
                "&:hover:not(&:active)": {
                    bg: "$$switchColorHover"
                }
            }
        },
        bordered: {
            true: {
                bg: "transparent",
                border: "$$switchBorderW solid $border",
                "&:hover": {
                    borderColor: "$$switchColor"
                },
                [`& ${$be84b330791ee60b$export$af97499c2f031e88}`]: {
                    left: "calc(($$switchWidth / 15) - ($$switchBorderW / 2))",
                    bg: "$accents2"
                }
            }
        },
        squared: {
            true: {
                br: "2px",
                [`& ${$be84b330791ee60b$export$af97499c2f031e88}`]: {
                    br: "2px"
                }
            }
        },
        shadow: {
            true: {}
        },
        disabled: {
            true: {
                borderColor: "$accents2",
                bg: "$accents2",
                [`& ${$be84b330791ee60b$export$af97499c2f031e88}`]: {
                    bg: "$accents4"
                }
            }
        },
        animated: {
            true: {
                "&:active": {
                    [`& ${$be84b330791ee60b$export$af97499c2f031e88}`]: {
                        width: "calc($$switchHeight * 0.7 + ($$switchWidth / 10))"
                    }
                }
            },
            false: {
                transition: "none",
                [`& ${$be84b330791ee60b$export$af97499c2f031e88}`]: {
                    transition: "none"
                }
            }
        }
    },
    compoundVariants: [
        {
            checked: !0,
            disabled: !0,
            css: {
                bg: "$accents3",
                [`& ${$be84b330791ee60b$export$af97499c2f031e88}`]: {
                    bg: "$accents0"
                },
                "&:hover:not(&:active)": {
                    bg: "$accents4"
                }
            }
        },
        {
            shadow: !0,
            checked: !0,
            css: {
                normalShadowVar: "$$switchColorShadow"
            }
        },
        {
            animated: !0,
            checked: !1,
            css: {
                "&:active": {
                    [`& ${$be84b330791ee60b$export$af97499c2f031e88}`]: {
                        left: "calc($$switchWidth / 7.5)"
                    }
                }
            }
        },
        {
            animated: !0,
            checked: !0,
            css: {
                "&:active": {
                    [`& ${$be84b330791ee60b$export$af97499c2f031e88}`]: {
                        left: "calc(100% - ($$switchWidth / 5) - $$switchHeight * 0.7)"
                    }
                }
            }
        },
        {
            checked: !0,
            bordered: !0,
            css: {
                bg: "$$switchColor",
                border: "$$switchBorderW solid transparent",
                "&:hover:not(&:active)": {
                    borderColor: "transparent"
                },
                [`& ${$be84b330791ee60b$export$af97499c2f031e88}`]: {
                    left: "calc(100% - ($$switchWidth / 15) - $$switchHeight * 0.7 + ($$switchBorderW / 2))",
                    bg: "$background"
                }
            }
        }
    ]
}, (0, $eaf275b21629a4ec$export$fcece08f39236f43));





const $57725ec9a13d7d96$var$k = "nextui-switch", $57725ec9a13d7d96$var$x = ({ initialChecked: e, checked: r, disabled: x, onChange: v, squared: w, bordered: g, shadow: $, icon: D, iconOn: j, iconOff: C, animated: O, preventDefault: q, ...y })=>{
    const [E, N] = (0, $acw62.useState)(e);
    D && (0, $9013ad1f954747ab$export$a866f231438cc228) && (j || C) && (0, $364cddea3adf1f69$export$2e2bcd8739ae039)('Remove props "icon" if iconOn or iconOff exists.', "Switch");
    const S = (0, $acw62.useCallback)((e)=>{
        if (x) return;
        const t = {
            target: {
                checked: !E
            },
            stopPropagation: e.stopPropagation,
            preventDefault: e.preventDefault,
            nativeEvent: e
        };
        N(!E), v && v(t);
    }, [
        x,
        E,
        v
    ]), { bindings: B } = (0, $16fc602777d9433e$export$2e2bcd8739ae039)((e)=>{
        S(e);
    }, [
        (0, $228cb05fefde7bd1$export$e9e0d96f49f57c33).Enter,
        (0, $228cb05fefde7bd1$export$e9e0d96f49f57c33).Space
    ], {
        disableGlobalEvent: !0,
        preventDefault: q
    }), I = (0, $acw62.useMemo)(()=>{
        const e = D || j || C, t = Boolean(j), a = Boolean(C);
        return e ? t && E ? j : a && !E ? C : e : null;
    }, [
        E,
        D,
        j,
        C
    ]);
    (0, $acw62.useEffect)(()=>{
        void 0 !== r && N(r);
    }, [
        r
    ]);
    const P = (0, $acw62.useMemo)(()=>E ? "checked" : "unchecked", [
        E
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $be84b330791ee60b$export$51b3cbad79d6035d), {
        "data-state": P,
        disabled: x,
        animated: O,
        ...y,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $be84b330791ee60b$export$6cfcd6c5a2289b2a), {
                tabIndex: -1,
                type: "checkbox",
                className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)(`${$57725ec9a13d7d96$var$k}-input`),
                "data-state": P,
                disabled: x,
                checked: E,
                onChange: S
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $be84b330791ee60b$export$72a2d32c474a0267), {
                role: "switch",
                tabIndex: x ? -1 : 0,
                checked: E,
                "aria-checked": E,
                "aria-disabled": x,
                animated: O,
                disabled: x,
                squared: w,
                bordered: g,
                shadow: $,
                "data-state": P,
                className: (0, $62c7a094ec6fa639$export$2e2bcd8739ae039)($57725ec9a13d7d96$var$k, `${$57725ec9a13d7d96$var$k}--${P}`, {
                    [`${$57725ec9a13d7d96$var$k}-checked`]: E,
                    [`${$57725ec9a13d7d96$var$k}-disabled`]: x
                }),
                ...B,
                children: (0, $7b02d682eb115277$exports.jsx)((0, $be84b330791ee60b$export$af97499c2f031e88), {
                    className: `${$57725ec9a13d7d96$var$k}-circle`,
                    children: I
                })
            })
        ]
    });
};
$57725ec9a13d7d96$var$x.toString = ()=>".nextui-switch";
const $57725ec9a13d7d96$var$v = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($57725ec9a13d7d96$var$x);
var $57725ec9a13d7d96$export$2e2bcd8739ae039 = (0, $ae4bbcebb3f13d26$export$2e2bcd8739ae039)($57725ec9a13d7d96$var$v, {
    disabled: !1,
    bordered: !1,
    shadow: !1,
    squared: !1,
    animated: !0,
    preventDefault: !0,
    initialChecked: !1
});



var $a757147768b90cdf$export$2e2bcd8739ae039 = (0, $57725ec9a13d7d96$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $3ee4be5251daba61$export$2e2bcd8739ae039() {
    const [state, setState] = (0, $acw62.useState)({
        patterns: [],
        types: [],
        loading: true
    });
    async function fetchPatterns() {
        try {
            const { data: data } = await (0, $3189fb41583a85b4$export$b5fe3f66a567bec0)("/shop/items");
            // console.log(data)
            setState((oldState)=>({
                    ...oldState,
                    patterns: data.items_patterns,
                    types: data.item_types,
                    loading: false
                }));
        } catch (err) {
            console.log(err);
            setState((oldState)=>({
                    ...oldState,
                    loading: false
                }));
        }
    }
    (0, $acw62.useEffect)(()=>{
        fetchPatterns();
    }, []);
    return {
        ...state
    };
}






var $acw62 = parcelRequire("acw62");

var $dac22b55eb23ffcc$export$db0345794bfc14ed = new Map([
    [
        "avi",
        "video/avi"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "ico",
        "image/x-icon"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ]
]);
function $dac22b55eb23ffcc$export$8cc09085015f0dc7(file, path) {
    var f = $dac22b55eb23ffcc$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $dac22b55eb23ffcc$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $dac22b55eb23ffcc$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $7ac450b547cb7da9$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $7ac450b547cb7da9$export$a36e16046ae8f1bb(evt) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$isDragEvt(evt) && evt.dataTransfer ? $7ac450b547cb7da9$var$getDataTransferFiles(evt.dataTransfer, evt.type) : $7ac450b547cb7da9$var$getInputFiles(evt)
            ];
        });
    });
}
function $7ac450b547cb7da9$var$isDragEvt(value) {
    return !!value.dataTransfer;
}
function $7ac450b547cb7da9$var$getInputFiles(evt) {
    var files = $7ac450b547cb7da9$var$isInput(evt.target) ? evt.target.files ? $7ac450b547cb7da9$var$fromList(evt.target.files) : [] : [];
    return files.map(function(file) {
        return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    });
}
function $7ac450b547cb7da9$var$isInput(value) {
    return value !== null;
}
function $7ac450b547cb7da9$var$getDataTransferFiles(dt, type) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $7ac450b547cb7da9$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($7ac450b547cb7da9$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$fromList(dt.files).map(function(file) {
                            return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $7ac450b547cb7da9$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $7ac450b547cb7da9$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $7ac450b547cb7da9$var$fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $7ac450b547cb7da9$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $7ac450b547cb7da9$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $7ac450b547cb7da9$var$fromDirEntry(entry);
    return $7ac450b547cb7da9$var$fromDataTransferItem(item);
}
function $7ac450b547cb7da9$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $5c96a02c592fcff1$export$afc72e2116322959)(acc, Array.isArray(files) ? $7ac450b547cb7da9$var$flatten(files) : [
            files
        ]);
    }, []);
}
function $7ac450b547cb7da9$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject(item + " is not a File");
    var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $7ac450b547cb7da9$var$fromEntry(entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $7ac450b547cb7da9$var$fromDirEntry(entry) : $7ac450b547cb7da9$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $7ac450b547cb7da9$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($7ac450b547cb7da9$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $7ac450b547cb7da9$var$fromFileEntry(entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




function $e19e94e73b73906a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $e19e94e73b73906a$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $e19e94e73b73906a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $e19e94e73b73906a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $e19e94e73b73906a$var$_extends() {
    $e19e94e73b73906a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e19e94e73b73906a$var$_extends.apply(this, arguments);
}
function $e19e94e73b73906a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e19e94e73b73906a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e19e94e73b73906a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e19e94e73b73906a$var$_arrayLikeToArray(o, minLen);
}
function $e19e94e73b73906a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e19e94e73b73906a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $e19e94e73b73906a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}
function $e19e94e73b73906a$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $e19e94e73b73906a$var$runtime_1 = $e19e94e73b73906a$var$createCommonjsModule(function(module) {
    /**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var runtime = function(exports) {
        var Op = Object.prototype;
        var hasOwn = Op.hasOwnProperty;
        var undefined$1; // More compressible than void 0.
        var $Symbol = typeof Symbol === "function" ? Symbol : {};
        var iteratorSymbol = $Symbol.iterator || "@@iterator";
        var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
        var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
        function define(obj, key, value) {
            Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
            return obj[key];
        }
        try {
            // IE 8 has a broken Object.defineProperty that only works on DOM objects.
            define({}, "");
        } catch (err) {
            define = function(obj, key, value) {
                return obj[key] = value;
            };
        }
        function wrap(innerFn, outerFn, self, tryLocsList) {
            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            var generator = Object.create(protoGenerator.prototype);
            var context = new Context(tryLocsList || []);
            // The ._invoke method unifies the implementations of the .next,
            // .throw, and .return methods.
            generator._invoke = makeInvokeMethod(innerFn, self, context);
            return generator;
        }
        exports.wrap = wrap;
        // Try/catch helper to minimize deoptimizations. Returns a completion
        // record like context.tryEntries[i].completion. This interface could
        // have been (and was previously) designed to take a closure to be
        // invoked without arguments, but in all the cases we care about we
        // already have an existing method we want to call, so there's no need
        // to create a new function object. We can even get away with assuming
        // the method takes exactly one argument, since that happens to be true
        // in every case, so we don't have to touch the arguments object. The
        // only additional allocation required is the completion record, which
        // has a stable shape and so hopefully should be cheap to allocate.
        function tryCatch(fn, obj, arg) {
            try {
                return {
                    type: "normal",
                    arg: fn.call(obj, arg)
                };
            } catch (err) {
                return {
                    type: "throw",
                    arg: err
                };
            }
        }
        var GenStateSuspendedStart = "suspendedStart";
        var GenStateSuspendedYield = "suspendedYield";
        var GenStateExecuting = "executing";
        var GenStateCompleted = "completed";
        // Returning this object from the innerFn has the same effect as
        // breaking out of the dispatch switch statement.
        var ContinueSentinel = {};
        // Dummy constructor functions that we use as the .constructor and
        // .constructor.prototype properties for functions that return Generator
        // objects. For full spec compliance, you may wish to configure your
        // minifier not to mangle the names of these two functions.
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}
        // This is a polyfill for %IteratorPrototype% for environments that
        // don't natively support it.
        var IteratorPrototype = {};
        IteratorPrototype[iteratorSymbol] = function() {
            return this;
        };
        var getProto = Object.getPrototypeOf;
        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
        if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
        // of the polyfill.
        IteratorPrototype = NativeIteratorPrototype;
        var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
        GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
        GeneratorFunctionPrototype.constructor = GeneratorFunction;
        GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
        // Helper for defining the .next, .throw, and .return methods of the
        // Iterator interface in terms of a single ._invoke method.
        function defineIteratorMethods(prototype) {
            [
                "next",
                "throw",
                "return"
            ].forEach(function(method) {
                define(prototype, method, function(arg) {
                    return this._invoke(method, arg);
                });
            });
        }
        exports.isGeneratorFunction = function(genFun) {
            var ctor = typeof genFun === "function" && genFun.constructor;
            return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
        };
        exports.mark = function(genFun) {
            if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            else {
                genFun.__proto__ = GeneratorFunctionPrototype;
                define(genFun, toStringTagSymbol, "GeneratorFunction");
            }
            genFun.prototype = Object.create(Gp);
            return genFun;
        };
        // Within the body of any async function, `await x` is transformed to
        // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
        // `hasOwn.call(value, "__await")` to determine if the yielded value is
        // meant to be awaited.
        exports.awrap = function(arg) {
            return {
                __await: arg
            };
        };
        function AsyncIterator(generator, PromiseImpl) {
            function invoke(method, arg, resolve, reject) {
                var record = tryCatch(generator[method], generator, arg);
                if (record.type === "throw") reject(record.arg);
                else {
                    var result = record.arg;
                    var value = result.value;
                    if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                        invoke("next", value, resolve, reject);
                    }, function(err) {
                        invoke("throw", err, resolve, reject);
                    });
                    return PromiseImpl.resolve(value).then(function(unwrapped) {
                        // When a yielded Promise is resolved, its final value becomes
                        // the .value of the Promise<{value,done}> result for the
                        // current iteration.
                        result.value = unwrapped;
                        resolve(result);
                    }, function(error) {
                        // If a rejected Promise was yielded, throw the rejection back
                        // into the async generator function so it can be handled there.
                        return invoke("throw", error, resolve, reject);
                    });
                }
            }
            var previousPromise;
            function enqueue(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = // If enqueue has been called before, then we want to wait until
                // all previous Promises have been resolved before calling invoke,
                // so that results are always delivered in the correct order. If
                // enqueue has not been called before, then it is important to
                // call invoke immediately, without waiting on a callback to fire,
                // so that the async generator function has the opportunity to do
                // any necessary setup in a predictable way. This predictability
                // is why the Promise constructor synchronously invokes its
                // executor callback, and why async functions synchronously
                // execute code before the first await. Since we implement simple
                // async functions in terms of async generators, it is especially
                // important to get this right, even though it requires care.
                previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
                // invocations of the iterator.
                callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
            // Define the unified helper method that is used to implement .next,
            // .throw, and .return (see defineIteratorMethods).
            this._invoke = enqueue;
        }
        defineIteratorMethods(AsyncIterator.prototype);
        AsyncIterator.prototype[asyncIteratorSymbol] = function() {
            return this;
        };
        exports.AsyncIterator = AsyncIterator;
        // Note that simple async functions are implemented on top of
        // AsyncIterator objects; they just return a Promise for the value of
        // the final result produced by the iterator.
        exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
            if (PromiseImpl === void 0) PromiseImpl = Promise;
            var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
            return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
             : iter.next().then(function(result) {
                return result.done ? result.value : iter.next();
            });
        };
        function makeInvokeMethod(innerFn, self, context) {
            var state = GenStateSuspendedStart;
            return function invoke(method, arg) {
                if (state === GenStateExecuting) throw new Error("Generator is already running");
                if (state === GenStateCompleted) {
                    if (method === "throw") throw arg;
                    // Be forgiving, per 25.3.3.3.3 of the spec:
                    // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                    return doneResult();
                }
                context.method = method;
                context.arg = arg;
                while(true){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if (context.method === "next") // Setting context._sent for legacy support of Babel's
                    // function.sent implementation.
                    context.sent = context._sent = context.arg;
                    else if (context.method === "throw") {
                        if (state === GenStateSuspendedStart) {
                            state = GenStateCompleted;
                            throw context.arg;
                        }
                        context.dispatchException(context.arg);
                    } else if (context.method === "return") context.abrupt("return", context.arg);
                    state = GenStateExecuting;
                    var record = tryCatch(innerFn, self, context);
                    if (record.type === "normal") {
                        // If an exception is thrown from innerFn, we leave state ===
                        // GenStateExecuting and loop back for another invocation.
                        state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                        if (record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    } else if (record.type === "throw") {
                        state = GenStateCompleted;
                        // Dispatch the exception by looping back around to the
                        // context.dispatchException(context.arg) call above.
                        context.method = "throw";
                        context.arg = record.arg;
                    }
                }
            };
        }
        // Call delegate.iterator[context.method](context.arg) and handle the
        // result, either by returning a { value, done } result from the
        // delegate iterator, or by modifying context.method and context.arg,
        // setting context.delegate to null, and returning the ContinueSentinel.
        function maybeInvokeDelegate(delegate, context) {
            var method = delegate.iterator[context.method];
            if (method === undefined$1) {
                // A .throw or .return when the delegate iterator has no .throw
                // method always terminates the yield* loop.
                context.delegate = null;
                if (context.method === "throw") {
                    // Note: ["return"] must be used for ES3 parsing compatibility.
                    if (delegate.iterator["return"]) {
                        // If the delegate iterator has a return method, give it a
                        // chance to clean up.
                        context.method = "return";
                        context.arg = undefined$1;
                        maybeInvokeDelegate(delegate, context);
                        if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                        // "return" to "throw", let that override the TypeError below.
                        return ContinueSentinel;
                    }
                    context.method = "throw";
                    context.arg = new TypeError("The iterator does not provide a 'throw' method");
                }
                return ContinueSentinel;
            }
            var record = tryCatch(method, delegate.iterator, context.arg);
            if (record.type === "throw") {
                context.method = "throw";
                context.arg = record.arg;
                context.delegate = null;
                return ContinueSentinel;
            }
            var info = record.arg;
            if (!info) {
                context.method = "throw";
                context.arg = new TypeError("iterator result is not an object");
                context.delegate = null;
                return ContinueSentinel;
            }
            if (info.done) {
                // Assign the result of the finished delegate to the temporary
                // variable specified by delegate.resultName (see delegateYield).
                context[delegate.resultName] = info.value;
                // Resume execution at the desired location (see delegateYield).
                context.next = delegate.nextLoc;
                // If context.method was "throw" but the delegate handled the
                // exception, let the outer generator proceed normally. If
                // context.method was "next", forget context.arg since it has been
                // "consumed" by the delegate iterator. If context.method was
                // "return", allow the original .return call to continue in the
                // outer generator.
                if (context.method !== "return") {
                    context.method = "next";
                    context.arg = undefined$1;
                }
            } else // Re-yield the result returned by the delegate method.
            return info;
            // The delegate iterator is finished, so forget it and continue with
            // the outer generator.
            context.delegate = null;
            return ContinueSentinel;
        }
        // Define Generator.prototype.{next,throw,return} in terms of the
        // unified ._invoke helper method.
        defineIteratorMethods(Gp);
        define(Gp, toStringTagSymbol, "Generator");
        // A Generator should always return itself as the iterator object when the
        // @@iterator function is called on it. Some browsers' implementations of the
        // iterator prototype chain incorrectly implement this, causing the Generator
        // object to not be returned from this call. This ensures that doesn't happen.
        // See https://github.com/facebook/regenerator/issues/274 for more details.
        Gp[iteratorSymbol] = function() {
            return this;
        };
        Gp.toString = function() {
            return "[object Generator]";
        };
        function pushTryEntry(locs) {
            var entry = {
                tryLoc: locs[0]
            };
            if (1 in locs) entry.catchLoc = locs[1];
            if (2 in locs) {
                entry.finallyLoc = locs[2];
                entry.afterLoc = locs[3];
            }
            this.tryEntries.push(entry);
        }
        function resetTryEntry(entry) {
            var record = entry.completion || {};
            record.type = "normal";
            delete record.arg;
            entry.completion = record;
        }
        function Context(tryLocsList) {
            // The root entry object (effectively a try statement without a catch
            // or a finally block) gives us a place to store values thrown from
            // locations where there is no enclosing try statement.
            this.tryEntries = [
                {
                    tryLoc: "root"
                }
            ];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
        }
        exports.keys = function(object) {
            var keys = [];
            for(var key in object)keys.push(key);
            keys.reverse();
            // Rather than returning an object with a next method, we keep
            // things simple and return the next function itself.
            return function next() {
                while(keys.length){
                    var key = keys.pop();
                    if (key in object) {
                        next.value = key;
                        next.done = false;
                        return next;
                    }
                }
                // To avoid creating an additional object, we just hang the .value
                // and .done properties off the next function object itself. This
                // also ensures that the minifier will not anonymize the function.
                next.done = true;
                return next;
            };
        };
        function values(iterable) {
            if (iterable) {
                var iteratorMethod = iterable[iteratorSymbol];
                if (iteratorMethod) return iteratorMethod.call(iterable);
                if (typeof iterable.next === "function") return iterable;
                if (!isNaN(iterable.length)) {
                    var i = -1, next = function next() {
                        while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                            next.value = iterable[i];
                            next.done = false;
                            return next;
                        }
                        next.value = undefined$1;
                        next.done = true;
                        return next;
                    };
                    return next.next = next;
                }
            }
            // Return an iterator with no values.
            return {
                next: doneResult
            };
        }
        exports.values = values;
        function doneResult() {
            return {
                value: undefined$1,
                done: true
            };
        }
        Context.prototype = {
            constructor: Context,
            reset: function(skipTempReset) {
                this.prev = 0;
                this.next = 0;
                // Resetting context._sent for legacy support of Babel's
                // function.sent implementation.
                this.sent = this._sent = undefined$1;
                this.done = false;
                this.delegate = null;
                this.method = "next";
                this.arg = undefined$1;
                this.tryEntries.forEach(resetTryEntry);
                if (!skipTempReset) {
                    for(var name in this)// Not sure about the optimal order of these conditions:
                    if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined$1;
                }
            },
            stop: function() {
                this.done = true;
                var rootEntry = this.tryEntries[0];
                var rootRecord = rootEntry.completion;
                if (rootRecord.type === "throw") throw rootRecord.arg;
                return this.rval;
            },
            dispatchException: function(exception) {
                if (this.done) throw exception;
                var context = this;
                function handle(loc, caught) {
                    record.type = "throw";
                    record.arg = exception;
                    context.next = loc;
                    if (caught) {
                        // If the dispatched exception was caught by a catch block,
                        // then let that catch block handle the exception normally.
                        context.method = "next";
                        context.arg = undefined$1;
                    }
                    return !!caught;
                }
                for(var i = this.tryEntries.length - 1; i >= 0; --i){
                    var entry = this.tryEntries[i];
                    var record = entry.completion;
                    if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                    // it, so set the completion value of the entire function to
                    // throw the exception.
                    return handle("end");
                    if (entry.tryLoc <= this.prev) {
                        var hasCatch = hasOwn.call(entry, "catchLoc");
                        var hasFinally = hasOwn.call(entry, "finallyLoc");
                        if (hasCatch && hasFinally) {
                            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                            else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                        } else if (hasCatch) {
                            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        } else if (hasFinally) {
                            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                        } else throw new Error("try statement without catch or finally");
                    }
                }
            },
            abrupt: function(type, arg) {
                for(var i = this.tryEntries.length - 1; i >= 0; --i){
                    var entry = this.tryEntries[i];
                    if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                        var finallyEntry = entry;
                        break;
                    }
                }
                if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
                var record = finallyEntry ? finallyEntry.completion : {};
                record.type = type;
                record.arg = arg;
                if (finallyEntry) {
                    this.method = "next";
                    this.next = finallyEntry.finallyLoc;
                    return ContinueSentinel;
                }
                return this.complete(record);
            },
            complete: function(record, afterLoc) {
                if (record.type === "throw") throw record.arg;
                if (record.type === "break" || record.type === "continue") this.next = record.arg;
                else if (record.type === "return") {
                    this.rval = this.arg = record.arg;
                    this.method = "return";
                    this.next = "end";
                } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
                return ContinueSentinel;
            },
            finish: function(finallyLoc) {
                for(var i = this.tryEntries.length - 1; i >= 0; --i){
                    var entry = this.tryEntries[i];
                    if (entry.finallyLoc === finallyLoc) {
                        this.complete(entry.completion, entry.afterLoc);
                        resetTryEntry(entry);
                        return ContinueSentinel;
                    }
                }
            },
            "catch": function(tryLoc) {
                for(var i = this.tryEntries.length - 1; i >= 0; --i){
                    var entry = this.tryEntries[i];
                    if (entry.tryLoc === tryLoc) {
                        var record = entry.completion;
                        if (record.type === "throw") {
                            var thrown = record.arg;
                            resetTryEntry(entry);
                        }
                        return thrown;
                    }
                }
                // The context.catch method must only be called with a location
                // argument that corresponds to a known catch block.
                throw new Error("illegal catch attempt");
            },
            delegateYield: function(iterable, resultName, nextLoc) {
                this.delegate = {
                    iterator: values(iterable),
                    resultName: resultName,
                    nextLoc: nextLoc
                };
                if (this.method === "next") // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined$1;
                return ContinueSentinel;
            }
        };
        // Regardless of whether this script is executing as a CommonJS module
        // or not, return the runtime object so that we can declare the variable
        // regeneratorRuntime in the outer scope, which allows this module to be
        // injected easily by `bin/regenerator --include-runtime script.js`.
        return exports;
    }(// If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
    module.exports);
    try {
        regeneratorRuntime = runtime;
    } catch (accidentalStrictMode) {
        // This module should not be running in strict mode, so the above
        // assignment should always work unless something is misconfigured. Just
        // in case runtime.js accidentally runs in strict mode, we can escape
        // strict mode using a global Function call. This could conceivably fail
        // if a Content Security Policy forbids using Function, but in that case
        // the proper solution is to fix the accidental strict mode problem. If
        // you've misconfigured your bundler to force strict mode and applied a
        // CSP to forbid Function, and you're not willing to fix either of those
        // problems, please detail your unique predicament in a GitHub issue.
        Function("r", "regeneratorRuntime = r")(runtime);
    }
});
var $e19e94e73b73906a$var$BYTES_PER_MEGABYTE = 1000000;
var $e19e94e73b73906a$var$FileSizeValidator = /*#__PURE__*/ function() {
    function FileSizeValidator() {}
    var _proto = FileSizeValidator.prototype;
    _proto.validateBeforeParsing = function validateBeforeParsing(config, plainFiles) {
        var minFileSize = config.minFileSize, maxFileSize = config.maxFileSize;
        for(var _iterator = $e19e94e73b73906a$var$_createForOfIteratorHelperLoose(plainFiles), _step; !(_step = _iterator()).done;){
            var file = _step.value;
            if (minFileSize || maxFileSize) return $e19e94e73b73906a$var$checkFileSize({
                minFileSize: minFileSize,
                maxFileSize: maxFileSize,
                fileSize: file.size
            });
        }
        return Promise.resolve();
    };
    _proto.validateAfterParsing = /*#__PURE__*/ function() {
        var _validateAfterParsing = /*#__PURE__*/ $e19e94e73b73906a$var$_asyncToGenerator(/*#__PURE__*/ $e19e94e73b73906a$var$runtime_1.mark(function _callee(_config, _file) {
            return $e19e94e73b73906a$var$runtime_1.wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        return _context.abrupt("return", Promise.resolve());
                    case 1:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        function validateAfterParsing(_x, _x2) {
            return _validateAfterParsing.apply(this, arguments);
        }
        return validateAfterParsing;
    }();
    return FileSizeValidator;
}();
var $e19e94e73b73906a$var$checkFileSize = function checkFileSize(_ref) {
    var fileSize = _ref.fileSize, maxFileSize = _ref.maxFileSize, minFileSize = _ref.minFileSize;
    return new Promise(function(resolve, reject) {
        if (minFileSize) {
            var minBytes = minFileSize * $e19e94e73b73906a$var$BYTES_PER_MEGABYTE;
            if (fileSize < minBytes) reject({
                fileSizeTooSmall: true
            });
        }
        if (maxFileSize) {
            var maxBytes = maxFileSize * $e19e94e73b73906a$var$BYTES_PER_MEGABYTE;
            if (fileSize > maxBytes) reject({
                fileSizeToolarge: true
            });
        }
        resolve();
    });
};
var $e19e94e73b73906a$var$FilesLimitValidator = /*#__PURE__*/ function() {
    function FilesLimitValidator() {}
    var _proto = FilesLimitValidator.prototype;
    _proto.validateBeforeParsing = function validateBeforeParsing(config, plainFiles) {
        var limitFilesConfig = config.limitFilesConfig;
        if (limitFilesConfig) {
            if (limitFilesConfig.max && plainFiles.length > limitFilesConfig.max) return Promise.reject({
                maxLimitExceeded: true
            });
            if (limitFilesConfig.min && plainFiles.length < limitFilesConfig.min) return Promise.reject({
                minLimitNotReached: true
            });
        }
        return Promise.resolve();
    };
    _proto.validateAfterParsing = function validateAfterParsing() {
        return Promise.resolve();
    };
    return FilesLimitValidator;
}();
function $e19e94e73b73906a$var$openFileDialog(accept, multiple, callback, initializeWithCustomAttributes) {
    // this function must be called from a user
    // activation event (ie an onclick event)
    // Create an input element
    var inputElement = document.createElement("input"); // Hide element and append to body (required to run on iOS safari)
    inputElement.style.display = "none";
    document.body.appendChild(inputElement); // Set its type to file
    inputElement.type = "file"; // Set accept to the file types you want the user to select.
    // Include both the file extension and the mime type
    // if accept is "*" then dont set the accept attribute
    if (accept !== "*") inputElement.accept = accept; // Accept multiple files
    inputElement.multiple = multiple; // set onchange event to call callback when user has selected file
    //inputElement.addEventListener('change', callback);
    inputElement.addEventListener("change", function(arg) {
        callback(arg); // remove element
        document.body.removeChild(inputElement);
    });
    if (initializeWithCustomAttributes) initializeWithCustomAttributes(inputElement);
     // dispatch a click event to open the file dialog
    inputElement.dispatchEvent(new MouseEvent("click"));
}
var $e19e94e73b73906a$var$ImageDimensionsValidator = /*#__PURE__*/ function() {
    function ImageDimensionsValidator() {}
    var _proto = ImageDimensionsValidator.prototype;
    _proto.validateBeforeParsing = function validateBeforeParsing() {
        return Promise.resolve();
    };
    _proto.validateAfterParsing = function validateAfterParsing(config, file, reader) {
        var readAs = config.readAs, imageSizeRestrictions = config.imageSizeRestrictions;
        if (readAs === "DataURL" && imageSizeRestrictions && $e19e94e73b73906a$var$isImage(file.type)) return $e19e94e73b73906a$var$checkImageDimensions(reader.result, imageSizeRestrictions);
        return Promise.resolve();
    };
    return ImageDimensionsValidator;
}();
var $e19e94e73b73906a$var$isImage = function isImage(fileType) {
    return fileType.startsWith("image");
};
var $e19e94e73b73906a$var$checkImageDimensions = function checkImageDimensions(imgDataURL, imageSizeRestrictions) {
    return new Promise(function(resolve, reject) {
        var img = new Image();
        img.onload = function() {
            var maxHeight = imageSizeRestrictions.maxHeight, maxWidth = imageSizeRestrictions.maxWidth, minHeight = imageSizeRestrictions.minHeight, minWidth = imageSizeRestrictions.minWidth;
            var width = this.width, height = this.height;
            var errors = {};
            if (maxHeight && maxHeight < height) errors = $e19e94e73b73906a$var$_extends({}, errors, {
                imageHeightTooBig: true
            });
            if (minHeight && minHeight > height) errors = $e19e94e73b73906a$var$_extends({}, errors, {
                imageHeightTooSmall: true
            });
            if (maxWidth && maxWidth < width) errors = $e19e94e73b73906a$var$_extends({}, errors, {
                imageWidthTooBig: true
            });
            if (minWidth && minWidth > width) errors = $e19e94e73b73906a$var$_extends({}, errors, {
                imageWidthTooSmall: true
            });
            Object.keys(errors).length ? reject(errors) : resolve();
        };
        img.onerror = function() {
            reject({
                imageNotLoaded: true
            });
        };
        img.src = imgDataURL;
    });
};
var $e19e94e73b73906a$var$VALIDATORS = [
    /*#__PURE__*/ new $e19e94e73b73906a$var$FileSizeValidator(),
    /*#__PURE__*/ new $e19e94e73b73906a$var$FilesLimitValidator(),
    /*#__PURE__*/ new $e19e94e73b73906a$var$ImageDimensionsValidator()
];
function $e19e94e73b73906a$export$6c42a6cd04a213b0(_ref) {
    var _ref$accept = _ref.accept, accept = _ref$accept === void 0 ? "*" : _ref$accept, _ref$multiple = _ref.multiple, multiple = _ref$multiple === void 0 ? true : _ref$multiple, _ref$readAs = _ref.readAs, readAs = _ref$readAs === void 0 ? "Text" : _ref$readAs, minFileSize = _ref.minFileSize, maxFileSize = _ref.maxFileSize, imageSizeRestrictions = _ref.imageSizeRestrictions, limitFilesConfig = _ref.limitFilesConfig, _ref$readFilesContent = _ref.readFilesContent, readFilesContent = _ref$readFilesContent === void 0 ? true : _ref$readFilesContent, _ref$validators = _ref.validators, validators = _ref$validators === void 0 ? [] : _ref$validators, initializeWithCustomParameters = _ref.initializeWithCustomParameters;
    var _useState = (0, $acw62.useState)([]), files = _useState[0], setFiles = _useState[1];
    var _useState2 = (0, $acw62.useState)([]), filesContent = _useState2[0], setFilesContent = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), fileErrors = _useState3[0], setFileErrors = _useState3[1];
    var _useState4 = (0, $acw62.useState)(false), loading = _useState4[0], setLoading = _useState4[1];
    var _useState5 = (0, $acw62.useState)([]), plainFiles = _useState5[0], setPlainFiles = _useState5[1];
    var plainFileObjectsRef = (0, $acw62.useRef)([]);
    var openFileSelector = function openFileSelector() {
        var fileExtensions = accept instanceof Array ? accept.join(",") : accept;
        $e19e94e73b73906a$var$openFileDialog(fileExtensions, multiple, function(evt) {
            clear();
            var inputElement = evt.target;
            plainFileObjectsRef.current = inputElement.files ? Array.from(inputElement.files) : [];
            var validations = $e19e94e73b73906a$var$VALIDATORS.concat(validators).map(function(validator) {
                return validator.validateBeforeParsing({
                    accept: accept,
                    multiple: multiple,
                    readAs: readAs,
                    minFileSize: minFileSize,
                    maxFileSize: maxFileSize,
                    imageSizeRestrictions: imageSizeRestrictions,
                    limitFilesConfig: limitFilesConfig,
                    readFilesContent: readFilesContent,
                    initializeWithCustomParameters: initializeWithCustomParameters
                }, plainFileObjectsRef.current)["catch"](function(err) {
                    return Promise.reject(setFileErrors(function(f) {
                        return [
                            $e19e94e73b73906a$var$_extends({}, err, f)
                        ];
                    }));
                });
            });
            Promise.all(validations).then(function() {
                if (!readFilesContent) {
                    setPlainFiles(plainFileObjectsRef.current);
                    return;
                }
                (0, $7ac450b547cb7da9$export$a36e16046ae8f1bb)(evt).then(function(files) {
                    setFiles(files);
                });
            })["catch"](function() {});
        }, initializeWithCustomParameters);
    };
    var clear = (0, $acw62.useCallback)(function() {
        setPlainFiles([]);
        setFiles([]);
        setFilesContent([]);
        setFileErrors([]);
    }, []);
    (0, $acw62.useEffect)(function() {
        if (files.length === 0) {
            setFilesContent([]);
            return;
        }
        setLoading(true);
        var fileParsingPromises = files.map(function(file) {
            return new Promise(/*#__PURE__*/ function() {
                var _ref2 = $e19e94e73b73906a$var$_asyncToGenerator(/*#__PURE__*/ $e19e94e73b73906a$var$runtime_1.mark(function _callee2(resolve, reject) {
                    var reader, readStrategy, addError;
                    return $e19e94e73b73906a$var$runtime_1.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                reader = new FileReader(); //availible reader methods: readAsText, readAsBinaryString, readAsArrayBuffer, readAsDataURL
                                readStrategy = reader["readAs" + readAs];
                                readStrategy.call(reader, file);
                                addError = function addError(_ref3) {
                                    var _ref3$name = _ref3.name, name = _ref3$name === void 0 ? file.name : _ref3$name, others = $e19e94e73b73906a$var$_objectWithoutPropertiesLoose(_ref3, [
                                        "name"
                                    ]);
                                    reject($e19e94e73b73906a$var$_extends({
                                        name: name,
                                        fileSizeToolarge: false,
                                        fileSizeTooSmall: false
                                    }, others));
                                };
                                reader.onload = /*#__PURE__*/ $e19e94e73b73906a$var$_asyncToGenerator(/*#__PURE__*/ $e19e94e73b73906a$var$runtime_1.mark(function _callee() {
                                    var validations;
                                    return $e19e94e73b73906a$var$runtime_1.wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                validations = $e19e94e73b73906a$var$VALIDATORS.concat(validators).map(function(validator) {
                                                    return validator.validateAfterParsing({
                                                        accept: accept,
                                                        multiple: multiple,
                                                        readAs: readAs,
                                                        minFileSize: minFileSize,
                                                        maxFileSize: maxFileSize,
                                                        imageSizeRestrictions: imageSizeRestrictions,
                                                        limitFilesConfig: limitFilesConfig,
                                                        readFilesContent: readFilesContent,
                                                        initializeWithCustomParameters: initializeWithCustomParameters
                                                    }, file, reader)["catch"](function(err) {
                                                        return Promise.reject(addError(err));
                                                    });
                                                });
                                                Promise.all(validations).then(function() {
                                                    return resolve({
                                                        content: reader.result,
                                                        name: file.name,
                                                        lastModified: file.lastModified
                                                    });
                                                })["catch"](function() {});
                                            case 2:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee);
                                }));
                                reader.onerror = function() {
                                    addError({
                                        readerError: reader.error
                                    });
                                };
                            case 6:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function(_x, _x2) {
                    return _ref2.apply(this, arguments);
                };
            }());
        });
        Promise.all(fileParsingPromises).then(function(fileContent) {
            setFilesContent(fileContent);
            setPlainFiles(plainFileObjectsRef.current);
            setFileErrors([]);
        })["catch"](function(err) {
            setFileErrors(function(f) {
                return [
                    err
                ].concat(f);
            });
        })["finally"](function() {
            return setLoading(false);
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        files
    ]);
    return [
        openFileSelector,
        {
            filesContent: filesContent,
            errors: fileErrors,
            loading: loading,
            plainFiles: plainFiles,
            clear: clear
        }
    ];
}




function $44ddd21093278155$export$2e2bcd8739ae039(props) {
    const { newModal: newModal, toggleModal: toggleModal } = (0, $afeee6e786e91a5d$export$33ffd74ebf07f060)();
    const appState = (0, $1aae03441633a07a$export$fca13ab91e1a6240)();
    const { corps: corps } = appState.corps.state;
    const [openFileSelector, { loading: loading, filesContent: filesContent, errors: errors, plainFiles: plainFiles, clear: clear }] = (0, $e19e94e73b73906a$export$6c42a6cd04a213b0)({
        multiple: false,
        accept: ".png, .svg"
    });
    const { patterns: patterns, types: types } = (0, $3ee4be5251daba61$export$2e2bcd8739ae039)();
    const [loadingSubmit, setLoadingSubmit] = (0, $acw62.useState)(false);
    const [state, setState] = (0, $acw62.useState)({
        cid: "-1",
        count: 1,
        backgroundColor: "#000000",
        contrastColor: "#FFFFFF",
        warranty: false,
        text: "",
        patternId: "-1",
        typeId: "-1"
    });
    const [colorState, setColorState] = (0, $acw62.useState)("custom");
    const selectedCorp = corps.find((corp)=>corp.id == Number(state.cid)) ?? null;
    const selectedPattern = patterns.find((pattern)=>pattern.id == Number(state.patternId)) ?? null;
    const selectedType = types.find((type)=>type.id == Number(state.typeId)) ?? null;
    const selectedColors = fetchColors();
    const canSubmit = (()=>state.count > 0 && selectedType != null)();
    console.log("can submit,", canSubmit, selectedType);
    console.log("FILES", plainFiles);
    function fetchColors() {
        if (colorState === "custom") return {
            backgroundColor: state.backgroundColor,
            contrastColor: state.contrastColor
        };
        else if (colorState === "card") return {
            backgroundColor: selectedType?.color ?? "",
            contrastColor: selectedType?.contrast_color ?? ""
        };
        else if (colorState === "corp") return {
            backgroundColor: selectedCorp?.background_color_hex ?? "",
            contrastColor: selectedCorp?.accent_color_hex ?? ""
        };
        else return {
            backgroundColor: "",
            contrastColor: ""
        };
    }
    function handleFileSelection() {
        openFileSelector();
    }
    function handleInput(e) {
        e.preventDefault();
        e.stopPropagation();
        setState((old)=>({
                ...old,
                [e.target.name]: e.target.value
            }));
    }
    async function submitData() {
        if (loadingSubmit) return;
        const cid = Number(state.cid);
        const file = plainFiles.length === 1 ? await (0, $fd5baa1bcf92a6bb$export$25df2e315be8e003)(plainFiles[0]) : null;
        const data = {
            cid: cid > 0 ? cid : null,
            count: Number(state.count),
            custom_background_color_hex: selectedColors.backgroundColor,
            custom_contrast_color_hex: selectedColors.contrastColor,
            include_warranty: state.warranty,
            item_pattern_id: selectedPattern ? selectedPattern.id : null,
            item_type_id: selectedType ? selectedType.id : null,
            text: state.text.length ? state.text : null,
            logo: file
        };
        setLoadingSubmit(true);
        try {
            const resp = await (0, $3189fb41583a85b4$export$1755ac0df8a95d32).post("/unlinked-items", data);
            setLoadingSubmit(false);
            newModal({
                hideActions: true,
                title: "",
                body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                    h4: true,
                    children: "Items creati con successo"
                })
            });
        } catch (err) {
            setLoadingSubmit(false);
        }
    }
    function handleCorpSelection(e) {
        setState((oldState)=>({
                ...oldState,
                cid: e.anchorKey
            }));
    }
    function handleTypeSelection(e) {
        setState((oldState)=>({
                ...oldState,
                typeId: e.anchorKey
            }));
    }
    function handlePatternSelection(e) {
        setState((oldState)=>({
                ...oldState,
                patternId: e.anchorKey
            }));
    }
    function handleColorState(e) {
        setColorState(e.anchorKey);
    }
    function handleSwitch(e) {
        const checked = e.target.checked;
        setState((oldState)=>({
                ...oldState,
                warranty: checked
            }));
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1fb3f02de1b1ab50$export$2e2bcd8739ae039), {
        title: "Nuovo unlinked-item",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fb3f02de1b1ab50$export$e213cebad6250b4a), {
                actions: []
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                css: {
                    height: "100%",
                    overflowY: "auto",
                    padding: "$5",
                    gap: "$5"
                },
                justify: "center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                    css: {
                        maxWidth: "500px",
                        gap: "$10"
                    },
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    style: {
                                        marginBottom: 10
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                                        weight: "normal",
                                        h6: true,
                                        children: "Seleziona una corporazione"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Button, {
                                            flat: true,
                                            ghost: true,
                                            children: !selectedCorp ? "Nessuna corporazione" : selectedCorp.name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Menu, {
                                            selectionMode: "single",
                                            selectedKeys: new Set([
                                                state.patternId
                                            ]),
                                            onSelectionChange: handleCorpSelection,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Item, {
                                                    children: "Nessuna corporazione"
                                                }, "-1"),
                                                corps.map((corp)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Item, {
                                                        children: corp.name
                                                    }, corp.id))
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
                                        value: state.count,
                                        width: "100%",
                                        name: "count",
                                        onChange: handleInput,
                                        label: "numero unlinked items",
                                        type: "number"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                                            children: "Garanzia"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a757147768b90cdf$export$2e2bcd8739ae039), {
                                            onChange: handleSwitch,
                                            checked: state.warranty
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bebbdb3c09143e6$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                            h4: true,
                            children: "Personalizzazione Item"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                            justify: "space-between",
                            css: {
                                gap: "$10"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                border: "1px solid black",
                                                width: 20,
                                                height: 20,
                                                background: selectedColors.backgroundColor
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
                                            value: selectedColors.backgroundColor,
                                            width: "100%",
                                            name: "backgroundColor",
                                            onChange: handleInput,
                                            disabled: colorState !== "custom",
                                            label: "colore di sfondo"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                border: "1px solid black",
                                                width: 20,
                                                height: 20,
                                                background: selectedColors.contrastColor
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
                                            value: selectedColors.contrastColor,
                                            width: "100%",
                                            name: "contrastColor",
                                            onChange: handleInput,
                                            disabled: colorState !== "custom",
                                            label: "colore di contrasto"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c78f4d7728e729df$export$2e2bcd8739ae039), {
                                        value: state.text,
                                        width: "100%",
                                        name: "text",
                                        onChange: handleInput,
                                        label: "testo card"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                            justify: "space-between",
                            css: {
                                gap: "$10"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                                    css: {
                                        flex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            style: {
                                                marginBottom: 10
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                                                weight: "normal",
                                                h6: true,
                                                children: "Seleziona la tipologia di card"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Button, {
                                                    flat: true,
                                                    ghost: true,
                                                    children: !selectedType ? "Nessuna tipologia selezionata" : selectedType.name
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Menu, {
                                                    selectionMode: "single",
                                                    selectedKeys: new Set([
                                                        state.typeId
                                                    ]),
                                                    onSelectionChange: handleTypeSelection,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Item, {
                                                            children: "Nessun tipologia selezionata"
                                                        }, "-1"),
                                                        types.map((type)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Item, {
                                                                children: type.name
                                                            }, type.id))
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            style: {
                                                marginBottom: 10
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                                                weight: "normal",
                                                h6: true,
                                                children: "Seleziona un pattern"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Button, {
                                                    flat: true,
                                                    ghost: true,
                                                    children: !selectedPattern ? "Nessun Pattern" : selectedPattern.name
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Menu, {
                                                    selectionMode: "single",
                                                    selectedKeys: new Set([
                                                        state.patternId
                                                    ]),
                                                    onSelectionChange: handlePatternSelection,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Item, {
                                                            children: "Nessun pattern"
                                                        }, "-1"),
                                                        patterns.map((pattern)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Item, {
                                                                children: pattern.name
                                                            }, pattern.id))
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            style: {
                                                marginBottom: 10
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639543044de9c802$export$2e2bcd8739ae039), {
                                                weight: "normal",
                                                h6: true,
                                                children: "Selezionare la fonte del colore"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Button, {
                                                    flat: true,
                                                    ghost: true,
                                                    children: colorState
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Menu, {
                                                    selectionMode: "single",
                                                    selectedKeys: new Set([
                                                        colorState
                                                    ]),
                                                    onSelectionChange: handleColorState,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Item, {
                                                            children: "colore custom"
                                                        }, "custom"),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Item, {
                                                            children: "colore card"
                                                        }, "card"),
                                                        selectedCorp ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae1adc4fb7ae7f25$export$2e2bcd8739ae039).Item, {
                                                            children: "colore corp"
                                                        }, "corp") : ""
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bebbdb3c09143e6$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039).Container, {
                            justify: "space-between",
                            css: {
                                gap: "$10"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    flat: true,
                                    ghost: true,
                                    onClick: handleFileSelection,
                                    children: filesContent.length === 1 ? filesContent[0].name : "Seleziona Logo"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                    light: true,
                                    color: "error",
                                    auto: true,
                                    onClick: clear,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63c37e44f569564f$export$bfadae053a633538), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bebbdb3c09143e6$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d26af2734c4b5b$export$2e2bcd8739ae039), {
                            css: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f992dede62d0c3b0$export$2e2bcd8739ae039), {
                                css: {
                                    width: "100%"
                                },
                                color: "success",
                                onPress: submitData,
                                flat: true,
                                disabled: !canSubmit,
                                children: !loadingSubmit ? `Aggiungi Unlinked ${state.count === 1 ? "Item" : "Items"}` : "Caricamento"
                            })
                        })
                    ]
                })
            })
        ]
    });
}


const $0c4ee6d4a2f72cd2$var$AppRoutes = (props)=>{
    const corp = (0, $6cdf033bc7603b4e$export$78c977097708e32c)();
    const { pathname: pathname } = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb5777539258543f$export$f01b3d7c7bbe3997), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $926608a7a86d7371$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
                        to: "/orders"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                    path: "/unlinked-items",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                            index: true,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0257f19214483c41$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                            path: "nuovo",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44ddd21093278155$export$2e2bcd8739ae039), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                    path: "/corps",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                            index: true,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $af5407a329b2ef92$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                            path: "nuova",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a7b0cb687e19b33$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                            path: ":cid",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e8b5695e07ff1ccc$export$2e2bcd8739ae039), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                    path: "/orders",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3b1ba0d4a39fc57$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                    path: "/members",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $105f993f66d4eb29$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
};
var $0c4ee6d4a2f72cd2$export$2e2bcd8739ae039 = $0c4ee6d4a2f72cd2$var$AppRoutes;






var $acw62 = parcelRequire("acw62");


function $e51752f1c727b356$export$2e2bcd8739ae039() {
    const { signout: signout } = (0, $befcb7e46ce523f6$export$1d39dc5b47e56ff0)();
    (0, $acw62.useEffect)(()=>{
        signout();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
        to: "/"
    });
}


const $6840e8b44f75a905$var$App = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c52ef0142b7b9e1$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $befcb7e46ce523f6$export$87091915187a1a85), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1aae03441633a07a$export$c7dacf3845253dcf), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6cdf033bc7603b4e$export$43a1055884b5da6d), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $afeee6e786e91a5d$export$178405afcd8c5eb), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $462c5a39e9e16ee8$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $926608a7a86d7371$export$3565eb3d00ca5a74), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                            path: "/*",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c4ee6d4a2f72cd2$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                            path: "/login",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c80e29f43e2dfdb6$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                            path: "/logout",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e51752f1c727b356$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
var $6840e8b44f75a905$export$2e2bcd8739ae039 = $6840e8b44f75a905$var$App;



parcelRequire("acw62");
(0, $11492dca620dcaa5$exports.render)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6840e8b44f75a905$export$2e2bcd8739ae039), {}), document.getElementById("root"));


//# sourceMappingURL=index.ba6ec56f.js.map
